import { defineComponent as z, computed as w, openBlock as E, createElementBlock as y, normalizeClass as M, createElementVNode as v, toDisplayString as O, unref as Hu, shallowRef as gf, watch as au, triggerRef as Uf, onScopeDispose as G0, ref as I, onUnmounted as vu, inject as Cu, nextTick as Eu, watchEffect as gu, onMounted as ru, cloneVNode as $1, h as uu, Fragment as J, provide as Bu, reactive as Qe, toRaw as cu, getCurrentInstance as X0, Teleport as Z0, resolveComponent as P, withModifiers as ju, renderSlot as fu, createVNode as U, createCommentVNode as R, createBlock as q, withCtx as N, resolveDynamicComponent as xu, Transition as _e, renderList as du, createTextVNode as G, createStaticVNode as K0, withDirectives as qe, vModelSelect as Q0, normalizeStyle as re, withKeys as Nu, resolveDirective as J0, vModelDynamic as ut, vShow as et, createSlots as Dt } from "vue";
const ft = z({
  props: {
    firstName: {
      type: String,
      default: ""
    },
    lastName: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "base",
      validator: (u) => ["xs", "sm", "base", "lg", "xl", "2xl", "3xl"].includes(u)
    },
    loading: { type: Boolean, default: !1 }
  },
  setup(u) {
    const e = {
      xs: "h-6 w-6",
      sm: "h-8 w-8",
      base: "h-10 w-10",
      lg: "h-12 w-12",
      xl: "h-14 w-14",
      "2xl": "h-20 w-20",
      "3xl": "h-28 w-28"
    }, D = {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      "2xl": "text-2xl",
      "3xl": "text-3xl"
    }, f = w(
      () => `${u.firstName.substring(0, 1)}${u.lastName.substring(0, 1)}`.toUpperCase()
    );
    return { sizes: e, textSizes: D, userInitials: f };
  }
}), Q = (u, e) => {
  const D = u.__vccOpts || u;
  for (const [f, t] of e)
    D[f] = t;
  return D;
}, tt = /* @__PURE__ */ v("svg", {
  class: "h-full w-full text-gray-300",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ v("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
], -1), at = [
  tt
];
function nt(u, e, D, f, t, n) {
  return u.loading ? (E(), y("div", {
    key: 0,
    class: M([u.sizes[u.size], "inline-flex items-center justify-center rounded-full bg-gray-200 animate-pulse"])
  }, null, 2)) : u.firstName && u.lastName ? (E(), y("span", {
    key: 1,
    class: M([u.sizes[u.size], "inline-flex items-center justify-center rounded-full bg-gray-100"])
  }, [
    v("span", {
      class: M([u.textSizes[u.size], "font-medium leading-none text-gray-400 capitalize"])
    }, O(u.userInitials), 3)
  ], 2)) : (E(), y("span", {
    key: 2,
    class: M([u.sizes[u.size], "inline-block rounded-full overflow-hidden bg-gray-100"])
  }, at, 2));
}
const ot = /* @__PURE__ */ Q(ft, [["render", nt]]), rt = z({}), lt = {
  class: "animate-spin",
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, it = /* @__PURE__ */ v("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1), dt = /* @__PURE__ */ v("path", {
  class: "opacity-75",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
  fill: "currentColor"
}, null, -1), st = [
  it,
  dt
];
function ct(u, e, D, f, t, n) {
  return E(), y("svg", lt, st);
}
const Je = /* @__PURE__ */ Q(rt, [["render", ct]]);
function Ft(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
    })
  ]);
}
function Ct(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    })
  ]);
}
function Et(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m19.5 8.25-7.5 7.5-7.5-7.5"
    })
  ]);
}
function Wf(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
    })
  ]);
}
function mt(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    })
  ]);
}
function pt(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 4.5v15m7.5-7.5h-15"
    })
  ]);
}
function vf(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    })
  ]);
}
function ve(u, e, D) {
  let f = D.initialDeps ?? [], t;
  return () => {
    var n, a, o, r;
    let l;
    D.key && ((n = D.debug) != null && n.call(D)) && (l = Date.now());
    const i = u();
    if (!(i.length !== f.length || i.some((g, h) => f[h] !== g)))
      return t;
    f = i;
    let d;
    if (D.key && ((a = D.debug) != null && a.call(D)) && (d = Date.now()), t = e(...i), D.key && ((o = D.debug) != null && o.call(D))) {
      const g = Math.round((Date.now() - l) * 100) / 100, h = Math.round((Date.now() - d) * 100) / 100, _ = h / 16, C = (p, b) => {
        for (p = String(p); p.length < b; )
          p = " " + p;
        return p;
      };
      console.info(
        `%c⏱ ${C(h, 5)} /${C(g, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * _, 120)
        )}deg 100% 31%);`,
        D == null ? void 0 : D.key
      );
    }
    return (r = D == null ? void 0 : D.onChange) == null || r.call(D, t), t;
  };
}
function ED(u, e) {
  if (u === void 0)
    throw new Error("Unexpected undefined");
  return u;
}
const bt = (u, e) => Math.abs(u - e) < 1, gt = (u, e) => {
  let D;
  return function(...f) {
    clearTimeout(D), D = setTimeout(() => u.apply(this, f), e);
  };
}, vt = (u) => u, ht = (u) => {
  const e = Math.max(u.startIndex - u.overscan, 0), D = Math.min(u.endIndex + u.overscan, u.count - 1), f = [];
  for (let t = e; t <= D; t++)
    f.push(t);
  return f;
}, Bt = (u, e) => {
  const D = u.scrollElement;
  if (!D)
    return;
  const f = (n) => {
    const { width: a, height: o } = n;
    e({ width: Math.round(a), height: Math.round(o) });
  };
  if (f(D.getBoundingClientRect()), typeof ResizeObserver > "u")
    return () => {
    };
  const t = new ResizeObserver((n) => {
    const a = n[0];
    if (a != null && a.borderBoxSize) {
      const o = a.borderBoxSize[0];
      if (o) {
        f({ width: o.inlineSize, height: o.blockSize });
        return;
      }
    }
    f(D.getBoundingClientRect());
  });
  return t.observe(D, { box: "border-box" }), () => {
    t.unobserve(D);
  };
}, qf = {
  passive: !0
}, yt = typeof window > "u" ? !0 : "onscrollend" in window, _t = (u, e) => {
  const D = u.scrollElement;
  if (!D)
    return;
  let f = 0;
  const t = yt ? () => {
  } : gt(() => {
    e(f, !1);
  }, u.options.isScrollingResetDelay), n = (r) => () => {
    f = D[u.options.horizontal ? "scrollLeft" : "scrollTop"], t(), e(f, r);
  }, a = n(!0), o = n(!1);
  return o(), D.addEventListener("scroll", a, qf), D.addEventListener("scrollend", o, qf), () => {
    D.removeEventListener("scroll", a), D.removeEventListener("scrollend", o);
  };
}, wt = (u, e, D) => {
  if (e != null && e.borderBoxSize) {
    const f = e.borderBoxSize[0];
    if (f)
      return Math.round(
        f[D.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    u.getBoundingClientRect()[D.options.horizontal ? "width" : "height"]
  );
}, kt = (u, {
  adjustments: e = 0,
  behavior: D
}, f) => {
  var t, n;
  const a = u + e;
  (n = (t = f.scrollElement) == null ? void 0 : t.scrollTo) == null || n.call(t, {
    [f.options.horizontal ? "left" : "top"]: a,
    behavior: D
  });
};
class At {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollDirection = null, this.scrollAdjustments = 0, this.measureElementCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let D = null;
      const f = () => D || (typeof ResizeObserver < "u" ? D = new ResizeObserver((t) => {
        t.forEach((n) => {
          this._measureElement(n.target, n);
        });
      }) : null);
      return {
        disconnect: () => {
          var t;
          return (t = f()) == null ? void 0 : t.disconnect();
        },
        observe: (t) => {
          var n;
          return (n = f()) == null ? void 0 : n.observe(t, { box: "border-box" });
        },
        unobserve: (t) => {
          var n;
          return (n = f()) == null ? void 0 : n.unobserve(t);
        }
      };
    })(), this.range = null, this.setOptions = (D) => {
      Object.entries(D).forEach(([f, t]) => {
        typeof t > "u" && delete D[f];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: vt,
        rangeExtractor: ht,
        onChange: () => {
        },
        measureElement: wt,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        ...D
      };
    }, this.notify = (D, f) => {
      var t, n;
      const { startIndex: a, endIndex: o } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      }, r = this.calculateRange();
      (D || a !== (r == null ? void 0 : r.startIndex) || o !== (r == null ? void 0 : r.endIndex)) && ((n = (t = this.options).onChange) == null || n.call(t, this, f));
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((D) => D()), this.unsubs = [], this.scrollElement = null;
    }, this._didMount = () => (this.measureElementCache.forEach(this.observer.observe), () => {
      this.observer.disconnect(), this.cleanup();
    }), this._willUpdate = () => {
      const D = this.options.getScrollElement();
      this.scrollElement !== D && (this.cleanup(), this.scrollElement = D, this._scrollToOffset(this.scrollOffset, {
        adjustments: void 0,
        behavior: void 0
      }), this.unsubs.push(
        this.options.observeElementRect(this, (f) => {
          this.scrollRect = f, this.notify(!1, !1);
        })
      ), this.unsubs.push(
        this.options.observeElementOffset(this, (f, t) => {
          this.scrollAdjustments = 0, this.scrollDirection = t ? this.scrollOffset < f ? "forward" : "backward" : null, this.scrollOffset = f;
          const n = this.isScrolling;
          this.isScrolling = t, this.notify(n !== t, t);
        })
      ));
    }, this.getSize = () => this.scrollRect[this.options.horizontal ? "width" : "height"], this.getMeasurementOptions = ve(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey
      ],
      (D, f, t, n) => (this.pendingMeasuredCacheIndexes = [], {
        count: D,
        paddingStart: f,
        scrollMargin: t,
        getItemKey: n
      }),
      {
        key: !1
      }
    ), this.getFurthestMeasurement = (D, f) => {
      const t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
      for (let a = f - 1; a >= 0; a--) {
        const o = D[a];
        if (t.has(o.lane))
          continue;
        const r = n.get(
          o.lane
        );
        if (r == null || o.end > r.end ? n.set(o.lane, o) : o.end < r.end && t.set(o.lane, !0), t.size === this.options.lanes)
          break;
      }
      return n.size === this.options.lanes ? Array.from(n.values()).sort((a, o) => a.end === o.end ? a.index - o.index : a.end - o.end)[0] : void 0;
    }, this.getMeasurements = ve(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: D, paddingStart: f, scrollMargin: t, getItemKey: n }, a) => {
        const o = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const r = this.measurementsCache.slice(0, o);
        for (let l = o; l < D; l++) {
          const i = n(l), s = this.options.lanes === 1 ? r[l - 1] : this.getFurthestMeasurement(r, l), d = s ? s.end + this.options.gap : f + t, g = a.get(i), h = typeof g == "number" ? g : this.options.estimateSize(l), _ = d + h, C = s ? s.lane : l % this.options.lanes;
          r[l] = {
            index: l,
            start: d,
            size: h,
            end: _,
            key: i,
            lane: C
          };
        }
        return this.measurementsCache = r, r;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = ve(
      () => [this.getMeasurements(), this.getSize(), this.scrollOffset],
      (D, f, t) => this.range = D.length > 0 && f > 0 ? xt({
        measurements: D,
        outerSize: f,
        scrollOffset: t
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = ve(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (D, f, t, n) => f === null ? [] : D({
        startIndex: f.startIndex,
        endIndex: f.endIndex,
        overscan: t,
        count: n
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (D) => {
      const f = this.options.indexAttribute, t = D.getAttribute(f);
      return t ? parseInt(t, 10) : (console.warn(
        `Missing attribute name '${f}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (D, f) => {
      const t = this.measurementsCache[this.indexFromElement(D)];
      if (!t || !D.isConnected) {
        this.measureElementCache.forEach((o, r) => {
          o === D && (this.observer.unobserve(D), this.measureElementCache.delete(r));
        });
        return;
      }
      const n = this.measureElementCache.get(t.key);
      n !== D && (n && this.observer.unobserve(n), this.observer.observe(D), this.measureElementCache.set(t.key, D));
      const a = this.options.measureElement(D, f, this);
      this.resizeItem(t, a);
    }, this.resizeItem = (D, f) => {
      const t = this.itemSizeCache.get(D.key) ?? D.size, n = f - t;
      n !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(D, n, this) : D.start < this.scrollOffset + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", n), this._scrollToOffset(this.scrollOffset, {
        adjustments: this.scrollAdjustments += n,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(D.index), this.itemSizeCache = new Map(this.itemSizeCache.set(D.key, f)), this.notify(!0, !1));
    }, this.measureElement = (D) => {
      D && this._measureElement(D, void 0);
    }, this.getVirtualItems = ve(
      () => [this.getIndexes(), this.getMeasurements()],
      (D, f) => {
        const t = [];
        for (let n = 0, a = D.length; n < a; n++) {
          const o = D[n], r = f[o];
          t.push(r);
        }
        return t;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (D) => {
      const f = this.getMeasurements();
      return ED(
        f[S1(
          0,
          f.length - 1,
          (t) => ED(f[t]).start,
          D
        )]
      );
    }, this.getOffsetForAlignment = (D, f) => {
      const t = this.getSize();
      f === "auto" && (D <= this.scrollOffset ? f = "start" : D >= this.scrollOffset + t ? f = "end" : f = "start"), f === "start" ? D = D : f === "end" ? D = D - t : f === "center" && (D = D - t / 2);
      const n = this.options.horizontal ? "scrollWidth" : "scrollHeight", o = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[n] : this.scrollElement[n] : 0) - this.getSize();
      return Math.max(Math.min(o, D), 0);
    }, this.getOffsetForIndex = (D, f = "auto") => {
      D = Math.max(0, Math.min(D, this.options.count - 1));
      const t = ED(this.getMeasurements()[D]);
      if (f === "auto")
        if (t.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd)
          f = "end";
        else if (t.start <= this.scrollOffset + this.options.scrollPaddingStart)
          f = "start";
        else
          return [this.scrollOffset, f];
      const n = f === "end" ? t.end + this.options.scrollPaddingEnd : t.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(n, f), f];
    }, this.isDynamicMode = () => this.measureElementCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && (clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (D, { align: f = "start", behavior: t } = {}) => {
      this.cancelScrollToIndex(), t === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(D, f), {
        adjustments: void 0,
        behavior: t
      });
    }, this.scrollToIndex = (D, { align: f = "auto", behavior: t } = {}) => {
      D = Math.max(0, Math.min(D, this.options.count - 1)), this.cancelScrollToIndex(), t === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const [n, a] = this.getOffsetForIndex(D, f);
      this._scrollToOffset(n, { adjustments: void 0, behavior: t }), t !== "smooth" && this.isDynamicMode() && (this.scrollToIndexTimeoutId = setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.measureElementCache.has(
          this.options.getItemKey(D)
        )) {
          const [r] = this.getOffsetForIndex(D, a);
          bt(r, this.scrollOffset) || this.scrollToIndex(D, { align: a, behavior: t });
        } else
          this.scrollToIndex(D, { align: a, behavior: t });
      }));
    }, this.scrollBy = (D, { behavior: f } = {}) => {
      this.cancelScrollToIndex(), f === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.scrollOffset + D, {
        adjustments: void 0,
        behavior: f
      });
    }, this.getTotalSize = () => {
      var D;
      const f = this.getMeasurements();
      let t;
      return f.length === 0 ? t = this.options.paddingStart : t = this.options.lanes === 1 ? ((D = f[f.length - 1]) == null ? void 0 : D.end) ?? 0 : Math.max(
        ...f.slice(-this.options.lanes).map((n) => n.end)
      ), t - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (D, {
      adjustments: f,
      behavior: t
    }) => {
      this.options.scrollToFn(D, { behavior: t, adjustments: f }, this);
    }, this.measure = () => {
      var D, f;
      this.itemSizeCache = /* @__PURE__ */ new Map(), (f = (D = this.options).onChange) == null || f.call(D, this, !1);
    }, this.setOptions(e), this.scrollRect = this.options.initialRect, this.scrollOffset = typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset, this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((D) => {
      this.itemSizeCache.set(D.key, D.size);
    }), this.notify(!1, !1);
  }
}
const S1 = (u, e, D, f) => {
  for (; u <= e; ) {
    const t = (u + e) / 2 | 0, n = D(t);
    if (n < f)
      u = t + 1;
    else if (n > f)
      e = t - 1;
    else
      return t;
  }
  return u > 0 ? u - 1 : 0;
};
function xt({
  measurements: u,
  outerSize: e,
  scrollOffset: D
}) {
  const f = u.length - 1, n = S1(0, f, (o) => u[o].start, D);
  let a = n;
  for (; a < f && u[a].end < D + e; )
    a++;
  return { startIndex: n, endIndex: a };
}
function $t(u) {
  const e = new At(Hu(u)), D = gf(e), f = e._didMount();
  return au(
    () => Hu(u).getScrollElement(),
    (t) => {
      t && e._willUpdate();
    },
    {
      immediate: !0
    }
  ), au(
    () => Hu(u),
    (t) => {
      e.setOptions({
        ...t,
        onChange: (n, a) => {
          var o;
          Uf(D), (o = t.onChange) == null || o.call(t, n, a);
        }
      }), e._willUpdate(), Uf(D);
    },
    {
      immediate: !0
    }
  ), G0(f), D;
}
function St(u) {
  return $t(
    w(() => ({
      observeElementRect: Bt,
      observeElementOffset: _t,
      scrollToFn: kt,
      ...Hu(u)
    }))
  );
}
function uD(u, e, D) {
  let f = I(D == null ? void 0 : D.value), t = w(() => u.value !== void 0);
  return [w(() => t.value ? u.value : f.value), function(n) {
    return t.value || (f.value = n), e == null ? void 0 : e(n);
  }];
}
function hf(u) {
  typeof queueMicrotask == "function" ? queueMicrotask(u) : Promise.resolve().then(u).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function ue() {
  let u = [], e = { addEventListener(D, f, t, n) {
    return D.addEventListener(f, t, n), e.add(() => D.removeEventListener(f, t, n));
  }, requestAnimationFrame(...D) {
    let f = requestAnimationFrame(...D);
    e.add(() => cancelAnimationFrame(f));
  }, nextFrame(...D) {
    e.requestAnimationFrame(() => {
      e.requestAnimationFrame(...D);
    });
  }, setTimeout(...D) {
    let f = setTimeout(...D);
    e.add(() => clearTimeout(f));
  }, microTask(...D) {
    let f = { current: !0 };
    return hf(() => {
      f.current && D[0]();
    }), e.add(() => {
      f.current = !1;
    });
  }, style(D, f, t) {
    let n = D.style.getPropertyValue(f);
    return Object.assign(D.style, { [f]: t }), this.add(() => {
      Object.assign(D.style, { [f]: n });
    });
  }, group(D) {
    let f = ue();
    return D(f), this.add(() => f.dispose());
  }, add(D) {
    return u.push(D), () => {
      let f = u.indexOf(D);
      if (f >= 0)
        for (let t of u.splice(f, 1))
          t();
    };
  }, dispose() {
    for (let D of u.splice(0))
      D();
  } };
  return e;
}
function Tt() {
  let u = ue();
  return vu(() => u.dispose()), u;
}
function Mt() {
  let u = Tt();
  return (e) => {
    u.dispose(), u.nextFrame(e);
  };
}
let Ot = Symbol("headlessui.useid"), It = 0;
function su() {
  return Cu(Ot, () => `${++It}`)();
}
function $(u) {
  var e;
  if (u == null || u.value == null)
    return null;
  let D = (e = u.value.$el) != null ? e : u.value;
  return D instanceof Node ? D : null;
}
function ou(u, e, ...D) {
  if (u in e) {
    let t = e[u];
    return typeof t == "function" ? t(...D) : t;
  }
  let f = new Error(`Tried to handle "${u}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((t) => `"${t}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(f, ou), f;
}
var Pt = Object.defineProperty, Lt = (u, e, D) => e in u ? Pt(u, e, { enumerable: !0, configurable: !0, writable: !0, value: D }) : u[e] = D, Yf = (u, e, D) => (Lt(u, typeof e != "symbol" ? e + "" : e, D), D);
let Rt = class {
  constructor() {
    Yf(this, "current", this.detect()), Yf(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, we = new Rt();
function ku(u) {
  if (we.isServer)
    return null;
  if (u instanceof Node)
    return u.ownerDocument;
  if (u != null && u.hasOwnProperty("value")) {
    let e = $(u);
    if (e)
      return e.ownerDocument;
  }
  return document;
}
let kD = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((u) => `${u}:not([tabindex='-1'])`).join(",");
var bu = ((u) => (u[u.First = 1] = "First", u[u.Previous = 2] = "Previous", u[u.Next = 4] = "Next", u[u.Last = 8] = "Last", u[u.WrapAround = 16] = "WrapAround", u[u.NoScroll = 32] = "NoScroll", u))(bu || {}), ie = ((u) => (u[u.Error = 0] = "Error", u[u.Overflow = 1] = "Overflow", u[u.Success = 2] = "Success", u[u.Underflow = 3] = "Underflow", u))(ie || {}), Nt = ((u) => (u[u.Previous = -1] = "Previous", u[u.Next = 1] = "Next", u))(Nt || {});
function ke(u = document.body) {
  return u == null ? [] : Array.from(u.querySelectorAll(kD)).sort((e, D) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (D.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Ae = ((u) => (u[u.Strict = 0] = "Strict", u[u.Loose = 1] = "Loose", u))(Ae || {});
function xe(u, e = 0) {
  var D;
  return u === ((D = ku(u)) == null ? void 0 : D.body) ? !1 : ou(e, { 0() {
    return u.matches(kD);
  }, 1() {
    let f = u;
    for (; f !== null; ) {
      if (f.matches(kD))
        return !0;
      f = f.parentElement;
    }
    return !1;
  } });
}
function T1(u) {
  let e = ku(u);
  Eu(() => {
    e && !xe(e.activeElement, 0) && Ju(u);
  });
}
var jt = ((u) => (u[u.Keyboard = 0] = "Keyboard", u[u.Mouse = 1] = "Mouse", u))(jt || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (u) => {
  u.metaKey || u.altKey || u.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (u) => {
  u.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : u.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Ju(u) {
  u == null || u.focus({ preventScroll: !0 });
}
let Vt = ["textarea", "input"].join(",");
function zt(u) {
  var e, D;
  return (D = (e = u == null ? void 0 : u.matches) == null ? void 0 : e.call(u, Vt)) != null ? D : !1;
}
function $e(u, e = (D) => D) {
  return u.slice().sort((D, f) => {
    let t = e(D), n = e(f);
    if (t === null || n === null)
      return 0;
    let a = t.compareDocumentPosition(n);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Ut(u, e) {
  return Mu(ke(), e, { relativeTo: u });
}
function Mu(u, e, { sorted: D = !0, relativeTo: f = null, skipElements: t = [] } = {}) {
  var n;
  let a = (n = Array.isArray(u) ? u.length > 0 ? u[0].ownerDocument : document : u == null ? void 0 : u.ownerDocument) != null ? n : document, o = Array.isArray(u) ? D ? $e(u) : u : ke(u);
  t.length > 0 && o.length > 1 && (o = o.filter((h) => !t.includes(h))), f = f ?? a.activeElement;
  let r = (() => {
    if (e & 5)
      return 1;
    if (e & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = (() => {
    if (e & 1)
      return 0;
    if (e & 2)
      return Math.max(0, o.indexOf(f)) - 1;
    if (e & 4)
      return Math.max(0, o.indexOf(f)) + 1;
    if (e & 8)
      return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), i = e & 32 ? { preventScroll: !0 } : {}, s = 0, d = o.length, g;
  do {
    if (s >= d || s + d <= 0)
      return 0;
    let h = l + s;
    if (e & 16)
      h = (h + d) % d;
    else {
      if (h < 0)
        return 3;
      if (h >= d)
        return 1;
    }
    g = o[h], g == null || g.focus(i), s += r;
  } while (g !== a.activeElement);
  return e & 6 && zt(g) && g.select(), 2;
}
function M1() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Wt() {
  return /Android/gi.test(window.navigator.userAgent);
}
function O1() {
  return M1() || Wt();
}
function je(u, e, D) {
  we.isServer || gu((f) => {
    document.addEventListener(u, e, D), f(() => document.removeEventListener(u, e, D));
  });
}
function I1(u, e, D) {
  we.isServer || gu((f) => {
    window.addEventListener(u, e, D), f(() => window.removeEventListener(u, e, D));
  });
}
function Se(u, e, D = w(() => !0)) {
  function f(n, a) {
    if (!D.value || n.defaultPrevented)
      return;
    let o = a(n);
    if (o === null || !o.getRootNode().contains(o))
      return;
    let r = function l(i) {
      return typeof i == "function" ? l(i()) : Array.isArray(i) || i instanceof Set ? i : [i];
    }(u);
    for (let l of r) {
      if (l === null)
        continue;
      let i = l instanceof HTMLElement ? l : $(l);
      if (i != null && i.contains(o) || n.composed && n.composedPath().includes(i))
        return;
    }
    return !xe(o, Ae.Loose) && o.tabIndex !== -1 && n.preventDefault(), e(n, o);
  }
  let t = I(null);
  je("pointerdown", (n) => {
    var a, o;
    D.value && (t.value = ((o = (a = n.composedPath) == null ? void 0 : a.call(n)) == null ? void 0 : o[0]) || n.target);
  }, !0), je("mousedown", (n) => {
    var a, o;
    D.value && (t.value = ((o = (a = n.composedPath) == null ? void 0 : a.call(n)) == null ? void 0 : o[0]) || n.target);
  }, !0), je("click", (n) => {
    O1() || t.value && (f(n, () => t.value), t.value = null);
  }, !0), je("touchend", (n) => f(n, () => n.target instanceof HTMLElement ? n.target : null), !0), I1("blur", (n) => f(n, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Hf(u, e) {
  if (u)
    return u;
  let D = e ?? "button";
  if (typeof D == "string" && D.toLowerCase() === "button")
    return "button";
}
function Te(u, e) {
  let D = I(Hf(u.value.type, u.value.as));
  return ru(() => {
    D.value = Hf(u.value.type, u.value.as);
  }), gu(() => {
    var f;
    D.value || $(e) && $(e) instanceof HTMLButtonElement && !((f = $(e)) != null && f.hasAttribute("type")) && (D.value = "button");
  }), D;
}
function Gf(u) {
  return [u.screenX, u.screenY];
}
function Bf() {
  let u = I([-1, -1]);
  return { wasMoved(e) {
    let D = Gf(e);
    return u.value[0] === D[0] && u.value[1] === D[1] ? !1 : (u.value = D, !0);
  }, update(e) {
    u.value = Gf(e);
  } };
}
function yf({ container: u, accept: e, walk: D, enabled: f }) {
  gu(() => {
    let t = u.value;
    if (!t || f !== void 0 && !f.value)
      return;
    let n = ku(u);
    if (!n)
      return;
    let a = Object.assign((r) => e(r), { acceptNode: e }), o = n.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, a, !1);
    for (; o.nextNode(); )
      D(o.currentNode);
  });
}
var Au = ((u) => (u[u.None = 0] = "None", u[u.RenderStrategy = 1] = "RenderStrategy", u[u.Static = 2] = "Static", u))(Au || {}), Qu = ((u) => (u[u.Unmount = 0] = "Unmount", u[u.Hidden = 1] = "Hidden", u))(Qu || {});
function eu({ visible: u = !0, features: e = 0, ourProps: D, theirProps: f, ...t }) {
  var n;
  let a = L1(f, D), o = Object.assign(t, { props: a });
  if (u || e & 2 && a.static)
    return mD(o);
  if (e & 1) {
    let r = (n = a.unmount) == null || n ? 0 : 1;
    return ou(r, { 0() {
      return null;
    }, 1() {
      return mD({ ...t, props: { ...a, hidden: !0, style: { display: "none" } } });
    } });
  }
  return mD(o);
}
function mD({ props: u, attrs: e, slots: D, slot: f, name: t }) {
  var n, a;
  let { as: o, ...r } = ee(u, ["unmount", "static"]), l = (n = D.default) == null ? void 0 : n.call(D, f), i = {};
  if (f) {
    let s = !1, d = [];
    for (let [g, h] of Object.entries(f))
      typeof h == "boolean" && (s = !0), h === !0 && d.push(g);
    s && (i["data-headlessui-state"] = d.join(" "));
  }
  if (o === "template") {
    if (l = P1(l ?? []), Object.keys(r).length > 0 || Object.keys(e).length > 0) {
      let [s, ...d] = l ?? [];
      if (!qt(s) || d.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${t} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(r).concat(Object.keys(e)).map((_) => _.trim()).filter((_, C, p) => p.indexOf(_) === C).sort((_, C) => _.localeCompare(C)).map((_) => `  - ${_}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((_) => `  - ${_}`).join(`
`)].join(`
`));
      let g = L1((a = s.props) != null ? a : {}, r, i), h = $1(s, g, !0);
      for (let _ in g)
        _.startsWith("on") && (h.props || (h.props = {}), h.props[_] = g[_]);
      return h;
    }
    return Array.isArray(l) && l.length === 1 ? l[0] : l;
  }
  return uu(o, Object.assign({}, r, i), { default: () => l });
}
function P1(u) {
  return u.flatMap((e) => e.type === J ? P1(e.children) : [e]);
}
function L1(...u) {
  if (u.length === 0)
    return {};
  if (u.length === 1)
    return u[0];
  let e = {}, D = {};
  for (let f of u)
    for (let t in f)
      t.startsWith("on") && typeof f[t] == "function" ? (D[t] != null || (D[t] = []), D[t].push(f[t])) : e[t] = f[t];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(D).map((f) => [f, void 0])));
  for (let f in D)
    Object.assign(e, { [f](t, ...n) {
      let a = D[f];
      for (let o of a) {
        if (t instanceof Event && t.defaultPrevented)
          return;
        o(t, ...n);
      }
    } });
  return e;
}
function eD(u) {
  let e = Object.assign({}, u);
  for (let D in e)
    e[D] === void 0 && delete e[D];
  return e;
}
function ee(u, e = []) {
  let D = Object.assign({}, u);
  for (let f of e)
    f in D && delete D[f];
  return D;
}
function qt(u) {
  return u == null ? !1 : typeof u.type == "string" || typeof u.type == "object" || typeof u.type == "function";
}
var Iu = ((u) => (u[u.None = 1] = "None", u[u.Focusable = 2] = "Focusable", u[u.Hidden = 4] = "Hidden", u))(Iu || {});
let Lu = z({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(u, { slots: e, attrs: D }) {
  return () => {
    var f;
    let { features: t, ...n } = u, a = { "aria-hidden": (t & 2) === 2 ? !0 : (f = n["aria-hidden"]) != null ? f : void 0, hidden: (t & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(t & 4) === 4 && (t & 2) !== 2 && { display: "none" } } };
    return eu({ ourProps: a, theirProps: n, slot: {}, attrs: D, slots: e, name: "Hidden" });
  };
} }), R1 = Symbol("Context");
var nu = ((u) => (u[u.Open = 1] = "Open", u[u.Closed = 2] = "Closed", u[u.Closing = 4] = "Closing", u[u.Opening = 8] = "Opening", u))(nu || {});
function Yt() {
  return De() !== null;
}
function De() {
  return Cu(R1, null);
}
function Me(u) {
  Bu(R1, u);
}
var Y = ((u) => (u.Space = " ", u.Enter = "Enter", u.Escape = "Escape", u.Backspace = "Backspace", u.Delete = "Delete", u.ArrowLeft = "ArrowLeft", u.ArrowUp = "ArrowUp", u.ArrowRight = "ArrowRight", u.ArrowDown = "ArrowDown", u.Home = "Home", u.End = "End", u.PageUp = "PageUp", u.PageDown = "PageDown", u.Tab = "Tab", u))(Y || {}), N1 = ((u) => (u[u.Left = 0] = "Left", u[u.Right = 2] = "Right", u))(N1 || {});
function Ht(u) {
  function e() {
    document.readyState !== "loading" && (u(), document.removeEventListener("DOMContentLoaded", e));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", e), e());
}
let Yu = [];
Ht(() => {
  function u(e) {
    e.target instanceof HTMLElement && e.target !== document.body && Yu[0] !== e.target && (Yu.unshift(e.target), Yu = Yu.filter((D) => D != null && D.isConnected), Yu.splice(10));
  }
  window.addEventListener("click", u, { capture: !0 }), window.addEventListener("mousedown", u, { capture: !0 }), window.addEventListener("focus", u, { capture: !0 }), document.body.addEventListener("click", u, { capture: !0 }), document.body.addEventListener("mousedown", u, { capture: !0 }), document.body.addEventListener("focus", u, { capture: !0 });
});
function Gt(u) {
  throw new Error("Unexpected object: " + u);
}
var Z = ((u) => (u[u.First = 0] = "First", u[u.Previous = 1] = "Previous", u[u.Next = 2] = "Next", u[u.Last = 3] = "Last", u[u.Specific = 4] = "Specific", u[u.Nothing = 5] = "Nothing", u))(Z || {});
function He(u, e) {
  let D = e.resolveItems();
  if (D.length <= 0)
    return null;
  let f = e.resolveActiveIndex(), t = f ?? -1;
  switch (u.focus) {
    case 0: {
      for (let n = 0; n < D.length; ++n)
        if (!e.resolveDisabled(D[n], n, D))
          return n;
      return f;
    }
    case 1: {
      t === -1 && (t = D.length);
      for (let n = t - 1; n >= 0; --n)
        if (!e.resolveDisabled(D[n], n, D))
          return n;
      return f;
    }
    case 2: {
      for (let n = t + 1; n < D.length; ++n)
        if (!e.resolveDisabled(D[n], n, D))
          return n;
      return f;
    }
    case 3: {
      for (let n = D.length - 1; n >= 0; --n)
        if (!e.resolveDisabled(D[n], n, D))
          return n;
      return f;
    }
    case 4: {
      for (let n = 0; n < D.length; ++n)
        if (e.resolveId(D[n], n, D) === u.id)
          return n;
      return f;
    }
    case 5:
      return null;
    default:
      Gt(u);
  }
}
function DD(u = {}, e = null, D = []) {
  for (let [f, t] of Object.entries(u))
    V1(D, j1(e, f), t);
  return D;
}
function j1(u, e) {
  return u ? u + "[" + e + "]" : e;
}
function V1(u, e, D) {
  if (Array.isArray(D))
    for (let [f, t] of D.entries())
      V1(u, j1(e, f.toString()), t);
  else
    D instanceof Date ? u.push([e, D.toISOString()]) : typeof D == "boolean" ? u.push([e, D ? "1" : "0"]) : typeof D == "string" ? u.push([e, D]) : typeof D == "number" ? u.push([e, `${D}`]) : D == null ? u.push([e, ""]) : DD(D, e, u);
}
function z1(u) {
  var e, D;
  let f = (e = u == null ? void 0 : u.form) != null ? e : u.closest("form");
  if (f) {
    for (let t of f.elements)
      if (t !== u && (t.tagName === "INPUT" && t.type === "submit" || t.tagName === "BUTTON" && t.type === "submit" || t.nodeName === "INPUT" && t.type === "image")) {
        t.click();
        return;
      }
    (D = f.requestSubmit) == null || D.call(f);
  }
}
function Xt(u, e) {
  return u === e;
}
var Zt = ((u) => (u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))(Zt || {}), Kt = ((u) => (u[u.Single = 0] = "Single", u[u.Multi = 1] = "Multi", u))(Kt || {}), Qt = ((u) => (u[u.Pointer = 0] = "Pointer", u[u.Focus = 1] = "Focus", u[u.Other = 2] = "Other", u))(Qt || {});
let U1 = Symbol("ComboboxContext");
function se(u) {
  let e = Cu(U1, null);
  if (e === null) {
    let D = new Error(`<${u} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(D, se), D;
  }
  return e;
}
let W1 = Symbol("VirtualContext"), Jt = z({ name: "VirtualProvider", setup(u, { slots: e }) {
  let D = se("VirtualProvider"), f = w(() => {
    let o = $(D.optionsRef);
    if (!o)
      return { start: 0, end: 0 };
    let r = window.getComputedStyle(o);
    return { start: parseFloat(r.paddingBlockStart || r.paddingTop), end: parseFloat(r.paddingBlockEnd || r.paddingBottom) };
  }), t = St(w(() => ({ scrollPaddingStart: f.value.start, scrollPaddingEnd: f.value.end, count: D.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return $(D.optionsRef);
  }, overscan: 12 }))), n = w(() => {
    var o;
    return (o = D.virtual.value) == null ? void 0 : o.options;
  }), a = I(0);
  return au([n], () => {
    a.value += 1;
  }), Bu(W1, D.virtual.value ? t : null), () => [uu("div", { style: { position: "relative", width: "100%", height: `${t.value.getTotalSize()}px` }, ref: (o) => {
    if (o) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || D.activationTrigger.value === 0)
        return;
      D.activeOptionIndex.value !== null && D.virtual.value.options.length > D.activeOptionIndex.value && t.value.scrollToIndex(D.activeOptionIndex.value);
    }
  } }, t.value.getVirtualItems().map((o) => $1(e.default({ option: D.virtual.value.options[o.index], open: D.comboboxState.value === 0 })[0], { key: `${a.value}-${o.index}`, "data-index": o.index, "aria-setsize": D.virtual.value.options.length, "aria-posinset": o.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${o.start}px)`, overflowAnchor: "none" } })))];
} }), ua = z({ name: "Combobox", emits: { "update:modelValue": (u) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(u, { slots: e, attrs: D, emit: f }) {
  let t = I(1), n = I(null), a = I(null), o = I(null), r = I(null), l = I({ static: !1, hold: !1 }), i = I([]), s = I(null), d = I(2), g = I(!1);
  function h(T = (S) => S) {
    let S = s.value !== null ? i.value[s.value] : null, W = T(i.value.slice()), L = W.length > 0 && W[0].dataRef.order.value !== null ? W.sort((X, lu) => X.dataRef.order.value - lu.dataRef.order.value) : $e(W, (X) => $(X.dataRef.domRef)), H = S ? L.indexOf(S) : null;
    return H === -1 && (H = null), { options: L, activeOptionIndex: H };
  }
  let _ = w(() => u.multiple ? 1 : 0), C = w(() => u.nullable), [p, b] = uD(w(() => u.modelValue), (T) => f("update:modelValue", T), w(() => u.defaultValue)), m = w(() => p.value === void 0 ? ou(_.value, { 1: [], 0: void 0 }) : p.value), F = null, c = null;
  function B(T) {
    return ou(_.value, { 0() {
      return b == null ? void 0 : b(T);
    }, 1: () => {
      let S = cu(A.value.value).slice(), W = cu(T), L = S.findIndex((H) => A.compare(W, cu(H)));
      return L === -1 ? S.push(W) : S.splice(L, 1), b == null ? void 0 : b(S);
    } });
  }
  let k = w(() => {
  });
  au([k], ([T], [S]) => {
    if (A.virtual.value && T && S && s.value !== null) {
      let W = T.indexOf(S[s.value]);
      W !== -1 ? s.value = W : s.value = null;
    }
  });
  let A = { comboboxState: t, value: m, mode: _, compare(T, S) {
    if (typeof u.by == "string") {
      let W = u.by;
      return (T == null ? void 0 : T[W]) === (S == null ? void 0 : S[W]);
    }
    return u.by === null ? Xt(T, S) : u.by(T, S);
  }, calculateIndex(T) {
    return A.virtual.value ? u.by === null ? A.virtual.value.options.indexOf(T) : A.virtual.value.options.findIndex((S) => A.compare(S, T)) : i.value.findIndex((S) => A.compare(S.dataRef.value, T));
  }, defaultValue: w(() => u.defaultValue), nullable: C, immediate: w(() => !1), virtual: w(() => null), inputRef: a, labelRef: n, buttonRef: o, optionsRef: r, disabled: w(() => u.disabled), options: i, change(T) {
    b(T);
  }, activeOptionIndex: w(() => {
    if (g.value && s.value === null && (A.virtual.value ? A.virtual.value.options.length > 0 : i.value.length > 0)) {
      if (A.virtual.value) {
        let S = A.virtual.value.options.findIndex((W) => {
          var L;
          return !((L = A.virtual.value) != null && L.disabled(W));
        });
        if (S !== -1)
          return S;
      }
      let T = i.value.findIndex((S) => !S.dataRef.disabled);
      if (T !== -1)
        return T;
    }
    return s.value;
  }), activationTrigger: d, optionsPropsRef: l, closeCombobox() {
    g.value = !1, !u.disabled && t.value !== 1 && (t.value = 1, s.value = null);
  }, openCombobox() {
    if (g.value = !0, !u.disabled && t.value !== 0) {
      if (A.value.value) {
        let T = A.calculateIndex(A.value.value);
        T !== -1 && (s.value = T);
      }
      t.value = 0;
    }
  }, setActivationTrigger(T) {
    d.value = T;
  }, goToOption(T, S, W) {
    g.value = !1, F !== null && cancelAnimationFrame(F), F = requestAnimationFrame(() => {
      if (u.disabled || r.value && !l.value.static && t.value === 1)
        return;
      if (A.virtual.value) {
        s.value = T === Z.Specific ? S : He({ focus: T }, { resolveItems: () => A.virtual.value.options, resolveActiveIndex: () => {
          var X, lu;
          return (lu = (X = A.activeOptionIndex.value) != null ? X : A.virtual.value.options.findIndex((yu) => {
            var Tu;
            return !((Tu = A.virtual.value) != null && Tu.disabled(yu));
          })) != null ? lu : null;
        }, resolveDisabled: (X) => A.virtual.value.disabled(X), resolveId() {
          throw new Error("Function not implemented.");
        } }), d.value = W ?? 2;
        return;
      }
      let L = h();
      if (L.activeOptionIndex === null) {
        let X = L.options.findIndex((lu) => !lu.dataRef.disabled);
        X !== -1 && (L.activeOptionIndex = X);
      }
      let H = T === Z.Specific ? S : He({ focus: T }, { resolveItems: () => L.options, resolveActiveIndex: () => L.activeOptionIndex, resolveId: (X) => X.id, resolveDisabled: (X) => X.dataRef.disabled });
      s.value = H, d.value = W ?? 2, i.value = L.options;
    });
  }, selectOption(T) {
    let S = i.value.find((L) => L.id === T);
    if (!S)
      return;
    let { dataRef: W } = S;
    B(W.value);
  }, selectActiveOption() {
    if (A.activeOptionIndex.value !== null) {
      if (A.virtual.value)
        B(A.virtual.value.options[A.activeOptionIndex.value]);
      else {
        let { dataRef: T } = i.value[A.activeOptionIndex.value];
        B(T.value);
      }
      A.goToOption(Z.Specific, A.activeOptionIndex.value);
    }
  }, registerOption(T, S) {
    let W = Qe({ id: T, dataRef: S });
    if (A.virtual.value) {
      i.value.push(W);
      return;
    }
    c && cancelAnimationFrame(c);
    let L = h((H) => (H.push(W), H));
    s.value === null && A.isSelected(S.value.value) && (L.activeOptionIndex = L.options.indexOf(W)), i.value = L.options, s.value = L.activeOptionIndex, d.value = 2, L.options.some((H) => !$(H.dataRef.domRef)) && (c = requestAnimationFrame(() => {
      let H = h();
      i.value = H.options, s.value = H.activeOptionIndex;
    }));
  }, unregisterOption(T, S) {
    if (F !== null && cancelAnimationFrame(F), S && (g.value = !0), A.virtual.value) {
      i.value = i.value.filter((L) => L.id !== T);
      return;
    }
    let W = h((L) => {
      let H = L.findIndex((X) => X.id === T);
      return H !== -1 && L.splice(H, 1), L;
    });
    i.value = W.options, s.value = W.activeOptionIndex, d.value = 2;
  }, isSelected(T) {
    return ou(_.value, { 0: () => A.compare(cu(A.value.value), cu(T)), 1: () => cu(A.value.value).some((S) => A.compare(cu(S), cu(T))) });
  }, isActive(T) {
    return s.value === A.calculateIndex(T);
  } };
  Se([a, o, r], () => A.closeCombobox(), w(() => t.value === 0)), Bu(U1, A), Me(w(() => ou(t.value, { 0: nu.Open, 1: nu.Closed })));
  let j = w(() => {
    var T;
    return (T = $(a)) == null ? void 0 : T.closest("form");
  });
  return ru(() => {
    au([j], () => {
      if (!j.value || u.defaultValue === void 0)
        return;
      function T() {
        A.change(u.defaultValue);
      }
      return j.value.addEventListener("reset", T), () => {
        var S;
        (S = j.value) == null || S.removeEventListener("reset", T);
      };
    }, { immediate: !0 });
  }), () => {
    var T, S, W;
    let { name: L, disabled: H, form: X, ...lu } = u, yu = { open: t.value === 0, disabled: H, activeIndex: A.activeOptionIndex.value, activeOption: A.activeOptionIndex.value === null ? null : A.virtual.value ? A.virtual.value.options[(T = A.activeOptionIndex.value) != null ? T : 0] : (W = (S = A.options.value[A.activeOptionIndex.value]) == null ? void 0 : S.dataRef.value) != null ? W : null, value: m.value };
    return uu(J, [...L != null && m.value != null ? DD({ [L]: m.value }).map(([Tu, Ru]) => uu(Lu, eD({ features: Iu.Hidden, key: Tu, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: X, disabled: H, name: Tu, value: Ru }))) : [], eu({ theirProps: { ...D, ...ee(lu, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: yu, slots: e, attrs: D, name: "Combobox" })]);
  };
} }), ea = z({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D }) {
  var f;
  let t = (f = u.id) != null ? f : `headlessui-combobox-label-${su()}`, n = se("ComboboxLabel");
  function a() {
    var o;
    (o = $(n.inputRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: n.comboboxState.value === 0, disabled: n.disabled.value }, { ...r } = u, l = { id: t, ref: n.labelRef, onClick: a };
    return eu({ ourProps: l, theirProps: r, slot: o, attrs: e, slots: D, name: "ComboboxLabel" });
  };
} }), Da = z({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-combobox-button-${su()}`, a = se("ComboboxButton");
  f({ el: a.buttonRef, $el: a.buttonRef });
  function o(i) {
    a.disabled.value || (a.comboboxState.value === 0 ? a.closeCombobox() : (i.preventDefault(), a.openCombobox()), Eu(() => {
      var s;
      return (s = $(a.inputRef)) == null ? void 0 : s.focus({ preventScroll: !0 });
    }));
  }
  function r(i) {
    switch (i.key) {
      case Y.ArrowDown:
        i.preventDefault(), i.stopPropagation(), a.comboboxState.value === 1 && a.openCombobox(), Eu(() => {
          var s;
          return (s = a.inputRef.value) == null ? void 0 : s.focus({ preventScroll: !0 });
        });
        return;
      case Y.ArrowUp:
        i.preventDefault(), i.stopPropagation(), a.comboboxState.value === 1 && (a.openCombobox(), Eu(() => {
          a.value.value || a.goToOption(Z.Last);
        })), Eu(() => {
          var s;
          return (s = a.inputRef.value) == null ? void 0 : s.focus({ preventScroll: !0 });
        });
        return;
      case Y.Escape:
        if (a.comboboxState.value !== 0)
          return;
        i.preventDefault(), a.optionsRef.value && !a.optionsPropsRef.value.static && i.stopPropagation(), a.closeCombobox(), Eu(() => {
          var s;
          return (s = a.inputRef.value) == null ? void 0 : s.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let l = Te(w(() => ({ as: u.as, type: e.type })), a.buttonRef);
  return () => {
    var i, s;
    let d = { open: a.comboboxState.value === 0, disabled: a.disabled.value, value: a.value.value }, { ...g } = u, h = { ref: a.buttonRef, id: n, type: l.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (i = $(a.optionsRef)) == null ? void 0 : i.id, "aria-expanded": a.comboboxState.value === 0, "aria-labelledby": a.labelRef.value ? [(s = $(a.labelRef)) == null ? void 0 : s.id, n].join(" ") : void 0, disabled: a.disabled.value === !0 ? !0 : void 0, onKeydown: r, onClick: o };
    return eu({ ourProps: h, theirProps: g, slot: d, attrs: e, slots: D, name: "ComboboxButton" });
  };
} }), fa = z({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: null } }, emits: { change: (u) => !0 }, setup(u, { emit: e, attrs: D, slots: f, expose: t }) {
  var n;
  let a = (n = u.id) != null ? n : `headlessui-combobox-input-${su()}`, o = se("ComboboxInput"), r = w(() => ku($(o.inputRef))), l = { value: !1 };
  t({ el: o.inputRef, $el: o.inputRef });
  function i() {
    o.change(null);
    let c = $(o.optionsRef);
    c && (c.scrollTop = 0), o.goToOption(Z.Nothing);
  }
  let s = w(() => {
    var c;
    let B = o.value.value;
    return $(o.inputRef) ? typeof u.displayValue < "u" && B !== void 0 ? (c = u.displayValue(B)) != null ? c : "" : typeof B == "string" ? B : "" : "";
  });
  ru(() => {
    au([s, o.comboboxState, r], ([c, B], [k, A]) => {
      if (l.value)
        return;
      let j = $(o.inputRef);
      j && ((A === 0 && B === 1 || c !== k) && (j.value = c), requestAnimationFrame(() => {
        var T;
        if (l.value || !j || ((T = r.value) == null ? void 0 : T.activeElement) !== j)
          return;
        let { selectionStart: S, selectionEnd: W } = j;
        Math.abs((W ?? 0) - (S ?? 0)) === 0 && S === 0 && j.setSelectionRange(j.value.length, j.value.length);
      }));
    }, { immediate: !0 }), au([o.comboboxState], ([c], [B]) => {
      if (c === 0 && B === 1) {
        if (l.value)
          return;
        let k = $(o.inputRef);
        if (!k)
          return;
        let A = k.value, { selectionStart: j, selectionEnd: T, selectionDirection: S } = k;
        k.value = "", k.value = A, S !== null ? k.setSelectionRange(j, T, S) : k.setSelectionRange(j, T);
      }
    });
  });
  let d = I(!1);
  function g() {
    d.value = !0;
  }
  function h() {
    ue().nextFrame(() => {
      d.value = !1;
    });
  }
  let _ = Mt();
  function C(c) {
    switch (l.value = !0, _(() => {
      l.value = !1;
    }), c.key) {
      case Y.Enter:
        if (l.value = !1, o.comboboxState.value !== 0 || d.value)
          return;
        if (c.preventDefault(), c.stopPropagation(), o.activeOptionIndex.value === null) {
          o.closeCombobox();
          return;
        }
        o.selectActiveOption(), o.mode.value === 0 && o.closeCombobox();
        break;
      case Y.ArrowDown:
        return l.value = !1, c.preventDefault(), c.stopPropagation(), ou(o.comboboxState.value, { 0: () => o.goToOption(Z.Next), 1: () => o.openCombobox() });
      case Y.ArrowUp:
        return l.value = !1, c.preventDefault(), c.stopPropagation(), ou(o.comboboxState.value, { 0: () => o.goToOption(Z.Previous), 1: () => {
          o.openCombobox(), Eu(() => {
            o.value.value || o.goToOption(Z.Last);
          });
        } });
      case Y.Home:
        if (c.shiftKey)
          break;
        return l.value = !1, c.preventDefault(), c.stopPropagation(), o.goToOption(Z.First);
      case Y.PageUp:
        return l.value = !1, c.preventDefault(), c.stopPropagation(), o.goToOption(Z.First);
      case Y.End:
        if (c.shiftKey)
          break;
        return l.value = !1, c.preventDefault(), c.stopPropagation(), o.goToOption(Z.Last);
      case Y.PageDown:
        return l.value = !1, c.preventDefault(), c.stopPropagation(), o.goToOption(Z.Last);
      case Y.Escape:
        if (l.value = !1, o.comboboxState.value !== 0)
          return;
        c.preventDefault(), o.optionsRef.value && !o.optionsPropsRef.value.static && c.stopPropagation(), o.nullable.value && o.mode.value === 0 && o.value.value === null && i(), o.closeCombobox();
        break;
      case Y.Tab:
        if (l.value = !1, o.comboboxState.value !== 0)
          return;
        o.mode.value === 0 && o.activationTrigger.value !== 1 && o.selectActiveOption(), o.closeCombobox();
        break;
    }
  }
  function p(c) {
    e("change", c), o.nullable.value && o.mode.value === 0 && c.target.value === "" && i(), o.openCombobox();
  }
  function b(c) {
    var B, k, A;
    let j = (B = c.relatedTarget) != null ? B : Yu.find((T) => T !== c.currentTarget);
    if (l.value = !1, !((k = $(o.optionsRef)) != null && k.contains(j)) && !((A = $(o.buttonRef)) != null && A.contains(j)) && o.comboboxState.value === 0)
      return c.preventDefault(), o.mode.value === 0 && (o.nullable.value && o.value.value === null ? i() : o.activationTrigger.value !== 1 && o.selectActiveOption()), o.closeCombobox();
  }
  function m(c) {
    var B, k, A;
    let j = (B = c.relatedTarget) != null ? B : Yu.find((T) => T !== c.currentTarget);
    (k = $(o.buttonRef)) != null && k.contains(j) || (A = $(o.optionsRef)) != null && A.contains(j) || o.disabled.value || o.immediate.value && o.comboboxState.value !== 0 && (o.openCombobox(), ue().nextFrame(() => {
      o.setActivationTrigger(1);
    }));
  }
  let F = w(() => {
    var c, B, k, A;
    return (A = (k = (B = u.defaultValue) != null ? B : o.defaultValue.value !== void 0 ? (c = u.displayValue) == null ? void 0 : c.call(u, o.defaultValue.value) : null) != null ? k : o.defaultValue.value) != null ? A : "";
  });
  return () => {
    var c, B, k, A, j, T, S;
    let W = { open: o.comboboxState.value === 0 }, { displayValue: L, onChange: H, ...X } = u, lu = { "aria-controls": (c = o.optionsRef.value) == null ? void 0 : c.id, "aria-expanded": o.comboboxState.value === 0, "aria-activedescendant": o.activeOptionIndex.value === null ? void 0 : o.virtual.value ? (B = o.options.value.find((yu) => !o.virtual.value.disabled(yu.dataRef.value) && o.compare(yu.dataRef.value, o.virtual.value.options[o.activeOptionIndex.value]))) == null ? void 0 : B.id : (k = o.options.value[o.activeOptionIndex.value]) == null ? void 0 : k.id, "aria-labelledby": (T = (A = $(o.labelRef)) == null ? void 0 : A.id) != null ? T : (j = $(o.buttonRef)) == null ? void 0 : j.id, "aria-autocomplete": "list", id: a, onCompositionstart: g, onCompositionend: h, onKeydown: C, onInput: p, onFocus: m, onBlur: b, role: "combobox", type: (S = D.type) != null ? S : "text", tabIndex: 0, ref: o.inputRef, defaultValue: F.value, disabled: o.disabled.value === !0 ? !0 : void 0 };
    return eu({ ourProps: lu, theirProps: X, slot: W, attrs: D, slots: f, features: Au.RenderStrategy | Au.Static, name: "ComboboxInput" });
  };
} }), ta = z({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(u, { attrs: e, slots: D, expose: f }) {
  let t = se("ComboboxOptions"), n = `headlessui-combobox-options-${su()}`;
  f({ el: t.optionsRef, $el: t.optionsRef }), gu(() => {
    t.optionsPropsRef.value.static = u.static;
  }), gu(() => {
    t.optionsPropsRef.value.hold = u.hold;
  });
  let a = De(), o = w(() => a !== null ? (a.value & nu.Open) === nu.Open : t.comboboxState.value === 0);
  yf({ container: w(() => $(t.optionsRef)), enabled: w(() => t.comboboxState.value === 0), accept(l) {
    return l.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : l.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(l) {
    l.setAttribute("role", "none");
  } });
  function r(l) {
    l.preventDefault();
  }
  return () => {
    var l, i, s;
    let d = { open: t.comboboxState.value === 0 }, g = { "aria-labelledby": (s = (l = $(t.labelRef)) == null ? void 0 : l.id) != null ? s : (i = $(t.buttonRef)) == null ? void 0 : i.id, id: n, ref: t.optionsRef, role: "listbox", "aria-multiselectable": t.mode.value === 1 ? !0 : void 0, onMousedown: r }, h = ee(u, ["hold"]);
    return eu({ ourProps: g, theirProps: h, slot: d, attrs: e, slots: t.virtual.value && t.comboboxState.value === 0 ? { ...D, default: () => [uu(Jt, {}, D.default)] } : D, features: Au.RenderStrategy | Au.Static, visible: o.value, name: "ComboboxOptions" });
  };
} }), aa = z({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(u, { slots: e, attrs: D, expose: f }) {
  let t = se("ComboboxOption"), n = `headlessui-combobox-option-${su()}`, a = I(null), o = w(() => u.disabled);
  f({ el: a, $el: a });
  let r = w(() => {
    var b;
    return t.virtual.value ? t.activeOptionIndex.value === t.calculateIndex(u.value) : t.activeOptionIndex.value === null ? !1 : ((b = t.options.value[t.activeOptionIndex.value]) == null ? void 0 : b.id) === n;
  }), l = w(() => t.isSelected(u.value)), i = Cu(W1, null), s = w(() => ({ disabled: u.disabled, value: u.value, domRef: a, order: w(() => u.order) }));
  ru(() => t.registerOption(n, s)), vu(() => t.unregisterOption(n, r.value)), gu(() => {
    let b = $(a);
    b && (i == null || i.value.measureElement(b));
  }), gu(() => {
    t.comboboxState.value === 0 && r.value && (t.virtual.value || t.activationTrigger.value !== 0 && Eu(() => {
      var b, m;
      return (m = (b = $(a)) == null ? void 0 : b.scrollIntoView) == null ? void 0 : m.call(b, { block: "nearest" });
    }));
  });
  function d(b) {
    b.preventDefault(), b.button === N1.Left && (o.value || (t.selectOption(n), O1() || requestAnimationFrame(() => {
      var m;
      return (m = $(t.inputRef)) == null ? void 0 : m.focus({ preventScroll: !0 });
    }), t.mode.value === 0 && t.closeCombobox()));
  }
  function g() {
    var b;
    if (u.disabled || (b = t.virtual.value) != null && b.disabled(u.value))
      return t.goToOption(Z.Nothing);
    let m = t.calculateIndex(u.value);
    t.goToOption(Z.Specific, m);
  }
  let h = Bf();
  function _(b) {
    h.update(b);
  }
  function C(b) {
    var m;
    if (!h.wasMoved(b) || u.disabled || (m = t.virtual.value) != null && m.disabled(u.value) || r.value)
      return;
    let F = t.calculateIndex(u.value);
    t.goToOption(Z.Specific, F, 0);
  }
  function p(b) {
    var m;
    h.wasMoved(b) && (u.disabled || (m = t.virtual.value) != null && m.disabled(u.value) || r.value && (t.optionsPropsRef.value.hold || t.goToOption(Z.Nothing)));
  }
  return () => {
    let { disabled: b } = u, m = { active: r.value, selected: l.value, disabled: b }, F = { id: n, ref: a, role: "option", tabIndex: b === !0 ? void 0 : -1, "aria-disabled": b === !0 ? !0 : void 0, "aria-selected": l.value, disabled: void 0, onMousedown: d, onFocus: g, onPointerenter: _, onMouseenter: _, onPointermove: C, onMousemove: C, onPointerleave: p, onMouseleave: p }, c = ee(u, ["order", "value"]);
    return eu({ ourProps: F, theirProps: c, slot: m, attrs: D, slots: e, name: "ComboboxOption" });
  };
} });
function _f(u, e, D, f) {
  we.isServer || gu((t) => {
    u = u ?? window, u.addEventListener(e, D, f), t(() => u.removeEventListener(e, D, f));
  });
}
var Ou = ((u) => (u[u.Forwards = 0] = "Forwards", u[u.Backwards = 1] = "Backwards", u))(Ou || {});
function wf() {
  let u = I(0);
  return I1("keydown", (e) => {
    e.key === "Tab" && (u.value = e.shiftKey ? 1 : 0);
  }), u;
}
function q1(u) {
  if (!u)
    return /* @__PURE__ */ new Set();
  if (typeof u == "function")
    return new Set(u());
  let e = /* @__PURE__ */ new Set();
  for (let D of u.value) {
    let f = $(D);
    f instanceof HTMLElement && e.add(f);
  }
  return e;
}
var Y1 = ((u) => (u[u.None = 1] = "None", u[u.InitialFocus = 2] = "InitialFocus", u[u.TabLock = 4] = "TabLock", u[u.FocusLock = 8] = "FocusLock", u[u.RestoreFocus = 16] = "RestoreFocus", u[u.All = 30] = "All", u))(Y1 || {});
let he = Object.assign(z({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: I(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(u, { attrs: e, slots: D, expose: f }) {
  let t = I(null);
  f({ el: t, $el: t });
  let n = w(() => ku(t)), a = I(!1);
  ru(() => a.value = !0), vu(() => a.value = !1), oa({ ownerDocument: n }, w(() => a.value && !!(u.features & 16)));
  let o = ra({ ownerDocument: n, container: t, initialFocus: w(() => u.initialFocus) }, w(() => a.value && !!(u.features & 2)));
  la({ ownerDocument: n, container: t, containers: u.containers, previousActiveElement: o }, w(() => a.value && !!(u.features & 8)));
  let r = wf();
  function l(g) {
    let h = $(t);
    h && ((_) => _())(() => {
      ou(r.value, { [Ou.Forwards]: () => {
        Mu(h, bu.First, { skipElements: [g.relatedTarget] });
      }, [Ou.Backwards]: () => {
        Mu(h, bu.Last, { skipElements: [g.relatedTarget] });
      } });
    });
  }
  let i = I(!1);
  function s(g) {
    g.key === "Tab" && (i.value = !0, requestAnimationFrame(() => {
      i.value = !1;
    }));
  }
  function d(g) {
    if (!a.value)
      return;
    let h = q1(u.containers);
    $(t) instanceof HTMLElement && h.add($(t));
    let _ = g.relatedTarget;
    _ instanceof HTMLElement && _.dataset.headlessuiFocusGuard !== "true" && (H1(h, _) || (i.value ? Mu($(t), ou(r.value, { [Ou.Forwards]: () => bu.Next, [Ou.Backwards]: () => bu.Previous }) | bu.WrapAround, { relativeTo: g.target }) : g.target instanceof HTMLElement && Ju(g.target)));
  }
  return () => {
    let g = {}, h = { ref: t, onKeydown: s, onFocusout: d }, { features: _, initialFocus: C, containers: p, ...b } = u;
    return uu(J, [!!(_ & 4) && uu(Lu, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: l, features: Iu.Focusable }), eu({ ourProps: h, theirProps: { ...e, ...b }, slot: g, attrs: e, slots: D, name: "FocusTrap" }), !!(_ & 4) && uu(Lu, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: l, features: Iu.Focusable })]);
  };
} }), { features: Y1 });
function na(u) {
  let e = I(Yu.slice());
  return au([u], ([D], [f]) => {
    f === !0 && D === !1 ? hf(() => {
      e.value.splice(0);
    }) : f === !1 && D === !0 && (e.value = Yu.slice());
  }, { flush: "post" }), () => {
    var D;
    return (D = e.value.find((f) => f != null && f.isConnected)) != null ? D : null;
  };
}
function oa({ ownerDocument: u }, e) {
  let D = na(e);
  ru(() => {
    gu(() => {
      var f, t;
      e.value || ((f = u.value) == null ? void 0 : f.activeElement) === ((t = u.value) == null ? void 0 : t.body) && Ju(D());
    }, { flush: "post" });
  }), vu(() => {
    e.value && Ju(D());
  });
}
function ra({ ownerDocument: u, container: e, initialFocus: D }, f) {
  let t = I(null), n = I(!1);
  return ru(() => n.value = !0), vu(() => n.value = !1), ru(() => {
    au([e, D, f], (a, o) => {
      if (a.every((l, i) => (o == null ? void 0 : o[i]) === l) || !f.value)
        return;
      let r = $(e);
      r && hf(() => {
        var l, i;
        if (!n.value)
          return;
        let s = $(D), d = (l = u.value) == null ? void 0 : l.activeElement;
        if (s) {
          if (s === d) {
            t.value = d;
            return;
          }
        } else if (r.contains(d)) {
          t.value = d;
          return;
        }
        s ? Ju(s) : Mu(r, bu.First | bu.NoScroll) === ie.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), t.value = (i = u.value) == null ? void 0 : i.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), t;
}
function la({ ownerDocument: u, container: e, containers: D, previousActiveElement: f }, t) {
  var n;
  _f((n = u.value) == null ? void 0 : n.defaultView, "focus", (a) => {
    if (!t.value)
      return;
    let o = q1(D);
    $(e) instanceof HTMLElement && o.add($(e));
    let r = f.value;
    if (!r)
      return;
    let l = a.target;
    l && l instanceof HTMLElement ? H1(o, l) ? (f.value = l, Ju(l)) : (a.preventDefault(), a.stopPropagation(), Ju(r)) : Ju(f.value);
  }, !0);
}
function H1(u, e) {
  for (let D of u)
    if (D.contains(e))
      return !0;
  return !1;
}
function ia(u) {
  let e = gf(u.getSnapshot());
  return vu(u.subscribe(() => {
    e.value = u.getSnapshot();
  })), e;
}
function da(u, e) {
  let D = u(), f = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return D;
  }, subscribe(t) {
    return f.add(t), () => f.delete(t);
  }, dispatch(t, ...n) {
    let a = e[t].call(D, ...n);
    a && (D = a, f.forEach((o) => o()));
  } };
}
function sa() {
  let u;
  return { before({ doc: e }) {
    var D;
    let f = e.documentElement;
    u = ((D = e.defaultView) != null ? D : window).innerWidth - f.clientWidth;
  }, after({ doc: e, d: D }) {
    let f = e.documentElement, t = f.clientWidth - f.offsetWidth, n = u - t;
    D.style(f, "paddingRight", `${n}px`);
  } };
}
function ca() {
  return M1() ? { before({ doc: u, d: e, meta: D }) {
    function f(t) {
      return D.containers.flatMap((n) => n()).some((n) => n.contains(t));
    }
    e.microTask(() => {
      var t;
      if (window.getComputedStyle(u.documentElement).scrollBehavior !== "auto") {
        let o = ue();
        o.style(u.documentElement, "scrollBehavior", "auto"), e.add(() => e.microTask(() => o.dispose()));
      }
      let n = (t = window.scrollY) != null ? t : window.pageYOffset, a = null;
      e.addEventListener(u, "click", (o) => {
        if (o.target instanceof HTMLElement)
          try {
            let r = o.target.closest("a");
            if (!r)
              return;
            let { hash: l } = new URL(r.href), i = u.querySelector(l);
            i && !f(i) && (a = i);
          } catch {
          }
      }, !0), e.addEventListener(u, "touchstart", (o) => {
        if (o.target instanceof HTMLElement)
          if (f(o.target)) {
            let r = o.target;
            for (; r.parentElement && f(r.parentElement); )
              r = r.parentElement;
            e.style(r, "overscrollBehavior", "contain");
          } else
            e.style(o.target, "touchAction", "none");
      }), e.addEventListener(u, "touchmove", (o) => {
        if (o.target instanceof HTMLElement) {
          if (o.target.tagName === "INPUT")
            return;
          if (f(o.target)) {
            let r = o.target;
            for (; r.parentElement && r.dataset.headlessuiPortal !== "" && !(r.scrollHeight > r.clientHeight || r.scrollWidth > r.clientWidth); )
              r = r.parentElement;
            r.dataset.headlessuiPortal === "" && o.preventDefault();
          } else
            o.preventDefault();
        }
      }, { passive: !1 }), e.add(() => {
        var o;
        let r = (o = window.scrollY) != null ? o : window.pageYOffset;
        n !== r && window.scrollTo(0, n), a && a.isConnected && (a.scrollIntoView({ block: "nearest" }), a = null);
      });
    });
  } } : {};
}
function Fa() {
  return { before({ doc: u, d: e }) {
    e.style(u.documentElement, "overflow", "hidden");
  } };
}
function Ca(u) {
  let e = {};
  for (let D of u)
    Object.assign(e, D(e));
  return e;
}
let le = da(() => /* @__PURE__ */ new Map(), { PUSH(u, e) {
  var D;
  let f = (D = this.get(u)) != null ? D : { doc: u, count: 0, d: ue(), meta: /* @__PURE__ */ new Set() };
  return f.count++, f.meta.add(e), this.set(u, f), this;
}, POP(u, e) {
  let D = this.get(u);
  return D && (D.count--, D.meta.delete(e)), this;
}, SCROLL_PREVENT({ doc: u, d: e, meta: D }) {
  let f = { doc: u, d: e, meta: Ca(D) }, t = [ca(), sa(), Fa()];
  t.forEach(({ before: n }) => n == null ? void 0 : n(f)), t.forEach(({ after: n }) => n == null ? void 0 : n(f));
}, SCROLL_ALLOW({ d: u }) {
  u.dispose();
}, TEARDOWN({ doc: u }) {
  this.delete(u);
} });
le.subscribe(() => {
  let u = le.getSnapshot(), e = /* @__PURE__ */ new Map();
  for (let [D] of u)
    e.set(D, D.documentElement.style.overflow);
  for (let D of u.values()) {
    let f = e.get(D.doc) === "hidden", t = D.count !== 0;
    (t && !f || !t && f) && le.dispatch(D.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", D), D.count === 0 && le.dispatch("TEARDOWN", D);
  }
});
function Ea(u, e, D) {
  let f = ia(le), t = w(() => {
    let n = u.value ? f.value.get(u.value) : void 0;
    return n ? n.count > 0 : !1;
  });
  return au([u, e], ([n, a], [o], r) => {
    if (!n || !a)
      return;
    le.dispatch("PUSH", n, D);
    let l = !1;
    r(() => {
      l || (le.dispatch("POP", o ?? n, D), l = !0);
    });
  }, { immediate: !0 }), t;
}
let pD = /* @__PURE__ */ new Map(), Be = /* @__PURE__ */ new Map();
function Xf(u, e = I(!0)) {
  gu((D) => {
    var f;
    if (!e.value)
      return;
    let t = $(u);
    if (!t)
      return;
    D(function() {
      var a;
      if (!t)
        return;
      let o = (a = Be.get(t)) != null ? a : 1;
      if (o === 1 ? Be.delete(t) : Be.set(t, o - 1), o !== 1)
        return;
      let r = pD.get(t);
      r && (r["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", r["aria-hidden"]), t.inert = r.inert, pD.delete(t));
    });
    let n = (f = Be.get(t)) != null ? f : 0;
    Be.set(t, n + 1), n === 0 && (pD.set(t, { "aria-hidden": t.getAttribute("aria-hidden"), inert: t.inert }), t.setAttribute("aria-hidden", "true"), t.inert = !0);
  });
}
function G1({ defaultContainers: u = [], portals: e, mainTreeNodeRef: D } = {}) {
  let f = I(null), t = ku(f);
  function n() {
    var a, o, r;
    let l = [];
    for (let i of u)
      i !== null && (i instanceof HTMLElement ? l.push(i) : "value" in i && i.value instanceof HTMLElement && l.push(i.value));
    if (e != null && e.value)
      for (let i of e.value)
        l.push(i);
    for (let i of (a = t == null ? void 0 : t.querySelectorAll("html > *, body > *")) != null ? a : [])
      i !== document.body && i !== document.head && i instanceof HTMLElement && i.id !== "headlessui-portal-root" && (i.contains($(f)) || i.contains((r = (o = $(f)) == null ? void 0 : o.getRootNode()) == null ? void 0 : r.host) || l.some((s) => i.contains(s)) || l.push(i));
    return l;
  }
  return { resolveContainers: n, contains(a) {
    return n().some((o) => o.contains(a));
  }, mainTreeNodeRef: f, MainTreeNode() {
    return D != null ? null : uu(Lu, { features: Iu.Hidden, ref: f });
  } };
}
function ma() {
  let u = I(null);
  return { mainTreeNodeRef: u, MainTreeNode() {
    return uu(Lu, { features: Iu.Hidden, ref: u });
  } };
}
let X1 = Symbol("ForcePortalRootContext");
function pa() {
  return Cu(X1, !1);
}
let AD = z({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(u, { slots: e, attrs: D }) {
  return Bu(X1, u.force), () => {
    let { force: f, ...t } = u;
    return eu({ theirProps: t, ourProps: {}, slot: {}, slots: e, attrs: D, name: "ForcePortalRoot" });
  };
} }), Z1 = Symbol("StackContext");
var xD = ((u) => (u[u.Add = 0] = "Add", u[u.Remove = 1] = "Remove", u))(xD || {});
function ba() {
  return Cu(Z1, () => {
  });
}
function ga({ type: u, enabled: e, element: D, onUpdate: f }) {
  let t = ba();
  function n(...a) {
    f == null || f(...a), t(...a);
  }
  ru(() => {
    au(e, (a, o) => {
      a ? n(0, u, D) : o === !0 && n(1, u, D);
    }, { immediate: !0, flush: "sync" });
  }), vu(() => {
    e.value && n(1, u, D);
  }), Bu(Z1, n);
}
let K1 = Symbol("DescriptionContext");
function va() {
  let u = Cu(K1, null);
  if (u === null)
    throw new Error("Missing parent");
  return u;
}
function fD({ slot: u = I({}), name: e = "Description", props: D = {} } = {}) {
  let f = I([]);
  function t(n) {
    return f.value.push(n), () => {
      let a = f.value.indexOf(n);
      a !== -1 && f.value.splice(a, 1);
    };
  }
  return Bu(K1, { register: t, slot: u, name: e, props: D }), w(() => f.value.length > 0 ? f.value.join(" ") : void 0);
}
let kf = z({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D }) {
  var f;
  let t = (f = u.id) != null ? f : `headlessui-description-${su()}`, n = va();
  return ru(() => vu(n.register(t))), () => {
    let { name: a = "Description", slot: o = I({}), props: r = {} } = n, { ...l } = u, i = { ...Object.entries(r).reduce((s, [d, g]) => Object.assign(s, { [d]: Hu(g) }), {}), id: t };
    return eu({ ourProps: i, theirProps: l, slot: o.value, attrs: e, slots: D, name: a });
  };
} });
function ha(u) {
  let e = ku(u);
  if (!e) {
    if (u === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${u}`);
  }
  let D = e.getElementById("headlessui-portal-root");
  if (D)
    return D;
  let f = e.createElement("div");
  return f.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(f);
}
const $D = /* @__PURE__ */ new WeakMap();
function Ba(u) {
  var e;
  return (e = $D.get(u)) != null ? e : 0;
}
function Zf(u, e) {
  let D = e(Ba(u));
  return D <= 0 ? $D.delete(u) : $D.set(u, D), D;
}
let Q1 = z({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(u, { slots: e, attrs: D }) {
  let f = I(null), t = w(() => ku(f)), n = pa(), a = Cu(u0, null), o = I(n === !0 || a == null ? ha(f.value) : a.resolveTarget());
  o.value && Zf(o.value, (d) => d + 1);
  let r = I(!1);
  ru(() => {
    r.value = !0;
  }), gu(() => {
    n || a != null && (o.value = a.resolveTarget());
  });
  let l = Cu(SD, null), i = !1, s = X0();
  return au(f, () => {
    if (i || !l)
      return;
    let d = $(f);
    d && (vu(l.register(d), s), i = !0);
  }), vu(() => {
    var d, g;
    let h = (d = t.value) == null ? void 0 : d.getElementById("headlessui-portal-root");
    !h || o.value !== h || Zf(o.value, (_) => _ - 1) || o.value.children.length > 0 || (g = o.value.parentElement) == null || g.removeChild(o.value);
  }), () => {
    if (!r.value || o.value === null)
      return null;
    let d = { ref: f, "data-headlessui-portal": "" };
    return uu(Z0, { to: o.value }, eu({ ourProps: d, theirProps: u, slot: {}, attrs: D, slots: e, name: "Portal" }));
  };
} }), SD = Symbol("PortalParentContext");
function J1() {
  let u = Cu(SD, null), e = I([]);
  function D(n) {
    return e.value.push(n), u && u.register(n), () => f(n);
  }
  function f(n) {
    let a = e.value.indexOf(n);
    a !== -1 && e.value.splice(a, 1), u && u.unregister(n);
  }
  let t = { register: D, unregister: f, portals: e };
  return [e, z({ name: "PortalWrapper", setup(n, { slots: a }) {
    return Bu(SD, t), () => {
      var o;
      return (o = a.default) == null ? void 0 : o.call(a);
    };
  } })];
}
let u0 = Symbol("PortalGroupContext"), ya = z({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(u, { attrs: e, slots: D }) {
  let f = Qe({ resolveTarget() {
    return u.target;
  } });
  return Bu(u0, f), () => {
    let { target: t, ...n } = u;
    return eu({ theirProps: n, ourProps: {}, slot: {}, attrs: e, slots: D, name: "PortalGroup" });
  };
} });
var _a = ((u) => (u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))(_a || {});
let TD = Symbol("DialogContext");
function Oe(u) {
  let e = Cu(TD, null);
  if (e === null) {
    let D = new Error(`<${u} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(D, Oe), D;
  }
  return e;
}
let Ve = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", e0 = z({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: Ve }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (u) => !0 }, setup(u, { emit: e, attrs: D, slots: f, expose: t }) {
  var n, a;
  let o = (n = u.id) != null ? n : `headlessui-dialog-${su()}`, r = I(!1);
  ru(() => {
    r.value = !0;
  });
  let l = !1, i = w(() => u.role === "dialog" || u.role === "alertdialog" ? u.role : (l || (l = !0, console.warn(`Invalid role [${i}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), s = I(0), d = De(), g = w(() => u.open === Ve && d !== null ? (d.value & nu.Open) === nu.Open : u.open), h = I(null), _ = w(() => ku(h));
  if (t({ el: h, $el: h }), !(u.open !== Ve || d !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof g.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${g.value === Ve ? void 0 : u.open}`);
  let C = w(() => r.value && g.value ? 0 : 1), p = w(() => C.value === 0), b = w(() => s.value > 1), m = Cu(TD, null) !== null, [F, c] = J1(), { resolveContainers: B, mainTreeNodeRef: k, MainTreeNode: A } = G1({ portals: F, defaultContainers: [w(() => {
    var Du;
    return (Du = yu.panelRef.value) != null ? Du : h.value;
  })] }), j = w(() => b.value ? "parent" : "leaf"), T = w(() => d !== null ? (d.value & nu.Closing) === nu.Closing : !1), S = w(() => m || T.value ? !1 : p.value), W = w(() => {
    var Du, tu, wu;
    return (wu = Array.from((tu = (Du = _.value) == null ? void 0 : Du.querySelectorAll("body > *")) != null ? tu : []).find((hu) => hu.id === "headlessui-portal-root" ? !1 : hu.contains($(k)) && hu instanceof HTMLElement)) != null ? wu : null;
  });
  Xf(W, S);
  let L = w(() => b.value ? !0 : p.value), H = w(() => {
    var Du, tu, wu;
    return (wu = Array.from((tu = (Du = _.value) == null ? void 0 : Du.querySelectorAll("[data-headlessui-portal]")) != null ? tu : []).find((hu) => hu.contains($(k)) && hu instanceof HTMLElement)) != null ? wu : null;
  });
  Xf(H, L), ga({ type: "Dialog", enabled: w(() => C.value === 0), element: h, onUpdate: (Du, tu) => {
    if (tu === "Dialog")
      return ou(Du, { [xD.Add]: () => s.value += 1, [xD.Remove]: () => s.value -= 1 });
  } });
  let X = fD({ name: "DialogDescription", slot: w(() => ({ open: g.value })) }), lu = I(null), yu = { titleId: lu, panelRef: I(null), dialogState: C, setTitleId(Du) {
    lu.value !== Du && (lu.value = Du);
  }, close() {
    e("close", !1);
  } };
  Bu(TD, yu);
  let Tu = w(() => !(!p.value || b.value));
  Se(B, (Du, tu) => {
    Du.preventDefault(), yu.close(), Eu(() => tu == null ? void 0 : tu.focus());
  }, Tu);
  let Ru = w(() => !(b.value || C.value !== 0));
  _f((a = _.value) == null ? void 0 : a.defaultView, "keydown", (Du) => {
    Ru.value && (Du.defaultPrevented || Du.key === Y.Escape && (Du.preventDefault(), Du.stopPropagation(), yu.close()));
  });
  let Wu = w(() => !(T.value || C.value !== 0 || m));
  return Ea(_, Wu, (Du) => {
    var tu;
    return { containers: [...(tu = Du.containers) != null ? tu : [], B] };
  }), gu((Du) => {
    if (C.value !== 0)
      return;
    let tu = $(h);
    if (!tu)
      return;
    let wu = new ResizeObserver((hu) => {
      for (let qu of hu) {
        let Gu = qu.target.getBoundingClientRect();
        Gu.x === 0 && Gu.y === 0 && Gu.width === 0 && Gu.height === 0 && yu.close();
      }
    });
    wu.observe(tu), Du(() => wu.disconnect());
  }), () => {
    let { open: Du, initialFocus: tu, ...wu } = u, hu = { ...D, ref: h, id: o, role: i.value, "aria-modal": C.value === 0 ? !0 : void 0, "aria-labelledby": lu.value, "aria-describedby": X.value }, qu = { open: C.value === 0 };
    return uu(AD, { force: !0 }, () => [uu(Q1, () => uu(ya, { target: h.value }, () => uu(AD, { force: !1 }, () => uu(he, { initialFocus: tu, containers: B, features: p.value ? ou(j.value, { parent: he.features.RestoreFocus, leaf: he.features.All & ~he.features.FocusLock }) : he.features.None }, () => uu(c, {}, () => eu({ ourProps: hu, theirProps: { ...wu, ...D }, slot: qu, attrs: D, slots: f, visible: C.value === 0, features: Au.RenderStrategy | Au.Static, name: "Dialog" })))))), uu(A)]);
  };
} }), wa = z({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D }) {
  var f;
  let t = (f = u.id) != null ? f : `headlessui-dialog-overlay-${su()}`, n = Oe("DialogOverlay");
  function a(o) {
    o.target === o.currentTarget && (o.preventDefault(), o.stopPropagation(), n.close());
  }
  return () => {
    let { ...o } = u;
    return eu({ ourProps: { id: t, "aria-hidden": !0, onClick: a }, theirProps: o, slot: { open: n.dialogState.value === 0 }, attrs: e, slots: D, name: "DialogOverlay" });
  };
} });
z({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-dialog-backdrop-${su()}`, a = Oe("DialogBackdrop"), o = I(null);
  return f({ el: o, $el: o }), ru(() => {
    if (a.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...r } = u, l = { id: n, ref: o, "aria-hidden": !0 };
    return uu(AD, { force: !0 }, () => uu(Q1, () => eu({ ourProps: l, theirProps: { ...e, ...r }, slot: { open: a.dialogState.value === 0 }, attrs: e, slots: D, name: "DialogBackdrop" })));
  };
} });
let ka = z({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-dialog-panel-${su()}`, a = Oe("DialogPanel");
  f({ el: a.panelRef, $el: a.panelRef });
  function o(r) {
    r.stopPropagation();
  }
  return () => {
    let { ...r } = u, l = { id: n, ref: a.panelRef, onClick: o };
    return eu({ ourProps: l, theirProps: r, slot: { open: a.dialogState.value === 0 }, attrs: e, slots: D, name: "DialogPanel" });
  };
} }), D0 = z({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D }) {
  var f;
  let t = (f = u.id) != null ? f : `headlessui-dialog-title-${su()}`, n = Oe("DialogTitle");
  return ru(() => {
    n.setTitleId(t), vu(() => n.setTitleId(null));
  }), () => {
    let { ...a } = u;
    return eu({ ourProps: { id: t }, theirProps: a, slot: { open: n.dialogState.value === 0 }, attrs: e, slots: D, name: "DialogTitle" });
  };
} }), Aa = kf, Kf = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Qf(u) {
  var e, D;
  let f = (e = u.innerText) != null ? e : "", t = u.cloneNode(!0);
  if (!(t instanceof HTMLElement))
    return f;
  let n = !1;
  for (let o of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    o.remove(), n = !0;
  let a = n ? (D = t.innerText) != null ? D : "" : f;
  return Kf.test(a) && (a = a.replace(Kf, "")), a;
}
function xa(u) {
  let e = u.getAttribute("aria-label");
  if (typeof e == "string")
    return e.trim();
  let D = u.getAttribute("aria-labelledby");
  if (D) {
    let f = D.split(" ").map((t) => {
      let n = document.getElementById(t);
      if (n) {
        let a = n.getAttribute("aria-label");
        return typeof a == "string" ? a.trim() : Qf(n).trim();
      }
      return null;
    }).filter(Boolean);
    if (f.length > 0)
      return f.join(", ");
  }
  return Qf(u).trim();
}
function f0(u) {
  let e = I(""), D = I("");
  return () => {
    let f = $(u);
    if (!f)
      return "";
    let t = f.innerText;
    if (e.value === t)
      return D.value;
    let n = xa(f).trim().toLowerCase();
    return e.value = t, D.value = n, n;
  };
}
function $a(u, e) {
  return u === e;
}
var Sa = ((u) => (u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))(Sa || {}), Ta = ((u) => (u[u.Single = 0] = "Single", u[u.Multi = 1] = "Multi", u))(Ta || {}), Ma = ((u) => (u[u.Pointer = 0] = "Pointer", u[u.Other = 1] = "Other", u))(Ma || {});
function Oa(u) {
  requestAnimationFrame(() => requestAnimationFrame(u));
}
let t0 = Symbol("ListboxContext");
function Ie(u) {
  let e = Cu(t0, null);
  if (e === null) {
    let D = new Error(`<${u} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(D, Ie), D;
  }
  return e;
}
let Jf = z({ name: "Listbox", emits: { "update:modelValue": (u) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => $a }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(u, { slots: e, attrs: D, emit: f }) {
  let t = I(1), n = I(null), a = I(null), o = I(null), r = I([]), l = I(""), i = I(null), s = I(1);
  function d(m = (F) => F) {
    let F = i.value !== null ? r.value[i.value] : null, c = $e(m(r.value.slice()), (k) => $(k.dataRef.domRef)), B = F ? c.indexOf(F) : null;
    return B === -1 && (B = null), { options: c, activeOptionIndex: B };
  }
  let g = w(() => u.multiple ? 1 : 0), [h, _] = uD(w(() => u.modelValue), (m) => f("update:modelValue", m), w(() => u.defaultValue)), C = w(() => h.value === void 0 ? ou(g.value, { 1: [], 0: void 0 }) : h.value), p = { listboxState: t, value: C, mode: g, compare(m, F) {
    if (typeof u.by == "string") {
      let c = u.by;
      return (m == null ? void 0 : m[c]) === (F == null ? void 0 : F[c]);
    }
    return u.by(m, F);
  }, orientation: w(() => u.horizontal ? "horizontal" : "vertical"), labelRef: n, buttonRef: a, optionsRef: o, disabled: w(() => u.disabled), options: r, searchQuery: l, activeOptionIndex: i, activationTrigger: s, closeListbox() {
    u.disabled || t.value !== 1 && (t.value = 1, i.value = null);
  }, openListbox() {
    u.disabled || t.value !== 0 && (t.value = 0);
  }, goToOption(m, F, c) {
    if (u.disabled || t.value === 1)
      return;
    let B = d(), k = He(m === Z.Specific ? { focus: Z.Specific, id: F } : { focus: m }, { resolveItems: () => B.options, resolveActiveIndex: () => B.activeOptionIndex, resolveId: (A) => A.id, resolveDisabled: (A) => A.dataRef.disabled });
    l.value = "", i.value = k, s.value = c ?? 1, r.value = B.options;
  }, search(m) {
    if (u.disabled || t.value === 1)
      return;
    let F = l.value !== "" ? 0 : 1;
    l.value += m.toLowerCase();
    let c = (i.value !== null ? r.value.slice(i.value + F).concat(r.value.slice(0, i.value + F)) : r.value).find((k) => k.dataRef.textValue.startsWith(l.value) && !k.dataRef.disabled), B = c ? r.value.indexOf(c) : -1;
    B === -1 || B === i.value || (i.value = B, s.value = 1);
  }, clearSearch() {
    u.disabled || t.value !== 1 && l.value !== "" && (l.value = "");
  }, registerOption(m, F) {
    let c = d((B) => [...B, { id: m, dataRef: F }]);
    r.value = c.options, i.value = c.activeOptionIndex;
  }, unregisterOption(m) {
    let F = d((c) => {
      let B = c.findIndex((k) => k.id === m);
      return B !== -1 && c.splice(B, 1), c;
    });
    r.value = F.options, i.value = F.activeOptionIndex, s.value = 1;
  }, theirOnChange(m) {
    u.disabled || _(m);
  }, select(m) {
    u.disabled || _(ou(g.value, { 0: () => m, 1: () => {
      let F = cu(p.value.value).slice(), c = cu(m), B = F.findIndex((k) => p.compare(c, cu(k)));
      return B === -1 ? F.push(c) : F.splice(B, 1), F;
    } }));
  } };
  Se([a, o], (m, F) => {
    var c;
    p.closeListbox(), xe(F, Ae.Loose) || (m.preventDefault(), (c = $(a)) == null || c.focus());
  }, w(() => t.value === 0)), Bu(t0, p), Me(w(() => ou(t.value, { 0: nu.Open, 1: nu.Closed })));
  let b = w(() => {
    var m;
    return (m = $(a)) == null ? void 0 : m.closest("form");
  });
  return ru(() => {
    au([b], () => {
      if (!b.value || u.defaultValue === void 0)
        return;
      function m() {
        p.theirOnChange(u.defaultValue);
      }
      return b.value.addEventListener("reset", m), () => {
        var F;
        (F = b.value) == null || F.removeEventListener("reset", m);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: m, modelValue: F, disabled: c, form: B, ...k } = u, A = { open: t.value === 0, disabled: c, value: C.value };
    return uu(J, [...m != null && C.value != null ? DD({ [m]: C.value }).map(([j, T]) => uu(Lu, eD({ features: Iu.Hidden, key: j, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: B, disabled: c, name: j, value: T }))) : [], eu({ ourProps: {}, theirProps: { ...D, ...ee(k, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: A, slots: e, attrs: D, name: "Listbox" })]);
  };
} }), u1 = z({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D }) {
  var f;
  let t = (f = u.id) != null ? f : `headlessui-listbox-label-${su()}`, n = Ie("ListboxLabel");
  function a() {
    var o;
    (o = $(n.buttonRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: n.listboxState.value === 0, disabled: n.disabled.value }, { ...r } = u, l = { id: t, ref: n.labelRef, onClick: a };
    return eu({ ourProps: l, theirProps: r, slot: o, attrs: e, slots: D, name: "ListboxLabel" });
  };
} }), Ia = z({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-listbox-button-${su()}`, a = Ie("ListboxButton");
  f({ el: a.buttonRef, $el: a.buttonRef });
  function o(s) {
    switch (s.key) {
      case Y.Space:
      case Y.Enter:
      case Y.ArrowDown:
        s.preventDefault(), a.openListbox(), Eu(() => {
          var d;
          (d = $(a.optionsRef)) == null || d.focus({ preventScroll: !0 }), a.value.value || a.goToOption(Z.First);
        });
        break;
      case Y.ArrowUp:
        s.preventDefault(), a.openListbox(), Eu(() => {
          var d;
          (d = $(a.optionsRef)) == null || d.focus({ preventScroll: !0 }), a.value.value || a.goToOption(Z.Last);
        });
        break;
    }
  }
  function r(s) {
    switch (s.key) {
      case Y.Space:
        s.preventDefault();
        break;
    }
  }
  function l(s) {
    a.disabled.value || (a.listboxState.value === 0 ? (a.closeListbox(), Eu(() => {
      var d;
      return (d = $(a.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })) : (s.preventDefault(), a.openListbox(), Oa(() => {
      var d;
      return (d = $(a.optionsRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })));
  }
  let i = Te(w(() => ({ as: u.as, type: e.type })), a.buttonRef);
  return () => {
    var s, d;
    let g = { open: a.listboxState.value === 0, disabled: a.disabled.value, value: a.value.value }, { ...h } = u, _ = { ref: a.buttonRef, id: n, type: i.value, "aria-haspopup": "listbox", "aria-controls": (s = $(a.optionsRef)) == null ? void 0 : s.id, "aria-expanded": a.listboxState.value === 0, "aria-labelledby": a.labelRef.value ? [(d = $(a.labelRef)) == null ? void 0 : d.id, n].join(" ") : void 0, disabled: a.disabled.value === !0 ? !0 : void 0, onKeydown: o, onKeyup: r, onClick: l };
    return eu({ ourProps: _, theirProps: h, slot: g, attrs: e, slots: D, name: "ListboxButton" });
  };
} }), e1 = z({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-listbox-options-${su()}`, a = Ie("ListboxOptions"), o = I(null);
  f({ el: a.optionsRef, $el: a.optionsRef });
  function r(s) {
    switch (o.value && clearTimeout(o.value), s.key) {
      case Y.Space:
        if (a.searchQuery.value !== "")
          return s.preventDefault(), s.stopPropagation(), a.search(s.key);
      case Y.Enter:
        if (s.preventDefault(), s.stopPropagation(), a.activeOptionIndex.value !== null) {
          let d = a.options.value[a.activeOptionIndex.value];
          a.select(d.dataRef.value);
        }
        a.mode.value === 0 && (a.closeListbox(), Eu(() => {
          var d;
          return (d = $(a.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
        }));
        break;
      case ou(a.orientation.value, { vertical: Y.ArrowDown, horizontal: Y.ArrowRight }):
        return s.preventDefault(), s.stopPropagation(), a.goToOption(Z.Next);
      case ou(a.orientation.value, { vertical: Y.ArrowUp, horizontal: Y.ArrowLeft }):
        return s.preventDefault(), s.stopPropagation(), a.goToOption(Z.Previous);
      case Y.Home:
      case Y.PageUp:
        return s.preventDefault(), s.stopPropagation(), a.goToOption(Z.First);
      case Y.End:
      case Y.PageDown:
        return s.preventDefault(), s.stopPropagation(), a.goToOption(Z.Last);
      case Y.Escape:
        s.preventDefault(), s.stopPropagation(), a.closeListbox(), Eu(() => {
          var d;
          return (d = $(a.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        break;
      case Y.Tab:
        s.preventDefault(), s.stopPropagation();
        break;
      default:
        s.key.length === 1 && (a.search(s.key), o.value = setTimeout(() => a.clearSearch(), 350));
        break;
    }
  }
  let l = De(), i = w(() => l !== null ? (l.value & nu.Open) === nu.Open : a.listboxState.value === 0);
  return () => {
    var s, d;
    let g = { open: a.listboxState.value === 0 }, { ...h } = u, _ = { "aria-activedescendant": a.activeOptionIndex.value === null || (s = a.options.value[a.activeOptionIndex.value]) == null ? void 0 : s.id, "aria-multiselectable": a.mode.value === 1 ? !0 : void 0, "aria-labelledby": (d = $(a.buttonRef)) == null ? void 0 : d.id, "aria-orientation": a.orientation.value, id: n, onKeydown: r, role: "listbox", tabIndex: 0, ref: a.optionsRef };
    return eu({ ourProps: _, theirProps: h, slot: g, attrs: e, slots: D, features: Au.RenderStrategy | Au.Static, visible: i.value, name: "ListboxOptions" });
  };
} }), D1 = z({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(u, { slots: e, attrs: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-listbox-option-${su()}`, a = Ie("ListboxOption"), o = I(null);
  f({ el: o, $el: o });
  let r = w(() => a.activeOptionIndex.value !== null ? a.options.value[a.activeOptionIndex.value].id === n : !1), l = w(() => ou(a.mode.value, { 0: () => a.compare(cu(a.value.value), cu(u.value)), 1: () => cu(a.value.value).some((m) => a.compare(cu(m), cu(u.value))) })), i = w(() => ou(a.mode.value, { 1: () => {
    var m;
    let F = cu(a.value.value);
    return ((m = a.options.value.find((c) => F.some((B) => a.compare(cu(B), cu(c.dataRef.value))))) == null ? void 0 : m.id) === n;
  }, 0: () => l.value })), s = f0(o), d = w(() => ({ disabled: u.disabled, value: u.value, get textValue() {
    return s();
  }, domRef: o }));
  ru(() => a.registerOption(n, d)), vu(() => a.unregisterOption(n)), ru(() => {
    au([a.listboxState, l], () => {
      a.listboxState.value === 0 && l.value && ou(a.mode.value, { 1: () => {
        i.value && a.goToOption(Z.Specific, n);
      }, 0: () => {
        a.goToOption(Z.Specific, n);
      } });
    }, { immediate: !0 });
  }), gu(() => {
    a.listboxState.value === 0 && r.value && a.activationTrigger.value !== 0 && Eu(() => {
      var m, F;
      return (F = (m = $(o)) == null ? void 0 : m.scrollIntoView) == null ? void 0 : F.call(m, { block: "nearest" });
    });
  });
  function g(m) {
    if (u.disabled)
      return m.preventDefault();
    a.select(u.value), a.mode.value === 0 && (a.closeListbox(), Eu(() => {
      var F;
      return (F = $(a.buttonRef)) == null ? void 0 : F.focus({ preventScroll: !0 });
    }));
  }
  function h() {
    if (u.disabled)
      return a.goToOption(Z.Nothing);
    a.goToOption(Z.Specific, n);
  }
  let _ = Bf();
  function C(m) {
    _.update(m);
  }
  function p(m) {
    _.wasMoved(m) && (u.disabled || r.value || a.goToOption(Z.Specific, n, 0));
  }
  function b(m) {
    _.wasMoved(m) && (u.disabled || r.value && a.goToOption(Z.Nothing));
  }
  return () => {
    let { disabled: m } = u, F = { active: r.value, selected: l.value, disabled: m }, { value: c, disabled: B, ...k } = u, A = { id: n, ref: o, role: "option", tabIndex: m === !0 ? void 0 : -1, "aria-disabled": m === !0 ? !0 : void 0, "aria-selected": l.value, disabled: void 0, onClick: g, onFocus: h, onPointerenter: C, onMouseenter: C, onPointermove: p, onMousemove: p, onPointerleave: b, onMouseleave: b };
    return eu({ ourProps: A, theirProps: k, slot: F, attrs: D, slots: e, name: "ListboxOption" });
  };
} });
var Pa = ((u) => (u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))(Pa || {}), La = ((u) => (u[u.Pointer = 0] = "Pointer", u[u.Other = 1] = "Other", u))(La || {});
function Ra(u) {
  requestAnimationFrame(() => requestAnimationFrame(u));
}
let a0 = Symbol("MenuContext");
function tD(u) {
  let e = Cu(a0, null);
  if (e === null) {
    let D = new Error(`<${u} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(D, tD), D;
  }
  return e;
}
let n0 = z({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(u, { slots: e, attrs: D }) {
  let f = I(1), t = I(null), n = I(null), a = I([]), o = I(""), r = I(null), l = I(1);
  function i(d = (g) => g) {
    let g = r.value !== null ? a.value[r.value] : null, h = $e(d(a.value.slice()), (C) => $(C.dataRef.domRef)), _ = g ? h.indexOf(g) : null;
    return _ === -1 && (_ = null), { items: h, activeItemIndex: _ };
  }
  let s = { menuState: f, buttonRef: t, itemsRef: n, items: a, searchQuery: o, activeItemIndex: r, activationTrigger: l, closeMenu: () => {
    f.value = 1, r.value = null;
  }, openMenu: () => f.value = 0, goToItem(d, g, h) {
    let _ = i(), C = He(d === Z.Specific ? { focus: Z.Specific, id: g } : { focus: d }, { resolveItems: () => _.items, resolveActiveIndex: () => _.activeItemIndex, resolveId: (p) => p.id, resolveDisabled: (p) => p.dataRef.disabled });
    o.value = "", r.value = C, l.value = h ?? 1, a.value = _.items;
  }, search(d) {
    let g = o.value !== "" ? 0 : 1;
    o.value += d.toLowerCase();
    let h = (r.value !== null ? a.value.slice(r.value + g).concat(a.value.slice(0, r.value + g)) : a.value).find((C) => C.dataRef.textValue.startsWith(o.value) && !C.dataRef.disabled), _ = h ? a.value.indexOf(h) : -1;
    _ === -1 || _ === r.value || (r.value = _, l.value = 1);
  }, clearSearch() {
    o.value = "";
  }, registerItem(d, g) {
    let h = i((_) => [..._, { id: d, dataRef: g }]);
    a.value = h.items, r.value = h.activeItemIndex, l.value = 1;
  }, unregisterItem(d) {
    let g = i((h) => {
      let _ = h.findIndex((C) => C.id === d);
      return _ !== -1 && h.splice(_, 1), h;
    });
    a.value = g.items, r.value = g.activeItemIndex, l.value = 1;
  } };
  return Se([t, n], (d, g) => {
    var h;
    s.closeMenu(), xe(g, Ae.Loose) || (d.preventDefault(), (h = $(t)) == null || h.focus());
  }, w(() => f.value === 0)), Bu(a0, s), Me(w(() => ou(f.value, { 0: nu.Open, 1: nu.Closed }))), () => {
    let d = { open: f.value === 0, close: s.closeMenu };
    return eu({ ourProps: {}, theirProps: u, slot: d, slots: e, attrs: D, name: "Menu" });
  };
} }), o0 = z({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-menu-button-${su()}`, a = tD("MenuButton");
  f({ el: a.buttonRef, $el: a.buttonRef });
  function o(s) {
    switch (s.key) {
      case Y.Space:
      case Y.Enter:
      case Y.ArrowDown:
        s.preventDefault(), s.stopPropagation(), a.openMenu(), Eu(() => {
          var d;
          (d = $(a.itemsRef)) == null || d.focus({ preventScroll: !0 }), a.goToItem(Z.First);
        });
        break;
      case Y.ArrowUp:
        s.preventDefault(), s.stopPropagation(), a.openMenu(), Eu(() => {
          var d;
          (d = $(a.itemsRef)) == null || d.focus({ preventScroll: !0 }), a.goToItem(Z.Last);
        });
        break;
    }
  }
  function r(s) {
    switch (s.key) {
      case Y.Space:
        s.preventDefault();
        break;
    }
  }
  function l(s) {
    u.disabled || (a.menuState.value === 0 ? (a.closeMenu(), Eu(() => {
      var d;
      return (d = $(a.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })) : (s.preventDefault(), a.openMenu(), Ra(() => {
      var d;
      return (d = $(a.itemsRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })));
  }
  let i = Te(w(() => ({ as: u.as, type: e.type })), a.buttonRef);
  return () => {
    var s;
    let d = { open: a.menuState.value === 0 }, { ...g } = u, h = { ref: a.buttonRef, id: n, type: i.value, "aria-haspopup": "menu", "aria-controls": (s = $(a.itemsRef)) == null ? void 0 : s.id, "aria-expanded": a.menuState.value === 0, onKeydown: o, onKeyup: r, onClick: l };
    return eu({ ourProps: h, theirProps: g, slot: d, attrs: e, slots: D, name: "MenuButton" });
  };
} }), r0 = z({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-menu-items-${su()}`, a = tD("MenuItems"), o = I(null);
  f({ el: a.itemsRef, $el: a.itemsRef }), yf({ container: w(() => $(a.itemsRef)), enabled: w(() => a.menuState.value === 0), accept(d) {
    return d.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : d.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(d) {
    d.setAttribute("role", "none");
  } });
  function r(d) {
    var g;
    switch (o.value && clearTimeout(o.value), d.key) {
      case Y.Space:
        if (a.searchQuery.value !== "")
          return d.preventDefault(), d.stopPropagation(), a.search(d.key);
      case Y.Enter:
        if (d.preventDefault(), d.stopPropagation(), a.activeItemIndex.value !== null) {
          let h = a.items.value[a.activeItemIndex.value];
          (g = $(h.dataRef.domRef)) == null || g.click();
        }
        a.closeMenu(), T1($(a.buttonRef));
        break;
      case Y.ArrowDown:
        return d.preventDefault(), d.stopPropagation(), a.goToItem(Z.Next);
      case Y.ArrowUp:
        return d.preventDefault(), d.stopPropagation(), a.goToItem(Z.Previous);
      case Y.Home:
      case Y.PageUp:
        return d.preventDefault(), d.stopPropagation(), a.goToItem(Z.First);
      case Y.End:
      case Y.PageDown:
        return d.preventDefault(), d.stopPropagation(), a.goToItem(Z.Last);
      case Y.Escape:
        d.preventDefault(), d.stopPropagation(), a.closeMenu(), Eu(() => {
          var h;
          return (h = $(a.buttonRef)) == null ? void 0 : h.focus({ preventScroll: !0 });
        });
        break;
      case Y.Tab:
        d.preventDefault(), d.stopPropagation(), a.closeMenu(), Eu(() => Ut($(a.buttonRef), d.shiftKey ? bu.Previous : bu.Next));
        break;
      default:
        d.key.length === 1 && (a.search(d.key), o.value = setTimeout(() => a.clearSearch(), 350));
        break;
    }
  }
  function l(d) {
    switch (d.key) {
      case Y.Space:
        d.preventDefault();
        break;
    }
  }
  let i = De(), s = w(() => i !== null ? (i.value & nu.Open) === nu.Open : a.menuState.value === 0);
  return () => {
    var d, g;
    let h = { open: a.menuState.value === 0 }, { ..._ } = u, C = { "aria-activedescendant": a.activeItemIndex.value === null || (d = a.items.value[a.activeItemIndex.value]) == null ? void 0 : d.id, "aria-labelledby": (g = $(a.buttonRef)) == null ? void 0 : g.id, id: n, onKeydown: r, onKeyup: l, role: "menu", tabIndex: 0, ref: a.itemsRef };
    return eu({ ourProps: C, theirProps: _, slot: h, attrs: e, slots: D, features: Au.RenderStrategy | Au.Static, visible: s.value, name: "MenuItems" });
  };
} }), l0 = z({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(u, { slots: e, attrs: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-menu-item-${su()}`, a = tD("MenuItem"), o = I(null);
  f({ el: o, $el: o });
  let r = w(() => a.activeItemIndex.value !== null ? a.items.value[a.activeItemIndex.value].id === n : !1), l = f0(o), i = w(() => ({ disabled: u.disabled, get textValue() {
    return l();
  }, domRef: o }));
  ru(() => a.registerItem(n, i)), vu(() => a.unregisterItem(n)), gu(() => {
    a.menuState.value === 0 && r.value && a.activationTrigger.value !== 0 && Eu(() => {
      var p, b;
      return (b = (p = $(o)) == null ? void 0 : p.scrollIntoView) == null ? void 0 : b.call(p, { block: "nearest" });
    });
  });
  function s(p) {
    if (u.disabled)
      return p.preventDefault();
    a.closeMenu(), T1($(a.buttonRef));
  }
  function d() {
    if (u.disabled)
      return a.goToItem(Z.Nothing);
    a.goToItem(Z.Specific, n);
  }
  let g = Bf();
  function h(p) {
    g.update(p);
  }
  function _(p) {
    g.wasMoved(p) && (u.disabled || r.value || a.goToItem(Z.Specific, n, 0));
  }
  function C(p) {
    g.wasMoved(p) && (u.disabled || r.value && a.goToItem(Z.Nothing));
  }
  return () => {
    let { disabled: p, ...b } = u, m = { active: r.value, disabled: p, close: a.closeMenu };
    return eu({ ourProps: { id: n, ref: o, role: "menuitem", tabIndex: p === !0 ? void 0 : -1, "aria-disabled": p === !0 ? !0 : void 0, onClick: s, onFocus: d, onPointerenter: h, onMouseenter: h, onPointermove: _, onMousemove: _, onPointerleave: C, onMouseleave: C }, theirProps: { ...D, ...b }, slot: m, attrs: D, slots: e, name: "MenuItem" });
  };
} });
var Na = ((u) => (u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))(Na || {});
let i0 = Symbol("PopoverContext");
function aD(u) {
  let e = Cu(i0, null);
  if (e === null) {
    let D = new Error(`<${u} /> is missing a parent <${Af.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(D, aD), D;
  }
  return e;
}
let d0 = Symbol("PopoverGroupContext");
function s0() {
  return Cu(d0, null);
}
let c0 = Symbol("PopoverPanelContext");
function ja() {
  return Cu(c0, null);
}
let Af = z({ name: "Popover", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(u, { slots: e, attrs: D, expose: f }) {
  var t;
  let n = I(null);
  f({ el: n, $el: n });
  let a = I(1), o = I(null), r = I(null), l = I(null), i = I(null), s = w(() => ku(n)), d = w(() => {
    var c, B;
    if (!$(o) || !$(i))
      return !1;
    for (let L of document.querySelectorAll("body > *"))
      if (Number(L == null ? void 0 : L.contains($(o))) ^ Number(L == null ? void 0 : L.contains($(i))))
        return !0;
    let k = ke(), A = k.indexOf($(o)), j = (A + k.length - 1) % k.length, T = (A + 1) % k.length, S = k[j], W = k[T];
    return !((c = $(i)) != null && c.contains(S)) && !((B = $(i)) != null && B.contains(W));
  }), g = { popoverState: a, buttonId: I(null), panelId: I(null), panel: i, button: o, isPortalled: d, beforePanelSentinel: r, afterPanelSentinel: l, togglePopover() {
    a.value = ou(a.value, { 0: 1, 1: 0 });
  }, closePopover() {
    a.value !== 1 && (a.value = 1);
  }, close(c) {
    g.closePopover();
    let B = c ? c instanceof HTMLElement ? c : c.value instanceof HTMLElement ? $(c) : $(g.button) : $(g.button);
    B == null || B.focus();
  } };
  Bu(i0, g), Me(w(() => ou(a.value, { 0: nu.Open, 1: nu.Closed })));
  let h = { buttonId: g.buttonId, panelId: g.panelId, close() {
    g.closePopover();
  } }, _ = s0(), C = _ == null ? void 0 : _.registerPopover, [p, b] = J1(), m = G1({ mainTreeNodeRef: _ == null ? void 0 : _.mainTreeNodeRef, portals: p, defaultContainers: [o, i] });
  function F() {
    var c, B, k, A;
    return (A = _ == null ? void 0 : _.isFocusWithinPopoverGroup()) != null ? A : ((c = s.value) == null ? void 0 : c.activeElement) && (((B = $(o)) == null ? void 0 : B.contains(s.value.activeElement)) || ((k = $(i)) == null ? void 0 : k.contains(s.value.activeElement)));
  }
  return gu(() => C == null ? void 0 : C(h)), _f((t = s.value) == null ? void 0 : t.defaultView, "focus", (c) => {
    var B, k;
    c.target !== window && c.target instanceof HTMLElement && a.value === 0 && (F() || o && i && (m.contains(c.target) || (B = $(g.beforePanelSentinel)) != null && B.contains(c.target) || (k = $(g.afterPanelSentinel)) != null && k.contains(c.target) || g.closePopover()));
  }, !0), Se(m.resolveContainers, (c, B) => {
    var k;
    g.closePopover(), xe(B, Ae.Loose) || (c.preventDefault(), (k = $(o)) == null || k.focus());
  }, w(() => a.value === 0)), () => {
    let c = { open: a.value === 0, close: g.close };
    return uu(J, [uu(b, {}, () => eu({ theirProps: { ...u, ...D }, ourProps: { ref: n }, slot: c, slots: e, attrs: D, name: "Popover" })), uu(m.MainTreeNode)]);
  };
} }), F0 = z({ name: "PopoverButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-popover-button-${su()}`, a = aD("PopoverButton"), o = w(() => ku(a.button));
  f({ el: a.button, $el: a.button }), ru(() => {
    a.buttonId.value = n;
  }), vu(() => {
    a.buttonId.value = null;
  });
  let r = s0(), l = r == null ? void 0 : r.closeOthers, i = ja(), s = w(() => i === null ? !1 : i.value === a.panelId.value), d = I(null), g = `headlessui-focus-sentinel-${su()}`;
  s.value || gu(() => {
    a.button.value = $(d);
  });
  let h = Te(w(() => ({ as: u.as, type: e.type })), d);
  function _(c) {
    var B, k, A, j, T;
    if (s.value) {
      if (a.popoverState.value === 1)
        return;
      switch (c.key) {
        case Y.Space:
        case Y.Enter:
          c.preventDefault(), (k = (B = c.target).click) == null || k.call(B), a.closePopover(), (A = $(a.button)) == null || A.focus();
          break;
      }
    } else
      switch (c.key) {
        case Y.Space:
        case Y.Enter:
          c.preventDefault(), c.stopPropagation(), a.popoverState.value === 1 && (l == null || l(a.buttonId.value)), a.togglePopover();
          break;
        case Y.Escape:
          if (a.popoverState.value !== 0)
            return l == null ? void 0 : l(a.buttonId.value);
          if (!$(a.button) || (j = o.value) != null && j.activeElement && !((T = $(a.button)) != null && T.contains(o.value.activeElement)))
            return;
          c.preventDefault(), c.stopPropagation(), a.closePopover();
          break;
      }
  }
  function C(c) {
    s.value || c.key === Y.Space && c.preventDefault();
  }
  function p(c) {
    var B, k;
    u.disabled || (s.value ? (a.closePopover(), (B = $(a.button)) == null || B.focus()) : (c.preventDefault(), c.stopPropagation(), a.popoverState.value === 1 && (l == null || l(a.buttonId.value)), a.togglePopover(), (k = $(a.button)) == null || k.focus()));
  }
  function b(c) {
    c.preventDefault(), c.stopPropagation();
  }
  let m = wf();
  function F() {
    let c = $(a.panel);
    if (!c)
      return;
    function B() {
      ou(m.value, { [Ou.Forwards]: () => Mu(c, bu.First), [Ou.Backwards]: () => Mu(c, bu.Last) }) === ie.Error && Mu(ke().filter((k) => k.dataset.headlessuiFocusGuard !== "true"), ou(m.value, { [Ou.Forwards]: bu.Next, [Ou.Backwards]: bu.Previous }), { relativeTo: $(a.button) });
    }
    B();
  }
  return () => {
    let c = a.popoverState.value === 0, B = { open: c }, { ...k } = u, A = s.value ? { ref: d, type: h.value, onKeydown: _, onClick: p } : { ref: d, id: n, type: h.value, "aria-expanded": a.popoverState.value === 0, "aria-controls": $(a.panel) ? a.panelId.value : void 0, disabled: u.disabled ? !0 : void 0, onKeydown: _, onKeyup: C, onClick: p, onMousedown: b };
    return uu(J, [eu({ ourProps: A, theirProps: { ...e, ...k }, slot: B, attrs: e, slots: D, name: "PopoverButton" }), c && !s.value && a.isPortalled.value && uu(Lu, { id: g, features: Iu.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: F })]);
  };
} }), Va = z({ name: "PopoverOverlay", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(u, { attrs: e, slots: D }) {
  let f = aD("PopoverOverlay"), t = `headlessui-popover-overlay-${su()}`, n = De(), a = w(() => n !== null ? (n.value & nu.Open) === nu.Open : f.popoverState.value === 0);
  function o() {
    f.closePopover();
  }
  return () => {
    let r = { open: f.popoverState.value === 0 };
    return eu({ ourProps: { id: t, "aria-hidden": !0, onClick: o }, theirProps: u, slot: r, attrs: e, slots: D, features: Au.RenderStrategy | Au.Static, visible: a.value, name: "PopoverOverlay" });
  };
} }), C0 = z({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-popover-panel-${su()}`, { focus: a } = u, o = aD("PopoverPanel"), r = w(() => ku(o.panel)), l = `headlessui-focus-sentinel-before-${su()}`, i = `headlessui-focus-sentinel-after-${su()}`;
  f({ el: o.panel, $el: o.panel }), ru(() => {
    o.panelId.value = n;
  }), vu(() => {
    o.panelId.value = null;
  }), Bu(c0, o.panelId), gu(() => {
    var b, m;
    if (!a || o.popoverState.value !== 0 || !o.panel)
      return;
    let F = (b = r.value) == null ? void 0 : b.activeElement;
    (m = $(o.panel)) != null && m.contains(F) || Mu($(o.panel), bu.First);
  });
  let s = De(), d = w(() => s !== null ? (s.value & nu.Open) === nu.Open : o.popoverState.value === 0);
  function g(b) {
    var m, F;
    switch (b.key) {
      case Y.Escape:
        if (o.popoverState.value !== 0 || !$(o.panel) || r.value && !((m = $(o.panel)) != null && m.contains(r.value.activeElement)))
          return;
        b.preventDefault(), b.stopPropagation(), o.closePopover(), (F = $(o.button)) == null || F.focus();
        break;
    }
  }
  function h(b) {
    var m, F, c, B, k;
    let A = b.relatedTarget;
    A && $(o.panel) && ((m = $(o.panel)) != null && m.contains(A) || (o.closePopover(), ((c = (F = $(o.beforePanelSentinel)) == null ? void 0 : F.contains) != null && c.call(F, A) || (k = (B = $(o.afterPanelSentinel)) == null ? void 0 : B.contains) != null && k.call(B, A)) && A.focus({ preventScroll: !0 })));
  }
  let _ = wf();
  function C() {
    let b = $(o.panel);
    if (!b)
      return;
    function m() {
      ou(_.value, { [Ou.Forwards]: () => {
        var F;
        Mu(b, bu.First) === ie.Error && ((F = $(o.afterPanelSentinel)) == null || F.focus());
      }, [Ou.Backwards]: () => {
        var F;
        (F = $(o.button)) == null || F.focus({ preventScroll: !0 });
      } });
    }
    m();
  }
  function p() {
    let b = $(o.panel);
    if (!b)
      return;
    function m() {
      ou(_.value, { [Ou.Forwards]: () => {
        let F = $(o.button), c = $(o.panel);
        if (!F)
          return;
        let B = ke(), k = B.indexOf(F), A = B.slice(0, k + 1), j = [...B.slice(k + 1), ...A];
        for (let T of j.slice())
          if (T.dataset.headlessuiFocusGuard === "true" || c != null && c.contains(T)) {
            let S = j.indexOf(T);
            S !== -1 && j.splice(S, 1);
          }
        Mu(j, bu.First, { sorted: !1 });
      }, [Ou.Backwards]: () => {
        var F;
        Mu(b, bu.Previous) === ie.Error && ((F = $(o.button)) == null || F.focus());
      } });
    }
    m();
  }
  return () => {
    let b = { open: o.popoverState.value === 0, close: o.close }, { focus: m, ...F } = u, c = { ref: o.panel, id: n, onKeydown: g, onFocusout: a && o.popoverState.value === 0 ? h : void 0, tabIndex: -1 };
    return eu({ ourProps: c, theirProps: { ...e, ...F }, attrs: e, slot: b, slots: { ...D, default: (...B) => {
      var k;
      return [uu(J, [d.value && o.isPortalled.value && uu(Lu, { id: l, ref: o.beforePanelSentinel, features: Iu.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: C }), (k = D.default) == null ? void 0 : k.call(D, ...B), d.value && o.isPortalled.value && uu(Lu, { id: i, ref: o.afterPanelSentinel, features: Iu.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: p })])];
    } }, features: Au.RenderStrategy | Au.Static, visible: d.value, name: "PopoverPanel" });
  };
} });
z({ name: "PopoverGroup", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(u, { attrs: e, slots: D, expose: f }) {
  let t = I(null), n = gf([]), a = w(() => ku(t)), o = ma();
  f({ el: t, $el: t });
  function r(d) {
    let g = n.value.indexOf(d);
    g !== -1 && n.value.splice(g, 1);
  }
  function l(d) {
    return n.value.push(d), () => {
      r(d);
    };
  }
  function i() {
    var d;
    let g = a.value;
    if (!g)
      return !1;
    let h = g.activeElement;
    return (d = $(t)) != null && d.contains(h) ? !0 : n.value.some((_) => {
      var C, p;
      return ((C = g.getElementById(_.buttonId.value)) == null ? void 0 : C.contains(h)) || ((p = g.getElementById(_.panelId.value)) == null ? void 0 : p.contains(h));
    });
  }
  function s(d) {
    for (let g of n.value)
      g.buttonId.value !== d && g.close();
  }
  return Bu(d0, { registerPopover: l, unregisterPopover: r, isFocusWithinPopoverGroup: i, closeOthers: s, mainTreeNodeRef: o.mainTreeNodeRef }), () => uu(J, [eu({ ourProps: { ref: t }, theirProps: { ...u, ...e }, slot: {}, attrs: e, slots: D, name: "PopoverGroup" }), uu(o.MainTreeNode)]);
} });
let E0 = Symbol("LabelContext");
function m0() {
  let u = Cu(E0, null);
  if (u === null) {
    let e = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, m0), e;
  }
  return u;
}
function xf({ slot: u = {}, name: e = "Label", props: D = {} } = {}) {
  let f = I([]);
  function t(n) {
    return f.value.push(n), () => {
      let a = f.value.indexOf(n);
      a !== -1 && f.value.splice(a, 1);
    };
  }
  return Bu(E0, { register: t, slot: u, name: e, props: D }), w(() => f.value.length > 0 ? f.value.join(" ") : void 0);
}
let p0 = z({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(u, { slots: e, attrs: D }) {
  var f;
  let t = (f = u.id) != null ? f : `headlessui-label-${su()}`, n = m0();
  return ru(() => vu(n.register(t))), () => {
    let { name: a = "Label", slot: o = {}, props: r = {} } = n, { passive: l, ...i } = u, s = { ...Object.entries(r).reduce((d, [g, h]) => Object.assign(d, { [g]: Hu(h) }), {}), id: t };
    return l && (delete s.onClick, delete s.htmlFor, delete i.onClick), eu({ ourProps: s, theirProps: i, slot: o, attrs: D, slots: e, name: a });
  };
} });
function za(u, e) {
  return u === e;
}
let b0 = Symbol("RadioGroupContext");
function g0(u) {
  let e = Cu(b0, null);
  if (e === null) {
    let D = new Error(`<${u} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(D, g0), D;
  }
  return e;
}
let v0 = z({ name: "RadioGroup", emits: { "update:modelValue": (u) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => za }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(u, { emit: e, attrs: D, slots: f, expose: t }) {
  var n;
  let a = (n = u.id) != null ? n : `headlessui-radiogroup-${su()}`, o = I(null), r = I([]), l = xf({ name: "RadioGroupLabel" }), i = fD({ name: "RadioGroupDescription" });
  t({ el: o, $el: o });
  let [s, d] = uD(w(() => u.modelValue), (C) => e("update:modelValue", C), w(() => u.defaultValue)), g = { options: r, value: s, disabled: w(() => u.disabled), firstOption: w(() => r.value.find((C) => !C.propsRef.disabled)), containsCheckedOption: w(() => r.value.some((C) => g.compare(cu(C.propsRef.value), cu(u.modelValue)))), compare(C, p) {
    if (typeof u.by == "string") {
      let b = u.by;
      return (C == null ? void 0 : C[b]) === (p == null ? void 0 : p[b]);
    }
    return u.by(C, p);
  }, change(C) {
    var p;
    if (u.disabled || g.compare(cu(s.value), cu(C)))
      return !1;
    let b = (p = r.value.find((m) => g.compare(cu(m.propsRef.value), cu(C)))) == null ? void 0 : p.propsRef;
    return b != null && b.disabled ? !1 : (d(C), !0);
  }, registerOption(C) {
    r.value.push(C), r.value = $e(r.value, (p) => p.element);
  }, unregisterOption(C) {
    let p = r.value.findIndex((b) => b.id === C);
    p !== -1 && r.value.splice(p, 1);
  } };
  Bu(b0, g), yf({ container: w(() => $(o)), accept(C) {
    return C.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : C.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(C) {
    C.setAttribute("role", "none");
  } });
  function h(C) {
    if (!o.value || !o.value.contains(C.target))
      return;
    let p = r.value.filter((b) => b.propsRef.disabled === !1).map((b) => b.element);
    switch (C.key) {
      case Y.Enter:
        z1(C.currentTarget);
        break;
      case Y.ArrowLeft:
      case Y.ArrowUp:
        if (C.preventDefault(), C.stopPropagation(), Mu(p, bu.Previous | bu.WrapAround) === ie.Success) {
          let b = r.value.find((m) => {
            var F;
            return m.element === ((F = ku(o)) == null ? void 0 : F.activeElement);
          });
          b && g.change(b.propsRef.value);
        }
        break;
      case Y.ArrowRight:
      case Y.ArrowDown:
        if (C.preventDefault(), C.stopPropagation(), Mu(p, bu.Next | bu.WrapAround) === ie.Success) {
          let b = r.value.find((m) => {
            var F;
            return m.element === ((F = ku(m.element)) == null ? void 0 : F.activeElement);
          });
          b && g.change(b.propsRef.value);
        }
        break;
      case Y.Space:
        {
          C.preventDefault(), C.stopPropagation();
          let b = r.value.find((m) => {
            var F;
            return m.element === ((F = ku(m.element)) == null ? void 0 : F.activeElement);
          });
          b && g.change(b.propsRef.value);
        }
        break;
    }
  }
  let _ = w(() => {
    var C;
    return (C = $(o)) == null ? void 0 : C.closest("form");
  });
  return ru(() => {
    au([_], () => {
      if (!_.value || u.defaultValue === void 0)
        return;
      function C() {
        g.change(u.defaultValue);
      }
      return _.value.addEventListener("reset", C), () => {
        var p;
        (p = _.value) == null || p.removeEventListener("reset", C);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: C, name: p, form: b, ...m } = u, F = { ref: o, id: a, role: "radiogroup", "aria-labelledby": l.value, "aria-describedby": i.value, onKeydown: h };
    return uu(J, [...p != null && s.value != null ? DD({ [p]: s.value }).map(([c, B]) => uu(Lu, eD({ features: Iu.Hidden, key: c, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: b, disabled: C, name: c, value: B }))) : [], eu({ ourProps: F, theirProps: { ...D, ...ee(m, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: D, slots: f, name: "RadioGroup" })]);
  };
} });
var Ua = ((u) => (u[u.Empty = 1] = "Empty", u[u.Active = 2] = "Active", u))(Ua || {});
let h0 = z({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(u, { attrs: e, slots: D, expose: f }) {
  var t;
  let n = (t = u.id) != null ? t : `headlessui-radiogroup-option-${su()}`, a = g0("RadioGroupOption"), o = xf({ name: "RadioGroupLabel" }), r = fD({ name: "RadioGroupDescription" }), l = I(null), i = w(() => ({ value: u.value, disabled: u.disabled })), s = I(1);
  f({ el: l, $el: l });
  let d = w(() => $(l));
  ru(() => a.registerOption({ id: n, element: d, propsRef: i })), vu(() => a.unregisterOption(n));
  let g = w(() => {
    var F;
    return ((F = a.firstOption.value) == null ? void 0 : F.id) === n;
  }), h = w(() => a.disabled.value || u.disabled), _ = w(() => a.compare(cu(a.value.value), cu(u.value))), C = w(() => h.value ? -1 : _.value || !a.containsCheckedOption.value && g.value ? 0 : -1);
  function p() {
    var F;
    a.change(u.value) && (s.value |= 2, (F = $(l)) == null || F.focus());
  }
  function b() {
    s.value |= 2;
  }
  function m() {
    s.value &= -3;
  }
  return () => {
    let { value: F, disabled: c, ...B } = u, k = { checked: _.value, disabled: h.value, active: !!(s.value & 2) }, A = { id: n, ref: l, role: "radio", "aria-checked": _.value ? "true" : "false", "aria-labelledby": o.value, "aria-describedby": r.value, "aria-disabled": h.value ? !0 : void 0, tabIndex: C.value, onClick: h.value ? void 0 : p, onFocus: h.value ? void 0 : b, onBlur: h.value ? void 0 : m };
    return eu({ ourProps: A, theirProps: B, slot: k, attrs: e, slots: D, name: "RadioGroupOption" });
  };
} }), B0 = p0, y0 = kf, _0 = Symbol("GroupContext"), Wa = z({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(u, { slots: e, attrs: D }) {
  let f = I(null), t = xf({ name: "SwitchLabel", props: { htmlFor: w(() => {
    var a;
    return (a = f.value) == null ? void 0 : a.id;
  }), onClick(a) {
    f.value && (a.currentTarget.tagName === "LABEL" && a.preventDefault(), f.value.click(), f.value.focus({ preventScroll: !0 }));
  } } }), n = fD({ name: "SwitchDescription" });
  return Bu(_0, { switchRef: f, labelledby: t, describedby: n }), () => eu({ theirProps: u, ourProps: {}, slot: {}, slots: e, attrs: D, name: "SwitchGroup" });
} }), qa = z({ name: "Switch", emits: { "update:modelValue": (u) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: null }, disabled: { type: Boolean, default: !1 }, tabIndex: { type: Number, default: 0 } }, inheritAttrs: !1, setup(u, { emit: e, attrs: D, slots: f, expose: t }) {
  var n;
  let a = (n = u.id) != null ? n : `headlessui-switch-${su()}`, o = Cu(_0, null), [r, l] = uD(w(() => u.modelValue), (b) => e("update:modelValue", b), w(() => u.defaultChecked));
  function i() {
    l(!r.value);
  }
  let s = I(null), d = o === null ? s : o.switchRef, g = Te(w(() => ({ as: u.as, type: D.type })), d);
  t({ el: d, $el: d });
  function h(b) {
    b.preventDefault(), i();
  }
  function _(b) {
    b.key === Y.Space ? (b.preventDefault(), i()) : b.key === Y.Enter && z1(b.currentTarget);
  }
  function C(b) {
    b.preventDefault();
  }
  let p = w(() => {
    var b, m;
    return (m = (b = $(d)) == null ? void 0 : b.closest) == null ? void 0 : m.call(b, "form");
  });
  return ru(() => {
    au([p], () => {
      if (!p.value || u.defaultChecked === void 0)
        return;
      function b() {
        l(u.defaultChecked);
      }
      return p.value.addEventListener("reset", b), () => {
        var m;
        (m = p.value) == null || m.removeEventListener("reset", b);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: b, value: m, form: F, tabIndex: c, ...B } = u, k = { checked: r.value }, A = { id: a, ref: d, role: "switch", type: g.value, tabIndex: c === -1 ? 0 : c, "aria-checked": r.value, "aria-labelledby": o == null ? void 0 : o.labelledby.value, "aria-describedby": o == null ? void 0 : o.describedby.value, onClick: h, onKeyup: _, onKeypress: C };
    return uu(J, [b != null && r.value != null ? uu(Lu, eD({ features: Iu.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: r.value, form: F, disabled: B.disabled, name: b, value: m })) : null, eu({ ourProps: A, theirProps: { ...D, ...ee(B, ["modelValue", "defaultChecked"]) }, slot: k, attrs: D, slots: f, name: "Switch" })]);
  };
} }), Ya = p0, Ha = kf;
function Ga(u) {
  let e = { called: !1 };
  return (...D) => {
    if (!e.called)
      return e.called = !0, u(...D);
  };
}
function bD(u, ...e) {
  u && e.length > 0 && u.classList.add(...e);
}
function ze(u, ...e) {
  u && e.length > 0 && u.classList.remove(...e);
}
var MD = ((u) => (u.Finished = "finished", u.Cancelled = "cancelled", u))(MD || {});
function Xa(u, e) {
  let D = ue();
  if (!u)
    return D.dispose;
  let { transitionDuration: f, transitionDelay: t } = getComputedStyle(u), [n, a] = [f, t].map((o) => {
    let [r = 0] = o.split(",").filter(Boolean).map((l) => l.includes("ms") ? parseFloat(l) : parseFloat(l) * 1e3).sort((l, i) => i - l);
    return r;
  });
  return n !== 0 ? D.setTimeout(() => e("finished"), n + a) : e("finished"), D.add(() => e("cancelled")), D.dispose;
}
function f1(u, e, D, f, t, n) {
  let a = ue(), o = n !== void 0 ? Ga(n) : () => {
  };
  return ze(u, ...t), bD(u, ...e, ...D), a.nextFrame(() => {
    ze(u, ...D), bD(u, ...f), a.add(Xa(u, (r) => (ze(u, ...f, ...e), bD(u, ...t), o(r))));
  }), a.add(() => ze(u, ...e, ...D, ...f, ...t)), a.add(() => o("cancelled")), a.dispose;
}
function ne(u = "") {
  return u.split(/\s+/).filter((e) => e.length > 1);
}
let $f = Symbol("TransitionContext");
var Za = ((u) => (u.Visible = "visible", u.Hidden = "hidden", u))(Za || {});
function Ka() {
  return Cu($f, null) !== null;
}
function Qa() {
  let u = Cu($f, null);
  if (u === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return u;
}
function Ja() {
  let u = Cu(Sf, null);
  if (u === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return u;
}
let Sf = Symbol("NestingContext");
function nD(u) {
  return "children" in u ? nD(u.children) : u.value.filter(({ state: e }) => e === "visible").length > 0;
}
function w0(u) {
  let e = I([]), D = I(!1);
  ru(() => D.value = !0), vu(() => D.value = !1);
  function f(n, a = Qu.Hidden) {
    let o = e.value.findIndex(({ id: r }) => r === n);
    o !== -1 && (ou(a, { [Qu.Unmount]() {
      e.value.splice(o, 1);
    }, [Qu.Hidden]() {
      e.value[o].state = "hidden";
    } }), !nD(e) && D.value && (u == null || u()));
  }
  function t(n) {
    let a = e.value.find(({ id: o }) => o === n);
    return a ? a.state !== "visible" && (a.state = "visible") : e.value.push({ id: n, state: "visible" }), () => f(n, Qu.Unmount);
  }
  return { children: e, register: t, unregister: f };
}
let k0 = Au.RenderStrategy, oD = z({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(u, { emit: e, attrs: D, slots: f, expose: t }) {
  let n = I(0);
  function a() {
    n.value |= nu.Opening, e("beforeEnter");
  }
  function o() {
    n.value &= ~nu.Opening, e("afterEnter");
  }
  function r() {
    n.value |= nu.Closing, e("beforeLeave");
  }
  function l() {
    n.value &= ~nu.Closing, e("afterLeave");
  }
  if (!Ka() && Yt())
    return () => uu(rD, { ...u, onBeforeEnter: a, onAfterEnter: o, onBeforeLeave: r, onAfterLeave: l }, f);
  let i = I(null), s = w(() => u.unmount ? Qu.Unmount : Qu.Hidden);
  t({ el: i, $el: i });
  let { show: d, appear: g } = Qa(), { register: h, unregister: _ } = Ja(), C = I(d.value ? "visible" : "hidden"), p = { value: !0 }, b = su(), m = { value: !1 }, F = w0(() => {
    !m.value && C.value !== "hidden" && (C.value = "hidden", _(b), l());
  });
  ru(() => {
    let L = h(b);
    vu(L);
  }), gu(() => {
    if (s.value === Qu.Hidden && b) {
      if (d.value && C.value !== "visible") {
        C.value = "visible";
        return;
      }
      ou(C.value, { hidden: () => _(b), visible: () => h(b) });
    }
  });
  let c = ne(u.enter), B = ne(u.enterFrom), k = ne(u.enterTo), A = ne(u.entered), j = ne(u.leave), T = ne(u.leaveFrom), S = ne(u.leaveTo);
  ru(() => {
    gu(() => {
      if (C.value === "visible") {
        let L = $(i);
        if (L instanceof Comment && L.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function W(L) {
    let H = p.value && !g.value, X = $(i);
    !X || !(X instanceof HTMLElement) || H || (m.value = !0, d.value && a(), d.value || r(), L(d.value ? f1(X, c, B, k, A, (lu) => {
      m.value = !1, lu === MD.Finished && o();
    }) : f1(X, j, T, S, A, (lu) => {
      m.value = !1, lu === MD.Finished && (nD(F) || (C.value = "hidden", _(b), l()));
    })));
  }
  return ru(() => {
    au([d], (L, H, X) => {
      W(X), p.value = !1;
    }, { immediate: !0 });
  }), Bu(Sf, F), Me(w(() => ou(C.value, { visible: nu.Open, hidden: nu.Closed }) | n.value)), () => {
    let { appear: L, show: H, enter: X, enterFrom: lu, enterTo: yu, entered: Tu, leave: Ru, leaveFrom: Wu, leaveTo: Du, ...tu } = u, wu = { ref: i }, hu = { ...tu, ...g.value && d.value && we.isServer ? { class: M([D.class, tu.class, ...c, ...B]) } : {} };
    return eu({ theirProps: hu, ourProps: wu, slot: {}, slots: f, attrs: D, features: k0, visible: C.value === "visible", name: "TransitionChild" });
  };
} }), u3 = oD, rD = z({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(u, { emit: e, attrs: D, slots: f }) {
  let t = De(), n = w(() => u.show === null && t !== null ? (t.value & nu.Open) === nu.Open : u.show);
  gu(() => {
    if (![!0, !1].includes(n.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let a = I(n.value ? "visible" : "hidden"), o = w0(() => {
    a.value = "hidden";
  }), r = I(!0), l = { show: n, appear: w(() => u.appear || !r.value) };
  return ru(() => {
    gu(() => {
      r.value = !1, n.value ? a.value = "visible" : nD(o) || (a.value = "hidden");
    });
  }), Bu(Sf, o), Bu($f, l), () => {
    let i = ee(u, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), s = { unmount: u.unmount };
    return eu({ ourProps: { ...s, as: "template" }, theirProps: {}, slot: {}, slots: { ...f, default: () => [uu(u3, { onBeforeEnter: () => e("beforeEnter"), onAfterEnter: () => e("afterEnter"), onBeforeLeave: () => e("beforeLeave"), onAfterLeave: () => e("afterLeave"), ...D, ...s, ...i }, f.default)] }, attrs: {}, features: k0, visible: a.value === "visible", name: "Transition" });
  };
} });
const e3 = z({
  components: {
    LoadingIcon: Je,
    ChevronDownIcon: Et,
    Menu: n0,
    MenuButton: o0,
    MenuItems: r0,
    MenuItem: l0
  },
  props: {
    loading: { type: Boolean },
    disabled: { type: Boolean },
    type: { type: String, default: "button" },
    color: { type: String, default: "primary" },
    size: { type: String, default: "base" },
    withDropdown: { type: Boolean },
    dropdownIcon: { type: Function },
    dropdownPosition: {
      type: String,
      default: () => "bottom",
      validator: (u) => ["top", "bottom"].includes(u)
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(u, { slots: e }) {
    const D = {
      primary: "text-white bg-primary-500 border border-transparent hover:bg-primary-600 focus:ring-primary-400 shadow-sm",
      secondary: "text-secondary-900 bg-secondary-300 border border-transparent hover:bg-secondary-400 focus:ring-secondary-200 shadow-sm",
      success: "text-white bg-green-400 border border-transparent hover:bg-green-500 focus:ring-green-300 shadow-sm",
      danger: "text-white bg-red-600 border border-transparent hover:bg-red-700 focus:ring-red-500 shadow-sm",
      warning: "text-red-700 bg-white border border-gray-300 focus:ring-red-500 shadow-sm",
      white: "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:ring-primary-400 shadow-sm"
    }, f = {
      primary: `${D.primary} focus:border-primary-400`,
      secondary: `${D.secondary} focus:border-secondary-200`,
      success: `${D.success} focus:border-green-300`,
      warning: `${D.warning} focus:border-red-400`,
      white: `${D.white} focus:border-primary-400`
    }, t = {
      primary: "bg-primary-500 text-white",
      secondary: "bg-secondary-200 text-secondary-900",
      success: "bg-green-500 text-white",
      warning: "bg-red-600 text-white",
      white: "bg-primary-500 text-white"
    }, n = w(() => {
      const C = {
        primary: "text-primary-400",
        secondary: "text-secondary-300",
        warning: "text-red-700",
        black: "text-gray-900"
      };
      return u.disabled ? C : {
        primary: `${C.primary} hover:text-primary-500`,
        secondary: `${C.secondary} hover:text-secondary-400`,
        warning: `${C.warning} hover:text-red-800`,
        black: C.black
      };
    }), a = {
      xl: "px-6 py-3 text-base",
      lg: "px-4 py-2 text-base",
      base: "px-4 py-2 text-sm",
      sm: "px-3 py-2 text-sm leading-4",
      xs: "px-2.5 py-1.5 text-xs"
    }, o = {
      xl: "px-3 py-3 text-base",
      lg: "px-2 py-2 text-base",
      base: "px-2 py-2 text-sm",
      sm: "px-2 py-2 text-sm leading-4",
      xs: "px-1.5 py-1.5 text-xs"
    }, r = {
      xl: "-ml-1 mr-3 h-5 w-5",
      lg: "-ml-1 mr-3 h-5 w-5",
      base: "-ml-1 mr-2 h-5 w-5",
      sm: "-ml-0.5 mr-2 h-4 w-4",
      xs: "-ml-0.5 mr-2 h-4 w-4"
    }, l = {
      xl: "-mr-1 ml-3 h-5 w-5",
      lg: "-mr-1 ml-3 h-5 w-5",
      base: "-mr-1 ml-2 h-5 w-5",
      sm: "-mr-0.5 ml-2 h-4 w-4",
      xs: "-mr-0.5 ml-2 h-4 w-4"
    }, i = {
      xl: "h-6 w-5",
      lg: "h-6 w-5",
      base: "py-0.5 h-5 w-5",
      sm: "h-4 w-4",
      xs: "h-4 w-4"
    }, s = {
      xl: "py-3 text-base",
      lg: "py-2 text-base",
      base: "py-2 text-sm",
      sm: "py-2 text-sm leading-4",
      xs: "py-1.5 text-xs"
    }, d = {
      bottom: "origin-top-right right-0",
      top: "origin-bottom-right right-0 bottom-full"
    }, g = {
      primary: "divide-x divide-primary-600",
      secondary: "divide-x divide-secondary-400",
      success: "divide-x divide-green-500"
    }, h = w(() => {
      let C;
      return u.type === "text" ? C = `${n.value[u.color]}` : C = `${f[u.color]} ${o[u.size]}`, e.default ? u.size === "xs" ? C += " rounded-r" : C += " rounded-r-md" : C += " rounded-full", C;
    }), _ = w(() => u.type === "text" ? `${n.value[u.color]} ${s[u.size]}` : u.withDropdown ? `${f[u.color]} ${a[u.size]} focus:ring-1 ${u.size === "xs" ? "rounded-l" : "rounded-l-md"}` : `${D[u.color]} ${a[u.size]} focus:ring-2 focus:ring-offset-2 ${u.size === "xs" ? "rounded" : "rounded-md"}`);
    return {
      dropdownCss: h,
      backgroundSizes: a,
      iconSizesLeft: r,
      iconSizesRight: l,
      textSizes: s,
      textColors: n,
      backgroundColors: D,
      dropdownColors: f,
      dropdownActiveItemColors: t,
      arrowButtonSizes: o,
      arrowIconSizes: i,
      dropdownMenuPosition: d,
      dividerColor: g,
      buttonCss: _
    };
  }
}), D3 = ["disabled", "type"], f3 = { key: 1 }, t3 = ["onClick"];
function a3(u, e, D, f, t, n) {
  const a = P("LoadingIcon"), o = P("ChevronDownIcon"), r = P("MenuButton"), l = P("MenuItem"), i = P("MenuItems"), s = P("Menu");
  return u.type === "link" ? (E(), y("a", {
    key: 0,
    class: M([[{ "opacity-50 cursor-not-allowed": u.disabled }], "text-sm font-medium text-primary-400 hover:text-primary-500 underline"]),
    href: "",
    onClick: e[0] || (e[0] = ju((d) => u.$emit("click"), ["prevent"]))
  }, [
    fu(u.$slots, "default")
  ], 2)) : (E(), y("span", {
    key: 1,
    class: M([[u.dividerColor[u.color], u.withDropdown ? "z-1" : "z-0"], "relative inline-flex rounded-md"])
  }, [
    u.$slots.default ? (E(), y("button", {
      key: 0,
      class: M([[u.buttonCss, { "opacity-50 cursor-not-allowed": u.disabled || u.loading }], "inline-flex font-medium focus:outline-none items-center justify-center focus:z-10 w-full"]),
      disabled: u.loading || u.disabled,
      type: u.type === "submit" ? "submit" : "button"
    }, [
      u.$slots["icon-before"] && !u.loading ? (E(), y("span", {
        key: 0,
        class: M([u.iconSizesLeft[u.size]])
      }, [
        fu(u.$slots, "icon-before")
      ], 2)) : u.loading ? (E(), y("span", f3, [
        U(a, {
          class: M([[
            u.color === "warning" || u.color === "white" || u.color === "primary" && u.type === "text" ? "text-primary-900" : "text-white"
          ], "mr-3 h-5 w-5 animate-spin"])
        }, null, 8, ["class"])
      ])) : R("", !0),
      fu(u.$slots, "default"),
      u.$slots["icon-after"] ? (E(), y("span", {
        key: 2,
        class: M(u.iconSizesRight[u.size])
      }, [
        fu(u.$slots, "icon-after")
      ], 2)) : R("", !0)
    ], 10, D3)) : R("", !0),
    u.withDropdown ? (E(), q(s, {
      key: 1,
      as: "span",
      class: "-ml-px relative block",
      onClick: e[1] || (e[1] = ju(() => {
      }, ["prevent", "stop"]))
    }, {
      default: N(() => [
        U(r, {
          class: M([u.dropdownCss, "relative inline-flex items-center font-medium focus:outline-none focus:ring-2 focus:z-10 max-w-md"])
        }, {
          default: N(() => [
            u.dropdownIcon ? (E(), q(xu(u.dropdownIcon), {
              key: 0,
              class: M(u.arrowIconSizes[u.size])
            }, null, 8, ["class"])) : (E(), q(o, {
              key: 1,
              class: M(u.arrowIconSizes[u.size])
            }, null, 8, ["class"]))
          ]),
          _: 1
        }, 8, ["class"]),
        U(_e, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: N(() => [
            U(i, {
              class: M([u.dropdownMenuPosition[u.dropdownPosition], "absolute my-2 z-10 rounded-md shadow-lg px-1 py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none w-max"])
            }, {
              default: N(() => [
                (E(!0), y(J, null, du(u.items, (d, g) => (E(), q(l, {
                  key: g,
                  disabled: d.disabled
                }, {
                  default: N(({ active: h }) => [
                    v("button", {
                      class: M([
                        h ? u.dropdownActiveItemColors[u.color] : "text-gray-700",
                        "group flex rounded-md items-center w-full px-2 py-2 text-sm",
                        d.disabled ? "opacity-75 cursor-not-allowed" : ""
                      ]),
                      onClick: d.action
                    }, O(d.name), 11, t3)
                  ]),
                  _: 2
                }, 1032, ["disabled"]))), 128))
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : R("", !0)
  ], 2));
}
const Pe = /* @__PURE__ */ Q(e3, [["render", a3]]), n3 = z({
  components: {
    XMarkIcon: vf
  },
  emits: ["remove"],
  props: {
    color: {
      type: String,
      default: () => "gray",
      validator: (u) => [
        "light-gray",
        "black",
        "gray",
        "red",
        "yellow",
        "orange",
        "green",
        "primary",
        "purple",
        "pink",
        "secondary",
        "redOutline"
      ].includes(u)
    },
    size: {
      type: String,
      default: () => "base",
      validator: (u) => ["base", "lg"].includes(u)
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  setup(u, { emit: e }) {
    return { colors: {
      "light-gray": "bg-gray-100 text-gray-500",
      gray: "bg-gray-100 text-gray-800",
      black: "bg-gray-700 text-gray-50",
      red: "bg-red-100 text-red-800",
      yellow: "bg-yellow-100 text-yellow-800",
      orange: "bg-orange-100 text-orange-800",
      green: "bg-green-100 text-green-800",
      primary: "bg-primary-100 text-primary-800",
      secondary: "bg-secondary-300 text-secondary-900",
      purple: "bg-purple-100 text-purple-800",
      pink: "bg-pink-100 text-pink-800",
      redOutline: "bg-transparent text-red-700 border border-red-600"
    }, sizes: {
      base: "px-2 py-0.5 rounded text-xs",
      lg: "px-2.5 py-0.5 rounded-md text-sm"
    }, remove: () => {
      e("remove");
    }, buttonColors: {
      "light-gray": "text-gray-500 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white",
      gray: "text-gray-800 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white",
      red: "text-red-400 hover:bg-red-200 hover:text-red-500 focus:bg-red-500 focus:text-white",
      yellow: "text-yellow-800 hover:bg-yellow-200 hover:text-yellow-500 focus:bg-yellow-500 focus:text-white",
      orange: "text-orange-800 hover:bg-orange-200 hover:text-orange-500 focus:bg-orange-500 focus:text-white",
      green: "text-green-800 hover:bg-green-200 hover:text-green-500 focus:bg-green-500 focus:text-white",
      primary: "text-primary-800 hover:bg-primary-200 hover:text-primary-500 focus:bg-primary-500 focus:text-white",
      purple: "text-purple-800 hover:bg-purple-200 hover:text-purple-500 focus:bg-purple-500 focus:text-white",
      pink: "text-pink-800 hover:bg-pink-200 hover:text-pink-500 focus:bg-pink-500 focus:text-white",
      secondary: "text-secondary-800 hover:bg-secondary-400 hover:text-secondary-700 focus:bg-secondary-600 focus:text-white",
      redOutline: "text-red-400 hover:bg-red-200 hover:text-red-500 focus:bg-red-500 focus:text-white"
    } };
  }
}), o3 = /* @__PURE__ */ v("span", { class: "sr-only" }, "Remove option", -1);
function r3(u, e, D, f, t, n) {
  const a = P("XMarkIcon");
  return E(), y("span", {
    class: M([[u.colors[u.color], u.sizes[u.size], { "rounded-full": u.rounded }], "inline-flex items-center font-medium"])
  }, [
    fu(u.$slots, "default"),
    u.clearable ? (E(), y("button", {
      key: 0,
      class: M([u.buttonColors[u.color], "flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center focus:outline-none"]),
      type: "button",
      onClick: e[0] || (e[0] = (...o) => u.remove && u.remove(...o))
    }, [
      o3,
      U(a, { class: "h-3 w-3" })
    ], 2)) : R("", !0)
  ], 2);
}
const lD = /* @__PURE__ */ Q(n3, [["render", r3]]), l3 = z({
  components: { Switch: qa, SwitchGroup: Wa, SwitchLabel: Ya, SwitchDescription: Ha },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "primary",
      validator: (u) => ["primary", "green", "light"].includes(u)
    },
    size: {
      type: String,
      default: "sm",
      validator: (u) => ["xs", "sm"].includes(u)
    },
    label: {
      type: String
    },
    description: {
      type: String
    },
    loading: { type: Boolean, default: !1 },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        },
        meta: {}
      })
    },
    validations: { type: Object, default: () => ({ exclusiveTests: {} }) },
    hideValidationError: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(u, { emit: e }) {
    return {
      bgColor: {
        light: "bg-secondary-300",
        primary: "bg-primary-600",
        green: "bg-green-200"
      },
      iconColor: {
        light: "text-primary-600",
        primary: "text-primary-600",
        green: "text-green-600"
      },
      ringColor: {
        light: " focus:ring-primary-500",
        primary: " focus:ring-primary-500",
        green: " focus:ring-green-300"
      },
      switchSize: {
        xs: "h-5 w-10",
        sm: "h-6 w-11"
      },
      bgSize: {
        xs: "h-4 w-9",
        sm: "h-6 w-11"
      },
      labelColor: {
        light: "text-primary-50",
        primary: "text-gray-700",
        green: "text-gray-700"
      },
      toggleSwitch: (i) => {
        u.disabled || e("update:modelValue", i);
      },
      labelSize: {
        xs: "text-xs",
        sm: "text-sm"
      }
    };
  }
}), i3 = { key: 1 }, d3 = {
  key: 0,
  class: "flex-grow flex flex-col pr-2"
}, s3 = { class: "h-3 w-3" }, c3 = { class: "h-3 w-3" }, F3 = {
  key: 2,
  class: "mt-1 min-h-5 text-red-600 text-xs"
};
function C3(u, e, D, f, t, n) {
  const a = P("SwitchLabel"), o = P("SwitchDescription"), r = P("Switch"), l = P("SwitchGroup");
  return E(), y("div", null, [
    u.loading ? (E(), y("div", {
      key: 0,
      class: M([u.bgSize[u.size], "animate-pulse bg-gray-200 rounded"])
    }, null, 2)) : (E(), y("div", i3, [
      U(l, {
        as: "div",
        class: "flex items-center justify-between"
      }, {
        default: N(() => [
          u.label ? (E(), y("span", d3, [
            U(a, {
              class: M([[u.labelColor[u.color], u.labelSize[u.size]], "font-medium"]),
              as: "span",
              passive: ""
            }, {
              default: N(() => [
                G(O(u.label), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            u.description ? (E(), q(o, {
              key: 0,
              as: "span",
              class: "text-sm text-gray-500"
            }, {
              default: N(() => [
                G(O(u.description), 1)
              ]),
              _: 1
            })) : R("", !0)
          ])) : R("", !0),
          U(r, {
            class: M([
              "group items-center justify-center relative inline-flex flex-shrink-0 bg-white border-2 border-transparent rounded-full  transition-colors ease-in-out duration-200",
              u.switchSize[u.size],
              u.ringColor[u.color],
              u.disabled ? "opacity-50 cursor-not-allowed focus:ring-0" : "cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2"
            ]),
            modelValue: u.modelValue,
            "onUpdate:modelValue": u.toggleSwitch
          }, {
            default: N(() => [
              v("span", {
                class: M([
                  u.bgSize[u.size],
                  u.modelValue ? u.bgColor[u.color] : "bg-gray-200",
                  "pointer-events-none absolute mx-auto rounded-full transition-colors ease-in-out duration-200"
                ]),
                "aria-hidden": "true"
              }, null, 2),
              v("span", {
                class: M([
                  {
                    "border border-gray-200 ": u.size === "xs"
                  },
                  u.modelValue ? "translate-x-5" : "translate-x-0",
                  "pointer-events-none absolute left-0 inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200"
                ]),
                "aria-hidden": "true"
              }, [
                v("span", {
                  class: M([[
                    u.modelValue ? "opacity-0 ease-out duration-100" : "opacity-100 ease-in duration-200"
                  ], "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity text-gray-400"]),
                  "aria-hidden": "true"
                }, [
                  v("span", s3, [
                    fu(u.$slots, "icon-disabled")
                  ])
                ], 2),
                v("span", {
                  class: M([[
                    u.modelValue ? "opacity-100 ease-in duration-200" : "opacity-0 ease-out duration-100",
                    u.iconColor[u.color]
                  ], "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"]),
                  "aria-hidden": "true"
                }, [
                  v("span", c3, [
                    fu(u.$slots, "icon-enabled")
                  ])
                ], 2)
              ], 2)
            ]),
            _: 3
          }, 8, ["class", "modelValue", "onUpdate:modelValue"])
        ]),
        _: 3
      })
    ])),
    u.hideValidationError ? R("", !0) : (E(), y("p", F3, O(u.validation.errorMessage), 1))
  ]);
}
const Wc = /* @__PURE__ */ Q(l3, [["render", C3]]);
var E3 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Le(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
var OD = { exports: {} };
(function(u, e) {
  (function() {
    var D = this, f = D.EmojiConvertor, t = function() {
      var n = this;
      return n.img_set = "apple", n.img_sets = {
        apple: { path: "/emoji-data/img-apple-64/", sheet: "/emoji-data/sheet_apple_64.png", sheet_size: 64, mask: 1 },
        google: { path: "/emoji-data/img-google-64/", sheet: "/emoji-data/sheet_google_64.png", sheet_size: 64, mask: 2 },
        twitter: { path: "/emoji-data/img-twitter-64/", sheet: "/emoji-data/sheet_twitter_64.png", sheet_size: 64, mask: 4 },
        facebook: { path: "/emoji-data/img-facebook-64/", sheet: "/emoji-data/sheet_facebook_64.png", sheet_size: 64, mask: 8 }
      }, n.use_css_imgs = !1, n.colons_mode = !1, n.text_mode = !1, n.include_title = !1, n.include_text = !1, n.allow_native = !0, n.wrap_native = !1, n.use_sheet = !1, n.avoid_ms_emoji = !0, n.allow_caps = !1, n.img_suffix = "", n.inits = {}, n.map = {}, n.init_env(), n;
    };
    t.prototype.noConflict = function() {
      return D.EmojiConvertor = f, t;
    }, t.prototype.replace_emoticons = function(n) {
      var a = this, o = a.replace_emoticons_with_colons(n);
      return a.replace_colons(o);
    }, t.prototype.replace_emoticons_with_colons = function(n) {
      var a = this;
      a.init_emoticons();
      var o = 0, r = [], l = n.replace(a.rx_emoticons, function(d, g, h, _) {
        var C = o;
        o = _ + d.length;
        var p = h.indexOf("(") !== -1, b = h.indexOf(")") !== -1;
        if ((p || b) && r.indexOf(h) == -1 && r.push(h), b && !p) {
          var m = n.substring(C, _);
          if (m.indexOf("(") !== -1 && m.indexOf(")") === -1)
            return d;
        }
        if (d === `
8)`) {
          var F = n.substring(0, _);
          if (/\n?(6\)|7\))/.test(F))
            return d;
        }
        var c = a.data[a.map.emoticons[h]][3][0];
        return c ? g + ":" + c + ":" : d;
      });
      if (r.length) {
        var i = r.map(a.escape_rx), s = new RegExp("(\\(.+)(" + i.join("|") + ")(.+\\))", "g");
        l = l.replace(s, function(d, g, h, _) {
          var C = a.data[a.map.emoticons[h]][3][0];
          return C ? g + ":" + C + ":" + _ : d;
        });
      }
      return l;
    }, t.prototype.replace_colons = function(n) {
      var a = this;
      return a.init_colons(), n.replace(a.rx_colons, function(o) {
        var r = o.substr(1, o.length - 2);
        if (a.allow_caps && (r = r.toLowerCase()), r.indexOf("::skin-tone-") > -1) {
          var l = r.substr(-1, 1), i = "skin-tone-" + l, s = a.map.colons[i];
          r = r.substr(0, r.length - 13);
          var d = a.map.colons[r];
          return d ? a.replacement(d, r, ":", {
            idx: s,
            actual: i,
            wrapper: ":"
          }) : ":" + r + ":" + a.replacement(s, i, ":");
        } else {
          var d = a.map.colons[r];
          return d ? a.replacement(d, r, ":") : o;
        }
      });
    }, t.prototype.replace_unified = function(n) {
      var a = this;
      return a.init_unified(), n.replace(a.rx_unified, function(o, r, l) {
        var i = a.map.unified[r];
        if (i) {
          var s = null;
          return l == "🏻" && (s = "1f3fb"), l == "🏼" && (s = "1f3fc"), l == "🏽" && (s = "1f3fd"), l == "🏾" && (s = "1f3fe"), l == "🏿" && (s = "1f3ff"), s ? a.replacement(i, null, null, {
            idx: s,
            actual: l,
            wrapper: ""
          }) : a.replacement(i);
        }
        return i = a.map.unified_vars[r], i ? a.replacement(i[0], null, null, {
          idx: i[1],
          actual: "",
          wrapper: ""
        }) : o;
      });
    }, t.prototype.addAliases = function(n) {
      var a = this;
      a.init_colons();
      for (var o in n)
        a.map.colons[o] = n[o];
    }, t.prototype.removeAliases = function(n) {
      for (var a = this, o = 0; o < n.length; o++) {
        var r = n[o];
        delete a.map.colons[r];
        u:
          for (var l in a.data)
            for (var i = 0; i < a.data[l][3].length; i++)
              if (r == a.data[l][3][i]) {
                a.map.colons[r] = l;
                break u;
              }
      }
    }, t.prototype.replacement = function(n, a, o, r, l) {
      var i = this, s = "", d = null;
      if (typeof r == "object" && (s = i.replacement(r.idx, r.actual, r.wrapper, void 0, !0), d = r.idx), o = o || "", i.colons_mode)
        return ":" + i.data[n][3][0] + ":" + s;
      var g = a ? o + a + o : i.data[n][8] || o + i.data[n][3][0] + o;
      if (i.text_mode)
        return g + s;
      var h = i.find_image(n, d);
      if (i.init_env(), i.replace_mode == "softbank" && i.allow_native && i.data[n][1])
        return i.format_native(i.data[n][1] + s, !l);
      if (i.replace_mode == "google" && i.allow_native && i.data[n][2])
        return i.format_native(i.data[n][2] + s, !l);
      if (h.is_var && (s = ""), i.replace_mode == "unified" && i.allow_native)
        return i.format_native(h.unified + s, !l);
      var _ = i.include_title ? ' title="' + (a || i.data[n][3][0]) + '"' : "", C = i.include_text ? o + (a || i.data[n][3][0]) + o : "";
      if (i.data[n][7] && (h.path = i.data[n][7], h.px = null, h.py = null, h.is_var = !1), h.is_var && i.include_text && r && r.actual && r.wrapper && (C += r.wrapper + r.actual + r.wrapper), i.replace_mode == "css")
        if (i.use_sheet && h.px != null && h.py != null) {
          var p = 100 * h.px / (i.sheet_size - 1), b = 100 * h.py / (i.sheet_size - 1), m = 100 * i.sheet_size, F = "background: url(" + h.sheet + ");background-position:" + p + "% " + b + "%;background-size:" + m + "% " + m + "%";
          return '<span class="emoji-outer emoji-sizer"><span class="emoji-inner" style="' + F + '"' + _ + ' data-codepoints="' + h.full_idx + '">' + C + "</span></span>" + s;
        } else
          return i.use_css_imgs ? '<span class="emoji emoji-' + n + '"' + _ + ' data-codepoints="' + h.full_idx + '">' + C + "</span>" + s : '<span class="emoji emoji-sizer" style="background-image:url(' + h.path + ')"' + _ + ' data-codepoints="' + h.full_idx + '">' + C + "</span>" + s;
      return '<img src="' + h.path + '" class="emoji" data-codepoints="' + h.full_idx + '" ' + _ + "/>" + s;
    }, t.prototype.format_native = function(n, a) {
      var o = this;
      return o.wrap_native && a ? '<span class="emoji-native">' + n + "</span>" : n;
    }, t.prototype.find_image = function(n, a) {
      var o = this, r = {
        path: "",
        sheet: "",
        sheet_size: 0,
        px: o.data[n][4],
        py: o.data[n][5],
        full_idx: n,
        is_var: !1,
        unified: o.data[n][0][0]
      }, l = o.data[n][6];
      if (a && o.variations_data[n] && o.variations_data[n][a]) {
        var i = o.variations_data[n][a];
        r.px = i[1], r.py = i[2], r.full_idx = i[0], r.is_var = !0, r.unified = i[4][0], l = i[3];
      }
      for (var s = [o.img_set, "apple", "google", "twitter", "facebook", "messenger"], d = 0; d < s.length; d++) {
        if (!o.img_sets[s[d]])
          throw Error("Invalid value for img_set");
        if (l & o.img_sets[s[d]].mask)
          return r.path = o.img_sets[s[d]].path + r.full_idx + ".png" + o.img_suffix, r.sheet = o.img_sets[o.img_set].sheet, r.sheet_size = o.img_sets[o.img_set].sheet_size, r;
        if (o.obsoletes_data[r.full_idx]) {
          var g = o.obsoletes_data[r.full_idx];
          if (g[3] & o.img_sets[s[d]].mask)
            return r.path = o.img_sets[s[d]].path + g[0] + ".png" + o.img_suffix, r.sheet = o.img_sets[s[d]].sheet, r.sheet_size = o.img_sets[s[d]].sheet_size, r.px = g[1], r.py = g[2], r;
        }
      }
      return r;
    }, t.prototype.init_emoticons = function() {
      var n = this;
      if (!n.inits.emoticons) {
        n.init_colons(), n.inits.emoticons = 1;
        var a = [];
        n.map.emoticons = {};
        for (var o in n.emoticons_data) {
          var r = o.replace(/\&/g, "&amp;").replace(/\</g, "&lt;").replace(/\>/g, "&gt;");
          n.map.colons[n.emoticons_data[o]] && (n.map.emoticons[r] = n.map.colons[n.emoticons_data[o]], a.push(n.escape_rx(r)));
        }
        n.rx_emoticons = new RegExp("(^|\\s)(" + a.join("|") + ")(?=$|[\\s|\\?\\.,!])", "g");
      }
    }, t.prototype.init_colons = function() {
      var n = this;
      if (!n.inits.colons) {
        n.inits.colons = 1, n.rx_colons = new RegExp(":[a-zA-Z0-9-_+]+:(:skin-tone-[2-6]:)?", "g"), n.map.colons = {};
        for (var a in n.data)
          for (var o = 0; o < n.data[a][3].length; o++)
            n.map.colons[n.data[a][3][o]] = a;
      }
    }, t.prototype.init_unified = function() {
      var n = this;
      if (!n.inits.unified) {
        n.inits.unified = 1;
        var a = [];
        n.map.unified = {}, n.map.unified_vars = {};
        for (var o in n.data)
          for (var r = 0; r < n.data[o][0].length; r++)
            a.push(n.data[o][0][r].replace("*", "\\*")), n.map.unified[n.data[o][0][r]] = o;
        for (var o in n.variations_data)
          if (!(n.variations_data[o]["1f3fb"] && n.variations_data[o]["1f3fb"][0] == o + "-1f3fb"))
            for (var l in n.variations_data[o])
              for (var r = 0; r < n.variations_data[o][l][4].length; r++)
                a.push(n.variations_data[o][l][4][r].replace("*", "\\*")), n.map.unified_vars[n.variations_data[o][l][4][r]] = [o, l];
        a = a.sort(function(i, s) {
          return s.length - i.length;
        }), n.rx_unified = new RegExp("(" + a.join("|") + ")(\uD83C[\uDFFB-\uDFFF])?", "g");
      }
    }, t.prototype.init_env = function() {
      var n = this;
      if (!n.inits.env) {
        n.inits.env = 1, n.replace_mode = "img";
        var a = !1;
        if (typeof navigator < "u") {
          var o = navigator.userAgent;
          if (typeof window < "u" && window.getComputedStyle)
            try {
              var r = window.getComputedStyle(document.body);
              (r["background-size"] || r.backgroundSize) && (a = !0);
            } catch {
              o.match(/Firefox/i) && (a = !0);
            }
          if (navigator.product.match(/ReactNative/i)) {
            n.replace_mode = "unified";
            return;
          }
          if (o.match(/(iPhone|iPod|iPad|iPhone\s+Simulator)/i)) {
            if (o.match(/OS\s+[12345]/i)) {
              n.replace_mode = "softbank";
              return;
            }
            if (o.match(/OS\s+[6789]/i)) {
              n.replace_mode = "unified";
              return;
            }
          }
          if (o.match(/Mac OS X (10[._ ](?:[789]|1)|11[._ ]\d)/i)) {
            n.replace_mode = "unified";
            return;
          }
          if (!n.avoid_ms_emoji && (o.match(/Windows NT 6.[1-9]/i) || o.match(/Windows NT 10.[0-9]/i)) && !o.match(/Chrome/i) && !o.match(/MSIE 8/i)) {
            n.replace_mode = "unified";
            return;
          }
        }
        if (a) {
          n.replace_mode = "css";
          return;
        }
      }
    }, t.prototype.escape_rx = function(n) {
      return n.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    }, t.prototype.sheet_size = 61, t.prototype.data = {
      "0023-fe0f-20e3": [["#️⃣", "#⃣"], "", "󾠬", ["hash"], 0, 0, 7, 0],
      "002a-fe0f-20e3": [["*️⃣", "*⃣"], "", "", ["keycap_star"], 0, 1, 7, 0],
      "0030-fe0f-20e3": [["0️⃣", "0⃣"], "", "󾠷", ["zero"], 0, 2, 7, 0],
      "0031-fe0f-20e3": [["1️⃣", "1⃣"], "", "󾠮", ["one"], 0, 3, 7, 0],
      "0032-fe0f-20e3": [["2️⃣", "2⃣"], "", "󾠯", ["two"], 0, 4, 7, 0],
      "0033-fe0f-20e3": [["3️⃣", "3⃣"], "", "󾠰", ["three"], 0, 5, 7, 0],
      "0034-fe0f-20e3": [["4️⃣", "4⃣"], "", "󾠱", ["four"], 0, 6, 7, 0],
      "0035-fe0f-20e3": [["5️⃣", "5⃣"], "", "󾠲", ["five"], 0, 7, 7, 0],
      "0036-fe0f-20e3": [["6️⃣", "6⃣"], "", "󾠳", ["six"], 0, 8, 7, 0],
      "0037-fe0f-20e3": [["7️⃣", "7⃣"], "", "󾠴", ["seven"], 0, 9, 7, 0],
      "0038-fe0f-20e3": [["8️⃣", "8⃣"], "", "󾠵", ["eight"], 0, 10, 7, 0],
      "0039-fe0f-20e3": [["9️⃣", "9⃣"], "", "󾠶", ["nine"], 0, 11, 7, 0],
      "00a9-fe0f": [["©️", "©"], "", "󾬩", ["copyright"], 0, 12, 7, 0],
      "00ae-fe0f": [["®️", "®"], "", "󾬭", ["registered"], 0, 13, 7, 0],
      "1f004": [["🀄"], "", "󾠋", ["mahjong"], 0, 14, 15, 0],
      "1f0cf": [["🃏"], "", "󾠒", ["black_joker"], 0, 15, 15, 0],
      "1f170-fe0f": [["🅰️", "🅰"], "", "󾔋", ["a"], 0, 16, 15, 0],
      "1f171-fe0f": [["🅱️", "🅱"], "", "󾔌", ["b"], 0, 17, 15, 0],
      "1f17e-fe0f": [["🅾️", "🅾"], "", "󾔎", ["o2"], 0, 18, 15, 0],
      "1f17f-fe0f": [["🅿️", "🅿"], "", "󾟶", ["parking"], 0, 19, 15, 0],
      "1f18e": [["🆎"], "", "󾔍", ["ab"], 0, 20, 15, 0],
      "1f191": [["🆑"], "", "󾮄", ["cl"], 0, 21, 15, 0],
      "1f192": [["🆒"], "", "󾬸", ["cool"], 0, 22, 15, 0],
      "1f193": [["🆓"], "", "󾬡", ["free"], 0, 23, 15, 0],
      "1f194": [["🆔"], "", "󾮁", ["id"], 0, 24, 15, 0],
      "1f195": [["🆕"], "", "󾬶", ["new"], 0, 25, 15, 0],
      "1f196": [["🆖"], "", "󾬨", ["ng"], 0, 26, 15, 0],
      "1f197": [["🆗"], "", "󾬧", ["ok"], 0, 27, 15, 0],
      "1f198": [["🆘"], "", "󾭏", ["sos"], 0, 28, 15, 0],
      "1f199": [["🆙"], "", "󾬷", ["up"], 0, 29, 15, 0],
      "1f19a": [["🆚"], "", "󾬲", ["vs"], 0, 30, 15, 0],
      "1f1e6-1f1e8": [["🇦🇨"], "", "", ["flag-ac"], 0, 31, 15, 0],
      "1f1e6-1f1e9": [["🇦🇩"], "", "", ["flag-ad"], 0, 32, 15, 0],
      "1f1e6-1f1ea": [["🇦🇪"], "", "", ["flag-ae"], 0, 33, 15, 0],
      "1f1e6-1f1eb": [["🇦🇫"], "", "", ["flag-af"], 0, 34, 15, 0],
      "1f1e6-1f1ec": [["🇦🇬"], "", "", ["flag-ag"], 0, 35, 15, 0],
      "1f1e6-1f1ee": [["🇦🇮"], "", "", ["flag-ai"], 0, 36, 15, 0],
      "1f1e6-1f1f1": [["🇦🇱"], "", "", ["flag-al"], 0, 37, 15, 0],
      "1f1e6-1f1f2": [["🇦🇲"], "", "", ["flag-am"], 0, 38, 15, 0],
      "1f1e6-1f1f4": [["🇦🇴"], "", "", ["flag-ao"], 0, 39, 15, 0],
      "1f1e6-1f1f6": [["🇦🇶"], "", "", ["flag-aq"], 0, 40, 15, 0],
      "1f1e6-1f1f7": [["🇦🇷"], "", "", ["flag-ar"], 0, 41, 15, 0],
      "1f1e6-1f1f8": [["🇦🇸"], "", "", ["flag-as"], 0, 42, 15, 0],
      "1f1e6-1f1f9": [["🇦🇹"], "", "", ["flag-at"], 0, 43, 15, 0],
      "1f1e6-1f1fa": [["🇦🇺"], "", "", ["flag-au"], 0, 44, 15, 0],
      "1f1e6-1f1fc": [["🇦🇼"], "", "", ["flag-aw"], 0, 45, 15, 0],
      "1f1e6-1f1fd": [["🇦🇽"], "", "", ["flag-ax"], 0, 46, 15, 0],
      "1f1e6-1f1ff": [["🇦🇿"], "", "", ["flag-az"], 0, 47, 15, 0],
      "1f1e7-1f1e6": [["🇧🇦"], "", "", ["flag-ba"], 0, 48, 15, 0],
      "1f1e7-1f1e7": [["🇧🇧"], "", "", ["flag-bb"], 0, 49, 15, 0],
      "1f1e7-1f1e9": [["🇧🇩"], "", "", ["flag-bd"], 0, 50, 15, 0],
      "1f1e7-1f1ea": [["🇧🇪"], "", "", ["flag-be"], 0, 51, 15, 0],
      "1f1e7-1f1eb": [["🇧🇫"], "", "", ["flag-bf"], 0, 52, 15, 0],
      "1f1e7-1f1ec": [["🇧🇬"], "", "", ["flag-bg"], 0, 53, 15, 0],
      "1f1e7-1f1ed": [["🇧🇭"], "", "", ["flag-bh"], 0, 54, 15, 0],
      "1f1e7-1f1ee": [["🇧🇮"], "", "", ["flag-bi"], 0, 55, 15, 0],
      "1f1e7-1f1ef": [["🇧🇯"], "", "", ["flag-bj"], 0, 56, 15, 0],
      "1f1e7-1f1f1": [["🇧🇱"], "", "", ["flag-bl"], 0, 57, 15, 0],
      "1f1e7-1f1f2": [["🇧🇲"], "", "", ["flag-bm"], 0, 58, 15, 0],
      "1f1e7-1f1f3": [["🇧🇳"], "", "", ["flag-bn"], 0, 59, 15, 0],
      "1f1e7-1f1f4": [["🇧🇴"], "", "", ["flag-bo"], 0, 60, 15, 0],
      "1f1e7-1f1f6": [["🇧🇶"], "", "", ["flag-bq"], 1, 0, 15, 0],
      "1f1e7-1f1f7": [["🇧🇷"], "", "", ["flag-br"], 1, 1, 15, 0],
      "1f1e7-1f1f8": [["🇧🇸"], "", "", ["flag-bs"], 1, 2, 15, 0],
      "1f1e7-1f1f9": [["🇧🇹"], "", "", ["flag-bt"], 1, 3, 15, 0],
      "1f1e7-1f1fb": [["🇧🇻"], "", "", ["flag-bv"], 1, 4, 15, 0],
      "1f1e7-1f1fc": [["🇧🇼"], "", "", ["flag-bw"], 1, 5, 15, 0],
      "1f1e7-1f1fe": [["🇧🇾"], "", "", ["flag-by"], 1, 6, 15, 0],
      "1f1e7-1f1ff": [["🇧🇿"], "", "", ["flag-bz"], 1, 7, 15, 0],
      "1f1e8-1f1e6": [["🇨🇦"], "", "", ["flag-ca"], 1, 8, 15, 0],
      "1f1e8-1f1e8": [["🇨🇨"], "", "", ["flag-cc"], 1, 9, 15, 0],
      "1f1e8-1f1e9": [["🇨🇩"], "", "", ["flag-cd"], 1, 10, 15, 0],
      "1f1e8-1f1eb": [["🇨🇫"], "", "", ["flag-cf"], 1, 11, 15, 0],
      "1f1e8-1f1ec": [["🇨🇬"], "", "", ["flag-cg"], 1, 12, 15, 0],
      "1f1e8-1f1ed": [["🇨🇭"], "", "", ["flag-ch"], 1, 13, 15, 0],
      "1f1e8-1f1ee": [["🇨🇮"], "", "", ["flag-ci"], 1, 14, 15, 0],
      "1f1e8-1f1f0": [["🇨🇰"], "", "", ["flag-ck"], 1, 15, 15, 0],
      "1f1e8-1f1f1": [["🇨🇱"], "", "", ["flag-cl"], 1, 16, 15, 0],
      "1f1e8-1f1f2": [["🇨🇲"], "", "", ["flag-cm"], 1, 17, 15, 0],
      "1f1e8-1f1f3": [["🇨🇳"], "", "󾓭", ["cn", "flag-cn"], 1, 18, 15, 0],
      "1f1e8-1f1f4": [["🇨🇴"], "", "", ["flag-co"], 1, 19, 15, 0],
      "1f1e8-1f1f5": [["🇨🇵"], "", "", ["flag-cp"], 1, 20, 15, 0],
      "1f1e8-1f1f7": [["🇨🇷"], "", "", ["flag-cr"], 1, 21, 15, 0],
      "1f1e8-1f1fa": [["🇨🇺"], "", "", ["flag-cu"], 1, 22, 15, 0],
      "1f1e8-1f1fb": [["🇨🇻"], "", "", ["flag-cv"], 1, 23, 15, 0],
      "1f1e8-1f1fc": [["🇨🇼"], "", "", ["flag-cw"], 1, 24, 15, 0],
      "1f1e8-1f1fd": [["🇨🇽"], "", "", ["flag-cx"], 1, 25, 15, 0],
      "1f1e8-1f1fe": [["🇨🇾"], "", "", ["flag-cy"], 1, 26, 15, 0],
      "1f1e8-1f1ff": [["🇨🇿"], "", "", ["flag-cz"], 1, 27, 15, 0],
      "1f1e9-1f1ea": [["🇩🇪"], "", "󾓨", ["de", "flag-de"], 1, 28, 15, 0],
      "1f1e9-1f1ec": [["🇩🇬"], "", "", ["flag-dg"], 1, 29, 15, 0],
      "1f1e9-1f1ef": [["🇩🇯"], "", "", ["flag-dj"], 1, 30, 15, 0],
      "1f1e9-1f1f0": [["🇩🇰"], "", "", ["flag-dk"], 1, 31, 15, 0],
      "1f1e9-1f1f2": [["🇩🇲"], "", "", ["flag-dm"], 1, 32, 15, 0],
      "1f1e9-1f1f4": [["🇩🇴"], "", "", ["flag-do"], 1, 33, 15, 0],
      "1f1e9-1f1ff": [["🇩🇿"], "", "", ["flag-dz"], 1, 34, 15, 0],
      "1f1ea-1f1e6": [["🇪🇦"], "", "", ["flag-ea"], 1, 35, 15, 0],
      "1f1ea-1f1e8": [["🇪🇨"], "", "", ["flag-ec"], 1, 36, 15, 0],
      "1f1ea-1f1ea": [["🇪🇪"], "", "", ["flag-ee"], 1, 37, 15, 0],
      "1f1ea-1f1ec": [["🇪🇬"], "", "", ["flag-eg"], 1, 38, 15, 0],
      "1f1ea-1f1ed": [["🇪🇭"], "", "", ["flag-eh"], 1, 39, 15, 0],
      "1f1ea-1f1f7": [["🇪🇷"], "", "", ["flag-er"], 1, 40, 15, 0],
      "1f1ea-1f1f8": [["🇪🇸"], "", "󾓫", ["es", "flag-es"], 1, 41, 15, 0],
      "1f1ea-1f1f9": [["🇪🇹"], "", "", ["flag-et"], 1, 42, 15, 0],
      "1f1ea-1f1fa": [["🇪🇺"], "", "", ["flag-eu"], 1, 43, 15, 0],
      "1f1eb-1f1ee": [["🇫🇮"], "", "", ["flag-fi"], 1, 44, 15, 0],
      "1f1eb-1f1ef": [["🇫🇯"], "", "", ["flag-fj"], 1, 45, 15, 0],
      "1f1eb-1f1f0": [["🇫🇰"], "", "", ["flag-fk"], 1, 46, 15, 0],
      "1f1eb-1f1f2": [["🇫🇲"], "", "", ["flag-fm"], 1, 47, 15, 0],
      "1f1eb-1f1f4": [["🇫🇴"], "", "", ["flag-fo"], 1, 48, 15, 0],
      "1f1eb-1f1f7": [["🇫🇷"], "", "󾓧", ["fr", "flag-fr"], 1, 49, 15, 0],
      "1f1ec-1f1e6": [["🇬🇦"], "", "", ["flag-ga"], 1, 50, 15, 0],
      "1f1ec-1f1e7": [["🇬🇧"], "", "󾓪", ["gb", "uk", "flag-gb"], 1, 51, 15, 0],
      "1f1ec-1f1e9": [["🇬🇩"], "", "", ["flag-gd"], 1, 52, 15, 0],
      "1f1ec-1f1ea": [["🇬🇪"], "", "", ["flag-ge"], 1, 53, 15, 0],
      "1f1ec-1f1eb": [["🇬🇫"], "", "", ["flag-gf"], 1, 54, 15, 0],
      "1f1ec-1f1ec": [["🇬🇬"], "", "", ["flag-gg"], 1, 55, 15, 0],
      "1f1ec-1f1ed": [["🇬🇭"], "", "", ["flag-gh"], 1, 56, 15, 0],
      "1f1ec-1f1ee": [["🇬🇮"], "", "", ["flag-gi"], 1, 57, 15, 0],
      "1f1ec-1f1f1": [["🇬🇱"], "", "", ["flag-gl"], 1, 58, 15, 0],
      "1f1ec-1f1f2": [["🇬🇲"], "", "", ["flag-gm"], 1, 59, 15, 0],
      "1f1ec-1f1f3": [["🇬🇳"], "", "", ["flag-gn"], 1, 60, 15, 0],
      "1f1ec-1f1f5": [["🇬🇵"], "", "", ["flag-gp"], 2, 0, 15, 0],
      "1f1ec-1f1f6": [["🇬🇶"], "", "", ["flag-gq"], 2, 1, 15, 0],
      "1f1ec-1f1f7": [["🇬🇷"], "", "", ["flag-gr"], 2, 2, 15, 0],
      "1f1ec-1f1f8": [["🇬🇸"], "", "", ["flag-gs"], 2, 3, 15, 0],
      "1f1ec-1f1f9": [["🇬🇹"], "", "", ["flag-gt"], 2, 4, 15, 0],
      "1f1ec-1f1fa": [["🇬🇺"], "", "", ["flag-gu"], 2, 5, 15, 0],
      "1f1ec-1f1fc": [["🇬🇼"], "", "", ["flag-gw"], 2, 6, 15, 0],
      "1f1ec-1f1fe": [["🇬🇾"], "", "", ["flag-gy"], 2, 7, 15, 0],
      "1f1ed-1f1f0": [["🇭🇰"], "", "", ["flag-hk"], 2, 8, 15, 0],
      "1f1ed-1f1f2": [["🇭🇲"], "", "", ["flag-hm"], 2, 9, 15, 0],
      "1f1ed-1f1f3": [["🇭🇳"], "", "", ["flag-hn"], 2, 10, 15, 0],
      "1f1ed-1f1f7": [["🇭🇷"], "", "", ["flag-hr"], 2, 11, 15, 0],
      "1f1ed-1f1f9": [["🇭🇹"], "", "", ["flag-ht"], 2, 12, 15, 0],
      "1f1ed-1f1fa": [["🇭🇺"], "", "", ["flag-hu"], 2, 13, 15, 0],
      "1f1ee-1f1e8": [["🇮🇨"], "", "", ["flag-ic"], 2, 14, 15, 0],
      "1f1ee-1f1e9": [["🇮🇩"], "", "", ["flag-id"], 2, 15, 15, 0],
      "1f1ee-1f1ea": [["🇮🇪"], "", "", ["flag-ie"], 2, 16, 15, 0],
      "1f1ee-1f1f1": [["🇮🇱"], "", "", ["flag-il"], 2, 17, 15, 0],
      "1f1ee-1f1f2": [["🇮🇲"], "", "", ["flag-im"], 2, 18, 15, 0],
      "1f1ee-1f1f3": [["🇮🇳"], "", "", ["flag-in"], 2, 19, 15, 0],
      "1f1ee-1f1f4": [["🇮🇴"], "", "", ["flag-io"], 2, 20, 15, 0],
      "1f1ee-1f1f6": [["🇮🇶"], "", "", ["flag-iq"], 2, 21, 15, 0],
      "1f1ee-1f1f7": [["🇮🇷"], "", "", ["flag-ir"], 2, 22, 15, 0],
      "1f1ee-1f1f8": [["🇮🇸"], "", "", ["flag-is"], 2, 23, 15, 0],
      "1f1ee-1f1f9": [["🇮🇹"], "", "󾓩", ["it", "flag-it"], 2, 24, 15, 0],
      "1f1ef-1f1ea": [["🇯🇪"], "", "", ["flag-je"], 2, 25, 15, 0],
      "1f1ef-1f1f2": [["🇯🇲"], "", "", ["flag-jm"], 2, 26, 15, 0],
      "1f1ef-1f1f4": [["🇯🇴"], "", "", ["flag-jo"], 2, 27, 15, 0],
      "1f1ef-1f1f5": [["🇯🇵"], "", "󾓥", ["jp", "flag-jp"], 2, 28, 15, 0],
      "1f1f0-1f1ea": [["🇰🇪"], "", "", ["flag-ke"], 2, 29, 15, 0],
      "1f1f0-1f1ec": [["🇰🇬"], "", "", ["flag-kg"], 2, 30, 15, 0],
      "1f1f0-1f1ed": [["🇰🇭"], "", "", ["flag-kh"], 2, 31, 15, 0],
      "1f1f0-1f1ee": [["🇰🇮"], "", "", ["flag-ki"], 2, 32, 15, 0],
      "1f1f0-1f1f2": [["🇰🇲"], "", "", ["flag-km"], 2, 33, 15, 0],
      "1f1f0-1f1f3": [["🇰🇳"], "", "", ["flag-kn"], 2, 34, 15, 0],
      "1f1f0-1f1f5": [["🇰🇵"], "", "", ["flag-kp"], 2, 35, 15, 0],
      "1f1f0-1f1f7": [["🇰🇷"], "", "󾓮", ["kr", "flag-kr"], 2, 36, 15, 0],
      "1f1f0-1f1fc": [["🇰🇼"], "", "", ["flag-kw"], 2, 37, 15, 0],
      "1f1f0-1f1fe": [["🇰🇾"], "", "", ["flag-ky"], 2, 38, 15, 0],
      "1f1f0-1f1ff": [["🇰🇿"], "", "", ["flag-kz"], 2, 39, 15, 0],
      "1f1f1-1f1e6": [["🇱🇦"], "", "", ["flag-la"], 2, 40, 15, 0],
      "1f1f1-1f1e7": [["🇱🇧"], "", "", ["flag-lb"], 2, 41, 15, 0],
      "1f1f1-1f1e8": [["🇱🇨"], "", "", ["flag-lc"], 2, 42, 15, 0],
      "1f1f1-1f1ee": [["🇱🇮"], "", "", ["flag-li"], 2, 43, 15, 0],
      "1f1f1-1f1f0": [["🇱🇰"], "", "", ["flag-lk"], 2, 44, 15, 0],
      "1f1f1-1f1f7": [["🇱🇷"], "", "", ["flag-lr"], 2, 45, 15, 0],
      "1f1f1-1f1f8": [["🇱🇸"], "", "", ["flag-ls"], 2, 46, 15, 0],
      "1f1f1-1f1f9": [["🇱🇹"], "", "", ["flag-lt"], 2, 47, 15, 0],
      "1f1f1-1f1fa": [["🇱🇺"], "", "", ["flag-lu"], 2, 48, 15, 0],
      "1f1f1-1f1fb": [["🇱🇻"], "", "", ["flag-lv"], 2, 49, 15, 0],
      "1f1f1-1f1fe": [["🇱🇾"], "", "", ["flag-ly"], 2, 50, 15, 0],
      "1f1f2-1f1e6": [["🇲🇦"], "", "", ["flag-ma"], 2, 51, 15, 0],
      "1f1f2-1f1e8": [["🇲🇨"], "", "", ["flag-mc"], 2, 52, 15, 0],
      "1f1f2-1f1e9": [["🇲🇩"], "", "", ["flag-md"], 2, 53, 15, 0],
      "1f1f2-1f1ea": [["🇲🇪"], "", "", ["flag-me"], 2, 54, 15, 0],
      "1f1f2-1f1eb": [["🇲🇫"], "", "", ["flag-mf"], 2, 55, 15, 0],
      "1f1f2-1f1ec": [["🇲🇬"], "", "", ["flag-mg"], 2, 56, 15, 0],
      "1f1f2-1f1ed": [["🇲🇭"], "", "", ["flag-mh"], 2, 57, 15, 0],
      "1f1f2-1f1f0": [["🇲🇰"], "", "", ["flag-mk"], 2, 58, 15, 0],
      "1f1f2-1f1f1": [["🇲🇱"], "", "", ["flag-ml"], 2, 59, 15, 0],
      "1f1f2-1f1f2": [["🇲🇲"], "", "", ["flag-mm"], 2, 60, 15, 0],
      "1f1f2-1f1f3": [["🇲🇳"], "", "", ["flag-mn"], 3, 0, 15, 0],
      "1f1f2-1f1f4": [["🇲🇴"], "", "", ["flag-mo"], 3, 1, 15, 0],
      "1f1f2-1f1f5": [["🇲🇵"], "", "", ["flag-mp"], 3, 2, 15, 0],
      "1f1f2-1f1f6": [["🇲🇶"], "", "", ["flag-mq"], 3, 3, 15, 0],
      "1f1f2-1f1f7": [["🇲🇷"], "", "", ["flag-mr"], 3, 4, 15, 0],
      "1f1f2-1f1f8": [["🇲🇸"], "", "", ["flag-ms"], 3, 5, 15, 0],
      "1f1f2-1f1f9": [["🇲🇹"], "", "", ["flag-mt"], 3, 6, 15, 0],
      "1f1f2-1f1fa": [["🇲🇺"], "", "", ["flag-mu"], 3, 7, 15, 0],
      "1f1f2-1f1fb": [["🇲🇻"], "", "", ["flag-mv"], 3, 8, 15, 0],
      "1f1f2-1f1fc": [["🇲🇼"], "", "", ["flag-mw"], 3, 9, 15, 0],
      "1f1f2-1f1fd": [["🇲🇽"], "", "", ["flag-mx"], 3, 10, 15, 0],
      "1f1f2-1f1fe": [["🇲🇾"], "", "", ["flag-my"], 3, 11, 15, 0],
      "1f1f2-1f1ff": [["🇲🇿"], "", "", ["flag-mz"], 3, 12, 15, 0],
      "1f1f3-1f1e6": [["🇳🇦"], "", "", ["flag-na"], 3, 13, 15, 0],
      "1f1f3-1f1e8": [["🇳🇨"], "", "", ["flag-nc"], 3, 14, 15, 0],
      "1f1f3-1f1ea": [["🇳🇪"], "", "", ["flag-ne"], 3, 15, 15, 0],
      "1f1f3-1f1eb": [["🇳🇫"], "", "", ["flag-nf"], 3, 16, 15, 0],
      "1f1f3-1f1ec": [["🇳🇬"], "", "", ["flag-ng"], 3, 17, 15, 0],
      "1f1f3-1f1ee": [["🇳🇮"], "", "", ["flag-ni"], 3, 18, 15, 0],
      "1f1f3-1f1f1": [["🇳🇱"], "", "", ["flag-nl"], 3, 19, 15, 0],
      "1f1f3-1f1f4": [["🇳🇴"], "", "", ["flag-no"], 3, 20, 15, 0],
      "1f1f3-1f1f5": [["🇳🇵"], "", "", ["flag-np"], 3, 21, 15, 0],
      "1f1f3-1f1f7": [["🇳🇷"], "", "", ["flag-nr"], 3, 22, 15, 0],
      "1f1f3-1f1fa": [["🇳🇺"], "", "", ["flag-nu"], 3, 23, 15, 0],
      "1f1f3-1f1ff": [["🇳🇿"], "", "", ["flag-nz"], 3, 24, 15, 0],
      "1f1f4-1f1f2": [["🇴🇲"], "", "", ["flag-om"], 3, 25, 15, 0],
      "1f1f5-1f1e6": [["🇵🇦"], "", "", ["flag-pa"], 3, 26, 15, 0],
      "1f1f5-1f1ea": [["🇵🇪"], "", "", ["flag-pe"], 3, 27, 15, 0],
      "1f1f5-1f1eb": [["🇵🇫"], "", "", ["flag-pf"], 3, 28, 15, 0],
      "1f1f5-1f1ec": [["🇵🇬"], "", "", ["flag-pg"], 3, 29, 15, 0],
      "1f1f5-1f1ed": [["🇵🇭"], "", "", ["flag-ph"], 3, 30, 15, 0],
      "1f1f5-1f1f0": [["🇵🇰"], "", "", ["flag-pk"], 3, 31, 15, 0],
      "1f1f5-1f1f1": [["🇵🇱"], "", "", ["flag-pl"], 3, 32, 15, 0],
      "1f1f5-1f1f2": [["🇵🇲"], "", "", ["flag-pm"], 3, 33, 15, 0],
      "1f1f5-1f1f3": [["🇵🇳"], "", "", ["flag-pn"], 3, 34, 15, 0],
      "1f1f5-1f1f7": [["🇵🇷"], "", "", ["flag-pr"], 3, 35, 15, 0],
      "1f1f5-1f1f8": [["🇵🇸"], "", "", ["flag-ps"], 3, 36, 15, 0],
      "1f1f5-1f1f9": [["🇵🇹"], "", "", ["flag-pt"], 3, 37, 15, 0],
      "1f1f5-1f1fc": [["🇵🇼"], "", "", ["flag-pw"], 3, 38, 15, 0],
      "1f1f5-1f1fe": [["🇵🇾"], "", "", ["flag-py"], 3, 39, 15, 0],
      "1f1f6-1f1e6": [["🇶🇦"], "", "", ["flag-qa"], 3, 40, 15, 0],
      "1f1f7-1f1ea": [["🇷🇪"], "", "", ["flag-re"], 3, 41, 15, 0],
      "1f1f7-1f1f4": [["🇷🇴"], "", "", ["flag-ro"], 3, 42, 15, 0],
      "1f1f7-1f1f8": [["🇷🇸"], "", "", ["flag-rs"], 3, 43, 15, 0],
      "1f1f7-1f1fa": [["🇷🇺"], "", "󾓬", ["ru", "flag-ru"], 3, 44, 15, 0],
      "1f1f7-1f1fc": [["🇷🇼"], "", "", ["flag-rw"], 3, 45, 15, 0],
      "1f1f8-1f1e6": [["🇸🇦"], "", "", ["flag-sa"], 3, 46, 15, 0],
      "1f1f8-1f1e7": [["🇸🇧"], "", "", ["flag-sb"], 3, 47, 15, 0],
      "1f1f8-1f1e8": [["🇸🇨"], "", "", ["flag-sc"], 3, 48, 15, 0],
      "1f1f8-1f1e9": [["🇸🇩"], "", "", ["flag-sd"], 3, 49, 15, 0],
      "1f1f8-1f1ea": [["🇸🇪"], "", "", ["flag-se"], 3, 50, 15, 0],
      "1f1f8-1f1ec": [["🇸🇬"], "", "", ["flag-sg"], 3, 51, 15, 0],
      "1f1f8-1f1ed": [["🇸🇭"], "", "", ["flag-sh"], 3, 52, 15, 0],
      "1f1f8-1f1ee": [["🇸🇮"], "", "", ["flag-si"], 3, 53, 15, 0],
      "1f1f8-1f1ef": [["🇸🇯"], "", "", ["flag-sj"], 3, 54, 15, 0],
      "1f1f8-1f1f0": [["🇸🇰"], "", "", ["flag-sk"], 3, 55, 15, 0],
      "1f1f8-1f1f1": [["🇸🇱"], "", "", ["flag-sl"], 3, 56, 15, 0],
      "1f1f8-1f1f2": [["🇸🇲"], "", "", ["flag-sm"], 3, 57, 15, 0],
      "1f1f8-1f1f3": [["🇸🇳"], "", "", ["flag-sn"], 3, 58, 15, 0],
      "1f1f8-1f1f4": [["🇸🇴"], "", "", ["flag-so"], 3, 59, 15, 0],
      "1f1f8-1f1f7": [["🇸🇷"], "", "", ["flag-sr"], 3, 60, 15, 0],
      "1f1f8-1f1f8": [["🇸🇸"], "", "", ["flag-ss"], 4, 0, 15, 0],
      "1f1f8-1f1f9": [["🇸🇹"], "", "", ["flag-st"], 4, 1, 15, 0],
      "1f1f8-1f1fb": [["🇸🇻"], "", "", ["flag-sv"], 4, 2, 15, 0],
      "1f1f8-1f1fd": [["🇸🇽"], "", "", ["flag-sx"], 4, 3, 15, 0],
      "1f1f8-1f1fe": [["🇸🇾"], "", "", ["flag-sy"], 4, 4, 15, 0],
      "1f1f8-1f1ff": [["🇸🇿"], "", "", ["flag-sz"], 4, 5, 15, 0],
      "1f1f9-1f1e6": [["🇹🇦"], "", "", ["flag-ta"], 4, 6, 15, 0],
      "1f1f9-1f1e8": [["🇹🇨"], "", "", ["flag-tc"], 4, 7, 15, 0],
      "1f1f9-1f1e9": [["🇹🇩"], "", "", ["flag-td"], 4, 8, 15, 0],
      "1f1f9-1f1eb": [["🇹🇫"], "", "", ["flag-tf"], 4, 9, 15, 0],
      "1f1f9-1f1ec": [["🇹🇬"], "", "", ["flag-tg"], 4, 10, 15, 0],
      "1f1f9-1f1ed": [["🇹🇭"], "", "", ["flag-th"], 4, 11, 15, 0],
      "1f1f9-1f1ef": [["🇹🇯"], "", "", ["flag-tj"], 4, 12, 15, 0],
      "1f1f9-1f1f0": [["🇹🇰"], "", "", ["flag-tk"], 4, 13, 15, 0],
      "1f1f9-1f1f1": [["🇹🇱"], "", "", ["flag-tl"], 4, 14, 15, 0],
      "1f1f9-1f1f2": [["🇹🇲"], "", "", ["flag-tm"], 4, 15, 15, 0],
      "1f1f9-1f1f3": [["🇹🇳"], "", "", ["flag-tn"], 4, 16, 15, 0],
      "1f1f9-1f1f4": [["🇹🇴"], "", "", ["flag-to"], 4, 17, 15, 0],
      "1f1f9-1f1f7": [["🇹🇷"], "", "", ["flag-tr"], 4, 18, 15, 0],
      "1f1f9-1f1f9": [["🇹🇹"], "", "", ["flag-tt"], 4, 19, 15, 0],
      "1f1f9-1f1fb": [["🇹🇻"], "", "", ["flag-tv"], 4, 20, 15, 0],
      "1f1f9-1f1fc": [["🇹🇼"], "", "", ["flag-tw"], 4, 21, 15, 0],
      "1f1f9-1f1ff": [["🇹🇿"], "", "", ["flag-tz"], 4, 22, 15, 0],
      "1f1fa-1f1e6": [["🇺🇦"], "", "", ["flag-ua"], 4, 23, 15, 0],
      "1f1fa-1f1ec": [["🇺🇬"], "", "", ["flag-ug"], 4, 24, 15, 0],
      "1f1fa-1f1f2": [["🇺🇲"], "", "", ["flag-um"], 4, 25, 15, 0],
      "1f1fa-1f1f3": [["🇺🇳"], "", "", ["flag-un"], 4, 26, 15, 0],
      "1f1fa-1f1f8": [["🇺🇸"], "", "󾓦", ["us", "flag-us"], 4, 27, 15, 0],
      "1f1fa-1f1fe": [["🇺🇾"], "", "", ["flag-uy"], 4, 28, 15, 0],
      "1f1fa-1f1ff": [["🇺🇿"], "", "", ["flag-uz"], 4, 29, 15, 0],
      "1f1fb-1f1e6": [["🇻🇦"], "", "", ["flag-va"], 4, 30, 15, 0],
      "1f1fb-1f1e8": [["🇻🇨"], "", "", ["flag-vc"], 4, 31, 15, 0],
      "1f1fb-1f1ea": [["🇻🇪"], "", "", ["flag-ve"], 4, 32, 15, 0],
      "1f1fb-1f1ec": [["🇻🇬"], "", "", ["flag-vg"], 4, 33, 15, 0],
      "1f1fb-1f1ee": [["🇻🇮"], "", "", ["flag-vi"], 4, 34, 15, 0],
      "1f1fb-1f1f3": [["🇻🇳"], "", "", ["flag-vn"], 4, 35, 15, 0],
      "1f1fb-1f1fa": [["🇻🇺"], "", "", ["flag-vu"], 4, 36, 15, 0],
      "1f1fc-1f1eb": [["🇼🇫"], "", "", ["flag-wf"], 4, 37, 15, 0],
      "1f1fc-1f1f8": [["🇼🇸"], "", "", ["flag-ws"], 4, 38, 15, 0],
      "1f1fd-1f1f0": [["🇽🇰"], "", "", ["flag-xk"], 4, 39, 15, 0],
      "1f1fe-1f1ea": [["🇾🇪"], "", "", ["flag-ye"], 4, 40, 15, 0],
      "1f1fe-1f1f9": [["🇾🇹"], "", "", ["flag-yt"], 4, 41, 15, 0],
      "1f1ff-1f1e6": [["🇿🇦"], "", "", ["flag-za"], 4, 42, 15, 0],
      "1f1ff-1f1f2": [["🇿🇲"], "", "", ["flag-zm"], 4, 43, 15, 0],
      "1f1ff-1f1fc": [["🇿🇼"], "", "", ["flag-zw"], 4, 44, 15, 0],
      "1f201": [["🈁"], "", "󾬤", ["koko"], 4, 45, 15, 0],
      "1f202-fe0f": [["🈂️", "🈂"], "", "󾬿", ["sa"], 4, 46, 15, 0],
      "1f21a": [["🈚"], "", "󾬺", ["u7121"], 4, 47, 15, 0],
      "1f22f": [["🈯"], "", "󾭀", ["u6307"], 4, 48, 15, 0],
      "1f232": [["🈲"], "", "󾬮", ["u7981"], 4, 49, 15, 0],
      "1f233": [["🈳"], "", "󾬯", ["u7a7a"], 4, 50, 15, 0],
      "1f234": [["🈴"], "", "󾬰", ["u5408"], 4, 51, 15, 0],
      "1f235": [["🈵"], "", "󾬱", ["u6e80"], 4, 52, 15, 0],
      "1f236": [["🈶"], "", "󾬹", ["u6709"], 4, 53, 15, 0],
      "1f237-fe0f": [["🈷️", "🈷"], "", "󾬻", ["u6708"], 4, 54, 15, 0],
      "1f238": [["🈸"], "", "󾬼", ["u7533"], 4, 55, 15, 0],
      "1f239": [["🈹"], "", "󾬾", ["u5272"], 4, 56, 15, 0],
      "1f23a": [["🈺"], "", "󾭁", ["u55b6"], 4, 57, 15, 0],
      "1f250": [["🉐"], "", "󾬽", ["ideograph_advantage"], 4, 58, 15, 0],
      "1f251": [["🉑"], "", "󾭐", ["accept"], 4, 59, 15, 0],
      "1f300": [["🌀"], "", "󾀅", ["cyclone"], 4, 60, 15, 0],
      "1f301": [["🌁"], "", "󾀆", ["foggy"], 5, 0, 15, 0],
      "1f302": [["🌂"], "", "󾀇", ["closed_umbrella"], 5, 1, 15, 0],
      "1f303": [["🌃"], "", "󾀈", ["night_with_stars"], 5, 2, 15, 0],
      "1f304": [["🌄"], "", "󾀉", ["sunrise_over_mountains"], 5, 3, 15, 0],
      "1f305": [["🌅"], "", "󾀊", ["sunrise"], 5, 4, 15, 0],
      "1f306": [["🌆"], "", "󾀋", ["city_sunset"], 5, 5, 15, 0],
      "1f307": [["🌇"], "", "󾀌", ["city_sunrise"], 5, 6, 15, 0],
      "1f308": [["🌈"], "", "󾀍", ["rainbow"], 5, 7, 15, 0],
      "1f309": [["🌉"], "", "󾀐", ["bridge_at_night"], 5, 8, 15, 0],
      "1f30a": [["🌊"], "", "󾀸", ["ocean"], 5, 9, 15, 0],
      "1f30b": [["🌋"], "", "󾀺", ["volcano"], 5, 10, 15, 0],
      "1f30c": [["🌌"], "", "󾀻", ["milky_way"], 5, 11, 15, 0],
      "1f30d": [["🌍"], "", "", ["earth_africa"], 5, 12, 15, 0],
      "1f30e": [["🌎"], "", "", ["earth_americas"], 5, 13, 15, 0],
      "1f30f": [["🌏"], "", "󾀹", ["earth_asia"], 5, 14, 15, 0],
      "1f310": [["🌐"], "", "", ["globe_with_meridians"], 5, 15, 15, 0],
      "1f311": [["🌑"], "", "󾀑", ["new_moon"], 5, 16, 15, 0],
      "1f312": [["🌒"], "", "", ["waxing_crescent_moon"], 5, 17, 15, 0],
      "1f313": [["🌓"], "", "󾀓", ["first_quarter_moon"], 5, 18, 15, 0],
      "1f314": [["🌔"], "", "󾀒", ["moon", "waxing_gibbous_moon"], 5, 19, 15, 0],
      "1f315": [["🌕"], "", "󾀕", ["full_moon"], 5, 20, 15, 0],
      "1f316": [["🌖"], "", "", ["waning_gibbous_moon"], 5, 21, 15, 0],
      "1f317": [["🌗"], "", "", ["last_quarter_moon"], 5, 22, 15, 0],
      "1f318": [["🌘"], "", "", ["waning_crescent_moon"], 5, 23, 15, 0],
      "1f319": [["🌙"], "", "󾀔", ["crescent_moon"], 5, 24, 15, 0],
      "1f31a": [["🌚"], "", "", ["new_moon_with_face"], 5, 25, 15, 0],
      "1f31b": [["🌛"], "", "󾀖", ["first_quarter_moon_with_face"], 5, 26, 15, 0],
      "1f31c": [["🌜"], "", "", ["last_quarter_moon_with_face"], 5, 27, 15, 0],
      "1f31d": [["🌝"], "", "", ["full_moon_with_face"], 5, 28, 15, 0],
      "1f31e": [["🌞"], "", "", ["sun_with_face"], 5, 29, 15, 0],
      "1f31f": [["🌟"], "", "󾭩", ["star2"], 5, 30, 15, 0],
      "1f320": [["🌠"], "", "󾭪", ["stars"], 5, 31, 15, 0],
      "1f321-fe0f": [["🌡️", "🌡"], "", "", ["thermometer"], 5, 32, 15, 0],
      "1f324-fe0f": [["🌤️", "🌤"], "", "", ["mostly_sunny", "sun_small_cloud"], 5, 33, 15, 0],
      "1f325-fe0f": [["🌥️", "🌥"], "", "", ["barely_sunny", "sun_behind_cloud"], 5, 34, 15, 0],
      "1f326-fe0f": [["🌦️", "🌦"], "", "", ["partly_sunny_rain", "sun_behind_rain_cloud"], 5, 35, 15, 0],
      "1f327-fe0f": [["🌧️", "🌧"], "", "", ["rain_cloud"], 5, 36, 15, 0],
      "1f328-fe0f": [["🌨️", "🌨"], "", "", ["snow_cloud"], 5, 37, 15, 0],
      "1f329-fe0f": [["🌩️", "🌩"], "", "", ["lightning", "lightning_cloud"], 5, 38, 15, 0],
      "1f32a-fe0f": [["🌪️", "🌪"], "", "", ["tornado", "tornado_cloud"], 5, 39, 15, 0],
      "1f32b-fe0f": [["🌫️", "🌫"], "", "", ["fog"], 5, 40, 15, 0],
      "1f32c-fe0f": [["🌬️", "🌬"], "", "", ["wind_blowing_face"], 5, 41, 15, 0],
      "1f32d": [["🌭"], "", "", ["hotdog"], 5, 42, 15, 0],
      "1f32e": [["🌮"], "", "", ["taco"], 5, 43, 15, 0],
      "1f32f": [["🌯"], "", "", ["burrito"], 5, 44, 15, 0],
      "1f330": [["🌰"], "", "󾁌", ["chestnut"], 5, 45, 15, 0],
      "1f331": [["🌱"], "", "󾀾", ["seedling"], 5, 46, 15, 0],
      "1f332": [["🌲"], "", "", ["evergreen_tree"], 5, 47, 15, 0],
      "1f333": [["🌳"], "", "", ["deciduous_tree"], 5, 48, 15, 0],
      "1f334": [["🌴"], "", "󾁇", ["palm_tree"], 5, 49, 15, 0],
      "1f335": [["🌵"], "", "󾁈", ["cactus"], 5, 50, 15, 0],
      "1f336-fe0f": [["🌶️", "🌶"], "", "", ["hot_pepper"], 5, 51, 15, 0],
      "1f337": [["🌷"], "", "󾀽", ["tulip"], 5, 52, 15, 0],
      "1f338": [["🌸"], "", "󾁀", ["cherry_blossom"], 5, 53, 15, 0],
      "1f339": [["🌹"], "", "󾁁", ["rose"], 5, 54, 15, 0],
      "1f33a": [["🌺"], "", "󾁅", ["hibiscus"], 5, 55, 15, 0],
      "1f33b": [["🌻"], "", "󾁆", ["sunflower"], 5, 56, 15, 0],
      "1f33c": [["🌼"], "", "󾁍", ["blossom"], 5, 57, 15, 0],
      "1f33d": [["🌽"], "", "󾁊", ["corn"], 5, 58, 15, 0],
      "1f33e": [["🌾"], "", "󾁉", ["ear_of_rice"], 5, 59, 15, 0],
      "1f33f": [["🌿"], "", "󾁎", ["herb"], 5, 60, 15, 0],
      "1f340": [["🍀"], "", "󾀼", ["four_leaf_clover"], 6, 0, 15, 0],
      "1f341": [["🍁"], "", "󾀿", ["maple_leaf"], 6, 1, 15, 0],
      "1f342": [["🍂"], "", "󾁂", ["fallen_leaf"], 6, 2, 15, 0],
      "1f343": [["🍃"], "", "󾁃", ["leaves"], 6, 3, 15, 0],
      "1f344": [["🍄"], "", "󾁋", ["mushroom"], 6, 4, 15, 0],
      "1f345": [["🍅"], "", "󾁕", ["tomato"], 6, 5, 15, 0],
      "1f346": [["🍆"], "", "󾁖", ["eggplant"], 6, 6, 15, 0],
      "1f347": [["🍇"], "", "󾁙", ["grapes"], 6, 7, 15, 0],
      "1f348": [["🍈"], "", "󾁗", ["melon"], 6, 8, 15, 0],
      "1f349": [["🍉"], "", "󾁔", ["watermelon"], 6, 9, 15, 0],
      "1f34a": [["🍊"], "", "󾁒", ["tangerine"], 6, 10, 15, 0],
      "1f34b": [["🍋"], "", "", ["lemon"], 6, 11, 15, 0],
      "1f34c": [["🍌"], "", "󾁐", ["banana"], 6, 12, 15, 0],
      "1f34d": [["🍍"], "", "󾁘", ["pineapple"], 6, 13, 15, 0],
      "1f34e": [["🍎"], "", "󾁑", ["apple"], 6, 14, 15, 0],
      "1f34f": [["🍏"], "", "󾁛", ["green_apple"], 6, 15, 15, 0],
      "1f350": [["🍐"], "", "", ["pear"], 6, 16, 15, 0],
      "1f351": [["🍑"], "", "󾁚", ["peach"], 6, 17, 15, 0],
      "1f352": [["🍒"], "", "󾁏", ["cherries"], 6, 18, 15, 0],
      "1f353": [["🍓"], "", "󾁓", ["strawberry"], 6, 19, 15, 0],
      "1f354": [["🍔"], "", "󾥠", ["hamburger"], 6, 20, 15, 0],
      "1f355": [["🍕"], "", "󾥵", ["pizza"], 6, 21, 15, 0],
      "1f356": [["🍖"], "", "󾥲", ["meat_on_bone"], 6, 22, 15, 0],
      "1f357": [["🍗"], "", "󾥶", ["poultry_leg"], 6, 23, 15, 0],
      "1f358": [["🍘"], "", "󾥩", ["rice_cracker"], 6, 24, 15, 0],
      "1f359": [["🍙"], "", "󾥡", ["rice_ball"], 6, 25, 15, 0],
      "1f35a": [["🍚"], "", "󾥪", ["rice"], 6, 26, 15, 0],
      "1f35b": [["🍛"], "", "󾥬", ["curry"], 6, 27, 15, 0],
      "1f35c": [["🍜"], "", "󾥣", ["ramen"], 6, 28, 15, 0],
      "1f35d": [["🍝"], "", "󾥫", ["spaghetti"], 6, 29, 15, 0],
      "1f35e": [["🍞"], "", "󾥤", ["bread"], 6, 30, 15, 0],
      "1f35f": [["🍟"], "", "󾥧", ["fries"], 6, 31, 15, 0],
      "1f360": [["🍠"], "", "󾥴", ["sweet_potato"], 6, 32, 15, 0],
      "1f361": [["🍡"], "", "󾥨", ["dango"], 6, 33, 15, 0],
      "1f362": [["🍢"], "", "󾥭", ["oden"], 6, 34, 15, 0],
      "1f363": [["🍣"], "", "󾥮", ["sushi"], 6, 35, 15, 0],
      "1f364": [["🍤"], "", "󾥿", ["fried_shrimp"], 6, 36, 15, 0],
      "1f365": [["🍥"], "", "󾥳", ["fish_cake"], 6, 37, 15, 0],
      "1f366": [["🍦"], "", "󾥦", ["icecream"], 6, 38, 15, 0],
      "1f367": [["🍧"], "", "󾥱", ["shaved_ice"], 6, 39, 15, 0],
      "1f368": [["🍨"], "", "󾥷", ["ice_cream"], 6, 40, 15, 0],
      "1f369": [["🍩"], "", "󾥸", ["doughnut"], 6, 41, 15, 0],
      "1f36a": [["🍪"], "", "󾥹", ["cookie"], 6, 42, 15, 0],
      "1f36b": [["🍫"], "", "󾥺", ["chocolate_bar"], 6, 43, 15, 0],
      "1f36c": [["🍬"], "", "󾥻", ["candy"], 6, 44, 15, 0],
      "1f36d": [["🍭"], "", "󾥼", ["lollipop"], 6, 45, 15, 0],
      "1f36e": [["🍮"], "", "󾥽", ["custard"], 6, 46, 15, 0],
      "1f36f": [["🍯"], "", "󾥾", ["honey_pot"], 6, 47, 15, 0],
      "1f370": [["🍰"], "", "󾥢", ["cake"], 6, 48, 15, 0],
      "1f371": [["🍱"], "", "󾥯", ["bento"], 6, 49, 15, 0],
      "1f372": [["🍲"], "", "󾥰", ["stew"], 6, 50, 15, 0],
      "1f373": [["🍳"], "", "󾥥", ["fried_egg", "cooking"], 6, 51, 15, 0],
      "1f374": [["🍴"], "", "󾦀", ["fork_and_knife"], 6, 52, 15, 0],
      "1f375": [["🍵"], "", "󾦄", ["tea"], 6, 53, 15, 0],
      "1f376": [["🍶"], "", "󾦅", ["sake"], 6, 54, 15, 0],
      "1f377": [["🍷"], "", "󾦆", ["wine_glass"], 6, 55, 15, 0],
      "1f378": [["🍸"], "", "󾦂", ["cocktail"], 6, 56, 15, 0],
      "1f379": [["🍹"], "", "󾦈", ["tropical_drink"], 6, 57, 15, 0],
      "1f37a": [["🍺"], "", "󾦃", ["beer"], 6, 58, 15, 0],
      "1f37b": [["🍻"], "", "󾦇", ["beers"], 6, 59, 15, 0],
      "1f37c": [["🍼"], "", "", ["baby_bottle"], 6, 60, 15, 0],
      "1f37d-fe0f": [["🍽️", "🍽"], "", "", ["knife_fork_plate"], 7, 0, 15, 0],
      "1f37e": [["🍾"], "", "", ["champagne"], 7, 1, 15, 0],
      "1f37f": [["🍿"], "", "", ["popcorn"], 7, 2, 15, 0],
      "1f380": [["🎀"], "", "󾔏", ["ribbon"], 7, 3, 15, 0],
      "1f381": [["🎁"], "", "󾔐", ["gift"], 7, 4, 15, 0],
      "1f382": [["🎂"], "", "󾔑", ["birthday"], 7, 5, 15, 0],
      "1f383": [["🎃"], "", "󾔟", ["jack_o_lantern"], 7, 6, 15, 0],
      "1f384": [["🎄"], "", "󾔒", ["christmas_tree"], 7, 7, 15, 0],
      "1f385": [["🎅"], "", "󾔓", ["santa"], 7, 8, 15, 0],
      "1f386": [["🎆"], "", "󾔕", ["fireworks"], 7, 14, 15, 0],
      "1f387": [["🎇"], "", "󾔝", ["sparkler"], 7, 15, 15, 0],
      "1f388": [["🎈"], "", "󾔖", ["balloon"], 7, 16, 15, 0],
      "1f389": [["🎉"], "", "󾔗", ["tada"], 7, 17, 15, 0],
      "1f38a": [["🎊"], "", "󾔠", ["confetti_ball"], 7, 18, 15, 0],
      "1f38b": [["🎋"], "", "󾔡", ["tanabata_tree"], 7, 19, 15, 0],
      "1f38c": [["🎌"], "", "󾔔", ["crossed_flags"], 7, 20, 15, 0],
      "1f38d": [["🎍"], "", "󾔘", ["bamboo"], 7, 21, 15, 0],
      "1f38e": [["🎎"], "", "󾔙", ["dolls"], 7, 22, 15, 0],
      "1f38f": [["🎏"], "", "󾔜", ["flags"], 7, 23, 15, 0],
      "1f390": [["🎐"], "", "󾔞", ["wind_chime"], 7, 24, 15, 0],
      "1f391": [["🎑"], "", "󾀗", ["rice_scene"], 7, 25, 15, 0],
      "1f392": [["🎒"], "", "󾔛", ["school_satchel"], 7, 26, 15, 0],
      "1f393": [["🎓"], "", "󾔚", ["mortar_board"], 7, 27, 15, 0],
      "1f396-fe0f": [["🎖️", "🎖"], "", "", ["medal"], 7, 28, 15, 0],
      "1f397-fe0f": [["🎗️", "🎗"], "", "", ["reminder_ribbon"], 7, 29, 15, 0],
      "1f399-fe0f": [["🎙️", "🎙"], "", "", ["studio_microphone"], 7, 30, 15, 0],
      "1f39a-fe0f": [["🎚️", "🎚"], "", "", ["level_slider"], 7, 31, 15, 0],
      "1f39b-fe0f": [["🎛️", "🎛"], "", "", ["control_knobs"], 7, 32, 15, 0],
      "1f39e-fe0f": [["🎞️", "🎞"], "", "", ["film_frames"], 7, 33, 15, 0],
      "1f39f-fe0f": [["🎟️", "🎟"], "", "", ["admission_tickets"], 7, 34, 15, 0],
      "1f3a0": [["🎠"], "", "󾟼", ["carousel_horse"], 7, 35, 15, 0],
      "1f3a1": [["🎡"], "", "󾟽", ["ferris_wheel"], 7, 36, 15, 0],
      "1f3a2": [["🎢"], "", "󾟾", ["roller_coaster"], 7, 37, 15, 0],
      "1f3a3": [["🎣"], "", "󾟿", ["fishing_pole_and_fish"], 7, 38, 15, 0],
      "1f3a4": [["🎤"], "", "󾠀", ["microphone"], 7, 39, 15, 0],
      "1f3a5": [["🎥"], "", "󾠁", ["movie_camera"], 7, 40, 15, 0],
      "1f3a6": [["🎦"], "", "󾠂", ["cinema"], 7, 41, 15, 0],
      "1f3a7": [["🎧"], "", "󾠃", ["headphones"], 7, 42, 15, 0],
      "1f3a8": [["🎨"], "", "󾠄", ["art"], 7, 43, 15, 0],
      "1f3a9": [["🎩"], "", "󾠅", ["tophat"], 7, 44, 15, 0],
      "1f3aa": [["🎪"], "", "󾠆", ["circus_tent"], 7, 45, 15, 0],
      "1f3ab": [["🎫"], "", "󾠇", ["ticket"], 7, 46, 15, 0],
      "1f3ac": [["🎬"], "", "󾠈", ["clapper"], 7, 47, 15, 0],
      "1f3ad": [["🎭"], "", "󾠉", ["performing_arts"], 7, 48, 15, 0],
      "1f3ae": [["🎮"], "", "󾠊", ["video_game"], 7, 49, 15, 0],
      "1f3af": [["🎯"], "", "󾠌", ["dart"], 7, 50, 15, 0],
      "1f3b0": [["🎰"], "", "󾠍", ["slot_machine"], 7, 51, 15, 0],
      "1f3b1": [["🎱"], "", "󾠎", ["8ball"], 7, 52, 15, 0],
      "1f3b2": [["🎲"], "", "󾠏", ["game_die"], 7, 53, 15, 0],
      "1f3b3": [["🎳"], "", "󾠐", ["bowling"], 7, 54, 15, 0],
      "1f3b4": [["🎴"], "", "󾠑", ["flower_playing_cards"], 7, 55, 15, 0],
      "1f3b5": [["🎵"], "", "󾠓", ["musical_note"], 7, 56, 15, 0],
      "1f3b6": [["🎶"], "", "󾠔", ["notes"], 7, 57, 15, 0],
      "1f3b7": [["🎷"], "", "󾠕", ["saxophone"], 7, 58, 15, 0],
      "1f3b8": [["🎸"], "", "󾠖", ["guitar"], 7, 59, 15, 0],
      "1f3b9": [["🎹"], "", "󾠗", ["musical_keyboard"], 7, 60, 15, 0],
      "1f3ba": [["🎺"], "", "󾠘", ["trumpet"], 8, 0, 15, 0],
      "1f3bb": [["🎻"], "", "󾠙", ["violin"], 8, 1, 15, 0],
      "1f3bc": [["🎼"], "", "󾠚", ["musical_score"], 8, 2, 15, 0],
      "1f3bd": [["🎽"], "", "󾟐", ["running_shirt_with_sash"], 8, 3, 15, 0],
      "1f3be": [["🎾"], "", "󾟓", ["tennis"], 8, 4, 15, 0],
      "1f3bf": [["🎿"], "", "󾟕", ["ski"], 8, 5, 15, 0],
      "1f3c0": [["🏀"], "", "󾟖", ["basketball"], 8, 6, 15, 0],
      "1f3c1": [["🏁"], "", "󾟗", ["checkered_flag"], 8, 7, 15, 0],
      "1f3c2": [["🏂"], "", "󾟘", ["snowboarder"], 8, 8, 15, 0],
      "1f3c3-200d-2640-fe0f": [["🏃‍♀️", "🏃‍♀"], "", "", ["woman-running"], 8, 14, 15, 0],
      "1f3c3-200d-2642-fe0f": [["🏃‍♂️", "🏃‍♂", "🏃"], "", "", ["man-running", "runner", "running"], 8, 20, 15, 0],
      "1f3c4-200d-2640-fe0f": [["🏄‍♀️", "🏄‍♀"], "", "", ["woman-surfing"], 8, 32, 15, 0],
      "1f3c4-200d-2642-fe0f": [["🏄‍♂️", "🏄‍♂", "🏄"], "", "", ["man-surfing", "surfer"], 8, 38, 15, 0],
      "1f3c5": [["🏅"], "", "", ["sports_medal"], 8, 50, 15, 0],
      "1f3c6": [["🏆"], "", "󾟛", ["trophy"], 8, 51, 15, 0],
      "1f3c7": [["🏇"], "", "", ["horse_racing"], 8, 52, 15, 0],
      "1f3c8": [["🏈"], "", "󾟝", ["football"], 8, 58, 15, 0],
      "1f3c9": [["🏉"], "", "", ["rugby_football"], 8, 59, 15, 0],
      "1f3ca-200d-2640-fe0f": [["🏊‍♀️", "🏊‍♀"], "", "", ["woman-swimming"], 8, 60, 15, 0],
      "1f3ca-200d-2642-fe0f": [["🏊‍♂️", "🏊‍♂", "🏊"], "", "", ["man-swimming", "swimmer"], 9, 5, 15, 0],
      "1f3cb-fe0f-200d-2640-fe0f": [["🏋️‍♀️"], "", "", ["woman-lifting-weights"], 9, 17, 7, 0],
      "1f3cb-fe0f-200d-2642-fe0f": [["🏋️‍♂️", "🏋️", "🏋"], "", "", ["man-lifting-weights", "weight_lifter"], 9, 23, 7, 0],
      "1f3cc-fe0f-200d-2640-fe0f": [["🏌️‍♀️"], "", "", ["woman-golfing"], 9, 35, 7, 0],
      "1f3cc-fe0f-200d-2642-fe0f": [["🏌️‍♂️", "🏌️", "🏌"], "", "", ["man-golfing", "golfer"], 9, 41, 7, 0],
      "1f3cd-fe0f": [["🏍️", "🏍"], "", "", ["racing_motorcycle"], 9, 53, 15, 0],
      "1f3ce-fe0f": [["🏎️", "🏎"], "", "", ["racing_car"], 9, 54, 15, 0],
      "1f3cf": [["🏏"], "", "", ["cricket_bat_and_ball"], 9, 55, 15, 0],
      "1f3d0": [["🏐"], "", "", ["volleyball"], 9, 56, 15, 0],
      "1f3d1": [["🏑"], "", "", ["field_hockey_stick_and_ball"], 9, 57, 15, 0],
      "1f3d2": [["🏒"], "", "", ["ice_hockey_stick_and_puck"], 9, 58, 15, 0],
      "1f3d3": [["🏓"], "", "", ["table_tennis_paddle_and_ball"], 9, 59, 15, 0],
      "1f3d4-fe0f": [["🏔️", "🏔"], "", "", ["snow_capped_mountain"], 9, 60, 15, 0],
      "1f3d5-fe0f": [["🏕️", "🏕"], "", "", ["camping"], 10, 0, 15, 0],
      "1f3d6-fe0f": [["🏖️", "🏖"], "", "", ["beach_with_umbrella"], 10, 1, 15, 0],
      "1f3d7-fe0f": [["🏗️", "🏗"], "", "", ["building_construction"], 10, 2, 15, 0],
      "1f3d8-fe0f": [["🏘️", "🏘"], "", "", ["house_buildings"], 10, 3, 15, 0],
      "1f3d9-fe0f": [["🏙️", "🏙"], "", "", ["cityscape"], 10, 4, 15, 0],
      "1f3da-fe0f": [["🏚️", "🏚"], "", "", ["derelict_house_building"], 10, 5, 15, 0],
      "1f3db-fe0f": [["🏛️", "🏛"], "", "", ["classical_building"], 10, 6, 15, 0],
      "1f3dc-fe0f": [["🏜️", "🏜"], "", "", ["desert"], 10, 7, 15, 0],
      "1f3dd-fe0f": [["🏝️", "🏝"], "", "", ["desert_island"], 10, 8, 15, 0],
      "1f3de-fe0f": [["🏞️", "🏞"], "", "", ["national_park"], 10, 9, 15, 0],
      "1f3df-fe0f": [["🏟️", "🏟"], "", "", ["stadium"], 10, 10, 15, 0],
      "1f3e0": [["🏠"], "", "󾒰", ["house"], 10, 11, 15, 0],
      "1f3e1": [["🏡"], "", "󾒱", ["house_with_garden"], 10, 12, 15, 0],
      "1f3e2": [["🏢"], "", "󾒲", ["office"], 10, 13, 15, 0],
      "1f3e3": [["🏣"], "", "󾒳", ["post_office"], 10, 14, 15, 0],
      "1f3e4": [["🏤"], "", "", ["european_post_office"], 10, 15, 15, 0],
      "1f3e5": [["🏥"], "", "󾒴", ["hospital"], 10, 16, 15, 0],
      "1f3e6": [["🏦"], "", "󾒵", ["bank"], 10, 17, 15, 0],
      "1f3e7": [["🏧"], "", "󾒶", ["atm"], 10, 18, 15, 0],
      "1f3e8": [["🏨"], "", "󾒷", ["hotel"], 10, 19, 15, 0],
      "1f3e9": [["🏩"], "", "󾒸", ["love_hotel"], 10, 20, 15, 0],
      "1f3ea": [["🏪"], "", "󾒹", ["convenience_store"], 10, 21, 15, 0],
      "1f3eb": [["🏫"], "", "󾒺", ["school"], 10, 22, 15, 0],
      "1f3ec": [["🏬"], "", "󾒽", ["department_store"], 10, 23, 15, 0],
      "1f3ed": [["🏭"], "", "󾓀", ["factory"], 10, 24, 15, 0],
      "1f3ee": [["🏮"], "", "󾓂", ["izakaya_lantern", "lantern"], 10, 25, 15, 0],
      "1f3ef": [["🏯"], "", "󾒾", ["japanese_castle"], 10, 26, 15, 0],
      "1f3f0": [["🏰"], "", "󾒿", ["european_castle"], 10, 27, 15, 0],
      "1f3f3-fe0f-200d-1f308": [["🏳️‍🌈", "🏳‍🌈"], "", "", ["rainbow-flag"], 10, 28, 15, 0],
      "1f3f3-fe0f-200d-26a7-fe0f": [["🏳️‍⚧️"], "", "", ["transgender_flag"], 10, 29, 7, 0],
      "1f3f3-fe0f": [["🏳️", "🏳"], "", "", ["waving_white_flag"], 10, 30, 15, 0],
      "1f3f4-200d-2620-fe0f": [["🏴‍☠️", "🏴‍☠"], "", "", ["pirate_flag"], 10, 31, 15, 0],
      "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f": [["🏴󠁧󠁢󠁥󠁮󠁧󠁿"], "", "", ["flag-england"], 10, 32, 15, 0],
      "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f": [["🏴󠁧󠁢󠁳󠁣󠁴󠁿"], "", "", ["flag-scotland"], 10, 33, 15, 0],
      "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f": [["🏴󠁧󠁢󠁷󠁬󠁳󠁿"], "", "", ["flag-wales"], 10, 34, 15, 0],
      "1f3f4": [["🏴"], "", "", ["waving_black_flag"], 10, 35, 15, 0],
      "1f3f5-fe0f": [["🏵️", "🏵"], "", "", ["rosette"], 10, 36, 15, 0],
      "1f3f7-fe0f": [["🏷️", "🏷"], "", "", ["label"], 10, 37, 15, 0],
      "1f3f8": [["🏸"], "", "", ["badminton_racquet_and_shuttlecock"], 10, 38, 15, 0],
      "1f3f9": [["🏹"], "", "", ["bow_and_arrow"], 10, 39, 15, 0],
      "1f3fa": [["🏺"], "", "", ["amphora"], 10, 40, 15, 0],
      "1f3fb": [["🏻"], "", "", ["skin-tone-2"], 10, 41, 15, 0],
      "1f3fc": [["🏼"], "", "", ["skin-tone-3"], 10, 42, 15, 0],
      "1f3fd": [["🏽"], "", "", ["skin-tone-4"], 10, 43, 15, 0],
      "1f3fe": [["🏾"], "", "", ["skin-tone-5"], 10, 44, 15, 0],
      "1f3ff": [["🏿"], "", "", ["skin-tone-6"], 10, 45, 15, 0],
      "1f400": [["🐀"], "", "", ["rat"], 10, 46, 15, 0],
      "1f401": [["🐁"], "", "", ["mouse2"], 10, 47, 15, 0],
      "1f402": [["🐂"], "", "", ["ox"], 10, 48, 15, 0],
      "1f403": [["🐃"], "", "", ["water_buffalo"], 10, 49, 15, 0],
      "1f404": [["🐄"], "", "", ["cow2"], 10, 50, 15, 0],
      "1f405": [["🐅"], "", "", ["tiger2"], 10, 51, 15, 0],
      "1f406": [["🐆"], "", "", ["leopard"], 10, 52, 15, 0],
      "1f407": [["🐇"], "", "", ["rabbit2"], 10, 53, 15, 0],
      "1f408-200d-2b1b": [["🐈‍⬛"], "", "", ["black_cat"], 10, 54, 15, 0],
      "1f408": [["🐈"], "", "", ["cat2"], 10, 55, 15, 0],
      "1f409": [["🐉"], "", "", ["dragon"], 10, 56, 15, 0],
      "1f40a": [["🐊"], "", "", ["crocodile"], 10, 57, 15, 0],
      "1f40b": [["🐋"], "", "", ["whale2"], 10, 58, 15, 0],
      "1f40c": [["🐌"], "", "󾆹", ["snail"], 10, 59, 15, 0],
      "1f40d": [["🐍"], "", "󾇓", ["snake"], 10, 60, 15, 0],
      "1f40e": [["🐎"], "", "󾟜", ["racehorse"], 11, 0, 15, 0],
      "1f40f": [["🐏"], "", "", ["ram"], 11, 1, 15, 0],
      "1f410": [["🐐"], "", "", ["goat"], 11, 2, 15, 0],
      "1f411": [["🐑"], "", "󾇏", ["sheep"], 11, 3, 15, 0],
      "1f412": [["🐒"], "", "󾇎", ["monkey"], 11, 4, 15, 0],
      "1f413": [["🐓"], "", "", ["rooster"], 11, 5, 15, 0],
      "1f414": [["🐔"], "", "󾇔", ["chicken"], 11, 6, 15, 0],
      "1f415-200d-1f9ba": [["🐕‍🦺"], "", "", ["service_dog"], 11, 7, 15, 0],
      "1f415": [["🐕"], "", "", ["dog2"], 11, 8, 15, 0],
      "1f416": [["🐖"], "", "", ["pig2"], 11, 9, 15, 0],
      "1f417": [["🐗"], "", "󾇕", ["boar"], 11, 10, 15, 0],
      "1f418": [["🐘"], "", "󾇌", ["elephant"], 11, 11, 15, 0],
      "1f419": [["🐙"], "", "󾇅", ["octopus"], 11, 12, 15, 0],
      "1f41a": [["🐚"], "", "󾇆", ["shell"], 11, 13, 15, 0],
      "1f41b": [["🐛"], "", "󾇋", ["bug"], 11, 14, 15, 0],
      "1f41c": [["🐜"], "", "󾇚", ["ant"], 11, 15, 15, 0],
      "1f41d": [["🐝"], "", "󾇡", ["bee", "honeybee"], 11, 16, 15, 0],
      "1f41e": [["🐞"], "", "󾇢", ["ladybug", "lady_beetle"], 11, 17, 15, 0],
      "1f41f": [["🐟"], "", "󾆽", ["fish"], 11, 18, 15, 0],
      "1f420": [["🐠"], "", "󾇉", ["tropical_fish"], 11, 19, 15, 0],
      "1f421": [["🐡"], "", "󾇙", ["blowfish"], 11, 20, 15, 0],
      "1f422": [["🐢"], "", "󾇜", ["turtle"], 11, 21, 15, 0],
      "1f423": [["🐣"], "", "󾇝", ["hatching_chick"], 11, 22, 15, 0],
      "1f424": [["🐤"], "", "󾆺", ["baby_chick"], 11, 23, 15, 0],
      "1f425": [["🐥"], "", "󾆻", ["hatched_chick"], 11, 24, 15, 0],
      "1f426-200d-2b1b": [["🐦‍⬛"], "", "", ["black_bird"], 11, 25, 3, 0],
      "1f426": [["🐦"], "", "󾇈", ["bird"], 11, 26, 15, 0],
      "1f427": [["🐧"], "", "󾆼", ["penguin"], 11, 27, 15, 0],
      "1f428": [["🐨"], "", "󾇍", ["koala"], 11, 28, 15, 0],
      "1f429": [["🐩"], "", "󾇘", ["poodle"], 11, 29, 15, 0],
      "1f42a": [["🐪"], "", "", ["dromedary_camel"], 11, 30, 15, 0],
      "1f42b": [["🐫"], "", "󾇖", ["camel"], 11, 31, 15, 0],
      "1f42c": [["🐬"], "", "󾇇", ["dolphin", "flipper"], 11, 32, 15, 0],
      "1f42d": [["🐭"], "", "󾇂", ["mouse"], 11, 33, 15, 0],
      "1f42e": [["🐮"], "", "󾇑", ["cow"], 11, 34, 15, 0],
      "1f42f": [["🐯"], "", "󾇀", ["tiger"], 11, 35, 15, 0],
      "1f430": [["🐰"], "", "󾇒", ["rabbit"], 11, 36, 15, 0],
      "1f431": [["🐱"], "", "󾆸", ["cat"], 11, 37, 15, 0],
      "1f432": [["🐲"], "", "󾇞", ["dragon_face"], 11, 38, 15, 0],
      "1f433": [["🐳"], "", "󾇃", ["whale"], 11, 39, 15, 0],
      "1f434": [["🐴"], "", "󾆾", ["horse"], 11, 40, 15, 0],
      "1f435": [["🐵"], "", "󾇄", ["monkey_face"], 11, 41, 15, 0],
      "1f436": [["🐶"], "", "󾆷", ["dog"], 11, 42, 15, 0],
      "1f437": [["🐷"], "", "󾆿", ["pig"], 11, 43, 15, 0],
      "1f438": [["🐸"], "", "󾇗", ["frog"], 11, 44, 15, 0],
      "1f439": [["🐹"], "", "󾇊", ["hamster"], 11, 45, 15, 0],
      "1f43a": [["🐺"], "", "󾇐", ["wolf"], 11, 46, 15, 0],
      "1f43b-200d-2744-fe0f": [["🐻‍❄️", "🐻‍❄"], "", "", ["polar_bear"], 11, 47, 15, 0],
      "1f43b": [["🐻"], "", "󾇁", ["bear"], 11, 48, 15, 0],
      "1f43c": [["🐼"], "", "󾇟", ["panda_face"], 11, 49, 15, 0],
      "1f43d": [["🐽"], "", "󾇠", ["pig_nose"], 11, 50, 15, 0],
      "1f43e": [["🐾"], "", "󾇛", ["feet", "paw_prints"], 11, 51, 15, 0],
      "1f43f-fe0f": [["🐿️", "🐿"], "", "", ["chipmunk"], 11, 52, 15, 0],
      "1f440": [["👀"], "", "󾆐", ["eyes"], 11, 53, 15, 0],
      "1f441-fe0f-200d-1f5e8-fe0f": [["👁️‍🗨️"], "", "", ["eye-in-speech-bubble"], 11, 54, 7, 0],
      "1f441-fe0f": [["👁️", "👁"], "", "", ["eye"], 11, 55, 15, 0],
      "1f442": [["👂"], "", "󾆑", ["ear"], 11, 56, 15, 0],
      "1f443": [["👃"], "", "󾆒", ["nose"], 12, 1, 15, 0],
      "1f444": [["👄"], "", "󾆓", ["lips"], 12, 7, 15, 0],
      "1f445": [["👅"], "", "󾆔", ["tongue"], 12, 8, 15, 0],
      "1f446": [["👆"], "", "󾮙", ["point_up_2"], 12, 9, 15, 0],
      "1f447": [["👇"], "", "󾮚", ["point_down"], 12, 15, 15, 0],
      "1f448": [["👈"], "", "󾮛", ["point_left"], 12, 21, 15, 0],
      "1f449": [["👉"], "", "󾮜", ["point_right"], 12, 27, 15, 0],
      "1f44a": [["👊"], "", "󾮖", ["facepunch", "punch"], 12, 33, 15, 0],
      "1f44b": [["👋"], "", "󾮝", ["wave"], 12, 39, 15, 0],
      "1f44c": [["👌"], "", "󾮟", ["ok_hand"], 12, 45, 15, 0],
      "1f44d": [["👍"], "", "󾮗", ["+1", "thumbsup"], 12, 51, 15, 0],
      "1f44e": [["👎"], "", "󾮠", ["-1", "thumbsdown"], 12, 57, 15, 0],
      "1f44f": [["👏"], "", "󾮞", ["clap"], 13, 2, 15, 0],
      "1f450": [["👐"], "", "󾮡", ["open_hands"], 13, 8, 15, 0],
      "1f451": [["👑"], "", "󾓑", ["crown"], 13, 14, 15, 0],
      "1f452": [["👒"], "", "󾓔", ["womans_hat"], 13, 15, 15, 0],
      "1f453": [["👓"], "", "󾓎", ["eyeglasses"], 13, 16, 15, 0],
      "1f454": [["👔"], "", "󾓓", ["necktie"], 13, 17, 15, 0],
      "1f455": [["👕"], "", "󾓏", ["shirt", "tshirt"], 13, 18, 15, 0],
      "1f456": [["👖"], "", "󾓐", ["jeans"], 13, 19, 15, 0],
      "1f457": [["👗"], "", "󾓕", ["dress"], 13, 20, 15, 0],
      "1f458": [["👘"], "", "󾓙", ["kimono"], 13, 21, 15, 0],
      "1f459": [["👙"], "", "󾓚", ["bikini"], 13, 22, 15, 0],
      "1f45a": [["👚"], "", "󾓛", ["womans_clothes"], 13, 23, 15, 0],
      "1f45b": [["👛"], "", "󾓜", ["purse"], 13, 24, 15, 0],
      "1f45c": [["👜"], "", "󾓰", ["handbag"], 13, 25, 15, 0],
      "1f45d": [["👝"], "", "󾓱", ["pouch"], 13, 26, 15, 0],
      "1f45e": [["👞"], "", "󾓌", ["mans_shoe", "shoe"], 13, 27, 15, 0],
      "1f45f": [["👟"], "", "󾓍", ["athletic_shoe"], 13, 28, 15, 0],
      "1f460": [["👠"], "", "󾓖", ["high_heel"], 13, 29, 15, 0],
      "1f461": [["👡"], "", "󾓗", ["sandal"], 13, 30, 15, 0],
      "1f462": [["👢"], "", "󾓘", ["boot"], 13, 31, 15, 0],
      "1f463": [["👣"], "", "󾕓", ["footprints"], 13, 32, 15, 0],
      "1f464": [["👤"], "", "󾆚", ["bust_in_silhouette"], 13, 33, 15, 0],
      "1f465": [["👥"], "", "", ["busts_in_silhouette"], 13, 34, 15, 0],
      "1f466": [["👦"], "", "󾆛", ["boy"], 13, 35, 15, 0],
      "1f467": [["👧"], "", "󾆜", ["girl"], 13, 41, 15, 0],
      "1f468-200d-1f33e": [["👨‍🌾"], "", "", ["male-farmer"], 13, 47, 15, 0],
      "1f468-200d-1f373": [["👨‍🍳"], "", "", ["male-cook"], 13, 53, 15, 0],
      "1f468-200d-1f37c": [["👨‍🍼"], "", "", ["man_feeding_baby"], 13, 59, 15, 0],
      "1f468-200d-1f393": [["👨‍🎓"], "", "", ["male-student"], 14, 4, 15, 0],
      "1f468-200d-1f3a4": [["👨‍🎤"], "", "", ["male-singer"], 14, 10, 15, 0],
      "1f468-200d-1f3a8": [["👨‍🎨"], "", "", ["male-artist"], 14, 16, 15, 0],
      "1f468-200d-1f3eb": [["👨‍🏫"], "", "", ["male-teacher"], 14, 22, 15, 0],
      "1f468-200d-1f3ed": [["👨‍🏭"], "", "", ["male-factory-worker"], 14, 28, 15, 0],
      "1f468-200d-1f466-200d-1f466": [["👨‍👦‍👦"], "", "", ["man-boy-boy"], 14, 34, 15, 0],
      "1f468-200d-1f466": [["👨‍👦"], "", "", ["man-boy"], 14, 35, 15, 0],
      "1f468-200d-1f467-200d-1f466": [["👨‍👧‍👦"], "", "", ["man-girl-boy"], 14, 36, 15, 0],
      "1f468-200d-1f467-200d-1f467": [["👨‍👧‍👧"], "", "", ["man-girl-girl"], 14, 37, 15, 0],
      "1f468-200d-1f467": [["👨‍👧"], "", "", ["man-girl"], 14, 38, 15, 0],
      "1f468-200d-1f468-200d-1f466": [["👨‍👨‍👦"], "", "", ["man-man-boy"], 14, 39, 15, 0],
      "1f468-200d-1f468-200d-1f466-200d-1f466": [["👨‍👨‍👦‍👦"], "", "", ["man-man-boy-boy"], 14, 40, 15, 0],
      "1f468-200d-1f468-200d-1f467": [["👨‍👨‍👧"], "", "", ["man-man-girl"], 14, 41, 15, 0],
      "1f468-200d-1f468-200d-1f467-200d-1f466": [["👨‍👨‍👧‍👦"], "", "", ["man-man-girl-boy"], 14, 42, 15, 0],
      "1f468-200d-1f468-200d-1f467-200d-1f467": [["👨‍👨‍👧‍👧"], "", "", ["man-man-girl-girl"], 14, 43, 15, 0],
      "1f468-200d-1f469-200d-1f466": [["👨‍👩‍👦", "👪"], "", "", ["man-woman-boy", "family"], 14, 44, 15, 0],
      "1f468-200d-1f469-200d-1f466-200d-1f466": [["👨‍👩‍👦‍👦"], "", "", ["man-woman-boy-boy"], 14, 45, 15, 0],
      "1f468-200d-1f469-200d-1f467": [["👨‍👩‍👧"], "", "", ["man-woman-girl"], 14, 46, 15, 0],
      "1f468-200d-1f469-200d-1f467-200d-1f466": [["👨‍👩‍👧‍👦"], "", "", ["man-woman-girl-boy"], 14, 47, 15, 0],
      "1f468-200d-1f469-200d-1f467-200d-1f467": [["👨‍👩‍👧‍👧"], "", "", ["man-woman-girl-girl"], 14, 48, 15, 0],
      "1f468-200d-1f4bb": [["👨‍💻"], "", "", ["male-technologist"], 14, 49, 15, 0],
      "1f468-200d-1f4bc": [["👨‍💼"], "", "", ["male-office-worker"], 14, 55, 15, 0],
      "1f468-200d-1f527": [["👨‍🔧"], "", "", ["male-mechanic"], 15, 0, 15, 0],
      "1f468-200d-1f52c": [["👨‍🔬"], "", "", ["male-scientist"], 15, 6, 15, 0],
      "1f468-200d-1f680": [["👨‍🚀"], "", "", ["male-astronaut"], 15, 12, 15, 0],
      "1f468-200d-1f692": [["👨‍🚒"], "", "", ["male-firefighter"], 15, 18, 15, 0],
      "1f468-200d-1f9af": [["👨‍🦯"], "", "", ["man_with_probing_cane"], 15, 24, 15, 0],
      "1f468-200d-1f9b0": [["👨‍🦰"], "", "", ["red_haired_man"], 15, 30, 15, 0],
      "1f468-200d-1f9b1": [["👨‍🦱"], "", "", ["curly_haired_man"], 15, 36, 15, 0],
      "1f468-200d-1f9b2": [["👨‍🦲"], "", "", ["bald_man"], 15, 42, 15, 0],
      "1f468-200d-1f9b3": [["👨‍🦳"], "", "", ["white_haired_man"], 15, 48, 15, 0],
      "1f468-200d-1f9bc": [["👨‍🦼"], "", "", ["man_in_motorized_wheelchair"], 15, 54, 15, 0],
      "1f468-200d-1f9bd": [["👨‍🦽"], "", "", ["man_in_manual_wheelchair"], 15, 60, 15, 0],
      "1f468-200d-2695-fe0f": [["👨‍⚕️", "👨‍⚕"], "", "", ["male-doctor"], 16, 5, 15, 0],
      "1f468-200d-2696-fe0f": [["👨‍⚖️", "👨‍⚖"], "", "", ["male-judge"], 16, 11, 15, 0],
      "1f468-200d-2708-fe0f": [["👨‍✈️", "👨‍✈"], "", "", ["male-pilot"], 16, 17, 15, 0],
      "1f468-200d-2764-fe0f-200d-1f468": [["👨‍❤️‍👨", "👨‍❤‍👨"], "", "", ["man-heart-man"], 16, 23, 15, 0],
      "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468": [["👨‍❤️‍💋‍👨", "👨‍❤‍💋‍👨"], "", "", ["man-kiss-man"], 16, 49, 15, 0],
      "1f468": [["👨"], "", "󾆝", ["man"], 17, 14, 15, 0],
      "1f469-200d-1f33e": [["👩‍🌾"], "", "", ["female-farmer"], 17, 20, 15, 0],
      "1f469-200d-1f373": [["👩‍🍳"], "", "", ["female-cook"], 17, 26, 15, 0],
      "1f469-200d-1f37c": [["👩‍🍼"], "", "", ["woman_feeding_baby"], 17, 32, 15, 0],
      "1f469-200d-1f393": [["👩‍🎓"], "", "", ["female-student"], 17, 38, 15, 0],
      "1f469-200d-1f3a4": [["👩‍🎤"], "", "", ["female-singer"], 17, 44, 15, 0],
      "1f469-200d-1f3a8": [["👩‍🎨"], "", "", ["female-artist"], 17, 50, 15, 0],
      "1f469-200d-1f3eb": [["👩‍🏫"], "", "", ["female-teacher"], 17, 56, 15, 0],
      "1f469-200d-1f3ed": [["👩‍🏭"], "", "", ["female-factory-worker"], 18, 1, 15, 0],
      "1f469-200d-1f466-200d-1f466": [["👩‍👦‍👦"], "", "", ["woman-boy-boy"], 18, 7, 15, 0],
      "1f469-200d-1f466": [["👩‍👦"], "", "", ["woman-boy"], 18, 8, 15, 0],
      "1f469-200d-1f467-200d-1f466": [["👩‍👧‍👦"], "", "", ["woman-girl-boy"], 18, 9, 15, 0],
      "1f469-200d-1f467-200d-1f467": [["👩‍👧‍👧"], "", "", ["woman-girl-girl"], 18, 10, 15, 0],
      "1f469-200d-1f467": [["👩‍👧"], "", "", ["woman-girl"], 18, 11, 15, 0],
      "1f469-200d-1f469-200d-1f466": [["👩‍👩‍👦"], "", "", ["woman-woman-boy"], 18, 12, 15, 0],
      "1f469-200d-1f469-200d-1f466-200d-1f466": [["👩‍👩‍👦‍👦"], "", "", ["woman-woman-boy-boy"], 18, 13, 15, 0],
      "1f469-200d-1f469-200d-1f467": [["👩‍👩‍👧"], "", "", ["woman-woman-girl"], 18, 14, 15, 0],
      "1f469-200d-1f469-200d-1f467-200d-1f466": [["👩‍👩‍👧‍👦"], "", "", ["woman-woman-girl-boy"], 18, 15, 15, 0],
      "1f469-200d-1f469-200d-1f467-200d-1f467": [["👩‍👩‍👧‍👧"], "", "", ["woman-woman-girl-girl"], 18, 16, 15, 0],
      "1f469-200d-1f4bb": [["👩‍💻"], "", "", ["female-technologist"], 18, 17, 15, 0],
      "1f469-200d-1f4bc": [["👩‍💼"], "", "", ["female-office-worker"], 18, 23, 15, 0],
      "1f469-200d-1f527": [["👩‍🔧"], "", "", ["female-mechanic"], 18, 29, 15, 0],
      "1f469-200d-1f52c": [["👩‍🔬"], "", "", ["female-scientist"], 18, 35, 15, 0],
      "1f469-200d-1f680": [["👩‍🚀"], "", "", ["female-astronaut"], 18, 41, 15, 0],
      "1f469-200d-1f692": [["👩‍🚒"], "", "", ["female-firefighter"], 18, 47, 15, 0],
      "1f469-200d-1f9af": [["👩‍🦯"], "", "", ["woman_with_probing_cane"], 18, 53, 15, 0],
      "1f469-200d-1f9b0": [["👩‍🦰"], "", "", ["red_haired_woman"], 18, 59, 15, 0],
      "1f469-200d-1f9b1": [["👩‍🦱"], "", "", ["curly_haired_woman"], 19, 4, 15, 0],
      "1f469-200d-1f9b2": [["👩‍🦲"], "", "", ["bald_woman"], 19, 10, 15, 0],
      "1f469-200d-1f9b3": [["👩‍🦳"], "", "", ["white_haired_woman"], 19, 16, 15, 0],
      "1f469-200d-1f9bc": [["👩‍🦼"], "", "", ["woman_in_motorized_wheelchair"], 19, 22, 15, 0],
      "1f469-200d-1f9bd": [["👩‍🦽"], "", "", ["woman_in_manual_wheelchair"], 19, 28, 15, 0],
      "1f469-200d-2695-fe0f": [["👩‍⚕️", "👩‍⚕"], "", "", ["female-doctor"], 19, 34, 15, 0],
      "1f469-200d-2696-fe0f": [["👩‍⚖️", "👩‍⚖"], "", "", ["female-judge"], 19, 40, 15, 0],
      "1f469-200d-2708-fe0f": [["👩‍✈️", "👩‍✈"], "", "", ["female-pilot"], 19, 46, 15, 0],
      "1f469-200d-2764-fe0f-200d-1f468": [["👩‍❤️‍👨", "👩‍❤‍👨"], "", "", ["woman-heart-man"], 19, 52, 15, 0],
      "1f469-200d-2764-fe0f-200d-1f469": [["👩‍❤️‍👩", "👩‍❤‍👩"], "", "", ["woman-heart-woman"], 20, 17, 15, 0],
      "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468": [["👩‍❤️‍💋‍👨", "👩‍❤‍💋‍👨"], "", "", ["woman-kiss-man"], 20, 43, 15, 0],
      "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469": [["👩‍❤️‍💋‍👩", "👩‍❤‍💋‍👩"], "", "", ["woman-kiss-woman"], 21, 8, 15, 0],
      "1f469": [["👩"], "", "󾆞", ["woman"], 21, 34, 15, 0],
      "1f46b": [["👫"], "", "󾆠", ["man_and_woman_holding_hands", "woman_and_man_holding_hands", "couple"], 21, 41, 15, 0],
      "1f46c": [["👬"], "", "", ["two_men_holding_hands", "men_holding_hands"], 22, 6, 15, 0],
      "1f46d": [["👭"], "", "", ["two_women_holding_hands", "women_holding_hands"], 22, 32, 15, 0],
      "1f46e-200d-2640-fe0f": [["👮‍♀️", "👮‍♀"], "", "", ["female-police-officer"], 22, 58, 15, 0],
      "1f46e-200d-2642-fe0f": [["👮‍♂️", "👮‍♂", "👮"], "", "", ["male-police-officer", "cop"], 23, 3, 15, 0],
      "1f46f-200d-2640-fe0f": [["👯‍♀️", "👯‍♀", "👯"], "", "", ["women-with-bunny-ears-partying", "woman-with-bunny-ears-partying", "dancers"], 23, 15, 15, 0],
      "1f46f-200d-2642-fe0f": [["👯‍♂️", "👯‍♂"], "", "", ["men-with-bunny-ears-partying", "man-with-bunny-ears-partying"], 23, 16, 15, 0],
      "1f470-200d-2640-fe0f": [["👰‍♀️", "👰‍♀"], "", "", ["woman_with_veil"], 23, 18, 15, 0],
      "1f470-200d-2642-fe0f": [["👰‍♂️", "👰‍♂"], "", "", ["man_with_veil"], 23, 24, 15, 0],
      "1f470": [["👰"], "", "󾆣", ["bride_with_veil"], 23, 30, 15, 0],
      "1f471-200d-2640-fe0f": [["👱‍♀️", "👱‍♀"], "", "", ["blond-haired-woman"], 23, 36, 15, 0],
      "1f471-200d-2642-fe0f": [["👱‍♂️", "👱‍♂", "👱"], "", "", ["blond-haired-man", "person_with_blond_hair"], 23, 42, 15, 0],
      "1f472": [["👲"], "", "󾆥", ["man_with_gua_pi_mao"], 23, 54, 15, 0],
      "1f473-200d-2640-fe0f": [["👳‍♀️", "👳‍♀"], "", "", ["woman-wearing-turban"], 23, 60, 15, 0],
      "1f473-200d-2642-fe0f": [["👳‍♂️", "👳‍♂", "👳"], "", "", ["man-wearing-turban", "man_with_turban"], 24, 5, 15, 0],
      "1f474": [["👴"], "", "󾆧", ["older_man"], 24, 17, 15, 0],
      "1f475": [["👵"], "", "󾆨", ["older_woman"], 24, 23, 15, 0],
      "1f476": [["👶"], "", "󾆩", ["baby"], 24, 29, 15, 0],
      "1f477-200d-2640-fe0f": [["👷‍♀️", "👷‍♀"], "", "", ["female-construction-worker"], 24, 35, 15, 0],
      "1f477-200d-2642-fe0f": [["👷‍♂️", "👷‍♂", "👷"], "", "", ["male-construction-worker", "construction_worker"], 24, 41, 15, 0],
      "1f478": [["👸"], "", "󾆫", ["princess"], 24, 53, 15, 0],
      "1f479": [["👹"], "", "󾆬", ["japanese_ogre"], 24, 59, 15, 0],
      "1f47a": [["👺"], "", "󾆭", ["japanese_goblin"], 24, 60, 15, 0],
      "1f47b": [["👻"], "", "󾆮", ["ghost"], 25, 0, 15, 0],
      "1f47c": [["👼"], "", "󾆯", ["angel"], 25, 1, 15, 0],
      "1f47d": [["👽"], "", "󾆰", ["alien"], 25, 7, 15, 0],
      "1f47e": [["👾"], "", "󾆱", ["space_invader"], 25, 8, 15, 0],
      "1f47f": [["👿"], "", "󾆲", ["imp"], 25, 9, 15, 0],
      "1f480": [["💀"], "", "󾆳", ["skull"], 25, 10, 15, 0],
      "1f481-200d-2640-fe0f": [["💁‍♀️", "💁‍♀", "💁"], "", "", ["woman-tipping-hand", "information_desk_person"], 25, 11, 15, 0],
      "1f481-200d-2642-fe0f": [["💁‍♂️", "💁‍♂"], "", "", ["man-tipping-hand"], 25, 17, 15, 0],
      "1f482-200d-2640-fe0f": [["💂‍♀️", "💂‍♀"], "", "", ["female-guard"], 25, 29, 15, 0],
      "1f482-200d-2642-fe0f": [["💂‍♂️", "💂‍♂", "💂"], "", "", ["male-guard", "guardsman"], 25, 35, 15, 0],
      "1f483": [["💃"], "", "󾆶", ["dancer"], 25, 47, 15, 0],
      "1f484": [["💄"], "", "󾆕", ["lipstick"], 25, 53, 15, 0],
      "1f485": [["💅"], "", "󾆖", ["nail_care"], 25, 54, 15, 0],
      "1f486-200d-2640-fe0f": [["💆‍♀️", "💆‍♀", "💆"], "", "", ["woman-getting-massage", "massage"], 25, 60, 15, 0],
      "1f486-200d-2642-fe0f": [["💆‍♂️", "💆‍♂"], "", "", ["man-getting-massage"], 26, 5, 15, 0],
      "1f487-200d-2640-fe0f": [["💇‍♀️", "💇‍♀", "💇"], "", "", ["woman-getting-haircut", "haircut"], 26, 17, 15, 0],
      "1f487-200d-2642-fe0f": [["💇‍♂️", "💇‍♂"], "", "", ["man-getting-haircut"], 26, 23, 15, 0],
      "1f488": [["💈"], "", "󾆙", ["barber"], 26, 35, 15, 0],
      "1f489": [["💉"], "", "󾔉", ["syringe"], 26, 36, 15, 0],
      "1f48a": [["💊"], "", "󾔊", ["pill"], 26, 37, 15, 0],
      "1f48b": [["💋"], "", "󾠣", ["kiss"], 26, 38, 15, 0],
      "1f48c": [["💌"], "", "󾠤", ["love_letter"], 26, 39, 15, 0],
      "1f48d": [["💍"], "", "󾠥", ["ring"], 26, 40, 15, 0],
      "1f48e": [["💎"], "", "󾠦", ["gem"], 26, 41, 15, 0],
      "1f48f": [["💏"], "", "󾠧", ["couplekiss"], 26, 42, 15, 0],
      "1f490": [["💐"], "", "󾠨", ["bouquet"], 27, 7, 15, 0],
      "1f491": [["💑"], "", "󾠩", ["couple_with_heart"], 27, 8, 15, 0],
      "1f492": [["💒"], "", "󾠪", ["wedding"], 27, 34, 15, 0],
      "1f493": [["💓"], "", "󾬍", ["heartbeat"], 27, 35, 15, 0],
      "1f494": [["💔"], "", "󾬎", ["broken_heart"], 27, 36, 15, 0, "</3"],
      "1f495": [["💕"], "", "󾬏", ["two_hearts"], 27, 37, 15, 0],
      "1f496": [["💖"], "", "󾬐", ["sparkling_heart"], 27, 38, 15, 0],
      "1f497": [["💗"], "", "󾬑", ["heartpulse"], 27, 39, 15, 0],
      "1f498": [["💘"], "", "󾬒", ["cupid"], 27, 40, 15, 0],
      "1f499": [["💙"], "", "󾬓", ["blue_heart"], 27, 41, 15, 0, "<3"],
      "1f49a": [["💚"], "", "󾬔", ["green_heart"], 27, 42, 15, 0, "<3"],
      "1f49b": [["💛"], "", "󾬕", ["yellow_heart"], 27, 43, 15, 0, "<3"],
      "1f49c": [["💜"], "", "󾬖", ["purple_heart"], 27, 44, 15, 0, "<3"],
      "1f49d": [["💝"], "", "󾬗", ["gift_heart"], 27, 45, 15, 0],
      "1f49e": [["💞"], "", "󾬘", ["revolving_hearts"], 27, 46, 15, 0],
      "1f49f": [["💟"], "", "󾬙", ["heart_decoration"], 27, 47, 15, 0],
      "1f4a0": [["💠"], "", "󾭕", ["diamond_shape_with_a_dot_inside"], 27, 48, 15, 0],
      "1f4a1": [["💡"], "", "󾭖", ["bulb"], 27, 49, 15, 0],
      "1f4a2": [["💢"], "", "󾭗", ["anger"], 27, 50, 15, 0],
      "1f4a3": [["💣"], "", "󾭘", ["bomb"], 27, 51, 15, 0],
      "1f4a4": [["💤"], "", "󾭙", ["zzz"], 27, 52, 15, 0],
      "1f4a5": [["💥"], "", "󾭚", ["boom", "collision"], 27, 53, 15, 0],
      "1f4a6": [["💦"], "", "󾭛", ["sweat_drops"], 27, 54, 15, 0],
      "1f4a7": [["💧"], "", "󾭜", ["droplet"], 27, 55, 15, 0],
      "1f4a8": [["💨"], "", "󾭝", ["dash"], 27, 56, 15, 0],
      "1f4a9": [["💩"], "", "󾓴", ["hankey", "poop", "shit"], 27, 57, 15, 0],
      "1f4aa": [["💪"], "", "󾭞", ["muscle"], 27, 58, 15, 0],
      "1f4ab": [["💫"], "", "󾭟", ["dizzy"], 28, 3, 15, 0],
      "1f4ac": [["💬"], "", "󾔲", ["speech_balloon"], 28, 4, 15, 0],
      "1f4ad": [["💭"], "", "", ["thought_balloon"], 28, 5, 15, 0],
      "1f4ae": [["💮"], "", "󾭺", ["white_flower"], 28, 6, 15, 0],
      "1f4af": [["💯"], "", "󾭻", ["100"], 28, 7, 15, 0],
      "1f4b0": [["💰"], "", "󾓝", ["moneybag"], 28, 8, 15, 0],
      "1f4b1": [["💱"], "", "󾓞", ["currency_exchange"], 28, 9, 15, 0],
      "1f4b2": [["💲"], "", "󾓠", ["heavy_dollar_sign"], 28, 10, 15, 0],
      "1f4b3": [["💳"], "", "󾓡", ["credit_card"], 28, 11, 15, 0],
      "1f4b4": [["💴"], "", "󾓢", ["yen"], 28, 12, 15, 0],
      "1f4b5": [["💵"], "", "󾓣", ["dollar"], 28, 13, 15, 0],
      "1f4b6": [["💶"], "", "", ["euro"], 28, 14, 15, 0],
      "1f4b7": [["💷"], "", "", ["pound"], 28, 15, 15, 0],
      "1f4b8": [["💸"], "", "󾓤", ["money_with_wings"], 28, 16, 15, 0],
      "1f4b9": [["💹"], "", "󾓟", ["chart"], 28, 17, 15, 0],
      "1f4ba": [["💺"], "", "󾔷", ["seat"], 28, 18, 15, 0],
      "1f4bb": [["💻"], "", "󾔸", ["computer"], 28, 19, 15, 0],
      "1f4bc": [["💼"], "", "󾔻", ["briefcase"], 28, 20, 15, 0],
      "1f4bd": [["💽"], "", "󾔼", ["minidisc"], 28, 21, 15, 0],
      "1f4be": [["💾"], "", "󾔽", ["floppy_disk"], 28, 22, 15, 0],
      "1f4bf": [["💿"], "", "󾠝", ["cd"], 28, 23, 15, 0],
      "1f4c0": [["📀"], "", "󾠞", ["dvd"], 28, 24, 15, 0],
      "1f4c1": [["📁"], "", "󾕃", ["file_folder"], 28, 25, 15, 0],
      "1f4c2": [["📂"], "", "󾕄", ["open_file_folder"], 28, 26, 15, 0],
      "1f4c3": [["📃"], "", "󾕀", ["page_with_curl"], 28, 27, 15, 0],
      "1f4c4": [["📄"], "", "󾕁", ["page_facing_up"], 28, 28, 15, 0],
      "1f4c5": [["📅"], "", "󾕂", ["date"], 28, 29, 15, 0],
      "1f4c6": [["📆"], "", "󾕉", ["calendar"], 28, 30, 15, 0],
      "1f4c7": [["📇"], "", "󾕍", ["card_index"], 28, 31, 15, 0],
      "1f4c8": [["📈"], "", "󾕋", ["chart_with_upwards_trend"], 28, 32, 15, 0],
      "1f4c9": [["📉"], "", "󾕌", ["chart_with_downwards_trend"], 28, 33, 15, 0],
      "1f4ca": [["📊"], "", "󾕊", ["bar_chart"], 28, 34, 15, 0],
      "1f4cb": [["📋"], "", "󾕈", ["clipboard"], 28, 35, 15, 0],
      "1f4cc": [["📌"], "", "󾕎", ["pushpin"], 28, 36, 15, 0],
      "1f4cd": [["📍"], "", "󾔿", ["round_pushpin"], 28, 37, 15, 0],
      "1f4ce": [["📎"], "", "󾔺", ["paperclip"], 28, 38, 15, 0],
      "1f4cf": [["📏"], "", "󾕐", ["straight_ruler"], 28, 39, 15, 0],
      "1f4d0": [["📐"], "", "󾕑", ["triangular_ruler"], 28, 40, 15, 0],
      "1f4d1": [["📑"], "", "󾕒", ["bookmark_tabs"], 28, 41, 15, 0],
      "1f4d2": [["📒"], "", "󾕏", ["ledger"], 28, 42, 15, 0],
      "1f4d3": [["📓"], "", "󾕅", ["notebook"], 28, 43, 15, 0],
      "1f4d4": [["📔"], "", "󾕇", ["notebook_with_decorative_cover"], 28, 44, 15, 0],
      "1f4d5": [["📕"], "", "󾔂", ["closed_book"], 28, 45, 15, 0],
      "1f4d6": [["📖"], "", "󾕆", ["book", "open_book"], 28, 46, 15, 0],
      "1f4d7": [["📗"], "", "󾓿", ["green_book"], 28, 47, 15, 0],
      "1f4d8": [["📘"], "", "󾔀", ["blue_book"], 28, 48, 15, 0],
      "1f4d9": [["📙"], "", "󾔁", ["orange_book"], 28, 49, 15, 0],
      "1f4da": [["📚"], "", "󾔃", ["books"], 28, 50, 15, 0],
      "1f4db": [["📛"], "", "󾔄", ["name_badge"], 28, 51, 15, 0],
      "1f4dc": [["📜"], "", "󾓽", ["scroll"], 28, 52, 15, 0],
      "1f4dd": [["📝"], "", "󾔧", ["memo", "pencil"], 28, 53, 15, 0],
      "1f4de": [["📞"], "", "󾔤", ["telephone_receiver"], 28, 54, 15, 0],
      "1f4df": [["📟"], "", "󾔢", ["pager"], 28, 55, 15, 0],
      "1f4e0": [["📠"], "", "󾔨", ["fax"], 28, 56, 15, 0],
      "1f4e1": [["📡"], "", "󾔱", ["satellite_antenna"], 28, 57, 15, 0],
      "1f4e2": [["📢"], "", "󾔯", ["loudspeaker"], 28, 58, 15, 0],
      "1f4e3": [["📣"], "", "󾔰", ["mega"], 28, 59, 15, 0],
      "1f4e4": [["📤"], "", "󾔳", ["outbox_tray"], 28, 60, 15, 0],
      "1f4e5": [["📥"], "", "󾔴", ["inbox_tray"], 29, 0, 15, 0],
      "1f4e6": [["📦"], "", "󾔵", ["package"], 29, 1, 15, 0],
      "1f4e7": [["📧"], "", "󾮒", ["e-mail"], 29, 2, 15, 0],
      "1f4e8": [["📨"], "", "󾔪", ["incoming_envelope"], 29, 3, 15, 0],
      "1f4e9": [["📩"], "", "󾔫", ["envelope_with_arrow"], 29, 4, 15, 0],
      "1f4ea": [["📪"], "", "󾔬", ["mailbox_closed"], 29, 5, 15, 0],
      "1f4eb": [["📫"], "", "󾔭", ["mailbox"], 29, 6, 15, 0],
      "1f4ec": [["📬"], "", "", ["mailbox_with_mail"], 29, 7, 15, 0],
      "1f4ed": [["📭"], "", "", ["mailbox_with_no_mail"], 29, 8, 15, 0],
      "1f4ee": [["📮"], "", "󾔮", ["postbox"], 29, 9, 15, 0],
      "1f4ef": [["📯"], "", "", ["postal_horn"], 29, 10, 15, 0],
      "1f4f0": [["📰"], "", "󾠢", ["newspaper"], 29, 11, 15, 0],
      "1f4f1": [["📱"], "", "󾔥", ["iphone"], 29, 12, 15, 0],
      "1f4f2": [["📲"], "", "󾔦", ["calling"], 29, 13, 15, 0],
      "1f4f3": [["📳"], "", "󾠹", ["vibration_mode"], 29, 14, 15, 0],
      "1f4f4": [["📴"], "", "󾠺", ["mobile_phone_off"], 29, 15, 15, 0],
      "1f4f5": [["📵"], "", "", ["no_mobile_phones"], 29, 16, 15, 0],
      "1f4f6": [["📶"], "", "󾠸", ["signal_strength"], 29, 17, 15, 0],
      "1f4f7": [["📷"], "", "󾓯", ["camera"], 29, 18, 15, 0],
      "1f4f8": [["📸"], "", "", ["camera_with_flash"], 29, 19, 15, 0],
      "1f4f9": [["📹"], "", "󾓹", ["video_camera"], 29, 20, 15, 0],
      "1f4fa": [["📺"], "", "󾠜", ["tv"], 29, 21, 15, 0],
      "1f4fb": [["📻"], "", "󾠟", ["radio"], 29, 22, 15, 0],
      "1f4fc": [["📼"], "", "󾠠", ["vhs"], 29, 23, 15, 0],
      "1f4fd-fe0f": [["📽️", "📽"], "", "", ["film_projector"], 29, 24, 15, 0],
      "1f4ff": [["📿"], "", "", ["prayer_beads"], 29, 25, 15, 0],
      "1f500": [["🔀"], "", "", ["twisted_rightwards_arrows"], 29, 26, 15, 0],
      "1f501": [["🔁"], "", "", ["repeat"], 29, 27, 15, 0],
      "1f502": [["🔂"], "", "", ["repeat_one"], 29, 28, 15, 0],
      "1f503": [["🔃"], "", "󾮑", ["arrows_clockwise"], 29, 29, 15, 0],
      "1f504": [["🔄"], "", "", ["arrows_counterclockwise"], 29, 30, 15, 0],
      "1f505": [["🔅"], "", "", ["low_brightness"], 29, 31, 15, 0],
      "1f506": [["🔆"], "", "", ["high_brightness"], 29, 32, 15, 0],
      "1f507": [["🔇"], "", "", ["mute"], 29, 33, 15, 0],
      "1f508": [["🔈"], "", "", ["speaker"], 29, 34, 15, 0],
      "1f509": [["🔉"], "", "", ["sound"], 29, 35, 15, 0],
      "1f50a": [["🔊"], "", "󾠡", ["loud_sound"], 29, 36, 15, 0],
      "1f50b": [["🔋"], "", "󾓼", ["battery"], 29, 37, 15, 0],
      "1f50c": [["🔌"], "", "󾓾", ["electric_plug"], 29, 38, 15, 0],
      "1f50d": [["🔍"], "", "󾮅", ["mag"], 29, 39, 15, 0],
      "1f50e": [["🔎"], "", "󾮍", ["mag_right"], 29, 40, 15, 0],
      "1f50f": [["🔏"], "", "󾮐", ["lock_with_ink_pen"], 29, 41, 15, 0],
      "1f510": [["🔐"], "", "󾮊", ["closed_lock_with_key"], 29, 42, 15, 0],
      "1f511": [["🔑"], "", "󾮂", ["key"], 29, 43, 15, 0],
      "1f512": [["🔒"], "", "󾮆", ["lock"], 29, 44, 15, 0],
      "1f513": [["🔓"], "", "󾮇", ["unlock"], 29, 45, 15, 0],
      "1f514": [["🔔"], "", "󾓲", ["bell"], 29, 46, 15, 0],
      "1f515": [["🔕"], "", "", ["no_bell"], 29, 47, 15, 0],
      "1f516": [["🔖"], "", "󾮏", ["bookmark"], 29, 48, 15, 0],
      "1f517": [["🔗"], "", "󾭋", ["link"], 29, 49, 15, 0],
      "1f518": [["🔘"], "", "󾮌", ["radio_button"], 29, 50, 15, 0],
      "1f519": [["🔙"], "", "󾮎", ["back"], 29, 51, 15, 0],
      "1f51a": [["🔚"], "", "󾀚", ["end"], 29, 52, 15, 0],
      "1f51b": [["🔛"], "", "󾀙", ["on"], 29, 53, 15, 0],
      "1f51c": [["🔜"], "", "󾀘", ["soon"], 29, 54, 15, 0],
      "1f51d": [["🔝"], "", "󾭂", ["top"], 29, 55, 15, 0],
      "1f51e": [["🔞"], "", "󾬥", ["underage"], 29, 56, 15, 0],
      "1f51f": [["🔟"], "", "󾠻", ["keycap_ten"], 29, 57, 15, 0],
      "1f520": [["🔠"], "", "󾭼", ["capital_abcd"], 29, 58, 15, 0],
      "1f521": [["🔡"], "", "󾭽", ["abcd"], 29, 59, 15, 0],
      "1f522": [["🔢"], "", "󾭾", ["1234"], 29, 60, 15, 0],
      "1f523": [["🔣"], "", "󾭿", ["symbols"], 30, 0, 15, 0],
      "1f524": [["🔤"], "", "󾮀", ["abc"], 30, 1, 15, 0],
      "1f525": [["🔥"], "", "󾓶", ["fire"], 30, 2, 15, 0],
      "1f526": [["🔦"], "", "󾓻", ["flashlight"], 30, 3, 15, 0],
      "1f527": [["🔧"], "", "󾓉", ["wrench"], 30, 4, 15, 0],
      "1f528": [["🔨"], "", "󾓊", ["hammer"], 30, 5, 15, 0],
      "1f529": [["🔩"], "", "󾓋", ["nut_and_bolt"], 30, 6, 15, 0],
      "1f52a": [["🔪"], "", "󾓺", ["hocho", "knife"], 30, 7, 15, 0],
      "1f52b": [["🔫"], "", "󾓵", ["gun"], 30, 8, 15, 0],
      "1f52c": [["🔬"], "", "", ["microscope"], 30, 9, 15, 0],
      "1f52d": [["🔭"], "", "", ["telescope"], 30, 10, 15, 0],
      "1f52e": [["🔮"], "", "󾓷", ["crystal_ball"], 30, 11, 15, 0],
      "1f52f": [["🔯"], "", "󾓸", ["six_pointed_star"], 30, 12, 15, 0],
      "1f530": [["🔰"], "", "󾁄", ["beginner"], 30, 13, 15, 0],
      "1f531": [["🔱"], "", "󾓒", ["trident"], 30, 14, 15, 0],
      "1f532": [["🔲"], "", "󾭤", ["black_square_button"], 30, 15, 15, 0],
      "1f533": [["🔳"], "", "󾭧", ["white_square_button"], 30, 16, 15, 0],
      "1f534": [["🔴"], "", "󾭣", ["red_circle"], 30, 17, 15, 0],
      "1f535": [["🔵"], "", "󾭤", ["large_blue_circle"], 30, 18, 15, 0],
      "1f536": [["🔶"], "", "󾭳", ["large_orange_diamond"], 30, 19, 15, 0],
      "1f537": [["🔷"], "", "󾭴", ["large_blue_diamond"], 30, 20, 15, 0],
      "1f538": [["🔸"], "", "󾭵", ["small_orange_diamond"], 30, 21, 15, 0],
      "1f539": [["🔹"], "", "󾭶", ["small_blue_diamond"], 30, 22, 15, 0],
      "1f53a": [["🔺"], "", "󾭸", ["small_red_triangle"], 30, 23, 15, 0],
      "1f53b": [["🔻"], "", "󾭹", ["small_red_triangle_down"], 30, 24, 15, 0],
      "1f53c": [["🔼"], "", "󾬁", ["arrow_up_small"], 30, 25, 15, 0],
      "1f53d": [["🔽"], "", "󾬀", ["arrow_down_small"], 30, 26, 15, 0],
      "1f549-fe0f": [["🕉️", "🕉"], "", "", ["om_symbol"], 30, 27, 15, 0],
      "1f54a-fe0f": [["🕊️", "🕊"], "", "", ["dove_of_peace"], 30, 28, 15, 0],
      "1f54b": [["🕋"], "", "", ["kaaba"], 30, 29, 15, 0],
      "1f54c": [["🕌"], "", "", ["mosque"], 30, 30, 15, 0],
      "1f54d": [["🕍"], "", "", ["synagogue"], 30, 31, 15, 0],
      "1f54e": [["🕎"], "", "", ["menorah_with_nine_branches"], 30, 32, 15, 0],
      "1f550": [["🕐"], "", "󾀞", ["clock1"], 30, 33, 15, 0],
      "1f551": [["🕑"], "", "󾀟", ["clock2"], 30, 34, 15, 0],
      "1f552": [["🕒"], "", "󾀠", ["clock3"], 30, 35, 15, 0],
      "1f553": [["🕓"], "", "󾀡", ["clock4"], 30, 36, 15, 0],
      "1f554": [["🕔"], "", "󾀢", ["clock5"], 30, 37, 15, 0],
      "1f555": [["🕕"], "", "󾀣", ["clock6"], 30, 38, 15, 0],
      "1f556": [["🕖"], "", "󾀤", ["clock7"], 30, 39, 15, 0],
      "1f557": [["🕗"], "", "󾀥", ["clock8"], 30, 40, 15, 0],
      "1f558": [["🕘"], "", "󾀦", ["clock9"], 30, 41, 15, 0],
      "1f559": [["🕙"], "", "󾀧", ["clock10"], 30, 42, 15, 0],
      "1f55a": [["🕚"], "", "󾀨", ["clock11"], 30, 43, 15, 0],
      "1f55b": [["🕛"], "", "󾀩", ["clock12"], 30, 44, 15, 0],
      "1f55c": [["🕜"], "", "", ["clock130"], 30, 45, 15, 0],
      "1f55d": [["🕝"], "", "", ["clock230"], 30, 46, 15, 0],
      "1f55e": [["🕞"], "", "", ["clock330"], 30, 47, 15, 0],
      "1f55f": [["🕟"], "", "", ["clock430"], 30, 48, 15, 0],
      "1f560": [["🕠"], "", "", ["clock530"], 30, 49, 15, 0],
      "1f561": [["🕡"], "", "", ["clock630"], 30, 50, 15, 0],
      "1f562": [["🕢"], "", "", ["clock730"], 30, 51, 15, 0],
      "1f563": [["🕣"], "", "", ["clock830"], 30, 52, 15, 0],
      "1f564": [["🕤"], "", "", ["clock930"], 30, 53, 15, 0],
      "1f565": [["🕥"], "", "", ["clock1030"], 30, 54, 15, 0],
      "1f566": [["🕦"], "", "", ["clock1130"], 30, 55, 15, 0],
      "1f567": [["🕧"], "", "", ["clock1230"], 30, 56, 15, 0],
      "1f56f-fe0f": [["🕯️", "🕯"], "", "", ["candle"], 30, 57, 15, 0],
      "1f570-fe0f": [["🕰️", "🕰"], "", "", ["mantelpiece_clock"], 30, 58, 15, 0],
      "1f573-fe0f": [["🕳️", "🕳"], "", "", ["hole"], 30, 59, 15, 0],
      "1f574-fe0f": [["🕴️", "🕴"], "", "", ["man_in_business_suit_levitating"], 30, 60, 15, 0],
      "1f575-fe0f-200d-2640-fe0f": [["🕵️‍♀️"], "", "", ["female-detective"], 31, 5, 7, 0],
      "1f575-fe0f-200d-2642-fe0f": [["🕵️‍♂️", "🕵️", "🕵"], "", "", ["male-detective", "sleuth_or_spy"], 31, 11, 7, 0],
      "1f576-fe0f": [["🕶️", "🕶"], "", "", ["dark_sunglasses"], 31, 23, 15, 0],
      "1f577-fe0f": [["🕷️", "🕷"], "", "", ["spider"], 31, 24, 15, 0],
      "1f578-fe0f": [["🕸️", "🕸"], "", "", ["spider_web"], 31, 25, 15, 0],
      "1f579-fe0f": [["🕹️", "🕹"], "", "", ["joystick"], 31, 26, 15, 0],
      "1f57a": [["🕺"], "", "", ["man_dancing"], 31, 27, 15, 0],
      "1f587-fe0f": [["🖇️", "🖇"], "", "", ["linked_paperclips"], 31, 33, 15, 0],
      "1f58a-fe0f": [["🖊️", "🖊"], "", "", ["lower_left_ballpoint_pen"], 31, 34, 15, 0],
      "1f58b-fe0f": [["🖋️", "🖋"], "", "", ["lower_left_fountain_pen"], 31, 35, 15, 0],
      "1f58c-fe0f": [["🖌️", "🖌"], "", "", ["lower_left_paintbrush"], 31, 36, 15, 0],
      "1f58d-fe0f": [["🖍️", "🖍"], "", "", ["lower_left_crayon"], 31, 37, 15, 0],
      "1f590-fe0f": [["🖐️", "🖐"], "", "", ["raised_hand_with_fingers_splayed"], 31, 38, 15, 0],
      "1f595": [["🖕"], "", "", ["middle_finger", "reversed_hand_with_middle_finger_extended"], 31, 44, 15, 0],
      "1f596": [["🖖"], "", "", ["spock-hand"], 31, 50, 15, 0],
      "1f5a4": [["🖤"], "", "", ["black_heart"], 31, 56, 15, 0],
      "1f5a5-fe0f": [["🖥️", "🖥"], "", "", ["desktop_computer"], 31, 57, 15, 0],
      "1f5a8-fe0f": [["🖨️", "🖨"], "", "", ["printer"], 31, 58, 15, 0],
      "1f5b1-fe0f": [["🖱️", "🖱"], "", "", ["three_button_mouse"], 31, 59, 15, 0],
      "1f5b2-fe0f": [["🖲️", "🖲"], "", "", ["trackball"], 31, 60, 15, 0],
      "1f5bc-fe0f": [["🖼️", "🖼"], "", "", ["frame_with_picture"], 32, 0, 15, 0],
      "1f5c2-fe0f": [["🗂️", "🗂"], "", "", ["card_index_dividers"], 32, 1, 15, 0],
      "1f5c3-fe0f": [["🗃️", "🗃"], "", "", ["card_file_box"], 32, 2, 15, 0],
      "1f5c4-fe0f": [["🗄️", "🗄"], "", "", ["file_cabinet"], 32, 3, 15, 0],
      "1f5d1-fe0f": [["🗑️", "🗑"], "", "", ["wastebasket"], 32, 4, 15, 0],
      "1f5d2-fe0f": [["🗒️", "🗒"], "", "", ["spiral_note_pad"], 32, 5, 15, 0],
      "1f5d3-fe0f": [["🗓️", "🗓"], "", "", ["spiral_calendar_pad"], 32, 6, 15, 0],
      "1f5dc-fe0f": [["🗜️", "🗜"], "", "", ["compression"], 32, 7, 15, 0],
      "1f5dd-fe0f": [["🗝️", "🗝"], "", "", ["old_key"], 32, 8, 15, 0],
      "1f5de-fe0f": [["🗞️", "🗞"], "", "", ["rolled_up_newspaper"], 32, 9, 15, 0],
      "1f5e1-fe0f": [["🗡️", "🗡"], "", "", ["dagger_knife"], 32, 10, 15, 0],
      "1f5e3-fe0f": [["🗣️", "🗣"], "", "", ["speaking_head_in_silhouette"], 32, 11, 15, 0],
      "1f5e8-fe0f": [["🗨️", "🗨"], "", "", ["left_speech_bubble"], 32, 12, 15, 0],
      "1f5ef-fe0f": [["🗯️", "🗯"], "", "", ["right_anger_bubble"], 32, 13, 15, 0],
      "1f5f3-fe0f": [["🗳️", "🗳"], "", "", ["ballot_box_with_ballot"], 32, 14, 15, 0],
      "1f5fa-fe0f": [["🗺️", "🗺"], "", "", ["world_map"], 32, 15, 15, 0],
      "1f5fb": [["🗻"], "", "󾓃", ["mount_fuji"], 32, 16, 15, 0],
      "1f5fc": [["🗼"], "", "󾓄", ["tokyo_tower"], 32, 17, 15, 0],
      "1f5fd": [["🗽"], "", "󾓆", ["statue_of_liberty"], 32, 18, 15, 0],
      "1f5fe": [["🗾"], "", "󾓇", ["japan"], 32, 19, 15, 0],
      "1f5ff": [["🗿"], "", "󾓈", ["moyai"], 32, 20, 15, 0],
      "1f600": [["😀"], "", "", ["grinning"], 32, 21, 15, 0, ":D"],
      "1f601": [["😁"], "", "󾌳", ["grin"], 32, 22, 15, 0],
      "1f602": [["😂"], "", "󾌴", ["joy"], 32, 23, 15, 0],
      "1f603": [["😃"], "", "󾌰", ["smiley"], 32, 24, 15, 0, ":)"],
      "1f604": [["😄"], "", "󾌸", ["smile"], 32, 25, 15, 0, ":)"],
      "1f605": [["😅"], "", "󾌱", ["sweat_smile"], 32, 26, 15, 0],
      "1f606": [["😆"], "", "󾌲", ["laughing", "satisfied"], 32, 27, 15, 0],
      "1f607": [["😇"], "", "", ["innocent"], 32, 28, 15, 0],
      "1f608": [["😈"], "", "", ["smiling_imp"], 32, 29, 15, 0],
      "1f609": [["😉"], "", "󾍇", ["wink"], 32, 30, 15, 0, ";)"],
      "1f60a": [["😊"], "", "󾌵", ["blush"], 32, 31, 15, 0, ":)"],
      "1f60b": [["😋"], "", "󾌫", ["yum"], 32, 32, 15, 0],
      "1f60c": [["😌"], "", "󾌾", ["relieved"], 32, 33, 15, 0],
      "1f60d": [["😍"], "", "󾌧", ["heart_eyes"], 32, 34, 15, 0],
      "1f60e": [["😎"], "", "", ["sunglasses"], 32, 35, 15, 0],
      "1f60f": [["😏"], "", "󾍃", ["smirk"], 32, 36, 15, 0],
      "1f610": [["😐"], "", "", ["neutral_face"], 32, 37, 15, 0],
      "1f611": [["😑"], "", "", ["expressionless"], 32, 38, 15, 0],
      "1f612": [["😒"], "", "󾌦", ["unamused"], 32, 39, 15, 0, ":("],
      "1f613": [["😓"], "", "󾍄", ["sweat"], 32, 40, 15, 0],
      "1f614": [["😔"], "", "󾍀", ["pensive"], 32, 41, 15, 0],
      "1f615": [["😕"], "", "", ["confused"], 32, 42, 15, 0],
      "1f616": [["😖"], "", "󾌿", ["confounded"], 32, 43, 15, 0],
      "1f617": [["😗"], "", "", ["kissing"], 32, 44, 15, 0],
      "1f618": [["😘"], "", "󾌬", ["kissing_heart"], 32, 45, 15, 0],
      "1f619": [["😙"], "", "", ["kissing_smiling_eyes"], 32, 46, 15, 0],
      "1f61a": [["😚"], "", "󾌭", ["kissing_closed_eyes"], 32, 47, 15, 0],
      "1f61b": [["😛"], "", "", ["stuck_out_tongue"], 32, 48, 15, 0, ":p"],
      "1f61c": [["😜"], "", "󾌩", ["stuck_out_tongue_winking_eye"], 32, 49, 15, 0, ";p"],
      "1f61d": [["😝"], "", "󾌪", ["stuck_out_tongue_closed_eyes"], 32, 50, 15, 0],
      "1f61e": [["😞"], "", "󾌣", ["disappointed"], 32, 51, 15, 0, ":("],
      "1f61f": [["😟"], "", "", ["worried"], 32, 52, 15, 0],
      "1f620": [["😠"], "", "󾌠", ["angry"], 32, 53, 15, 0],
      "1f621": [["😡"], "", "󾌽", ["rage"], 32, 54, 15, 0],
      "1f622": [["😢"], "", "󾌹", ["cry"], 32, 55, 15, 0, ":'("],
      "1f623": [["😣"], "", "󾌼", ["persevere"], 32, 56, 15, 0],
      "1f624": [["😤"], "", "󾌨", ["triumph"], 32, 57, 15, 0],
      "1f625": [["😥"], "", "󾍅", ["disappointed_relieved"], 32, 58, 15, 0],
      "1f626": [["😦"], "", "", ["frowning"], 32, 59, 15, 0],
      "1f627": [["😧"], "", "", ["anguished"], 32, 60, 15, 0],
      "1f628": [["😨"], "", "󾌻", ["fearful"], 33, 0, 15, 0],
      "1f629": [["😩"], "", "󾌡", ["weary"], 33, 1, 15, 0],
      "1f62a": [["😪"], "", "󾍂", ["sleepy"], 33, 2, 15, 0],
      "1f62b": [["😫"], "", "󾍆", ["tired_face"], 33, 3, 15, 0],
      "1f62c": [["😬"], "", "", ["grimacing"], 33, 4, 15, 0],
      "1f62d": [["😭"], "", "󾌺", ["sob"], 33, 5, 15, 0, ":'("],
      "1f62e-200d-1f4a8": [["😮‍💨"], "", "", ["face_exhaling"], 33, 6, 15, 0],
      "1f62e": [["😮"], "", "", ["open_mouth"], 33, 7, 15, 0],
      "1f62f": [["😯"], "", "", ["hushed"], 33, 8, 15, 0],
      "1f630": [["😰"], "", "󾌥", ["cold_sweat"], 33, 9, 15, 0],
      "1f631": [["😱"], "", "󾍁", ["scream"], 33, 10, 15, 0],
      "1f632": [["😲"], "", "󾌢", ["astonished"], 33, 11, 15, 0],
      "1f633": [["😳"], "", "󾌯", ["flushed"], 33, 12, 15, 0],
      "1f634": [["😴"], "", "", ["sleeping"], 33, 13, 15, 0],
      "1f635-200d-1f4ab": [["😵‍💫"], "", "", ["face_with_spiral_eyes"], 33, 14, 15, 0],
      "1f635": [["😵"], "", "󾌤", ["dizzy_face"], 33, 15, 15, 0],
      "1f636-200d-1f32b-fe0f": [["😶‍🌫️", "😶‍🌫"], "", "", ["face_in_clouds"], 33, 16, 15, 0],
      "1f636": [["😶"], "", "", ["no_mouth"], 33, 17, 15, 0],
      "1f637": [["😷"], "", "󾌮", ["mask"], 33, 18, 15, 0],
      "1f638": [["😸"], "", "󾍉", ["smile_cat"], 33, 19, 15, 0],
      "1f639": [["😹"], "", "󾍊", ["joy_cat"], 33, 20, 15, 0],
      "1f63a": [["😺"], "", "󾍈", ["smiley_cat"], 33, 21, 15, 0],
      "1f63b": [["😻"], "", "󾍌", ["heart_eyes_cat"], 33, 22, 15, 0],
      "1f63c": [["😼"], "", "󾍏", ["smirk_cat"], 33, 23, 15, 0],
      "1f63d": [["😽"], "", "󾍋", ["kissing_cat"], 33, 24, 15, 0],
      "1f63e": [["😾"], "", "󾍎", ["pouting_cat"], 33, 25, 15, 0],
      "1f63f": [["😿"], "", "󾍍", ["crying_cat_face"], 33, 26, 15, 0],
      "1f640": [["🙀"], "", "󾍐", ["scream_cat"], 33, 27, 15, 0],
      "1f641": [["🙁"], "", "", ["slightly_frowning_face"], 33, 28, 15, 0],
      "1f642": [["🙂"], "", "", ["slightly_smiling_face"], 33, 29, 15, 0],
      "1f643": [["🙃"], "", "", ["upside_down_face"], 33, 30, 15, 0],
      "1f644": [["🙄"], "", "", ["face_with_rolling_eyes"], 33, 31, 15, 0],
      "1f645-200d-2640-fe0f": [["🙅‍♀️", "🙅‍♀", "🙅"], "", "", ["woman-gesturing-no", "no_good"], 33, 32, 15, 0],
      "1f645-200d-2642-fe0f": [["🙅‍♂️", "🙅‍♂"], "", "", ["man-gesturing-no"], 33, 38, 15, 0],
      "1f646-200d-2640-fe0f": [["🙆‍♀️", "🙆‍♀", "🙆"], "", "", ["woman-gesturing-ok", "ok_woman"], 33, 50, 15, 0],
      "1f646-200d-2642-fe0f": [["🙆‍♂️", "🙆‍♂"], "", "", ["man-gesturing-ok"], 33, 56, 15, 0],
      "1f647-200d-2640-fe0f": [["🙇‍♀️", "🙇‍♀"], "", "", ["woman-bowing"], 34, 7, 15, 0],
      "1f647-200d-2642-fe0f": [["🙇‍♂️", "🙇‍♂"], "", "", ["man-bowing"], 34, 13, 15, 0],
      "1f647": [["🙇"], "", "󾍓", ["bow"], 34, 19, 15, 0],
      "1f648": [["🙈"], "", "󾍔", ["see_no_evil"], 34, 25, 15, 0],
      "1f649": [["🙉"], "", "󾍖", ["hear_no_evil"], 34, 26, 15, 0],
      "1f64a": [["🙊"], "", "󾍕", ["speak_no_evil"], 34, 27, 15, 0],
      "1f64b-200d-2640-fe0f": [["🙋‍♀️", "🙋‍♀", "🙋"], "", "", ["woman-raising-hand", "raising_hand"], 34, 28, 15, 0],
      "1f64b-200d-2642-fe0f": [["🙋‍♂️", "🙋‍♂"], "", "", ["man-raising-hand"], 34, 34, 15, 0],
      "1f64c": [["🙌"], "", "󾍘", ["raised_hands"], 34, 46, 15, 0],
      "1f64d-200d-2640-fe0f": [["🙍‍♀️", "🙍‍♀", "🙍"], "", "", ["woman-frowning", "person_frowning"], 34, 52, 15, 0],
      "1f64d-200d-2642-fe0f": [["🙍‍♂️", "🙍‍♂"], "", "", ["man-frowning"], 34, 58, 15, 0],
      "1f64e-200d-2640-fe0f": [["🙎‍♀️", "🙎‍♀", "🙎"], "", "", ["woman-pouting", "person_with_pouting_face"], 35, 9, 15, 0],
      "1f64e-200d-2642-fe0f": [["🙎‍♂️", "🙎‍♂"], "", "", ["man-pouting"], 35, 15, 15, 0],
      "1f64f": [["🙏"], "", "󾍛", ["pray"], 35, 27, 15, 0],
      "1f680": [["🚀"], "", "󾟭", ["rocket"], 35, 33, 15, 0],
      "1f681": [["🚁"], "", "", ["helicopter"], 35, 34, 15, 0],
      "1f682": [["🚂"], "", "", ["steam_locomotive"], 35, 35, 15, 0],
      "1f683": [["🚃"], "", "󾟟", ["railway_car"], 35, 36, 15, 0],
      "1f684": [["🚄"], "", "󾟢", ["bullettrain_side"], 35, 37, 15, 0],
      "1f685": [["🚅"], "", "󾟣", ["bullettrain_front"], 35, 38, 15, 0],
      "1f686": [["🚆"], "", "", ["train2"], 35, 39, 15, 0],
      "1f687": [["🚇"], "", "󾟠", ["metro"], 35, 40, 15, 0],
      "1f688": [["🚈"], "", "", ["light_rail"], 35, 41, 15, 0],
      "1f689": [["🚉"], "", "󾟬", ["station"], 35, 42, 15, 0],
      "1f68a": [["🚊"], "", "", ["tram"], 35, 43, 15, 0],
      "1f68b": [["🚋"], "", "", ["train"], 35, 44, 15, 0],
      "1f68c": [["🚌"], "", "󾟦", ["bus"], 35, 45, 15, 0],
      "1f68d": [["🚍"], "", "", ["oncoming_bus"], 35, 46, 15, 0],
      "1f68e": [["🚎"], "", "", ["trolleybus"], 35, 47, 15, 0],
      "1f68f": [["🚏"], "", "󾟧", ["busstop"], 35, 48, 15, 0],
      "1f690": [["🚐"], "", "", ["minibus"], 35, 49, 15, 0],
      "1f691": [["🚑"], "", "󾟳", ["ambulance"], 35, 50, 15, 0],
      "1f692": [["🚒"], "", "󾟲", ["fire_engine"], 35, 51, 15, 0],
      "1f693": [["🚓"], "", "󾟴", ["police_car"], 35, 52, 15, 0],
      "1f694": [["🚔"], "", "", ["oncoming_police_car"], 35, 53, 15, 0],
      "1f695": [["🚕"], "", "󾟯", ["taxi"], 35, 54, 15, 0],
      "1f696": [["🚖"], "", "", ["oncoming_taxi"], 35, 55, 15, 0],
      "1f697": [["🚗"], "", "󾟤", ["car", "red_car"], 35, 56, 15, 0],
      "1f698": [["🚘"], "", "", ["oncoming_automobile"], 35, 57, 15, 0],
      "1f699": [["🚙"], "", "󾟥", ["blue_car"], 35, 58, 15, 0],
      "1f69a": [["🚚"], "", "󾟱", ["truck"], 35, 59, 15, 0],
      "1f69b": [["🚛"], "", "", ["articulated_lorry"], 35, 60, 15, 0],
      "1f69c": [["🚜"], "", "", ["tractor"], 36, 0, 15, 0],
      "1f69d": [["🚝"], "", "", ["monorail"], 36, 1, 15, 0],
      "1f69e": [["🚞"], "", "", ["mountain_railway"], 36, 2, 15, 0],
      "1f69f": [["🚟"], "", "", ["suspension_railway"], 36, 3, 15, 0],
      "1f6a0": [["🚠"], "", "", ["mountain_cableway"], 36, 4, 15, 0],
      "1f6a1": [["🚡"], "", "", ["aerial_tramway"], 36, 5, 15, 0],
      "1f6a2": [["🚢"], "", "󾟨", ["ship"], 36, 6, 15, 0],
      "1f6a3-200d-2640-fe0f": [["🚣‍♀️", "🚣‍♀"], "", "", ["woman-rowing-boat"], 36, 7, 15, 0],
      "1f6a3-200d-2642-fe0f": [["🚣‍♂️", "🚣‍♂", "🚣"], "", "", ["man-rowing-boat", "rowboat"], 36, 13, 15, 0],
      "1f6a4": [["🚤"], "", "󾟮", ["speedboat"], 36, 25, 15, 0],
      "1f6a5": [["🚥"], "", "󾟷", ["traffic_light"], 36, 26, 15, 0],
      "1f6a6": [["🚦"], "", "", ["vertical_traffic_light"], 36, 27, 15, 0],
      "1f6a7": [["🚧"], "", "󾟸", ["construction"], 36, 28, 15, 0],
      "1f6a8": [["🚨"], "", "󾟹", ["rotating_light"], 36, 29, 15, 0],
      "1f6a9": [["🚩"], "", "󾬢", ["triangular_flag_on_post"], 36, 30, 15, 0],
      "1f6aa": [["🚪"], "", "󾓳", ["door"], 36, 31, 15, 0],
      "1f6ab": [["🚫"], "", "󾭈", ["no_entry_sign"], 36, 32, 15, 0],
      "1f6ac": [["🚬"], "", "󾬞", ["smoking"], 36, 33, 15, 0],
      "1f6ad": [["🚭"], "", "󾬟", ["no_smoking"], 36, 34, 15, 0],
      "1f6ae": [["🚮"], "", "", ["put_litter_in_its_place"], 36, 35, 15, 0],
      "1f6af": [["🚯"], "", "", ["do_not_litter"], 36, 36, 15, 0],
      "1f6b0": [["🚰"], "", "", ["potable_water"], 36, 37, 15, 0],
      "1f6b1": [["🚱"], "", "", ["non-potable_water"], 36, 38, 15, 0],
      "1f6b2": [["🚲"], "", "󾟫", ["bike"], 36, 39, 15, 0],
      "1f6b3": [["🚳"], "", "", ["no_bicycles"], 36, 40, 15, 0],
      "1f6b4-200d-2640-fe0f": [["🚴‍♀️", "🚴‍♀"], "", "", ["woman-biking"], 36, 41, 15, 0],
      "1f6b4-200d-2642-fe0f": [["🚴‍♂️", "🚴‍♂", "🚴"], "", "", ["man-biking", "bicyclist"], 36, 47, 15, 0],
      "1f6b5-200d-2640-fe0f": [["🚵‍♀️", "🚵‍♀"], "", "", ["woman-mountain-biking"], 36, 59, 15, 0],
      "1f6b5-200d-2642-fe0f": [["🚵‍♂️", "🚵‍♂", "🚵"], "", "", ["man-mountain-biking", "mountain_bicyclist"], 37, 4, 15, 0],
      "1f6b6-200d-2640-fe0f": [["🚶‍♀️", "🚶‍♀"], "", "", ["woman-walking"], 37, 16, 15, 0],
      "1f6b6-200d-2642-fe0f": [["🚶‍♂️", "🚶‍♂", "🚶"], "", "", ["man-walking", "walking"], 37, 22, 15, 0],
      "1f6b7": [["🚷"], "", "", ["no_pedestrians"], 37, 34, 15, 0],
      "1f6b8": [["🚸"], "", "", ["children_crossing"], 37, 35, 15, 0],
      "1f6b9": [["🚹"], "", "󾬳", ["mens"], 37, 36, 15, 0],
      "1f6ba": [["🚺"], "", "󾬴", ["womens"], 37, 37, 15, 0],
      "1f6bb": [["🚻"], "", "󾔆", ["restroom"], 37, 38, 15, 0],
      "1f6bc": [["🚼"], "", "󾬵", ["baby_symbol"], 37, 39, 15, 0],
      "1f6bd": [["🚽"], "", "󾔇", ["toilet"], 37, 40, 15, 0],
      "1f6be": [["🚾"], "", "󾔈", ["wc"], 37, 41, 15, 0],
      "1f6bf": [["🚿"], "", "", ["shower"], 37, 42, 15, 0],
      "1f6c0": [["🛀"], "", "󾔅", ["bath"], 37, 43, 15, 0],
      "1f6c1": [["🛁"], "", "", ["bathtub"], 37, 49, 15, 0],
      "1f6c2": [["🛂"], "", "", ["passport_control"], 37, 50, 15, 0],
      "1f6c3": [["🛃"], "", "", ["customs"], 37, 51, 15, 0],
      "1f6c4": [["🛄"], "", "", ["baggage_claim"], 37, 52, 15, 0],
      "1f6c5": [["🛅"], "", "", ["left_luggage"], 37, 53, 15, 0],
      "1f6cb-fe0f": [["🛋️", "🛋"], "", "", ["couch_and_lamp"], 37, 54, 15, 0],
      "1f6cc": [["🛌"], "", "", ["sleeping_accommodation"], 37, 55, 15, 0],
      "1f6cd-fe0f": [["🛍️", "🛍"], "", "", ["shopping_bags"], 38, 0, 15, 0],
      "1f6ce-fe0f": [["🛎️", "🛎"], "", "", ["bellhop_bell"], 38, 1, 15, 0],
      "1f6cf-fe0f": [["🛏️", "🛏"], "", "", ["bed"], 38, 2, 15, 0],
      "1f6d0": [["🛐"], "", "", ["place_of_worship"], 38, 3, 15, 0],
      "1f6d1": [["🛑"], "", "", ["octagonal_sign"], 38, 4, 15, 0],
      "1f6d2": [["🛒"], "", "", ["shopping_trolley"], 38, 5, 15, 0],
      "1f6d5": [["🛕"], "", "", ["hindu_temple"], 38, 6, 15, 0],
      "1f6d6": [["🛖"], "", "", ["hut"], 38, 7, 15, 0],
      "1f6d7": [["🛗"], "", "", ["elevator"], 38, 8, 15, 0],
      "1f6dc": [["🛜"], "", "", ["wireless"], 38, 9, 3, 0],
      "1f6dd": [["🛝"], "", "", ["playground_slide"], 38, 10, 15, 0],
      "1f6de": [["🛞"], "", "", ["wheel"], 38, 11, 15, 0],
      "1f6df": [["🛟"], "", "", ["ring_buoy"], 38, 12, 15, 0],
      "1f6e0-fe0f": [["🛠️", "🛠"], "", "", ["hammer_and_wrench"], 38, 13, 15, 0],
      "1f6e1-fe0f": [["🛡️", "🛡"], "", "", ["shield"], 38, 14, 15, 0],
      "1f6e2-fe0f": [["🛢️", "🛢"], "", "", ["oil_drum"], 38, 15, 15, 0],
      "1f6e3-fe0f": [["🛣️", "🛣"], "", "", ["motorway"], 38, 16, 15, 0],
      "1f6e4-fe0f": [["🛤️", "🛤"], "", "", ["railway_track"], 38, 17, 15, 0],
      "1f6e5-fe0f": [["🛥️", "🛥"], "", "", ["motor_boat"], 38, 18, 15, 0],
      "1f6e9-fe0f": [["🛩️", "🛩"], "", "", ["small_airplane"], 38, 19, 15, 0],
      "1f6eb": [["🛫"], "", "", ["airplane_departure"], 38, 20, 15, 0],
      "1f6ec": [["🛬"], "", "", ["airplane_arriving"], 38, 21, 15, 0],
      "1f6f0-fe0f": [["🛰️", "🛰"], "", "", ["satellite"], 38, 22, 15, 0],
      "1f6f3-fe0f": [["🛳️", "🛳"], "", "", ["passenger_ship"], 38, 23, 15, 0],
      "1f6f4": [["🛴"], "", "", ["scooter"], 38, 24, 15, 0],
      "1f6f5": [["🛵"], "", "", ["motor_scooter"], 38, 25, 15, 0],
      "1f6f6": [["🛶"], "", "", ["canoe"], 38, 26, 15, 0],
      "1f6f7": [["🛷"], "", "", ["sled"], 38, 27, 15, 0],
      "1f6f8": [["🛸"], "", "", ["flying_saucer"], 38, 28, 15, 0],
      "1f6f9": [["🛹"], "", "", ["skateboard"], 38, 29, 15, 0],
      "1f6fa": [["🛺"], "", "", ["auto_rickshaw"], 38, 30, 15, 0],
      "1f6fb": [["🛻"], "", "", ["pickup_truck"], 38, 31, 15, 0],
      "1f6fc": [["🛼"], "", "", ["roller_skate"], 38, 32, 15, 0],
      "1f7e0": [["🟠"], "", "", ["large_orange_circle"], 38, 33, 15, 0],
      "1f7e1": [["🟡"], "", "", ["large_yellow_circle"], 38, 34, 15, 0],
      "1f7e2": [["🟢"], "", "", ["large_green_circle"], 38, 35, 15, 0],
      "1f7e3": [["🟣"], "", "", ["large_purple_circle"], 38, 36, 15, 0],
      "1f7e4": [["🟤"], "", "", ["large_brown_circle"], 38, 37, 15, 0],
      "1f7e5": [["🟥"], "", "", ["large_red_square"], 38, 38, 15, 0],
      "1f7e6": [["🟦"], "", "", ["large_blue_square"], 38, 39, 15, 0],
      "1f7e7": [["🟧"], "", "", ["large_orange_square"], 38, 40, 15, 0],
      "1f7e8": [["🟨"], "", "", ["large_yellow_square"], 38, 41, 15, 0],
      "1f7e9": [["🟩"], "", "", ["large_green_square"], 38, 42, 15, 0],
      "1f7ea": [["🟪"], "", "", ["large_purple_square"], 38, 43, 15, 0],
      "1f7eb": [["🟫"], "", "", ["large_brown_square"], 38, 44, 15, 0],
      "1f7f0": [["🟰"], "", "", ["heavy_equals_sign"], 38, 45, 15, 0],
      "1f90c": [["🤌"], "", "", ["pinched_fingers"], 38, 46, 15, 0],
      "1f90d": [["🤍"], "", "", ["white_heart"], 38, 52, 15, 0],
      "1f90e": [["🤎"], "", "", ["brown_heart"], 38, 53, 15, 0],
      "1f90f": [["🤏"], "", "", ["pinching_hand"], 38, 54, 15, 0],
      "1f910": [["🤐"], "", "", ["zipper_mouth_face"], 38, 60, 15, 0],
      "1f911": [["🤑"], "", "", ["money_mouth_face"], 39, 0, 15, 0],
      "1f912": [["🤒"], "", "", ["face_with_thermometer"], 39, 1, 15, 0],
      "1f913": [["🤓"], "", "", ["nerd_face"], 39, 2, 15, 0],
      "1f914": [["🤔"], "", "", ["thinking_face"], 39, 3, 15, 0],
      "1f915": [["🤕"], "", "", ["face_with_head_bandage"], 39, 4, 15, 0],
      "1f916": [["🤖"], "", "", ["robot_face"], 39, 5, 15, 0],
      "1f917": [["🤗"], "", "", ["hugging_face"], 39, 6, 15, 0],
      "1f918": [["🤘"], "", "", ["the_horns", "sign_of_the_horns"], 39, 7, 15, 0],
      "1f919": [["🤙"], "", "", ["call_me_hand"], 39, 13, 15, 0],
      "1f91a": [["🤚"], "", "", ["raised_back_of_hand"], 39, 19, 15, 0],
      "1f91b": [["🤛"], "", "", ["left-facing_fist"], 39, 25, 15, 0],
      "1f91c": [["🤜"], "", "", ["right-facing_fist"], 39, 31, 15, 0],
      "1f91d": [["🤝"], "", "", ["handshake"], 39, 37, 15, 0],
      "1f91e": [["🤞"], "", "", ["crossed_fingers", "hand_with_index_and_middle_fingers_crossed"], 40, 2, 15, 0],
      "1f91f": [["🤟"], "", "", ["i_love_you_hand_sign"], 40, 8, 15, 0],
      "1f920": [["🤠"], "", "", ["face_with_cowboy_hat"], 40, 14, 15, 0],
      "1f921": [["🤡"], "", "", ["clown_face"], 40, 15, 15, 0],
      "1f922": [["🤢"], "", "", ["nauseated_face"], 40, 16, 15, 0],
      "1f923": [["🤣"], "", "", ["rolling_on_the_floor_laughing"], 40, 17, 15, 0],
      "1f924": [["🤤"], "", "", ["drooling_face"], 40, 18, 15, 0],
      "1f925": [["🤥"], "", "", ["lying_face"], 40, 19, 15, 0],
      "1f926-200d-2640-fe0f": [["🤦‍♀️", "🤦‍♀"], "", "", ["woman-facepalming"], 40, 20, 15, 0],
      "1f926-200d-2642-fe0f": [["🤦‍♂️", "🤦‍♂"], "", "", ["man-facepalming"], 40, 26, 15, 0],
      "1f926": [["🤦"], "", "", ["face_palm"], 40, 32, 15, 0],
      "1f927": [["🤧"], "", "", ["sneezing_face"], 40, 38, 15, 0],
      "1f928": [["🤨"], "", "", ["face_with_raised_eyebrow", "face_with_one_eyebrow_raised"], 40, 39, 15, 0],
      "1f929": [["🤩"], "", "", ["star-struck", "grinning_face_with_star_eyes"], 40, 40, 15, 0],
      "1f92a": [["🤪"], "", "", ["zany_face", "grinning_face_with_one_large_and_one_small_eye"], 40, 41, 15, 0],
      "1f92b": [["🤫"], "", "", ["shushing_face", "face_with_finger_covering_closed_lips"], 40, 42, 15, 0],
      "1f92c": [["🤬"], "", "", ["face_with_symbols_on_mouth", "serious_face_with_symbols_covering_mouth"], 40, 43, 15, 0],
      "1f92d": [["🤭"], "", "", ["face_with_hand_over_mouth", "smiling_face_with_smiling_eyes_and_hand_covering_mouth"], 40, 44, 15, 0],
      "1f92e": [["🤮"], "", "", ["face_vomiting", "face_with_open_mouth_vomiting"], 40, 45, 15, 0],
      "1f92f": [["🤯"], "", "", ["exploding_head", "shocked_face_with_exploding_head"], 40, 46, 15, 0],
      "1f930": [["🤰"], "", "", ["pregnant_woman"], 40, 47, 15, 0],
      "1f931": [["🤱"], "", "", ["breast-feeding"], 40, 53, 15, 0],
      "1f932": [["🤲"], "", "", ["palms_up_together"], 40, 59, 15, 0],
      "1f933": [["🤳"], "", "", ["selfie"], 41, 4, 15, 0],
      "1f934": [["🤴"], "", "", ["prince"], 41, 10, 15, 0],
      "1f935-200d-2640-fe0f": [["🤵‍♀️", "🤵‍♀"], "", "", ["woman_in_tuxedo"], 41, 16, 15, 0],
      "1f935-200d-2642-fe0f": [["🤵‍♂️", "🤵‍♂"], "", "", ["man_in_tuxedo"], 41, 22, 15, 0],
      "1f935": [["🤵"], "", "", ["person_in_tuxedo"], 41, 28, 15, 0],
      "1f936": [["🤶"], "", "", ["mrs_claus", "mother_christmas"], 41, 34, 15, 0],
      "1f937-200d-2640-fe0f": [["🤷‍♀️", "🤷‍♀"], "", "", ["woman-shrugging"], 41, 40, 15, 0],
      "1f937-200d-2642-fe0f": [["🤷‍♂️", "🤷‍♂"], "", "", ["man-shrugging"], 41, 46, 15, 0],
      "1f937": [["🤷"], "", "", ["shrug"], 41, 52, 15, 0],
      "1f938-200d-2640-fe0f": [["🤸‍♀️", "🤸‍♀"], "", "", ["woman-cartwheeling"], 41, 58, 15, 0],
      "1f938-200d-2642-fe0f": [["🤸‍♂️", "🤸‍♂"], "", "", ["man-cartwheeling"], 42, 3, 15, 0],
      "1f938": [["🤸"], "", "", ["person_doing_cartwheel"], 42, 9, 15, 0],
      "1f939-200d-2640-fe0f": [["🤹‍♀️", "🤹‍♀"], "", "", ["woman-juggling"], 42, 15, 15, 0],
      "1f939-200d-2642-fe0f": [["🤹‍♂️", "🤹‍♂"], "", "", ["man-juggling"], 42, 21, 15, 0],
      "1f939": [["🤹"], "", "", ["juggling"], 42, 27, 15, 0],
      "1f93a": [["🤺"], "", "", ["fencer"], 42, 33, 15, 0],
      "1f93c-200d-2640-fe0f": [["🤼‍♀️", "🤼‍♀"], "", "", ["woman-wrestling"], 42, 34, 15, 0],
      "1f93c-200d-2642-fe0f": [["🤼‍♂️", "🤼‍♂"], "", "", ["man-wrestling"], 42, 35, 15, 0],
      "1f93c": [["🤼"], "", "", ["wrestlers"], 42, 36, 15, 0],
      "1f93d-200d-2640-fe0f": [["🤽‍♀️", "🤽‍♀"], "", "", ["woman-playing-water-polo"], 42, 37, 15, 0],
      "1f93d-200d-2642-fe0f": [["🤽‍♂️", "🤽‍♂"], "", "", ["man-playing-water-polo"], 42, 43, 15, 0],
      "1f93d": [["🤽"], "", "", ["water_polo"], 42, 49, 15, 0],
      "1f93e-200d-2640-fe0f": [["🤾‍♀️", "🤾‍♀"], "", "", ["woman-playing-handball"], 42, 55, 15, 0],
      "1f93e-200d-2642-fe0f": [["🤾‍♂️", "🤾‍♂"], "", "", ["man-playing-handball"], 43, 0, 15, 0],
      "1f93e": [["🤾"], "", "", ["handball"], 43, 6, 15, 0],
      "1f93f": [["🤿"], "", "", ["diving_mask"], 43, 12, 15, 0],
      "1f940": [["🥀"], "", "", ["wilted_flower"], 43, 13, 15, 0],
      "1f941": [["🥁"], "", "", ["drum_with_drumsticks"], 43, 14, 15, 0],
      "1f942": [["🥂"], "", "", ["clinking_glasses"], 43, 15, 15, 0],
      "1f943": [["🥃"], "", "", ["tumbler_glass"], 43, 16, 15, 0],
      "1f944": [["🥄"], "", "", ["spoon"], 43, 17, 15, 0],
      "1f945": [["🥅"], "", "", ["goal_net"], 43, 18, 15, 0],
      "1f947": [["🥇"], "", "", ["first_place_medal"], 43, 19, 15, 0],
      "1f948": [["🥈"], "", "", ["second_place_medal"], 43, 20, 15, 0],
      "1f949": [["🥉"], "", "", ["third_place_medal"], 43, 21, 15, 0],
      "1f94a": [["🥊"], "", "", ["boxing_glove"], 43, 22, 15, 0],
      "1f94b": [["🥋"], "", "", ["martial_arts_uniform"], 43, 23, 15, 0],
      "1f94c": [["🥌"], "", "", ["curling_stone"], 43, 24, 15, 0],
      "1f94d": [["🥍"], "", "", ["lacrosse"], 43, 25, 15, 0],
      "1f94e": [["🥎"], "", "", ["softball"], 43, 26, 15, 0],
      "1f94f": [["🥏"], "", "", ["flying_disc"], 43, 27, 15, 0],
      "1f950": [["🥐"], "", "", ["croissant"], 43, 28, 15, 0],
      "1f951": [["🥑"], "", "", ["avocado"], 43, 29, 15, 0],
      "1f952": [["🥒"], "", "", ["cucumber"], 43, 30, 15, 0],
      "1f953": [["🥓"], "", "", ["bacon"], 43, 31, 15, 0],
      "1f954": [["🥔"], "", "", ["potato"], 43, 32, 15, 0],
      "1f955": [["🥕"], "", "", ["carrot"], 43, 33, 15, 0],
      "1f956": [["🥖"], "", "", ["baguette_bread"], 43, 34, 15, 0],
      "1f957": [["🥗"], "", "", ["green_salad"], 43, 35, 15, 0],
      "1f958": [["🥘"], "", "", ["shallow_pan_of_food"], 43, 36, 15, 0],
      "1f959": [["🥙"], "", "", ["stuffed_flatbread"], 43, 37, 15, 0],
      "1f95a": [["🥚"], "", "", ["egg"], 43, 38, 15, 0],
      "1f95b": [["🥛"], "", "", ["glass_of_milk"], 43, 39, 15, 0],
      "1f95c": [["🥜"], "", "", ["peanuts"], 43, 40, 15, 0],
      "1f95d": [["🥝"], "", "", ["kiwifruit"], 43, 41, 15, 0],
      "1f95e": [["🥞"], "", "", ["pancakes"], 43, 42, 15, 0],
      "1f95f": [["🥟"], "", "", ["dumpling"], 43, 43, 15, 0],
      "1f960": [["🥠"], "", "", ["fortune_cookie"], 43, 44, 15, 0],
      "1f961": [["🥡"], "", "", ["takeout_box"], 43, 45, 15, 0],
      "1f962": [["🥢"], "", "", ["chopsticks"], 43, 46, 15, 0],
      "1f963": [["🥣"], "", "", ["bowl_with_spoon"], 43, 47, 15, 0],
      "1f964": [["🥤"], "", "", ["cup_with_straw"], 43, 48, 15, 0],
      "1f965": [["🥥"], "", "", ["coconut"], 43, 49, 15, 0],
      "1f966": [["🥦"], "", "", ["broccoli"], 43, 50, 15, 0],
      "1f967": [["🥧"], "", "", ["pie"], 43, 51, 15, 0],
      "1f968": [["🥨"], "", "", ["pretzel"], 43, 52, 15, 0],
      "1f969": [["🥩"], "", "", ["cut_of_meat"], 43, 53, 15, 0],
      "1f96a": [["🥪"], "", "", ["sandwich"], 43, 54, 15, 0],
      "1f96b": [["🥫"], "", "", ["canned_food"], 43, 55, 15, 0],
      "1f96c": [["🥬"], "", "", ["leafy_green"], 43, 56, 15, 0],
      "1f96d": [["🥭"], "", "", ["mango"], 43, 57, 15, 0],
      "1f96e": [["🥮"], "", "", ["moon_cake"], 43, 58, 15, 0],
      "1f96f": [["🥯"], "", "", ["bagel"], 43, 59, 15, 0],
      "1f970": [["🥰"], "", "", ["smiling_face_with_3_hearts"], 43, 60, 15, 0],
      "1f971": [["🥱"], "", "", ["yawning_face"], 44, 0, 15, 0],
      "1f972": [["🥲"], "", "", ["smiling_face_with_tear"], 44, 1, 15, 0],
      "1f973": [["🥳"], "", "", ["partying_face"], 44, 2, 15, 0],
      "1f974": [["🥴"], "", "", ["woozy_face"], 44, 3, 15, 0],
      "1f975": [["🥵"], "", "", ["hot_face"], 44, 4, 15, 0],
      "1f976": [["🥶"], "", "", ["cold_face"], 44, 5, 15, 0],
      "1f977": [["🥷"], "", "", ["ninja"], 44, 6, 15, 0],
      "1f978": [["🥸"], "", "", ["disguised_face"], 44, 12, 15, 0],
      "1f979": [["🥹"], "", "", ["face_holding_back_tears"], 44, 13, 15, 0],
      "1f97a": [["🥺"], "", "", ["pleading_face"], 44, 14, 15, 0],
      "1f97b": [["🥻"], "", "", ["sari"], 44, 15, 15, 0],
      "1f97c": [["🥼"], "", "", ["lab_coat"], 44, 16, 15, 0],
      "1f97d": [["🥽"], "", "", ["goggles"], 44, 17, 15, 0],
      "1f97e": [["🥾"], "", "", ["hiking_boot"], 44, 18, 15, 0],
      "1f97f": [["🥿"], "", "", ["womans_flat_shoe"], 44, 19, 15, 0],
      "1f980": [["🦀"], "", "", ["crab"], 44, 20, 15, 0],
      "1f981": [["🦁"], "", "", ["lion_face"], 44, 21, 15, 0],
      "1f982": [["🦂"], "", "", ["scorpion"], 44, 22, 15, 0],
      "1f983": [["🦃"], "", "", ["turkey"], 44, 23, 15, 0],
      "1f984": [["🦄"], "", "", ["unicorn_face"], 44, 24, 15, 0],
      "1f985": [["🦅"], "", "", ["eagle"], 44, 25, 15, 0],
      "1f986": [["🦆"], "", "", ["duck"], 44, 26, 15, 0],
      "1f987": [["🦇"], "", "", ["bat"], 44, 27, 15, 0],
      "1f988": [["🦈"], "", "", ["shark"], 44, 28, 15, 0],
      "1f989": [["🦉"], "", "", ["owl"], 44, 29, 15, 0],
      "1f98a": [["🦊"], "", "", ["fox_face"], 44, 30, 15, 0],
      "1f98b": [["🦋"], "", "", ["butterfly"], 44, 31, 15, 0],
      "1f98c": [["🦌"], "", "", ["deer"], 44, 32, 15, 0],
      "1f98d": [["🦍"], "", "", ["gorilla"], 44, 33, 15, 0],
      "1f98e": [["🦎"], "", "", ["lizard"], 44, 34, 15, 0],
      "1f98f": [["🦏"], "", "", ["rhinoceros"], 44, 35, 15, 0],
      "1f990": [["🦐"], "", "", ["shrimp"], 44, 36, 15, 0],
      "1f991": [["🦑"], "", "", ["squid"], 44, 37, 15, 0],
      "1f992": [["🦒"], "", "", ["giraffe_face"], 44, 38, 15, 0],
      "1f993": [["🦓"], "", "", ["zebra_face"], 44, 39, 15, 0],
      "1f994": [["🦔"], "", "", ["hedgehog"], 44, 40, 15, 0],
      "1f995": [["🦕"], "", "", ["sauropod"], 44, 41, 15, 0],
      "1f996": [["🦖"], "", "", ["t-rex"], 44, 42, 15, 0],
      "1f997": [["🦗"], "", "", ["cricket"], 44, 43, 15, 0],
      "1f998": [["🦘"], "", "", ["kangaroo"], 44, 44, 15, 0],
      "1f999": [["🦙"], "", "", ["llama"], 44, 45, 15, 0],
      "1f99a": [["🦚"], "", "", ["peacock"], 44, 46, 15, 0],
      "1f99b": [["🦛"], "", "", ["hippopotamus"], 44, 47, 15, 0],
      "1f99c": [["🦜"], "", "", ["parrot"], 44, 48, 15, 0],
      "1f99d": [["🦝"], "", "", ["raccoon"], 44, 49, 15, 0],
      "1f99e": [["🦞"], "", "", ["lobster"], 44, 50, 15, 0],
      "1f99f": [["🦟"], "", "", ["mosquito"], 44, 51, 15, 0],
      "1f9a0": [["🦠"], "", "", ["microbe"], 44, 52, 15, 0],
      "1f9a1": [["🦡"], "", "", ["badger"], 44, 53, 15, 0],
      "1f9a2": [["🦢"], "", "", ["swan"], 44, 54, 15, 0],
      "1f9a3": [["🦣"], "", "", ["mammoth"], 44, 55, 15, 0],
      "1f9a4": [["🦤"], "", "", ["dodo"], 44, 56, 15, 0],
      "1f9a5": [["🦥"], "", "", ["sloth"], 44, 57, 15, 0],
      "1f9a6": [["🦦"], "", "", ["otter"], 44, 58, 15, 0],
      "1f9a7": [["🦧"], "", "", ["orangutan"], 44, 59, 15, 0],
      "1f9a8": [["🦨"], "", "", ["skunk"], 44, 60, 15, 0],
      "1f9a9": [["🦩"], "", "", ["flamingo"], 45, 0, 15, 0],
      "1f9aa": [["🦪"], "", "", ["oyster"], 45, 1, 15, 0],
      "1f9ab": [["🦫"], "", "", ["beaver"], 45, 2, 15, 0],
      "1f9ac": [["🦬"], "", "", ["bison"], 45, 3, 15, 0],
      "1f9ad": [["🦭"], "", "", ["seal"], 45, 4, 15, 0],
      "1f9ae": [["🦮"], "", "", ["guide_dog"], 45, 5, 15, 0],
      "1f9af": [["🦯"], "", "", ["probing_cane"], 45, 6, 15, 0],
      "1f9b4": [["🦴"], "", "", ["bone"], 45, 7, 15, 0],
      "1f9b5": [["🦵"], "", "", ["leg"], 45, 8, 15, 0],
      "1f9b6": [["🦶"], "", "", ["foot"], 45, 14, 15, 0],
      "1f9b7": [["🦷"], "", "", ["tooth"], 45, 20, 15, 0],
      "1f9b8-200d-2640-fe0f": [["🦸‍♀️", "🦸‍♀"], "", "", ["female_superhero"], 45, 21, 15, 0],
      "1f9b8-200d-2642-fe0f": [["🦸‍♂️", "🦸‍♂"], "", "", ["male_superhero"], 45, 27, 15, 0],
      "1f9b8": [["🦸"], "", "", ["superhero"], 45, 33, 15, 0],
      "1f9b9-200d-2640-fe0f": [["🦹‍♀️", "🦹‍♀"], "", "", ["female_supervillain"], 45, 39, 15, 0],
      "1f9b9-200d-2642-fe0f": [["🦹‍♂️", "🦹‍♂"], "", "", ["male_supervillain"], 45, 45, 15, 0],
      "1f9b9": [["🦹"], "", "", ["supervillain"], 45, 51, 15, 0],
      "1f9ba": [["🦺"], "", "", ["safety_vest"], 45, 57, 15, 0],
      "1f9bb": [["🦻"], "", "", ["ear_with_hearing_aid"], 45, 58, 15, 0],
      "1f9bc": [["🦼"], "", "", ["motorized_wheelchair"], 46, 3, 15, 0],
      "1f9bd": [["🦽"], "", "", ["manual_wheelchair"], 46, 4, 15, 0],
      "1f9be": [["🦾"], "", "", ["mechanical_arm"], 46, 5, 15, 0],
      "1f9bf": [["🦿"], "", "", ["mechanical_leg"], 46, 6, 15, 0],
      "1f9c0": [["🧀"], "", "", ["cheese_wedge"], 46, 7, 15, 0],
      "1f9c1": [["🧁"], "", "", ["cupcake"], 46, 8, 15, 0],
      "1f9c2": [["🧂"], "", "", ["salt"], 46, 9, 15, 0],
      "1f9c3": [["🧃"], "", "", ["beverage_box"], 46, 10, 15, 0],
      "1f9c4": [["🧄"], "", "", ["garlic"], 46, 11, 15, 0],
      "1f9c5": [["🧅"], "", "", ["onion"], 46, 12, 15, 0],
      "1f9c6": [["🧆"], "", "", ["falafel"], 46, 13, 15, 0],
      "1f9c7": [["🧇"], "", "", ["waffle"], 46, 14, 15, 0],
      "1f9c8": [["🧈"], "", "", ["butter"], 46, 15, 15, 0],
      "1f9c9": [["🧉"], "", "", ["mate_drink"], 46, 16, 15, 0],
      "1f9ca": [["🧊"], "", "", ["ice_cube"], 46, 17, 15, 0],
      "1f9cb": [["🧋"], "", "", ["bubble_tea"], 46, 18, 15, 0],
      "1f9cc": [["🧌"], "", "", ["troll"], 46, 19, 15, 0],
      "1f9cd-200d-2640-fe0f": [["🧍‍♀️", "🧍‍♀"], "", "", ["woman_standing"], 46, 20, 15, 0],
      "1f9cd-200d-2642-fe0f": [["🧍‍♂️", "🧍‍♂"], "", "", ["man_standing"], 46, 26, 15, 0],
      "1f9cd": [["🧍"], "", "", ["standing_person"], 46, 32, 15, 0],
      "1f9ce-200d-2640-fe0f": [["🧎‍♀️", "🧎‍♀"], "", "", ["woman_kneeling"], 46, 38, 15, 0],
      "1f9ce-200d-2642-fe0f": [["🧎‍♂️", "🧎‍♂"], "", "", ["man_kneeling"], 46, 44, 15, 0],
      "1f9ce": [["🧎"], "", "", ["kneeling_person"], 46, 50, 15, 0],
      "1f9cf-200d-2640-fe0f": [["🧏‍♀️", "🧏‍♀"], "", "", ["deaf_woman"], 46, 56, 15, 0],
      "1f9cf-200d-2642-fe0f": [["🧏‍♂️", "🧏‍♂"], "", "", ["deaf_man"], 47, 1, 15, 0],
      "1f9cf": [["🧏"], "", "", ["deaf_person"], 47, 7, 15, 0],
      "1f9d0": [["🧐"], "", "", ["face_with_monocle"], 47, 13, 15, 0],
      "1f9d1-200d-1f33e": [["🧑‍🌾"], "", "", ["farmer"], 47, 14, 15, 0],
      "1f9d1-200d-1f373": [["🧑‍🍳"], "", "", ["cook"], 47, 20, 15, 0],
      "1f9d1-200d-1f37c": [["🧑‍🍼"], "", "", ["person_feeding_baby"], 47, 26, 15, 0],
      "1f9d1-200d-1f384": [["🧑‍🎄"], "", "", ["mx_claus"], 47, 32, 15, 0],
      "1f9d1-200d-1f393": [["🧑‍🎓"], "", "", ["student"], 47, 38, 15, 0],
      "1f9d1-200d-1f3a4": [["🧑‍🎤"], "", "", ["singer"], 47, 44, 15, 0],
      "1f9d1-200d-1f3a8": [["🧑‍🎨"], "", "", ["artist"], 47, 50, 15, 0],
      "1f9d1-200d-1f3eb": [["🧑‍🏫"], "", "", ["teacher"], 47, 56, 15, 0],
      "1f9d1-200d-1f3ed": [["🧑‍🏭"], "", "", ["factory_worker"], 48, 1, 15, 0],
      "1f9d1-200d-1f4bb": [["🧑‍💻"], "", "", ["technologist"], 48, 7, 15, 0],
      "1f9d1-200d-1f4bc": [["🧑‍💼"], "", "", ["office_worker"], 48, 13, 15, 0],
      "1f9d1-200d-1f527": [["🧑‍🔧"], "", "", ["mechanic"], 48, 19, 15, 0],
      "1f9d1-200d-1f52c": [["🧑‍🔬"], "", "", ["scientist"], 48, 25, 15, 0],
      "1f9d1-200d-1f680": [["🧑‍🚀"], "", "", ["astronaut"], 48, 31, 15, 0],
      "1f9d1-200d-1f692": [["🧑‍🚒"], "", "", ["firefighter"], 48, 37, 15, 0],
      "1f9d1-200d-1f91d-200d-1f9d1": [["🧑‍🤝‍🧑"], "", "", ["people_holding_hands"], 48, 43, 15, 0],
      "1f9d1-200d-1f9af": [["🧑‍🦯"], "", "", ["person_with_probing_cane"], 49, 8, 15, 0],
      "1f9d1-200d-1f9b0": [["🧑‍🦰"], "", "", ["red_haired_person"], 49, 14, 15, 0],
      "1f9d1-200d-1f9b1": [["🧑‍🦱"], "", "", ["curly_haired_person"], 49, 20, 15, 0],
      "1f9d1-200d-1f9b2": [["🧑‍🦲"], "", "", ["bald_person"], 49, 26, 15, 0],
      "1f9d1-200d-1f9b3": [["🧑‍🦳"], "", "", ["white_haired_person"], 49, 32, 15, 0],
      "1f9d1-200d-1f9bc": [["🧑‍🦼"], "", "", ["person_in_motorized_wheelchair"], 49, 38, 15, 0],
      "1f9d1-200d-1f9bd": [["🧑‍🦽"], "", "", ["person_in_manual_wheelchair"], 49, 44, 15, 0],
      "1f9d1-200d-2695-fe0f": [["🧑‍⚕️", "🧑‍⚕"], "", "", ["health_worker"], 49, 50, 15, 0],
      "1f9d1-200d-2696-fe0f": [["🧑‍⚖️", "🧑‍⚖"], "", "", ["judge"], 49, 56, 15, 0],
      "1f9d1-200d-2708-fe0f": [["🧑‍✈️", "🧑‍✈"], "", "", ["pilot"], 50, 1, 15, 0],
      "1f9d1": [["🧑"], "", "", ["adult"], 50, 7, 15, 0],
      "1f9d2": [["🧒"], "", "", ["child"], 50, 13, 15, 0],
      "1f9d3": [["🧓"], "", "", ["older_adult"], 50, 19, 15, 0],
      "1f9d4-200d-2640-fe0f": [["🧔‍♀️", "🧔‍♀"], "", "", ["woman_with_beard"], 50, 25, 15, 0],
      "1f9d4-200d-2642-fe0f": [["🧔‍♂️", "🧔‍♂"], "", "", ["man_with_beard"], 50, 31, 15, 0],
      "1f9d4": [["🧔"], "", "", ["bearded_person"], 50, 37, 15, 0],
      "1f9d5": [["🧕"], "", "", ["person_with_headscarf"], 50, 43, 15, 0],
      "1f9d6-200d-2640-fe0f": [["🧖‍♀️", "🧖‍♀"], "", "", ["woman_in_steamy_room"], 50, 49, 15, 0],
      "1f9d6-200d-2642-fe0f": [["🧖‍♂️", "🧖‍♂", "🧖"], "", "", ["man_in_steamy_room", "person_in_steamy_room"], 50, 55, 15, 0],
      "1f9d7-200d-2640-fe0f": [["🧗‍♀️", "🧗‍♀", "🧗"], "", "", ["woman_climbing", "person_climbing"], 51, 6, 15, 0],
      "1f9d7-200d-2642-fe0f": [["🧗‍♂️", "🧗‍♂"], "", "", ["man_climbing"], 51, 12, 15, 0],
      "1f9d8-200d-2640-fe0f": [["🧘‍♀️", "🧘‍♀", "🧘"], "", "", ["woman_in_lotus_position", "person_in_lotus_position"], 51, 24, 15, 0],
      "1f9d8-200d-2642-fe0f": [["🧘‍♂️", "🧘‍♂"], "", "", ["man_in_lotus_position"], 51, 30, 15, 0],
      "1f9d9-200d-2640-fe0f": [["🧙‍♀️", "🧙‍♀", "🧙"], "", "", ["female_mage", "mage"], 51, 42, 15, 0],
      "1f9d9-200d-2642-fe0f": [["🧙‍♂️", "🧙‍♂"], "", "", ["male_mage"], 51, 48, 15, 0],
      "1f9da-200d-2640-fe0f": [["🧚‍♀️", "🧚‍♀", "🧚"], "", "", ["female_fairy", "fairy"], 51, 60, 15, 0],
      "1f9da-200d-2642-fe0f": [["🧚‍♂️", "🧚‍♂"], "", "", ["male_fairy"], 52, 5, 15, 0],
      "1f9db-200d-2640-fe0f": [["🧛‍♀️", "🧛‍♀", "🧛"], "", "", ["female_vampire", "vampire"], 52, 17, 15, 0],
      "1f9db-200d-2642-fe0f": [["🧛‍♂️", "🧛‍♂"], "", "", ["male_vampire"], 52, 23, 15, 0],
      "1f9dc-200d-2640-fe0f": [["🧜‍♀️", "🧜‍♀"], "", "", ["mermaid"], 52, 35, 15, 0],
      "1f9dc-200d-2642-fe0f": [["🧜‍♂️", "🧜‍♂", "🧜"], "", "", ["merman", "merperson"], 52, 41, 15, 0],
      "1f9dd-200d-2640-fe0f": [["🧝‍♀️", "🧝‍♀"], "", "", ["female_elf"], 52, 53, 15, 0],
      "1f9dd-200d-2642-fe0f": [["🧝‍♂️", "🧝‍♂", "🧝"], "", "", ["male_elf", "elf"], 52, 59, 15, 0],
      "1f9de-200d-2640-fe0f": [["🧞‍♀️", "🧞‍♀"], "", "", ["female_genie"], 53, 10, 15, 0],
      "1f9de-200d-2642-fe0f": [["🧞‍♂️", "🧞‍♂", "🧞"], "", "", ["male_genie", "genie"], 53, 11, 15, 0],
      "1f9df-200d-2640-fe0f": [["🧟‍♀️", "🧟‍♀"], "", "", ["female_zombie"], 53, 13, 15, 0],
      "1f9df-200d-2642-fe0f": [["🧟‍♂️", "🧟‍♂", "🧟"], "", "", ["male_zombie", "zombie"], 53, 14, 15, 0],
      "1f9e0": [["🧠"], "", "", ["brain"], 53, 16, 15, 0],
      "1f9e1": [["🧡"], "", "", ["orange_heart"], 53, 17, 15, 0],
      "1f9e2": [["🧢"], "", "", ["billed_cap"], 53, 18, 15, 0],
      "1f9e3": [["🧣"], "", "", ["scarf"], 53, 19, 15, 0],
      "1f9e4": [["🧤"], "", "", ["gloves"], 53, 20, 15, 0],
      "1f9e5": [["🧥"], "", "", ["coat"], 53, 21, 15, 0],
      "1f9e6": [["🧦"], "", "", ["socks"], 53, 22, 15, 0],
      "1f9e7": [["🧧"], "", "", ["red_envelope"], 53, 23, 15, 0],
      "1f9e8": [["🧨"], "", "", ["firecracker"], 53, 24, 15, 0],
      "1f9e9": [["🧩"], "", "", ["jigsaw"], 53, 25, 15, 0],
      "1f9ea": [["🧪"], "", "", ["test_tube"], 53, 26, 15, 0],
      "1f9eb": [["🧫"], "", "", ["petri_dish"], 53, 27, 15, 0],
      "1f9ec": [["🧬"], "", "", ["dna"], 53, 28, 15, 0],
      "1f9ed": [["🧭"], "", "", ["compass"], 53, 29, 15, 0],
      "1f9ee": [["🧮"], "", "", ["abacus"], 53, 30, 15, 0],
      "1f9ef": [["🧯"], "", "", ["fire_extinguisher"], 53, 31, 15, 0],
      "1f9f0": [["🧰"], "", "", ["toolbox"], 53, 32, 15, 0],
      "1f9f1": [["🧱"], "", "", ["bricks"], 53, 33, 15, 0],
      "1f9f2": [["🧲"], "", "", ["magnet"], 53, 34, 15, 0],
      "1f9f3": [["🧳"], "", "", ["luggage"], 53, 35, 15, 0],
      "1f9f4": [["🧴"], "", "", ["lotion_bottle"], 53, 36, 15, 0],
      "1f9f5": [["🧵"], "", "", ["thread"], 53, 37, 15, 0],
      "1f9f6": [["🧶"], "", "", ["yarn"], 53, 38, 15, 0],
      "1f9f7": [["🧷"], "", "", ["safety_pin"], 53, 39, 15, 0],
      "1f9f8": [["🧸"], "", "", ["teddy_bear"], 53, 40, 15, 0],
      "1f9f9": [["🧹"], "", "", ["broom"], 53, 41, 15, 0],
      "1f9fa": [["🧺"], "", "", ["basket"], 53, 42, 15, 0],
      "1f9fb": [["🧻"], "", "", ["roll_of_paper"], 53, 43, 15, 0],
      "1f9fc": [["🧼"], "", "", ["soap"], 53, 44, 15, 0],
      "1f9fd": [["🧽"], "", "", ["sponge"], 53, 45, 15, 0],
      "1f9fe": [["🧾"], "", "", ["receipt"], 53, 46, 15, 0],
      "1f9ff": [["🧿"], "", "", ["nazar_amulet"], 53, 47, 15, 0],
      "1fa70": [["🩰"], "", "", ["ballet_shoes"], 53, 48, 15, 0],
      "1fa71": [["🩱"], "", "", ["one-piece_swimsuit"], 53, 49, 15, 0],
      "1fa72": [["🩲"], "", "", ["briefs"], 53, 50, 15, 0],
      "1fa73": [["🩳"], "", "", ["shorts"], 53, 51, 15, 0],
      "1fa74": [["🩴"], "", "", ["thong_sandal"], 53, 52, 15, 0],
      "1fa75": [["🩵"], "", "", ["light_blue_heart"], 53, 53, 3, 0],
      "1fa76": [["🩶"], "", "", ["grey_heart"], 53, 54, 3, 0],
      "1fa77": [["🩷"], "", "", ["pink_heart"], 53, 55, 3, 0],
      "1fa78": [["🩸"], "", "", ["drop_of_blood"], 53, 56, 15, 0],
      "1fa79": [["🩹"], "", "", ["adhesive_bandage"], 53, 57, 15, 0],
      "1fa7a": [["🩺"], "", "", ["stethoscope"], 53, 58, 15, 0],
      "1fa7b": [["🩻"], "", "", ["x-ray"], 53, 59, 15, 0],
      "1fa7c": [["🩼"], "", "", ["crutch"], 53, 60, 15, 0],
      "1fa80": [["🪀"], "", "", ["yo-yo"], 54, 0, 15, 0],
      "1fa81": [["🪁"], "", "", ["kite"], 54, 1, 15, 0],
      "1fa82": [["🪂"], "", "", ["parachute"], 54, 2, 15, 0],
      "1fa83": [["🪃"], "", "", ["boomerang"], 54, 3, 15, 0],
      "1fa84": [["🪄"], "", "", ["magic_wand"], 54, 4, 15, 0],
      "1fa85": [["🪅"], "", "", ["pinata"], 54, 5, 15, 0],
      "1fa86": [["🪆"], "", "", ["nesting_dolls"], 54, 6, 15, 0],
      "1fa87": [["🪇"], "", "", ["maracas"], 54, 7, 3, 0],
      "1fa88": [["🪈"], "", "", ["flute"], 54, 8, 3, 0],
      "1fa90": [["🪐"], "", "", ["ringed_planet"], 54, 9, 15, 0],
      "1fa91": [["🪑"], "", "", ["chair"], 54, 10, 15, 0],
      "1fa92": [["🪒"], "", "", ["razor"], 54, 11, 15, 0],
      "1fa93": [["🪓"], "", "", ["axe"], 54, 12, 15, 0],
      "1fa94": [["🪔"], "", "", ["diya_lamp"], 54, 13, 15, 0],
      "1fa95": [["🪕"], "", "", ["banjo"], 54, 14, 15, 0],
      "1fa96": [["🪖"], "", "", ["military_helmet"], 54, 15, 15, 0],
      "1fa97": [["🪗"], "", "", ["accordion"], 54, 16, 15, 0],
      "1fa98": [["🪘"], "", "", ["long_drum"], 54, 17, 15, 0],
      "1fa99": [["🪙"], "", "", ["coin"], 54, 18, 15, 0],
      "1fa9a": [["🪚"], "", "", ["carpentry_saw"], 54, 19, 15, 0],
      "1fa9b": [["🪛"], "", "", ["screwdriver"], 54, 20, 15, 0],
      "1fa9c": [["🪜"], "", "", ["ladder"], 54, 21, 15, 0],
      "1fa9d": [["🪝"], "", "", ["hook"], 54, 22, 15, 0],
      "1fa9e": [["🪞"], "", "", ["mirror"], 54, 23, 15, 0],
      "1fa9f": [["🪟"], "", "", ["window"], 54, 24, 15, 0],
      "1faa0": [["🪠"], "", "", ["plunger"], 54, 25, 15, 0],
      "1faa1": [["🪡"], "", "", ["sewing_needle"], 54, 26, 15, 0],
      "1faa2": [["🪢"], "", "", ["knot"], 54, 27, 15, 0],
      "1faa3": [["🪣"], "", "", ["bucket"], 54, 28, 15, 0],
      "1faa4": [["🪤"], "", "", ["mouse_trap"], 54, 29, 15, 0],
      "1faa5": [["🪥"], "", "", ["toothbrush"], 54, 30, 15, 0],
      "1faa6": [["🪦"], "", "", ["headstone"], 54, 31, 15, 0],
      "1faa7": [["🪧"], "", "", ["placard"], 54, 32, 15, 0],
      "1faa8": [["🪨"], "", "", ["rock"], 54, 33, 15, 0],
      "1faa9": [["🪩"], "", "", ["mirror_ball"], 54, 34, 15, 0],
      "1faaa": [["🪪"], "", "", ["identification_card"], 54, 35, 15, 0],
      "1faab": [["🪫"], "", "", ["low_battery"], 54, 36, 15, 0],
      "1faac": [["🪬"], "", "", ["hamsa"], 54, 37, 15, 0],
      "1faad": [["🪭"], "", "", ["folding_hand_fan"], 54, 38, 3, 0],
      "1faae": [["🪮"], "", "", ["hair_pick"], 54, 39, 3, 0],
      "1faaf": [["🪯"], "", "", ["khanda"], 54, 40, 3, 0],
      "1fab0": [["🪰"], "", "", ["fly"], 54, 41, 15, 0],
      "1fab1": [["🪱"], "", "", ["worm"], 54, 42, 15, 0],
      "1fab2": [["🪲"], "", "", ["beetle"], 54, 43, 15, 0],
      "1fab3": [["🪳"], "", "", ["cockroach"], 54, 44, 15, 0],
      "1fab4": [["🪴"], "", "", ["potted_plant"], 54, 45, 15, 0],
      "1fab5": [["🪵"], "", "", ["wood"], 54, 46, 15, 0],
      "1fab6": [["🪶"], "", "", ["feather"], 54, 47, 15, 0],
      "1fab7": [["🪷"], "", "", ["lotus"], 54, 48, 15, 0],
      "1fab8": [["🪸"], "", "", ["coral"], 54, 49, 15, 0],
      "1fab9": [["🪹"], "", "", ["empty_nest"], 54, 50, 15, 0],
      "1faba": [["🪺"], "", "", ["nest_with_eggs"], 54, 51, 15, 0],
      "1fabb": [["🪻"], "", "", ["hyacinth"], 54, 52, 3, 0],
      "1fabc": [["🪼"], "", "", ["jellyfish"], 54, 53, 3, 0],
      "1fabd": [["🪽"], "", "", ["wing"], 54, 54, 3, 0],
      "1fabf": [["🪿"], "", "", ["goose"], 54, 55, 3, 0],
      "1fac0": [["🫀"], "", "", ["anatomical_heart"], 54, 56, 15, 0],
      "1fac1": [["🫁"], "", "", ["lungs"], 54, 57, 15, 0],
      "1fac2": [["🫂"], "", "", ["people_hugging"], 54, 58, 15, 0],
      "1fac3": [["🫃"], "", "", ["pregnant_man"], 54, 59, 15, 0],
      "1fac4": [["🫄"], "", "", ["pregnant_person"], 55, 4, 15, 0],
      "1fac5": [["🫅"], "", "", ["person_with_crown"], 55, 10, 15, 0],
      "1face": [["🫎"], "", "", ["moose"], 55, 16, 3, 0],
      "1facf": [["🫏"], "", "", ["donkey"], 55, 17, 3, 0],
      "1fad0": [["🫐"], "", "", ["blueberries"], 55, 18, 15, 0],
      "1fad1": [["🫑"], "", "", ["bell_pepper"], 55, 19, 15, 0],
      "1fad2": [["🫒"], "", "", ["olive"], 55, 20, 15, 0],
      "1fad3": [["🫓"], "", "", ["flatbread"], 55, 21, 15, 0],
      "1fad4": [["🫔"], "", "", ["tamale"], 55, 22, 15, 0],
      "1fad5": [["🫕"], "", "", ["fondue"], 55, 23, 15, 0],
      "1fad6": [["🫖"], "", "", ["teapot"], 55, 24, 15, 0],
      "1fad7": [["🫗"], "", "", ["pouring_liquid"], 55, 25, 15, 0],
      "1fad8": [["🫘"], "", "", ["beans"], 55, 26, 15, 0],
      "1fad9": [["🫙"], "", "", ["jar"], 55, 27, 15, 0],
      "1fada": [["🫚"], "", "", ["ginger_root"], 55, 28, 3, 0],
      "1fadb": [["🫛"], "", "", ["pea_pod"], 55, 29, 3, 0],
      "1fae0": [["🫠"], "", "", ["melting_face"], 55, 30, 15, 0],
      "1fae1": [["🫡"], "", "", ["saluting_face"], 55, 31, 15, 0],
      "1fae2": [["🫢"], "", "", ["face_with_open_eyes_and_hand_over_mouth"], 55, 32, 15, 0],
      "1fae3": [["🫣"], "", "", ["face_with_peeking_eye"], 55, 33, 15, 0],
      "1fae4": [["🫤"], "", "", ["face_with_diagonal_mouth"], 55, 34, 15, 0],
      "1fae5": [["🫥"], "", "", ["dotted_line_face"], 55, 35, 15, 0],
      "1fae6": [["🫦"], "", "", ["biting_lip"], 55, 36, 15, 0],
      "1fae7": [["🫧"], "", "", ["bubbles"], 55, 37, 15, 0],
      "1fae8": [["🫨"], "", "", ["shaking_face"], 55, 38, 3, 0],
      "1faf0": [["🫰"], "", "", ["hand_with_index_finger_and_thumb_crossed"], 55, 39, 15, 0],
      "1faf1": [["🫱"], "", "", ["rightwards_hand"], 55, 45, 15, 0],
      "1faf2": [["🫲"], "", "", ["leftwards_hand"], 55, 51, 15, 0],
      "1faf3": [["🫳"], "", "", ["palm_down_hand"], 55, 57, 15, 0],
      "1faf4": [["🫴"], "", "", ["palm_up_hand"], 56, 2, 15, 0],
      "1faf5": [["🫵"], "", "", ["index_pointing_at_the_viewer"], 56, 8, 15, 0],
      "1faf6": [["🫶"], "", "", ["heart_hands"], 56, 14, 15, 0],
      "1faf7": [["🫷"], "", "", ["leftwards_pushing_hand"], 56, 20, 3, 0],
      "1faf8": [["🫸"], "", "", ["rightwards_pushing_hand"], 56, 26, 3, 0],
      "203c-fe0f": [["‼️", "‼"], "", "󾬆", ["bangbang"], 56, 32, 15, 0],
      "2049-fe0f": [["⁉️", "⁉"], "", "󾬅", ["interrobang"], 56, 33, 15, 0],
      "2122-fe0f": [["™️", "™"], "", "󾬪", ["tm"], 56, 34, 15, 0],
      "2139-fe0f": [["ℹ️", "ℹ"], "", "󾭇", ["information_source"], 56, 35, 15, 0],
      "2194-fe0f": [["↔️", "↔"], "", "󾫶", ["left_right_arrow"], 56, 36, 15, 0],
      "2195-fe0f": [["↕️", "↕"], "", "󾫷", ["arrow_up_down"], 56, 37, 15, 0],
      "2196-fe0f": [["↖️", "↖"], "", "󾫲", ["arrow_upper_left"], 56, 38, 15, 0],
      "2197-fe0f": [["↗️", "↗"], "", "󾫰", ["arrow_upper_right"], 56, 39, 15, 0],
      "2198-fe0f": [["↘️", "↘"], "", "󾫱", ["arrow_lower_right"], 56, 40, 15, 0],
      "2199-fe0f": [["↙️", "↙"], "", "󾫳", ["arrow_lower_left"], 56, 41, 15, 0],
      "21a9-fe0f": [["↩️", "↩"], "", "󾮃", ["leftwards_arrow_with_hook"], 56, 42, 15, 0],
      "21aa-fe0f": [["↪️", "↪"], "", "󾮈", ["arrow_right_hook"], 56, 43, 15, 0],
      "231a": [["⌚"], "", "󾀝", ["watch"], 56, 44, 15, 0],
      "231b": [["⌛"], "", "󾀜", ["hourglass"], 56, 45, 15, 0],
      "2328-fe0f": [["⌨️", "⌨"], "", "", ["keyboard"], 56, 46, 15, 0],
      "23cf-fe0f": [["⏏️", "⏏"], "", "", ["eject"], 56, 47, 15, 0],
      "23e9": [["⏩"], "", "󾫾", ["fast_forward"], 56, 48, 15, 0],
      "23ea": [["⏪"], "", "󾫿", ["rewind"], 56, 49, 15, 0],
      "23eb": [["⏫"], "", "󾬃", ["arrow_double_up"], 56, 50, 15, 0],
      "23ec": [["⏬"], "", "󾬂", ["arrow_double_down"], 56, 51, 15, 0],
      "23ed-fe0f": [["⏭️", "⏭"], "", "", ["black_right_pointing_double_triangle_with_vertical_bar"], 56, 52, 15, 0],
      "23ee-fe0f": [["⏮️", "⏮"], "", "", ["black_left_pointing_double_triangle_with_vertical_bar"], 56, 53, 15, 0],
      "23ef-fe0f": [["⏯️", "⏯"], "", "", ["black_right_pointing_triangle_with_double_vertical_bar"], 56, 54, 15, 0],
      "23f0": [["⏰"], "", "󾀪", ["alarm_clock"], 56, 55, 15, 0],
      "23f1-fe0f": [["⏱️", "⏱"], "", "", ["stopwatch"], 56, 56, 15, 0],
      "23f2-fe0f": [["⏲️", "⏲"], "", "", ["timer_clock"], 56, 57, 15, 0],
      "23f3": [["⏳"], "", "󾀛", ["hourglass_flowing_sand"], 56, 58, 15, 0],
      "23f8-fe0f": [["⏸️", "⏸"], "", "", ["double_vertical_bar"], 56, 59, 15, 0],
      "23f9-fe0f": [["⏹️", "⏹"], "", "", ["black_square_for_stop"], 56, 60, 15, 0],
      "23fa-fe0f": [["⏺️", "⏺"], "", "", ["black_circle_for_record"], 57, 0, 15, 0],
      "24c2-fe0f": [["Ⓜ️", "Ⓜ"], "", "󾟡", ["m"], 57, 1, 15, 0],
      "25aa-fe0f": [["▪️", "▪"], "", "󾭮", ["black_small_square"], 57, 2, 15, 0],
      "25ab-fe0f": [["▫️", "▫"], "", "󾭭", ["white_small_square"], 57, 3, 15, 0],
      "25b6-fe0f": [["▶️", "▶"], "", "󾫼", ["arrow_forward"], 57, 4, 15, 0],
      "25c0-fe0f": [["◀️", "◀"], "", "󾫽", ["arrow_backward"], 57, 5, 15, 0],
      "25fb-fe0f": [["◻️", "◻"], "", "󾭱", ["white_medium_square"], 57, 6, 15, 0],
      "25fc-fe0f": [["◼️", "◼"], "", "󾭲", ["black_medium_square"], 57, 7, 15, 0],
      "25fd": [["◽"], "", "󾭯", ["white_medium_small_square"], 57, 8, 15, 0],
      "25fe": [["◾"], "", "󾭰", ["black_medium_small_square"], 57, 9, 15, 0],
      "2600-fe0f": [["☀️", "☀"], "", "󾀀", ["sunny"], 57, 10, 15, 0],
      "2601-fe0f": [["☁️", "☁"], "", "󾀁", ["cloud"], 57, 11, 15, 0],
      "2602-fe0f": [["☂️", "☂"], "", "", ["umbrella"], 57, 12, 15, 0],
      "2603-fe0f": [["☃️", "☃"], "", "", ["snowman"], 57, 13, 15, 0],
      "2604-fe0f": [["☄️", "☄"], "", "", ["comet"], 57, 14, 15, 0],
      "260e-fe0f": [["☎️", "☎"], "", "󾔣", ["phone", "telephone"], 57, 15, 15, 0],
      "2611-fe0f": [["☑️", "☑"], "", "󾮋", ["ballot_box_with_check"], 57, 16, 15, 0],
      2614: [["☔"], "", "󾀂", ["umbrella_with_rain_drops"], 57, 17, 15, 0],
      2615: [["☕"], "", "󾦁", ["coffee"], 57, 18, 15, 0],
      "2618-fe0f": [["☘️", "☘"], "", "", ["shamrock"], 57, 19, 15, 0],
      "261d-fe0f": [["☝️", "☝"], "", "󾮘", ["point_up"], 57, 20, 15, 0],
      "2620-fe0f": [["☠️", "☠"], "", "", ["skull_and_crossbones"], 57, 26, 15, 0],
      "2622-fe0f": [["☢️", "☢"], "", "", ["radioactive_sign"], 57, 27, 15, 0],
      "2623-fe0f": [["☣️", "☣"], "", "", ["biohazard_sign"], 57, 28, 15, 0],
      "2626-fe0f": [["☦️", "☦"], "", "", ["orthodox_cross"], 57, 29, 15, 0],
      "262a-fe0f": [["☪️", "☪"], "", "", ["star_and_crescent"], 57, 30, 15, 0],
      "262e-fe0f": [["☮️", "☮"], "", "", ["peace_symbol"], 57, 31, 15, 0],
      "262f-fe0f": [["☯️", "☯"], "", "", ["yin_yang"], 57, 32, 15, 0],
      "2638-fe0f": [["☸️", "☸"], "", "", ["wheel_of_dharma"], 57, 33, 15, 0],
      "2639-fe0f": [["☹️", "☹"], "", "", ["white_frowning_face"], 57, 34, 15, 0],
      "263a-fe0f": [["☺️", "☺"], "", "󾌶", ["relaxed"], 57, 35, 15, 0],
      "2640-fe0f": [["♀️", "♀"], "", "", ["female_sign"], 57, 36, 14, 0],
      "2642-fe0f": [["♂️", "♂"], "", "", ["male_sign"], 57, 37, 14, 0],
      2648: [["♈"], "", "󾀫", ["aries"], 57, 38, 15, 0],
      2649: [["♉"], "", "󾀬", ["taurus"], 57, 39, 15, 0],
      "264a": [["♊"], "", "󾀭", ["gemini"], 57, 40, 15, 0],
      "264b": [["♋"], "", "󾀮", ["cancer"], 57, 41, 15, 0],
      "264c": [["♌"], "", "󾀯", ["leo"], 57, 42, 15, 0],
      "264d": [["♍"], "", "󾀰", ["virgo"], 57, 43, 15, 0],
      "264e": [["♎"], "", "󾀱", ["libra"], 57, 44, 15, 0],
      "264f": [["♏"], "", "󾀲", ["scorpius"], 57, 45, 15, 0],
      2650: [["♐"], "", "󾀳", ["sagittarius"], 57, 46, 15, 0],
      2651: [["♑"], "", "󾀴", ["capricorn"], 57, 47, 15, 0],
      2652: [["♒"], "", "󾀵", ["aquarius"], 57, 48, 15, 0],
      2653: [["♓"], "", "󾀶", ["pisces"], 57, 49, 15, 0],
      "265f-fe0f": [["♟️", "♟"], "", "", ["chess_pawn"], 57, 50, 15, 0],
      "2660-fe0f": [["♠️", "♠"], "", "󾬛", ["spades"], 57, 51, 15, 0],
      "2663-fe0f": [["♣️", "♣"], "", "󾬝", ["clubs"], 57, 52, 15, 0],
      "2665-fe0f": [["♥️", "♥"], "", "󾬚", ["hearts"], 57, 53, 15, 0],
      "2666-fe0f": [["♦️", "♦"], "", "󾬜", ["diamonds"], 57, 54, 15, 0],
      "2668-fe0f": [["♨️", "♨"], "", "󾟺", ["hotsprings"], 57, 55, 15, 0],
      "267b-fe0f": [["♻️", "♻"], "", "󾬬", ["recycle"], 57, 56, 15, 0],
      "267e-fe0f": [["♾️", "♾"], "", "", ["infinity"], 57, 57, 15, 0],
      "267f": [["♿"], "", "󾬠", ["wheelchair"], 57, 58, 15, 0],
      "2692-fe0f": [["⚒️", "⚒"], "", "", ["hammer_and_pick"], 57, 59, 15, 0],
      2693: [["⚓"], "", "󾓁", ["anchor"], 57, 60, 15, 0],
      "2694-fe0f": [["⚔️", "⚔"], "", "", ["crossed_swords"], 58, 0, 15, 0],
      "2695-fe0f": [["⚕️", "⚕"], "", "", ["medical_symbol", "staff_of_aesculapius"], 58, 1, 14, 0],
      "2696-fe0f": [["⚖️", "⚖"], "", "", ["scales"], 58, 2, 15, 0],
      "2697-fe0f": [["⚗️", "⚗"], "", "", ["alembic"], 58, 3, 15, 0],
      "2699-fe0f": [["⚙️", "⚙"], "", "", ["gear"], 58, 4, 15, 0],
      "269b-fe0f": [["⚛️", "⚛"], "", "", ["atom_symbol"], 58, 5, 15, 0],
      "269c-fe0f": [["⚜️", "⚜"], "", "", ["fleur_de_lis"], 58, 6, 15, 0],
      "26a0-fe0f": [["⚠️", "⚠"], "", "󾬣", ["warning"], 58, 7, 15, 0],
      "26a1": [["⚡"], "", "󾀄", ["zap"], 58, 8, 15, 0],
      "26a7-fe0f": [["⚧️", "⚧"], "", "", ["transgender_symbol"], 58, 9, 15, 0],
      "26aa": [["⚪"], "", "󾭥", ["white_circle"], 58, 10, 15, 0],
      "26ab": [["⚫"], "", "󾭦", ["black_circle"], 58, 11, 15, 0],
      "26b0-fe0f": [["⚰️", "⚰"], "", "", ["coffin"], 58, 12, 15, 0],
      "26b1-fe0f": [["⚱️", "⚱"], "", "", ["funeral_urn"], 58, 13, 15, 0],
      "26bd": [["⚽"], "", "󾟔", ["soccer"], 58, 14, 15, 0],
      "26be": [["⚾"], "", "󾟑", ["baseball"], 58, 15, 15, 0],
      "26c4": [["⛄"], "", "󾀃", ["snowman_without_snow"], 58, 16, 15, 0],
      "26c5": [["⛅"], "", "󾀏", ["partly_sunny"], 58, 17, 15, 0],
      "26c8-fe0f": [["⛈️", "⛈"], "", "", ["thunder_cloud_and_rain"], 58, 18, 15, 0],
      "26ce": [["⛎"], "", "󾀷", ["ophiuchus"], 58, 19, 15, 0],
      "26cf-fe0f": [["⛏️", "⛏"], "", "", ["pick"], 58, 20, 15, 0],
      "26d1-fe0f": [["⛑️", "⛑"], "", "", ["helmet_with_white_cross"], 58, 21, 15, 0],
      "26d3-fe0f": [["⛓️", "⛓"], "", "", ["chains"], 58, 22, 15, 0],
      "26d4": [["⛔"], "", "󾬦", ["no_entry"], 58, 23, 15, 0],
      "26e9-fe0f": [["⛩️", "⛩"], "", "", ["shinto_shrine"], 58, 24, 15, 0],
      "26ea": [["⛪"], "", "󾒻", ["church"], 58, 25, 15, 0],
      "26f0-fe0f": [["⛰️", "⛰"], "", "", ["mountain"], 58, 26, 15, 0],
      "26f1-fe0f": [["⛱️", "⛱"], "", "", ["umbrella_on_ground"], 58, 27, 15, 0],
      "26f2": [["⛲"], "", "󾒼", ["fountain"], 58, 28, 15, 0],
      "26f3": [["⛳"], "", "󾟒", ["golf"], 58, 29, 15, 0],
      "26f4-fe0f": [["⛴️", "⛴"], "", "", ["ferry"], 58, 30, 15, 0],
      "26f5": [["⛵"], "", "󾟪", ["boat", "sailboat"], 58, 31, 15, 0],
      "26f7-fe0f": [["⛷️", "⛷"], "", "", ["skier"], 58, 32, 15, 0],
      "26f8-fe0f": [["⛸️", "⛸"], "", "", ["ice_skate"], 58, 33, 15, 0],
      "26f9-fe0f-200d-2640-fe0f": [["⛹️‍♀️"], "", "", ["woman-bouncing-ball"], 58, 34, 7, 0],
      "26f9-fe0f-200d-2642-fe0f": [["⛹️‍♂️", "⛹️", "⛹"], "", "", ["man-bouncing-ball", "person_with_ball"], 58, 40, 7, 0],
      "26fa": [["⛺"], "", "󾟻", ["tent"], 58, 52, 15, 0],
      "26fd": [["⛽"], "", "󾟵", ["fuelpump"], 58, 53, 15, 0],
      "2702-fe0f": [["✂️", "✂"], "", "󾔾", ["scissors"], 58, 54, 15, 0],
      2705: [["✅"], "", "󾭊", ["white_check_mark"], 58, 55, 15, 0],
      "2708-fe0f": [["✈️", "✈"], "", "󾟩", ["airplane"], 58, 56, 15, 0],
      "2709-fe0f": [["✉️", "✉"], "", "󾔩", ["email", "envelope"], 58, 57, 15, 0],
      "270a": [["✊"], "", "󾮓", ["fist"], 58, 58, 15, 0],
      "270b": [["✋"], "", "󾮕", ["hand", "raised_hand"], 59, 3, 15, 0],
      "270c-fe0f": [["✌️", "✌"], "", "󾮔", ["v"], 59, 9, 15, 0],
      "270d-fe0f": [["✍️", "✍"], "", "", ["writing_hand"], 59, 15, 15, 0],
      "270f-fe0f": [["✏️", "✏"], "", "󾔹", ["pencil2"], 59, 21, 15, 0],
      "2712-fe0f": [["✒️", "✒"], "", "󾔶", ["black_nib"], 59, 22, 15, 0],
      "2714-fe0f": [["✔️", "✔"], "", "󾭉", ["heavy_check_mark"], 59, 23, 15, 0],
      "2716-fe0f": [["✖️", "✖"], "", "󾭓", ["heavy_multiplication_x"], 59, 24, 15, 0],
      "271d-fe0f": [["✝️", "✝"], "", "", ["latin_cross"], 59, 25, 15, 0],
      "2721-fe0f": [["✡️", "✡"], "", "", ["star_of_david"], 59, 26, 15, 0],
      2728: [["✨"], "", "󾭠", ["sparkles"], 59, 27, 15, 0],
      "2733-fe0f": [["✳️", "✳"], "", "󾭢", ["eight_spoked_asterisk"], 59, 28, 15, 0],
      "2734-fe0f": [["✴️", "✴"], "", "󾭡", ["eight_pointed_black_star"], 59, 29, 15, 0],
      "2744-fe0f": [["❄️", "❄"], "", "󾀎", ["snowflake"], 59, 30, 15, 0],
      "2747-fe0f": [["❇️", "❇"], "", "󾭷", ["sparkle"], 59, 31, 15, 0],
      "274c": [["❌"], "", "󾭅", ["x"], 59, 32, 15, 0],
      "274e": [["❎"], "", "󾭆", ["negative_squared_cross_mark"], 59, 33, 15, 0],
      2753: [["❓"], "", "󾬉", ["question"], 59, 34, 15, 0],
      2754: [["❔"], "", "󾬊", ["grey_question"], 59, 35, 15, 0],
      2755: [["❕"], "", "󾬋", ["grey_exclamation"], 59, 36, 15, 0],
      2757: [["❗"], "", "󾬄", ["exclamation", "heavy_exclamation_mark"], 59, 37, 15, 0],
      "2763-fe0f": [["❣️", "❣"], "", "", ["heavy_heart_exclamation_mark_ornament"], 59, 38, 15, 0],
      "2764-fe0f-200d-1f525": [["❤️‍🔥", "❤‍🔥"], "", "", ["heart_on_fire"], 59, 39, 15, 0],
      "2764-fe0f-200d-1fa79": [["❤️‍🩹", "❤‍🩹"], "", "", ["mending_heart"], 59, 40, 15, 0],
      "2764-fe0f": [["❤️", "❤"], "", "󾬌", ["heart"], 59, 41, 15, 0, "<3"],
      2795: [["➕"], "", "󾭑", ["heavy_plus_sign"], 59, 42, 15, 0],
      2796: [["➖"], "", "󾭒", ["heavy_minus_sign"], 59, 43, 15, 0],
      2797: [["➗"], "", "󾭔", ["heavy_division_sign"], 59, 44, 15, 0],
      "27a1-fe0f": [["➡️", "➡"], "", "󾫺", ["arrow_right"], 59, 45, 15, 0],
      "27b0": [["➰"], "", "󾬈", ["curly_loop"], 59, 46, 15, 0],
      "27bf": [["➿"], "", "󾠫", ["loop"], 59, 47, 15, 0],
      "2934-fe0f": [["⤴️", "⤴"], "", "󾫴", ["arrow_heading_up"], 59, 48, 15, 0],
      "2935-fe0f": [["⤵️", "⤵"], "", "󾫵", ["arrow_heading_down"], 59, 49, 15, 0],
      "2b05-fe0f": [["⬅️", "⬅"], "", "󾫻", ["arrow_left"], 59, 50, 15, 0],
      "2b06-fe0f": [["⬆️", "⬆"], "", "󾫸", ["arrow_up"], 59, 51, 15, 0],
      "2b07-fe0f": [["⬇️", "⬇"], "", "󾫹", ["arrow_down"], 59, 52, 15, 0],
      "2b1b": [["⬛"], "", "󾭬", ["black_large_square"], 59, 53, 15, 0],
      "2b1c": [["⬜"], "", "󾭫", ["white_large_square"], 59, 54, 15, 0],
      "2b50": [["⭐"], "", "󾭨", ["star"], 59, 55, 15, 0],
      "2b55": [["⭕"], "", "󾭄", ["o"], 59, 56, 15, 0],
      "3030-fe0f": [["〰️", "〰"], "", "󾬇", ["wavy_dash"], 59, 57, 15, 0],
      "303d-fe0f": [["〽️", "〽"], "", "󾠛", ["part_alternation_mark"], 59, 58, 15, 0],
      "3297-fe0f": [["㊗️", "㊗"], "", "󾭃", ["congratulations"], 59, 59, 15, 0],
      "3299-fe0f": [["㊙️", "㊙"], "", "󾬫", ["secret"], 59, 60, 15, 0]
    }, t.prototype.emoticons_data = {
      ":o)": "monkey_face",
      "</3": "broken_heart",
      "=)": "smiley",
      "=-)": "smiley",
      "C:": "smile",
      "c:": "smile",
      ":D": "smile",
      ":-D": "smile",
      ":>": "laughing",
      ":->": "laughing",
      ";)": "wink",
      ";-)": "wink",
      "8)": "sunglasses",
      ":|": "neutral_face",
      ":-|": "neutral_face",
      ":\\": "confused",
      ":-\\": "confused",
      ":/": "confused",
      ":-/": "confused",
      ":*": "kissing_heart",
      ":-*": "kissing_heart",
      ":p": "stuck_out_tongue",
      ":-p": "stuck_out_tongue",
      ":P": "stuck_out_tongue",
      ":-P": "stuck_out_tongue",
      ":b": "stuck_out_tongue",
      ":-b": "stuck_out_tongue",
      ";p": "stuck_out_tongue_winking_eye",
      ";-p": "stuck_out_tongue_winking_eye",
      ";b": "stuck_out_tongue_winking_eye",
      ";-b": "stuck_out_tongue_winking_eye",
      ";P": "stuck_out_tongue_winking_eye",
      ";-P": "stuck_out_tongue_winking_eye",
      "):": "disappointed",
      ":(": "disappointed",
      ":-(": "disappointed",
      ">:(": "angry",
      ">:-(": "angry",
      ":'(": "cry",
      "D:": "anguished",
      ":o": "open_mouth",
      ":-o": "open_mouth",
      ":O": "open_mouth",
      ":-O": "open_mouth",
      ":)": "slightly_smiling_face",
      "(:": "slightly_smiling_face",
      ":-)": "slightly_smiling_face",
      "<3": "heart"
    }, t.prototype.variations_data = {
      "1f385": { "1f3fb": ["1f385-1f3fb", 7, 9, 15, ["🎅🏻"]], "1f3fc": ["1f385-1f3fc", 7, 10, 15, ["🎅🏼"]], "1f3fd": ["1f385-1f3fd", 7, 11, 15, ["🎅🏽"]], "1f3fe": ["1f385-1f3fe", 7, 12, 15, ["🎅🏾"]], "1f3ff": ["1f385-1f3ff", 7, 13, 15, ["🎅🏿"]] },
      "1f3c2": { "1f3fb": ["1f3c2-1f3fb", 8, 9, 15, ["🏂🏻"]], "1f3fc": ["1f3c2-1f3fc", 8, 10, 15, ["🏂🏼"]], "1f3fd": ["1f3c2-1f3fd", 8, 11, 15, ["🏂🏽"]], "1f3fe": ["1f3c2-1f3fe", 8, 12, 15, ["🏂🏾"]], "1f3ff": ["1f3c2-1f3ff", 8, 13, 15, ["🏂🏿"]] },
      "1f3c3-200d-2640-fe0f": { "1f3fb": ["1f3c3-1f3fb-200d-2640-fe0f", 8, 15, 15, ["🏃🏻‍♀️"]], "1f3fc": ["1f3c3-1f3fc-200d-2640-fe0f", 8, 16, 15, ["🏃🏼‍♀️"]], "1f3fd": ["1f3c3-1f3fd-200d-2640-fe0f", 8, 17, 15, ["🏃🏽‍♀️"]], "1f3fe": ["1f3c3-1f3fe-200d-2640-fe0f", 8, 18, 15, ["🏃🏾‍♀️"]], "1f3ff": ["1f3c3-1f3ff-200d-2640-fe0f", 8, 19, 15, ["🏃🏿‍♀️"]] },
      "1f3c3-200d-2642-fe0f": { "1f3fb": ["1f3c3-1f3fb-200d-2642-fe0f", 8, 21, 15, ["🏃🏻‍♂️", "🏃🏻"]], "1f3fc": ["1f3c3-1f3fc-200d-2642-fe0f", 8, 22, 15, ["🏃🏼‍♂️", "🏃🏼"]], "1f3fd": ["1f3c3-1f3fd-200d-2642-fe0f", 8, 23, 15, ["🏃🏽‍♂️", "🏃🏽"]], "1f3fe": ["1f3c3-1f3fe-200d-2642-fe0f", 8, 24, 15, ["🏃🏾‍♂️", "🏃🏾"]], "1f3ff": ["1f3c3-1f3ff-200d-2642-fe0f", 8, 25, 15, ["🏃🏿‍♂️", "🏃🏿"]] },
      "1f3c4-200d-2640-fe0f": { "1f3fb": ["1f3c4-1f3fb-200d-2640-fe0f", 8, 33, 15, ["🏄🏻‍♀️"]], "1f3fc": ["1f3c4-1f3fc-200d-2640-fe0f", 8, 34, 15, ["🏄🏼‍♀️"]], "1f3fd": ["1f3c4-1f3fd-200d-2640-fe0f", 8, 35, 15, ["🏄🏽‍♀️"]], "1f3fe": ["1f3c4-1f3fe-200d-2640-fe0f", 8, 36, 15, ["🏄🏾‍♀️"]], "1f3ff": ["1f3c4-1f3ff-200d-2640-fe0f", 8, 37, 15, ["🏄🏿‍♀️"]] },
      "1f3c4-200d-2642-fe0f": { "1f3fb": ["1f3c4-1f3fb-200d-2642-fe0f", 8, 39, 15, ["🏄🏻‍♂️", "🏄🏻"]], "1f3fc": ["1f3c4-1f3fc-200d-2642-fe0f", 8, 40, 15, ["🏄🏼‍♂️", "🏄🏼"]], "1f3fd": ["1f3c4-1f3fd-200d-2642-fe0f", 8, 41, 15, ["🏄🏽‍♂️", "🏄🏽"]], "1f3fe": ["1f3c4-1f3fe-200d-2642-fe0f", 8, 42, 15, ["🏄🏾‍♂️", "🏄🏾"]], "1f3ff": ["1f3c4-1f3ff-200d-2642-fe0f", 8, 43, 15, ["🏄🏿‍♂️", "🏄🏿"]] },
      "1f3c7": { "1f3fb": ["1f3c7-1f3fb", 8, 53, 15, ["🏇🏻"]], "1f3fc": ["1f3c7-1f3fc", 8, 54, 15, ["🏇🏼"]], "1f3fd": ["1f3c7-1f3fd", 8, 55, 15, ["🏇🏽"]], "1f3fe": ["1f3c7-1f3fe", 8, 56, 15, ["🏇🏾"]], "1f3ff": ["1f3c7-1f3ff", 8, 57, 15, ["🏇🏿"]] },
      "1f3ca-200d-2640-fe0f": { "1f3fb": ["1f3ca-1f3fb-200d-2640-fe0f", 9, 0, 15, ["🏊🏻‍♀️"]], "1f3fc": ["1f3ca-1f3fc-200d-2640-fe0f", 9, 1, 15, ["🏊🏼‍♀️"]], "1f3fd": ["1f3ca-1f3fd-200d-2640-fe0f", 9, 2, 15, ["🏊🏽‍♀️"]], "1f3fe": ["1f3ca-1f3fe-200d-2640-fe0f", 9, 3, 15, ["🏊🏾‍♀️"]], "1f3ff": ["1f3ca-1f3ff-200d-2640-fe0f", 9, 4, 15, ["🏊🏿‍♀️"]] },
      "1f3ca-200d-2642-fe0f": { "1f3fb": ["1f3ca-1f3fb-200d-2642-fe0f", 9, 6, 15, ["🏊🏻‍♂️", "🏊🏻"]], "1f3fc": ["1f3ca-1f3fc-200d-2642-fe0f", 9, 7, 15, ["🏊🏼‍♂️", "🏊🏼"]], "1f3fd": ["1f3ca-1f3fd-200d-2642-fe0f", 9, 8, 15, ["🏊🏽‍♂️", "🏊🏽"]], "1f3fe": ["1f3ca-1f3fe-200d-2642-fe0f", 9, 9, 15, ["🏊🏾‍♂️", "🏊🏾"]], "1f3ff": ["1f3ca-1f3ff-200d-2642-fe0f", 9, 10, 15, ["🏊🏿‍♂️", "🏊🏿"]] },
      "1f3cb-fe0f-200d-2640-fe0f": { "1f3fb": ["1f3cb-1f3fb-200d-2640-fe0f", 9, 18, 15, ["🏋🏻‍♀️"]], "1f3fc": ["1f3cb-1f3fc-200d-2640-fe0f", 9, 19, 15, ["🏋🏼‍♀️"]], "1f3fd": ["1f3cb-1f3fd-200d-2640-fe0f", 9, 20, 15, ["🏋🏽‍♀️"]], "1f3fe": ["1f3cb-1f3fe-200d-2640-fe0f", 9, 21, 15, ["🏋🏾‍♀️"]], "1f3ff": ["1f3cb-1f3ff-200d-2640-fe0f", 9, 22, 15, ["🏋🏿‍♀️"]] },
      "1f3cb-fe0f-200d-2642-fe0f": { "1f3fb": ["1f3cb-1f3fb-200d-2642-fe0f", 9, 24, 15, ["🏋🏻‍♂️", "🏋🏻"]], "1f3fc": ["1f3cb-1f3fc-200d-2642-fe0f", 9, 25, 15, ["🏋🏼‍♂️", "🏋🏼"]], "1f3fd": ["1f3cb-1f3fd-200d-2642-fe0f", 9, 26, 15, ["🏋🏽‍♂️", "🏋🏽"]], "1f3fe": ["1f3cb-1f3fe-200d-2642-fe0f", 9, 27, 15, ["🏋🏾‍♂️", "🏋🏾"]], "1f3ff": ["1f3cb-1f3ff-200d-2642-fe0f", 9, 28, 15, ["🏋🏿‍♂️", "🏋🏿"]] },
      "1f3cc-fe0f-200d-2640-fe0f": { "1f3fb": ["1f3cc-1f3fb-200d-2640-fe0f", 9, 36, 15, ["🏌🏻‍♀️"]], "1f3fc": ["1f3cc-1f3fc-200d-2640-fe0f", 9, 37, 15, ["🏌🏼‍♀️"]], "1f3fd": ["1f3cc-1f3fd-200d-2640-fe0f", 9, 38, 15, ["🏌🏽‍♀️"]], "1f3fe": ["1f3cc-1f3fe-200d-2640-fe0f", 9, 39, 15, ["🏌🏾‍♀️"]], "1f3ff": ["1f3cc-1f3ff-200d-2640-fe0f", 9, 40, 15, ["🏌🏿‍♀️"]] },
      "1f3cc-fe0f-200d-2642-fe0f": { "1f3fb": ["1f3cc-1f3fb-200d-2642-fe0f", 9, 42, 15, ["🏌🏻‍♂️", "🏌🏻"]], "1f3fc": ["1f3cc-1f3fc-200d-2642-fe0f", 9, 43, 15, ["🏌🏼‍♂️", "🏌🏼"]], "1f3fd": ["1f3cc-1f3fd-200d-2642-fe0f", 9, 44, 15, ["🏌🏽‍♂️", "🏌🏽"]], "1f3fe": ["1f3cc-1f3fe-200d-2642-fe0f", 9, 45, 15, ["🏌🏾‍♂️", "🏌🏾"]], "1f3ff": ["1f3cc-1f3ff-200d-2642-fe0f", 9, 46, 15, ["🏌🏿‍♂️", "🏌🏿"]] },
      "1f442": { "1f3fb": ["1f442-1f3fb", 11, 57, 15, ["👂🏻"]], "1f3fc": ["1f442-1f3fc", 11, 58, 15, ["👂🏼"]], "1f3fd": ["1f442-1f3fd", 11, 59, 15, ["👂🏽"]], "1f3fe": ["1f442-1f3fe", 11, 60, 15, ["👂🏾"]], "1f3ff": ["1f442-1f3ff", 12, 0, 15, ["👂🏿"]] },
      "1f443": { "1f3fb": ["1f443-1f3fb", 12, 2, 15, ["👃🏻"]], "1f3fc": ["1f443-1f3fc", 12, 3, 15, ["👃🏼"]], "1f3fd": ["1f443-1f3fd", 12, 4, 15, ["👃🏽"]], "1f3fe": ["1f443-1f3fe", 12, 5, 15, ["👃🏾"]], "1f3ff": ["1f443-1f3ff", 12, 6, 15, ["👃🏿"]] },
      "1f446": { "1f3fb": ["1f446-1f3fb", 12, 10, 15, ["👆🏻"]], "1f3fc": ["1f446-1f3fc", 12, 11, 15, ["👆🏼"]], "1f3fd": ["1f446-1f3fd", 12, 12, 15, ["👆🏽"]], "1f3fe": ["1f446-1f3fe", 12, 13, 15, ["👆🏾"]], "1f3ff": ["1f446-1f3ff", 12, 14, 15, ["👆🏿"]] },
      "1f447": { "1f3fb": ["1f447-1f3fb", 12, 16, 15, ["👇🏻"]], "1f3fc": ["1f447-1f3fc", 12, 17, 15, ["👇🏼"]], "1f3fd": ["1f447-1f3fd", 12, 18, 15, ["👇🏽"]], "1f3fe": ["1f447-1f3fe", 12, 19, 15, ["👇🏾"]], "1f3ff": ["1f447-1f3ff", 12, 20, 15, ["👇🏿"]] },
      "1f448": { "1f3fb": ["1f448-1f3fb", 12, 22, 15, ["👈🏻"]], "1f3fc": ["1f448-1f3fc", 12, 23, 15, ["👈🏼"]], "1f3fd": ["1f448-1f3fd", 12, 24, 15, ["👈🏽"]], "1f3fe": ["1f448-1f3fe", 12, 25, 15, ["👈🏾"]], "1f3ff": ["1f448-1f3ff", 12, 26, 15, ["👈🏿"]] },
      "1f449": { "1f3fb": ["1f449-1f3fb", 12, 28, 15, ["👉🏻"]], "1f3fc": ["1f449-1f3fc", 12, 29, 15, ["👉🏼"]], "1f3fd": ["1f449-1f3fd", 12, 30, 15, ["👉🏽"]], "1f3fe": ["1f449-1f3fe", 12, 31, 15, ["👉🏾"]], "1f3ff": ["1f449-1f3ff", 12, 32, 15, ["👉🏿"]] },
      "1f44a": { "1f3fb": ["1f44a-1f3fb", 12, 34, 15, ["👊🏻"]], "1f3fc": ["1f44a-1f3fc", 12, 35, 15, ["👊🏼"]], "1f3fd": ["1f44a-1f3fd", 12, 36, 15, ["👊🏽"]], "1f3fe": ["1f44a-1f3fe", 12, 37, 15, ["👊🏾"]], "1f3ff": ["1f44a-1f3ff", 12, 38, 15, ["👊🏿"]] },
      "1f44b": { "1f3fb": ["1f44b-1f3fb", 12, 40, 15, ["👋🏻"]], "1f3fc": ["1f44b-1f3fc", 12, 41, 15, ["👋🏼"]], "1f3fd": ["1f44b-1f3fd", 12, 42, 15, ["👋🏽"]], "1f3fe": ["1f44b-1f3fe", 12, 43, 15, ["👋🏾"]], "1f3ff": ["1f44b-1f3ff", 12, 44, 15, ["👋🏿"]] },
      "1f44c": { "1f3fb": ["1f44c-1f3fb", 12, 46, 15, ["👌🏻"]], "1f3fc": ["1f44c-1f3fc", 12, 47, 15, ["👌🏼"]], "1f3fd": ["1f44c-1f3fd", 12, 48, 15, ["👌🏽"]], "1f3fe": ["1f44c-1f3fe", 12, 49, 15, ["👌🏾"]], "1f3ff": ["1f44c-1f3ff", 12, 50, 15, ["👌🏿"]] },
      "1f44d": { "1f3fb": ["1f44d-1f3fb", 12, 52, 15, ["👍🏻"]], "1f3fc": ["1f44d-1f3fc", 12, 53, 15, ["👍🏼"]], "1f3fd": ["1f44d-1f3fd", 12, 54, 15, ["👍🏽"]], "1f3fe": ["1f44d-1f3fe", 12, 55, 15, ["👍🏾"]], "1f3ff": ["1f44d-1f3ff", 12, 56, 15, ["👍🏿"]] },
      "1f44e": { "1f3fb": ["1f44e-1f3fb", 12, 58, 15, ["👎🏻"]], "1f3fc": ["1f44e-1f3fc", 12, 59, 15, ["👎🏼"]], "1f3fd": ["1f44e-1f3fd", 12, 60, 15, ["👎🏽"]], "1f3fe": ["1f44e-1f3fe", 13, 0, 15, ["👎🏾"]], "1f3ff": ["1f44e-1f3ff", 13, 1, 15, ["👎🏿"]] },
      "1f44f": { "1f3fb": ["1f44f-1f3fb", 13, 3, 15, ["👏🏻"]], "1f3fc": ["1f44f-1f3fc", 13, 4, 15, ["👏🏼"]], "1f3fd": ["1f44f-1f3fd", 13, 5, 15, ["👏🏽"]], "1f3fe": ["1f44f-1f3fe", 13, 6, 15, ["👏🏾"]], "1f3ff": ["1f44f-1f3ff", 13, 7, 15, ["👏🏿"]] },
      "1f450": { "1f3fb": ["1f450-1f3fb", 13, 9, 15, ["👐🏻"]], "1f3fc": ["1f450-1f3fc", 13, 10, 15, ["👐🏼"]], "1f3fd": ["1f450-1f3fd", 13, 11, 15, ["👐🏽"]], "1f3fe": ["1f450-1f3fe", 13, 12, 15, ["👐🏾"]], "1f3ff": ["1f450-1f3ff", 13, 13, 15, ["👐🏿"]] },
      "1f466": { "1f3fb": ["1f466-1f3fb", 13, 36, 15, ["👦🏻"]], "1f3fc": ["1f466-1f3fc", 13, 37, 15, ["👦🏼"]], "1f3fd": ["1f466-1f3fd", 13, 38, 15, ["👦🏽"]], "1f3fe": ["1f466-1f3fe", 13, 39, 15, ["👦🏾"]], "1f3ff": ["1f466-1f3ff", 13, 40, 15, ["👦🏿"]] },
      "1f467": { "1f3fb": ["1f467-1f3fb", 13, 42, 15, ["👧🏻"]], "1f3fc": ["1f467-1f3fc", 13, 43, 15, ["👧🏼"]], "1f3fd": ["1f467-1f3fd", 13, 44, 15, ["👧🏽"]], "1f3fe": ["1f467-1f3fe", 13, 45, 15, ["👧🏾"]], "1f3ff": ["1f467-1f3ff", 13, 46, 15, ["👧🏿"]] },
      "1f468-200d-1f33e": { "1f3fb": ["1f468-1f3fb-200d-1f33e", 13, 48, 15, ["👨🏻‍🌾"]], "1f3fc": ["1f468-1f3fc-200d-1f33e", 13, 49, 15, ["👨🏼‍🌾"]], "1f3fd": ["1f468-1f3fd-200d-1f33e", 13, 50, 15, ["👨🏽‍🌾"]], "1f3fe": ["1f468-1f3fe-200d-1f33e", 13, 51, 15, ["👨🏾‍🌾"]], "1f3ff": ["1f468-1f3ff-200d-1f33e", 13, 52, 15, ["👨🏿‍🌾"]] },
      "1f468-200d-1f373": { "1f3fb": ["1f468-1f3fb-200d-1f373", 13, 54, 15, ["👨🏻‍🍳"]], "1f3fc": ["1f468-1f3fc-200d-1f373", 13, 55, 15, ["👨🏼‍🍳"]], "1f3fd": ["1f468-1f3fd-200d-1f373", 13, 56, 15, ["👨🏽‍🍳"]], "1f3fe": ["1f468-1f3fe-200d-1f373", 13, 57, 15, ["👨🏾‍🍳"]], "1f3ff": ["1f468-1f3ff-200d-1f373", 13, 58, 15, ["👨🏿‍🍳"]] },
      "1f468-200d-1f37c": { "1f3fb": ["1f468-1f3fb-200d-1f37c", 13, 60, 15, ["👨🏻‍🍼"]], "1f3fc": ["1f468-1f3fc-200d-1f37c", 14, 0, 15, ["👨🏼‍🍼"]], "1f3fd": ["1f468-1f3fd-200d-1f37c", 14, 1, 15, ["👨🏽‍🍼"]], "1f3fe": ["1f468-1f3fe-200d-1f37c", 14, 2, 15, ["👨🏾‍🍼"]], "1f3ff": ["1f468-1f3ff-200d-1f37c", 14, 3, 15, ["👨🏿‍🍼"]] },
      "1f468-200d-1f393": { "1f3fb": ["1f468-1f3fb-200d-1f393", 14, 5, 15, ["👨🏻‍🎓"]], "1f3fc": ["1f468-1f3fc-200d-1f393", 14, 6, 15, ["👨🏼‍🎓"]], "1f3fd": ["1f468-1f3fd-200d-1f393", 14, 7, 15, ["👨🏽‍🎓"]], "1f3fe": ["1f468-1f3fe-200d-1f393", 14, 8, 15, ["👨🏾‍🎓"]], "1f3ff": ["1f468-1f3ff-200d-1f393", 14, 9, 15, ["👨🏿‍🎓"]] },
      "1f468-200d-1f3a4": { "1f3fb": ["1f468-1f3fb-200d-1f3a4", 14, 11, 15, ["👨🏻‍🎤"]], "1f3fc": ["1f468-1f3fc-200d-1f3a4", 14, 12, 15, ["👨🏼‍🎤"]], "1f3fd": ["1f468-1f3fd-200d-1f3a4", 14, 13, 15, ["👨🏽‍🎤"]], "1f3fe": ["1f468-1f3fe-200d-1f3a4", 14, 14, 15, ["👨🏾‍🎤"]], "1f3ff": ["1f468-1f3ff-200d-1f3a4", 14, 15, 15, ["👨🏿‍🎤"]] },
      "1f468-200d-1f3a8": { "1f3fb": ["1f468-1f3fb-200d-1f3a8", 14, 17, 15, ["👨🏻‍🎨"]], "1f3fc": ["1f468-1f3fc-200d-1f3a8", 14, 18, 15, ["👨🏼‍🎨"]], "1f3fd": ["1f468-1f3fd-200d-1f3a8", 14, 19, 15, ["👨🏽‍🎨"]], "1f3fe": ["1f468-1f3fe-200d-1f3a8", 14, 20, 15, ["👨🏾‍🎨"]], "1f3ff": ["1f468-1f3ff-200d-1f3a8", 14, 21, 15, ["👨🏿‍🎨"]] },
      "1f468-200d-1f3eb": { "1f3fb": ["1f468-1f3fb-200d-1f3eb", 14, 23, 15, ["👨🏻‍🏫"]], "1f3fc": ["1f468-1f3fc-200d-1f3eb", 14, 24, 15, ["👨🏼‍🏫"]], "1f3fd": ["1f468-1f3fd-200d-1f3eb", 14, 25, 15, ["👨🏽‍🏫"]], "1f3fe": ["1f468-1f3fe-200d-1f3eb", 14, 26, 15, ["👨🏾‍🏫"]], "1f3ff": ["1f468-1f3ff-200d-1f3eb", 14, 27, 15, ["👨🏿‍🏫"]] },
      "1f468-200d-1f3ed": { "1f3fb": ["1f468-1f3fb-200d-1f3ed", 14, 29, 15, ["👨🏻‍🏭"]], "1f3fc": ["1f468-1f3fc-200d-1f3ed", 14, 30, 15, ["👨🏼‍🏭"]], "1f3fd": ["1f468-1f3fd-200d-1f3ed", 14, 31, 15, ["👨🏽‍🏭"]], "1f3fe": ["1f468-1f3fe-200d-1f3ed", 14, 32, 15, ["👨🏾‍🏭"]], "1f3ff": ["1f468-1f3ff-200d-1f3ed", 14, 33, 15, ["👨🏿‍🏭"]] },
      "1f468-200d-1f4bb": { "1f3fb": ["1f468-1f3fb-200d-1f4bb", 14, 50, 15, ["👨🏻‍💻"]], "1f3fc": ["1f468-1f3fc-200d-1f4bb", 14, 51, 15, ["👨🏼‍💻"]], "1f3fd": ["1f468-1f3fd-200d-1f4bb", 14, 52, 15, ["👨🏽‍💻"]], "1f3fe": ["1f468-1f3fe-200d-1f4bb", 14, 53, 15, ["👨🏾‍💻"]], "1f3ff": ["1f468-1f3ff-200d-1f4bb", 14, 54, 15, ["👨🏿‍💻"]] },
      "1f468-200d-1f4bc": { "1f3fb": ["1f468-1f3fb-200d-1f4bc", 14, 56, 15, ["👨🏻‍💼"]], "1f3fc": ["1f468-1f3fc-200d-1f4bc", 14, 57, 15, ["👨🏼‍💼"]], "1f3fd": ["1f468-1f3fd-200d-1f4bc", 14, 58, 15, ["👨🏽‍💼"]], "1f3fe": ["1f468-1f3fe-200d-1f4bc", 14, 59, 15, ["👨🏾‍💼"]], "1f3ff": ["1f468-1f3ff-200d-1f4bc", 14, 60, 15, ["👨🏿‍💼"]] },
      "1f468-200d-1f527": { "1f3fb": ["1f468-1f3fb-200d-1f527", 15, 1, 15, ["👨🏻‍🔧"]], "1f3fc": ["1f468-1f3fc-200d-1f527", 15, 2, 15, ["👨🏼‍🔧"]], "1f3fd": ["1f468-1f3fd-200d-1f527", 15, 3, 15, ["👨🏽‍🔧"]], "1f3fe": ["1f468-1f3fe-200d-1f527", 15, 4, 15, ["👨🏾‍🔧"]], "1f3ff": ["1f468-1f3ff-200d-1f527", 15, 5, 15, ["👨🏿‍🔧"]] },
      "1f468-200d-1f52c": { "1f3fb": ["1f468-1f3fb-200d-1f52c", 15, 7, 15, ["👨🏻‍🔬"]], "1f3fc": ["1f468-1f3fc-200d-1f52c", 15, 8, 15, ["👨🏼‍🔬"]], "1f3fd": ["1f468-1f3fd-200d-1f52c", 15, 9, 15, ["👨🏽‍🔬"]], "1f3fe": ["1f468-1f3fe-200d-1f52c", 15, 10, 15, ["👨🏾‍🔬"]], "1f3ff": ["1f468-1f3ff-200d-1f52c", 15, 11, 15, ["👨🏿‍🔬"]] },
      "1f468-200d-1f680": { "1f3fb": ["1f468-1f3fb-200d-1f680", 15, 13, 15, ["👨🏻‍🚀"]], "1f3fc": ["1f468-1f3fc-200d-1f680", 15, 14, 15, ["👨🏼‍🚀"]], "1f3fd": ["1f468-1f3fd-200d-1f680", 15, 15, 15, ["👨🏽‍🚀"]], "1f3fe": ["1f468-1f3fe-200d-1f680", 15, 16, 15, ["👨🏾‍🚀"]], "1f3ff": ["1f468-1f3ff-200d-1f680", 15, 17, 15, ["👨🏿‍🚀"]] },
      "1f468-200d-1f692": { "1f3fb": ["1f468-1f3fb-200d-1f692", 15, 19, 15, ["👨🏻‍🚒"]], "1f3fc": ["1f468-1f3fc-200d-1f692", 15, 20, 15, ["👨🏼‍🚒"]], "1f3fd": ["1f468-1f3fd-200d-1f692", 15, 21, 15, ["👨🏽‍🚒"]], "1f3fe": ["1f468-1f3fe-200d-1f692", 15, 22, 15, ["👨🏾‍🚒"]], "1f3ff": ["1f468-1f3ff-200d-1f692", 15, 23, 15, ["👨🏿‍🚒"]] },
      "1f468-200d-1f9af": { "1f3fb": ["1f468-1f3fb-200d-1f9af", 15, 25, 15, ["👨🏻‍🦯"]], "1f3fc": ["1f468-1f3fc-200d-1f9af", 15, 26, 15, ["👨🏼‍🦯"]], "1f3fd": ["1f468-1f3fd-200d-1f9af", 15, 27, 15, ["👨🏽‍🦯"]], "1f3fe": ["1f468-1f3fe-200d-1f9af", 15, 28, 15, ["👨🏾‍🦯"]], "1f3ff": ["1f468-1f3ff-200d-1f9af", 15, 29, 15, ["👨🏿‍🦯"]] },
      "1f468-200d-1f9b0": { "1f3fb": ["1f468-1f3fb-200d-1f9b0", 15, 31, 15, ["👨🏻‍🦰"]], "1f3fc": ["1f468-1f3fc-200d-1f9b0", 15, 32, 15, ["👨🏼‍🦰"]], "1f3fd": ["1f468-1f3fd-200d-1f9b0", 15, 33, 15, ["👨🏽‍🦰"]], "1f3fe": ["1f468-1f3fe-200d-1f9b0", 15, 34, 15, ["👨🏾‍🦰"]], "1f3ff": ["1f468-1f3ff-200d-1f9b0", 15, 35, 15, ["👨🏿‍🦰"]] },
      "1f468-200d-1f9b1": { "1f3fb": ["1f468-1f3fb-200d-1f9b1", 15, 37, 15, ["👨🏻‍🦱"]], "1f3fc": ["1f468-1f3fc-200d-1f9b1", 15, 38, 15, ["👨🏼‍🦱"]], "1f3fd": ["1f468-1f3fd-200d-1f9b1", 15, 39, 15, ["👨🏽‍🦱"]], "1f3fe": ["1f468-1f3fe-200d-1f9b1", 15, 40, 15, ["👨🏾‍🦱"]], "1f3ff": ["1f468-1f3ff-200d-1f9b1", 15, 41, 15, ["👨🏿‍🦱"]] },
      "1f468-200d-1f9b2": { "1f3fb": ["1f468-1f3fb-200d-1f9b2", 15, 43, 15, ["👨🏻‍🦲"]], "1f3fc": ["1f468-1f3fc-200d-1f9b2", 15, 44, 15, ["👨🏼‍🦲"]], "1f3fd": ["1f468-1f3fd-200d-1f9b2", 15, 45, 15, ["👨🏽‍🦲"]], "1f3fe": ["1f468-1f3fe-200d-1f9b2", 15, 46, 15, ["👨🏾‍🦲"]], "1f3ff": ["1f468-1f3ff-200d-1f9b2", 15, 47, 15, ["👨🏿‍🦲"]] },
      "1f468-200d-1f9b3": { "1f3fb": ["1f468-1f3fb-200d-1f9b3", 15, 49, 15, ["👨🏻‍🦳"]], "1f3fc": ["1f468-1f3fc-200d-1f9b3", 15, 50, 15, ["👨🏼‍🦳"]], "1f3fd": ["1f468-1f3fd-200d-1f9b3", 15, 51, 15, ["👨🏽‍🦳"]], "1f3fe": ["1f468-1f3fe-200d-1f9b3", 15, 52, 15, ["👨🏾‍🦳"]], "1f3ff": ["1f468-1f3ff-200d-1f9b3", 15, 53, 15, ["👨🏿‍🦳"]] },
      "1f468-200d-1f9bc": { "1f3fb": ["1f468-1f3fb-200d-1f9bc", 15, 55, 15, ["👨🏻‍🦼"]], "1f3fc": ["1f468-1f3fc-200d-1f9bc", 15, 56, 15, ["👨🏼‍🦼"]], "1f3fd": ["1f468-1f3fd-200d-1f9bc", 15, 57, 15, ["👨🏽‍🦼"]], "1f3fe": ["1f468-1f3fe-200d-1f9bc", 15, 58, 15, ["👨🏾‍🦼"]], "1f3ff": ["1f468-1f3ff-200d-1f9bc", 15, 59, 15, ["👨🏿‍🦼"]] },
      "1f468-200d-1f9bd": { "1f3fb": ["1f468-1f3fb-200d-1f9bd", 16, 0, 15, ["👨🏻‍🦽"]], "1f3fc": ["1f468-1f3fc-200d-1f9bd", 16, 1, 15, ["👨🏼‍🦽"]], "1f3fd": ["1f468-1f3fd-200d-1f9bd", 16, 2, 15, ["👨🏽‍🦽"]], "1f3fe": ["1f468-1f3fe-200d-1f9bd", 16, 3, 15, ["👨🏾‍🦽"]], "1f3ff": ["1f468-1f3ff-200d-1f9bd", 16, 4, 15, ["👨🏿‍🦽"]] },
      "1f468-200d-2695-fe0f": { "1f3fb": ["1f468-1f3fb-200d-2695-fe0f", 16, 6, 15, ["👨🏻‍⚕️"]], "1f3fc": ["1f468-1f3fc-200d-2695-fe0f", 16, 7, 15, ["👨🏼‍⚕️"]], "1f3fd": ["1f468-1f3fd-200d-2695-fe0f", 16, 8, 15, ["👨🏽‍⚕️"]], "1f3fe": ["1f468-1f3fe-200d-2695-fe0f", 16, 9, 15, ["👨🏾‍⚕️"]], "1f3ff": ["1f468-1f3ff-200d-2695-fe0f", 16, 10, 15, ["👨🏿‍⚕️"]] },
      "1f468-200d-2696-fe0f": { "1f3fb": ["1f468-1f3fb-200d-2696-fe0f", 16, 12, 15, ["👨🏻‍⚖️"]], "1f3fc": ["1f468-1f3fc-200d-2696-fe0f", 16, 13, 15, ["👨🏼‍⚖️"]], "1f3fd": ["1f468-1f3fd-200d-2696-fe0f", 16, 14, 15, ["👨🏽‍⚖️"]], "1f3fe": ["1f468-1f3fe-200d-2696-fe0f", 16, 15, 15, ["👨🏾‍⚖️"]], "1f3ff": ["1f468-1f3ff-200d-2696-fe0f", 16, 16, 15, ["👨🏿‍⚖️"]] },
      "1f468-200d-2708-fe0f": { "1f3fb": ["1f468-1f3fb-200d-2708-fe0f", 16, 18, 15, ["👨🏻‍✈️"]], "1f3fc": ["1f468-1f3fc-200d-2708-fe0f", 16, 19, 15, ["👨🏼‍✈️"]], "1f3fd": ["1f468-1f3fd-200d-2708-fe0f", 16, 20, 15, ["👨🏽‍✈️"]], "1f3fe": ["1f468-1f3fe-200d-2708-fe0f", 16, 21, 15, ["👨🏾‍✈️"]], "1f3ff": ["1f468-1f3ff-200d-2708-fe0f", 16, 22, 15, ["👨🏿‍✈️"]] },
      "1f468-200d-2764-fe0f-200d-1f468": { "1f3fb-1f3fb": ["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb", 16, 24, 15, ["👨🏻‍❤️‍👨🏻"]], "1f3fb-1f3fc": ["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc", 16, 25, 15, ["👨🏻‍❤️‍👨🏼"]], "1f3fb-1f3fd": ["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd", 16, 26, 15, ["👨🏻‍❤️‍👨🏽"]], "1f3fb-1f3fe": ["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe", 16, 27, 15, ["👨🏻‍❤️‍👨🏾"]], "1f3fb-1f3ff": ["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff", 16, 28, 15, ["👨🏻‍❤️‍👨🏿"]], "1f3fc-1f3fb": ["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb", 16, 29, 15, ["👨🏼‍❤️‍👨🏻"]], "1f3fc-1f3fc": ["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc", 16, 30, 15, ["👨🏼‍❤️‍👨🏼"]], "1f3fc-1f3fd": ["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd", 16, 31, 15, ["👨🏼‍❤️‍👨🏽"]], "1f3fc-1f3fe": ["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe", 16, 32, 15, ["👨🏼‍❤️‍👨🏾"]], "1f3fc-1f3ff": ["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff", 16, 33, 15, ["👨🏼‍❤️‍👨🏿"]], "1f3fd-1f3fb": ["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb", 16, 34, 15, ["👨🏽‍❤️‍👨🏻"]], "1f3fd-1f3fc": ["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc", 16, 35, 15, ["👨🏽‍❤️‍👨🏼"]], "1f3fd-1f3fd": ["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd", 16, 36, 15, ["👨🏽‍❤️‍👨🏽"]], "1f3fd-1f3fe": ["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe", 16, 37, 15, ["👨🏽‍❤️‍👨🏾"]], "1f3fd-1f3ff": ["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff", 16, 38, 15, ["👨🏽‍❤️‍👨🏿"]], "1f3fe-1f3fb": ["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb", 16, 39, 15, ["👨🏾‍❤️‍👨🏻"]], "1f3fe-1f3fc": ["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc", 16, 40, 15, ["👨🏾‍❤️‍👨🏼"]], "1f3fe-1f3fd": ["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd", 16, 41, 15, ["👨🏾‍❤️‍👨🏽"]], "1f3fe-1f3fe": ["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe", 16, 42, 15, ["👨🏾‍❤️‍👨🏾"]], "1f3fe-1f3ff": ["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff", 16, 43, 15, ["👨🏾‍❤️‍👨🏿"]], "1f3ff-1f3fb": ["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb", 16, 44, 15, ["👨🏿‍❤️‍👨🏻"]], "1f3ff-1f3fc": ["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc", 16, 45, 15, ["👨🏿‍❤️‍👨🏼"]], "1f3ff-1f3fd": ["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd", 16, 46, 15, ["👨🏿‍❤️‍👨🏽"]], "1f3ff-1f3fe": ["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe", 16, 47, 15, ["👨🏿‍❤️‍👨🏾"]], "1f3ff-1f3ff": ["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff", 16, 48, 15, ["👨🏿‍❤️‍👨🏿"]] },
      "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468": { "1f3fb-1f3fb": ["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 16, 50, 15, ["👨🏻‍❤️‍💋‍👨🏻"]], "1f3fb-1f3fc": ["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 16, 51, 15, ["👨🏻‍❤️‍💋‍👨🏼"]], "1f3fb-1f3fd": ["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 16, 52, 15, ["👨🏻‍❤️‍💋‍👨🏽"]], "1f3fb-1f3fe": ["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 16, 53, 15, ["👨🏻‍❤️‍💋‍👨🏾"]], "1f3fb-1f3ff": ["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 16, 54, 15, ["👨🏻‍❤️‍💋‍👨🏿"]], "1f3fc-1f3fb": ["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 16, 55, 15, ["👨🏼‍❤️‍💋‍👨🏻"]], "1f3fc-1f3fc": ["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 16, 56, 15, ["👨🏼‍❤️‍💋‍👨🏼"]], "1f3fc-1f3fd": ["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 16, 57, 15, ["👨🏼‍❤️‍💋‍👨🏽"]], "1f3fc-1f3fe": ["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 16, 58, 15, ["👨🏼‍❤️‍💋‍👨🏾"]], "1f3fc-1f3ff": ["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 16, 59, 15, ["👨🏼‍❤️‍💋‍👨🏿"]], "1f3fd-1f3fb": ["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 16, 60, 15, ["👨🏽‍❤️‍💋‍👨🏻"]], "1f3fd-1f3fc": ["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 17, 0, 15, ["👨🏽‍❤️‍💋‍👨🏼"]], "1f3fd-1f3fd": ["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 17, 1, 15, ["👨🏽‍❤️‍💋‍👨🏽"]], "1f3fd-1f3fe": ["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 17, 2, 15, ["👨🏽‍❤️‍💋‍👨🏾"]], "1f3fd-1f3ff": ["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 17, 3, 15, ["👨🏽‍❤️‍💋‍👨🏿"]], "1f3fe-1f3fb": ["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 17, 4, 15, ["👨🏾‍❤️‍💋‍👨🏻"]], "1f3fe-1f3fc": ["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 17, 5, 15, ["👨🏾‍❤️‍💋‍👨🏼"]], "1f3fe-1f3fd": ["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 17, 6, 15, ["👨🏾‍❤️‍💋‍👨🏽"]], "1f3fe-1f3fe": ["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 17, 7, 15, ["👨🏾‍❤️‍💋‍👨🏾"]], "1f3fe-1f3ff": ["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 17, 8, 15, ["👨🏾‍❤️‍💋‍👨🏿"]], "1f3ff-1f3fb": ["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 17, 9, 15, ["👨🏿‍❤️‍💋‍👨🏻"]], "1f3ff-1f3fc": ["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 17, 10, 15, ["👨🏿‍❤️‍💋‍👨🏼"]], "1f3ff-1f3fd": ["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 17, 11, 15, ["👨🏿‍❤️‍💋‍👨🏽"]], "1f3ff-1f3fe": ["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 17, 12, 15, ["👨🏿‍❤️‍💋‍👨🏾"]], "1f3ff-1f3ff": ["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 17, 13, 15, ["👨🏿‍❤️‍💋‍👨🏿"]] },
      "1f468": { "1f3fb": ["1f468-1f3fb", 17, 15, 15, ["👨🏻"]], "1f3fc": ["1f468-1f3fc", 17, 16, 15, ["👨🏼"]], "1f3fd": ["1f468-1f3fd", 17, 17, 15, ["👨🏽"]], "1f3fe": ["1f468-1f3fe", 17, 18, 15, ["👨🏾"]], "1f3ff": ["1f468-1f3ff", 17, 19, 15, ["👨🏿"]] },
      "1f469-200d-1f33e": { "1f3fb": ["1f469-1f3fb-200d-1f33e", 17, 21, 15, ["👩🏻‍🌾"]], "1f3fc": ["1f469-1f3fc-200d-1f33e", 17, 22, 15, ["👩🏼‍🌾"]], "1f3fd": ["1f469-1f3fd-200d-1f33e", 17, 23, 15, ["👩🏽‍🌾"]], "1f3fe": ["1f469-1f3fe-200d-1f33e", 17, 24, 15, ["👩🏾‍🌾"]], "1f3ff": ["1f469-1f3ff-200d-1f33e", 17, 25, 15, ["👩🏿‍🌾"]] },
      "1f469-200d-1f373": { "1f3fb": ["1f469-1f3fb-200d-1f373", 17, 27, 15, ["👩🏻‍🍳"]], "1f3fc": ["1f469-1f3fc-200d-1f373", 17, 28, 15, ["👩🏼‍🍳"]], "1f3fd": ["1f469-1f3fd-200d-1f373", 17, 29, 15, ["👩🏽‍🍳"]], "1f3fe": ["1f469-1f3fe-200d-1f373", 17, 30, 15, ["👩🏾‍🍳"]], "1f3ff": ["1f469-1f3ff-200d-1f373", 17, 31, 15, ["👩🏿‍🍳"]] },
      "1f469-200d-1f37c": { "1f3fb": ["1f469-1f3fb-200d-1f37c", 17, 33, 15, ["👩🏻‍🍼"]], "1f3fc": ["1f469-1f3fc-200d-1f37c", 17, 34, 15, ["👩🏼‍🍼"]], "1f3fd": ["1f469-1f3fd-200d-1f37c", 17, 35, 15, ["👩🏽‍🍼"]], "1f3fe": ["1f469-1f3fe-200d-1f37c", 17, 36, 15, ["👩🏾‍🍼"]], "1f3ff": ["1f469-1f3ff-200d-1f37c", 17, 37, 15, ["👩🏿‍🍼"]] },
      "1f469-200d-1f393": { "1f3fb": ["1f469-1f3fb-200d-1f393", 17, 39, 15, ["👩🏻‍🎓"]], "1f3fc": ["1f469-1f3fc-200d-1f393", 17, 40, 15, ["👩🏼‍🎓"]], "1f3fd": ["1f469-1f3fd-200d-1f393", 17, 41, 15, ["👩🏽‍🎓"]], "1f3fe": ["1f469-1f3fe-200d-1f393", 17, 42, 15, ["👩🏾‍🎓"]], "1f3ff": ["1f469-1f3ff-200d-1f393", 17, 43, 15, ["👩🏿‍🎓"]] },
      "1f469-200d-1f3a4": { "1f3fb": ["1f469-1f3fb-200d-1f3a4", 17, 45, 15, ["👩🏻‍🎤"]], "1f3fc": ["1f469-1f3fc-200d-1f3a4", 17, 46, 15, ["👩🏼‍🎤"]], "1f3fd": ["1f469-1f3fd-200d-1f3a4", 17, 47, 15, ["👩🏽‍🎤"]], "1f3fe": ["1f469-1f3fe-200d-1f3a4", 17, 48, 15, ["👩🏾‍🎤"]], "1f3ff": ["1f469-1f3ff-200d-1f3a4", 17, 49, 15, ["👩🏿‍🎤"]] },
      "1f469-200d-1f3a8": { "1f3fb": ["1f469-1f3fb-200d-1f3a8", 17, 51, 15, ["👩🏻‍🎨"]], "1f3fc": ["1f469-1f3fc-200d-1f3a8", 17, 52, 15, ["👩🏼‍🎨"]], "1f3fd": ["1f469-1f3fd-200d-1f3a8", 17, 53, 15, ["👩🏽‍🎨"]], "1f3fe": ["1f469-1f3fe-200d-1f3a8", 17, 54, 15, ["👩🏾‍🎨"]], "1f3ff": ["1f469-1f3ff-200d-1f3a8", 17, 55, 15, ["👩🏿‍🎨"]] },
      "1f469-200d-1f3eb": { "1f3fb": ["1f469-1f3fb-200d-1f3eb", 17, 57, 15, ["👩🏻‍🏫"]], "1f3fc": ["1f469-1f3fc-200d-1f3eb", 17, 58, 15, ["👩🏼‍🏫"]], "1f3fd": ["1f469-1f3fd-200d-1f3eb", 17, 59, 15, ["👩🏽‍🏫"]], "1f3fe": ["1f469-1f3fe-200d-1f3eb", 17, 60, 15, ["👩🏾‍🏫"]], "1f3ff": ["1f469-1f3ff-200d-1f3eb", 18, 0, 15, ["👩🏿‍🏫"]] },
      "1f469-200d-1f3ed": { "1f3fb": ["1f469-1f3fb-200d-1f3ed", 18, 2, 15, ["👩🏻‍🏭"]], "1f3fc": ["1f469-1f3fc-200d-1f3ed", 18, 3, 15, ["👩🏼‍🏭"]], "1f3fd": ["1f469-1f3fd-200d-1f3ed", 18, 4, 15, ["👩🏽‍🏭"]], "1f3fe": ["1f469-1f3fe-200d-1f3ed", 18, 5, 15, ["👩🏾‍🏭"]], "1f3ff": ["1f469-1f3ff-200d-1f3ed", 18, 6, 15, ["👩🏿‍🏭"]] },
      "1f469-200d-1f4bb": { "1f3fb": ["1f469-1f3fb-200d-1f4bb", 18, 18, 15, ["👩🏻‍💻"]], "1f3fc": ["1f469-1f3fc-200d-1f4bb", 18, 19, 15, ["👩🏼‍💻"]], "1f3fd": ["1f469-1f3fd-200d-1f4bb", 18, 20, 15, ["👩🏽‍💻"]], "1f3fe": ["1f469-1f3fe-200d-1f4bb", 18, 21, 15, ["👩🏾‍💻"]], "1f3ff": ["1f469-1f3ff-200d-1f4bb", 18, 22, 15, ["👩🏿‍💻"]] },
      "1f469-200d-1f4bc": { "1f3fb": ["1f469-1f3fb-200d-1f4bc", 18, 24, 15, ["👩🏻‍💼"]], "1f3fc": ["1f469-1f3fc-200d-1f4bc", 18, 25, 15, ["👩🏼‍💼"]], "1f3fd": ["1f469-1f3fd-200d-1f4bc", 18, 26, 15, ["👩🏽‍💼"]], "1f3fe": ["1f469-1f3fe-200d-1f4bc", 18, 27, 15, ["👩🏾‍💼"]], "1f3ff": ["1f469-1f3ff-200d-1f4bc", 18, 28, 15, ["👩🏿‍💼"]] },
      "1f469-200d-1f527": { "1f3fb": ["1f469-1f3fb-200d-1f527", 18, 30, 15, ["👩🏻‍🔧"]], "1f3fc": ["1f469-1f3fc-200d-1f527", 18, 31, 15, ["👩🏼‍🔧"]], "1f3fd": ["1f469-1f3fd-200d-1f527", 18, 32, 15, ["👩🏽‍🔧"]], "1f3fe": ["1f469-1f3fe-200d-1f527", 18, 33, 15, ["👩🏾‍🔧"]], "1f3ff": ["1f469-1f3ff-200d-1f527", 18, 34, 15, ["👩🏿‍🔧"]] },
      "1f469-200d-1f52c": { "1f3fb": ["1f469-1f3fb-200d-1f52c", 18, 36, 15, ["👩🏻‍🔬"]], "1f3fc": ["1f469-1f3fc-200d-1f52c", 18, 37, 15, ["👩🏼‍🔬"]], "1f3fd": ["1f469-1f3fd-200d-1f52c", 18, 38, 15, ["👩🏽‍🔬"]], "1f3fe": ["1f469-1f3fe-200d-1f52c", 18, 39, 15, ["👩🏾‍🔬"]], "1f3ff": ["1f469-1f3ff-200d-1f52c", 18, 40, 15, ["👩🏿‍🔬"]] },
      "1f469-200d-1f680": { "1f3fb": ["1f469-1f3fb-200d-1f680", 18, 42, 15, ["👩🏻‍🚀"]], "1f3fc": ["1f469-1f3fc-200d-1f680", 18, 43, 15, ["👩🏼‍🚀"]], "1f3fd": ["1f469-1f3fd-200d-1f680", 18, 44, 15, ["👩🏽‍🚀"]], "1f3fe": ["1f469-1f3fe-200d-1f680", 18, 45, 15, ["👩🏾‍🚀"]], "1f3ff": ["1f469-1f3ff-200d-1f680", 18, 46, 15, ["👩🏿‍🚀"]] },
      "1f469-200d-1f692": { "1f3fb": ["1f469-1f3fb-200d-1f692", 18, 48, 15, ["👩🏻‍🚒"]], "1f3fc": ["1f469-1f3fc-200d-1f692", 18, 49, 15, ["👩🏼‍🚒"]], "1f3fd": ["1f469-1f3fd-200d-1f692", 18, 50, 15, ["👩🏽‍🚒"]], "1f3fe": ["1f469-1f3fe-200d-1f692", 18, 51, 15, ["👩🏾‍🚒"]], "1f3ff": ["1f469-1f3ff-200d-1f692", 18, 52, 15, ["👩🏿‍🚒"]] },
      "1f469-200d-1f9af": { "1f3fb": ["1f469-1f3fb-200d-1f9af", 18, 54, 15, ["👩🏻‍🦯"]], "1f3fc": ["1f469-1f3fc-200d-1f9af", 18, 55, 15, ["👩🏼‍🦯"]], "1f3fd": ["1f469-1f3fd-200d-1f9af", 18, 56, 15, ["👩🏽‍🦯"]], "1f3fe": ["1f469-1f3fe-200d-1f9af", 18, 57, 15, ["👩🏾‍🦯"]], "1f3ff": ["1f469-1f3ff-200d-1f9af", 18, 58, 15, ["👩🏿‍🦯"]] },
      "1f469-200d-1f9b0": { "1f3fb": ["1f469-1f3fb-200d-1f9b0", 18, 60, 15, ["👩🏻‍🦰"]], "1f3fc": ["1f469-1f3fc-200d-1f9b0", 19, 0, 15, ["👩🏼‍🦰"]], "1f3fd": ["1f469-1f3fd-200d-1f9b0", 19, 1, 15, ["👩🏽‍🦰"]], "1f3fe": ["1f469-1f3fe-200d-1f9b0", 19, 2, 15, ["👩🏾‍🦰"]], "1f3ff": ["1f469-1f3ff-200d-1f9b0", 19, 3, 15, ["👩🏿‍🦰"]] },
      "1f469-200d-1f9b1": { "1f3fb": ["1f469-1f3fb-200d-1f9b1", 19, 5, 15, ["👩🏻‍🦱"]], "1f3fc": ["1f469-1f3fc-200d-1f9b1", 19, 6, 15, ["👩🏼‍🦱"]], "1f3fd": ["1f469-1f3fd-200d-1f9b1", 19, 7, 15, ["👩🏽‍🦱"]], "1f3fe": ["1f469-1f3fe-200d-1f9b1", 19, 8, 15, ["👩🏾‍🦱"]], "1f3ff": ["1f469-1f3ff-200d-1f9b1", 19, 9, 15, ["👩🏿‍🦱"]] },
      "1f469-200d-1f9b2": { "1f3fb": ["1f469-1f3fb-200d-1f9b2", 19, 11, 15, ["👩🏻‍🦲"]], "1f3fc": ["1f469-1f3fc-200d-1f9b2", 19, 12, 15, ["👩🏼‍🦲"]], "1f3fd": ["1f469-1f3fd-200d-1f9b2", 19, 13, 15, ["👩🏽‍🦲"]], "1f3fe": ["1f469-1f3fe-200d-1f9b2", 19, 14, 15, ["👩🏾‍🦲"]], "1f3ff": ["1f469-1f3ff-200d-1f9b2", 19, 15, 15, ["👩🏿‍🦲"]] },
      "1f469-200d-1f9b3": { "1f3fb": ["1f469-1f3fb-200d-1f9b3", 19, 17, 15, ["👩🏻‍🦳"]], "1f3fc": ["1f469-1f3fc-200d-1f9b3", 19, 18, 15, ["👩🏼‍🦳"]], "1f3fd": ["1f469-1f3fd-200d-1f9b3", 19, 19, 15, ["👩🏽‍🦳"]], "1f3fe": ["1f469-1f3fe-200d-1f9b3", 19, 20, 15, ["👩🏾‍🦳"]], "1f3ff": ["1f469-1f3ff-200d-1f9b3", 19, 21, 15, ["👩🏿‍🦳"]] },
      "1f469-200d-1f9bc": { "1f3fb": ["1f469-1f3fb-200d-1f9bc", 19, 23, 15, ["👩🏻‍🦼"]], "1f3fc": ["1f469-1f3fc-200d-1f9bc", 19, 24, 15, ["👩🏼‍🦼"]], "1f3fd": ["1f469-1f3fd-200d-1f9bc", 19, 25, 15, ["👩🏽‍🦼"]], "1f3fe": ["1f469-1f3fe-200d-1f9bc", 19, 26, 15, ["👩🏾‍🦼"]], "1f3ff": ["1f469-1f3ff-200d-1f9bc", 19, 27, 15, ["👩🏿‍🦼"]] },
      "1f469-200d-1f9bd": { "1f3fb": ["1f469-1f3fb-200d-1f9bd", 19, 29, 15, ["👩🏻‍🦽"]], "1f3fc": ["1f469-1f3fc-200d-1f9bd", 19, 30, 15, ["👩🏼‍🦽"]], "1f3fd": ["1f469-1f3fd-200d-1f9bd", 19, 31, 15, ["👩🏽‍🦽"]], "1f3fe": ["1f469-1f3fe-200d-1f9bd", 19, 32, 15, ["👩🏾‍🦽"]], "1f3ff": ["1f469-1f3ff-200d-1f9bd", 19, 33, 15, ["👩🏿‍🦽"]] },
      "1f469-200d-2695-fe0f": { "1f3fb": ["1f469-1f3fb-200d-2695-fe0f", 19, 35, 15, ["👩🏻‍⚕️"]], "1f3fc": ["1f469-1f3fc-200d-2695-fe0f", 19, 36, 15, ["👩🏼‍⚕️"]], "1f3fd": ["1f469-1f3fd-200d-2695-fe0f", 19, 37, 15, ["👩🏽‍⚕️"]], "1f3fe": ["1f469-1f3fe-200d-2695-fe0f", 19, 38, 15, ["👩🏾‍⚕️"]], "1f3ff": ["1f469-1f3ff-200d-2695-fe0f", 19, 39, 15, ["👩🏿‍⚕️"]] },
      "1f469-200d-2696-fe0f": { "1f3fb": ["1f469-1f3fb-200d-2696-fe0f", 19, 41, 15, ["👩🏻‍⚖️"]], "1f3fc": ["1f469-1f3fc-200d-2696-fe0f", 19, 42, 15, ["👩🏼‍⚖️"]], "1f3fd": ["1f469-1f3fd-200d-2696-fe0f", 19, 43, 15, ["👩🏽‍⚖️"]], "1f3fe": ["1f469-1f3fe-200d-2696-fe0f", 19, 44, 15, ["👩🏾‍⚖️"]], "1f3ff": ["1f469-1f3ff-200d-2696-fe0f", 19, 45, 15, ["👩🏿‍⚖️"]] },
      "1f469-200d-2708-fe0f": { "1f3fb": ["1f469-1f3fb-200d-2708-fe0f", 19, 47, 15, ["👩🏻‍✈️"]], "1f3fc": ["1f469-1f3fc-200d-2708-fe0f", 19, 48, 15, ["👩🏼‍✈️"]], "1f3fd": ["1f469-1f3fd-200d-2708-fe0f", 19, 49, 15, ["👩🏽‍✈️"]], "1f3fe": ["1f469-1f3fe-200d-2708-fe0f", 19, 50, 15, ["👩🏾‍✈️"]], "1f3ff": ["1f469-1f3ff-200d-2708-fe0f", 19, 51, 15, ["👩🏿‍✈️"]] },
      "1f469-200d-2764-fe0f-200d-1f468": { "1f3fb-1f3fb": ["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb", 19, 53, 15, ["👩🏻‍❤️‍👨🏻"]], "1f3fb-1f3fc": ["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc", 19, 54, 15, ["👩🏻‍❤️‍👨🏼"]], "1f3fb-1f3fd": ["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd", 19, 55, 15, ["👩🏻‍❤️‍👨🏽"]], "1f3fb-1f3fe": ["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe", 19, 56, 15, ["👩🏻‍❤️‍👨🏾"]], "1f3fb-1f3ff": ["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff", 19, 57, 15, ["👩🏻‍❤️‍👨🏿"]], "1f3fc-1f3fb": ["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb", 19, 58, 15, ["👩🏼‍❤️‍👨🏻"]], "1f3fc-1f3fc": ["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc", 19, 59, 15, ["👩🏼‍❤️‍👨🏼"]], "1f3fc-1f3fd": ["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd", 19, 60, 15, ["👩🏼‍❤️‍👨🏽"]], "1f3fc-1f3fe": ["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe", 20, 0, 15, ["👩🏼‍❤️‍👨🏾"]], "1f3fc-1f3ff": ["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff", 20, 1, 15, ["👩🏼‍❤️‍👨🏿"]], "1f3fd-1f3fb": ["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb", 20, 2, 15, ["👩🏽‍❤️‍👨🏻"]], "1f3fd-1f3fc": ["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc", 20, 3, 15, ["👩🏽‍❤️‍👨🏼"]], "1f3fd-1f3fd": ["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd", 20, 4, 15, ["👩🏽‍❤️‍👨🏽"]], "1f3fd-1f3fe": ["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe", 20, 5, 15, ["👩🏽‍❤️‍👨🏾"]], "1f3fd-1f3ff": ["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff", 20, 6, 15, ["👩🏽‍❤️‍👨🏿"]], "1f3fe-1f3fb": ["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb", 20, 7, 15, ["👩🏾‍❤️‍👨🏻"]], "1f3fe-1f3fc": ["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc", 20, 8, 15, ["👩🏾‍❤️‍👨🏼"]], "1f3fe-1f3fd": ["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd", 20, 9, 15, ["👩🏾‍❤️‍👨🏽"]], "1f3fe-1f3fe": ["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe", 20, 10, 15, ["👩🏾‍❤️‍👨🏾"]], "1f3fe-1f3ff": ["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff", 20, 11, 15, ["👩🏾‍❤️‍👨🏿"]], "1f3ff-1f3fb": ["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb", 20, 12, 15, ["👩🏿‍❤️‍👨🏻"]], "1f3ff-1f3fc": ["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc", 20, 13, 15, ["👩🏿‍❤️‍👨🏼"]], "1f3ff-1f3fd": ["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd", 20, 14, 15, ["👩🏿‍❤️‍👨🏽"]], "1f3ff-1f3fe": ["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe", 20, 15, 15, ["👩🏿‍❤️‍👨🏾"]], "1f3ff-1f3ff": ["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff", 20, 16, 15, ["👩🏿‍❤️‍👨🏿"]] },
      "1f469-200d-2764-fe0f-200d-1f469": { "1f3fb-1f3fb": ["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb", 20, 18, 15, ["👩🏻‍❤️‍👩🏻"]], "1f3fb-1f3fc": ["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc", 20, 19, 15, ["👩🏻‍❤️‍👩🏼"]], "1f3fb-1f3fd": ["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd", 20, 20, 15, ["👩🏻‍❤️‍👩🏽"]], "1f3fb-1f3fe": ["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe", 20, 21, 15, ["👩🏻‍❤️‍👩🏾"]], "1f3fb-1f3ff": ["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff", 20, 22, 15, ["👩🏻‍❤️‍👩🏿"]], "1f3fc-1f3fb": ["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb", 20, 23, 15, ["👩🏼‍❤️‍👩🏻"]], "1f3fc-1f3fc": ["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc", 20, 24, 15, ["👩🏼‍❤️‍👩🏼"]], "1f3fc-1f3fd": ["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd", 20, 25, 15, ["👩🏼‍❤️‍👩🏽"]], "1f3fc-1f3fe": ["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe", 20, 26, 15, ["👩🏼‍❤️‍👩🏾"]], "1f3fc-1f3ff": ["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff", 20, 27, 15, ["👩🏼‍❤️‍👩🏿"]], "1f3fd-1f3fb": ["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb", 20, 28, 15, ["👩🏽‍❤️‍👩🏻"]], "1f3fd-1f3fc": ["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc", 20, 29, 15, ["👩🏽‍❤️‍👩🏼"]], "1f3fd-1f3fd": ["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd", 20, 30, 15, ["👩🏽‍❤️‍👩🏽"]], "1f3fd-1f3fe": ["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe", 20, 31, 15, ["👩🏽‍❤️‍👩🏾"]], "1f3fd-1f3ff": ["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff", 20, 32, 15, ["👩🏽‍❤️‍👩🏿"]], "1f3fe-1f3fb": ["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb", 20, 33, 15, ["👩🏾‍❤️‍👩🏻"]], "1f3fe-1f3fc": ["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc", 20, 34, 15, ["👩🏾‍❤️‍👩🏼"]], "1f3fe-1f3fd": ["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd", 20, 35, 15, ["👩🏾‍❤️‍👩🏽"]], "1f3fe-1f3fe": ["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe", 20, 36, 15, ["👩🏾‍❤️‍👩🏾"]], "1f3fe-1f3ff": ["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff", 20, 37, 15, ["👩🏾‍❤️‍👩🏿"]], "1f3ff-1f3fb": ["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb", 20, 38, 15, ["👩🏿‍❤️‍👩🏻"]], "1f3ff-1f3fc": ["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc", 20, 39, 15, ["👩🏿‍❤️‍👩🏼"]], "1f3ff-1f3fd": ["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd", 20, 40, 15, ["👩🏿‍❤️‍👩🏽"]], "1f3ff-1f3fe": ["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe", 20, 41, 15, ["👩🏿‍❤️‍👩🏾"]], "1f3ff-1f3ff": ["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff", 20, 42, 15, ["👩🏿‍❤️‍👩🏿"]] },
      "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468": { "1f3fb-1f3fb": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 20, 44, 15, ["👩🏻‍❤️‍💋‍👨🏻"]], "1f3fb-1f3fc": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 20, 45, 15, ["👩🏻‍❤️‍💋‍👨🏼"]], "1f3fb-1f3fd": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 20, 46, 15, ["👩🏻‍❤️‍💋‍👨🏽"]], "1f3fb-1f3fe": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 20, 47, 15, ["👩🏻‍❤️‍💋‍👨🏾"]], "1f3fb-1f3ff": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 20, 48, 15, ["👩🏻‍❤️‍💋‍👨🏿"]], "1f3fc-1f3fb": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 20, 49, 15, ["👩🏼‍❤️‍💋‍👨🏻"]], "1f3fc-1f3fc": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 20, 50, 15, ["👩🏼‍❤️‍💋‍👨🏼"]], "1f3fc-1f3fd": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 20, 51, 15, ["👩🏼‍❤️‍💋‍👨🏽"]], "1f3fc-1f3fe": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 20, 52, 15, ["👩🏼‍❤️‍💋‍👨🏾"]], "1f3fc-1f3ff": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 20, 53, 15, ["👩🏼‍❤️‍💋‍👨🏿"]], "1f3fd-1f3fb": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 20, 54, 15, ["👩🏽‍❤️‍💋‍👨🏻"]], "1f3fd-1f3fc": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 20, 55, 15, ["👩🏽‍❤️‍💋‍👨🏼"]], "1f3fd-1f3fd": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 20, 56, 15, ["👩🏽‍❤️‍💋‍👨🏽"]], "1f3fd-1f3fe": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 20, 57, 15, ["👩🏽‍❤️‍💋‍👨🏾"]], "1f3fd-1f3ff": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 20, 58, 15, ["👩🏽‍❤️‍💋‍👨🏿"]], "1f3fe-1f3fb": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 20, 59, 15, ["👩🏾‍❤️‍💋‍👨🏻"]], "1f3fe-1f3fc": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 20, 60, 15, ["👩🏾‍❤️‍💋‍👨🏼"]], "1f3fe-1f3fd": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 21, 0, 15, ["👩🏾‍❤️‍💋‍👨🏽"]], "1f3fe-1f3fe": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 21, 1, 15, ["👩🏾‍❤️‍💋‍👨🏾"]], "1f3fe-1f3ff": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 21, 2, 15, ["👩🏾‍❤️‍💋‍👨🏿"]], "1f3ff-1f3fb": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", 21, 3, 15, ["👩🏿‍❤️‍💋‍👨🏻"]], "1f3ff-1f3fc": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", 21, 4, 15, ["👩🏿‍❤️‍💋‍👨🏼"]], "1f3ff-1f3fd": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", 21, 5, 15, ["👩🏿‍❤️‍💋‍👨🏽"]], "1f3ff-1f3fe": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", 21, 6, 15, ["👩🏿‍❤️‍💋‍👨🏾"]], "1f3ff-1f3ff": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", 21, 7, 15, ["👩🏿‍❤️‍💋‍👨🏿"]] },
      "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469": { "1f3fb-1f3fb": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", 21, 9, 15, ["👩🏻‍❤️‍💋‍👩🏻"]], "1f3fb-1f3fc": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", 21, 10, 15, ["👩🏻‍❤️‍💋‍👩🏼"]], "1f3fb-1f3fd": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", 21, 11, 15, ["👩🏻‍❤️‍💋‍👩🏽"]], "1f3fb-1f3fe": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", 21, 12, 15, ["👩🏻‍❤️‍💋‍👩🏾"]], "1f3fb-1f3ff": ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", 21, 13, 15, ["👩🏻‍❤️‍💋‍👩🏿"]], "1f3fc-1f3fb": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", 21, 14, 15, ["👩🏼‍❤️‍💋‍👩🏻"]], "1f3fc-1f3fc": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", 21, 15, 15, ["👩🏼‍❤️‍💋‍👩🏼"]], "1f3fc-1f3fd": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", 21, 16, 15, ["👩🏼‍❤️‍💋‍👩🏽"]], "1f3fc-1f3fe": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", 21, 17, 15, ["👩🏼‍❤️‍💋‍👩🏾"]], "1f3fc-1f3ff": ["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", 21, 18, 15, ["👩🏼‍❤️‍💋‍👩🏿"]], "1f3fd-1f3fb": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", 21, 19, 15, ["👩🏽‍❤️‍💋‍👩🏻"]], "1f3fd-1f3fc": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", 21, 20, 15, ["👩🏽‍❤️‍💋‍👩🏼"]], "1f3fd-1f3fd": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", 21, 21, 15, ["👩🏽‍❤️‍💋‍👩🏽"]], "1f3fd-1f3fe": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", 21, 22, 15, ["👩🏽‍❤️‍💋‍👩🏾"]], "1f3fd-1f3ff": ["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", 21, 23, 15, ["👩🏽‍❤️‍💋‍👩🏿"]], "1f3fe-1f3fb": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", 21, 24, 15, ["👩🏾‍❤️‍💋‍👩🏻"]], "1f3fe-1f3fc": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", 21, 25, 15, ["👩🏾‍❤️‍💋‍👩🏼"]], "1f3fe-1f3fd": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", 21, 26, 15, ["👩🏾‍❤️‍💋‍👩🏽"]], "1f3fe-1f3fe": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", 21, 27, 15, ["👩🏾‍❤️‍💋‍👩🏾"]], "1f3fe-1f3ff": ["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", 21, 28, 15, ["👩🏾‍❤️‍💋‍👩🏿"]], "1f3ff-1f3fb": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", 21, 29, 15, ["👩🏿‍❤️‍💋‍👩🏻"]], "1f3ff-1f3fc": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", 21, 30, 15, ["👩🏿‍❤️‍💋‍👩🏼"]], "1f3ff-1f3fd": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", 21, 31, 15, ["👩🏿‍❤️‍💋‍👩🏽"]], "1f3ff-1f3fe": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", 21, 32, 15, ["👩🏿‍❤️‍💋‍👩🏾"]], "1f3ff-1f3ff": ["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", 21, 33, 15, ["👩🏿‍❤️‍💋‍👩🏿"]] },
      "1f469": { "1f3fb": ["1f469-1f3fb", 21, 35, 15, ["👩🏻"]], "1f3fc": ["1f469-1f3fc", 21, 36, 15, ["👩🏼"]], "1f3fd": ["1f469-1f3fd", 21, 37, 15, ["👩🏽"]], "1f3fe": ["1f469-1f3fe", 21, 38, 15, ["👩🏾"]], "1f3ff": ["1f469-1f3ff", 21, 39, 15, ["👩🏿"]] },
      "1f46b": { "1f3fb": ["1f46b-1f3fb", 21, 42, 15, ["👫🏻"]], "1f3fc": ["1f46b-1f3fc", 21, 43, 15, ["👫🏼"]], "1f3fd": ["1f46b-1f3fd", 21, 44, 15, ["👫🏽"]], "1f3fe": ["1f46b-1f3fe", 21, 45, 15, ["👫🏾"]], "1f3ff": ["1f46b-1f3ff", 21, 46, 15, ["👫🏿"]], "1f3fb-1f3fc": ["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc", 21, 47, 15, ["👩🏻‍🤝‍👨🏼"]], "1f3fb-1f3fd": ["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd", 21, 48, 15, ["👩🏻‍🤝‍👨🏽"]], "1f3fb-1f3fe": ["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe", 21, 49, 15, ["👩🏻‍🤝‍👨🏾"]], "1f3fb-1f3ff": ["1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff", 21, 50, 15, ["👩🏻‍🤝‍👨🏿"]], "1f3fc-1f3fb": ["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb", 21, 51, 15, ["👩🏼‍🤝‍👨🏻"]], "1f3fc-1f3fd": ["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd", 21, 52, 15, ["👩🏼‍🤝‍👨🏽"]], "1f3fc-1f3fe": ["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe", 21, 53, 15, ["👩🏼‍🤝‍👨🏾"]], "1f3fc-1f3ff": ["1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff", 21, 54, 15, ["👩🏼‍🤝‍👨🏿"]], "1f3fd-1f3fb": ["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb", 21, 55, 15, ["👩🏽‍🤝‍👨🏻"]], "1f3fd-1f3fc": ["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc", 21, 56, 15, ["👩🏽‍🤝‍👨🏼"]], "1f3fd-1f3fe": ["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe", 21, 57, 15, ["👩🏽‍🤝‍👨🏾"]], "1f3fd-1f3ff": ["1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff", 21, 58, 15, ["👩🏽‍🤝‍👨🏿"]], "1f3fe-1f3fb": ["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb", 21, 59, 15, ["👩🏾‍🤝‍👨🏻"]], "1f3fe-1f3fc": ["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc", 21, 60, 15, ["👩🏾‍🤝‍👨🏼"]], "1f3fe-1f3fd": ["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd", 22, 0, 15, ["👩🏾‍🤝‍👨🏽"]], "1f3fe-1f3ff": ["1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff", 22, 1, 15, ["👩🏾‍🤝‍👨🏿"]], "1f3ff-1f3fb": ["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb", 22, 2, 15, ["👩🏿‍🤝‍👨🏻"]], "1f3ff-1f3fc": ["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc", 22, 3, 15, ["👩🏿‍🤝‍👨🏼"]], "1f3ff-1f3fd": ["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd", 22, 4, 15, ["👩🏿‍🤝‍👨🏽"]], "1f3ff-1f3fe": ["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe", 22, 5, 15, ["👩🏿‍🤝‍👨🏾"]] },
      "1f46c": { "1f3fb": ["1f46c-1f3fb", 22, 7, 15, ["👬🏻"]], "1f3fc": ["1f46c-1f3fc", 22, 8, 15, ["👬🏼"]], "1f3fd": ["1f46c-1f3fd", 22, 9, 15, ["👬🏽"]], "1f3fe": ["1f46c-1f3fe", 22, 10, 15, ["👬🏾"]], "1f3ff": ["1f46c-1f3ff", 22, 11, 15, ["👬🏿"]], "1f3fb-1f3fc": ["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc", 22, 12, 15, ["👨🏻‍🤝‍👨🏼"]], "1f3fb-1f3fd": ["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd", 22, 13, 15, ["👨🏻‍🤝‍👨🏽"]], "1f3fb-1f3fe": ["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe", 22, 14, 15, ["👨🏻‍🤝‍👨🏾"]], "1f3fb-1f3ff": ["1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff", 22, 15, 15, ["👨🏻‍🤝‍👨🏿"]], "1f3fc-1f3fb": ["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb", 22, 16, 15, ["👨🏼‍🤝‍👨🏻"]], "1f3fc-1f3fd": ["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd", 22, 17, 15, ["👨🏼‍🤝‍👨🏽"]], "1f3fc-1f3fe": ["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe", 22, 18, 15, ["👨🏼‍🤝‍👨🏾"]], "1f3fc-1f3ff": ["1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff", 22, 19, 15, ["👨🏼‍🤝‍👨🏿"]], "1f3fd-1f3fb": ["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb", 22, 20, 15, ["👨🏽‍🤝‍👨🏻"]], "1f3fd-1f3fc": ["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc", 22, 21, 15, ["👨🏽‍🤝‍👨🏼"]], "1f3fd-1f3fe": ["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe", 22, 22, 15, ["👨🏽‍🤝‍👨🏾"]], "1f3fd-1f3ff": ["1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff", 22, 23, 15, ["👨🏽‍🤝‍👨🏿"]], "1f3fe-1f3fb": ["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb", 22, 24, 15, ["👨🏾‍🤝‍👨🏻"]], "1f3fe-1f3fc": ["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc", 22, 25, 15, ["👨🏾‍🤝‍👨🏼"]], "1f3fe-1f3fd": ["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd", 22, 26, 15, ["👨🏾‍🤝‍👨🏽"]], "1f3fe-1f3ff": ["1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff", 22, 27, 15, ["👨🏾‍🤝‍👨🏿"]], "1f3ff-1f3fb": ["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb", 22, 28, 15, ["👨🏿‍🤝‍👨🏻"]], "1f3ff-1f3fc": ["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc", 22, 29, 15, ["👨🏿‍🤝‍👨🏼"]], "1f3ff-1f3fd": ["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd", 22, 30, 15, ["👨🏿‍🤝‍👨🏽"]], "1f3ff-1f3fe": ["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe", 22, 31, 15, ["👨🏿‍🤝‍👨🏾"]] },
      "1f46d": { "1f3fb": ["1f46d-1f3fb", 22, 33, 15, ["👭🏻"]], "1f3fc": ["1f46d-1f3fc", 22, 34, 15, ["👭🏼"]], "1f3fd": ["1f46d-1f3fd", 22, 35, 15, ["👭🏽"]], "1f3fe": ["1f46d-1f3fe", 22, 36, 15, ["👭🏾"]], "1f3ff": ["1f46d-1f3ff", 22, 37, 15, ["👭🏿"]], "1f3fb-1f3fc": ["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc", 22, 38, 15, ["👩🏻‍🤝‍👩🏼"]], "1f3fb-1f3fd": ["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd", 22, 39, 15, ["👩🏻‍🤝‍👩🏽"]], "1f3fb-1f3fe": ["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe", 22, 40, 15, ["👩🏻‍🤝‍👩🏾"]], "1f3fb-1f3ff": ["1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff", 22, 41, 15, ["👩🏻‍🤝‍👩🏿"]], "1f3fc-1f3fb": ["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb", 22, 42, 15, ["👩🏼‍🤝‍👩🏻"]], "1f3fc-1f3fd": ["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd", 22, 43, 15, ["👩🏼‍🤝‍👩🏽"]], "1f3fc-1f3fe": ["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe", 22, 44, 15, ["👩🏼‍🤝‍👩🏾"]], "1f3fc-1f3ff": ["1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff", 22, 45, 15, ["👩🏼‍🤝‍👩🏿"]], "1f3fd-1f3fb": ["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb", 22, 46, 15, ["👩🏽‍🤝‍👩🏻"]], "1f3fd-1f3fc": ["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc", 22, 47, 15, ["👩🏽‍🤝‍👩🏼"]], "1f3fd-1f3fe": ["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe", 22, 48, 15, ["👩🏽‍🤝‍👩🏾"]], "1f3fd-1f3ff": ["1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff", 22, 49, 15, ["👩🏽‍🤝‍👩🏿"]], "1f3fe-1f3fb": ["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb", 22, 50, 15, ["👩🏾‍🤝‍👩🏻"]], "1f3fe-1f3fc": ["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc", 22, 51, 15, ["👩🏾‍🤝‍👩🏼"]], "1f3fe-1f3fd": ["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd", 22, 52, 15, ["👩🏾‍🤝‍👩🏽"]], "1f3fe-1f3ff": ["1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff", 22, 53, 15, ["👩🏾‍🤝‍👩🏿"]], "1f3ff-1f3fb": ["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb", 22, 54, 15, ["👩🏿‍🤝‍👩🏻"]], "1f3ff-1f3fc": ["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc", 22, 55, 15, ["👩🏿‍🤝‍👩🏼"]], "1f3ff-1f3fd": ["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd", 22, 56, 15, ["👩🏿‍🤝‍👩🏽"]], "1f3ff-1f3fe": ["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe", 22, 57, 15, ["👩🏿‍🤝‍👩🏾"]] },
      "1f46e-200d-2640-fe0f": { "1f3fb": ["1f46e-1f3fb-200d-2640-fe0f", 22, 59, 15, ["👮🏻‍♀️"]], "1f3fc": ["1f46e-1f3fc-200d-2640-fe0f", 22, 60, 15, ["👮🏼‍♀️"]], "1f3fd": ["1f46e-1f3fd-200d-2640-fe0f", 23, 0, 15, ["👮🏽‍♀️"]], "1f3fe": ["1f46e-1f3fe-200d-2640-fe0f", 23, 1, 15, ["👮🏾‍♀️"]], "1f3ff": ["1f46e-1f3ff-200d-2640-fe0f", 23, 2, 15, ["👮🏿‍♀️"]] },
      "1f46e-200d-2642-fe0f": { "1f3fb": ["1f46e-1f3fb-200d-2642-fe0f", 23, 4, 15, ["👮🏻‍♂️", "👮🏻"]], "1f3fc": ["1f46e-1f3fc-200d-2642-fe0f", 23, 5, 15, ["👮🏼‍♂️", "👮🏼"]], "1f3fd": ["1f46e-1f3fd-200d-2642-fe0f", 23, 6, 15, ["👮🏽‍♂️", "👮🏽"]], "1f3fe": ["1f46e-1f3fe-200d-2642-fe0f", 23, 7, 15, ["👮🏾‍♂️", "👮🏾"]], "1f3ff": ["1f46e-1f3ff-200d-2642-fe0f", 23, 8, 15, ["👮🏿‍♂️", "👮🏿"]] },
      "1f470-200d-2640-fe0f": { "1f3fb": ["1f470-1f3fb-200d-2640-fe0f", 23, 19, 15, ["👰🏻‍♀️"]], "1f3fc": ["1f470-1f3fc-200d-2640-fe0f", 23, 20, 15, ["👰🏼‍♀️"]], "1f3fd": ["1f470-1f3fd-200d-2640-fe0f", 23, 21, 15, ["👰🏽‍♀️"]], "1f3fe": ["1f470-1f3fe-200d-2640-fe0f", 23, 22, 15, ["👰🏾‍♀️"]], "1f3ff": ["1f470-1f3ff-200d-2640-fe0f", 23, 23, 15, ["👰🏿‍♀️"]] },
      "1f470-200d-2642-fe0f": { "1f3fb": ["1f470-1f3fb-200d-2642-fe0f", 23, 25, 15, ["👰🏻‍♂️"]], "1f3fc": ["1f470-1f3fc-200d-2642-fe0f", 23, 26, 15, ["👰🏼‍♂️"]], "1f3fd": ["1f470-1f3fd-200d-2642-fe0f", 23, 27, 15, ["👰🏽‍♂️"]], "1f3fe": ["1f470-1f3fe-200d-2642-fe0f", 23, 28, 15, ["👰🏾‍♂️"]], "1f3ff": ["1f470-1f3ff-200d-2642-fe0f", 23, 29, 15, ["👰🏿‍♂️"]] },
      "1f470": { "1f3fb": ["1f470-1f3fb", 23, 31, 15, ["👰🏻"]], "1f3fc": ["1f470-1f3fc", 23, 32, 15, ["👰🏼"]], "1f3fd": ["1f470-1f3fd", 23, 33, 15, ["👰🏽"]], "1f3fe": ["1f470-1f3fe", 23, 34, 15, ["👰🏾"]], "1f3ff": ["1f470-1f3ff", 23, 35, 15, ["👰🏿"]] },
      "1f471-200d-2640-fe0f": { "1f3fb": ["1f471-1f3fb-200d-2640-fe0f", 23, 37, 15, ["👱🏻‍♀️"]], "1f3fc": ["1f471-1f3fc-200d-2640-fe0f", 23, 38, 15, ["👱🏼‍♀️"]], "1f3fd": ["1f471-1f3fd-200d-2640-fe0f", 23, 39, 15, ["👱🏽‍♀️"]], "1f3fe": ["1f471-1f3fe-200d-2640-fe0f", 23, 40, 15, ["👱🏾‍♀️"]], "1f3ff": ["1f471-1f3ff-200d-2640-fe0f", 23, 41, 15, ["👱🏿‍♀️"]] },
      "1f471-200d-2642-fe0f": { "1f3fb": ["1f471-1f3fb-200d-2642-fe0f", 23, 43, 15, ["👱🏻‍♂️", "👱🏻"]], "1f3fc": ["1f471-1f3fc-200d-2642-fe0f", 23, 44, 15, ["👱🏼‍♂️", "👱🏼"]], "1f3fd": ["1f471-1f3fd-200d-2642-fe0f", 23, 45, 15, ["👱🏽‍♂️", "👱🏽"]], "1f3fe": ["1f471-1f3fe-200d-2642-fe0f", 23, 46, 15, ["👱🏾‍♂️", "👱🏾"]], "1f3ff": ["1f471-1f3ff-200d-2642-fe0f", 23, 47, 15, ["👱🏿‍♂️", "👱🏿"]] },
      "1f472": { "1f3fb": ["1f472-1f3fb", 23, 55, 15, ["👲🏻"]], "1f3fc": ["1f472-1f3fc", 23, 56, 15, ["👲🏼"]], "1f3fd": ["1f472-1f3fd", 23, 57, 15, ["👲🏽"]], "1f3fe": ["1f472-1f3fe", 23, 58, 15, ["👲🏾"]], "1f3ff": ["1f472-1f3ff", 23, 59, 15, ["👲🏿"]] },
      "1f473-200d-2640-fe0f": { "1f3fb": ["1f473-1f3fb-200d-2640-fe0f", 24, 0, 15, ["👳🏻‍♀️"]], "1f3fc": ["1f473-1f3fc-200d-2640-fe0f", 24, 1, 15, ["👳🏼‍♀️"]], "1f3fd": ["1f473-1f3fd-200d-2640-fe0f", 24, 2, 15, ["👳🏽‍♀️"]], "1f3fe": ["1f473-1f3fe-200d-2640-fe0f", 24, 3, 15, ["👳🏾‍♀️"]], "1f3ff": ["1f473-1f3ff-200d-2640-fe0f", 24, 4, 15, ["👳🏿‍♀️"]] },
      "1f473-200d-2642-fe0f": { "1f3fb": ["1f473-1f3fb-200d-2642-fe0f", 24, 6, 15, ["👳🏻‍♂️", "👳🏻"]], "1f3fc": ["1f473-1f3fc-200d-2642-fe0f", 24, 7, 15, ["👳🏼‍♂️", "👳🏼"]], "1f3fd": ["1f473-1f3fd-200d-2642-fe0f", 24, 8, 15, ["👳🏽‍♂️", "👳🏽"]], "1f3fe": ["1f473-1f3fe-200d-2642-fe0f", 24, 9, 15, ["👳🏾‍♂️", "👳🏾"]], "1f3ff": ["1f473-1f3ff-200d-2642-fe0f", 24, 10, 15, ["👳🏿‍♂️", "👳🏿"]] },
      "1f474": { "1f3fb": ["1f474-1f3fb", 24, 18, 15, ["👴🏻"]], "1f3fc": ["1f474-1f3fc", 24, 19, 15, ["👴🏼"]], "1f3fd": ["1f474-1f3fd", 24, 20, 15, ["👴🏽"]], "1f3fe": ["1f474-1f3fe", 24, 21, 15, ["👴🏾"]], "1f3ff": ["1f474-1f3ff", 24, 22, 15, ["👴🏿"]] },
      "1f475": { "1f3fb": ["1f475-1f3fb", 24, 24, 15, ["👵🏻"]], "1f3fc": ["1f475-1f3fc", 24, 25, 15, ["👵🏼"]], "1f3fd": ["1f475-1f3fd", 24, 26, 15, ["👵🏽"]], "1f3fe": ["1f475-1f3fe", 24, 27, 15, ["👵🏾"]], "1f3ff": ["1f475-1f3ff", 24, 28, 15, ["👵🏿"]] },
      "1f476": { "1f3fb": ["1f476-1f3fb", 24, 30, 15, ["👶🏻"]], "1f3fc": ["1f476-1f3fc", 24, 31, 15, ["👶🏼"]], "1f3fd": ["1f476-1f3fd", 24, 32, 15, ["👶🏽"]], "1f3fe": ["1f476-1f3fe", 24, 33, 15, ["👶🏾"]], "1f3ff": ["1f476-1f3ff", 24, 34, 15, ["👶🏿"]] },
      "1f477-200d-2640-fe0f": { "1f3fb": ["1f477-1f3fb-200d-2640-fe0f", 24, 36, 15, ["👷🏻‍♀️"]], "1f3fc": ["1f477-1f3fc-200d-2640-fe0f", 24, 37, 15, ["👷🏼‍♀️"]], "1f3fd": ["1f477-1f3fd-200d-2640-fe0f", 24, 38, 15, ["👷🏽‍♀️"]], "1f3fe": ["1f477-1f3fe-200d-2640-fe0f", 24, 39, 15, ["👷🏾‍♀️"]], "1f3ff": ["1f477-1f3ff-200d-2640-fe0f", 24, 40, 15, ["👷🏿‍♀️"]] },
      "1f477-200d-2642-fe0f": { "1f3fb": ["1f477-1f3fb-200d-2642-fe0f", 24, 42, 15, ["👷🏻‍♂️", "👷🏻"]], "1f3fc": ["1f477-1f3fc-200d-2642-fe0f", 24, 43, 15, ["👷🏼‍♂️", "👷🏼"]], "1f3fd": ["1f477-1f3fd-200d-2642-fe0f", 24, 44, 15, ["👷🏽‍♂️", "👷🏽"]], "1f3fe": ["1f477-1f3fe-200d-2642-fe0f", 24, 45, 15, ["👷🏾‍♂️", "👷🏾"]], "1f3ff": ["1f477-1f3ff-200d-2642-fe0f", 24, 46, 15, ["👷🏿‍♂️", "👷🏿"]] },
      "1f478": { "1f3fb": ["1f478-1f3fb", 24, 54, 15, ["👸🏻"]], "1f3fc": ["1f478-1f3fc", 24, 55, 15, ["👸🏼"]], "1f3fd": ["1f478-1f3fd", 24, 56, 15, ["👸🏽"]], "1f3fe": ["1f478-1f3fe", 24, 57, 15, ["👸🏾"]], "1f3ff": ["1f478-1f3ff", 24, 58, 15, ["👸🏿"]] },
      "1f47c": { "1f3fb": ["1f47c-1f3fb", 25, 2, 15, ["👼🏻"]], "1f3fc": ["1f47c-1f3fc", 25, 3, 15, ["👼🏼"]], "1f3fd": ["1f47c-1f3fd", 25, 4, 15, ["👼🏽"]], "1f3fe": ["1f47c-1f3fe", 25, 5, 15, ["👼🏾"]], "1f3ff": ["1f47c-1f3ff", 25, 6, 15, ["👼🏿"]] },
      "1f481-200d-2640-fe0f": { "1f3fb": ["1f481-1f3fb-200d-2640-fe0f", 25, 12, 15, ["💁🏻‍♀️", "💁🏻"]], "1f3fc": ["1f481-1f3fc-200d-2640-fe0f", 25, 13, 15, ["💁🏼‍♀️", "💁🏼"]], "1f3fd": ["1f481-1f3fd-200d-2640-fe0f", 25, 14, 15, ["💁🏽‍♀️", "💁🏽"]], "1f3fe": ["1f481-1f3fe-200d-2640-fe0f", 25, 15, 15, ["💁🏾‍♀️", "💁🏾"]], "1f3ff": ["1f481-1f3ff-200d-2640-fe0f", 25, 16, 15, ["💁🏿‍♀️", "💁🏿"]] },
      "1f481-200d-2642-fe0f": { "1f3fb": ["1f481-1f3fb-200d-2642-fe0f", 25, 18, 15, ["💁🏻‍♂️"]], "1f3fc": ["1f481-1f3fc-200d-2642-fe0f", 25, 19, 15, ["💁🏼‍♂️"]], "1f3fd": ["1f481-1f3fd-200d-2642-fe0f", 25, 20, 15, ["💁🏽‍♂️"]], "1f3fe": ["1f481-1f3fe-200d-2642-fe0f", 25, 21, 15, ["💁🏾‍♂️"]], "1f3ff": ["1f481-1f3ff-200d-2642-fe0f", 25, 22, 15, ["💁🏿‍♂️"]] },
      "1f482-200d-2640-fe0f": { "1f3fb": ["1f482-1f3fb-200d-2640-fe0f", 25, 30, 15, ["💂🏻‍♀️"]], "1f3fc": ["1f482-1f3fc-200d-2640-fe0f", 25, 31, 15, ["💂🏼‍♀️"]], "1f3fd": ["1f482-1f3fd-200d-2640-fe0f", 25, 32, 15, ["💂🏽‍♀️"]], "1f3fe": ["1f482-1f3fe-200d-2640-fe0f", 25, 33, 15, ["💂🏾‍♀️"]], "1f3ff": ["1f482-1f3ff-200d-2640-fe0f", 25, 34, 15, ["💂🏿‍♀️"]] },
      "1f482-200d-2642-fe0f": { "1f3fb": ["1f482-1f3fb-200d-2642-fe0f", 25, 36, 15, ["💂🏻‍♂️", "💂🏻"]], "1f3fc": ["1f482-1f3fc-200d-2642-fe0f", 25, 37, 15, ["💂🏼‍♂️", "💂🏼"]], "1f3fd": ["1f482-1f3fd-200d-2642-fe0f", 25, 38, 15, ["💂🏽‍♂️", "💂🏽"]], "1f3fe": ["1f482-1f3fe-200d-2642-fe0f", 25, 39, 15, ["💂🏾‍♂️", "💂🏾"]], "1f3ff": ["1f482-1f3ff-200d-2642-fe0f", 25, 40, 15, ["💂🏿‍♂️", "💂🏿"]] },
      "1f483": { "1f3fb": ["1f483-1f3fb", 25, 48, 15, ["💃🏻"]], "1f3fc": ["1f483-1f3fc", 25, 49, 15, ["💃🏼"]], "1f3fd": ["1f483-1f3fd", 25, 50, 15, ["💃🏽"]], "1f3fe": ["1f483-1f3fe", 25, 51, 15, ["💃🏾"]], "1f3ff": ["1f483-1f3ff", 25, 52, 15, ["💃🏿"]] },
      "1f485": { "1f3fb": ["1f485-1f3fb", 25, 55, 15, ["💅🏻"]], "1f3fc": ["1f485-1f3fc", 25, 56, 15, ["💅🏼"]], "1f3fd": ["1f485-1f3fd", 25, 57, 15, ["💅🏽"]], "1f3fe": ["1f485-1f3fe", 25, 58, 15, ["💅🏾"]], "1f3ff": ["1f485-1f3ff", 25, 59, 15, ["💅🏿"]] },
      "1f486-200d-2640-fe0f": { "1f3fb": ["1f486-1f3fb-200d-2640-fe0f", 26, 0, 15, ["💆🏻‍♀️", "💆🏻"]], "1f3fc": ["1f486-1f3fc-200d-2640-fe0f", 26, 1, 15, ["💆🏼‍♀️", "💆🏼"]], "1f3fd": ["1f486-1f3fd-200d-2640-fe0f", 26, 2, 15, ["💆🏽‍♀️", "💆🏽"]], "1f3fe": ["1f486-1f3fe-200d-2640-fe0f", 26, 3, 15, ["💆🏾‍♀️", "💆🏾"]], "1f3ff": ["1f486-1f3ff-200d-2640-fe0f", 26, 4, 15, ["💆🏿‍♀️", "💆🏿"]] },
      "1f486-200d-2642-fe0f": { "1f3fb": ["1f486-1f3fb-200d-2642-fe0f", 26, 6, 15, ["💆🏻‍♂️"]], "1f3fc": ["1f486-1f3fc-200d-2642-fe0f", 26, 7, 15, ["💆🏼‍♂️"]], "1f3fd": ["1f486-1f3fd-200d-2642-fe0f", 26, 8, 15, ["💆🏽‍♂️"]], "1f3fe": ["1f486-1f3fe-200d-2642-fe0f", 26, 9, 15, ["💆🏾‍♂️"]], "1f3ff": ["1f486-1f3ff-200d-2642-fe0f", 26, 10, 15, ["💆🏿‍♂️"]] },
      "1f487-200d-2640-fe0f": { "1f3fb": ["1f487-1f3fb-200d-2640-fe0f", 26, 18, 15, ["💇🏻‍♀️", "💇🏻"]], "1f3fc": ["1f487-1f3fc-200d-2640-fe0f", 26, 19, 15, ["💇🏼‍♀️", "💇🏼"]], "1f3fd": ["1f487-1f3fd-200d-2640-fe0f", 26, 20, 15, ["💇🏽‍♀️", "💇🏽"]], "1f3fe": ["1f487-1f3fe-200d-2640-fe0f", 26, 21, 15, ["💇🏾‍♀️", "💇🏾"]], "1f3ff": ["1f487-1f3ff-200d-2640-fe0f", 26, 22, 15, ["💇🏿‍♀️", "💇🏿"]] },
      "1f487-200d-2642-fe0f": { "1f3fb": ["1f487-1f3fb-200d-2642-fe0f", 26, 24, 15, ["💇🏻‍♂️"]], "1f3fc": ["1f487-1f3fc-200d-2642-fe0f", 26, 25, 15, ["💇🏼‍♂️"]], "1f3fd": ["1f487-1f3fd-200d-2642-fe0f", 26, 26, 15, ["💇🏽‍♂️"]], "1f3fe": ["1f487-1f3fe-200d-2642-fe0f", 26, 27, 15, ["💇🏾‍♂️"]], "1f3ff": ["1f487-1f3ff-200d-2642-fe0f", 26, 28, 15, ["💇🏿‍♂️"]] },
      "1f48f": { "1f3fb": ["1f48f-1f3fb", 26, 43, 15, ["💏🏻"]], "1f3fc": ["1f48f-1f3fc", 26, 44, 15, ["💏🏼"]], "1f3fd": ["1f48f-1f3fd", 26, 45, 15, ["💏🏽"]], "1f3fe": ["1f48f-1f3fe", 26, 46, 15, ["💏🏾"]], "1f3ff": ["1f48f-1f3ff", 26, 47, 15, ["💏🏿"]], "1f3fb-1f3fc": ["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", 26, 48, 15, ["🧑🏻‍❤️‍💋‍🧑🏼"]], "1f3fb-1f3fd": ["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", 26, 49, 15, ["🧑🏻‍❤️‍💋‍🧑🏽"]], "1f3fb-1f3fe": ["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", 26, 50, 15, ["🧑🏻‍❤️‍💋‍🧑🏾"]], "1f3fb-1f3ff": ["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", 26, 51, 15, ["🧑🏻‍❤️‍💋‍🧑🏿"]], "1f3fc-1f3fb": ["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", 26, 52, 15, ["🧑🏼‍❤️‍💋‍🧑🏻"]], "1f3fc-1f3fd": ["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", 26, 53, 15, ["🧑🏼‍❤️‍💋‍🧑🏽"]], "1f3fc-1f3fe": ["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", 26, 54, 15, ["🧑🏼‍❤️‍💋‍🧑🏾"]], "1f3fc-1f3ff": ["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", 26, 55, 15, ["🧑🏼‍❤️‍💋‍🧑🏿"]], "1f3fd-1f3fb": ["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", 26, 56, 15, ["🧑🏽‍❤️‍💋‍🧑🏻"]], "1f3fd-1f3fc": ["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", 26, 57, 15, ["🧑🏽‍❤️‍💋‍🧑🏼"]], "1f3fd-1f3fe": ["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", 26, 58, 15, ["🧑🏽‍❤️‍💋‍🧑🏾"]], "1f3fd-1f3ff": ["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", 26, 59, 15, ["🧑🏽‍❤️‍💋‍🧑🏿"]], "1f3fe-1f3fb": ["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", 26, 60, 15, ["🧑🏾‍❤️‍💋‍🧑🏻"]], "1f3fe-1f3fc": ["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", 27, 0, 15, ["🧑🏾‍❤️‍💋‍🧑🏼"]], "1f3fe-1f3fd": ["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", 27, 1, 15, ["🧑🏾‍❤️‍💋‍🧑🏽"]], "1f3fe-1f3ff": ["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", 27, 2, 15, ["🧑🏾‍❤️‍💋‍🧑🏿"]], "1f3ff-1f3fb": ["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", 27, 3, 15, ["🧑🏿‍❤️‍💋‍🧑🏻"]], "1f3ff-1f3fc": ["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", 27, 4, 15, ["🧑🏿‍❤️‍💋‍🧑🏼"]], "1f3ff-1f3fd": ["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", 27, 5, 15, ["🧑🏿‍❤️‍💋‍🧑🏽"]], "1f3ff-1f3fe": ["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", 27, 6, 15, ["🧑🏿‍❤️‍💋‍🧑🏾"]] },
      "1f491": { "1f3fb": ["1f491-1f3fb", 27, 9, 15, ["💑🏻"]], "1f3fc": ["1f491-1f3fc", 27, 10, 15, ["💑🏼"]], "1f3fd": ["1f491-1f3fd", 27, 11, 15, ["💑🏽"]], "1f3fe": ["1f491-1f3fe", 27, 12, 15, ["💑🏾"]], "1f3ff": ["1f491-1f3ff", 27, 13, 15, ["💑🏿"]], "1f3fb-1f3fc": ["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc", 27, 14, 15, ["🧑🏻‍❤️‍🧑🏼"]], "1f3fb-1f3fd": ["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd", 27, 15, 15, ["🧑🏻‍❤️‍🧑🏽"]], "1f3fb-1f3fe": ["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe", 27, 16, 15, ["🧑🏻‍❤️‍🧑🏾"]], "1f3fb-1f3ff": ["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff", 27, 17, 15, ["🧑🏻‍❤️‍🧑🏿"]], "1f3fc-1f3fb": ["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb", 27, 18, 15, ["🧑🏼‍❤️‍🧑🏻"]], "1f3fc-1f3fd": ["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd", 27, 19, 15, ["🧑🏼‍❤️‍🧑🏽"]], "1f3fc-1f3fe": ["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe", 27, 20, 15, ["🧑🏼‍❤️‍🧑🏾"]], "1f3fc-1f3ff": ["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff", 27, 21, 15, ["🧑🏼‍❤️‍🧑🏿"]], "1f3fd-1f3fb": ["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb", 27, 22, 15, ["🧑🏽‍❤️‍🧑🏻"]], "1f3fd-1f3fc": ["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc", 27, 23, 15, ["🧑🏽‍❤️‍🧑🏼"]], "1f3fd-1f3fe": ["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe", 27, 24, 15, ["🧑🏽‍❤️‍🧑🏾"]], "1f3fd-1f3ff": ["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff", 27, 25, 15, ["🧑🏽‍❤️‍🧑🏿"]], "1f3fe-1f3fb": ["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb", 27, 26, 15, ["🧑🏾‍❤️‍🧑🏻"]], "1f3fe-1f3fc": ["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc", 27, 27, 15, ["🧑🏾‍❤️‍🧑🏼"]], "1f3fe-1f3fd": ["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd", 27, 28, 15, ["🧑🏾‍❤️‍🧑🏽"]], "1f3fe-1f3ff": ["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff", 27, 29, 15, ["🧑🏾‍❤️‍🧑🏿"]], "1f3ff-1f3fb": ["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb", 27, 30, 15, ["🧑🏿‍❤️‍🧑🏻"]], "1f3ff-1f3fc": ["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc", 27, 31, 15, ["🧑🏿‍❤️‍🧑🏼"]], "1f3ff-1f3fd": ["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd", 27, 32, 15, ["🧑🏿‍❤️‍🧑🏽"]], "1f3ff-1f3fe": ["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe", 27, 33, 15, ["🧑🏿‍❤️‍🧑🏾"]] },
      "1f4aa": { "1f3fb": ["1f4aa-1f3fb", 27, 59, 15, ["💪🏻"]], "1f3fc": ["1f4aa-1f3fc", 27, 60, 15, ["💪🏼"]], "1f3fd": ["1f4aa-1f3fd", 28, 0, 15, ["💪🏽"]], "1f3fe": ["1f4aa-1f3fe", 28, 1, 15, ["💪🏾"]], "1f3ff": ["1f4aa-1f3ff", 28, 2, 15, ["💪🏿"]] },
      "1f574-fe0f": { "1f3fb": ["1f574-1f3fb", 31, 0, 15, ["🕴🏻"]], "1f3fc": ["1f574-1f3fc", 31, 1, 15, ["🕴🏼"]], "1f3fd": ["1f574-1f3fd", 31, 2, 15, ["🕴🏽"]], "1f3fe": ["1f574-1f3fe", 31, 3, 15, ["🕴🏾"]], "1f3ff": ["1f574-1f3ff", 31, 4, 15, ["🕴🏿"]] },
      "1f575-fe0f-200d-2640-fe0f": { "1f3fb": ["1f575-1f3fb-200d-2640-fe0f", 31, 6, 15, ["🕵🏻‍♀️"]], "1f3fc": ["1f575-1f3fc-200d-2640-fe0f", 31, 7, 15, ["🕵🏼‍♀️"]], "1f3fd": ["1f575-1f3fd-200d-2640-fe0f", 31, 8, 15, ["🕵🏽‍♀️"]], "1f3fe": ["1f575-1f3fe-200d-2640-fe0f", 31, 9, 15, ["🕵🏾‍♀️"]], "1f3ff": ["1f575-1f3ff-200d-2640-fe0f", 31, 10, 15, ["🕵🏿‍♀️"]] },
      "1f575-fe0f-200d-2642-fe0f": { "1f3fb": ["1f575-1f3fb-200d-2642-fe0f", 31, 12, 15, ["🕵🏻‍♂️", "🕵🏻"]], "1f3fc": ["1f575-1f3fc-200d-2642-fe0f", 31, 13, 15, ["🕵🏼‍♂️", "🕵🏼"]], "1f3fd": ["1f575-1f3fd-200d-2642-fe0f", 31, 14, 15, ["🕵🏽‍♂️", "🕵🏽"]], "1f3fe": ["1f575-1f3fe-200d-2642-fe0f", 31, 15, 15, ["🕵🏾‍♂️", "🕵🏾"]], "1f3ff": ["1f575-1f3ff-200d-2642-fe0f", 31, 16, 15, ["🕵🏿‍♂️", "🕵🏿"]] },
      "1f57a": { "1f3fb": ["1f57a-1f3fb", 31, 28, 15, ["🕺🏻"]], "1f3fc": ["1f57a-1f3fc", 31, 29, 15, ["🕺🏼"]], "1f3fd": ["1f57a-1f3fd", 31, 30, 15, ["🕺🏽"]], "1f3fe": ["1f57a-1f3fe", 31, 31, 15, ["🕺🏾"]], "1f3ff": ["1f57a-1f3ff", 31, 32, 15, ["🕺🏿"]] },
      "1f590-fe0f": { "1f3fb": ["1f590-1f3fb", 31, 39, 15, ["🖐🏻"]], "1f3fc": ["1f590-1f3fc", 31, 40, 15, ["🖐🏼"]], "1f3fd": ["1f590-1f3fd", 31, 41, 15, ["🖐🏽"]], "1f3fe": ["1f590-1f3fe", 31, 42, 15, ["🖐🏾"]], "1f3ff": ["1f590-1f3ff", 31, 43, 15, ["🖐🏿"]] },
      "1f595": { "1f3fb": ["1f595-1f3fb", 31, 45, 15, ["🖕🏻"]], "1f3fc": ["1f595-1f3fc", 31, 46, 15, ["🖕🏼"]], "1f3fd": ["1f595-1f3fd", 31, 47, 15, ["🖕🏽"]], "1f3fe": ["1f595-1f3fe", 31, 48, 15, ["🖕🏾"]], "1f3ff": ["1f595-1f3ff", 31, 49, 15, ["🖕🏿"]] },
      "1f596": { "1f3fb": ["1f596-1f3fb", 31, 51, 15, ["🖖🏻"]], "1f3fc": ["1f596-1f3fc", 31, 52, 15, ["🖖🏼"]], "1f3fd": ["1f596-1f3fd", 31, 53, 15, ["🖖🏽"]], "1f3fe": ["1f596-1f3fe", 31, 54, 15, ["🖖🏾"]], "1f3ff": ["1f596-1f3ff", 31, 55, 15, ["🖖🏿"]] },
      "1f645-200d-2640-fe0f": { "1f3fb": ["1f645-1f3fb-200d-2640-fe0f", 33, 33, 15, ["🙅🏻‍♀️", "🙅🏻"]], "1f3fc": ["1f645-1f3fc-200d-2640-fe0f", 33, 34, 15, ["🙅🏼‍♀️", "🙅🏼"]], "1f3fd": ["1f645-1f3fd-200d-2640-fe0f", 33, 35, 15, ["🙅🏽‍♀️", "🙅🏽"]], "1f3fe": ["1f645-1f3fe-200d-2640-fe0f", 33, 36, 15, ["🙅🏾‍♀️", "🙅🏾"]], "1f3ff": ["1f645-1f3ff-200d-2640-fe0f", 33, 37, 15, ["🙅🏿‍♀️", "🙅🏿"]] },
      "1f645-200d-2642-fe0f": { "1f3fb": ["1f645-1f3fb-200d-2642-fe0f", 33, 39, 15, ["🙅🏻‍♂️"]], "1f3fc": ["1f645-1f3fc-200d-2642-fe0f", 33, 40, 15, ["🙅🏼‍♂️"]], "1f3fd": ["1f645-1f3fd-200d-2642-fe0f", 33, 41, 15, ["🙅🏽‍♂️"]], "1f3fe": ["1f645-1f3fe-200d-2642-fe0f", 33, 42, 15, ["🙅🏾‍♂️"]], "1f3ff": ["1f645-1f3ff-200d-2642-fe0f", 33, 43, 15, ["🙅🏿‍♂️"]] },
      "1f646-200d-2640-fe0f": { "1f3fb": ["1f646-1f3fb-200d-2640-fe0f", 33, 51, 15, ["🙆🏻‍♀️", "🙆🏻"]], "1f3fc": ["1f646-1f3fc-200d-2640-fe0f", 33, 52, 15, ["🙆🏼‍♀️", "🙆🏼"]], "1f3fd": ["1f646-1f3fd-200d-2640-fe0f", 33, 53, 15, ["🙆🏽‍♀️", "🙆🏽"]], "1f3fe": ["1f646-1f3fe-200d-2640-fe0f", 33, 54, 15, ["🙆🏾‍♀️", "🙆🏾"]], "1f3ff": ["1f646-1f3ff-200d-2640-fe0f", 33, 55, 15, ["🙆🏿‍♀️", "🙆🏿"]] },
      "1f646-200d-2642-fe0f": { "1f3fb": ["1f646-1f3fb-200d-2642-fe0f", 33, 57, 15, ["🙆🏻‍♂️"]], "1f3fc": ["1f646-1f3fc-200d-2642-fe0f", 33, 58, 15, ["🙆🏼‍♂️"]], "1f3fd": ["1f646-1f3fd-200d-2642-fe0f", 33, 59, 15, ["🙆🏽‍♂️"]], "1f3fe": ["1f646-1f3fe-200d-2642-fe0f", 33, 60, 15, ["🙆🏾‍♂️"]], "1f3ff": ["1f646-1f3ff-200d-2642-fe0f", 34, 0, 15, ["🙆🏿‍♂️"]] },
      "1f647-200d-2640-fe0f": { "1f3fb": ["1f647-1f3fb-200d-2640-fe0f", 34, 8, 15, ["🙇🏻‍♀️"]], "1f3fc": ["1f647-1f3fc-200d-2640-fe0f", 34, 9, 15, ["🙇🏼‍♀️"]], "1f3fd": ["1f647-1f3fd-200d-2640-fe0f", 34, 10, 15, ["🙇🏽‍♀️"]], "1f3fe": ["1f647-1f3fe-200d-2640-fe0f", 34, 11, 15, ["🙇🏾‍♀️"]], "1f3ff": ["1f647-1f3ff-200d-2640-fe0f", 34, 12, 15, ["🙇🏿‍♀️"]] },
      "1f647-200d-2642-fe0f": { "1f3fb": ["1f647-1f3fb-200d-2642-fe0f", 34, 14, 15, ["🙇🏻‍♂️"]], "1f3fc": ["1f647-1f3fc-200d-2642-fe0f", 34, 15, 15, ["🙇🏼‍♂️"]], "1f3fd": ["1f647-1f3fd-200d-2642-fe0f", 34, 16, 15, ["🙇🏽‍♂️"]], "1f3fe": ["1f647-1f3fe-200d-2642-fe0f", 34, 17, 15, ["🙇🏾‍♂️"]], "1f3ff": ["1f647-1f3ff-200d-2642-fe0f", 34, 18, 15, ["🙇🏿‍♂️"]] },
      "1f647": { "1f3fb": ["1f647-1f3fb", 34, 20, 15, ["🙇🏻"]], "1f3fc": ["1f647-1f3fc", 34, 21, 15, ["🙇🏼"]], "1f3fd": ["1f647-1f3fd", 34, 22, 15, ["🙇🏽"]], "1f3fe": ["1f647-1f3fe", 34, 23, 15, ["🙇🏾"]], "1f3ff": ["1f647-1f3ff", 34, 24, 15, ["🙇🏿"]] },
      "1f64b-200d-2640-fe0f": { "1f3fb": ["1f64b-1f3fb-200d-2640-fe0f", 34, 29, 15, ["🙋🏻‍♀️", "🙋🏻"]], "1f3fc": ["1f64b-1f3fc-200d-2640-fe0f", 34, 30, 15, ["🙋🏼‍♀️", "🙋🏼"]], "1f3fd": ["1f64b-1f3fd-200d-2640-fe0f", 34, 31, 15, ["🙋🏽‍♀️", "🙋🏽"]], "1f3fe": ["1f64b-1f3fe-200d-2640-fe0f", 34, 32, 15, ["🙋🏾‍♀️", "🙋🏾"]], "1f3ff": ["1f64b-1f3ff-200d-2640-fe0f", 34, 33, 15, ["🙋🏿‍♀️", "🙋🏿"]] },
      "1f64b-200d-2642-fe0f": { "1f3fb": ["1f64b-1f3fb-200d-2642-fe0f", 34, 35, 15, ["🙋🏻‍♂️"]], "1f3fc": ["1f64b-1f3fc-200d-2642-fe0f", 34, 36, 15, ["🙋🏼‍♂️"]], "1f3fd": ["1f64b-1f3fd-200d-2642-fe0f", 34, 37, 15, ["🙋🏽‍♂️"]], "1f3fe": ["1f64b-1f3fe-200d-2642-fe0f", 34, 38, 15, ["🙋🏾‍♂️"]], "1f3ff": ["1f64b-1f3ff-200d-2642-fe0f", 34, 39, 15, ["🙋🏿‍♂️"]] },
      "1f64c": { "1f3fb": ["1f64c-1f3fb", 34, 47, 15, ["🙌🏻"]], "1f3fc": ["1f64c-1f3fc", 34, 48, 15, ["🙌🏼"]], "1f3fd": ["1f64c-1f3fd", 34, 49, 15, ["🙌🏽"]], "1f3fe": ["1f64c-1f3fe", 34, 50, 15, ["🙌🏾"]], "1f3ff": ["1f64c-1f3ff", 34, 51, 15, ["🙌🏿"]] },
      "1f64d-200d-2640-fe0f": { "1f3fb": ["1f64d-1f3fb-200d-2640-fe0f", 34, 53, 15, ["🙍🏻‍♀️", "🙍🏻"]], "1f3fc": ["1f64d-1f3fc-200d-2640-fe0f", 34, 54, 15, ["🙍🏼‍♀️", "🙍🏼"]], "1f3fd": ["1f64d-1f3fd-200d-2640-fe0f", 34, 55, 15, ["🙍🏽‍♀️", "🙍🏽"]], "1f3fe": ["1f64d-1f3fe-200d-2640-fe0f", 34, 56, 15, ["🙍🏾‍♀️", "🙍🏾"]], "1f3ff": ["1f64d-1f3ff-200d-2640-fe0f", 34, 57, 15, ["🙍🏿‍♀️", "🙍🏿"]] },
      "1f64d-200d-2642-fe0f": { "1f3fb": ["1f64d-1f3fb-200d-2642-fe0f", 34, 59, 15, ["🙍🏻‍♂️"]], "1f3fc": ["1f64d-1f3fc-200d-2642-fe0f", 34, 60, 15, ["🙍🏼‍♂️"]], "1f3fd": ["1f64d-1f3fd-200d-2642-fe0f", 35, 0, 15, ["🙍🏽‍♂️"]], "1f3fe": ["1f64d-1f3fe-200d-2642-fe0f", 35, 1, 15, ["🙍🏾‍♂️"]], "1f3ff": ["1f64d-1f3ff-200d-2642-fe0f", 35, 2, 15, ["🙍🏿‍♂️"]] },
      "1f64e-200d-2640-fe0f": { "1f3fb": ["1f64e-1f3fb-200d-2640-fe0f", 35, 10, 15, ["🙎🏻‍♀️", "🙎🏻"]], "1f3fc": ["1f64e-1f3fc-200d-2640-fe0f", 35, 11, 15, ["🙎🏼‍♀️", "🙎🏼"]], "1f3fd": ["1f64e-1f3fd-200d-2640-fe0f", 35, 12, 15, ["🙎🏽‍♀️", "🙎🏽"]], "1f3fe": ["1f64e-1f3fe-200d-2640-fe0f", 35, 13, 15, ["🙎🏾‍♀️", "🙎🏾"]], "1f3ff": ["1f64e-1f3ff-200d-2640-fe0f", 35, 14, 15, ["🙎🏿‍♀️", "🙎🏿"]] },
      "1f64e-200d-2642-fe0f": { "1f3fb": ["1f64e-1f3fb-200d-2642-fe0f", 35, 16, 15, ["🙎🏻‍♂️"]], "1f3fc": ["1f64e-1f3fc-200d-2642-fe0f", 35, 17, 15, ["🙎🏼‍♂️"]], "1f3fd": ["1f64e-1f3fd-200d-2642-fe0f", 35, 18, 15, ["🙎🏽‍♂️"]], "1f3fe": ["1f64e-1f3fe-200d-2642-fe0f", 35, 19, 15, ["🙎🏾‍♂️"]], "1f3ff": ["1f64e-1f3ff-200d-2642-fe0f", 35, 20, 15, ["🙎🏿‍♂️"]] },
      "1f64f": { "1f3fb": ["1f64f-1f3fb", 35, 28, 15, ["🙏🏻"]], "1f3fc": ["1f64f-1f3fc", 35, 29, 15, ["🙏🏼"]], "1f3fd": ["1f64f-1f3fd", 35, 30, 15, ["🙏🏽"]], "1f3fe": ["1f64f-1f3fe", 35, 31, 15, ["🙏🏾"]], "1f3ff": ["1f64f-1f3ff", 35, 32, 15, ["🙏🏿"]] },
      "1f6a3-200d-2640-fe0f": { "1f3fb": ["1f6a3-1f3fb-200d-2640-fe0f", 36, 8, 15, ["🚣🏻‍♀️"]], "1f3fc": ["1f6a3-1f3fc-200d-2640-fe0f", 36, 9, 15, ["🚣🏼‍♀️"]], "1f3fd": ["1f6a3-1f3fd-200d-2640-fe0f", 36, 10, 15, ["🚣🏽‍♀️"]], "1f3fe": ["1f6a3-1f3fe-200d-2640-fe0f", 36, 11, 15, ["🚣🏾‍♀️"]], "1f3ff": ["1f6a3-1f3ff-200d-2640-fe0f", 36, 12, 15, ["🚣🏿‍♀️"]] },
      "1f6a3-200d-2642-fe0f": { "1f3fb": ["1f6a3-1f3fb-200d-2642-fe0f", 36, 14, 15, ["🚣🏻‍♂️", "🚣🏻"]], "1f3fc": ["1f6a3-1f3fc-200d-2642-fe0f", 36, 15, 15, ["🚣🏼‍♂️", "🚣🏼"]], "1f3fd": ["1f6a3-1f3fd-200d-2642-fe0f", 36, 16, 15, ["🚣🏽‍♂️", "🚣🏽"]], "1f3fe": ["1f6a3-1f3fe-200d-2642-fe0f", 36, 17, 15, ["🚣🏾‍♂️", "🚣🏾"]], "1f3ff": ["1f6a3-1f3ff-200d-2642-fe0f", 36, 18, 15, ["🚣🏿‍♂️", "🚣🏿"]] },
      "1f6b4-200d-2640-fe0f": { "1f3fb": ["1f6b4-1f3fb-200d-2640-fe0f", 36, 42, 15, ["🚴🏻‍♀️"]], "1f3fc": ["1f6b4-1f3fc-200d-2640-fe0f", 36, 43, 15, ["🚴🏼‍♀️"]], "1f3fd": ["1f6b4-1f3fd-200d-2640-fe0f", 36, 44, 15, ["🚴🏽‍♀️"]], "1f3fe": ["1f6b4-1f3fe-200d-2640-fe0f", 36, 45, 15, ["🚴🏾‍♀️"]], "1f3ff": ["1f6b4-1f3ff-200d-2640-fe0f", 36, 46, 15, ["🚴🏿‍♀️"]] },
      "1f6b4-200d-2642-fe0f": { "1f3fb": ["1f6b4-1f3fb-200d-2642-fe0f", 36, 48, 15, ["🚴🏻‍♂️", "🚴🏻"]], "1f3fc": ["1f6b4-1f3fc-200d-2642-fe0f", 36, 49, 15, ["🚴🏼‍♂️", "🚴🏼"]], "1f3fd": ["1f6b4-1f3fd-200d-2642-fe0f", 36, 50, 15, ["🚴🏽‍♂️", "🚴🏽"]], "1f3fe": ["1f6b4-1f3fe-200d-2642-fe0f", 36, 51, 15, ["🚴🏾‍♂️", "🚴🏾"]], "1f3ff": ["1f6b4-1f3ff-200d-2642-fe0f", 36, 52, 15, ["🚴🏿‍♂️", "🚴🏿"]] },
      "1f6b5-200d-2640-fe0f": { "1f3fb": ["1f6b5-1f3fb-200d-2640-fe0f", 36, 60, 15, ["🚵🏻‍♀️"]], "1f3fc": ["1f6b5-1f3fc-200d-2640-fe0f", 37, 0, 15, ["🚵🏼‍♀️"]], "1f3fd": ["1f6b5-1f3fd-200d-2640-fe0f", 37, 1, 15, ["🚵🏽‍♀️"]], "1f3fe": ["1f6b5-1f3fe-200d-2640-fe0f", 37, 2, 15, ["🚵🏾‍♀️"]], "1f3ff": ["1f6b5-1f3ff-200d-2640-fe0f", 37, 3, 15, ["🚵🏿‍♀️"]] },
      "1f6b5-200d-2642-fe0f": { "1f3fb": ["1f6b5-1f3fb-200d-2642-fe0f", 37, 5, 15, ["🚵🏻‍♂️", "🚵🏻"]], "1f3fc": ["1f6b5-1f3fc-200d-2642-fe0f", 37, 6, 15, ["🚵🏼‍♂️", "🚵🏼"]], "1f3fd": ["1f6b5-1f3fd-200d-2642-fe0f", 37, 7, 15, ["🚵🏽‍♂️", "🚵🏽"]], "1f3fe": ["1f6b5-1f3fe-200d-2642-fe0f", 37, 8, 15, ["🚵🏾‍♂️", "🚵🏾"]], "1f3ff": ["1f6b5-1f3ff-200d-2642-fe0f", 37, 9, 15, ["🚵🏿‍♂️", "🚵🏿"]] },
      "1f6b6-200d-2640-fe0f": { "1f3fb": ["1f6b6-1f3fb-200d-2640-fe0f", 37, 17, 15, ["🚶🏻‍♀️"]], "1f3fc": ["1f6b6-1f3fc-200d-2640-fe0f", 37, 18, 15, ["🚶🏼‍♀️"]], "1f3fd": ["1f6b6-1f3fd-200d-2640-fe0f", 37, 19, 15, ["🚶🏽‍♀️"]], "1f3fe": ["1f6b6-1f3fe-200d-2640-fe0f", 37, 20, 15, ["🚶🏾‍♀️"]], "1f3ff": ["1f6b6-1f3ff-200d-2640-fe0f", 37, 21, 15, ["🚶🏿‍♀️"]] },
      "1f6b6-200d-2642-fe0f": { "1f3fb": ["1f6b6-1f3fb-200d-2642-fe0f", 37, 23, 15, ["🚶🏻‍♂️", "🚶🏻"]], "1f3fc": ["1f6b6-1f3fc-200d-2642-fe0f", 37, 24, 15, ["🚶🏼‍♂️", "🚶🏼"]], "1f3fd": ["1f6b6-1f3fd-200d-2642-fe0f", 37, 25, 15, ["🚶🏽‍♂️", "🚶🏽"]], "1f3fe": ["1f6b6-1f3fe-200d-2642-fe0f", 37, 26, 15, ["🚶🏾‍♂️", "🚶🏾"]], "1f3ff": ["1f6b6-1f3ff-200d-2642-fe0f", 37, 27, 15, ["🚶🏿‍♂️", "🚶🏿"]] },
      "1f6c0": { "1f3fb": ["1f6c0-1f3fb", 37, 44, 15, ["🛀🏻"]], "1f3fc": ["1f6c0-1f3fc", 37, 45, 15, ["🛀🏼"]], "1f3fd": ["1f6c0-1f3fd", 37, 46, 15, ["🛀🏽"]], "1f3fe": ["1f6c0-1f3fe", 37, 47, 15, ["🛀🏾"]], "1f3ff": ["1f6c0-1f3ff", 37, 48, 15, ["🛀🏿"]] },
      "1f6cc": { "1f3fb": ["1f6cc-1f3fb", 37, 56, 15, ["🛌🏻"]], "1f3fc": ["1f6cc-1f3fc", 37, 57, 15, ["🛌🏼"]], "1f3fd": ["1f6cc-1f3fd", 37, 58, 15, ["🛌🏽"]], "1f3fe": ["1f6cc-1f3fe", 37, 59, 15, ["🛌🏾"]], "1f3ff": ["1f6cc-1f3ff", 37, 60, 15, ["🛌🏿"]] },
      "1f90c": { "1f3fb": ["1f90c-1f3fb", 38, 47, 15, ["🤌🏻"]], "1f3fc": ["1f90c-1f3fc", 38, 48, 15, ["🤌🏼"]], "1f3fd": ["1f90c-1f3fd", 38, 49, 15, ["🤌🏽"]], "1f3fe": ["1f90c-1f3fe", 38, 50, 15, ["🤌🏾"]], "1f3ff": ["1f90c-1f3ff", 38, 51, 15, ["🤌🏿"]] },
      "1f90f": { "1f3fb": ["1f90f-1f3fb", 38, 55, 15, ["🤏🏻"]], "1f3fc": ["1f90f-1f3fc", 38, 56, 15, ["🤏🏼"]], "1f3fd": ["1f90f-1f3fd", 38, 57, 15, ["🤏🏽"]], "1f3fe": ["1f90f-1f3fe", 38, 58, 15, ["🤏🏾"]], "1f3ff": ["1f90f-1f3ff", 38, 59, 15, ["🤏🏿"]] },
      "1f918": { "1f3fb": ["1f918-1f3fb", 39, 8, 15, ["🤘🏻"]], "1f3fc": ["1f918-1f3fc", 39, 9, 15, ["🤘🏼"]], "1f3fd": ["1f918-1f3fd", 39, 10, 15, ["🤘🏽"]], "1f3fe": ["1f918-1f3fe", 39, 11, 15, ["🤘🏾"]], "1f3ff": ["1f918-1f3ff", 39, 12, 15, ["🤘🏿"]] },
      "1f919": { "1f3fb": ["1f919-1f3fb", 39, 14, 15, ["🤙🏻"]], "1f3fc": ["1f919-1f3fc", 39, 15, 15, ["🤙🏼"]], "1f3fd": ["1f919-1f3fd", 39, 16, 15, ["🤙🏽"]], "1f3fe": ["1f919-1f3fe", 39, 17, 15, ["🤙🏾"]], "1f3ff": ["1f919-1f3ff", 39, 18, 15, ["🤙🏿"]] },
      "1f91a": { "1f3fb": ["1f91a-1f3fb", 39, 20, 15, ["🤚🏻"]], "1f3fc": ["1f91a-1f3fc", 39, 21, 15, ["🤚🏼"]], "1f3fd": ["1f91a-1f3fd", 39, 22, 15, ["🤚🏽"]], "1f3fe": ["1f91a-1f3fe", 39, 23, 15, ["🤚🏾"]], "1f3ff": ["1f91a-1f3ff", 39, 24, 15, ["🤚🏿"]] },
      "1f91b": { "1f3fb": ["1f91b-1f3fb", 39, 26, 15, ["🤛🏻"]], "1f3fc": ["1f91b-1f3fc", 39, 27, 15, ["🤛🏼"]], "1f3fd": ["1f91b-1f3fd", 39, 28, 15, ["🤛🏽"]], "1f3fe": ["1f91b-1f3fe", 39, 29, 15, ["🤛🏾"]], "1f3ff": ["1f91b-1f3ff", 39, 30, 15, ["🤛🏿"]] },
      "1f91c": { "1f3fb": ["1f91c-1f3fb", 39, 32, 15, ["🤜🏻"]], "1f3fc": ["1f91c-1f3fc", 39, 33, 15, ["🤜🏼"]], "1f3fd": ["1f91c-1f3fd", 39, 34, 15, ["🤜🏽"]], "1f3fe": ["1f91c-1f3fe", 39, 35, 15, ["🤜🏾"]], "1f3ff": ["1f91c-1f3ff", 39, 36, 15, ["🤜🏿"]] },
      "1f91d": { "1f3fb": ["1f91d-1f3fb", 39, 38, 15, ["🤝🏻"]], "1f3fc": ["1f91d-1f3fc", 39, 39, 15, ["🤝🏼"]], "1f3fd": ["1f91d-1f3fd", 39, 40, 15, ["🤝🏽"]], "1f3fe": ["1f91d-1f3fe", 39, 41, 15, ["🤝🏾"]], "1f3ff": ["1f91d-1f3ff", 39, 42, 15, ["🤝🏿"]], "1f3fb-1f3fc": ["1faf1-1f3fb-200d-1faf2-1f3fc", 39, 43, 15, ["🫱🏻‍🫲🏼"]], "1f3fb-1f3fd": ["1faf1-1f3fb-200d-1faf2-1f3fd", 39, 44, 15, ["🫱🏻‍🫲🏽"]], "1f3fb-1f3fe": ["1faf1-1f3fb-200d-1faf2-1f3fe", 39, 45, 15, ["🫱🏻‍🫲🏾"]], "1f3fb-1f3ff": ["1faf1-1f3fb-200d-1faf2-1f3ff", 39, 46, 15, ["🫱🏻‍🫲🏿"]], "1f3fc-1f3fb": ["1faf1-1f3fc-200d-1faf2-1f3fb", 39, 47, 15, ["🫱🏼‍🫲🏻"]], "1f3fc-1f3fd": ["1faf1-1f3fc-200d-1faf2-1f3fd", 39, 48, 15, ["🫱🏼‍🫲🏽"]], "1f3fc-1f3fe": ["1faf1-1f3fc-200d-1faf2-1f3fe", 39, 49, 15, ["🫱🏼‍🫲🏾"]], "1f3fc-1f3ff": ["1faf1-1f3fc-200d-1faf2-1f3ff", 39, 50, 15, ["🫱🏼‍🫲🏿"]], "1f3fd-1f3fb": ["1faf1-1f3fd-200d-1faf2-1f3fb", 39, 51, 15, ["🫱🏽‍🫲🏻"]], "1f3fd-1f3fc": ["1faf1-1f3fd-200d-1faf2-1f3fc", 39, 52, 15, ["🫱🏽‍🫲🏼"]], "1f3fd-1f3fe": ["1faf1-1f3fd-200d-1faf2-1f3fe", 39, 53, 15, ["🫱🏽‍🫲🏾"]], "1f3fd-1f3ff": ["1faf1-1f3fd-200d-1faf2-1f3ff", 39, 54, 15, ["🫱🏽‍🫲🏿"]], "1f3fe-1f3fb": ["1faf1-1f3fe-200d-1faf2-1f3fb", 39, 55, 15, ["🫱🏾‍🫲🏻"]], "1f3fe-1f3fc": ["1faf1-1f3fe-200d-1faf2-1f3fc", 39, 56, 15, ["🫱🏾‍🫲🏼"]], "1f3fe-1f3fd": ["1faf1-1f3fe-200d-1faf2-1f3fd", 39, 57, 15, ["🫱🏾‍🫲🏽"]], "1f3fe-1f3ff": ["1faf1-1f3fe-200d-1faf2-1f3ff", 39, 58, 15, ["🫱🏾‍🫲🏿"]], "1f3ff-1f3fb": ["1faf1-1f3ff-200d-1faf2-1f3fb", 39, 59, 15, ["🫱🏿‍🫲🏻"]], "1f3ff-1f3fc": ["1faf1-1f3ff-200d-1faf2-1f3fc", 39, 60, 15, ["🫱🏿‍🫲🏼"]], "1f3ff-1f3fd": ["1faf1-1f3ff-200d-1faf2-1f3fd", 40, 0, 15, ["🫱🏿‍🫲🏽"]], "1f3ff-1f3fe": ["1faf1-1f3ff-200d-1faf2-1f3fe", 40, 1, 15, ["🫱🏿‍🫲🏾"]] },
      "1f91e": { "1f3fb": ["1f91e-1f3fb", 40, 3, 15, ["🤞🏻"]], "1f3fc": ["1f91e-1f3fc", 40, 4, 15, ["🤞🏼"]], "1f3fd": ["1f91e-1f3fd", 40, 5, 15, ["🤞🏽"]], "1f3fe": ["1f91e-1f3fe", 40, 6, 15, ["🤞🏾"]], "1f3ff": ["1f91e-1f3ff", 40, 7, 15, ["🤞🏿"]] },
      "1f91f": { "1f3fb": ["1f91f-1f3fb", 40, 9, 15, ["🤟🏻"]], "1f3fc": ["1f91f-1f3fc", 40, 10, 15, ["🤟🏼"]], "1f3fd": ["1f91f-1f3fd", 40, 11, 15, ["🤟🏽"]], "1f3fe": ["1f91f-1f3fe", 40, 12, 15, ["🤟🏾"]], "1f3ff": ["1f91f-1f3ff", 40, 13, 15, ["🤟🏿"]] },
      "1f926-200d-2640-fe0f": { "1f3fb": ["1f926-1f3fb-200d-2640-fe0f", 40, 21, 15, ["🤦🏻‍♀️"]], "1f3fc": ["1f926-1f3fc-200d-2640-fe0f", 40, 22, 15, ["🤦🏼‍♀️"]], "1f3fd": ["1f926-1f3fd-200d-2640-fe0f", 40, 23, 15, ["🤦🏽‍♀️"]], "1f3fe": ["1f926-1f3fe-200d-2640-fe0f", 40, 24, 15, ["🤦🏾‍♀️"]], "1f3ff": ["1f926-1f3ff-200d-2640-fe0f", 40, 25, 15, ["🤦🏿‍♀️"]] },
      "1f926-200d-2642-fe0f": { "1f3fb": ["1f926-1f3fb-200d-2642-fe0f", 40, 27, 15, ["🤦🏻‍♂️"]], "1f3fc": ["1f926-1f3fc-200d-2642-fe0f", 40, 28, 15, ["🤦🏼‍♂️"]], "1f3fd": ["1f926-1f3fd-200d-2642-fe0f", 40, 29, 15, ["🤦🏽‍♂️"]], "1f3fe": ["1f926-1f3fe-200d-2642-fe0f", 40, 30, 15, ["🤦🏾‍♂️"]], "1f3ff": ["1f926-1f3ff-200d-2642-fe0f", 40, 31, 15, ["🤦🏿‍♂️"]] },
      "1f926": { "1f3fb": ["1f926-1f3fb", 40, 33, 15, ["🤦🏻"]], "1f3fc": ["1f926-1f3fc", 40, 34, 15, ["🤦🏼"]], "1f3fd": ["1f926-1f3fd", 40, 35, 15, ["🤦🏽"]], "1f3fe": ["1f926-1f3fe", 40, 36, 15, ["🤦🏾"]], "1f3ff": ["1f926-1f3ff", 40, 37, 15, ["🤦🏿"]] },
      "1f930": { "1f3fb": ["1f930-1f3fb", 40, 48, 15, ["🤰🏻"]], "1f3fc": ["1f930-1f3fc", 40, 49, 15, ["🤰🏼"]], "1f3fd": ["1f930-1f3fd", 40, 50, 15, ["🤰🏽"]], "1f3fe": ["1f930-1f3fe", 40, 51, 15, ["🤰🏾"]], "1f3ff": ["1f930-1f3ff", 40, 52, 15, ["🤰🏿"]] },
      "1f931": { "1f3fb": ["1f931-1f3fb", 40, 54, 15, ["🤱🏻"]], "1f3fc": ["1f931-1f3fc", 40, 55, 15, ["🤱🏼"]], "1f3fd": ["1f931-1f3fd", 40, 56, 15, ["🤱🏽"]], "1f3fe": ["1f931-1f3fe", 40, 57, 15, ["🤱🏾"]], "1f3ff": ["1f931-1f3ff", 40, 58, 15, ["🤱🏿"]] },
      "1f932": { "1f3fb": ["1f932-1f3fb", 40, 60, 15, ["🤲🏻"]], "1f3fc": ["1f932-1f3fc", 41, 0, 15, ["🤲🏼"]], "1f3fd": ["1f932-1f3fd", 41, 1, 15, ["🤲🏽"]], "1f3fe": ["1f932-1f3fe", 41, 2, 15, ["🤲🏾"]], "1f3ff": ["1f932-1f3ff", 41, 3, 15, ["🤲🏿"]] },
      "1f933": { "1f3fb": ["1f933-1f3fb", 41, 5, 15, ["🤳🏻"]], "1f3fc": ["1f933-1f3fc", 41, 6, 15, ["🤳🏼"]], "1f3fd": ["1f933-1f3fd", 41, 7, 15, ["🤳🏽"]], "1f3fe": ["1f933-1f3fe", 41, 8, 15, ["🤳🏾"]], "1f3ff": ["1f933-1f3ff", 41, 9, 15, ["🤳🏿"]] },
      "1f934": { "1f3fb": ["1f934-1f3fb", 41, 11, 15, ["🤴🏻"]], "1f3fc": ["1f934-1f3fc", 41, 12, 15, ["🤴🏼"]], "1f3fd": ["1f934-1f3fd", 41, 13, 15, ["🤴🏽"]], "1f3fe": ["1f934-1f3fe", 41, 14, 15, ["🤴🏾"]], "1f3ff": ["1f934-1f3ff", 41, 15, 15, ["🤴🏿"]] },
      "1f935-200d-2640-fe0f": { "1f3fb": ["1f935-1f3fb-200d-2640-fe0f", 41, 17, 15, ["🤵🏻‍♀️"]], "1f3fc": ["1f935-1f3fc-200d-2640-fe0f", 41, 18, 15, ["🤵🏼‍♀️"]], "1f3fd": ["1f935-1f3fd-200d-2640-fe0f", 41, 19, 15, ["🤵🏽‍♀️"]], "1f3fe": ["1f935-1f3fe-200d-2640-fe0f", 41, 20, 15, ["🤵🏾‍♀️"]], "1f3ff": ["1f935-1f3ff-200d-2640-fe0f", 41, 21, 15, ["🤵🏿‍♀️"]] },
      "1f935-200d-2642-fe0f": { "1f3fb": ["1f935-1f3fb-200d-2642-fe0f", 41, 23, 15, ["🤵🏻‍♂️"]], "1f3fc": ["1f935-1f3fc-200d-2642-fe0f", 41, 24, 15, ["🤵🏼‍♂️"]], "1f3fd": ["1f935-1f3fd-200d-2642-fe0f", 41, 25, 15, ["🤵🏽‍♂️"]], "1f3fe": ["1f935-1f3fe-200d-2642-fe0f", 41, 26, 15, ["🤵🏾‍♂️"]], "1f3ff": ["1f935-1f3ff-200d-2642-fe0f", 41, 27, 15, ["🤵🏿‍♂️"]] },
      "1f935": { "1f3fb": ["1f935-1f3fb", 41, 29, 15, ["🤵🏻"]], "1f3fc": ["1f935-1f3fc", 41, 30, 15, ["🤵🏼"]], "1f3fd": ["1f935-1f3fd", 41, 31, 15, ["🤵🏽"]], "1f3fe": ["1f935-1f3fe", 41, 32, 15, ["🤵🏾"]], "1f3ff": ["1f935-1f3ff", 41, 33, 15, ["🤵🏿"]] },
      "1f936": { "1f3fb": ["1f936-1f3fb", 41, 35, 15, ["🤶🏻"]], "1f3fc": ["1f936-1f3fc", 41, 36, 15, ["🤶🏼"]], "1f3fd": ["1f936-1f3fd", 41, 37, 15, ["🤶🏽"]], "1f3fe": ["1f936-1f3fe", 41, 38, 15, ["🤶🏾"]], "1f3ff": ["1f936-1f3ff", 41, 39, 15, ["🤶🏿"]] },
      "1f937-200d-2640-fe0f": { "1f3fb": ["1f937-1f3fb-200d-2640-fe0f", 41, 41, 15, ["🤷🏻‍♀️"]], "1f3fc": ["1f937-1f3fc-200d-2640-fe0f", 41, 42, 15, ["🤷🏼‍♀️"]], "1f3fd": ["1f937-1f3fd-200d-2640-fe0f", 41, 43, 15, ["🤷🏽‍♀️"]], "1f3fe": ["1f937-1f3fe-200d-2640-fe0f", 41, 44, 15, ["🤷🏾‍♀️"]], "1f3ff": ["1f937-1f3ff-200d-2640-fe0f", 41, 45, 15, ["🤷🏿‍♀️"]] },
      "1f937-200d-2642-fe0f": { "1f3fb": ["1f937-1f3fb-200d-2642-fe0f", 41, 47, 15, ["🤷🏻‍♂️"]], "1f3fc": ["1f937-1f3fc-200d-2642-fe0f", 41, 48, 15, ["🤷🏼‍♂️"]], "1f3fd": ["1f937-1f3fd-200d-2642-fe0f", 41, 49, 15, ["🤷🏽‍♂️"]], "1f3fe": ["1f937-1f3fe-200d-2642-fe0f", 41, 50, 15, ["🤷🏾‍♂️"]], "1f3ff": ["1f937-1f3ff-200d-2642-fe0f", 41, 51, 15, ["🤷🏿‍♂️"]] },
      "1f937": { "1f3fb": ["1f937-1f3fb", 41, 53, 15, ["🤷🏻"]], "1f3fc": ["1f937-1f3fc", 41, 54, 15, ["🤷🏼"]], "1f3fd": ["1f937-1f3fd", 41, 55, 15, ["🤷🏽"]], "1f3fe": ["1f937-1f3fe", 41, 56, 15, ["🤷🏾"]], "1f3ff": ["1f937-1f3ff", 41, 57, 15, ["🤷🏿"]] },
      "1f938-200d-2640-fe0f": { "1f3fb": ["1f938-1f3fb-200d-2640-fe0f", 41, 59, 15, ["🤸🏻‍♀️"]], "1f3fc": ["1f938-1f3fc-200d-2640-fe0f", 41, 60, 15, ["🤸🏼‍♀️"]], "1f3fd": ["1f938-1f3fd-200d-2640-fe0f", 42, 0, 15, ["🤸🏽‍♀️"]], "1f3fe": ["1f938-1f3fe-200d-2640-fe0f", 42, 1, 15, ["🤸🏾‍♀️"]], "1f3ff": ["1f938-1f3ff-200d-2640-fe0f", 42, 2, 15, ["🤸🏿‍♀️"]] },
      "1f938-200d-2642-fe0f": { "1f3fb": ["1f938-1f3fb-200d-2642-fe0f", 42, 4, 15, ["🤸🏻‍♂️"]], "1f3fc": ["1f938-1f3fc-200d-2642-fe0f", 42, 5, 15, ["🤸🏼‍♂️"]], "1f3fd": ["1f938-1f3fd-200d-2642-fe0f", 42, 6, 15, ["🤸🏽‍♂️"]], "1f3fe": ["1f938-1f3fe-200d-2642-fe0f", 42, 7, 15, ["🤸🏾‍♂️"]], "1f3ff": ["1f938-1f3ff-200d-2642-fe0f", 42, 8, 15, ["🤸🏿‍♂️"]] },
      "1f938": { "1f3fb": ["1f938-1f3fb", 42, 10, 15, ["🤸🏻"]], "1f3fc": ["1f938-1f3fc", 42, 11, 15, ["🤸🏼"]], "1f3fd": ["1f938-1f3fd", 42, 12, 15, ["🤸🏽"]], "1f3fe": ["1f938-1f3fe", 42, 13, 15, ["🤸🏾"]], "1f3ff": ["1f938-1f3ff", 42, 14, 15, ["🤸🏿"]] },
      "1f939-200d-2640-fe0f": { "1f3fb": ["1f939-1f3fb-200d-2640-fe0f", 42, 16, 15, ["🤹🏻‍♀️"]], "1f3fc": ["1f939-1f3fc-200d-2640-fe0f", 42, 17, 15, ["🤹🏼‍♀️"]], "1f3fd": ["1f939-1f3fd-200d-2640-fe0f", 42, 18, 15, ["🤹🏽‍♀️"]], "1f3fe": ["1f939-1f3fe-200d-2640-fe0f", 42, 19, 15, ["🤹🏾‍♀️"]], "1f3ff": ["1f939-1f3ff-200d-2640-fe0f", 42, 20, 15, ["🤹🏿‍♀️"]] },
      "1f939-200d-2642-fe0f": { "1f3fb": ["1f939-1f3fb-200d-2642-fe0f", 42, 22, 15, ["🤹🏻‍♂️"]], "1f3fc": ["1f939-1f3fc-200d-2642-fe0f", 42, 23, 15, ["🤹🏼‍♂️"]], "1f3fd": ["1f939-1f3fd-200d-2642-fe0f", 42, 24, 15, ["🤹🏽‍♂️"]], "1f3fe": ["1f939-1f3fe-200d-2642-fe0f", 42, 25, 15, ["🤹🏾‍♂️"]], "1f3ff": ["1f939-1f3ff-200d-2642-fe0f", 42, 26, 15, ["🤹🏿‍♂️"]] },
      "1f939": { "1f3fb": ["1f939-1f3fb", 42, 28, 15, ["🤹🏻"]], "1f3fc": ["1f939-1f3fc", 42, 29, 15, ["🤹🏼"]], "1f3fd": ["1f939-1f3fd", 42, 30, 15, ["🤹🏽"]], "1f3fe": ["1f939-1f3fe", 42, 31, 15, ["🤹🏾"]], "1f3ff": ["1f939-1f3ff", 42, 32, 15, ["🤹🏿"]] },
      "1f93d-200d-2640-fe0f": { "1f3fb": ["1f93d-1f3fb-200d-2640-fe0f", 42, 38, 15, ["🤽🏻‍♀️"]], "1f3fc": ["1f93d-1f3fc-200d-2640-fe0f", 42, 39, 15, ["🤽🏼‍♀️"]], "1f3fd": ["1f93d-1f3fd-200d-2640-fe0f", 42, 40, 15, ["🤽🏽‍♀️"]], "1f3fe": ["1f93d-1f3fe-200d-2640-fe0f", 42, 41, 15, ["🤽🏾‍♀️"]], "1f3ff": ["1f93d-1f3ff-200d-2640-fe0f", 42, 42, 15, ["🤽🏿‍♀️"]] },
      "1f93d-200d-2642-fe0f": { "1f3fb": ["1f93d-1f3fb-200d-2642-fe0f", 42, 44, 15, ["🤽🏻‍♂️"]], "1f3fc": ["1f93d-1f3fc-200d-2642-fe0f", 42, 45, 15, ["🤽🏼‍♂️"]], "1f3fd": ["1f93d-1f3fd-200d-2642-fe0f", 42, 46, 15, ["🤽🏽‍♂️"]], "1f3fe": ["1f93d-1f3fe-200d-2642-fe0f", 42, 47, 15, ["🤽🏾‍♂️"]], "1f3ff": ["1f93d-1f3ff-200d-2642-fe0f", 42, 48, 15, ["🤽🏿‍♂️"]] },
      "1f93d": { "1f3fb": ["1f93d-1f3fb", 42, 50, 15, ["🤽🏻"]], "1f3fc": ["1f93d-1f3fc", 42, 51, 15, ["🤽🏼"]], "1f3fd": ["1f93d-1f3fd", 42, 52, 15, ["🤽🏽"]], "1f3fe": ["1f93d-1f3fe", 42, 53, 15, ["🤽🏾"]], "1f3ff": ["1f93d-1f3ff", 42, 54, 15, ["🤽🏿"]] },
      "1f93e-200d-2640-fe0f": { "1f3fb": ["1f93e-1f3fb-200d-2640-fe0f", 42, 56, 15, ["🤾🏻‍♀️"]], "1f3fc": ["1f93e-1f3fc-200d-2640-fe0f", 42, 57, 15, ["🤾🏼‍♀️"]], "1f3fd": ["1f93e-1f3fd-200d-2640-fe0f", 42, 58, 15, ["🤾🏽‍♀️"]], "1f3fe": ["1f93e-1f3fe-200d-2640-fe0f", 42, 59, 15, ["🤾🏾‍♀️"]], "1f3ff": ["1f93e-1f3ff-200d-2640-fe0f", 42, 60, 15, ["🤾🏿‍♀️"]] },
      "1f93e-200d-2642-fe0f": { "1f3fb": ["1f93e-1f3fb-200d-2642-fe0f", 43, 1, 15, ["🤾🏻‍♂️"]], "1f3fc": ["1f93e-1f3fc-200d-2642-fe0f", 43, 2, 15, ["🤾🏼‍♂️"]], "1f3fd": ["1f93e-1f3fd-200d-2642-fe0f", 43, 3, 15, ["🤾🏽‍♂️"]], "1f3fe": ["1f93e-1f3fe-200d-2642-fe0f", 43, 4, 15, ["🤾🏾‍♂️"]], "1f3ff": ["1f93e-1f3ff-200d-2642-fe0f", 43, 5, 15, ["🤾🏿‍♂️"]] },
      "1f93e": { "1f3fb": ["1f93e-1f3fb", 43, 7, 15, ["🤾🏻"]], "1f3fc": ["1f93e-1f3fc", 43, 8, 15, ["🤾🏼"]], "1f3fd": ["1f93e-1f3fd", 43, 9, 15, ["🤾🏽"]], "1f3fe": ["1f93e-1f3fe", 43, 10, 15, ["🤾🏾"]], "1f3ff": ["1f93e-1f3ff", 43, 11, 15, ["🤾🏿"]] },
      "1f977": { "1f3fb": ["1f977-1f3fb", 44, 7, 15, ["🥷🏻"]], "1f3fc": ["1f977-1f3fc", 44, 8, 15, ["🥷🏼"]], "1f3fd": ["1f977-1f3fd", 44, 9, 15, ["🥷🏽"]], "1f3fe": ["1f977-1f3fe", 44, 10, 15, ["🥷🏾"]], "1f3ff": ["1f977-1f3ff", 44, 11, 15, ["🥷🏿"]] },
      "1f9b5": { "1f3fb": ["1f9b5-1f3fb", 45, 9, 15, ["🦵🏻"]], "1f3fc": ["1f9b5-1f3fc", 45, 10, 15, ["🦵🏼"]], "1f3fd": ["1f9b5-1f3fd", 45, 11, 15, ["🦵🏽"]], "1f3fe": ["1f9b5-1f3fe", 45, 12, 15, ["🦵🏾"]], "1f3ff": ["1f9b5-1f3ff", 45, 13, 15, ["🦵🏿"]] },
      "1f9b6": { "1f3fb": ["1f9b6-1f3fb", 45, 15, 15, ["🦶🏻"]], "1f3fc": ["1f9b6-1f3fc", 45, 16, 15, ["🦶🏼"]], "1f3fd": ["1f9b6-1f3fd", 45, 17, 15, ["🦶🏽"]], "1f3fe": ["1f9b6-1f3fe", 45, 18, 15, ["🦶🏾"]], "1f3ff": ["1f9b6-1f3ff", 45, 19, 15, ["🦶🏿"]] },
      "1f9b8-200d-2640-fe0f": { "1f3fb": ["1f9b8-1f3fb-200d-2640-fe0f", 45, 22, 15, ["🦸🏻‍♀️"]], "1f3fc": ["1f9b8-1f3fc-200d-2640-fe0f", 45, 23, 15, ["🦸🏼‍♀️"]], "1f3fd": ["1f9b8-1f3fd-200d-2640-fe0f", 45, 24, 15, ["🦸🏽‍♀️"]], "1f3fe": ["1f9b8-1f3fe-200d-2640-fe0f", 45, 25, 15, ["🦸🏾‍♀️"]], "1f3ff": ["1f9b8-1f3ff-200d-2640-fe0f", 45, 26, 15, ["🦸🏿‍♀️"]] },
      "1f9b8-200d-2642-fe0f": { "1f3fb": ["1f9b8-1f3fb-200d-2642-fe0f", 45, 28, 15, ["🦸🏻‍♂️"]], "1f3fc": ["1f9b8-1f3fc-200d-2642-fe0f", 45, 29, 15, ["🦸🏼‍♂️"]], "1f3fd": ["1f9b8-1f3fd-200d-2642-fe0f", 45, 30, 15, ["🦸🏽‍♂️"]], "1f3fe": ["1f9b8-1f3fe-200d-2642-fe0f", 45, 31, 15, ["🦸🏾‍♂️"]], "1f3ff": ["1f9b8-1f3ff-200d-2642-fe0f", 45, 32, 15, ["🦸🏿‍♂️"]] },
      "1f9b8": { "1f3fb": ["1f9b8-1f3fb", 45, 34, 15, ["🦸🏻"]], "1f3fc": ["1f9b8-1f3fc", 45, 35, 15, ["🦸🏼"]], "1f3fd": ["1f9b8-1f3fd", 45, 36, 15, ["🦸🏽"]], "1f3fe": ["1f9b8-1f3fe", 45, 37, 15, ["🦸🏾"]], "1f3ff": ["1f9b8-1f3ff", 45, 38, 15, ["🦸🏿"]] },
      "1f9b9-200d-2640-fe0f": { "1f3fb": ["1f9b9-1f3fb-200d-2640-fe0f", 45, 40, 15, ["🦹🏻‍♀️"]], "1f3fc": ["1f9b9-1f3fc-200d-2640-fe0f", 45, 41, 15, ["🦹🏼‍♀️"]], "1f3fd": ["1f9b9-1f3fd-200d-2640-fe0f", 45, 42, 15, ["🦹🏽‍♀️"]], "1f3fe": ["1f9b9-1f3fe-200d-2640-fe0f", 45, 43, 15, ["🦹🏾‍♀️"]], "1f3ff": ["1f9b9-1f3ff-200d-2640-fe0f", 45, 44, 15, ["🦹🏿‍♀️"]] },
      "1f9b9-200d-2642-fe0f": { "1f3fb": ["1f9b9-1f3fb-200d-2642-fe0f", 45, 46, 15, ["🦹🏻‍♂️"]], "1f3fc": ["1f9b9-1f3fc-200d-2642-fe0f", 45, 47, 15, ["🦹🏼‍♂️"]], "1f3fd": ["1f9b9-1f3fd-200d-2642-fe0f", 45, 48, 15, ["🦹🏽‍♂️"]], "1f3fe": ["1f9b9-1f3fe-200d-2642-fe0f", 45, 49, 15, ["🦹🏾‍♂️"]], "1f3ff": ["1f9b9-1f3ff-200d-2642-fe0f", 45, 50, 15, ["🦹🏿‍♂️"]] },
      "1f9b9": { "1f3fb": ["1f9b9-1f3fb", 45, 52, 15, ["🦹🏻"]], "1f3fc": ["1f9b9-1f3fc", 45, 53, 15, ["🦹🏼"]], "1f3fd": ["1f9b9-1f3fd", 45, 54, 15, ["🦹🏽"]], "1f3fe": ["1f9b9-1f3fe", 45, 55, 15, ["🦹🏾"]], "1f3ff": ["1f9b9-1f3ff", 45, 56, 15, ["🦹🏿"]] },
      "1f9bb": { "1f3fb": ["1f9bb-1f3fb", 45, 59, 15, ["🦻🏻"]], "1f3fc": ["1f9bb-1f3fc", 45, 60, 15, ["🦻🏼"]], "1f3fd": ["1f9bb-1f3fd", 46, 0, 15, ["🦻🏽"]], "1f3fe": ["1f9bb-1f3fe", 46, 1, 15, ["🦻🏾"]], "1f3ff": ["1f9bb-1f3ff", 46, 2, 15, ["🦻🏿"]] },
      "1f9cd-200d-2640-fe0f": { "1f3fb": ["1f9cd-1f3fb-200d-2640-fe0f", 46, 21, 15, ["🧍🏻‍♀️"]], "1f3fc": ["1f9cd-1f3fc-200d-2640-fe0f", 46, 22, 15, ["🧍🏼‍♀️"]], "1f3fd": ["1f9cd-1f3fd-200d-2640-fe0f", 46, 23, 15, ["🧍🏽‍♀️"]], "1f3fe": ["1f9cd-1f3fe-200d-2640-fe0f", 46, 24, 15, ["🧍🏾‍♀️"]], "1f3ff": ["1f9cd-1f3ff-200d-2640-fe0f", 46, 25, 15, ["🧍🏿‍♀️"]] },
      "1f9cd-200d-2642-fe0f": { "1f3fb": ["1f9cd-1f3fb-200d-2642-fe0f", 46, 27, 15, ["🧍🏻‍♂️"]], "1f3fc": ["1f9cd-1f3fc-200d-2642-fe0f", 46, 28, 15, ["🧍🏼‍♂️"]], "1f3fd": ["1f9cd-1f3fd-200d-2642-fe0f", 46, 29, 15, ["🧍🏽‍♂️"]], "1f3fe": ["1f9cd-1f3fe-200d-2642-fe0f", 46, 30, 15, ["🧍🏾‍♂️"]], "1f3ff": ["1f9cd-1f3ff-200d-2642-fe0f", 46, 31, 15, ["🧍🏿‍♂️"]] },
      "1f9cd": { "1f3fb": ["1f9cd-1f3fb", 46, 33, 15, ["🧍🏻"]], "1f3fc": ["1f9cd-1f3fc", 46, 34, 15, ["🧍🏼"]], "1f3fd": ["1f9cd-1f3fd", 46, 35, 15, ["🧍🏽"]], "1f3fe": ["1f9cd-1f3fe", 46, 36, 15, ["🧍🏾"]], "1f3ff": ["1f9cd-1f3ff", 46, 37, 15, ["🧍🏿"]] },
      "1f9ce-200d-2640-fe0f": { "1f3fb": ["1f9ce-1f3fb-200d-2640-fe0f", 46, 39, 15, ["🧎🏻‍♀️"]], "1f3fc": ["1f9ce-1f3fc-200d-2640-fe0f", 46, 40, 15, ["🧎🏼‍♀️"]], "1f3fd": ["1f9ce-1f3fd-200d-2640-fe0f", 46, 41, 15, ["🧎🏽‍♀️"]], "1f3fe": ["1f9ce-1f3fe-200d-2640-fe0f", 46, 42, 15, ["🧎🏾‍♀️"]], "1f3ff": ["1f9ce-1f3ff-200d-2640-fe0f", 46, 43, 15, ["🧎🏿‍♀️"]] },
      "1f9ce-200d-2642-fe0f": { "1f3fb": ["1f9ce-1f3fb-200d-2642-fe0f", 46, 45, 15, ["🧎🏻‍♂️"]], "1f3fc": ["1f9ce-1f3fc-200d-2642-fe0f", 46, 46, 15, ["🧎🏼‍♂️"]], "1f3fd": ["1f9ce-1f3fd-200d-2642-fe0f", 46, 47, 15, ["🧎🏽‍♂️"]], "1f3fe": ["1f9ce-1f3fe-200d-2642-fe0f", 46, 48, 15, ["🧎🏾‍♂️"]], "1f3ff": ["1f9ce-1f3ff-200d-2642-fe0f", 46, 49, 15, ["🧎🏿‍♂️"]] },
      "1f9ce": { "1f3fb": ["1f9ce-1f3fb", 46, 51, 15, ["🧎🏻"]], "1f3fc": ["1f9ce-1f3fc", 46, 52, 15, ["🧎🏼"]], "1f3fd": ["1f9ce-1f3fd", 46, 53, 15, ["🧎🏽"]], "1f3fe": ["1f9ce-1f3fe", 46, 54, 15, ["🧎🏾"]], "1f3ff": ["1f9ce-1f3ff", 46, 55, 15, ["🧎🏿"]] },
      "1f9cf-200d-2640-fe0f": { "1f3fb": ["1f9cf-1f3fb-200d-2640-fe0f", 46, 57, 15, ["🧏🏻‍♀️"]], "1f3fc": ["1f9cf-1f3fc-200d-2640-fe0f", 46, 58, 15, ["🧏🏼‍♀️"]], "1f3fd": ["1f9cf-1f3fd-200d-2640-fe0f", 46, 59, 15, ["🧏🏽‍♀️"]], "1f3fe": ["1f9cf-1f3fe-200d-2640-fe0f", 46, 60, 15, ["🧏🏾‍♀️"]], "1f3ff": ["1f9cf-1f3ff-200d-2640-fe0f", 47, 0, 15, ["🧏🏿‍♀️"]] },
      "1f9cf-200d-2642-fe0f": { "1f3fb": ["1f9cf-1f3fb-200d-2642-fe0f", 47, 2, 15, ["🧏🏻‍♂️"]], "1f3fc": ["1f9cf-1f3fc-200d-2642-fe0f", 47, 3, 15, ["🧏🏼‍♂️"]], "1f3fd": ["1f9cf-1f3fd-200d-2642-fe0f", 47, 4, 15, ["🧏🏽‍♂️"]], "1f3fe": ["1f9cf-1f3fe-200d-2642-fe0f", 47, 5, 15, ["🧏🏾‍♂️"]], "1f3ff": ["1f9cf-1f3ff-200d-2642-fe0f", 47, 6, 15, ["🧏🏿‍♂️"]] },
      "1f9cf": { "1f3fb": ["1f9cf-1f3fb", 47, 8, 15, ["🧏🏻"]], "1f3fc": ["1f9cf-1f3fc", 47, 9, 15, ["🧏🏼"]], "1f3fd": ["1f9cf-1f3fd", 47, 10, 15, ["🧏🏽"]], "1f3fe": ["1f9cf-1f3fe", 47, 11, 15, ["🧏🏾"]], "1f3ff": ["1f9cf-1f3ff", 47, 12, 15, ["🧏🏿"]] },
      "1f9d1-200d-1f33e": { "1f3fb": ["1f9d1-1f3fb-200d-1f33e", 47, 15, 15, ["🧑🏻‍🌾"]], "1f3fc": ["1f9d1-1f3fc-200d-1f33e", 47, 16, 15, ["🧑🏼‍🌾"]], "1f3fd": ["1f9d1-1f3fd-200d-1f33e", 47, 17, 15, ["🧑🏽‍🌾"]], "1f3fe": ["1f9d1-1f3fe-200d-1f33e", 47, 18, 15, ["🧑🏾‍🌾"]], "1f3ff": ["1f9d1-1f3ff-200d-1f33e", 47, 19, 15, ["🧑🏿‍🌾"]] },
      "1f9d1-200d-1f373": { "1f3fb": ["1f9d1-1f3fb-200d-1f373", 47, 21, 15, ["🧑🏻‍🍳"]], "1f3fc": ["1f9d1-1f3fc-200d-1f373", 47, 22, 15, ["🧑🏼‍🍳"]], "1f3fd": ["1f9d1-1f3fd-200d-1f373", 47, 23, 15, ["🧑🏽‍🍳"]], "1f3fe": ["1f9d1-1f3fe-200d-1f373", 47, 24, 15, ["🧑🏾‍🍳"]], "1f3ff": ["1f9d1-1f3ff-200d-1f373", 47, 25, 15, ["🧑🏿‍🍳"]] },
      "1f9d1-200d-1f37c": { "1f3fb": ["1f9d1-1f3fb-200d-1f37c", 47, 27, 15, ["🧑🏻‍🍼"]], "1f3fc": ["1f9d1-1f3fc-200d-1f37c", 47, 28, 15, ["🧑🏼‍🍼"]], "1f3fd": ["1f9d1-1f3fd-200d-1f37c", 47, 29, 15, ["🧑🏽‍🍼"]], "1f3fe": ["1f9d1-1f3fe-200d-1f37c", 47, 30, 15, ["🧑🏾‍🍼"]], "1f3ff": ["1f9d1-1f3ff-200d-1f37c", 47, 31, 15, ["🧑🏿‍🍼"]] },
      "1f9d1-200d-1f384": { "1f3fb": ["1f9d1-1f3fb-200d-1f384", 47, 33, 15, ["🧑🏻‍🎄"]], "1f3fc": ["1f9d1-1f3fc-200d-1f384", 47, 34, 15, ["🧑🏼‍🎄"]], "1f3fd": ["1f9d1-1f3fd-200d-1f384", 47, 35, 15, ["🧑🏽‍🎄"]], "1f3fe": ["1f9d1-1f3fe-200d-1f384", 47, 36, 15, ["🧑🏾‍🎄"]], "1f3ff": ["1f9d1-1f3ff-200d-1f384", 47, 37, 15, ["🧑🏿‍🎄"]] },
      "1f9d1-200d-1f393": { "1f3fb": ["1f9d1-1f3fb-200d-1f393", 47, 39, 15, ["🧑🏻‍🎓"]], "1f3fc": ["1f9d1-1f3fc-200d-1f393", 47, 40, 15, ["🧑🏼‍🎓"]], "1f3fd": ["1f9d1-1f3fd-200d-1f393", 47, 41, 15, ["🧑🏽‍🎓"]], "1f3fe": ["1f9d1-1f3fe-200d-1f393", 47, 42, 15, ["🧑🏾‍🎓"]], "1f3ff": ["1f9d1-1f3ff-200d-1f393", 47, 43, 15, ["🧑🏿‍🎓"]] },
      "1f9d1-200d-1f3a4": { "1f3fb": ["1f9d1-1f3fb-200d-1f3a4", 47, 45, 15, ["🧑🏻‍🎤"]], "1f3fc": ["1f9d1-1f3fc-200d-1f3a4", 47, 46, 15, ["🧑🏼‍🎤"]], "1f3fd": ["1f9d1-1f3fd-200d-1f3a4", 47, 47, 15, ["🧑🏽‍🎤"]], "1f3fe": ["1f9d1-1f3fe-200d-1f3a4", 47, 48, 15, ["🧑🏾‍🎤"]], "1f3ff": ["1f9d1-1f3ff-200d-1f3a4", 47, 49, 15, ["🧑🏿‍🎤"]] },
      "1f9d1-200d-1f3a8": { "1f3fb": ["1f9d1-1f3fb-200d-1f3a8", 47, 51, 15, ["🧑🏻‍🎨"]], "1f3fc": ["1f9d1-1f3fc-200d-1f3a8", 47, 52, 15, ["🧑🏼‍🎨"]], "1f3fd": ["1f9d1-1f3fd-200d-1f3a8", 47, 53, 15, ["🧑🏽‍🎨"]], "1f3fe": ["1f9d1-1f3fe-200d-1f3a8", 47, 54, 15, ["🧑🏾‍🎨"]], "1f3ff": ["1f9d1-1f3ff-200d-1f3a8", 47, 55, 15, ["🧑🏿‍🎨"]] },
      "1f9d1-200d-1f3eb": { "1f3fb": ["1f9d1-1f3fb-200d-1f3eb", 47, 57, 15, ["🧑🏻‍🏫"]], "1f3fc": ["1f9d1-1f3fc-200d-1f3eb", 47, 58, 15, ["🧑🏼‍🏫"]], "1f3fd": ["1f9d1-1f3fd-200d-1f3eb", 47, 59, 15, ["🧑🏽‍🏫"]], "1f3fe": ["1f9d1-1f3fe-200d-1f3eb", 47, 60, 15, ["🧑🏾‍🏫"]], "1f3ff": ["1f9d1-1f3ff-200d-1f3eb", 48, 0, 15, ["🧑🏿‍🏫"]] },
      "1f9d1-200d-1f3ed": { "1f3fb": ["1f9d1-1f3fb-200d-1f3ed", 48, 2, 15, ["🧑🏻‍🏭"]], "1f3fc": ["1f9d1-1f3fc-200d-1f3ed", 48, 3, 15, ["🧑🏼‍🏭"]], "1f3fd": ["1f9d1-1f3fd-200d-1f3ed", 48, 4, 15, ["🧑🏽‍🏭"]], "1f3fe": ["1f9d1-1f3fe-200d-1f3ed", 48, 5, 15, ["🧑🏾‍🏭"]], "1f3ff": ["1f9d1-1f3ff-200d-1f3ed", 48, 6, 15, ["🧑🏿‍🏭"]] },
      "1f9d1-200d-1f4bb": { "1f3fb": ["1f9d1-1f3fb-200d-1f4bb", 48, 8, 15, ["🧑🏻‍💻"]], "1f3fc": ["1f9d1-1f3fc-200d-1f4bb", 48, 9, 15, ["🧑🏼‍💻"]], "1f3fd": ["1f9d1-1f3fd-200d-1f4bb", 48, 10, 15, ["🧑🏽‍💻"]], "1f3fe": ["1f9d1-1f3fe-200d-1f4bb", 48, 11, 15, ["🧑🏾‍💻"]], "1f3ff": ["1f9d1-1f3ff-200d-1f4bb", 48, 12, 15, ["🧑🏿‍💻"]] },
      "1f9d1-200d-1f4bc": { "1f3fb": ["1f9d1-1f3fb-200d-1f4bc", 48, 14, 15, ["🧑🏻‍💼"]], "1f3fc": ["1f9d1-1f3fc-200d-1f4bc", 48, 15, 15, ["🧑🏼‍💼"]], "1f3fd": ["1f9d1-1f3fd-200d-1f4bc", 48, 16, 15, ["🧑🏽‍💼"]], "1f3fe": ["1f9d1-1f3fe-200d-1f4bc", 48, 17, 15, ["🧑🏾‍💼"]], "1f3ff": ["1f9d1-1f3ff-200d-1f4bc", 48, 18, 15, ["🧑🏿‍💼"]] },
      "1f9d1-200d-1f527": { "1f3fb": ["1f9d1-1f3fb-200d-1f527", 48, 20, 15, ["🧑🏻‍🔧"]], "1f3fc": ["1f9d1-1f3fc-200d-1f527", 48, 21, 15, ["🧑🏼‍🔧"]], "1f3fd": ["1f9d1-1f3fd-200d-1f527", 48, 22, 15, ["🧑🏽‍🔧"]], "1f3fe": ["1f9d1-1f3fe-200d-1f527", 48, 23, 15, ["🧑🏾‍🔧"]], "1f3ff": ["1f9d1-1f3ff-200d-1f527", 48, 24, 15, ["🧑🏿‍🔧"]] },
      "1f9d1-200d-1f52c": { "1f3fb": ["1f9d1-1f3fb-200d-1f52c", 48, 26, 15, ["🧑🏻‍🔬"]], "1f3fc": ["1f9d1-1f3fc-200d-1f52c", 48, 27, 15, ["🧑🏼‍🔬"]], "1f3fd": ["1f9d1-1f3fd-200d-1f52c", 48, 28, 15, ["🧑🏽‍🔬"]], "1f3fe": ["1f9d1-1f3fe-200d-1f52c", 48, 29, 15, ["🧑🏾‍🔬"]], "1f3ff": ["1f9d1-1f3ff-200d-1f52c", 48, 30, 15, ["🧑🏿‍🔬"]] },
      "1f9d1-200d-1f680": { "1f3fb": ["1f9d1-1f3fb-200d-1f680", 48, 32, 15, ["🧑🏻‍🚀"]], "1f3fc": ["1f9d1-1f3fc-200d-1f680", 48, 33, 15, ["🧑🏼‍🚀"]], "1f3fd": ["1f9d1-1f3fd-200d-1f680", 48, 34, 15, ["🧑🏽‍🚀"]], "1f3fe": ["1f9d1-1f3fe-200d-1f680", 48, 35, 15, ["🧑🏾‍🚀"]], "1f3ff": ["1f9d1-1f3ff-200d-1f680", 48, 36, 15, ["🧑🏿‍🚀"]] },
      "1f9d1-200d-1f692": { "1f3fb": ["1f9d1-1f3fb-200d-1f692", 48, 38, 15, ["🧑🏻‍🚒"]], "1f3fc": ["1f9d1-1f3fc-200d-1f692", 48, 39, 15, ["🧑🏼‍🚒"]], "1f3fd": ["1f9d1-1f3fd-200d-1f692", 48, 40, 15, ["🧑🏽‍🚒"]], "1f3fe": ["1f9d1-1f3fe-200d-1f692", 48, 41, 15, ["🧑🏾‍🚒"]], "1f3ff": ["1f9d1-1f3ff-200d-1f692", 48, 42, 15, ["🧑🏿‍🚒"]] },
      "1f9d1-200d-1f91d-200d-1f9d1": { "1f3fb-1f3fb": ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb", 48, 44, 15, ["🧑🏻‍🤝‍🧑🏻"]], "1f3fb-1f3fc": ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc", 48, 45, 15, ["🧑🏻‍🤝‍🧑🏼"]], "1f3fb-1f3fd": ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd", 48, 46, 15, ["🧑🏻‍🤝‍🧑🏽"]], "1f3fb-1f3fe": ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe", 48, 47, 15, ["🧑🏻‍🤝‍🧑🏾"]], "1f3fb-1f3ff": ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff", 48, 48, 15, ["🧑🏻‍🤝‍🧑🏿"]], "1f3fc-1f3fb": ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb", 48, 49, 15, ["🧑🏼‍🤝‍🧑🏻"]], "1f3fc-1f3fc": ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc", 48, 50, 15, ["🧑🏼‍🤝‍🧑🏼"]], "1f3fc-1f3fd": ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd", 48, 51, 15, ["🧑🏼‍🤝‍🧑🏽"]], "1f3fc-1f3fe": ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe", 48, 52, 15, ["🧑🏼‍🤝‍🧑🏾"]], "1f3fc-1f3ff": ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff", 48, 53, 15, ["🧑🏼‍🤝‍🧑🏿"]], "1f3fd-1f3fb": ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb", 48, 54, 15, ["🧑🏽‍🤝‍🧑🏻"]], "1f3fd-1f3fc": ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc", 48, 55, 15, ["🧑🏽‍🤝‍🧑🏼"]], "1f3fd-1f3fd": ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd", 48, 56, 15, ["🧑🏽‍🤝‍🧑🏽"]], "1f3fd-1f3fe": ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe", 48, 57, 15, ["🧑🏽‍🤝‍🧑🏾"]], "1f3fd-1f3ff": ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff", 48, 58, 15, ["🧑🏽‍🤝‍🧑🏿"]], "1f3fe-1f3fb": ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb", 48, 59, 15, ["🧑🏾‍🤝‍🧑🏻"]], "1f3fe-1f3fc": ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc", 48, 60, 15, ["🧑🏾‍🤝‍🧑🏼"]], "1f3fe-1f3fd": ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd", 49, 0, 15, ["🧑🏾‍🤝‍🧑🏽"]], "1f3fe-1f3fe": ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe", 49, 1, 15, ["🧑🏾‍🤝‍🧑🏾"]], "1f3fe-1f3ff": ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff", 49, 2, 15, ["🧑🏾‍🤝‍🧑🏿"]], "1f3ff-1f3fb": ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb", 49, 3, 15, ["🧑🏿‍🤝‍🧑🏻"]], "1f3ff-1f3fc": ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc", 49, 4, 15, ["🧑🏿‍🤝‍🧑🏼"]], "1f3ff-1f3fd": ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd", 49, 5, 15, ["🧑🏿‍🤝‍🧑🏽"]], "1f3ff-1f3fe": ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe", 49, 6, 15, ["🧑🏿‍🤝‍🧑🏾"]], "1f3ff-1f3ff": ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff", 49, 7, 15, ["🧑🏿‍🤝‍🧑🏿"]] },
      "1f9d1-200d-1f9af": { "1f3fb": ["1f9d1-1f3fb-200d-1f9af", 49, 9, 15, ["🧑🏻‍🦯"]], "1f3fc": ["1f9d1-1f3fc-200d-1f9af", 49, 10, 15, ["🧑🏼‍🦯"]], "1f3fd": ["1f9d1-1f3fd-200d-1f9af", 49, 11, 15, ["🧑🏽‍🦯"]], "1f3fe": ["1f9d1-1f3fe-200d-1f9af", 49, 12, 15, ["🧑🏾‍🦯"]], "1f3ff": ["1f9d1-1f3ff-200d-1f9af", 49, 13, 15, ["🧑🏿‍🦯"]] },
      "1f9d1-200d-1f9b0": { "1f3fb": ["1f9d1-1f3fb-200d-1f9b0", 49, 15, 15, ["🧑🏻‍🦰"]], "1f3fc": ["1f9d1-1f3fc-200d-1f9b0", 49, 16, 15, ["🧑🏼‍🦰"]], "1f3fd": ["1f9d1-1f3fd-200d-1f9b0", 49, 17, 15, ["🧑🏽‍🦰"]], "1f3fe": ["1f9d1-1f3fe-200d-1f9b0", 49, 18, 15, ["🧑🏾‍🦰"]], "1f3ff": ["1f9d1-1f3ff-200d-1f9b0", 49, 19, 15, ["🧑🏿‍🦰"]] },
      "1f9d1-200d-1f9b1": { "1f3fb": ["1f9d1-1f3fb-200d-1f9b1", 49, 21, 15, ["🧑🏻‍🦱"]], "1f3fc": ["1f9d1-1f3fc-200d-1f9b1", 49, 22, 15, ["🧑🏼‍🦱"]], "1f3fd": ["1f9d1-1f3fd-200d-1f9b1", 49, 23, 15, ["🧑🏽‍🦱"]], "1f3fe": ["1f9d1-1f3fe-200d-1f9b1", 49, 24, 15, ["🧑🏾‍🦱"]], "1f3ff": ["1f9d1-1f3ff-200d-1f9b1", 49, 25, 15, ["🧑🏿‍🦱"]] },
      "1f9d1-200d-1f9b2": { "1f3fb": ["1f9d1-1f3fb-200d-1f9b2", 49, 27, 15, ["🧑🏻‍🦲"]], "1f3fc": ["1f9d1-1f3fc-200d-1f9b2", 49, 28, 15, ["🧑🏼‍🦲"]], "1f3fd": ["1f9d1-1f3fd-200d-1f9b2", 49, 29, 15, ["🧑🏽‍🦲"]], "1f3fe": ["1f9d1-1f3fe-200d-1f9b2", 49, 30, 15, ["🧑🏾‍🦲"]], "1f3ff": ["1f9d1-1f3ff-200d-1f9b2", 49, 31, 15, ["🧑🏿‍🦲"]] },
      "1f9d1-200d-1f9b3": { "1f3fb": ["1f9d1-1f3fb-200d-1f9b3", 49, 33, 15, ["🧑🏻‍🦳"]], "1f3fc": ["1f9d1-1f3fc-200d-1f9b3", 49, 34, 15, ["🧑🏼‍🦳"]], "1f3fd": ["1f9d1-1f3fd-200d-1f9b3", 49, 35, 15, ["🧑🏽‍🦳"]], "1f3fe": ["1f9d1-1f3fe-200d-1f9b3", 49, 36, 15, ["🧑🏾‍🦳"]], "1f3ff": ["1f9d1-1f3ff-200d-1f9b3", 49, 37, 15, ["🧑🏿‍🦳"]] },
      "1f9d1-200d-1f9bc": { "1f3fb": ["1f9d1-1f3fb-200d-1f9bc", 49, 39, 15, ["🧑🏻‍🦼"]], "1f3fc": ["1f9d1-1f3fc-200d-1f9bc", 49, 40, 15, ["🧑🏼‍🦼"]], "1f3fd": ["1f9d1-1f3fd-200d-1f9bc", 49, 41, 15, ["🧑🏽‍🦼"]], "1f3fe": ["1f9d1-1f3fe-200d-1f9bc", 49, 42, 15, ["🧑🏾‍🦼"]], "1f3ff": ["1f9d1-1f3ff-200d-1f9bc", 49, 43, 15, ["🧑🏿‍🦼"]] },
      "1f9d1-200d-1f9bd": { "1f3fb": ["1f9d1-1f3fb-200d-1f9bd", 49, 45, 15, ["🧑🏻‍🦽"]], "1f3fc": ["1f9d1-1f3fc-200d-1f9bd", 49, 46, 15, ["🧑🏼‍🦽"]], "1f3fd": ["1f9d1-1f3fd-200d-1f9bd", 49, 47, 15, ["🧑🏽‍🦽"]], "1f3fe": ["1f9d1-1f3fe-200d-1f9bd", 49, 48, 15, ["🧑🏾‍🦽"]], "1f3ff": ["1f9d1-1f3ff-200d-1f9bd", 49, 49, 15, ["🧑🏿‍🦽"]] },
      "1f9d1-200d-2695-fe0f": { "1f3fb": ["1f9d1-1f3fb-200d-2695-fe0f", 49, 51, 15, ["🧑🏻‍⚕️"]], "1f3fc": ["1f9d1-1f3fc-200d-2695-fe0f", 49, 52, 15, ["🧑🏼‍⚕️"]], "1f3fd": ["1f9d1-1f3fd-200d-2695-fe0f", 49, 53, 15, ["🧑🏽‍⚕️"]], "1f3fe": ["1f9d1-1f3fe-200d-2695-fe0f", 49, 54, 15, ["🧑🏾‍⚕️"]], "1f3ff": ["1f9d1-1f3ff-200d-2695-fe0f", 49, 55, 15, ["🧑🏿‍⚕️"]] },
      "1f9d1-200d-2696-fe0f": { "1f3fb": ["1f9d1-1f3fb-200d-2696-fe0f", 49, 57, 15, ["🧑🏻‍⚖️"]], "1f3fc": ["1f9d1-1f3fc-200d-2696-fe0f", 49, 58, 15, ["🧑🏼‍⚖️"]], "1f3fd": ["1f9d1-1f3fd-200d-2696-fe0f", 49, 59, 15, ["🧑🏽‍⚖️"]], "1f3fe": ["1f9d1-1f3fe-200d-2696-fe0f", 49, 60, 15, ["🧑🏾‍⚖️"]], "1f3ff": ["1f9d1-1f3ff-200d-2696-fe0f", 50, 0, 15, ["🧑🏿‍⚖️"]] },
      "1f9d1-200d-2708-fe0f": { "1f3fb": ["1f9d1-1f3fb-200d-2708-fe0f", 50, 2, 15, ["🧑🏻‍✈️"]], "1f3fc": ["1f9d1-1f3fc-200d-2708-fe0f", 50, 3, 15, ["🧑🏼‍✈️"]], "1f3fd": ["1f9d1-1f3fd-200d-2708-fe0f", 50, 4, 15, ["🧑🏽‍✈️"]], "1f3fe": ["1f9d1-1f3fe-200d-2708-fe0f", 50, 5, 15, ["🧑🏾‍✈️"]], "1f3ff": ["1f9d1-1f3ff-200d-2708-fe0f", 50, 6, 15, ["🧑🏿‍✈️"]] },
      "1f9d1": { "1f3fb": ["1f9d1-1f3fb", 50, 8, 15, ["🧑🏻"]], "1f3fc": ["1f9d1-1f3fc", 50, 9, 15, ["🧑🏼"]], "1f3fd": ["1f9d1-1f3fd", 50, 10, 15, ["🧑🏽"]], "1f3fe": ["1f9d1-1f3fe", 50, 11, 15, ["🧑🏾"]], "1f3ff": ["1f9d1-1f3ff", 50, 12, 15, ["🧑🏿"]] },
      "1f9d2": { "1f3fb": ["1f9d2-1f3fb", 50, 14, 15, ["🧒🏻"]], "1f3fc": ["1f9d2-1f3fc", 50, 15, 15, ["🧒🏼"]], "1f3fd": ["1f9d2-1f3fd", 50, 16, 15, ["🧒🏽"]], "1f3fe": ["1f9d2-1f3fe", 50, 17, 15, ["🧒🏾"]], "1f3ff": ["1f9d2-1f3ff", 50, 18, 15, ["🧒🏿"]] },
      "1f9d3": { "1f3fb": ["1f9d3-1f3fb", 50, 20, 15, ["🧓🏻"]], "1f3fc": ["1f9d3-1f3fc", 50, 21, 15, ["🧓🏼"]], "1f3fd": ["1f9d3-1f3fd", 50, 22, 15, ["🧓🏽"]], "1f3fe": ["1f9d3-1f3fe", 50, 23, 15, ["🧓🏾"]], "1f3ff": ["1f9d3-1f3ff", 50, 24, 15, ["🧓🏿"]] },
      "1f9d4-200d-2640-fe0f": { "1f3fb": ["1f9d4-1f3fb-200d-2640-fe0f", 50, 26, 15, ["🧔🏻‍♀️"]], "1f3fc": ["1f9d4-1f3fc-200d-2640-fe0f", 50, 27, 15, ["🧔🏼‍♀️"]], "1f3fd": ["1f9d4-1f3fd-200d-2640-fe0f", 50, 28, 15, ["🧔🏽‍♀️"]], "1f3fe": ["1f9d4-1f3fe-200d-2640-fe0f", 50, 29, 15, ["🧔🏾‍♀️"]], "1f3ff": ["1f9d4-1f3ff-200d-2640-fe0f", 50, 30, 15, ["🧔🏿‍♀️"]] },
      "1f9d4-200d-2642-fe0f": { "1f3fb": ["1f9d4-1f3fb-200d-2642-fe0f", 50, 32, 15, ["🧔🏻‍♂️"]], "1f3fc": ["1f9d4-1f3fc-200d-2642-fe0f", 50, 33, 15, ["🧔🏼‍♂️"]], "1f3fd": ["1f9d4-1f3fd-200d-2642-fe0f", 50, 34, 15, ["🧔🏽‍♂️"]], "1f3fe": ["1f9d4-1f3fe-200d-2642-fe0f", 50, 35, 15, ["🧔🏾‍♂️"]], "1f3ff": ["1f9d4-1f3ff-200d-2642-fe0f", 50, 36, 15, ["🧔🏿‍♂️"]] },
      "1f9d4": { "1f3fb": ["1f9d4-1f3fb", 50, 38, 15, ["🧔🏻"]], "1f3fc": ["1f9d4-1f3fc", 50, 39, 15, ["🧔🏼"]], "1f3fd": ["1f9d4-1f3fd", 50, 40, 15, ["🧔🏽"]], "1f3fe": ["1f9d4-1f3fe", 50, 41, 15, ["🧔🏾"]], "1f3ff": ["1f9d4-1f3ff", 50, 42, 15, ["🧔🏿"]] },
      "1f9d5": { "1f3fb": ["1f9d5-1f3fb", 50, 44, 15, ["🧕🏻"]], "1f3fc": ["1f9d5-1f3fc", 50, 45, 15, ["🧕🏼"]], "1f3fd": ["1f9d5-1f3fd", 50, 46, 15, ["🧕🏽"]], "1f3fe": ["1f9d5-1f3fe", 50, 47, 15, ["🧕🏾"]], "1f3ff": ["1f9d5-1f3ff", 50, 48, 15, ["🧕🏿"]] },
      "1f9d6-200d-2640-fe0f": { "1f3fb": ["1f9d6-1f3fb-200d-2640-fe0f", 50, 50, 15, ["🧖🏻‍♀️"]], "1f3fc": ["1f9d6-1f3fc-200d-2640-fe0f", 50, 51, 15, ["🧖🏼‍♀️"]], "1f3fd": ["1f9d6-1f3fd-200d-2640-fe0f", 50, 52, 15, ["🧖🏽‍♀️"]], "1f3fe": ["1f9d6-1f3fe-200d-2640-fe0f", 50, 53, 15, ["🧖🏾‍♀️"]], "1f3ff": ["1f9d6-1f3ff-200d-2640-fe0f", 50, 54, 15, ["🧖🏿‍♀️"]] },
      "1f9d6-200d-2642-fe0f": { "1f3fb": ["1f9d6-1f3fb-200d-2642-fe0f", 50, 56, 15, ["🧖🏻‍♂️", "🧖🏻"]], "1f3fc": ["1f9d6-1f3fc-200d-2642-fe0f", 50, 57, 15, ["🧖🏼‍♂️", "🧖🏼"]], "1f3fd": ["1f9d6-1f3fd-200d-2642-fe0f", 50, 58, 15, ["🧖🏽‍♂️", "🧖🏽"]], "1f3fe": ["1f9d6-1f3fe-200d-2642-fe0f", 50, 59, 15, ["🧖🏾‍♂️", "🧖🏾"]], "1f3ff": ["1f9d6-1f3ff-200d-2642-fe0f", 50, 60, 15, ["🧖🏿‍♂️", "🧖🏿"]] },
      "1f9d7-200d-2640-fe0f": { "1f3fb": ["1f9d7-1f3fb-200d-2640-fe0f", 51, 7, 15, ["🧗🏻‍♀️", "🧗🏻"]], "1f3fc": ["1f9d7-1f3fc-200d-2640-fe0f", 51, 8, 15, ["🧗🏼‍♀️", "🧗🏼"]], "1f3fd": ["1f9d7-1f3fd-200d-2640-fe0f", 51, 9, 15, ["🧗🏽‍♀️", "🧗🏽"]], "1f3fe": ["1f9d7-1f3fe-200d-2640-fe0f", 51, 10, 15, ["🧗🏾‍♀️", "🧗🏾"]], "1f3ff": ["1f9d7-1f3ff-200d-2640-fe0f", 51, 11, 15, ["🧗🏿‍♀️", "🧗🏿"]] },
      "1f9d7-200d-2642-fe0f": { "1f3fb": ["1f9d7-1f3fb-200d-2642-fe0f", 51, 13, 15, ["🧗🏻‍♂️"]], "1f3fc": ["1f9d7-1f3fc-200d-2642-fe0f", 51, 14, 15, ["🧗🏼‍♂️"]], "1f3fd": ["1f9d7-1f3fd-200d-2642-fe0f", 51, 15, 15, ["🧗🏽‍♂️"]], "1f3fe": ["1f9d7-1f3fe-200d-2642-fe0f", 51, 16, 15, ["🧗🏾‍♂️"]], "1f3ff": ["1f9d7-1f3ff-200d-2642-fe0f", 51, 17, 15, ["🧗🏿‍♂️"]] },
      "1f9d8-200d-2640-fe0f": { "1f3fb": ["1f9d8-1f3fb-200d-2640-fe0f", 51, 25, 15, ["🧘🏻‍♀️", "🧘🏻"]], "1f3fc": ["1f9d8-1f3fc-200d-2640-fe0f", 51, 26, 15, ["🧘🏼‍♀️", "🧘🏼"]], "1f3fd": ["1f9d8-1f3fd-200d-2640-fe0f", 51, 27, 15, ["🧘🏽‍♀️", "🧘🏽"]], "1f3fe": ["1f9d8-1f3fe-200d-2640-fe0f", 51, 28, 15, ["🧘🏾‍♀️", "🧘🏾"]], "1f3ff": ["1f9d8-1f3ff-200d-2640-fe0f", 51, 29, 15, ["🧘🏿‍♀️", "🧘🏿"]] },
      "1f9d8-200d-2642-fe0f": { "1f3fb": ["1f9d8-1f3fb-200d-2642-fe0f", 51, 31, 15, ["🧘🏻‍♂️"]], "1f3fc": ["1f9d8-1f3fc-200d-2642-fe0f", 51, 32, 15, ["🧘🏼‍♂️"]], "1f3fd": ["1f9d8-1f3fd-200d-2642-fe0f", 51, 33, 15, ["🧘🏽‍♂️"]], "1f3fe": ["1f9d8-1f3fe-200d-2642-fe0f", 51, 34, 15, ["🧘🏾‍♂️"]], "1f3ff": ["1f9d8-1f3ff-200d-2642-fe0f", 51, 35, 15, ["🧘🏿‍♂️"]] },
      "1f9d9-200d-2640-fe0f": { "1f3fb": ["1f9d9-1f3fb-200d-2640-fe0f", 51, 43, 15, ["🧙🏻‍♀️", "🧙🏻"]], "1f3fc": ["1f9d9-1f3fc-200d-2640-fe0f", 51, 44, 15, ["🧙🏼‍♀️", "🧙🏼"]], "1f3fd": ["1f9d9-1f3fd-200d-2640-fe0f", 51, 45, 15, ["🧙🏽‍♀️", "🧙🏽"]], "1f3fe": ["1f9d9-1f3fe-200d-2640-fe0f", 51, 46, 15, ["🧙🏾‍♀️", "🧙🏾"]], "1f3ff": ["1f9d9-1f3ff-200d-2640-fe0f", 51, 47, 15, ["🧙🏿‍♀️", "🧙🏿"]] },
      "1f9d9-200d-2642-fe0f": { "1f3fb": ["1f9d9-1f3fb-200d-2642-fe0f", 51, 49, 15, ["🧙🏻‍♂️"]], "1f3fc": ["1f9d9-1f3fc-200d-2642-fe0f", 51, 50, 15, ["🧙🏼‍♂️"]], "1f3fd": ["1f9d9-1f3fd-200d-2642-fe0f", 51, 51, 15, ["🧙🏽‍♂️"]], "1f3fe": ["1f9d9-1f3fe-200d-2642-fe0f", 51, 52, 15, ["🧙🏾‍♂️"]], "1f3ff": ["1f9d9-1f3ff-200d-2642-fe0f", 51, 53, 15, ["🧙🏿‍♂️"]] },
      "1f9da-200d-2640-fe0f": { "1f3fb": ["1f9da-1f3fb-200d-2640-fe0f", 52, 0, 15, ["🧚🏻‍♀️", "🧚🏻"]], "1f3fc": ["1f9da-1f3fc-200d-2640-fe0f", 52, 1, 15, ["🧚🏼‍♀️", "🧚🏼"]], "1f3fd": ["1f9da-1f3fd-200d-2640-fe0f", 52, 2, 15, ["🧚🏽‍♀️", "🧚🏽"]], "1f3fe": ["1f9da-1f3fe-200d-2640-fe0f", 52, 3, 15, ["🧚🏾‍♀️", "🧚🏾"]], "1f3ff": ["1f9da-1f3ff-200d-2640-fe0f", 52, 4, 15, ["🧚🏿‍♀️", "🧚🏿"]] },
      "1f9da-200d-2642-fe0f": { "1f3fb": ["1f9da-1f3fb-200d-2642-fe0f", 52, 6, 15, ["🧚🏻‍♂️"]], "1f3fc": ["1f9da-1f3fc-200d-2642-fe0f", 52, 7, 15, ["🧚🏼‍♂️"]], "1f3fd": ["1f9da-1f3fd-200d-2642-fe0f", 52, 8, 15, ["🧚🏽‍♂️"]], "1f3fe": ["1f9da-1f3fe-200d-2642-fe0f", 52, 9, 15, ["🧚🏾‍♂️"]], "1f3ff": ["1f9da-1f3ff-200d-2642-fe0f", 52, 10, 15, ["🧚🏿‍♂️"]] },
      "1f9db-200d-2640-fe0f": { "1f3fb": ["1f9db-1f3fb-200d-2640-fe0f", 52, 18, 15, ["🧛🏻‍♀️", "🧛🏻"]], "1f3fc": ["1f9db-1f3fc-200d-2640-fe0f", 52, 19, 15, ["🧛🏼‍♀️", "🧛🏼"]], "1f3fd": ["1f9db-1f3fd-200d-2640-fe0f", 52, 20, 15, ["🧛🏽‍♀️", "🧛🏽"]], "1f3fe": ["1f9db-1f3fe-200d-2640-fe0f", 52, 21, 15, ["🧛🏾‍♀️", "🧛🏾"]], "1f3ff": ["1f9db-1f3ff-200d-2640-fe0f", 52, 22, 15, ["🧛🏿‍♀️", "🧛🏿"]] },
      "1f9db-200d-2642-fe0f": { "1f3fb": ["1f9db-1f3fb-200d-2642-fe0f", 52, 24, 15, ["🧛🏻‍♂️"]], "1f3fc": ["1f9db-1f3fc-200d-2642-fe0f", 52, 25, 15, ["🧛🏼‍♂️"]], "1f3fd": ["1f9db-1f3fd-200d-2642-fe0f", 52, 26, 15, ["🧛🏽‍♂️"]], "1f3fe": ["1f9db-1f3fe-200d-2642-fe0f", 52, 27, 15, ["🧛🏾‍♂️"]], "1f3ff": ["1f9db-1f3ff-200d-2642-fe0f", 52, 28, 15, ["🧛🏿‍♂️"]] },
      "1f9dc-200d-2640-fe0f": { "1f3fb": ["1f9dc-1f3fb-200d-2640-fe0f", 52, 36, 15, ["🧜🏻‍♀️"]], "1f3fc": ["1f9dc-1f3fc-200d-2640-fe0f", 52, 37, 15, ["🧜🏼‍♀️"]], "1f3fd": ["1f9dc-1f3fd-200d-2640-fe0f", 52, 38, 15, ["🧜🏽‍♀️"]], "1f3fe": ["1f9dc-1f3fe-200d-2640-fe0f", 52, 39, 15, ["🧜🏾‍♀️"]], "1f3ff": ["1f9dc-1f3ff-200d-2640-fe0f", 52, 40, 15, ["🧜🏿‍♀️"]] },
      "1f9dc-200d-2642-fe0f": { "1f3fb": ["1f9dc-1f3fb-200d-2642-fe0f", 52, 42, 15, ["🧜🏻‍♂️", "🧜🏻"]], "1f3fc": ["1f9dc-1f3fc-200d-2642-fe0f", 52, 43, 15, ["🧜🏼‍♂️", "🧜🏼"]], "1f3fd": ["1f9dc-1f3fd-200d-2642-fe0f", 52, 44, 15, ["🧜🏽‍♂️", "🧜🏽"]], "1f3fe": ["1f9dc-1f3fe-200d-2642-fe0f", 52, 45, 15, ["🧜🏾‍♂️", "🧜🏾"]], "1f3ff": ["1f9dc-1f3ff-200d-2642-fe0f", 52, 46, 15, ["🧜🏿‍♂️", "🧜🏿"]] },
      "1f9dd-200d-2640-fe0f": { "1f3fb": ["1f9dd-1f3fb-200d-2640-fe0f", 52, 54, 15, ["🧝🏻‍♀️"]], "1f3fc": ["1f9dd-1f3fc-200d-2640-fe0f", 52, 55, 15, ["🧝🏼‍♀️"]], "1f3fd": ["1f9dd-1f3fd-200d-2640-fe0f", 52, 56, 15, ["🧝🏽‍♀️"]], "1f3fe": ["1f9dd-1f3fe-200d-2640-fe0f", 52, 57, 15, ["🧝🏾‍♀️"]], "1f3ff": ["1f9dd-1f3ff-200d-2640-fe0f", 52, 58, 15, ["🧝🏿‍♀️"]] },
      "1f9dd-200d-2642-fe0f": { "1f3fb": ["1f9dd-1f3fb-200d-2642-fe0f", 52, 60, 15, ["🧝🏻‍♂️", "🧝🏻"]], "1f3fc": ["1f9dd-1f3fc-200d-2642-fe0f", 53, 0, 15, ["🧝🏼‍♂️", "🧝🏼"]], "1f3fd": ["1f9dd-1f3fd-200d-2642-fe0f", 53, 1, 15, ["🧝🏽‍♂️", "🧝🏽"]], "1f3fe": ["1f9dd-1f3fe-200d-2642-fe0f", 53, 2, 15, ["🧝🏾‍♂️", "🧝🏾"]], "1f3ff": ["1f9dd-1f3ff-200d-2642-fe0f", 53, 3, 15, ["🧝🏿‍♂️", "🧝🏿"]] },
      "1fac3": { "1f3fb": ["1fac3-1f3fb", 54, 60, 15, ["🫃🏻"]], "1f3fc": ["1fac3-1f3fc", 55, 0, 15, ["🫃🏼"]], "1f3fd": ["1fac3-1f3fd", 55, 1, 15, ["🫃🏽"]], "1f3fe": ["1fac3-1f3fe", 55, 2, 15, ["🫃🏾"]], "1f3ff": ["1fac3-1f3ff", 55, 3, 15, ["🫃🏿"]] },
      "1fac4": { "1f3fb": ["1fac4-1f3fb", 55, 5, 15, ["🫄🏻"]], "1f3fc": ["1fac4-1f3fc", 55, 6, 15, ["🫄🏼"]], "1f3fd": ["1fac4-1f3fd", 55, 7, 15, ["🫄🏽"]], "1f3fe": ["1fac4-1f3fe", 55, 8, 15, ["🫄🏾"]], "1f3ff": ["1fac4-1f3ff", 55, 9, 15, ["🫄🏿"]] },
      "1fac5": { "1f3fb": ["1fac5-1f3fb", 55, 11, 15, ["🫅🏻"]], "1f3fc": ["1fac5-1f3fc", 55, 12, 15, ["🫅🏼"]], "1f3fd": ["1fac5-1f3fd", 55, 13, 15, ["🫅🏽"]], "1f3fe": ["1fac5-1f3fe", 55, 14, 15, ["🫅🏾"]], "1f3ff": ["1fac5-1f3ff", 55, 15, 15, ["🫅🏿"]] },
      "1faf0": { "1f3fb": ["1faf0-1f3fb", 55, 40, 15, ["🫰🏻"]], "1f3fc": ["1faf0-1f3fc", 55, 41, 15, ["🫰🏼"]], "1f3fd": ["1faf0-1f3fd", 55, 42, 15, ["🫰🏽"]], "1f3fe": ["1faf0-1f3fe", 55, 43, 15, ["🫰🏾"]], "1f3ff": ["1faf0-1f3ff", 55, 44, 15, ["🫰🏿"]] },
      "1faf1": { "1f3fb": ["1faf1-1f3fb", 55, 46, 15, ["🫱🏻"]], "1f3fc": ["1faf1-1f3fc", 55, 47, 15, ["🫱🏼"]], "1f3fd": ["1faf1-1f3fd", 55, 48, 15, ["🫱🏽"]], "1f3fe": ["1faf1-1f3fe", 55, 49, 15, ["🫱🏾"]], "1f3ff": ["1faf1-1f3ff", 55, 50, 15, ["🫱🏿"]] },
      "1faf2": { "1f3fb": ["1faf2-1f3fb", 55, 52, 15, ["🫲🏻"]], "1f3fc": ["1faf2-1f3fc", 55, 53, 15, ["🫲🏼"]], "1f3fd": ["1faf2-1f3fd", 55, 54, 15, ["🫲🏽"]], "1f3fe": ["1faf2-1f3fe", 55, 55, 15, ["🫲🏾"]], "1f3ff": ["1faf2-1f3ff", 55, 56, 15, ["🫲🏿"]] },
      "1faf3": { "1f3fb": ["1faf3-1f3fb", 55, 58, 15, ["🫳🏻"]], "1f3fc": ["1faf3-1f3fc", 55, 59, 15, ["🫳🏼"]], "1f3fd": ["1faf3-1f3fd", 55, 60, 15, ["🫳🏽"]], "1f3fe": ["1faf3-1f3fe", 56, 0, 15, ["🫳🏾"]], "1f3ff": ["1faf3-1f3ff", 56, 1, 15, ["🫳🏿"]] },
      "1faf4": { "1f3fb": ["1faf4-1f3fb", 56, 3, 15, ["🫴🏻"]], "1f3fc": ["1faf4-1f3fc", 56, 4, 15, ["🫴🏼"]], "1f3fd": ["1faf4-1f3fd", 56, 5, 15, ["🫴🏽"]], "1f3fe": ["1faf4-1f3fe", 56, 6, 15, ["🫴🏾"]], "1f3ff": ["1faf4-1f3ff", 56, 7, 15, ["🫴🏿"]] },
      "1faf5": { "1f3fb": ["1faf5-1f3fb", 56, 9, 15, ["🫵🏻"]], "1f3fc": ["1faf5-1f3fc", 56, 10, 15, ["🫵🏼"]], "1f3fd": ["1faf5-1f3fd", 56, 11, 15, ["🫵🏽"]], "1f3fe": ["1faf5-1f3fe", 56, 12, 15, ["🫵🏾"]], "1f3ff": ["1faf5-1f3ff", 56, 13, 15, ["🫵🏿"]] },
      "1faf6": { "1f3fb": ["1faf6-1f3fb", 56, 15, 15, ["🫶🏻"]], "1f3fc": ["1faf6-1f3fc", 56, 16, 15, ["🫶🏼"]], "1f3fd": ["1faf6-1f3fd", 56, 17, 15, ["🫶🏽"]], "1f3fe": ["1faf6-1f3fe", 56, 18, 15, ["🫶🏾"]], "1f3ff": ["1faf6-1f3ff", 56, 19, 15, ["🫶🏿"]] },
      "1faf7": { "1f3fb": ["1faf7-1f3fb", 56, 21, 3, ["🫷🏻"]], "1f3fc": ["1faf7-1f3fc", 56, 22, 3, ["🫷🏼"]], "1f3fd": ["1faf7-1f3fd", 56, 23, 3, ["🫷🏽"]], "1f3fe": ["1faf7-1f3fe", 56, 24, 3, ["🫷🏾"]], "1f3ff": ["1faf7-1f3ff", 56, 25, 3, ["🫷🏿"]] },
      "1faf8": { "1f3fb": ["1faf8-1f3fb", 56, 27, 3, ["🫸🏻"]], "1f3fc": ["1faf8-1f3fc", 56, 28, 3, ["🫸🏼"]], "1f3fd": ["1faf8-1f3fd", 56, 29, 3, ["🫸🏽"]], "1f3fe": ["1faf8-1f3fe", 56, 30, 3, ["🫸🏾"]], "1f3ff": ["1faf8-1f3ff", 56, 31, 3, ["🫸🏿"]] },
      "261d-fe0f": { "1f3fb": ["261d-1f3fb", 57, 21, 15, ["☝🏻"]], "1f3fc": ["261d-1f3fc", 57, 22, 15, ["☝🏼"]], "1f3fd": ["261d-1f3fd", 57, 23, 15, ["☝🏽"]], "1f3fe": ["261d-1f3fe", 57, 24, 15, ["☝🏾"]], "1f3ff": ["261d-1f3ff", 57, 25, 15, ["☝🏿"]] },
      "26f9-fe0f-200d-2640-fe0f": { "1f3fb": ["26f9-1f3fb-200d-2640-fe0f", 58, 35, 15, ["⛹🏻‍♀️"]], "1f3fc": ["26f9-1f3fc-200d-2640-fe0f", 58, 36, 15, ["⛹🏼‍♀️"]], "1f3fd": ["26f9-1f3fd-200d-2640-fe0f", 58, 37, 15, ["⛹🏽‍♀️"]], "1f3fe": ["26f9-1f3fe-200d-2640-fe0f", 58, 38, 15, ["⛹🏾‍♀️"]], "1f3ff": ["26f9-1f3ff-200d-2640-fe0f", 58, 39, 15, ["⛹🏿‍♀️"]] },
      "26f9-fe0f-200d-2642-fe0f": { "1f3fb": ["26f9-1f3fb-200d-2642-fe0f", 58, 41, 15, ["⛹🏻‍♂️", "⛹🏻"]], "1f3fc": ["26f9-1f3fc-200d-2642-fe0f", 58, 42, 15, ["⛹🏼‍♂️", "⛹🏼"]], "1f3fd": ["26f9-1f3fd-200d-2642-fe0f", 58, 43, 15, ["⛹🏽‍♂️", "⛹🏽"]], "1f3fe": ["26f9-1f3fe-200d-2642-fe0f", 58, 44, 15, ["⛹🏾‍♂️", "⛹🏾"]], "1f3ff": ["26f9-1f3ff-200d-2642-fe0f", 58, 45, 15, ["⛹🏿‍♂️", "⛹🏿"]] },
      "270a": { "1f3fb": ["270a-1f3fb", 58, 59, 15, ["✊🏻"]], "1f3fc": ["270a-1f3fc", 58, 60, 15, ["✊🏼"]], "1f3fd": ["270a-1f3fd", 59, 0, 15, ["✊🏽"]], "1f3fe": ["270a-1f3fe", 59, 1, 15, ["✊🏾"]], "1f3ff": ["270a-1f3ff", 59, 2, 15, ["✊🏿"]] },
      "270b": { "1f3fb": ["270b-1f3fb", 59, 4, 15, ["✋🏻"]], "1f3fc": ["270b-1f3fc", 59, 5, 15, ["✋🏼"]], "1f3fd": ["270b-1f3fd", 59, 6, 15, ["✋🏽"]], "1f3fe": ["270b-1f3fe", 59, 7, 15, ["✋🏾"]], "1f3ff": ["270b-1f3ff", 59, 8, 15, ["✋🏿"]] },
      "270c-fe0f": { "1f3fb": ["270c-1f3fb", 59, 10, 15, ["✌🏻"]], "1f3fc": ["270c-1f3fc", 59, 11, 15, ["✌🏼"]], "1f3fd": ["270c-1f3fd", 59, 12, 15, ["✌🏽"]], "1f3fe": ["270c-1f3fe", 59, 13, 15, ["✌🏾"]], "1f3ff": ["270c-1f3ff", 59, 14, 15, ["✌🏿"]] },
      "270d-fe0f": { "1f3fb": ["270d-1f3fb", 59, 16, 15, ["✍🏻"]], "1f3fc": ["270d-1f3fc", 59, 17, 15, ["✍🏼"]], "1f3fd": ["270d-1f3fd", 59, 18, 15, ["✍🏽"]], "1f3fe": ["270d-1f3fe", 59, 19, 15, ["✍🏾"]], "1f3ff": ["270d-1f3ff", 59, 20, 15, ["✍🏿"]] }
    }, t.prototype.obsoletes_data = {
      "1f3c3-200d-2642-fe0f": ["1f3c3", 8, 26, 15],
      "1f3c3-1f3fb-200d-2642-fe0f": ["1f3c3-1f3fb", 8, 27, 15],
      "1f3c3-1f3fc-200d-2642-fe0f": ["1f3c3-1f3fc", 8, 28, 15],
      "1f3c3-1f3fd-200d-2642-fe0f": ["1f3c3-1f3fd", 8, 29, 15],
      "1f3c3-1f3fe-200d-2642-fe0f": ["1f3c3-1f3fe", 8, 30, 15],
      "1f3c3-1f3ff-200d-2642-fe0f": ["1f3c3-1f3ff", 8, 31, 15],
      "1f3c4-200d-2642-fe0f": ["1f3c4", 8, 44, 15],
      "1f3c4-1f3fb-200d-2642-fe0f": ["1f3c4-1f3fb", 8, 45, 15],
      "1f3c4-1f3fc-200d-2642-fe0f": ["1f3c4-1f3fc", 8, 46, 15],
      "1f3c4-1f3fd-200d-2642-fe0f": ["1f3c4-1f3fd", 8, 47, 15],
      "1f3c4-1f3fe-200d-2642-fe0f": ["1f3c4-1f3fe", 8, 48, 15],
      "1f3c4-1f3ff-200d-2642-fe0f": ["1f3c4-1f3ff", 8, 49, 15],
      "1f3ca-200d-2642-fe0f": ["1f3ca", 9, 11, 15],
      "1f3ca-1f3fb-200d-2642-fe0f": ["1f3ca-1f3fb", 9, 12, 15],
      "1f3ca-1f3fc-200d-2642-fe0f": ["1f3ca-1f3fc", 9, 13, 15],
      "1f3ca-1f3fd-200d-2642-fe0f": ["1f3ca-1f3fd", 9, 14, 15],
      "1f3ca-1f3fe-200d-2642-fe0f": ["1f3ca-1f3fe", 9, 15, 15],
      "1f3ca-1f3ff-200d-2642-fe0f": ["1f3ca-1f3ff", 9, 16, 15],
      "1f3cb-fe0f-200d-2642-fe0f": ["1f3cb-fe0f", 9, 29, 15],
      "1f3cb-1f3fb-200d-2642-fe0f": ["1f3cb-1f3fb", 9, 30, 15],
      "1f3cb-1f3fc-200d-2642-fe0f": ["1f3cb-1f3fc", 9, 31, 15],
      "1f3cb-1f3fd-200d-2642-fe0f": ["1f3cb-1f3fd", 9, 32, 15],
      "1f3cb-1f3fe-200d-2642-fe0f": ["1f3cb-1f3fe", 9, 33, 15],
      "1f3cb-1f3ff-200d-2642-fe0f": ["1f3cb-1f3ff", 9, 34, 15],
      "1f3cc-fe0f-200d-2642-fe0f": ["1f3cc-fe0f", 9, 47, 15],
      "1f3cc-1f3fb-200d-2642-fe0f": ["1f3cc-1f3fb", 9, 48, 15],
      "1f3cc-1f3fc-200d-2642-fe0f": ["1f3cc-1f3fc", 9, 49, 15],
      "1f3cc-1f3fd-200d-2642-fe0f": ["1f3cc-1f3fd", 9, 50, 15],
      "1f3cc-1f3fe-200d-2642-fe0f": ["1f3cc-1f3fe", 9, 51, 15],
      "1f3cc-1f3ff-200d-2642-fe0f": ["1f3cc-1f3ff", 9, 52, 15],
      "1f468-200d-1f469-200d-1f466": ["1f46a", 21, 40, 15],
      "1f46e-200d-2642-fe0f": ["1f46e", 23, 9, 15],
      "1f46e-1f3fb-200d-2642-fe0f": ["1f46e-1f3fb", 23, 10, 15],
      "1f46e-1f3fc-200d-2642-fe0f": ["1f46e-1f3fc", 23, 11, 15],
      "1f46e-1f3fd-200d-2642-fe0f": ["1f46e-1f3fd", 23, 12, 15],
      "1f46e-1f3fe-200d-2642-fe0f": ["1f46e-1f3fe", 23, 13, 15],
      "1f46e-1f3ff-200d-2642-fe0f": ["1f46e-1f3ff", 23, 14, 15],
      "1f46f-200d-2640-fe0f": ["1f46f", 23, 17, 15],
      "1f471-200d-2642-fe0f": ["1f471", 23, 48, 15],
      "1f471-1f3fb-200d-2642-fe0f": ["1f471-1f3fb", 23, 49, 15],
      "1f471-1f3fc-200d-2642-fe0f": ["1f471-1f3fc", 23, 50, 15],
      "1f471-1f3fd-200d-2642-fe0f": ["1f471-1f3fd", 23, 51, 15],
      "1f471-1f3fe-200d-2642-fe0f": ["1f471-1f3fe", 23, 52, 15],
      "1f471-1f3ff-200d-2642-fe0f": ["1f471-1f3ff", 23, 53, 15],
      "1f473-200d-2642-fe0f": ["1f473", 24, 11, 15],
      "1f473-1f3fb-200d-2642-fe0f": ["1f473-1f3fb", 24, 12, 15],
      "1f473-1f3fc-200d-2642-fe0f": ["1f473-1f3fc", 24, 13, 15],
      "1f473-1f3fd-200d-2642-fe0f": ["1f473-1f3fd", 24, 14, 15],
      "1f473-1f3fe-200d-2642-fe0f": ["1f473-1f3fe", 24, 15, 15],
      "1f473-1f3ff-200d-2642-fe0f": ["1f473-1f3ff", 24, 16, 15],
      "1f477-200d-2642-fe0f": ["1f477", 24, 47, 15],
      "1f477-1f3fb-200d-2642-fe0f": ["1f477-1f3fb", 24, 48, 15],
      "1f477-1f3fc-200d-2642-fe0f": ["1f477-1f3fc", 24, 49, 15],
      "1f477-1f3fd-200d-2642-fe0f": ["1f477-1f3fd", 24, 50, 15],
      "1f477-1f3fe-200d-2642-fe0f": ["1f477-1f3fe", 24, 51, 15],
      "1f477-1f3ff-200d-2642-fe0f": ["1f477-1f3ff", 24, 52, 15],
      "1f481-200d-2640-fe0f": ["1f481", 25, 23, 15],
      "1f481-1f3fb-200d-2640-fe0f": ["1f481-1f3fb", 25, 24, 15],
      "1f481-1f3fc-200d-2640-fe0f": ["1f481-1f3fc", 25, 25, 15],
      "1f481-1f3fd-200d-2640-fe0f": ["1f481-1f3fd", 25, 26, 15],
      "1f481-1f3fe-200d-2640-fe0f": ["1f481-1f3fe", 25, 27, 15],
      "1f481-1f3ff-200d-2640-fe0f": ["1f481-1f3ff", 25, 28, 15],
      "1f482-200d-2642-fe0f": ["1f482", 25, 41, 15],
      "1f482-1f3fb-200d-2642-fe0f": ["1f482-1f3fb", 25, 42, 15],
      "1f482-1f3fc-200d-2642-fe0f": ["1f482-1f3fc", 25, 43, 15],
      "1f482-1f3fd-200d-2642-fe0f": ["1f482-1f3fd", 25, 44, 15],
      "1f482-1f3fe-200d-2642-fe0f": ["1f482-1f3fe", 25, 45, 15],
      "1f482-1f3ff-200d-2642-fe0f": ["1f482-1f3ff", 25, 46, 15],
      "1f486-200d-2640-fe0f": ["1f486", 26, 11, 15],
      "1f486-1f3fb-200d-2640-fe0f": ["1f486-1f3fb", 26, 12, 15],
      "1f486-1f3fc-200d-2640-fe0f": ["1f486-1f3fc", 26, 13, 15],
      "1f486-1f3fd-200d-2640-fe0f": ["1f486-1f3fd", 26, 14, 15],
      "1f486-1f3fe-200d-2640-fe0f": ["1f486-1f3fe", 26, 15, 15],
      "1f486-1f3ff-200d-2640-fe0f": ["1f486-1f3ff", 26, 16, 15],
      "1f487-200d-2640-fe0f": ["1f487", 26, 29, 15],
      "1f487-1f3fb-200d-2640-fe0f": ["1f487-1f3fb", 26, 30, 15],
      "1f487-1f3fc-200d-2640-fe0f": ["1f487-1f3fc", 26, 31, 15],
      "1f487-1f3fd-200d-2640-fe0f": ["1f487-1f3fd", 26, 32, 15],
      "1f487-1f3fe-200d-2640-fe0f": ["1f487-1f3fe", 26, 33, 15],
      "1f487-1f3ff-200d-2640-fe0f": ["1f487-1f3ff", 26, 34, 15],
      "1f575-fe0f-200d-2642-fe0f": ["1f575-fe0f", 31, 17, 15],
      "1f575-1f3fb-200d-2642-fe0f": ["1f575-1f3fb", 31, 18, 15],
      "1f575-1f3fc-200d-2642-fe0f": ["1f575-1f3fc", 31, 19, 15],
      "1f575-1f3fd-200d-2642-fe0f": ["1f575-1f3fd", 31, 20, 15],
      "1f575-1f3fe-200d-2642-fe0f": ["1f575-1f3fe", 31, 21, 15],
      "1f575-1f3ff-200d-2642-fe0f": ["1f575-1f3ff", 31, 22, 15],
      "1f645-200d-2640-fe0f": ["1f645", 33, 44, 15],
      "1f645-1f3fb-200d-2640-fe0f": ["1f645-1f3fb", 33, 45, 15],
      "1f645-1f3fc-200d-2640-fe0f": ["1f645-1f3fc", 33, 46, 15],
      "1f645-1f3fd-200d-2640-fe0f": ["1f645-1f3fd", 33, 47, 15],
      "1f645-1f3fe-200d-2640-fe0f": ["1f645-1f3fe", 33, 48, 15],
      "1f645-1f3ff-200d-2640-fe0f": ["1f645-1f3ff", 33, 49, 15],
      "1f646-200d-2640-fe0f": ["1f646", 34, 1, 15],
      "1f646-1f3fb-200d-2640-fe0f": ["1f646-1f3fb", 34, 2, 15],
      "1f646-1f3fc-200d-2640-fe0f": ["1f646-1f3fc", 34, 3, 15],
      "1f646-1f3fd-200d-2640-fe0f": ["1f646-1f3fd", 34, 4, 15],
      "1f646-1f3fe-200d-2640-fe0f": ["1f646-1f3fe", 34, 5, 15],
      "1f646-1f3ff-200d-2640-fe0f": ["1f646-1f3ff", 34, 6, 15],
      "1f64b-200d-2640-fe0f": ["1f64b", 34, 40, 15],
      "1f64b-1f3fb-200d-2640-fe0f": ["1f64b-1f3fb", 34, 41, 15],
      "1f64b-1f3fc-200d-2640-fe0f": ["1f64b-1f3fc", 34, 42, 15],
      "1f64b-1f3fd-200d-2640-fe0f": ["1f64b-1f3fd", 34, 43, 15],
      "1f64b-1f3fe-200d-2640-fe0f": ["1f64b-1f3fe", 34, 44, 15],
      "1f64b-1f3ff-200d-2640-fe0f": ["1f64b-1f3ff", 34, 45, 15],
      "1f64d-200d-2640-fe0f": ["1f64d", 35, 3, 15],
      "1f64d-1f3fb-200d-2640-fe0f": ["1f64d-1f3fb", 35, 4, 15],
      "1f64d-1f3fc-200d-2640-fe0f": ["1f64d-1f3fc", 35, 5, 15],
      "1f64d-1f3fd-200d-2640-fe0f": ["1f64d-1f3fd", 35, 6, 15],
      "1f64d-1f3fe-200d-2640-fe0f": ["1f64d-1f3fe", 35, 7, 15],
      "1f64d-1f3ff-200d-2640-fe0f": ["1f64d-1f3ff", 35, 8, 15],
      "1f64e-200d-2640-fe0f": ["1f64e", 35, 21, 15],
      "1f64e-1f3fb-200d-2640-fe0f": ["1f64e-1f3fb", 35, 22, 15],
      "1f64e-1f3fc-200d-2640-fe0f": ["1f64e-1f3fc", 35, 23, 15],
      "1f64e-1f3fd-200d-2640-fe0f": ["1f64e-1f3fd", 35, 24, 15],
      "1f64e-1f3fe-200d-2640-fe0f": ["1f64e-1f3fe", 35, 25, 15],
      "1f64e-1f3ff-200d-2640-fe0f": ["1f64e-1f3ff", 35, 26, 15],
      "1f6a3-200d-2642-fe0f": ["1f6a3", 36, 19, 15],
      "1f6a3-1f3fb-200d-2642-fe0f": ["1f6a3-1f3fb", 36, 20, 15],
      "1f6a3-1f3fc-200d-2642-fe0f": ["1f6a3-1f3fc", 36, 21, 15],
      "1f6a3-1f3fd-200d-2642-fe0f": ["1f6a3-1f3fd", 36, 22, 15],
      "1f6a3-1f3fe-200d-2642-fe0f": ["1f6a3-1f3fe", 36, 23, 15],
      "1f6a3-1f3ff-200d-2642-fe0f": ["1f6a3-1f3ff", 36, 24, 15],
      "1f6b4-200d-2642-fe0f": ["1f6b4", 36, 53, 15],
      "1f6b4-1f3fb-200d-2642-fe0f": ["1f6b4-1f3fb", 36, 54, 15],
      "1f6b4-1f3fc-200d-2642-fe0f": ["1f6b4-1f3fc", 36, 55, 15],
      "1f6b4-1f3fd-200d-2642-fe0f": ["1f6b4-1f3fd", 36, 56, 15],
      "1f6b4-1f3fe-200d-2642-fe0f": ["1f6b4-1f3fe", 36, 57, 15],
      "1f6b4-1f3ff-200d-2642-fe0f": ["1f6b4-1f3ff", 36, 58, 15],
      "1f6b5-200d-2642-fe0f": ["1f6b5", 37, 10, 15],
      "1f6b5-1f3fb-200d-2642-fe0f": ["1f6b5-1f3fb", 37, 11, 15],
      "1f6b5-1f3fc-200d-2642-fe0f": ["1f6b5-1f3fc", 37, 12, 15],
      "1f6b5-1f3fd-200d-2642-fe0f": ["1f6b5-1f3fd", 37, 13, 15],
      "1f6b5-1f3fe-200d-2642-fe0f": ["1f6b5-1f3fe", 37, 14, 15],
      "1f6b5-1f3ff-200d-2642-fe0f": ["1f6b5-1f3ff", 37, 15, 15],
      "1f6b6-200d-2642-fe0f": ["1f6b6", 37, 28, 15],
      "1f6b6-1f3fb-200d-2642-fe0f": ["1f6b6-1f3fb", 37, 29, 15],
      "1f6b6-1f3fc-200d-2642-fe0f": ["1f6b6-1f3fc", 37, 30, 15],
      "1f6b6-1f3fd-200d-2642-fe0f": ["1f6b6-1f3fd", 37, 31, 15],
      "1f6b6-1f3fe-200d-2642-fe0f": ["1f6b6-1f3fe", 37, 32, 15],
      "1f6b6-1f3ff-200d-2642-fe0f": ["1f6b6-1f3ff", 37, 33, 15],
      "1f9d6-200d-2642-fe0f": ["1f9d6", 51, 0, 15],
      "1f9d6-1f3fb-200d-2642-fe0f": ["1f9d6-1f3fb", 51, 1, 15],
      "1f9d6-1f3fc-200d-2642-fe0f": ["1f9d6-1f3fc", 51, 2, 15],
      "1f9d6-1f3fd-200d-2642-fe0f": ["1f9d6-1f3fd", 51, 3, 15],
      "1f9d6-1f3fe-200d-2642-fe0f": ["1f9d6-1f3fe", 51, 4, 15],
      "1f9d6-1f3ff-200d-2642-fe0f": ["1f9d6-1f3ff", 51, 5, 15],
      "1f9d7-200d-2640-fe0f": ["1f9d7", 51, 18, 15],
      "1f9d7-1f3fb-200d-2640-fe0f": ["1f9d7-1f3fb", 51, 19, 15],
      "1f9d7-1f3fc-200d-2640-fe0f": ["1f9d7-1f3fc", 51, 20, 15],
      "1f9d7-1f3fd-200d-2640-fe0f": ["1f9d7-1f3fd", 51, 21, 15],
      "1f9d7-1f3fe-200d-2640-fe0f": ["1f9d7-1f3fe", 51, 22, 15],
      "1f9d7-1f3ff-200d-2640-fe0f": ["1f9d7-1f3ff", 51, 23, 15],
      "1f9d8-200d-2640-fe0f": ["1f9d8", 51, 36, 15],
      "1f9d8-1f3fb-200d-2640-fe0f": ["1f9d8-1f3fb", 51, 37, 15],
      "1f9d8-1f3fc-200d-2640-fe0f": ["1f9d8-1f3fc", 51, 38, 15],
      "1f9d8-1f3fd-200d-2640-fe0f": ["1f9d8-1f3fd", 51, 39, 15],
      "1f9d8-1f3fe-200d-2640-fe0f": ["1f9d8-1f3fe", 51, 40, 15],
      "1f9d8-1f3ff-200d-2640-fe0f": ["1f9d8-1f3ff", 51, 41, 15],
      "1f9d9-200d-2640-fe0f": ["1f9d9", 51, 54, 15],
      "1f9d9-1f3fb-200d-2640-fe0f": ["1f9d9-1f3fb", 51, 55, 15],
      "1f9d9-1f3fc-200d-2640-fe0f": ["1f9d9-1f3fc", 51, 56, 15],
      "1f9d9-1f3fd-200d-2640-fe0f": ["1f9d9-1f3fd", 51, 57, 15],
      "1f9d9-1f3fe-200d-2640-fe0f": ["1f9d9-1f3fe", 51, 58, 15],
      "1f9d9-1f3ff-200d-2640-fe0f": ["1f9d9-1f3ff", 51, 59, 15],
      "1f9da-200d-2640-fe0f": ["1f9da", 52, 11, 15],
      "1f9da-1f3fb-200d-2640-fe0f": ["1f9da-1f3fb", 52, 12, 15],
      "1f9da-1f3fc-200d-2640-fe0f": ["1f9da-1f3fc", 52, 13, 15],
      "1f9da-1f3fd-200d-2640-fe0f": ["1f9da-1f3fd", 52, 14, 15],
      "1f9da-1f3fe-200d-2640-fe0f": ["1f9da-1f3fe", 52, 15, 15],
      "1f9da-1f3ff-200d-2640-fe0f": ["1f9da-1f3ff", 52, 16, 15],
      "1f9db-200d-2640-fe0f": ["1f9db", 52, 29, 15],
      "1f9db-1f3fb-200d-2640-fe0f": ["1f9db-1f3fb", 52, 30, 15],
      "1f9db-1f3fc-200d-2640-fe0f": ["1f9db-1f3fc", 52, 31, 15],
      "1f9db-1f3fd-200d-2640-fe0f": ["1f9db-1f3fd", 52, 32, 15],
      "1f9db-1f3fe-200d-2640-fe0f": ["1f9db-1f3fe", 52, 33, 15],
      "1f9db-1f3ff-200d-2640-fe0f": ["1f9db-1f3ff", 52, 34, 15],
      "1f9dc-200d-2642-fe0f": ["1f9dc", 52, 47, 15],
      "1f9dc-1f3fb-200d-2642-fe0f": ["1f9dc-1f3fb", 52, 48, 15],
      "1f9dc-1f3fc-200d-2642-fe0f": ["1f9dc-1f3fc", 52, 49, 15],
      "1f9dc-1f3fd-200d-2642-fe0f": ["1f9dc-1f3fd", 52, 50, 15],
      "1f9dc-1f3fe-200d-2642-fe0f": ["1f9dc-1f3fe", 52, 51, 15],
      "1f9dc-1f3ff-200d-2642-fe0f": ["1f9dc-1f3ff", 52, 52, 15],
      "1f9dd-200d-2642-fe0f": ["1f9dd", 53, 4, 15],
      "1f9dd-1f3fb-200d-2642-fe0f": ["1f9dd-1f3fb", 53, 5, 15],
      "1f9dd-1f3fc-200d-2642-fe0f": ["1f9dd-1f3fc", 53, 6, 15],
      "1f9dd-1f3fd-200d-2642-fe0f": ["1f9dd-1f3fd", 53, 7, 15],
      "1f9dd-1f3fe-200d-2642-fe0f": ["1f9dd-1f3fe", 53, 8, 15],
      "1f9dd-1f3ff-200d-2642-fe0f": ["1f9dd-1f3ff", 53, 9, 15],
      "1f9de-200d-2642-fe0f": ["1f9de", 53, 12, 15],
      "1f9df-200d-2642-fe0f": ["1f9df", 53, 15, 15],
      "26f9-fe0f-200d-2642-fe0f": ["26f9-fe0f", 58, 46, 15],
      "26f9-1f3fb-200d-2642-fe0f": ["26f9-1f3fb", 58, 47, 15],
      "26f9-1f3fc-200d-2642-fe0f": ["26f9-1f3fc", 58, 48, 15],
      "26f9-1f3fd-200d-2642-fe0f": ["26f9-1f3fd", 58, 49, 15],
      "26f9-1f3fe-200d-2642-fe0f": ["26f9-1f3fe", 58, 50, 15],
      "26f9-1f3ff-200d-2642-fe0f": ["26f9-1f3ff", 58, 51, 15]
    }, u.exports && (e = u.exports = t), e.EmojiConvertor = t;
  }).call(/* @__PURE__ */ function() {
    return this || (typeof window < "u" ? window : E3);
  }());
})(OD, OD.exports);
var m3 = OD.exports;
const p3 = /* @__PURE__ */ Le(m3), ye = new p3(), b3 = z({
  props: {
    data: { type: String, default: "" },
    useSheet: { type: Boolean },
    size: { type: String, default: "64" }
  },
  setup(u) {
    const { useSheet: e, size: D } = Hu(u);
    return ye.replace_mode = e ? "css" : "img", ye.use_sheet = e, ye.img_sets.apple.path = `https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/${D}/`, ye.img_sets.apple.sheet = `https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/sheets/${D}.png`, {
      emoji: w(() => {
        let t = ye.replace_unified(u.data);
        return e || (t = t.replace("/>", 'loading="lazy" />')), t;
      })
    };
  }
}), g3 = ["innerHTML"];
function v3(u, e, D, f, t, n) {
  return E(), y("span", { innerHTML: u.emoji }, null, 8, g3);
}
const h3 = /* @__PURE__ */ Q(b3, [["render", v3]]);
function iD(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Tf(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function B3(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Mf(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function y3(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _3(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
    v("path", {
      "fill-rule": "evenodd",
      d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function w3(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function k3(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M18.97 3.659a2.25 2.25 0 0 0-3.182 0l-10.94 10.94a3.75 3.75 0 1 0 5.304 5.303l7.693-7.693a.75.75 0 0 1 1.06 1.06l-7.693 7.693a5.25 5.25 0 1 1-7.424-7.424l10.939-10.94a3.75 3.75 0 1 1 5.303 5.304L9.097 18.835l-.008.008-.007.007-.002.002-.003.002A2.25 2.25 0 0 1 5.91 15.66l7.81-7.81a.75.75 0 0 1 1.061 1.06l-7.81 7.81a.75.75 0 0 0 1.054 1.068L18.97 6.84a2.25 2.25 0 0 0 0-3.182Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Of(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function If(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const A3 = z({
  props: {
    type: { type: String, required: !0 },
    title: { type: String, default: "" },
    description: { type: String }
  },
  setup(u) {
    const e = w(() => ({
      success: iD,
      error: Of,
      warning: y3,
      info: w3
    })[u.type]), D = w(() => ({
      success: "text-green-800",
      error: "text-red-800",
      warning: "text-yellow-800",
      info: "text-primary-400"
    })[u.type]), f = w(() => ({
      success: "text-green-400",
      error: "text-red-400",
      warning: "text-yellow-400",
      info: "text-primary-400"
    })[u.type]), t = w(() => ({
      success: "bg-green-50",
      error: "bg-red-50",
      warning: "bg-yellow-50",
      info: "bg-primary-50"
    })[u.type]);
    return {
      icon: e,
      iconColor: f,
      textColor: D,
      backgroundColor: t
    };
  }
}), x3 = { class: "flex" }, $3 = { class: "flex-shrink-0" }, S3 = { class: "ml-3" }, T3 = { key: 0 }, M3 = { key: 1 }, O3 = ["innerHTML"], I3 = { key: 1 };
function P3(u, e, D, f, t, n) {
  return E(), y("div", {
    class: M(`rounded-md ${u.backgroundColor}  p-4`)
  }, [
    v("div", x3, [
      v("div", $3, [
        (E(), q(xu(u.icon), {
          class: M(`h-5 w-5 ${u.iconColor}`)
        }, null, 8, ["class"]))
      ]),
      v("div", S3, [
        v("p", {
          class: M([`text-sm ${u.textColor}`, { "font-medium": u.description || u.$slots.description }])
        }, [
          u.title ? (E(), y("span", T3, O(u.title), 1)) : (E(), y("span", M3, [
            fu(u.$slots, "default")
          ]))
        ], 2),
        u.description || u.$slots.description ? (E(), y("p", {
          key: 0,
          class: M([{ "mt-2": u.title }, `text-sm ${u.textColor}`])
        }, [
          u.description ? (E(), y("span", {
            key: 0,
            innerHTML: u.description
          }, null, 8, O3)) : (E(), y("span", I3, [
            fu(u.$slots, "description")
          ]))
        ], 2)) : R("", !0)
      ])
    ])
  ], 2);
}
const qc = /* @__PURE__ */ Q(A3, [["render", P3]]), L3 = z({
  components: {
    CheckIcon: Tf,
    XMarkIcon: If
  },
  props: {
    steps: { type: Array, required: !0 },
    isStopped: { type: Boolean, default: !1 },
    isCompleted: { type: Boolean, default: !1 }
  },
  setup(u) {
    return { currentStepIndex: w(
      () => u.steps.findIndex((D) => D.isCurrent)
    ) };
  }
}), R3 = {
  "aria-label": "Progress",
  class: "px-4 py-5 sm:px-6"
}, N3 = {
  class: "overflow-hidden",
  role: "list"
}, j3 = { class: "relative flex items-start group" }, V3 = { class: "h-9 flex items-center" }, z3 = {
  key: 2,
  class: "h-2.5 w-2.5 bg-primary-400 rounded-full"
}, U3 = { class: "ml-4 min-w-0 flex flex-col" }, W3 = { class: "text-xs text-primary-400 font-semibold tracking-wide uppercase" }, q3 = { class: "text-sm text-gray-500" };
function Y3(u, e, D, f, t, n) {
  const a = P("CheckIcon"), o = P("XMarkIcon");
  return E(), y("nav", R3, [
    v("ol", N3, [
      (E(!0), y(J, null, du(u.steps, (r, l) => (E(), y("li", {
        key: l,
        class: M([l !== u.steps.length - 1 ? "pb-10" : "", "relative"])
      }, [
        l !== u.steps.length - 1 ? (E(), y("div", {
          key: 0,
          class: M([l > u.currentStepIndex - 1 && !u.isCompleted ? "bg-gray-300" : "bg-primary-400", "-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full"]),
          "aria-hidden": "true"
        }, null, 2)) : R("", !0),
        v("div", j3, [
          v("span", V3, [
            v("span", {
              class: M([{
                "bg-primary-400": u.isCompleted || l < u.currentStepIndex,
                "bg-white border-2 border-primary-400": l === u.currentStepIndex,
                "bg-white border-2 border-gray-300": l > u.currentStepIndex && !u.isCompleted
              }, "relative z-10 w-8 h-8 flex items-center justify-center rounded-full"])
            }, [
              u.isCompleted || l < u.currentStepIndex ? (E(), q(a, {
                key: 0,
                "aria-hidden": "true",
                class: "w-5 h-5 text-white"
              })) : u.isStopped && l === u.currentStepIndex ? (E(), q(o, {
                key: 1,
                class: "h-5 w-5 text-primary-400"
              })) : l === u.currentStepIndex ? (E(), y("span", z3)) : R("", !0)
            ], 2)
          ]),
          v("span", U3, [
            v("span", W3, O(r.title), 1),
            v("span", q3, O(r.description), 1)
          ])
        ])
      ], 2))), 128))
    ])
  ]);
}
const Yc = /* @__PURE__ */ Q(L3, [["render", Y3]]), H3 = z({
  components: {
    TransitionRoot: rD,
    TransitionChild: oD,
    Dialog: e0,
    DialogOverlay: wa,
    DialogTitle: D0,
    DialogDescription: Aa,
    XMarkIcon: vf
  },
  props: {
    title: { type: String },
    description: { type: String },
    isOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:isOpen"],
  setup(u, { emit: e }) {
    return { closeModal: () => {
      e("update:isOpen", !1);
    } };
  }
}), G3 = {
  class: "fixed inset-0 overflow-y-auto",
  style: { "z-index": "100" }
}, X3 = { class: "min-h-screen px-4 text-center" }, Z3 = /* @__PURE__ */ v("span", {
  "aria-hidden": "true",
  class: "hidden sm:inline-block sm:align-middle sm:h-screen"
}, "​", -1), K3 = { class: "inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl" }, Q3 = { class: "absolute top-0 right-0 pt-4 pr-4" }, J3 = /* @__PURE__ */ v("span", { class: "sr-only" }, "Close", -1), un = { key: 0 };
function en(u, e, D, f, t, n) {
  const a = P("DialogOverlay"), o = P("TransitionChild"), r = P("XMarkIcon"), l = P("DialogTitle"), i = P("DialogDescription"), s = P("Dialog"), d = P("TransitionRoot");
  return E(), q(d, {
    show: u.isOpen,
    appear: "",
    as: "template"
  }, {
    default: N(() => [
      U(s, {
        as: "div",
        onClose: u.closeModal
      }, {
        default: N(() => [
          v("div", G3, [
            v("div", X3, [
              U(o, {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: N(() => [
                  U(a, { class: "fixed inset-0 bg-gray-500 bg-opacity-75" })
                ]),
                _: 1
              }),
              Z3,
              U(o, {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: N(() => [
                  v("div", K3, [
                    v("div", Q3, [
                      v("button", {
                        class: "bg-white rounded-md text-gray-400 hover:text-gray-500",
                        tabindex: "-1",
                        type: "button",
                        onClick: e[0] || (e[0] = (...g) => u.closeModal && u.closeModal(...g))
                      }, [
                        J3,
                        U(r, { class: "h-6 w-6" })
                      ])
                    ]),
                    u.title ? (E(), y("div", un, [
                      U(l, {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: N(() => [
                          G(O(u.title), 1)
                        ]),
                        _: 1
                      }),
                      U(i, {
                        as: "p",
                        class: "text-sm text-gray-500 mt-2"
                      }, {
                        default: N(() => [
                          G(O(u.description), 1)
                        ]),
                        _: 1
                      })
                    ])) : R("", !0),
                    fu(u.$slots, "default")
                  ])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      }, 8, ["onClose"])
    ]),
    _: 3
  }, 8, ["show"]);
}
const Hc = /* @__PURE__ */ Q(H3, [["render", en]]), Dn = z({
  components: {
    TransitionRoot: rD,
    TransitionChild: oD,
    Dialog: e0,
    DialogPanel: ka,
    DialogTitle: D0,
    ExclamationTriangleIcon: mt,
    Button: Pe
  },
  props: {
    title: { type: String },
    description: { type: String },
    confirmActionName: { type: String },
    cancelActionName: { type: String },
    confirmActionLoading: { type: Boolean, default: !1 },
    closeOnConfirm: { type: Boolean, default: !0 },
    isOpen: { type: Boolean, default: !1 },
    confirmFunction: { type: Function, default: () => !0 },
    layout: {
      type: String,
      default: () => "row",
      validator: (u) => ["row", "column"].includes(u)
    },
    color: {
      type: String,
      default: () => "danger",
      validator: (u) => ["danger", "secondary"].includes(u)
    }
  },
  emits: ["update:isOpen", "confirm"],
  setup(u, { emit: e }) {
    const D = I(!1), f = {
      secondary: "text-secondary-600 bg-secondary-100",
      danger: "text-red-600 bg-red-100"
    }, t = () => {
      e("update:isOpen", !1);
    };
    return { closeModal: t, confirm: async () => {
      D.value = !0, await u.confirmFunction(), u.closeOnConfirm && t(), D.value = !1, e("confirm");
    }, iconColors: f, loading: D };
  }
}), fn = /* @__PURE__ */ v("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1), tn = {
  class: "fixed inset-0 overflow-y-auto",
  style: { "z-index": "100" }
}, an = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0" }, nn = { class: "mt-2" }, on = { class: "text-sm text-gray-500" };
function rn(u, e, D, f, t, n) {
  const a = P("TransitionChild"), o = P("ExclamationTriangleIcon"), r = P("DialogTitle"), l = P("Button"), i = P("DialogPanel"), s = P("Dialog"), d = P("TransitionRoot");
  return E(), q(d, {
    show: u.isOpen,
    as: "template"
  }, {
    default: N(() => [
      U(s, {
        as: "div",
        class: "relative",
        style: { "z-index": "100" },
        onClose: u.closeModal
      }, {
        default: N(() => [
          U(a, {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: N(() => [
              fn
            ]),
            _: 1
          }),
          v("div", tn, [
            v("div", an, [
              U(a, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: N(() => [
                  U(i, {
                    class: M([{ "sm:my-8 sm:max-w-lg sm:w-full sm:p-6": u.layout === "row" }, "relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6"])
                  }, {
                    default: N(() => [
                      v("div", {
                        class: M({ "sm:flex sm:items-start": u.layout === "row" })
                      }, [
                        v("div", {
                          class: M([[u.iconColors[u.color], { "sm:mx-0 sm:h-10 sm:w-10": u.layout === "row" }], "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full"])
                        }, [
                          U(o, {
                            "aria-hidden": "true",
                            class: "h-6 w-6"
                          })
                        ], 2),
                        v("div", {
                          class: M([{ "sm:mt-0 sm:ml-4 sm:text-left": u.layout === "row" }, "mt-3 text-center"])
                        }, [
                          U(r, {
                            as: "h3",
                            class: "text-lg leading-6 font-medium text-gray-900"
                          }, {
                            default: N(() => [
                              G(O(u.title), 1)
                            ]),
                            _: 1
                          }),
                          v("div", nn, [
                            v("p", on, O(u.description), 1),
                            fu(u.$slots, "default")
                          ])
                        ], 2)
                      ], 2),
                      v("div", {
                        class: M([[
                          { "sm:flex sm:flex-row-reverse": u.layout === "row" },
                          { "sm:grid sm:grid-cols-2 sm:grid-flow-row-dense": u.layout === "column" }
                        ], "mt-5 sm:mt-6 sm:gap-3"])
                      }, [
                        u.confirmFunction ? (E(), q(l, {
                          key: 0,
                          color: u.color,
                          loading: u.confirmActionLoading || u.loading,
                          class: "w-full sm:w-auto sm:col-start-2",
                          onClick: u.confirm
                        }, {
                          default: N(() => [
                            G(O(u.confirmActionName || "Confirmer"), 1)
                          ]),
                          _: 1
                        }, 8, ["color", "loading", "onClick"])) : R("", !0),
                        U(l, {
                          ref: "cancelButtonRef",
                          class: "mt-3 w-full sm:mt-0 sm:w-auto sm:col-start-1",
                          color: "white",
                          onClick: u.closeModal
                        }, {
                          default: N(() => [
                            G(O(u.cancelActionName || "Annuler"), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 2)
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      }, 8, ["onClose"])
    ]),
    _: 3
  }, 8, ["show"]);
}
const Gc = /* @__PURE__ */ Q(Dn, [["render", rn]]), ln = z({
  props: {
    title: { type: String },
    subTitle: { type: String },
    loading: { type: Boolean, default: !1 },
    separator: { type: Boolean, default: !0 }
  }
}), dn = { class: "bg-white rounded-lg shadow break-words" }, sn = { class: "-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap" }, cn = { class: "ml-4 mt-4" }, Fn = {
  key: 0,
  class: "mt-1 animate-pulse h-3 bg-gray-200 rounded w-96"
}, Cn = {
  key: 1,
  class: "text-lg leading-6 font-medium text-gray-900"
}, En = {
  key: 2,
  class: "mt-2 animate-pulse h-3 bg-gray-200 rounded w-2/3"
}, mn = {
  key: 3,
  class: "mt-1 text-sm text-gray-500"
}, pn = {
  key: 0,
  class: "ml-4 mt-4 flex-shrink-0"
}, bn = { key: 1 }, gn = {
  class: "divide-y divide-gray-200",
  role: "list"
}, vn = /* @__PURE__ */ K0('<div class="flex items-center px-4 py-4 sm:px-6"><div class="min-w-0 flex-1 flex items-center"><div class="flex-shrink-0"></div><div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4"><div><div class="animate-pulse h-3 bg-gray-300 rounded w-36"></div><div class="animate-pulse mt-3 h-3 bg-gray-200 rounded w-56"></div></div><div class="hidden md:block"><div><div class="animate-pulse h-3 bg-gray-200 rounded w-56"></div><div class="animate-pulse mt-3 h-3 bg-gray-200 rounded w-40"></div></div></div></div></div><div><div class="animate-pulse h-7 bg-gray-300 rounded w-20"></div></div></div>', 1), hn = [
  vn
];
function Bn(u, e, D, f, t, n) {
  return E(), y("div", dn, [
    u.title ? (E(), y("div", {
      key: 0,
      class: M([
        { "border-b border-gray-200": u.separator },
        "rounded-t-lg bg-white px-4 py-5 sm:px-6"
      ])
    }, [
      v("div", sn, [
        v("div", cn, [
          u.loading ? (E(), y("div", Fn)) : (E(), y("h3", Cn, O(u.title), 1)),
          u.loading ? (E(), y("div", En)) : (E(), y("p", mn, O(u.subTitle), 1))
        ]),
        u.loading ? R("", !0) : (E(), y("div", pn, [
          fu(u.$slots, "actions")
        ]))
      ])
    ], 2)) : R("", !0),
    u.loading ? (E(), y("div", bn, [
      v("ul", gn, [
        (E(!0), y(J, null, du(new Array(8), (a, o) => (E(), y("li", { key: o }, hn))), 128))
      ])
    ])) : fu(u.$slots, "default", { key: 2 })
  ]);
}
const Xc = /* @__PURE__ */ Q(ln, [["render", Bn]]), yn = z({
  props: {
    tabs: {
      type: Array,
      default: () => [],
      required: !0
    },
    badgeColor: {
      type: String,
      default: () => "primary",
      validator: (u) => ["primary", "secondary"].includes(u)
    }
  },
  setup(u) {
    const e = Cu(Vf);
    return {
      selectedTab: w({
        get: () => e.currentRoute.value.query.tab ? e.currentRoute.value.query.tab.toString() : u.tabs.length ? u.tabs[0].key : "",
        set: async (t) => {
          await e.push({
            path: e.currentRoute.value.fullPath,
            query: {
              ...e.currentRoute.value.query,
              tab: t
            }
          });
        }
      }),
      badgeClasses: {
        primary: {
          current: "bg-primary-100 text-primary-600",
          default: "bg-gray-100 text-gray-900"
        },
        secondary: {
          current: "bg-secondary-300 text-primary-600",
          default: "bg-secondary-100 text-gray-900"
        }
      }
    };
  }
}), _n = { class: "md:hidden pb-3 pt-4" }, wn = /* @__PURE__ */ v("label", {
  class: "sr-only",
  for: "tabs"
}, "Select a tab", -1), kn = ["selected", "value"], An = { class: "hidden md:block" }, xn = { class: "border-b border-gray-200" }, $n = {
  "aria-label": "Tabs",
  class: "-mb-px flex space-x-4 lg:space-x-8"
};
function Sn(u, e, D, f, t, n) {
  const a = P("router-link");
  return E(), y("div", null, [
    v("div", _n, [
      wn,
      qe(v("select", {
        id: "tabs",
        "onUpdate:modelValue": e[0] || (e[0] = (o) => u.selectedTab = o),
        class: "block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md",
        name: "tabs"
      }, [
        (E(!0), y(J, null, du(u.tabs, (o) => (E(), y("option", {
          key: o.name,
          selected: o.current,
          value: o.to.query.tab
        }, O(o.name), 9, kn))), 128))
      ], 512), [
        [Q0, u.selectedTab]
      ])
    ]),
    v("div", An, [
      v("div", xn, [
        v("nav", $n, [
          (E(!0), y(J, null, du(u.tabs, (o) => (E(), q(a, {
            key: o.name,
            "aria-current": o.current ? "page" : void 0,
            class: M([
              o.current ? "border-primary-500 text-primary-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200",
              "whitespace-nowrap flex py-4 px-1 border-b-2 font-medium text-sm"
            ]),
            to: o.to
          }, {
            default: N(() => [
              (E(), q(xu(o.icon), {
                class: M([
                  o.current ? "text-primary-500" : "text-gray-400 group-hover:text-gray-500",
                  "-ml-0.5 mr-2 h-5 w-5"
                ]),
                "aria-hidden": "true"
              }, null, 8, ["class"])),
              v("span", null, O(o.name), 1),
              o.count ? (E(), y("span", {
                key: 0,
                class: M([
                  u.badgeClasses[u.badgeColor][o.current ? "current" : "default"],
                  "hidden ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium lg:inline-block"
                ])
              }, O(o.count), 3)) : R("", !0)
            ]),
            _: 2
          }, 1032, ["aria-current", "class", "to"]))), 128))
        ])
      ])
    ])
  ]);
}
const Zc = /* @__PURE__ */ Q(yn, [["render", Sn]]);
function A0(u) {
  const e = Qe({ offset: 0, limit: 25 });
  u && (e.limit = u);
  const D = (t) => {
    t.query.offset ? e.offset = Number(t.query.offset) : e.offset = 0;
  }, { currentRoute: f } = Cu(Vf);
  return au(f, D, { immediate: !0 }), { pagination: e };
}
const Tn = z({
  props: {
    total: { type: Number, required: !0 },
    pageSize: { type: Number, required: !0 },
    previousOffset: { type: Number, required: !0 },
    nextOffset: { type: Number, required: !0 },
    hasMore: { type: Boolean, required: !0 },
    loading: { type: Boolean }
  },
  setup() {
    const { pagination: u } = A0(), { currentRoute: e } = Cu(Vf), { pluralize: D } = fe();
    return {
      pagination: u,
      currentRoute: e,
      pluralize: D
    };
  }
}), Mn = {
  "aria-label": "Pagination",
  class: "bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
}, On = { class: "hidden sm:block" }, In = {
  key: 0,
  class: "animate-pulse h-3 bg-gray-200 rounded w-48"
}, Pn = {
  key: 1,
  class: "text-sm text-gray-700"
}, Ln = { class: "font-medium" }, Rn = { class: "font-medium" }, Nn = { class: "font-medium" }, jn = { class: "flex-1 flex justify-between sm:justify-end" };
function Vn(u, e, D, f, t, n) {
  const a = P("router-link");
  return E(), y("nav", Mn, [
    v("div", On, [
      u.loading ? (E(), y("div", In)) : (E(), y("p", Pn, [
        G(" Affichage de "),
        v("span", Ln, O(u.pageSize ? u.pagination.offset + 1 : 0), 1),
        G(" à "),
        v("span", Rn, O(u.pagination.offset + u.pageSize), 1),
        G(" sur "),
        v("span", Nn, O(u.total), 1),
        G(" " + O(u.pluralize("résultat", u.total)), 1)
      ]))
    ]),
    v("div", jn, [
      U(a, {
        class: M([{ "opacity-50 cursor-not-allowed": u.pagination.offset === 0 }, "relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"]),
        to: {
          path: u.currentRoute.fullPath,
          query: {
            ...u.currentRoute.query,
            offset: u.previousOffset || void 0
          }
        }
      }, {
        default: N(() => [
          G(" Précédent ")
        ]),
        _: 1
      }, 8, ["class", "to"]),
      U(a, {
        class: M([{ "opacity-50 cursor-not-allowed": !u.hasMore }, "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"]),
        to: {
          path: u.currentRoute.fullPath,
          query: {
            ...u.currentRoute.query,
            offset: u.nextOffset || void 0
          }
        }
      }, {
        default: N(() => [
          G(" Suivant ")
        ]),
        _: 1
      }, 8, ["class", "to"])
    ])
  ]);
}
const zn = /* @__PURE__ */ Q(Tn, [["render", Vn]]), Un = z({
  emits: ["empty-button-action", "edit", "view", "delete"],
  props: {
    header: { type: Array, required: !0 },
    paginationResult: { type: Object },
    items: { type: Array },
    loading: { type: Boolean },
    loadingElementNumber: { type: Number },
    editable: { type: Boolean },
    deletable: { type: Boolean },
    viewable: { type: Boolean },
    maxHeight: { type: String, default: "100%" },
    enablePagination: { type: Boolean, default: !0 },
    emptyIcon: {
      type: Function,
      default: Wf
    },
    emptyTitle: { type: String, default: "Aucun résultat" },
    emptyDescription: { type: String, default: "Commencez par créer une donnée." },
    emptyButtonName: { type: String, default: "" }
  },
  components: { Pagination: zn, Button: Pe, DocumentMagnifyingGlassIcon: Wf, PlusIcon: pt },
  setup(u, { emit: e }) {
    const { pagination: D } = A0(), f = () => {
      e("empty-button-action");
    };
    return { data: w(
      () => u.items || u.paginationResult && u.paginationResult.items || []
    ), pagination: D, emptyButtonAction: f };
  }
}), Wn = { class: "flex flex-col" }, qn = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }, Yn = { class: "pb-2 sm:py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }, Hn = { class: "min-w-full" }, Gn = {
  key: 0,
  class: "bg-gray-50"
}, Xn = /* @__PURE__ */ v("span", { class: "sr-only" }, "Modifier", -1), Zn = [
  Xn
], Kn = {
  key: 1,
  class: "bg-white divide-y divide-gray-200"
}, Qn = /* @__PURE__ */ v("div", { class: "h-9 flex items-center" }, [
  /* @__PURE__ */ v("div", { class: "animate-pulse h-3 bg-gray-200 rounded w-3/4" })
], -1), Jn = [
  Qn
], uo = /* @__PURE__ */ v("td", { class: "py-3.5 pl-3 pr-6 relative whitespace-nowrap text-right text-sm font-medium" }, null, -1), eo = {
  key: 2,
  class: "bg-white divide-y divide-gray-200"
}, Do = { key: 1 }, fo = { class: "pl-3 pr-6 relative whitespace-nowrap text-right text-sm font-medium space-x-2" }, to = { key: 0 }, ao = ["colspan"], no = { class: "text-center py-8" }, oo = { class: "mt-2 text-sm font-medium text-gray-900" }, ro = { class: "mt-1 text-sm text-gray-500" };
function lo(u, e, D, f, t, n) {
  const a = P("Button"), o = P("PlusIcon"), r = P("Pagination");
  return E(), y("div", Wn, [
    v("div", qn, [
      v("div", Yn, [
        v("div", {
          style: re({ "max-height": u.maxHeight }),
          class: "shadow overflow-auto border-gray-500 sm:rounded-lg ring-1 ring-black ring-opacity-5"
        }, [
          v("table", Hn, [
            u.loading || u.data.length > 0 ? (E(), y("thead", Gn, [
              v("tr", null, [
                (E(!0), y(J, null, du(u.header, (l, i) => (E(), y("th", {
                  key: l.key,
                  class: M([[
                    l.classes,
                    {
                      "sticky top-0 z-20 bg-gray-50": u.maxHeight !== "100%",
                      "pl-6 pr-3": i === 0,
                      "px-3": i > 0
                    }
                  ], "py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"]),
                  style: re([
                    { "max-width": l.maxWidth },
                    "box-shadow: inset 0 0 0 rgba(229, 231, 235, var(--tw-border-opacity)),inset 0 -1px 0 rgba(229, 231, 235, var(--tw-border-opacity));"
                  ]),
                  scope: "col"
                }, [
                  v("div", {
                    class: M({ "text-left": u.loading })
                  }, O(l.name), 3)
                ], 6))), 128)),
                v("th", {
                  class: M([{ "sticky top-0 z-20 bg-gray-50": u.maxHeight !== "100%" }, "relative py-3.5 pl-3 pr-6"]),
                  style: re([
                    "box-shadow: inset 0 0 0 rgba(229, 231, 235, var(--tw-border-opacity)),inset 0 -1px 0 rgba(229, 231, 235, var(--tw-border-opacity));"
                  ]),
                  scope: "col"
                }, Zn, 2)
              ])
            ])) : R("", !0),
            u.loading ? (E(), y("tbody", Kn, [
              (E(!0), y(J, null, du(u.loadingElementNumber || u.pagination.limit, (l) => (E(), y("tr", { key: l }, [
                (E(!0), y(J, null, du(u.header, (i, s) => (E(), y("td", {
                  key: i.key,
                  class: M([[
                    i.classes,
                    {
                      "py-4 pl-6 pr-3 text-gray-900 font-medium": s === 0,
                      "px-3 py-4 text-gray-500": s > 0
                    }
                  ], "py-3.5 whitespace-nowrap text-sm font-medium text-gray-900"]),
                  style: re({ "max-width": i.maxWidth })
                }, Jn, 6))), 128)),
                uo
              ]))), 128))
            ])) : (E(), y("tbody", eo, [
              (E(!0), y(J, null, du(u.data, (l) => (E(), y("tr", {
                key: l.id
              }, [
                (E(!0), y(J, null, du(u.header, (i, s) => (E(), y("td", {
                  key: i.key,
                  class: M([[
                    i.classes,
                    {
                      "py-4 pl-6 pr-3 text-gray-900 font-medium": s === 0,
                      "px-3 py-4 text-gray-500": s > 0
                    }
                  ], "text-sm"]),
                  style: re({ "max-width": i.maxWidth })
                }, [
                  u.$slots[i.key] ? fu(u.$slots, i.key, {
                    key: i.key,
                    item: l,
                    items: u.data,
                    value: l[i.key]
                  }) : (E(), y("span", Do, O(i.key.split(".").reduce((d, g) => d[g], l)), 1))
                ], 6))), 128)),
                v("td", fo, [
                  u.deletable ? (E(), q(a, {
                    key: 0,
                    type: "text",
                    onClick: (i) => u.$emit("delete", l.id)
                  }, {
                    default: N(() => [
                      G("Supprimer ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : R("", !0),
                  u.editable ? (E(), q(a, {
                    key: 1,
                    type: "text",
                    onClick: (i) => u.$emit("edit", l.id)
                  }, {
                    default: N(() => [
                      G("Modifier")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : R("", !0),
                  u.viewable ? (E(), q(a, {
                    key: 2,
                    type: "text",
                    onClick: (i) => u.$emit("view", l.id)
                  }, {
                    default: N(() => [
                      G("Voir")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : R("", !0)
                ])
              ]))), 128)),
              !u.loading && u.data.length === 0 ? (E(), y("tr", to, [
                v("td", {
                  colspan: u.header.length + 1,
                  class: "py-4 pl-6 pr-3"
                }, [
                  v("div", no, [
                    (E(), q(xu(u.emptyIcon), { class: "mx-auto h-12 w-12 text-gray-400 stroke-1" })),
                    v("h3", oo, O(u.emptyTitle), 1),
                    v("p", ro, O(u.emptyDescription), 1),
                    u.emptyButtonName ? (E(), q(a, {
                      key: 0,
                      class: "mt-3",
                      color: "primary",
                      size: "sm",
                      onClick: u.emptyButtonAction
                    }, {
                      "icon-before": N(() => [
                        U(o)
                      ]),
                      default: N(() => [
                        G(" " + O(u.emptyButtonName), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])) : R("", !0)
                  ])
                ], 8, ao)
              ])) : R("", !0)
            ]))
          ]),
          u.enablePagination && (u.loading || u.data.length !== 0) && u.paginationResult ? (E(), q(r, {
            key: 0,
            class: M({ "sticky bottom-0": u.maxHeight !== "100%" }),
            "has-more": u.paginationResult.hasMore,
            loading: u.loading,
            "next-offset": u.paginationResult.nextOffset,
            "page-size": u.paginationResult.pageSize,
            "previous-offset": u.paginationResult.previousOffset,
            total: u.paginationResult.total
          }, null, 8, ["class", "has-more", "loading", "next-offset", "page-size", "previous-offset", "total"])) : R("", !0)
        ], 4)
      ])
    ])
  ]);
}
const Kc = /* @__PURE__ */ Q(Un, [["render", lo]]), io = z({
  components: { Popover: Af, PopoverButton: F0, PopoverPanel: C0 },
  props: {
    position: {
      type: String,
      default: () => "top",
      validator: (u) => ["top", "bottom"].includes(u)
    }
  },
  setup() {
    return {
      isOpen: I(!1)
    };
  }
}), so = { class: "overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 p-4" };
function co(u, e, D, f, t, n) {
  const a = P("PopoverButton"), o = P("PopoverPanel"), r = P("Popover");
  return E(), q(r, { class: "align-middle inline relative z-20" }, {
    default: N(() => [
      U(a, {
        class: "focus:outline-none",
        onMouseenter: e[0] || (e[0] = (l) => u.isOpen = !0),
        onMouseleave: e[1] || (e[1] = (l) => u.isOpen = !1)
      }, {
        default: N(() => [
          fu(u.$slots, "trigger")
        ]),
        _: 3
      }),
      v("div", {
        class: M([{
          "sm:bottom-full sm:left-1/2 sm:-translate-x-1/2": u.position === "top",
          "sm:top-full sm:left-1/2 sm:-translate-x-1/2": u.position === "bottom"
        }, "relative sm:absolute sm:z-50 sm:transform sm:w-screen max-w-sm"])
      }, [
        U(_e, {
          "enter-active-class": "delay-200 transition duration-200 ease-out",
          "enter-from-class": "translate-y-1 opacity-0",
          "enter-to-class": "translate-y-0 opacity-100",
          "leave-active-class": "delay-200 transition duration-150 ease-in",
          "leave-from-class": "translate-y-0 opacity-100",
          "leave-to-class": "translate-y-1 opacity-0"
        }, {
          default: N(() => [
            u.isOpen ? (E(), q(o, {
              key: 0,
              class: M([{
                "bottom-full mb-10 sm:mb-3 left-1/2 -translate-x-1/2": u.position === "top",
                "top-full left-1/2 -translate-x-1/2": u.position === "bottom"
              }, "absolute sm:static sm:left-auto sm:translate-x-0 z-50 bg-white w-full transform"]),
              static: ""
            }, {
              default: N(() => [
                v("div", so, [
                  fu(u.$slots, "content")
                ])
              ]),
              _: 3
            }, 8, ["class"])) : R("", !0)
          ]),
          _: 3
        })
      ], 2)
    ]),
    _: 3
  });
}
const Pf = /* @__PURE__ */ Q(io, [["render", co]]), Fo = z({
  emits: ["update:modelValue", "update-batch"],
  props: {
    name: { type: String, required: !0 },
    label: { type: String },
    modelValue: { type: Boolean, default: !1 },
    hideValidationError: { type: Boolean, default: !1 },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        }
      })
    },
    validations: { type: Object, default: () => ({}) },
    uuid: {
      type: Number,
      default: 0
    },
    component: {
      type: Object
    },
    model: {
      type: String
    },
    class: {
      type: String
    },
    disabled: { type: Boolean }
  },
  setup(u, { emit: e }) {
    return { updateModelValue: (f) => {
      const t = f.target;
      e("update:modelValue", t.checked);
    } };
  }
}), Co = { class: "flex items-center" }, Eo = ["id", "checked", "disabled", "name", "required"], mo = ["for"], po = {
  key: 0,
  class: "mt-1 min-h-5 text-red-600 text-xs"
};
function bo(u, e, D, f, t, n) {
  return E(), y("div", null, [
    v("div", Co, [
      v("input", {
        id: u.name,
        checked: u.modelValue,
        class: M([
          { "opacity-50 cursor-not-allowed": u.disabled },
          "h-4 w-4 text-primary-400 focus:ring-primary-400 border-gray-300 rounded"
        ]),
        disabled: u.disabled,
        name: u.name,
        required: u.validations.required,
        type: "checkbox",
        onBlur: e[0] || (e[0] = (a) => u.validation.setTouched(!0)),
        onInput: e[1] || (e[1] = (...a) => u.updateModelValue && u.updateModelValue(...a))
      }, null, 42, Eo),
      v("label", {
        class: M([{ "opacity-50 cursor-not-allowed": u.disabled }, "ml-2 block text-sm text-gray-700"]),
        for: u.name
      }, O(u.label), 11, mo)
    ]),
    u.hideValidationError ? R("", !0) : (E(), y("p", po, O(u.validation.errorMessage), 1))
  ]);
}
const Qc = /* @__PURE__ */ Q(Fo, [["render", bo]]), go = z({
  emits: ["update:modelValue", "update-batch"],
  props: {
    name: { type: String, required: !0 },
    label: { type: String },
    link: { type: String },
    secondLabel: { type: String },
    secondLink: { type: String },
    modelValue: { type: Boolean, default: !1 },
    hideValidationError: { type: Boolean, default: !1 },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        }
      })
    },
    validations: { type: Object, default: () => ({}) },
    uuid: {
      type: Number,
      default: 0
    },
    component: {
      type: Object
    },
    model: {
      type: String
    },
    class: {
      type: String
    },
    disabled: { type: Boolean }
  },
  setup(u, { emit: e }) {
    return { updateModelValue: (f) => {
      const t = f.target;
      e("update:modelValue", t.checked);
    } };
  }
}), vo = { class: "flex items-center" }, ho = ["id", "checked", "disabled", "name", "required"], Bo = ["for"], yo = ["href"], _o = ["href"], wo = {
  key: 0,
  class: "mt-1 min-h-5 text-red-600 text-xs"
};
function ko(u, e, D, f, t, n) {
  return E(), y("div", null, [
    v("div", vo, [
      v("input", {
        id: u.name,
        checked: u.modelValue,
        class: M([
          { "opacity-50 cursor-not-allowed": u.disabled },
          "h-4 w-4 text-primary-400 focus:ring-primary-400 border-gray-300 rounded"
        ]),
        disabled: u.disabled,
        name: u.name,
        required: u.validations.required,
        type: "checkbox",
        onBlur: e[0] || (e[0] = (a) => u.validation.setTouched(!0)),
        onInput: e[1] || (e[1] = (...a) => u.updateModelValue && u.updateModelValue(...a))
      }, null, 42, ho),
      v("label", {
        class: M([{ "opacity-50 cursor-not-allowed": u.disabled }, "ml-2 block text-sm text-gray-700"]),
        for: u.name
      }, [
        G(" J'accepte les "),
        v("a", {
          href: u.link,
          class: "font-medium text-primary-400 hover:text-primary-500 underline",
          target: "_blank"
        }, O(u.label), 9, yo),
        u.secondLink && u.secondLabel ? (E(), y(J, { key: 0 }, [
          G(" et les "),
          v("a", {
            href: u.secondLink,
            class: "font-medium text-primary-400 hover:text-primary-500 underline",
            target: "_blank"
          }, O(u.secondLabel), 9, _o)
        ], 64)) : R("", !0)
      ], 10, Bo)
    ]),
    u.hideValidationError ? R("", !0) : (E(), y("p", wo, O(u.validation.errorMessage), 1))
  ]);
}
const Jc = /* @__PURE__ */ Q(go, [["render", ko]]);
function Ge(u) {
  "@babel/helpers - typeof";
  return Ge = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ge(u);
}
function de(u) {
  if (u === null || u === !0 || u === !1)
    return NaN;
  var e = Number(u);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function mu(u, e) {
  if (e.length < u)
    throw new TypeError(u + " argument" + (u > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function Fu(u) {
  mu(1, arguments);
  var e = Object.prototype.toString.call(u);
  return u instanceof Date || Ge(u) === "object" && e === "[object Date]" ? new Date(u.getTime()) : typeof u == "number" || e === "[object Number]" ? new Date(u) : ((typeof u == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Ao(u, e) {
  mu(2, arguments);
  var D = Fu(u).getTime(), f = de(e);
  return new Date(D + f);
}
var xo = {};
function Re() {
  return xo;
}
function ID(u) {
  var e = new Date(Date.UTC(u.getFullYear(), u.getMonth(), u.getDate(), u.getHours(), u.getMinutes(), u.getSeconds(), u.getMilliseconds()));
  return e.setUTCFullYear(u.getFullYear()), u.getTime() - e.getTime();
}
function Ye(u, e) {
  mu(2, arguments);
  var D = Fu(u), f = Fu(e), t = D.getTime() - f.getTime();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function $o(u) {
  return mu(1, arguments), u instanceof Date || Ge(u) === "object" && Object.prototype.toString.call(u) === "[object Date]";
}
function So(u) {
  if (mu(1, arguments), !$o(u) && typeof u != "number")
    return !1;
  var e = Fu(u);
  return !isNaN(Number(e));
}
function To(u, e) {
  mu(2, arguments);
  var D = Fu(u), f = Fu(e), t = D.getFullYear() - f.getFullYear(), n = D.getMonth() - f.getMonth();
  return t * 12 + n;
}
function Mo(u, e) {
  return mu(2, arguments), Fu(u).getTime() - Fu(e).getTime();
}
var t1 = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
  }
  // Math.trunc is not supported by IE
}, Oo = "trunc";
function Io(u) {
  return u ? t1[u] : t1[Oo];
}
function Po(u) {
  mu(1, arguments);
  var e = Fu(u);
  return e.setHours(23, 59, 59, 999), e;
}
function Lo(u) {
  mu(1, arguments);
  var e = Fu(u), D = e.getMonth();
  return e.setFullYear(e.getFullYear(), D + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function Ro(u) {
  mu(1, arguments);
  var e = Fu(u);
  return Po(e).getTime() === Lo(e).getTime();
}
function No(u, e) {
  mu(2, arguments);
  var D = Fu(u), f = Fu(e), t = Ye(D, f), n = Math.abs(To(D, f)), a;
  if (n < 1)
    a = 0;
  else {
    D.getMonth() === 1 && D.getDate() > 27 && D.setDate(30), D.setMonth(D.getMonth() - t * n);
    var o = Ye(D, f) === -t;
    Ro(Fu(u)) && n === 1 && Ye(u, f) === 1 && (o = !1), a = t * (n - Number(o));
  }
  return a === 0 ? 0 : a;
}
function jo(u, e, D) {
  mu(2, arguments);
  var f = Mo(u, e) / 1e3;
  return Io(void 0)(f);
}
function Vo(u, e) {
  mu(2, arguments);
  var D = de(e);
  return Ao(u, -D);
}
var zo = 864e5;
function Uo(u) {
  mu(1, arguments);
  var e = Fu(u), D = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var f = e.getTime(), t = D - f;
  return Math.floor(t / zo) + 1;
}
function Xe(u) {
  mu(1, arguments);
  var e = 1, D = Fu(u), f = D.getUTCDay(), t = (f < e ? 7 : 0) + f - e;
  return D.setUTCDate(D.getUTCDate() - t), D.setUTCHours(0, 0, 0, 0), D;
}
function x0(u) {
  mu(1, arguments);
  var e = Fu(u), D = e.getUTCFullYear(), f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(D + 1, 0, 4), f.setUTCHours(0, 0, 0, 0);
  var t = Xe(f), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(D, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = Xe(n);
  return e.getTime() >= t.getTime() ? D + 1 : e.getTime() >= a.getTime() ? D : D - 1;
}
function Wo(u) {
  mu(1, arguments);
  var e = x0(u), D = /* @__PURE__ */ new Date(0);
  D.setUTCFullYear(e, 0, 4), D.setUTCHours(0, 0, 0, 0);
  var f = Xe(D);
  return f;
}
var qo = 6048e5;
function Yo(u) {
  mu(1, arguments);
  var e = Fu(u), D = Xe(e).getTime() - Wo(e).getTime();
  return Math.round(D / qo) + 1;
}
function Ze(u, e) {
  var D, f, t, n, a, o, r, l;
  mu(1, arguments);
  var i = Re(), s = de((D = (f = (t = (n = e == null ? void 0 : e.weekStartsOn) !== null && n !== void 0 ? n : e == null || (a = e.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && t !== void 0 ? t : i.weekStartsOn) !== null && f !== void 0 ? f : (r = i.locale) === null || r === void 0 || (l = r.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && D !== void 0 ? D : 0);
  if (!(s >= 0 && s <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = Fu(u), g = d.getUTCDay(), h = (g < s ? 7 : 0) + g - s;
  return d.setUTCDate(d.getUTCDate() - h), d.setUTCHours(0, 0, 0, 0), d;
}
function $0(u, e) {
  var D, f, t, n, a, o, r, l;
  mu(1, arguments);
  var i = Fu(u), s = i.getUTCFullYear(), d = Re(), g = de((D = (f = (t = (n = e == null ? void 0 : e.firstWeekContainsDate) !== null && n !== void 0 ? n : e == null || (a = e.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && t !== void 0 ? t : d.firstWeekContainsDate) !== null && f !== void 0 ? f : (r = d.locale) === null || r === void 0 || (l = r.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && D !== void 0 ? D : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(s + 1, 0, g), h.setUTCHours(0, 0, 0, 0);
  var _ = Ze(h, e), C = /* @__PURE__ */ new Date(0);
  C.setUTCFullYear(s, 0, g), C.setUTCHours(0, 0, 0, 0);
  var p = Ze(C, e);
  return i.getTime() >= _.getTime() ? s + 1 : i.getTime() >= p.getTime() ? s : s - 1;
}
function Ho(u, e) {
  var D, f, t, n, a, o, r, l;
  mu(1, arguments);
  var i = Re(), s = de((D = (f = (t = (n = e == null ? void 0 : e.firstWeekContainsDate) !== null && n !== void 0 ? n : e == null || (a = e.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && t !== void 0 ? t : i.firstWeekContainsDate) !== null && f !== void 0 ? f : (r = i.locale) === null || r === void 0 || (l = r.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && D !== void 0 ? D : 1), d = $0(u, e), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d, 0, s), g.setUTCHours(0, 0, 0, 0);
  var h = Ze(g, e);
  return h;
}
var Go = 6048e5;
function Xo(u, e) {
  mu(1, arguments);
  var D = Fu(u), f = Ze(D, e).getTime() - Ho(D, e).getTime();
  return Math.round(f / Go) + 1;
}
function iu(u, e) {
  for (var D = u < 0 ? "-" : "", f = Math.abs(u).toString(); f.length < e; )
    f = "0" + f;
  return D + f;
}
var Ku = {
  // Year
  y: function(e, D) {
    var f = e.getUTCFullYear(), t = f > 0 ? f : 1 - f;
    return iu(D === "yy" ? t % 100 : t, D.length);
  },
  // Month
  M: function(e, D) {
    var f = e.getUTCMonth();
    return D === "M" ? String(f + 1) : iu(f + 1, 2);
  },
  // Day of the month
  d: function(e, D) {
    return iu(e.getUTCDate(), D.length);
  },
  // AM or PM
  a: function(e, D) {
    var f = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (D) {
      case "a":
      case "aa":
        return f.toUpperCase();
      case "aaa":
        return f;
      case "aaaaa":
        return f[0];
      case "aaaa":
      default:
        return f === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, D) {
    return iu(e.getUTCHours() % 12 || 12, D.length);
  },
  // Hour [0-23]
  H: function(e, D) {
    return iu(e.getUTCHours(), D.length);
  },
  // Minute
  m: function(e, D) {
    return iu(e.getUTCMinutes(), D.length);
  },
  // Second
  s: function(e, D) {
    return iu(e.getUTCSeconds(), D.length);
  },
  // Fraction of second
  S: function(e, D) {
    var f = D.length, t = e.getUTCMilliseconds(), n = Math.floor(t * Math.pow(10, f - 3));
    return iu(n, D.length);
  }
}, me = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Zo = {
  // Era
  G: function(e, D, f) {
    var t = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (D) {
      case "G":
      case "GG":
      case "GGG":
        return f.era(t, {
          width: "abbreviated"
        });
      case "GGGGG":
        return f.era(t, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return f.era(t, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, D, f) {
    if (D === "yo") {
      var t = e.getUTCFullYear(), n = t > 0 ? t : 1 - t;
      return f.ordinalNumber(n, {
        unit: "year"
      });
    }
    return Ku.y(e, D);
  },
  // Local week-numbering year
  Y: function(e, D, f, t) {
    var n = $0(e, t), a = n > 0 ? n : 1 - n;
    if (D === "YY") {
      var o = a % 100;
      return iu(o, 2);
    }
    return D === "Yo" ? f.ordinalNumber(a, {
      unit: "year"
    }) : iu(a, D.length);
  },
  // ISO week-numbering year
  R: function(e, D) {
    var f = x0(e);
    return iu(f, D.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, D) {
    var f = e.getUTCFullYear();
    return iu(f, D.length);
  },
  // Quarter
  Q: function(e, D, f) {
    var t = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (D) {
      case "Q":
        return String(t);
      case "QQ":
        return iu(t, 2);
      case "Qo":
        return f.ordinalNumber(t, {
          unit: "quarter"
        });
      case "QQQ":
        return f.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return f.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return f.quarter(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, D, f) {
    var t = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (D) {
      case "q":
        return String(t);
      case "qq":
        return iu(t, 2);
      case "qo":
        return f.ordinalNumber(t, {
          unit: "quarter"
        });
      case "qqq":
        return f.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return f.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return f.quarter(t, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, D, f) {
    var t = e.getUTCMonth();
    switch (D) {
      case "M":
      case "MM":
        return Ku.M(e, D);
      case "Mo":
        return f.ordinalNumber(t + 1, {
          unit: "month"
        });
      case "MMM":
        return f.month(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return f.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return f.month(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, D, f) {
    var t = e.getUTCMonth();
    switch (D) {
      case "L":
        return String(t + 1);
      case "LL":
        return iu(t + 1, 2);
      case "Lo":
        return f.ordinalNumber(t + 1, {
          unit: "month"
        });
      case "LLL":
        return f.month(t, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return f.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return f.month(t, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, D, f, t) {
    var n = Xo(e, t);
    return D === "wo" ? f.ordinalNumber(n, {
      unit: "week"
    }) : iu(n, D.length);
  },
  // ISO week of year
  I: function(e, D, f) {
    var t = Yo(e);
    return D === "Io" ? f.ordinalNumber(t, {
      unit: "week"
    }) : iu(t, D.length);
  },
  // Day of the month
  d: function(e, D, f) {
    return D === "do" ? f.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Ku.d(e, D);
  },
  // Day of year
  D: function(e, D, f) {
    var t = Uo(e);
    return D === "Do" ? f.ordinalNumber(t, {
      unit: "dayOfYear"
    }) : iu(t, D.length);
  },
  // Day of week
  E: function(e, D, f) {
    var t = e.getUTCDay();
    switch (D) {
      case "E":
      case "EE":
      case "EEE":
        return f.day(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return f.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return f.day(t, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return f.day(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, D, f, t) {
    var n = e.getUTCDay(), a = (n - t.weekStartsOn + 8) % 7 || 7;
    switch (D) {
      case "e":
        return String(a);
      case "ee":
        return iu(a, 2);
      case "eo":
        return f.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return f.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return f.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return f.day(n, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return f.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, D, f, t) {
    var n = e.getUTCDay(), a = (n - t.weekStartsOn + 8) % 7 || 7;
    switch (D) {
      case "c":
        return String(a);
      case "cc":
        return iu(a, D.length);
      case "co":
        return f.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return f.day(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return f.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return f.day(n, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return f.day(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, D, f) {
    var t = e.getUTCDay(), n = t === 0 ? 7 : t;
    switch (D) {
      case "i":
        return String(n);
      case "ii":
        return iu(n, D.length);
      case "io":
        return f.ordinalNumber(n, {
          unit: "day"
        });
      case "iii":
        return f.day(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return f.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return f.day(t, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return f.day(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, D, f) {
    var t = e.getUTCHours(), n = t / 12 >= 1 ? "pm" : "am";
    switch (D) {
      case "a":
      case "aa":
        return f.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return f.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return f.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return f.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, D, f) {
    var t = e.getUTCHours(), n;
    switch (t === 12 ? n = me.noon : t === 0 ? n = me.midnight : n = t / 12 >= 1 ? "pm" : "am", D) {
      case "b":
      case "bb":
        return f.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return f.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return f.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return f.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, D, f) {
    var t = e.getUTCHours(), n;
    switch (t >= 17 ? n = me.evening : t >= 12 ? n = me.afternoon : t >= 4 ? n = me.morning : n = me.night, D) {
      case "B":
      case "BB":
      case "BBB":
        return f.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return f.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return f.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, D, f) {
    if (D === "ho") {
      var t = e.getUTCHours() % 12;
      return t === 0 && (t = 12), f.ordinalNumber(t, {
        unit: "hour"
      });
    }
    return Ku.h(e, D);
  },
  // Hour [0-23]
  H: function(e, D, f) {
    return D === "Ho" ? f.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Ku.H(e, D);
  },
  // Hour [0-11]
  K: function(e, D, f) {
    var t = e.getUTCHours() % 12;
    return D === "Ko" ? f.ordinalNumber(t, {
      unit: "hour"
    }) : iu(t, D.length);
  },
  // Hour [1-24]
  k: function(e, D, f) {
    var t = e.getUTCHours();
    return t === 0 && (t = 24), D === "ko" ? f.ordinalNumber(t, {
      unit: "hour"
    }) : iu(t, D.length);
  },
  // Minute
  m: function(e, D, f) {
    return D === "mo" ? f.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Ku.m(e, D);
  },
  // Second
  s: function(e, D, f) {
    return D === "so" ? f.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Ku.s(e, D);
  },
  // Fraction of second
  S: function(e, D) {
    return Ku.S(e, D);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, D, f, t) {
    var n = t._originalDate || e, a = n.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (D) {
      case "X":
        return n1(a);
      case "XXXX":
      case "XX":
        return oe(a);
      case "XXXXX":
      case "XXX":
      default:
        return oe(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, D, f, t) {
    var n = t._originalDate || e, a = n.getTimezoneOffset();
    switch (D) {
      case "x":
        return n1(a);
      case "xxxx":
      case "xx":
        return oe(a);
      case "xxxxx":
      case "xxx":
      default:
        return oe(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, D, f, t) {
    var n = t._originalDate || e, a = n.getTimezoneOffset();
    switch (D) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + a1(a, ":");
      case "OOOO":
      default:
        return "GMT" + oe(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, D, f, t) {
    var n = t._originalDate || e, a = n.getTimezoneOffset();
    switch (D) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + a1(a, ":");
      case "zzzz":
      default:
        return "GMT" + oe(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, D, f, t) {
    var n = t._originalDate || e, a = Math.floor(n.getTime() / 1e3);
    return iu(a, D.length);
  },
  // Milliseconds timestamp
  T: function(e, D, f, t) {
    var n = t._originalDate || e, a = n.getTime();
    return iu(a, D.length);
  }
};
function a1(u, e) {
  var D = u > 0 ? "-" : "+", f = Math.abs(u), t = Math.floor(f / 60), n = f % 60;
  if (n === 0)
    return D + String(t);
  var a = e;
  return D + String(t) + a + iu(n, 2);
}
function n1(u, e) {
  if (u % 60 === 0) {
    var D = u > 0 ? "-" : "+";
    return D + iu(Math.abs(u) / 60, 2);
  }
  return oe(u, e);
}
function oe(u, e) {
  var D = e || "", f = u > 0 ? "-" : "+", t = Math.abs(u), n = iu(Math.floor(t / 60), 2), a = iu(t % 60, 2);
  return f + n + D + a;
}
var o1 = function(e, D) {
  switch (e) {
    case "P":
      return D.date({
        width: "short"
      });
    case "PP":
      return D.date({
        width: "medium"
      });
    case "PPP":
      return D.date({
        width: "long"
      });
    case "PPPP":
    default:
      return D.date({
        width: "full"
      });
  }
}, S0 = function(e, D) {
  switch (e) {
    case "p":
      return D.time({
        width: "short"
      });
    case "pp":
      return D.time({
        width: "medium"
      });
    case "ppp":
      return D.time({
        width: "long"
      });
    case "pppp":
    default:
      return D.time({
        width: "full"
      });
  }
}, Ko = function(e, D) {
  var f = e.match(/(P+)(p+)?/) || [], t = f[1], n = f[2];
  if (!n)
    return o1(e, D);
  var a;
  switch (t) {
    case "P":
      a = D.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = D.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = D.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = D.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", o1(t, D)).replace("{{time}}", S0(n, D));
}, Qo = {
  p: S0,
  P: Ko
}, Jo = ["D", "DD"], ur = ["YY", "YYYY"];
function er(u) {
  return Jo.indexOf(u) !== -1;
}
function Dr(u) {
  return ur.indexOf(u) !== -1;
}
function r1(u, e, D) {
  if (u === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(D, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (u === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(D, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (u === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(D, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (u === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(D, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var fr = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, tr = function(e, D, f) {
  var t, n = fr[e];
  return typeof n == "string" ? t = n : D === 1 ? t = n.one : t = n.other.replace("{{count}}", D.toString()), f != null && f.addSuffix ? f.comparison && f.comparison > 0 ? "in " + t : t + " ago" : t;
};
function be(u) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, D = e.width ? String(e.width) : u.defaultWidth, f = u.formats[D] || u.formats[u.defaultWidth];
    return f;
  };
}
var ar = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, nr = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, or = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, rr = {
  date: be({
    formats: ar,
    defaultWidth: "full"
  }),
  time: be({
    formats: nr,
    defaultWidth: "full"
  }),
  dateTime: be({
    formats: or,
    defaultWidth: "full"
  })
}, lr = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ir = function(e, D, f, t) {
  return lr[e];
};
function Vu(u) {
  return function(e, D) {
    var f = D != null && D.context ? String(D.context) : "standalone", t;
    if (f === "formatting" && u.formattingValues) {
      var n = u.defaultFormattingWidth || u.defaultWidth, a = D != null && D.width ? String(D.width) : n;
      t = u.formattingValues[a] || u.formattingValues[n];
    } else {
      var o = u.defaultWidth, r = D != null && D.width ? String(D.width) : u.defaultWidth;
      t = u.values[r] || u.values[o];
    }
    var l = u.argumentCallback ? u.argumentCallback(e) : e;
    return t[l];
  };
}
var dr = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, sr = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, cr = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Fr = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Cr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Er = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, mr = function(e, D) {
  var f = Number(e), t = f % 100;
  if (t > 20 || t < 10)
    switch (t % 10) {
      case 1:
        return f + "st";
      case 2:
        return f + "nd";
      case 3:
        return f + "rd";
    }
  return f + "th";
}, pr = {
  ordinalNumber: mr,
  era: Vu({
    values: dr,
    defaultWidth: "wide"
  }),
  quarter: Vu({
    values: sr,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Vu({
    values: cr,
    defaultWidth: "wide"
  }),
  day: Vu({
    values: Fr,
    defaultWidth: "wide"
  }),
  dayPeriod: Vu({
    values: Cr,
    defaultWidth: "wide",
    formattingValues: Er,
    defaultFormattingWidth: "wide"
  })
};
function zu(u) {
  return function(e) {
    var D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, f = D.width, t = f && u.matchPatterns[f] || u.matchPatterns[u.defaultMatchWidth], n = e.match(t);
    if (!n)
      return null;
    var a = n[0], o = f && u.parsePatterns[f] || u.parsePatterns[u.defaultParseWidth], r = Array.isArray(o) ? gr(o, function(s) {
      return s.test(a);
    }) : br(o, function(s) {
      return s.test(a);
    }), l;
    l = u.valueCallback ? u.valueCallback(r) : r, l = D.valueCallback ? D.valueCallback(l) : l;
    var i = e.slice(a.length);
    return {
      value: l,
      rest: i
    };
  };
}
function br(u, e) {
  for (var D in u)
    if (u.hasOwnProperty(D) && e(u[D]))
      return D;
}
function gr(u, e) {
  for (var D = 0; D < u.length; D++)
    if (e(u[D]))
      return D;
}
function T0(u) {
  return function(e) {
    var D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, f = e.match(u.matchPattern);
    if (!f)
      return null;
    var t = f[0], n = e.match(u.parsePattern);
    if (!n)
      return null;
    var a = u.valueCallback ? u.valueCallback(n[0]) : n[0];
    a = D.valueCallback ? D.valueCallback(a) : a;
    var o = e.slice(t.length);
    return {
      value: a,
      rest: o
    };
  };
}
var vr = /^(\d+)(th|st|nd|rd)?/i, hr = /\d+/i, Br = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, yr = {
  any: [/^b/i, /^(a|c)/i]
}, _r = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, wr = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kr = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ar = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, xr = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $r = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Sr = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Tr = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Mr = {
  ordinalNumber: T0({
    matchPattern: vr,
    parsePattern: hr,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: zu({
    matchPatterns: Br,
    defaultMatchWidth: "wide",
    parsePatterns: yr,
    defaultParseWidth: "any"
  }),
  quarter: zu({
    matchPatterns: _r,
    defaultMatchWidth: "wide",
    parsePatterns: wr,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: zu({
    matchPatterns: kr,
    defaultMatchWidth: "wide",
    parsePatterns: Ar,
    defaultParseWidth: "any"
  }),
  day: zu({
    matchPatterns: xr,
    defaultMatchWidth: "wide",
    parsePatterns: $r,
    defaultParseWidth: "any"
  }),
  dayPeriod: zu({
    matchPatterns: Sr,
    defaultMatchWidth: "any",
    parsePatterns: Tr,
    defaultParseWidth: "any"
  })
}, M0 = {
  code: "en-US",
  formatDistance: tr,
  formatLong: rr,
  formatRelative: ir,
  localize: pr,
  match: Mr,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Or = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ir = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Pr = /^'([^]*?)'?$/, Lr = /''/g, Rr = /[a-zA-Z]/;
function Ue(u, e, D) {
  var f, t, n, a, o, r, l, i, s, d, g, h, _, C;
  mu(2, arguments);
  var p = String(e), b = Re(), m = (f = (t = void 0) !== null && t !== void 0 ? t : b.locale) !== null && f !== void 0 ? f : M0, F = de((n = (a = (o = (r = void 0) !== null && r !== void 0 ? r : void 0) !== null && o !== void 0 ? o : b.firstWeekContainsDate) !== null && a !== void 0 ? a : (l = b.locale) === null || l === void 0 || (i = l.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(F >= 1 && F <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c = de((s = (d = (g = (h = void 0) !== null && h !== void 0 ? h : void 0) !== null && g !== void 0 ? g : b.weekStartsOn) !== null && d !== void 0 ? d : (_ = b.locale) === null || _ === void 0 || (C = _.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && s !== void 0 ? s : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!m.localize)
    throw new RangeError("locale must contain localize property");
  if (!m.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var B = Fu(u);
  if (!So(B))
    throw new RangeError("Invalid time value");
  var k = ID(B), A = Vo(B, k), j = {
    firstWeekContainsDate: F,
    weekStartsOn: c,
    locale: m,
    _originalDate: B
  }, T = p.match(Ir).map(function(S) {
    var W = S[0];
    if (W === "p" || W === "P") {
      var L = Qo[W];
      return L(S, m.formatLong);
    }
    return S;
  }).join("").match(Or).map(function(S) {
    if (S === "''")
      return "'";
    var W = S[0];
    if (W === "'")
      return Nr(S);
    var L = Zo[W];
    if (L)
      return Dr(S) && r1(S, e, String(u)), er(S) && r1(S, e, String(u)), L(A, S, m.localize, j);
    if (W.match(Rr))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + W + "`");
    return S;
  }).join("");
  return T;
}
function Nr(u) {
  var e = u.match(Pr);
  return e ? e[1].replace(Lr, "'") : u;
}
function O0(u, e) {
  if (u == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var D in e)
    Object.prototype.hasOwnProperty.call(e, D) && (u[D] = e[D]);
  return u;
}
function jr(u) {
  return O0({}, u);
}
var l1 = 1440, Vr = 2520, gD = 43200, zr = 86400;
function Ur(u, e, D) {
  var f, t;
  mu(2, arguments);
  var n = Re(), a = (f = (t = D == null ? void 0 : D.locale) !== null && t !== void 0 ? t : n.locale) !== null && f !== void 0 ? f : M0;
  if (!a.formatDistance)
    throw new RangeError("locale must contain formatDistance property");
  var o = Ye(u, e);
  if (isNaN(o))
    throw new RangeError("Invalid time value");
  var r = O0(jr(D), {
    addSuffix: !!(D != null && D.addSuffix),
    comparison: o
  }), l, i;
  o > 0 ? (l = Fu(e), i = Fu(u)) : (l = Fu(u), i = Fu(e));
  var s = jo(i, l), d = (ID(i) - ID(l)) / 1e3, g = Math.round((s - d) / 60), h;
  if (g < 2)
    return D != null && D.includeSeconds ? s < 5 ? a.formatDistance("lessThanXSeconds", 5, r) : s < 10 ? a.formatDistance("lessThanXSeconds", 10, r) : s < 20 ? a.formatDistance("lessThanXSeconds", 20, r) : s < 40 ? a.formatDistance("halfAMinute", 0, r) : s < 60 ? a.formatDistance("lessThanXMinutes", 1, r) : a.formatDistance("xMinutes", 1, r) : g === 0 ? a.formatDistance("lessThanXMinutes", 1, r) : a.formatDistance("xMinutes", g, r);
  if (g < 45)
    return a.formatDistance("xMinutes", g, r);
  if (g < 90)
    return a.formatDistance("aboutXHours", 1, r);
  if (g < l1) {
    var _ = Math.round(g / 60);
    return a.formatDistance("aboutXHours", _, r);
  } else {
    if (g < Vr)
      return a.formatDistance("xDays", 1, r);
    if (g < gD) {
      var C = Math.round(g / l1);
      return a.formatDistance("xDays", C, r);
    } else if (g < zr)
      return h = Math.round(g / gD), a.formatDistance("aboutXMonths", h, r);
  }
  if (h = No(i, l), h < 12) {
    var p = Math.round(g / gD);
    return a.formatDistance("xMonths", p, r);
  } else {
    var b = h % 12, m = Math.floor(h / 12);
    return b < 3 ? a.formatDistance("aboutXYears", m, r) : b < 9 ? a.formatDistance("overXYears", m, r) : a.formatDistance("almostXYears", m + 1, r);
  }
}
var Wr = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, qr = function(e, D, f) {
  var t, n = Wr[e];
  return typeof n == "string" ? t = n : D === 1 ? t = n.one : t = n.other.replace("{{count}}", String(D)), f != null && f.addSuffix ? f.comparison && f.comparison > 0 ? "dans " + t : "il y a " + t : t;
}, Yr = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Hr = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Gr = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Xr = {
  date: be({
    formats: Yr,
    defaultWidth: "full"
  }),
  time: be({
    formats: Hr,
    defaultWidth: "full"
  }),
  dateTime: be({
    formats: Gr,
    defaultWidth: "full"
  })
}, Zr = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, Kr = function(e, D, f, t) {
  return Zr[e];
}, Qr = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, Jr = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, ul = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, el = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, Dl = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, fl = function(e, D) {
  var f = Number(e), t = D == null ? void 0 : D.unit;
  if (f === 0)
    return "0";
  var n = ["year", "week", "hour", "minute", "second"], a;
  return f === 1 ? a = t && n.includes(t) ? "ère" : "er" : a = "ème", f + a;
}, tl = {
  ordinalNumber: fl,
  era: Vu({
    values: Qr,
    defaultWidth: "wide"
  }),
  quarter: Vu({
    values: Jr,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Vu({
    values: ul,
    defaultWidth: "wide"
  }),
  day: Vu({
    values: el,
    defaultWidth: "wide"
  }),
  dayPeriod: Vu({
    values: Dl,
    defaultWidth: "wide"
  })
}, al = /^(\d+)(ième|ère|ème|er|e)?/i, nl = /\d+/i, ol = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, rl = {
  any: [/^av/i, /^ap/i]
}, ll = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, il = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dl = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, sl = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, cl = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, Fl = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, Cl = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, El = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, ml = {
  ordinalNumber: T0({
    matchPattern: al,
    parsePattern: nl,
    valueCallback: function(e) {
      return parseInt(e);
    }
  }),
  era: zu({
    matchPatterns: ol,
    defaultMatchWidth: "wide",
    parsePatterns: rl,
    defaultParseWidth: "any"
  }),
  quarter: zu({
    matchPatterns: ll,
    defaultMatchWidth: "wide",
    parsePatterns: il,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: zu({
    matchPatterns: dl,
    defaultMatchWidth: "wide",
    parsePatterns: sl,
    defaultParseWidth: "any"
  }),
  day: zu({
    matchPatterns: cl,
    defaultMatchWidth: "wide",
    parsePatterns: Fl,
    defaultParseWidth: "any"
  }),
  dayPeriod: zu({
    matchPatterns: Cl,
    defaultMatchWidth: "any",
    parsePatterns: El,
    defaultParseWidth: "any"
  })
}, i1 = {
  code: "fr",
  formatDistance: qr,
  formatLong: Xr,
  formatRelative: Kr,
  localize: tl,
  match: ml,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, PD = { exports: {} }, I0 = { exports: {} };
(function(u) {
  function e(D) {
    return D && D.__esModule ? D : {
      default: D
    };
  }
  u.exports = e, u.exports.__esModule = !0, u.exports.default = u.exports;
})(I0);
var pu = I0.exports, LD = { exports: {} }, RD = { exports: {} }, P0 = { exports: {} };
(function(u) {
  function e(D) {
    "@babel/helpers - typeof";
    return u.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
      return typeof f;
    } : function(f) {
      return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
    }, u.exports.__esModule = !0, u.exports.default = u.exports, e(D);
  }
  u.exports = e, u.exports.__esModule = !0, u.exports.default = u.exports;
})(P0);
var L0 = P0.exports, ND = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(f, t) {
    if (t.length < f)
      throw new TypeError(f + " argument" + (f > 1 ? "s" : "") + " required, but only " + t.length + " present");
  }
  u.exports = e.default;
})(ND, ND.exports);
var Su = ND.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  var f = D(L0), t = D(Su);
  function n(a) {
    return (0, t.default)(1, arguments), a instanceof Date || (0, f.default)(a) === "object" && Object.prototype.toString.call(a) === "[object Date]";
  }
  u.exports = e.default;
})(RD, RD.exports);
var pl = RD.exports, jD = { exports: {} };
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  var f = D(L0), t = D(Su);
  function n(a) {
    (0, t.default)(1, arguments);
    var o = Object.prototype.toString.call(a);
    return a instanceof Date || (0, f.default)(a) === "object" && o === "[object Date]" ? new Date(a.getTime()) : typeof a == "number" || o === "[object Number]" ? new Date(a) : ((typeof a == "string" || o === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  u.exports = e.default;
})(jD, jD.exports);
var Uu = jD.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var f = D(pl), t = D(Uu), n = D(Su);
  function a(o) {
    if ((0, n.default)(1, arguments), !(0, f.default)(o) && typeof o != "number")
      return !1;
    var r = (0, t.default)(o);
    return !isNaN(Number(r));
  }
  u.exports = e.default;
})(LD, LD.exports);
var bl = LD.exports, VD = { exports: {} }, zD = { exports: {} }, UD = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(f) {
    if (f === null || f === !0 || f === !1)
      return NaN;
    var t = Number(f);
    return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  u.exports = e.default;
})(UD, UD.exports);
var ce = UD.exports;
const gl = /* @__PURE__ */ Le(ce);
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var f = D(ce), t = D(Uu), n = D(Su);
  function a(o, r) {
    (0, n.default)(2, arguments);
    var l = (0, t.default)(o).getTime(), i = (0, f.default)(r);
    return new Date(l + i);
  }
  u.exports = e.default;
})(zD, zD.exports);
var vl = zD.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var f = D(vl), t = D(Su), n = D(ce);
  function a(o, r) {
    (0, t.default)(2, arguments);
    var l = (0, n.default)(r);
    return (0, f.default)(o, -l);
  }
  u.exports = e.default;
})(VD, VD.exports);
var hl = VD.exports, WD = { exports: {} }, qD = { exports: {} };
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var f = D(Uu), t = D(Su), n = 864e5;
  function a(o) {
    (0, t.default)(1, arguments);
    var r = (0, f.default)(o), l = r.getTime();
    r.setUTCMonth(0, 1), r.setUTCHours(0, 0, 0, 0);
    var i = r.getTime(), s = l - i;
    return Math.floor(s / n) + 1;
  }
  u.exports = e.default;
})(qD, qD.exports);
var Bl = qD.exports, YD = { exports: {} }, HD = { exports: {} };
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  var f = D(Uu), t = D(Su);
  function n(a) {
    (0, t.default)(1, arguments);
    var o = 1, r = (0, f.default)(a), l = r.getUTCDay(), i = (l < o ? 7 : 0) + l - o;
    return r.setUTCDate(r.getUTCDate() - i), r.setUTCHours(0, 0, 0, 0), r;
  }
  u.exports = e.default;
})(HD, HD.exports);
var Lf = HD.exports, GD = { exports: {} }, XD = { exports: {} };
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var f = D(Uu), t = D(Su), n = D(Lf);
  function a(o) {
    (0, t.default)(1, arguments);
    var r = (0, f.default)(o), l = r.getUTCFullYear(), i = /* @__PURE__ */ new Date(0);
    i.setUTCFullYear(l + 1, 0, 4), i.setUTCHours(0, 0, 0, 0);
    var s = (0, n.default)(i), d = /* @__PURE__ */ new Date(0);
    d.setUTCFullYear(l, 0, 4), d.setUTCHours(0, 0, 0, 0);
    var g = (0, n.default)(d);
    return r.getTime() >= s.getTime() ? l + 1 : r.getTime() >= g.getTime() ? l : l - 1;
  }
  u.exports = e.default;
})(XD, XD.exports);
var R0 = XD.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var f = D(R0), t = D(Lf), n = D(Su);
  function a(o) {
    (0, n.default)(1, arguments);
    var r = (0, f.default)(o), l = /* @__PURE__ */ new Date(0);
    l.setUTCFullYear(r, 0, 4), l.setUTCHours(0, 0, 0, 0);
    var i = (0, t.default)(l);
    return i;
  }
  u.exports = e.default;
})(GD, GD.exports);
var yl = GD.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  var f = D(Uu), t = D(Lf), n = D(yl), a = D(Su), o = 6048e5;
  function r(l) {
    (0, a.default)(1, arguments);
    var i = (0, f.default)(l), s = (0, t.default)(i).getTime() - (0, n.default)(i).getTime();
    return Math.round(s / o) + 1;
  }
  u.exports = e.default;
})(YD, YD.exports);
var _l = YD.exports, ZD = { exports: {} }, KD = { exports: {} }, Fe = {};
Object.defineProperty(Fe, "__esModule", {
  value: !0
});
Fe.getDefaultOptions = wl;
Fe.setDefaultOptions = kl;
var N0 = {};
function wl() {
  return N0;
}
function kl(u) {
  N0 = u;
}
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var f = D(Uu), t = D(Su), n = D(ce), a = Fe;
  function o(r, l) {
    var i, s, d, g, h, _, C, p;
    (0, t.default)(1, arguments);
    var b = (0, a.getDefaultOptions)(), m = (0, n.default)((i = (s = (d = (g = l == null ? void 0 : l.weekStartsOn) !== null && g !== void 0 ? g : l == null || (h = l.locale) === null || h === void 0 || (_ = h.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && d !== void 0 ? d : b.weekStartsOn) !== null && s !== void 0 ? s : (C = b.locale) === null || C === void 0 || (p = C.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && i !== void 0 ? i : 0);
    if (!(m >= 0 && m <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var F = (0, f.default)(r), c = F.getUTCDay(), B = (c < m ? 7 : 0) + c - m;
    return F.setUTCDate(F.getUTCDate() - B), F.setUTCHours(0, 0, 0, 0), F;
  }
  u.exports = e.default;
})(KD, KD.exports);
var Rf = KD.exports, QD = { exports: {} }, JD = { exports: {} };
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  var f = D(Uu), t = D(Su), n = D(Rf), a = D(ce), o = Fe;
  function r(l, i) {
    var s, d, g, h, _, C, p, b;
    (0, t.default)(1, arguments);
    var m = (0, f.default)(l), F = m.getUTCFullYear(), c = (0, o.getDefaultOptions)(), B = (0, a.default)((s = (d = (g = (h = i == null ? void 0 : i.firstWeekContainsDate) !== null && h !== void 0 ? h : i == null || (_ = i.locale) === null || _ === void 0 || (C = _.options) === null || C === void 0 ? void 0 : C.firstWeekContainsDate) !== null && g !== void 0 ? g : c.firstWeekContainsDate) !== null && d !== void 0 ? d : (p = c.locale) === null || p === void 0 || (b = p.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
    if (!(B >= 1 && B <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var k = /* @__PURE__ */ new Date(0);
    k.setUTCFullYear(F + 1, 0, B), k.setUTCHours(0, 0, 0, 0);
    var A = (0, n.default)(k, i), j = /* @__PURE__ */ new Date(0);
    j.setUTCFullYear(F, 0, B), j.setUTCHours(0, 0, 0, 0);
    var T = (0, n.default)(j, i);
    return m.getTime() >= A.getTime() ? F + 1 : m.getTime() >= T.getTime() ? F : F - 1;
  }
  u.exports = e.default;
})(JD, JD.exports);
var j0 = JD.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  var f = D(j0), t = D(Su), n = D(Rf), a = D(ce), o = Fe;
  function r(l, i) {
    var s, d, g, h, _, C, p, b;
    (0, t.default)(1, arguments);
    var m = (0, o.getDefaultOptions)(), F = (0, a.default)((s = (d = (g = (h = i == null ? void 0 : i.firstWeekContainsDate) !== null && h !== void 0 ? h : i == null || (_ = i.locale) === null || _ === void 0 || (C = _.options) === null || C === void 0 ? void 0 : C.firstWeekContainsDate) !== null && g !== void 0 ? g : m.firstWeekContainsDate) !== null && d !== void 0 ? d : (p = m.locale) === null || p === void 0 || (b = p.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && s !== void 0 ? s : 1), c = (0, f.default)(l, i), B = /* @__PURE__ */ new Date(0);
    B.setUTCFullYear(c, 0, F), B.setUTCHours(0, 0, 0, 0);
    var k = (0, n.default)(B, i);
    return k;
  }
  u.exports = e.default;
})(QD, QD.exports);
var Al = QD.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  var f = D(Uu), t = D(Rf), n = D(Al), a = D(Su), o = 6048e5;
  function r(l, i) {
    (0, a.default)(1, arguments);
    var s = (0, f.default)(l), d = (0, t.default)(s, i).getTime() - (0, n.default)(s, i).getTime();
    return Math.round(d / o) + 1;
  }
  u.exports = e.default;
})(ZD, ZD.exports);
var xl = ZD.exports, uf = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(f, t) {
    for (var n = f < 0 ? "-" : "", a = Math.abs(f).toString(); a.length < t; )
      a = "0" + a;
    return n + a;
  }
  u.exports = e.default;
})(uf, uf.exports);
var V0 = uf.exports, ef = { exports: {} };
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var f = D(V0), t = {
    // Year
    y: function(o, r) {
      var l = o.getUTCFullYear(), i = l > 0 ? l : 1 - l;
      return (0, f.default)(r === "yy" ? i % 100 : i, r.length);
    },
    // Month
    M: function(o, r) {
      var l = o.getUTCMonth();
      return r === "M" ? String(l + 1) : (0, f.default)(l + 1, 2);
    },
    // Day of the month
    d: function(o, r) {
      return (0, f.default)(o.getUTCDate(), r.length);
    },
    // AM or PM
    a: function(o, r) {
      var l = o.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (r) {
        case "a":
        case "aa":
          return l.toUpperCase();
        case "aaa":
          return l;
        case "aaaaa":
          return l[0];
        case "aaaa":
        default:
          return l === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(o, r) {
      return (0, f.default)(o.getUTCHours() % 12 || 12, r.length);
    },
    // Hour [0-23]
    H: function(o, r) {
      return (0, f.default)(o.getUTCHours(), r.length);
    },
    // Minute
    m: function(o, r) {
      return (0, f.default)(o.getUTCMinutes(), r.length);
    },
    // Second
    s: function(o, r) {
      return (0, f.default)(o.getUTCSeconds(), r.length);
    },
    // Fraction of second
    S: function(o, r) {
      var l = r.length, i = o.getUTCMilliseconds(), s = Math.floor(i * Math.pow(10, l - 3));
      return (0, f.default)(s, r.length);
    }
  }, n = t;
  e.default = n, u.exports = e.default;
})(ef, ef.exports);
var $l = ef.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var f = D(Bl), t = D(_l), n = D(R0), a = D(xl), o = D(j0), r = D(V0), l = D($l), i = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, s = {
    // Era
    G: function(p, b, m) {
      var F = p.getUTCFullYear() > 0 ? 1 : 0;
      switch (b) {
        case "G":
        case "GG":
        case "GGG":
          return m.era(F, {
            width: "abbreviated"
          });
        case "GGGGG":
          return m.era(F, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return m.era(F, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(p, b, m) {
      if (b === "yo") {
        var F = p.getUTCFullYear(), c = F > 0 ? F : 1 - F;
        return m.ordinalNumber(c, {
          unit: "year"
        });
      }
      return l.default.y(p, b);
    },
    // Local week-numbering year
    Y: function(p, b, m, F) {
      var c = (0, o.default)(p, F), B = c > 0 ? c : 1 - c;
      if (b === "YY") {
        var k = B % 100;
        return (0, r.default)(k, 2);
      }
      return b === "Yo" ? m.ordinalNumber(B, {
        unit: "year"
      }) : (0, r.default)(B, b.length);
    },
    // ISO week-numbering year
    R: function(p, b) {
      var m = (0, n.default)(p);
      return (0, r.default)(m, b.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(p, b) {
      var m = p.getUTCFullYear();
      return (0, r.default)(m, b.length);
    },
    // Quarter
    Q: function(p, b, m) {
      var F = Math.ceil((p.getUTCMonth() + 1) / 3);
      switch (b) {
        case "Q":
          return String(F);
        case "QQ":
          return (0, r.default)(F, 2);
        case "Qo":
          return m.ordinalNumber(F, {
            unit: "quarter"
          });
        case "QQQ":
          return m.quarter(F, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return m.quarter(F, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return m.quarter(F, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(p, b, m) {
      var F = Math.ceil((p.getUTCMonth() + 1) / 3);
      switch (b) {
        case "q":
          return String(F);
        case "qq":
          return (0, r.default)(F, 2);
        case "qo":
          return m.ordinalNumber(F, {
            unit: "quarter"
          });
        case "qqq":
          return m.quarter(F, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return m.quarter(F, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return m.quarter(F, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(p, b, m) {
      var F = p.getUTCMonth();
      switch (b) {
        case "M":
        case "MM":
          return l.default.M(p, b);
        case "Mo":
          return m.ordinalNumber(F + 1, {
            unit: "month"
          });
        case "MMM":
          return m.month(F, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return m.month(F, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return m.month(F, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(p, b, m) {
      var F = p.getUTCMonth();
      switch (b) {
        case "L":
          return String(F + 1);
        case "LL":
          return (0, r.default)(F + 1, 2);
        case "Lo":
          return m.ordinalNumber(F + 1, {
            unit: "month"
          });
        case "LLL":
          return m.month(F, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return m.month(F, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return m.month(F, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(p, b, m, F) {
      var c = (0, a.default)(p, F);
      return b === "wo" ? m.ordinalNumber(c, {
        unit: "week"
      }) : (0, r.default)(c, b.length);
    },
    // ISO week of year
    I: function(p, b, m) {
      var F = (0, t.default)(p);
      return b === "Io" ? m.ordinalNumber(F, {
        unit: "week"
      }) : (0, r.default)(F, b.length);
    },
    // Day of the month
    d: function(p, b, m) {
      return b === "do" ? m.ordinalNumber(p.getUTCDate(), {
        unit: "date"
      }) : l.default.d(p, b);
    },
    // Day of year
    D: function(p, b, m) {
      var F = (0, f.default)(p);
      return b === "Do" ? m.ordinalNumber(F, {
        unit: "dayOfYear"
      }) : (0, r.default)(F, b.length);
    },
    // Day of week
    E: function(p, b, m) {
      var F = p.getUTCDay();
      switch (b) {
        case "E":
        case "EE":
        case "EEE":
          return m.day(F, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return m.day(F, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return m.day(F, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return m.day(F, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(p, b, m, F) {
      var c = p.getUTCDay(), B = (c - F.weekStartsOn + 8) % 7 || 7;
      switch (b) {
        case "e":
          return String(B);
        case "ee":
          return (0, r.default)(B, 2);
        case "eo":
          return m.ordinalNumber(B, {
            unit: "day"
          });
        case "eee":
          return m.day(c, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return m.day(c, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return m.day(c, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return m.day(c, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(p, b, m, F) {
      var c = p.getUTCDay(), B = (c - F.weekStartsOn + 8) % 7 || 7;
      switch (b) {
        case "c":
          return String(B);
        case "cc":
          return (0, r.default)(B, b.length);
        case "co":
          return m.ordinalNumber(B, {
            unit: "day"
          });
        case "ccc":
          return m.day(c, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return m.day(c, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return m.day(c, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return m.day(c, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(p, b, m) {
      var F = p.getUTCDay(), c = F === 0 ? 7 : F;
      switch (b) {
        case "i":
          return String(c);
        case "ii":
          return (0, r.default)(c, b.length);
        case "io":
          return m.ordinalNumber(c, {
            unit: "day"
          });
        case "iii":
          return m.day(F, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return m.day(F, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return m.day(F, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return m.day(F, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(p, b, m) {
      var F = p.getUTCHours(), c = F / 12 >= 1 ? "pm" : "am";
      switch (b) {
        case "a":
        case "aa":
          return m.dayPeriod(c, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return m.dayPeriod(c, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return m.dayPeriod(c, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return m.dayPeriod(c, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(p, b, m) {
      var F = p.getUTCHours(), c;
      switch (F === 12 ? c = i.noon : F === 0 ? c = i.midnight : c = F / 12 >= 1 ? "pm" : "am", b) {
        case "b":
        case "bb":
          return m.dayPeriod(c, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return m.dayPeriod(c, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return m.dayPeriod(c, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return m.dayPeriod(c, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(p, b, m) {
      var F = p.getUTCHours(), c;
      switch (F >= 17 ? c = i.evening : F >= 12 ? c = i.afternoon : F >= 4 ? c = i.morning : c = i.night, b) {
        case "B":
        case "BB":
        case "BBB":
          return m.dayPeriod(c, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return m.dayPeriod(c, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return m.dayPeriod(c, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(p, b, m) {
      if (b === "ho") {
        var F = p.getUTCHours() % 12;
        return F === 0 && (F = 12), m.ordinalNumber(F, {
          unit: "hour"
        });
      }
      return l.default.h(p, b);
    },
    // Hour [0-23]
    H: function(p, b, m) {
      return b === "Ho" ? m.ordinalNumber(p.getUTCHours(), {
        unit: "hour"
      }) : l.default.H(p, b);
    },
    // Hour [0-11]
    K: function(p, b, m) {
      var F = p.getUTCHours() % 12;
      return b === "Ko" ? m.ordinalNumber(F, {
        unit: "hour"
      }) : (0, r.default)(F, b.length);
    },
    // Hour [1-24]
    k: function(p, b, m) {
      var F = p.getUTCHours();
      return F === 0 && (F = 24), b === "ko" ? m.ordinalNumber(F, {
        unit: "hour"
      }) : (0, r.default)(F, b.length);
    },
    // Minute
    m: function(p, b, m) {
      return b === "mo" ? m.ordinalNumber(p.getUTCMinutes(), {
        unit: "minute"
      }) : l.default.m(p, b);
    },
    // Second
    s: function(p, b, m) {
      return b === "so" ? m.ordinalNumber(p.getUTCSeconds(), {
        unit: "second"
      }) : l.default.s(p, b);
    },
    // Fraction of second
    S: function(p, b) {
      return l.default.S(p, b);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(p, b, m, F) {
      var c = F._originalDate || p, B = c.getTimezoneOffset();
      if (B === 0)
        return "Z";
      switch (b) {
        case "X":
          return g(B);
        case "XXXX":
        case "XX":
          return h(B);
        case "XXXXX":
        case "XXX":
        default:
          return h(B, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(p, b, m, F) {
      var c = F._originalDate || p, B = c.getTimezoneOffset();
      switch (b) {
        case "x":
          return g(B);
        case "xxxx":
        case "xx":
          return h(B);
        case "xxxxx":
        case "xxx":
        default:
          return h(B, ":");
      }
    },
    // Timezone (GMT)
    O: function(p, b, m, F) {
      var c = F._originalDate || p, B = c.getTimezoneOffset();
      switch (b) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + d(B, ":");
        case "OOOO":
        default:
          return "GMT" + h(B, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(p, b, m, F) {
      var c = F._originalDate || p, B = c.getTimezoneOffset();
      switch (b) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + d(B, ":");
        case "zzzz":
        default:
          return "GMT" + h(B, ":");
      }
    },
    // Seconds timestamp
    t: function(p, b, m, F) {
      var c = F._originalDate || p, B = Math.floor(c.getTime() / 1e3);
      return (0, r.default)(B, b.length);
    },
    // Milliseconds timestamp
    T: function(p, b, m, F) {
      var c = F._originalDate || p, B = c.getTime();
      return (0, r.default)(B, b.length);
    }
  };
  function d(C, p) {
    var b = C > 0 ? "-" : "+", m = Math.abs(C), F = Math.floor(m / 60), c = m % 60;
    if (c === 0)
      return b + String(F);
    var B = p;
    return b + String(F) + B + (0, r.default)(c, 2);
  }
  function g(C, p) {
    if (C % 60 === 0) {
      var b = C > 0 ? "-" : "+";
      return b + (0, r.default)(Math.abs(C) / 60, 2);
    }
    return h(C, p);
  }
  function h(C, p) {
    var b = p || "", m = C > 0 ? "-" : "+", F = Math.abs(C), c = (0, r.default)(Math.floor(F / 60), 2), B = (0, r.default)(F % 60, 2);
    return m + c + b + B;
  }
  var _ = s;
  e.default = _, u.exports = e.default;
})(WD, WD.exports);
var Sl = WD.exports, Df = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var D = function(r, l) {
    switch (r) {
      case "P":
        return l.date({
          width: "short"
        });
      case "PP":
        return l.date({
          width: "medium"
        });
      case "PPP":
        return l.date({
          width: "long"
        });
      case "PPPP":
      default:
        return l.date({
          width: "full"
        });
    }
  }, f = function(r, l) {
    switch (r) {
      case "p":
        return l.time({
          width: "short"
        });
      case "pp":
        return l.time({
          width: "medium"
        });
      case "ppp":
        return l.time({
          width: "long"
        });
      case "pppp":
      default:
        return l.time({
          width: "full"
        });
    }
  }, t = function(r, l) {
    var i = r.match(/(P+)(p+)?/) || [], s = i[1], d = i[2];
    if (!d)
      return D(r, l);
    var g;
    switch (s) {
      case "P":
        g = l.dateTime({
          width: "short"
        });
        break;
      case "PP":
        g = l.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        g = l.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        g = l.dateTime({
          width: "full"
        });
        break;
    }
    return g.replace("{{date}}", D(s, l)).replace("{{time}}", f(d, l));
  }, n = {
    p: f,
    P: t
  }, a = n;
  e.default = a, u.exports = e.default;
})(Df, Df.exports);
var Tl = Df.exports, ff = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(f) {
    var t = new Date(Date.UTC(f.getFullYear(), f.getMonth(), f.getDate(), f.getHours(), f.getMinutes(), f.getSeconds(), f.getMilliseconds()));
    return t.setUTCFullYear(f.getFullYear()), f.getTime() - t.getTime();
  }
  u.exports = e.default;
})(ff, ff.exports);
var z0 = ff.exports;
const d1 = /* @__PURE__ */ Le(z0);
var Ne = {};
Object.defineProperty(Ne, "__esModule", {
  value: !0
});
Ne.isProtectedDayOfYearToken = Il;
Ne.isProtectedWeekYearToken = Pl;
Ne.throwProtectedError = Ll;
var Ml = ["D", "DD"], Ol = ["YY", "YYYY"];
function Il(u) {
  return Ml.indexOf(u) !== -1;
}
function Pl(u) {
  return Ol.indexOf(u) !== -1;
}
function Ll(u, e, D) {
  if (u === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(D, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (u === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(D, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (u === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(D, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (u === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(D, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var tf = { exports: {} }, af = { exports: {} }, nf = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var D = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, f = function(a, o, r) {
    var l, i = D[a];
    return typeof i == "string" ? l = i : o === 1 ? l = i.one : l = i.other.replace("{{count}}", o.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + l : l + " ago" : l;
  }, t = f;
  e.default = t, u.exports = e.default;
})(nf, nf.exports);
var Rl = nf.exports, of = { exports: {} }, rf = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(f) {
    return function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : f.defaultWidth, a = f.formats[n] || f.formats[f.defaultWidth];
      return a;
    };
  }
  u.exports = e.default;
})(rf, rf.exports);
var Nl = rf.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var f = D(Nl), t = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, n = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, a = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, f.default)({
      formats: t,
      defaultWidth: "full"
    }),
    time: (0, f.default)({
      formats: n,
      defaultWidth: "full"
    }),
    dateTime: (0, f.default)({
      formats: a,
      defaultWidth: "full"
    })
  }, r = o;
  e.default = r, u.exports = e.default;
})(of, of.exports);
var jl = of.exports, lf = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var D = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, f = function(a, o, r, l) {
    return D[a];
  }, t = f;
  e.default = t, u.exports = e.default;
})(lf, lf.exports);
var Vl = lf.exports, df = { exports: {} }, sf = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(f) {
    return function(t, n) {
      var a = n != null && n.context ? String(n.context) : "standalone", o;
      if (a === "formatting" && f.formattingValues) {
        var r = f.defaultFormattingWidth || f.defaultWidth, l = n != null && n.width ? String(n.width) : r;
        o = f.formattingValues[l] || f.formattingValues[r];
      } else {
        var i = f.defaultWidth, s = n != null && n.width ? String(n.width) : f.defaultWidth;
        o = f.values[s] || f.values[i];
      }
      var d = f.argumentCallback ? f.argumentCallback(t) : t;
      return o[d];
    };
  }
  u.exports = e.default;
})(sf, sf.exports);
var zl = sf.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var f = D(zl), t = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, n = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, a = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, o = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, r = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, i = function(h, _) {
    var C = Number(h), p = C % 100;
    if (p > 20 || p < 10)
      switch (p % 10) {
        case 1:
          return C + "st";
        case 2:
          return C + "nd";
        case 3:
          return C + "rd";
      }
    return C + "th";
  }, s = {
    ordinalNumber: i,
    era: (0, f.default)({
      values: t,
      defaultWidth: "wide"
    }),
    quarter: (0, f.default)({
      values: n,
      defaultWidth: "wide",
      argumentCallback: function(h) {
        return h - 1;
      }
    }),
    month: (0, f.default)({
      values: a,
      defaultWidth: "wide"
    }),
    day: (0, f.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, f.default)({
      values: r,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, d = s;
  e.default = d, u.exports = e.default;
})(df, df.exports);
var Ul = df.exports, cf = { exports: {} }, Ff = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(n) {
    return function(a) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = o.width, l = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], i = a.match(l);
      if (!i)
        return null;
      var s = i[0], d = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], g = Array.isArray(d) ? t(d, function(C) {
        return C.test(s);
      }) : f(d, function(C) {
        return C.test(s);
      }), h;
      h = n.valueCallback ? n.valueCallback(g) : g, h = o.valueCallback ? o.valueCallback(h) : h;
      var _ = a.slice(s.length);
      return {
        value: h,
        rest: _
      };
    };
  }
  function f(n, a) {
    for (var o in n)
      if (n.hasOwnProperty(o) && a(n[o]))
        return o;
  }
  function t(n, a) {
    for (var o = 0; o < n.length; o++)
      if (a(n[o]))
        return o;
  }
  u.exports = e.default;
})(Ff, Ff.exports);
var Wl = Ff.exports, Cf = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(f) {
    return function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = t.match(f.matchPattern);
      if (!a)
        return null;
      var o = a[0], r = t.match(f.parsePattern);
      if (!r)
        return null;
      var l = f.valueCallback ? f.valueCallback(r[0]) : r[0];
      l = n.valueCallback ? n.valueCallback(l) : l;
      var i = t.slice(o.length);
      return {
        value: l,
        rest: i
      };
    };
  }
  u.exports = e.default;
})(Cf, Cf.exports);
var ql = Cf.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var f = D(Wl), t = D(ql), n = /^(\d+)(th|st|nd|rd)?/i, a = /\d+/i, o = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, r = {
    any: [/^b/i, /^(a|c)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, i = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, s = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, d = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, g = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, h = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, _ = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, C = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, p = {
    ordinalNumber: (0, t.default)({
      matchPattern: n,
      parsePattern: a,
      valueCallback: function(F) {
        return parseInt(F, 10);
      }
    }),
    era: (0, f.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: r,
      defaultParseWidth: "any"
    }),
    quarter: (0, f.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any",
      valueCallback: function(F) {
        return F + 1;
      }
    }),
    month: (0, f.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    day: (0, f.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, f.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: C,
      defaultParseWidth: "any"
    })
  }, b = p;
  e.default = b, u.exports = e.default;
})(cf, cf.exports);
var Yl = cf.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var f = D(Rl), t = D(jl), n = D(Vl), a = D(Ul), o = D(Yl), r = {
    code: "en-US",
    formatDistance: f.default,
    formatLong: t.default,
    formatRelative: n.default,
    localize: a.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = r;
  e.default = l, u.exports = e.default;
})(af, af.exports);
var Hl = af.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var f = D(Hl), t = f.default;
  e.default = t, u.exports = e.default;
})(tf, tf.exports);
var Gl = tf.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = m;
  var f = D(bl), t = D(hl), n = D(Uu), a = D(Sl), o = D(Tl), r = D(z0), l = Ne, i = D(ce), s = D(Su), d = Fe, g = D(Gl), h = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, C = /^'([^]*?)'?$/, p = /''/g, b = /[a-zA-Z]/;
  function m(c, B, k) {
    var A, j, T, S, W, L, H, X, lu, yu, Tu, Ru, Wu, Du, tu, wu, hu, qu;
    (0, s.default)(2, arguments);
    var Gu = String(B), Pu = (0, d.getDefaultOptions)(), Xu = (A = (j = k == null ? void 0 : k.locale) !== null && j !== void 0 ? j : Pu.locale) !== null && A !== void 0 ? A : g.default, Ce = (0, i.default)((T = (S = (W = (L = k == null ? void 0 : k.firstWeekContainsDate) !== null && L !== void 0 ? L : k == null || (H = k.locale) === null || H === void 0 || (X = H.options) === null || X === void 0 ? void 0 : X.firstWeekContainsDate) !== null && W !== void 0 ? W : Pu.firstWeekContainsDate) !== null && S !== void 0 ? S : (lu = Pu.locale) === null || lu === void 0 || (yu = lu.options) === null || yu === void 0 ? void 0 : yu.firstWeekContainsDate) !== null && T !== void 0 ? T : 1);
    if (!(Ce >= 1 && Ce <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var ge = (0, i.default)((Tu = (Ru = (Wu = (Du = k == null ? void 0 : k.weekStartsOn) !== null && Du !== void 0 ? Du : k == null || (tu = k.locale) === null || tu === void 0 || (wu = tu.options) === null || wu === void 0 ? void 0 : wu.weekStartsOn) !== null && Wu !== void 0 ? Wu : Pu.weekStartsOn) !== null && Ru !== void 0 ? Ru : (hu = Pu.locale) === null || hu === void 0 || (qu = hu.options) === null || qu === void 0 ? void 0 : qu.weekStartsOn) !== null && Tu !== void 0 ? Tu : 0);
    if (!(ge >= 0 && ge <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!Xu.localize)
      throw new RangeError("locale must contain localize property");
    if (!Xu.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var te = (0, n.default)(c);
    if (!(0, f.default)(te))
      throw new RangeError("Invalid time value");
    var dD = (0, r.default)(te), sD = (0, t.default)(te, dD), cD = {
      firstWeekContainsDate: Ce,
      weekStartsOn: ge,
      locale: Xu,
      _originalDate: te
    }, FD = Gu.match(_).map(function(x) {
      var V = x[0];
      if (V === "p" || V === "P") {
        var K = o.default[V];
        return K(x, Xu.formatLong);
      }
      return x;
    }).join("").match(h).map(function(x) {
      if (x === "''")
        return "'";
      var V = x[0];
      if (V === "'")
        return F(x);
      var K = a.default[V];
      if (K)
        return !(k != null && k.useAdditionalWeekYearTokens) && (0, l.isProtectedWeekYearToken)(x) && (0, l.throwProtectedError)(x, B, String(c)), !(k != null && k.useAdditionalDayOfYearTokens) && (0, l.isProtectedDayOfYearToken)(x) && (0, l.throwProtectedError)(x, B, String(c)), K(sD, x, Xu.localize, cD);
      if (V.match(b))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + V + "`");
      return x;
    }).join("");
    return FD;
  }
  function F(c) {
    var B = c.match(C);
    return B ? B[1].replace(p, "'") : c;
  }
  u.exports = e.default;
})(PD, PD.exports);
var Xl = PD.exports;
const Zl = /* @__PURE__ */ Le(Xl);
function s1(u, e, D) {
  var f = Jl(u, D.timeZone, D.locale);
  return f.formatToParts ? Kl(f, e) : Ql(f, e);
}
function Kl(u, e) {
  for (var D = u.formatToParts(e), f = D.length - 1; f >= 0; --f)
    if (D[f].type === "timeZoneName")
      return D[f].value;
}
function Ql(u, e) {
  var D = u.format(e).replace(/\u200E/g, ""), f = / [\w-+ ]+$/.exec(D);
  return f ? f[0].substr(1) : "";
}
function Jl(u, e, D) {
  if (D && !D.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(D ? [D.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: u
  });
}
function u2(u, e) {
  var D = t2(e);
  return D.formatToParts ? D2(D, u) : f2(D, u);
}
var e2 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function D2(u, e) {
  try {
    for (var D = u.formatToParts(e), f = [], t = 0; t < D.length; t++) {
      var n = e2[D[t].type];
      n >= 0 && (f[n] = parseInt(D[t].value, 10));
    }
    return f;
  } catch (a) {
    if (a instanceof RangeError)
      return [NaN];
    throw a;
  }
}
function f2(u, e) {
  var D = u.format(e), f = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(D);
  return [f[3], f[1], f[2], f[4], f[5], f[6]];
}
var vD = {};
function t2(u) {
  if (!vD[u]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), D = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    vD[u] = D ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: u,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: u,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return vD[u];
}
function U0(u, e, D, f, t, n, a) {
  var o = /* @__PURE__ */ new Date(0);
  return o.setUTCFullYear(u, e, D), o.setUTCHours(f, t, n, a), o;
}
var c1 = 36e5, a2 = 6e4, hD = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function Nf(u, e, D) {
  var f, t;
  if (!u || (f = hD.timezoneZ.exec(u), f))
    return 0;
  var n;
  if (f = hD.timezoneHH.exec(u), f)
    return n = parseInt(f[1], 10), F1(n) ? -(n * c1) : NaN;
  if (f = hD.timezoneHHMM.exec(u), f) {
    n = parseInt(f[2], 10);
    var a = parseInt(f[3], 10);
    return F1(n, a) ? (t = Math.abs(n) * c1 + a * a2, f[1] === "+" ? -t : t) : NaN;
  }
  if (r2(u)) {
    e = new Date(e || Date.now());
    var o = D ? e : n2(e), r = Ef(o, u), l = D ? r : o2(e, r, u);
    return -l;
  }
  return NaN;
}
function n2(u) {
  return U0(
    u.getFullYear(),
    u.getMonth(),
    u.getDate(),
    u.getHours(),
    u.getMinutes(),
    u.getSeconds(),
    u.getMilliseconds()
  );
}
function Ef(u, e) {
  var D = u2(u, e), f = U0(
    D[0],
    D[1] - 1,
    D[2],
    D[3] % 24,
    D[4],
    D[5],
    0
  ).getTime(), t = u.getTime(), n = t % 1e3;
  return t -= n >= 0 ? n : 1e3 + n, f - t;
}
function o2(u, e, D) {
  var f = u.getTime(), t = f - e, n = Ef(new Date(t), D);
  if (e === n)
    return e;
  t -= n - e;
  var a = Ef(new Date(t), D);
  return n === a ? n : Math.max(n, a);
}
function F1(u, e) {
  return -23 <= u && u <= 23 && (e == null || 0 <= e && e <= 59);
}
var C1 = {};
function r2(u) {
  if (C1[u])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: u }), C1[u] = !0, !0;
  } catch {
    return !1;
  }
}
var l2 = 60 * 1e3, i2 = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(u, e, D, f) {
    var t = BD(f.timeZone, u);
    if (t === 0)
      return "Z";
    switch (e) {
      case "X":
        return E1(t);
      case "XXXX":
      case "XX":
        return pe(t);
      case "XXXXX":
      case "XXX":
      default:
        return pe(t, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(u, e, D, f) {
    var t = BD(f.timeZone, u);
    switch (e) {
      case "x":
        return E1(t);
      case "xxxx":
      case "xx":
        return pe(t);
      case "xxxxx":
      case "xxx":
      default:
        return pe(t, ":");
    }
  },
  // Timezone (GMT)
  O: function(u, e, D, f) {
    var t = BD(f.timeZone, u);
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + d2(t, ":");
      case "OOOO":
      default:
        return "GMT" + pe(t, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(u, e, D, f) {
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return s1("short", u, f);
      case "zzzz":
      default:
        return s1("long", u, f);
    }
  }
};
function BD(u, e) {
  var D = u ? Nf(u, e, !0) / l2 : e.getTimezoneOffset();
  if (Number.isNaN(D))
    throw new RangeError("Invalid time zone specified: " + u);
  return D;
}
function Ke(u, e) {
  for (var D = u < 0 ? "-" : "", f = Math.abs(u).toString(); f.length < e; )
    f = "0" + f;
  return D + f;
}
function pe(u, e) {
  var D = e || "", f = u > 0 ? "-" : "+", t = Math.abs(u), n = Ke(Math.floor(t / 60), 2), a = Ke(Math.floor(t % 60), 2);
  return f + n + D + a;
}
function E1(u, e) {
  if (u % 60 === 0) {
    var D = u > 0 ? "-" : "+";
    return D + Ke(Math.abs(u) / 60, 2);
  }
  return pe(u, e);
}
function d2(u, e) {
  var D = u > 0 ? "-" : "+", f = Math.abs(u), t = Math.floor(f / 60), n = f % 60;
  if (n === 0)
    return D + String(t);
  var a = e;
  return D + String(t) + a + Ke(n, 2);
}
var s2 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, yD = 36e5, m1 = 6e4, c2 = 2, $u = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: s2
};
function W0(u, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (u === null)
    return /* @__PURE__ */ new Date(NaN);
  var D = e || {}, f = D.additionalDigits == null ? c2 : gl(D.additionalDigits);
  if (f !== 2 && f !== 1 && f !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (u instanceof Date || typeof u == "object" && Object.prototype.toString.call(u) === "[object Date]")
    return new Date(u.getTime());
  if (typeof u == "number" || Object.prototype.toString.call(u) === "[object Number]")
    return new Date(u);
  if (!(typeof u == "string" || Object.prototype.toString.call(u) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var t = F2(u), n = C2(t.date, f), a = n.year, o = n.restDateString, r = E2(o, a);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (r) {
    var l = r.getTime(), i = 0, s;
    if (t.time && (i = m2(t.time), isNaN(i)))
      return /* @__PURE__ */ new Date(NaN);
    if (t.timeZone || D.timeZone) {
      if (s = Nf(t.timeZone || D.timeZone, new Date(l + i)), isNaN(s))
        return /* @__PURE__ */ new Date(NaN);
    } else
      s = d1(new Date(l + i)), s = d1(new Date(l + i + s));
    return new Date(l + i + s);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function F2(u) {
  var e = {}, D = $u.dateTimePattern.exec(u), f;
  if (D ? (e.date = D[1], f = D[3]) : (D = $u.datePattern.exec(u), D ? (e.date = D[1], f = D[2]) : (e.date = null, f = u)), f) {
    var t = $u.timeZone.exec(f);
    t ? (e.time = f.replace(t[1], ""), e.timeZone = t[1].trim()) : e.time = f;
  }
  return e;
}
function C2(u, e) {
  var D = $u.YYY[e], f = $u.YYYYY[e], t;
  if (t = $u.YYYY.exec(u) || f.exec(u), t) {
    var n = t[1];
    return {
      year: parseInt(n, 10),
      restDateString: u.slice(n.length)
    };
  }
  if (t = $u.YY.exec(u) || D.exec(u), t) {
    var a = t[1];
    return {
      year: parseInt(a, 10) * 100,
      restDateString: u.slice(a.length)
    };
  }
  return {
    year: null
  };
}
function E2(u, e) {
  if (e === null)
    return null;
  var D, f, t, n;
  if (u.length === 0)
    return f = /* @__PURE__ */ new Date(0), f.setUTCFullYear(e), f;
  if (D = $u.MM.exec(u), D)
    return f = /* @__PURE__ */ new Date(0), t = parseInt(D[1], 10) - 1, b1(e, t) ? (f.setUTCFullYear(e, t), f) : /* @__PURE__ */ new Date(NaN);
  if (D = $u.DDD.exec(u), D) {
    f = /* @__PURE__ */ new Date(0);
    var a = parseInt(D[1], 10);
    return g2(e, a) ? (f.setUTCFullYear(e, 0, a), f) : /* @__PURE__ */ new Date(NaN);
  }
  if (D = $u.MMDD.exec(u), D) {
    f = /* @__PURE__ */ new Date(0), t = parseInt(D[1], 10) - 1;
    var o = parseInt(D[2], 10);
    return b1(e, t, o) ? (f.setUTCFullYear(e, t, o), f) : /* @__PURE__ */ new Date(NaN);
  }
  if (D = $u.Www.exec(u), D)
    return n = parseInt(D[1], 10) - 1, g1(e, n) ? p1(e, n) : /* @__PURE__ */ new Date(NaN);
  if (D = $u.WwwD.exec(u), D) {
    n = parseInt(D[1], 10) - 1;
    var r = parseInt(D[2], 10) - 1;
    return g1(e, n, r) ? p1(e, n, r) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function m2(u) {
  var e, D, f;
  if (e = $u.HH.exec(u), e)
    return D = parseFloat(e[1].replace(",", ".")), _D(D) ? D % 24 * yD : NaN;
  if (e = $u.HHMM.exec(u), e)
    return D = parseInt(e[1], 10), f = parseFloat(e[2].replace(",", ".")), _D(D, f) ? D % 24 * yD + f * m1 : NaN;
  if (e = $u.HHMMSS.exec(u), e) {
    D = parseInt(e[1], 10), f = parseInt(e[2], 10);
    var t = parseFloat(e[3].replace(",", "."));
    return _D(D, f, t) ? D % 24 * yD + f * m1 + t * 1e3 : NaN;
  }
  return null;
}
function p1(u, e, D) {
  e = e || 0, D = D || 0;
  var f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(u, 0, 4);
  var t = f.getUTCDay() || 7, n = e * 7 + D + 1 - t;
  return f.setUTCDate(f.getUTCDate() + n), f;
}
var p2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], b2 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function q0(u) {
  return u % 400 === 0 || u % 4 === 0 && u % 100 !== 0;
}
function b1(u, e, D) {
  if (e < 0 || e > 11)
    return !1;
  if (D != null) {
    if (D < 1)
      return !1;
    var f = q0(u);
    if (f && D > b2[e] || !f && D > p2[e])
      return !1;
  }
  return !0;
}
function g2(u, e) {
  if (e < 1)
    return !1;
  var D = q0(u);
  return !(D && e > 366 || !D && e > 365);
}
function g1(u, e, D) {
  return !(e < 0 || e > 52 || D != null && (D < 0 || D > 6));
}
function _D(u, e, D) {
  return !(u != null && (u < 0 || u >= 25) || e != null && (e < 0 || e >= 60) || D != null && (D < 0 || D >= 60));
}
var v2 = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function h2(u, e, D) {
  var f = String(e), t = D || {}, n = f.match(v2);
  if (n) {
    var a = W0(t.originalDate || u, t);
    f = n.reduce(function(o, r) {
      if (r[0] === "'")
        return o;
      var l = o.indexOf(r), i = o[l - 1] === "'", s = o.replace(
        r,
        "'" + i2[r[0]](a, r, null, t) + "'"
      );
      return i ? s.substring(0, l - 1) + s.substring(l + 1) : s;
    }, f);
  }
  return Zl(u, f, t);
}
var mf = { exports: {} }, pf = { exports: {} };
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = D;
  function D(f, t) {
    if (f == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (f[n] = t[n]);
    return f;
  }
  u.exports = e.default;
})(pf, pf.exports);
var B2 = pf.exports;
(function(u, e) {
  var D = pu.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  var f = D(B2);
  function t(n) {
    return (0, f.default)({}, n);
  }
  u.exports = e.default;
})(mf, mf.exports);
var y2 = mf.exports;
const _2 = /* @__PURE__ */ Le(y2);
function w2(u, e, D) {
  var f = W0(u, D), t = Nf(e, f, !0), n = new Date(f.getTime() - t), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()), a.setHours(n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.getUTCMilliseconds()), a;
}
function k2(u, e, D, f) {
  var t = _2(f);
  return t.timeZone = e, t.originalDate = u, h2(w2(u, e), D, t);
}
const v1 = I(window.innerHeight), h1 = I(window.innerWidth);
function A2(u = /* @__PURE__ */ new Date()) {
  const e = typeof u == "string" ? new Date(u) : u;
  return new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()));
}
function u4({ start: u, end: e }) {
  const D = [];
  let f = new Date(Date.UTC(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()));
  const t = new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()));
  for (; f <= t; )
    D.push(new Date(f)), f = new Date(
      Date.UTC(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate() + 1)
    );
  return D;
}
function e4(u, e = 1) {
  return new Date(
    Date.UTC(
      u.getUTCFullYear(),
      u.getUTCMonth(),
      u.getUTCDate() - (u.getUTCDay() - e + 7) % 7
    )
  );
}
function D4(u, e = 1) {
  return new Date(
    Date.UTC(
      u.getUTCFullYear(),
      u.getUTCMonth(),
      u.getUTCDate() + (6 - (u.getUTCDay() - e + 7) % 7)
    )
  );
}
function f4(u) {
  return new Date(Date.UTC(u.getUTCFullYear(), u.getUTCMonth(), 1));
}
function t4(u) {
  return new Date(Date.UTC(u.getUTCFullYear(), u.getUTCMonth() + 1, 0));
}
function x2(u, e) {
  return new Date(Date.UTC(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate() + e));
}
function a4(u, e) {
  return x2(u, e * 7);
}
function n4(u, e) {
  return new Date(Date.UTC(u.getUTCFullYear(), u.getUTCMonth() + e, u.getUTCDate()));
}
function fe() {
  const u = (F) => F.charAt(0).toUpperCase() + F.slice(1), e = (F, c) => {
    if (c <= 1)
      return F;
    const B = F.split(" "), k = [];
    let A, j;
    for (const T in B) {
      const S = B[T];
      j || (j = "");
      const W = S[S.length - 1], L = S.slice(-2), H = S.slice(-3);
      if (W === "s" || W === "z" || W === "x")
        j = S;
      else if (L === "au" || L === "eu")
        switch (S) {
          case "bleu":
          case "émeu":
          case "landau":
          case "pneu":
          case "sarrau":
            j = S + "s";
            break;
          default:
            j = S + "x";
        }
      else if (L === "ou")
        switch (S) {
          case "bijou":
          case "chou":
          case "genou":
          case "caillou":
          case "hibou":
          case "joujou":
          case "pou":
          case "ripou":
          case "chouchou":
          case "boutchou":
            j = S + "x";
            break;
          default:
            j = S + "s";
        }
      else if (H === "ail")
        switch (S) {
          case "bail":
          case "corail":
          case "émail":
          case "gemmail":
          case "soupirail":
          case "travail":
          case "vantail":
          case "vitrail":
            A = S.substring(0, S.length - 3), j = A + "aux";
            break;
          case "ail":
            j = "aulx";
            break;
          default:
            j = S + "s";
        }
      else if (L === "al")
        switch (S) {
          case "aval":
          case "bal":
          case "banal":
          case "bancal":
          case "cal":
          case "carnaval":
          case "cérémonial":
          case "choral":
          case "étal":
          case "fatal":
          case "festival":
          case "natal":
          case "naval":
          case "pal":
          case "récital":
          case "régal":
          case "tonal":
          case "val":
          case "virginal":
            j = S + "s";
            break;
          default:
            A = S.substring(0, S.length - 2), j = A + "aux";
        }
      else
        L === "il" && (S === "oeil" || S === "œil") ? j = "yeux" : j = S + "s";
      k.push(j);
    }
    return j = k.join(" "), j;
  }, D = (F) => (c, B) => c[F] > B[F] ? 1 : B[F] > c[F] ? -1 : 0, f = (F, c) => (F || []).reduce((B, k, A, j, T = k[c]) => ((B[T] || (B[T] = [])).push(k), B), {});
  function t(F, c) {
    return (F || []).reduce(
      (B, k) => {
        const A = k[c];
        return (typeof A == "string" || typeof A == "number" || typeof A == "symbol") && (B[A] = k), B;
      },
      {}
    );
  }
  const n = (F, c = 300) => {
    let B;
    return (...k) => (B && clearTimeout(B), new Promise((A) => {
      B = setTimeout(() => {
        const j = F(...k);
        A(j);
      }, c);
    }));
  }, a = () => {
    const F = n(() => {
      v1.value = window.innerHeight;
    });
    return window.addEventListener("resize", F), vu(() => window.removeEventListener("resize", F)), v1;
  }, o = () => {
    const F = n(() => {
      h1.value = window.innerWidth;
    });
    return window.addEventListener("resize", F), vu(() => window.removeEventListener("resize", F)), h1;
  }, r = (F, c = []) => Object.assign(
    {},
    ...Object.entries(F).map(
      ([B, k]) => k && typeof k == "object" ? r(k, [...c, B]) : { [[...c, B].join(".")]: k }
    )
  );
  return {
    scaledIntegerToNumber: (F, c = 2) => {
      if (F == null || !Number.isInteger(F))
        return null;
      const B = Math.pow(10, c);
      return Number((F / B).toFixed(c));
    },
    formatScaledInteger: (F, c = 2, B = ",", k = {}) => {
      if (F == null || !Number.isInteger(F))
        return "";
      const A = Math.pow(10, c), j = F < 0 ? "-" : "", T = Math.abs(F), S = Math.floor(T / A).toString(), W = c > 0 ? (T % A).toString().padStart(c, "0") : "", L = k.trimTrailingZeros ? W.replace(/0+$/, "") : W;
      return c > 0 && L ? `${j}${S}${B}${L}` : `${j}${S}`;
    },
    pluralize: e,
    capitalize: u,
    sortBy: D,
    groupBy: f,
    keyBy: t,
    debounce: n,
    getWindowHeight: a,
    getWindowWidth: o,
    flattenObject: r,
    unflattenObject: (F) => Object.keys(F).reduce((c, B) => (B.split(".").reduce(
      (k, A, j, T) => k[A] || (k[A] = isNaN(Number(T[j + 1])) ? T.length - 1 === j ? F[B] : {} : []),
      c
    ), c), {}),
    setInitialFormValues: (F, c, B) => {
      const k = (T) => {
        var W;
        const S = {};
        if (Array.isArray(T)) {
          for (const L of T)
            if (L) {
              if (Array.isArray(L)) {
                const H = k(L);
                Object.assign(S, H);
                continue;
              }
              if (typeof L == "object")
                if ("model" in L && typeof L.model == "string")
                  Array.isArray(L.schema) ? S[L.model] = {
                    ...L,
                    schema: k(L.schema)
                  } : S[L.model] = L;
                else {
                  const H = Array.isArray(L.schema) ? L.schema : Array.isArray((W = L.component) == null ? void 0 : W.schema) ? L.component.schema : null;
                  if (H) {
                    const X = k(H);
                    Object.assign(S, X);
                  }
                }
            }
        } else if (typeof T == "object" && T !== null)
          for (const [L, H] of Object.entries(T))
            H && typeof H == "object" && "schema" in H && Array.isArray(H.schema) ? S[L] = {
              ...H,
              schema: k(H.schema)
            } : S[L] = H;
        return S;
      }, A = (T, S, W) => {
        const L = {};
        for (const H of Object.keys(S))
          if (H in W) {
            const X = W[H], lu = S[H];
            X !== null && typeof X == "object" && lu.schema && typeof lu.schema == "object" ? L[H] = A({}, lu.schema, X) : L[H] = X;
          }
        return L;
      }, j = k(c.value);
      F.value = A({}, j, B);
    },
    arraysEquals: (F, c) => F.length == c.length && F.every((B, k) => JSON.stringify(B) === JSON.stringify(c[k])),
    midnightUTC: A2,
    formatDate: (F, c) => k2(new Date(F), "Europe/Paris", c, { locale: i1 }),
    formatDateTimeAgo: (F) => Ur(new Date(F), /* @__PURE__ */ new Date(), { locale: i1, addSuffix: !0 }),
    shuffle: (F) => {
      const c = [...F];
      for (let B = c.length - 1; B > 0; B--) {
        const k = Math.floor(Math.random() * (B + 1));
        [c[B], c[k]] = [c[k], c[B]];
      }
      return c;
    },
    getTutorName: () => import.meta.env.VITE_APP_THEME === "magic" ? "animateur" : "tuteur",
    getAppName: () => import.meta.env.VITE_APP_NAME && import.meta.env.VITE_APP_NAME !== "Parkours" ? import.meta.env.VITE_APP_NAME : "Parkours",
    omit: (F, c, { deep: B } = { deep: !1 }) => {
      const k = B ? JSON.parse(JSON.stringify(F)) : { ...F }, A = (j) => {
        for (const T in j)
          c.includes(T) ? delete j[T] : B && typeof j[T] == "object" && j[T] !== null && A(j[T]);
      };
      return A(k), k;
    }
  };
}
function jf(u, e) {
  return E(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    v("path", {
      "fill-rule": "evenodd",
      d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM8.94 6.94a.75.75 0 1 1-1.061-1.061 3 3 0 1 1 2.871 5.026v.345a.75.75 0 0 1-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 1 0 8.94 6.94ZM10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const $2 = z({
  emits: ["update:modelValue", "update-batch"],
  props: {
    searchable: { type: Boolean, default: !1 },
    autoSelectSingle: { type: Boolean, default: !1 },
    emptySearchText: { type: String, default: "Aucun résultat" },
    optionsMaxHeight: { type: String, default: "max-h-60" },
    size: { type: String, default: "base" },
    color: { type: String, default: "light" },
    label: { type: String },
    itemName: { type: String, default: "élément" },
    subLabel: { type: String },
    name: { type: String, required: !0 },
    clearable: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    modelValue: {
      type: [String, Number, Array, Boolean],
      default: (u) => u ? [] : void 0
    },
    placeholder: { type: String, default: "" },
    items: { type: Array, default: () => [] },
    multiple: { type: Boolean, default: !1 },
    truncate: { type: Boolean, default: !1 },
    selectAllOption: { type: Boolean, default: !1 },
    showSelectedTick: { type: Boolean, default: !0 },
    tooltip: { type: Boolean },
    tooltipHeader: { type: String },
    tooltipText: { type: String },
    hideValidationError: { type: Boolean, default: !1 },
    errorLoadingItems: { type: Boolean, default: !1 },
    direction: { type: String, default: "down" },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        },
        meta: {}
      })
    },
    validations: { type: Object, default: () => ({}) },
    itemComponent: { type: Object }
  },
  components: {
    ComboboxButton: Da,
    ComboboxInput: fa,
    QuestionMarkCircleIcon: jf,
    Emoji: h3,
    Listbox: Jf,
    ListboxButton: Ia,
    ListboxLabel: u1,
    ListboxOption: D1,
    ListboxOptions: e1,
    CheckIcon: Tf,
    ChevronUpDownIcon: B3,
    XCircleIcon: Of,
    ExclamationCircleIcon: Mf,
    Tooltip: Pf
  },
  setup(u, { emit: e }) {
    const { arraysEquals: D, pluralize: f } = fe(), t = I(""), n = I(null), a = I(null), o = w(() => !u.multiple || Array.isArray(u.modelValue) ? u.modelValue : u.modelValue == null ? [] : [u.modelValue]), r = (c) => c.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("fr").trim(), l = w(() => {
      if (!u.searchable)
        return u.items;
      const c = r(t.value);
      return u.items.filter((B) => r(B.searchText ?? B.name).includes(c));
    }), i = (c) => {
      var B;
      !c && !u.disabled && (t.value = "", (B = a.value) == null || B.$el.click());
    }, s = (c) => {
      c.target instanceof HTMLInputElement && (t.value = c.target.value);
    }, d = async () => {
      t.value = "", await Eu(), n.value && (n.value.$el.value = "");
    }, g = w(() => {
      if (!(!u.autoSelectSingle || u.loading || u.disabled || u.items.length !== 1 || u.items[0].disabled))
        return u.items[0].id ?? void 0;
    });
    ru(() => {
      au(
        g,
        (c) => {
          const B = u.modelValue, k = Array.isArray(B) ? B.length === 0 : B == null || B === "";
          c !== void 0 && k && e("update:modelValue", u.multiple ? [c] : c);
        },
        { immediate: !0 }
      );
    });
    const h = w(() => u.items.map((c) => c.id)), _ = w(() => !u.multiple || !u.modelValue ? !1 : D(
      [...o.value],
      h.value
    )), C = w(() => {
      if (u.multiple) {
        const c = o.value || [];
        return u.items.filter((B) => c.includes(B.id));
      } else
        return u.items.find((c) => c.id === u.modelValue);
    }), p = w(() => {
      var c;
      return Array.isArray(C.value) ? C.value.length === 1 ? C.value[0].name : C.value.length ? `${C.value.length} ${f(u.itemName, C.value.length)}` : "" : ((c = C.value) == null ? void 0 : c.name) ?? "";
    }), b = w(
      () => Array.isArray(C.value) && C.value.length > 1 && !t.value
    );
    return {
      Combobox: ua,
      ComboboxLabel: ea,
      ComboboxOption: aa,
      ComboboxOptions: ta,
      Listbox: Jf,
      ListboxLabel: u1,
      ListboxOption: D1,
      ListboxOptions: e1,
      search: t,
      searchInput: n,
      optionsButton: a,
      normalizedValue: o,
      filteredItems: l,
      selectionLabel: p,
      showSelectionBadge: b,
      openOptions: i,
      updateSearch: s,
      pluralize: f,
      areAllSelected: _,
      selected: C,
      select: (c) => {
        u.searchable && d(), u.multiple && Array.isArray(c) && c.includes("select-all") ? _.value ? e("update:modelValue", []) : e("update:modelValue", [...h.value]) : u.modelValue === c && u.clearable ? e("update:modelValue", u.multiple ? [] : void 0) : e("update:modelValue", c);
      },
      clear: () => {
        u.disabled || (d(), u.multiple ? e("update:modelValue", []) : e("update:modelValue", void 0));
      }
    };
  }
}), S2 = {
  key: 0,
  class: "text-xs text-gray-500"
}, T2 = { class: "text-sm" }, M2 = { class: "font-medium text-gray-900" }, O2 = { class: "font-light text-gray-500" }, I2 = { class: "relative" }, P2 = {
  key: 0,
  class: "absolute inset-0 py-3 px-4 w-full flex items-center z-20"
}, L2 = { class: "flex items-center" }, R2 = { key: 0 }, N2 = {
  key: 1,
  class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 lowercase"
}, j2 = { key: 2 }, V2 = {
  key: 0,
  class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-red-500"
}, z2 = {
  key: 2,
  class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
}, U2 = {
  key: 2,
  class: "relative"
}, W2 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 left-3 flex items-center text-gray-400"
}, q2 = { class: "h-5 w-5" }, Y2 = { class: "inline-flex min-w-0 items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium lowercase text-gray-800" }, H2 = { class: "truncate" }, G2 = ["aria-label", "disabled"], X2 = { class: "cursor-default select-none relative py-2 pl-3 pr-9 text-gray-400" }, Z2 = { class: "font-normal block truncate" }, K2 = { class: "lowercase" }, Q2 = {
  key: 1,
  class: "mt-1 min-h-5 text-red-600 text-xs"
}, J2 = { key: 0 }, ui = { key: 1 };
function ei(u, e, D, f, t, n) {
  const a = P("QuestionMarkCircleIcon"), o = P("Tooltip"), r = P("Emoji"), l = P("ExclamationCircleIcon"), i = P("XCircleIcon"), s = P("ChevronUpDownIcon"), d = P("ListboxButton"), g = P("ComboboxInput"), h = P("ComboboxButton"), _ = P("CheckIcon");
  return E(), q(xu(u.searchable ? u.Combobox : u.Listbox), {
    disabled: u.disabled,
    modelValue: u.normalizedValue,
    multiple: u.multiple,
    required: !0,
    as: "div",
    "onUpdate:modelValue": u.select
  }, {
    default: N(({ open: C }) => [
      u.label ? (E(), q(xu(u.searchable ? u.ComboboxLabel : u.ListboxLabel), {
        key: 0,
        class: M([{
          "opacity-50": u.disabled,
          "text-gray-700": u.color === "light",
          "text-primary-100": u.color === "dark"
        }, "block align-middle text-sm font-medium mb-1"])
      }, {
        default: N(() => [
          G(O(u.label) + " ", 1),
          u.subLabel ? (E(), y("p", S2, O(u.subLabel), 1)) : R("", !0),
          u.tooltip && !u.disabled ? (E(), q(o, { key: 1 }, {
            trigger: N(() => [
              U(a, { class: "h-5 w-5 text-gray-400 hover:text-gray-500" })
            ]),
            content: N(() => [
              v("div", T2, [
                v("p", M2, O(u.tooltipHeader), 1),
                v("p", O2, O(u.tooltipText), 1)
              ])
            ]),
            _: 1
          })) : R("", !0)
        ]),
        _: 1
      }, 8, ["class"])) : R("", !0),
      v("div", I2, [
        u.loading ? (E(), y("div", P2, [
          v("div", {
            class: M([{ "mx-6": u.$slots["icon-before"] }, "animate-pulse h-3 my-2 bg-gray-200 rounded w-5/6"])
          }, null, 2)
        ])) : R("", !0),
        u.searchable ? (E(), y("div", U2, [
          U(g, {
            ref: "searchInput",
            "aria-description": u.selectionLabel || void 0,
            "aria-label": u.label || u.placeholder || "Rechercher",
            class: M([[
              {
                "py-3 px-4": u.size === "lg",
                "px-2.5 py-1.5": u.size === "xs",
                "px-3 py-2": u.size === "base",
                "bg-primary-600 border-primary-700 text-white": u.color === "dark",
                "bg-white border-gray-300 text-gray-900": u.color === "light",
                "placeholder-white": u.color === "dark" && !!u.selectionLabel,
                "placeholder-gray-300": u.color === "dark" && !u.selectionLabel,
                "placeholder-gray-700": u.color !== "dark" && !!u.selectionLabel,
                "placeholder-gray-400": u.color !== "dark" && !u.selectionLabel,
                "bg-gray-50 border-gray-300 rounded-r-none": u.color === "transparent",
                "opacity-50 cursor-not-allowed": u.disabled,
                "caret-transparent": u.showSelectionBadge,
                "pl-10": u.$slots["icon-before"],
                "text-opacity-0 placeholder-opacity-0": u.loading
              },
              u.validation.errorMessage ? "border-red-300" : ""
            ], "block w-full rounded-md border pl-3 pr-16 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-400"]),
            "display-value": () => "",
            placeholder: u.showSelectionBadge ? "" : u.selectionLabel || u.placeholder || "Sélectionner",
            autocomplete: "off",
            onChange: u.updateSearch,
            onClick: (p) => u.openOptions(C)
          }, null, 8, ["aria-description", "aria-label", "class", "placeholder", "onChange", "onClick"]),
          u.$slots["icon-before"] && !u.loading ? (E(), y("span", W2, [
            v("span", q2, [
              fu(u.$slots, "icon-before")
            ])
          ])) : R("", !0),
          u.showSelectionBadge && !u.loading ? (E(), y("div", {
            key: 1,
            "aria-hidden": "true",
            class: M([u.$slots["icon-before"] ? "left-10" : "left-3", "pointer-events-none absolute inset-y-0 right-16 flex items-center"])
          }, [
            v("span", Y2, [
              v("span", H2, O(u.selectionLabel), 1)
            ])
          ], 2)) : R("", !0),
          u.clearable && u.selectionLabel && !u.loading ? (E(), y("button", {
            key: 2,
            "aria-label": `Effacer la sélection : ${u.placeholder || u.itemName}`,
            disabled: u.disabled,
            class: "absolute inset-y-0 right-7 px-1 text-gray-400 hover:text-gray-500",
            type: "button",
            onClick: e[2] || (e[2] = (...p) => u.clear && u.clear(...p))
          }, [
            U(i, {
              "aria-hidden": "true",
              class: "h-5 w-5"
            })
          ], 8, G2)) : R("", !0),
          U(h, {
            ref: "optionsButton",
            "aria-label": `Afficher : ${u.placeholder || u.itemName}`,
            class: "absolute inset-y-0 right-0 px-2 text-gray-400"
          }, {
            default: N(() => [
              U(s, {
                "aria-hidden": "true",
                class: "h-5 w-5"
              })
            ]),
            _: 1
          }, 8, ["aria-label"])
        ])) : (E(), q(d, {
          key: 1,
          class: M([[
            {
              "py-3 px-4": u.size === "lg",
              "px-2.5 py-1.5": u.size === "xs",
              "px-3 py-2": u.size === "base",
              "opacity-50 cursor-not-allowed": u.disabled,
              "bg-primary-600 border-primary-700": u.color === "dark",
              "bg-white border-gray-300": u.color === "light",
              "bg-gray-50 border-gray-300 rounded-r-none": u.color === "transparent"
            },
            u.validation.errorMessage ? "border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10" : "focus:ring-primary-400 focus:border-primary-400"
          ], "relative w-full border rounded-md shadow-sm pl-3 pr-10 text-left cursor-default focus:outline-none focus:ring-1 sm:text-sm"]),
          name: u.name
        }, {
          default: N(() => [
            v("span", L2, [
              u.$slots["icon-before"] ? (E(), y("span", {
                key: 0,
                class: M([u.loading ? "text-opacity-0" : "text-gray-400", "h-5 w-5 mr-2"])
              }, [
                fu(u.$slots, "icon-before")
              ], 2)) : R("", !0),
              u.multiple && Array.isArray(u.selected) && u.selected.length || u.selected && !u.multiple ? (E(), y("span", {
                key: 1,
                class: M([{
                  "text-white": u.color === "dark",
                  "text-gray-700": u.color === "light",
                  "text-opacity-0": u.loading
                }, "block truncate"])
              }, [
                u.multiple && Array.isArray(u.selected) && u.selected.length === 1 ? (E(), y("span", R2, O(u.selected[0].name), 1)) : u.multiple && Array.isArray(u.selected) && u.selected.length > 1 ? (E(), y("span", N2, O(u.selected.length) + " " + O(u.pluralize(u.itemName, u.selected.length)), 1)) : !u.multiple && !Array.isArray(u.selected) ? (E(), y("span", j2, [
                  u.selected.emoji ? (E(), q(r, {
                    key: 0,
                    data: u.selected.emoji
                  }, null, 8, ["data"])) : R("", !0),
                  G(" " + O(u.selected.name), 1)
                ])) : R("", !0)
              ], 2)) : (E(), y("span", {
                key: 2,
                class: M([{
                  "text-red-300": u.validation.errorMessage,
                  "text-gray-300": !u.validation.errorMessage && u.color === "dark",
                  "text-gray-400": !u.validation.errorMessage && u.color === "light",
                  "text-opacity-0 placeholder-opacity-0": u.loading
                }, "block truncate"])
              }, O(u.placeholder || "Sélectionner"), 3))
            ]),
            u.validation.errorMessage ? (E(), y("span", V2, [
              U(l, {
                "aria-hidden": "true",
                class: "h-5 w-5"
              })
            ])) : !u.loading && u.clearable && (u.multiple && Array.isArray(u.selected) && u.selected.length || u.selected && !u.multiple) ? (E(), y("button", {
              key: 1,
              class: M([{
                "hover:text-white": u.color === "dark",
                "hover:text-gray-500": u.color === "light"
              }, "absolute inset-y-0 right-0 inline-flex items-center px-3 border border-transparent rounded-md text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-400"]),
              type: "button",
              onClick: e[0] || (e[0] = ju((...p) => u.clear && u.clear(...p), ["stop"])),
              onKeydown: e[1] || (e[1] = Nu(ju((...p) => u.clear && u.clear(...p), ["stop"]), ["enter"]))
            }, [
              U(i, {
                "aria-hidden": "true",
                class: "h-5 w-5"
              })
            ], 34)) : (E(), y("span", z2, [
              U(s, {
                "aria-hidden": "true",
                class: "h-5 w-5 text-gray-400"
              })
            ]))
          ]),
          _: 3
        }, 8, ["class", "name"])),
        U(_e, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0",
          onBeforeLeave: e[3] || (e[3] = (p) => u.search = "")
        }, {
          default: N(() => [
            (E(), q(xu(u.searchable ? u.ComboboxOptions : u.ListboxOptions), {
              class: M([[
                u.optionsMaxHeight,
                { "mt-1": u.direction === "down", "bottom-full mb-1": u.direction === "up" }
              ], "z-30 absolute w-full bg-white shadow-lg rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"])
            }, {
              default: N(() => [
                u.filteredItems.length ? R("", !0) : (E(), q(xu(u.searchable ? u.ComboboxOption : u.ListboxOption), {
                  key: 0,
                  disabled: !0,
                  as: "template",
                  value: "none"
                }, {
                  default: N(() => [
                    v("li", X2, [
                      v("span", Z2, O(u.searchable ? u.emptySearchText : "Aucun élément"), 1)
                    ])
                  ]),
                  _: 1
                })),
                u.selectAllOption && u.multiple && u.items.length && !u.search ? (E(), q(xu(u.searchable ? u.ComboboxOption : u.ListboxOption), {
                  key: 1,
                  as: "template",
                  value: "select-all"
                }, {
                  default: N(({ active: p }) => [
                    v("li", {
                      class: M([
                        p ? "text-white bg-primary-400" : "text-primary-400",
                        "cursor-default select-none relative py-2 pl-3 pr-9"
                      ])
                    }, [
                      v("span", {
                        class: M([u.areAllSelected ? "font-semibold" : "font-normal", "block truncate"])
                      }, [
                        G(" Tout " + O(u.areAllSelected ? "désélectionner" : "sélectionner") + " (" + O(u.items.length) + " ", 1),
                        v("span", K2, O(u.pluralize(u.placeholder, u.items.length)), 1),
                        G(") ")
                      ], 2),
                      u.areAllSelected ? (E(), y("span", {
                        key: 0,
                        class: M([
                          p ? "text-white" : "text-primary-400",
                          "absolute inset-y-0 right-0 flex items-center pr-4"
                        ])
                      }, [
                        U(_, {
                          "aria-hidden": "true",
                          class: "h-5 w-5"
                        })
                      ], 2)) : R("", !0)
                    ], 2)
                  ]),
                  _: 1
                })) : R("", !0),
                (E(!0), y(J, null, du(u.filteredItems, (p) => {
                  var b;
                  return E(), q(xu(u.searchable ? u.ComboboxOption : u.ListboxOption), {
                    key: ((b = p.id) == null ? void 0 : b.toString()) ?? "null",
                    class: M({ "opacity-50 cursor-not-allowed": p.disabled }),
                    disabled: p.disabled,
                    value: p.id,
                    as: "template"
                  }, {
                    default: N(({ active: m, selected: F }) => [
                      u.itemComponent ? (E(), q(xu(u.itemComponent), {
                        key: 0,
                        "is-active": m,
                        "is-selected": F,
                        item: p
                      }, null, 8, ["is-active", "is-selected", "item"])) : (E(), y("li", {
                        key: 1,
                        class: M([
                          u.showSelectedTick ? "pr-9" : "pr-3",
                          m ? "text-white bg-primary-400" : "text-gray-900",
                          "cursor-default select-none relative py-2 pl-3"
                        ])
                      }, [
                        v("span", {
                          class: M([
                            F ? "font-semibold" : "font-normal",
                            "block",
                            { truncate: u.truncate }
                          ])
                        }, [
                          p.emoji ? (E(), q(r, {
                            key: 0,
                            data: p.emoji
                          }, null, 8, ["data"])) : R("", !0),
                          G(" " + O(p.name), 1)
                        ], 2),
                        F && u.showSelectedTick ? (E(), y("span", {
                          key: 0,
                          class: M([
                            m ? "text-white" : "text-primary-400",
                            "absolute inset-y-0 right-0 flex items-center pr-4"
                          ])
                        }, [
                          U(_, {
                            "aria-hidden": "true",
                            class: "h-5 w-5"
                          })
                        ], 2)) : R("", !0)
                      ], 2))
                    ]),
                    _: 2
                  }, 1032, ["class", "disabled", "value"]);
                }), 128))
              ]),
              _: 1
            }, 8, ["class"]))
          ]),
          _: 1
        })
      ]),
      u.hideValidationError ? R("", !0) : (E(), y("p", Q2, [
        u.errorLoadingItems ? (E(), y("span", J2, "Erreur lors du chargement de la liste. Veuillez réessayer plus tard.")) : (E(), y("span", ui, O(u.validation.errorMessage), 1))
      ]))
    ]),
    _: 3
  }, 8, ["disabled", "modelValue", "multiple", "onUpdate:modelValue"]);
}
const Di = /* @__PURE__ */ Q($2, [["render", ei]]), B1 = [
  {
    name: "Afghanistan",
    flag: "🇦🇫",
    code: "AF",
    dial_code: "+93"
  },
  {
    name: "Åland Islands",
    flag: "🇦🇽",
    code: "AX",
    dial_code: "+358"
  },
  {
    name: "Albania",
    flag: "🇦🇱",
    code: "AL",
    dial_code: "+355"
  },
  {
    name: "Algeria",
    flag: "🇩🇿",
    code: "DZ",
    dial_code: "+213"
  },
  {
    name: "American Samoa",
    flag: "🇦🇸",
    code: "AS",
    dial_code: "+1684"
  },
  {
    name: "Andorra",
    flag: "🇦🇩",
    code: "AD",
    dial_code: "+376"
  },
  {
    name: "Angola",
    flag: "🇦🇴",
    code: "AO",
    dial_code: "+244"
  },
  {
    name: "Anguilla",
    flag: "🇦🇮",
    code: "AI",
    dial_code: "+1264"
  },
  {
    name: "Antarctica",
    flag: "🇦🇶",
    code: "AQ",
    dial_code: "+672"
  },
  {
    name: "Antigua and Barbuda",
    flag: "🇦🇬",
    code: "AG",
    dial_code: "+1268"
  },
  {
    name: "Argentina",
    flag: "🇦🇷",
    code: "AR",
    dial_code: "+54"
  },
  {
    name: "Armenia",
    flag: "🇦🇲",
    code: "AM",
    dial_code: "+374"
  },
  {
    name: "Aruba",
    flag: "🇦🇼",
    code: "AW",
    dial_code: "+297"
  },
  {
    name: "Australia",
    flag: "🇦🇺",
    code: "AU",
    dial_code: "+61"
  },
  {
    name: "Austria",
    flag: "🇦🇹",
    code: "AT",
    dial_code: "+43"
  },
  {
    name: "Azerbaijan",
    flag: "🇦🇿",
    code: "AZ",
    dial_code: "+994"
  },
  {
    name: "Bahamas",
    flag: "🇧🇸",
    code: "BS",
    dial_code: "+1242"
  },
  {
    name: "Bahrain",
    flag: "🇧🇭",
    code: "BH",
    dial_code: "+973"
  },
  {
    name: "Bangladesh",
    flag: "🇧🇩",
    code: "BD",
    dial_code: "+880"
  },
  {
    name: "Barbados",
    flag: "🇧🇧",
    code: "BB",
    dial_code: "+1246"
  },
  {
    name: "Belarus",
    flag: "🇧🇾",
    code: "BY",
    dial_code: "+375"
  },
  {
    name: "Belgium",
    flag: "🇧🇪",
    code: "BE",
    dial_code: "+32"
  },
  {
    name: "Belize",
    flag: "🇧🇿",
    code: "BZ",
    dial_code: "+501"
  },
  {
    name: "Benin",
    flag: "🇧🇯",
    code: "BJ",
    dial_code: "+229"
  },
  {
    name: "Bermuda",
    flag: "🇧🇲",
    code: "BM",
    dial_code: "+1441"
  },
  {
    name: "Bhutan",
    flag: "🇧🇹",
    code: "BT",
    dial_code: "+975"
  },
  {
    name: "Bolivia, Plurinational State of bolivia",
    flag: "🇧🇴",
    code: "BO",
    dial_code: "+591"
  },
  {
    name: "Bosnia and Herzegovina",
    flag: "🇧🇦",
    code: "BA",
    dial_code: "+387"
  },
  {
    name: "Botswana",
    flag: "🇧🇼",
    code: "BW",
    dial_code: "+267"
  },
  {
    name: "Bouvet Island",
    flag: "🇧🇻",
    code: "BV",
    dial_code: "+47"
  },
  {
    name: "Brazil",
    flag: "🇧🇷",
    code: "BR",
    dial_code: "+55"
  },
  {
    name: "British Indian Ocean Territory",
    flag: "🇮🇴",
    code: "IO",
    dial_code: "+246"
  },
  {
    name: "Brunei Darussalam",
    flag: "🇧🇳",
    code: "BN",
    dial_code: "+673"
  },
  {
    name: "Bulgaria",
    flag: "🇧🇬",
    code: "BG",
    dial_code: "+359"
  },
  {
    name: "Burkina Faso",
    flag: "🇧🇫",
    code: "BF",
    dial_code: "+226"
  },
  {
    name: "Burundi",
    flag: "🇧🇮",
    code: "BI",
    dial_code: "+257"
  },
  {
    name: "Cambodia",
    flag: "🇰🇭",
    code: "KH",
    dial_code: "+855"
  },
  {
    name: "Cameroon",
    flag: "🇨🇲",
    code: "CM",
    dial_code: "+237"
  },
  {
    name: "Canada",
    flag: "🇨🇦",
    code: "CA",
    dial_code: "+1"
  },
  {
    name: "Cape Verde",
    flag: "🇨🇻",
    code: "CV",
    dial_code: "+238"
  },
  {
    name: "Cayman Islands",
    flag: "🇰🇾",
    code: "KY",
    dial_code: "+345"
  },
  {
    name: "Central African Republic",
    flag: "🇨🇫",
    code: "CF",
    dial_code: "+236"
  },
  {
    name: "Chad",
    flag: "🇹🇩",
    code: "TD",
    dial_code: "+235"
  },
  {
    name: "Chile",
    flag: "🇨🇱",
    code: "CL",
    dial_code: "+56"
  },
  {
    name: "China",
    flag: "🇨🇳",
    code: "CN",
    dial_code: "+86"
  },
  {
    name: "Christmas Island",
    flag: "🇨🇽",
    code: "CX",
    dial_code: "+61"
  },
  {
    name: "Cocos (Keeling) Islands",
    flag: "🇨🇨",
    code: "CC",
    dial_code: "+61"
  },
  {
    name: "Colombia",
    flag: "🇨🇴",
    code: "CO",
    dial_code: "+57"
  },
  {
    name: "Comoros",
    flag: "🇰🇲",
    code: "KM",
    dial_code: "+269"
  },
  {
    name: "Congo",
    flag: "🇨🇬",
    code: "CG",
    dial_code: "+242"
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    flag: "🇨🇩",
    code: "CD",
    dial_code: "+243"
  },
  {
    name: "Cook Islands",
    flag: "🇨🇰",
    code: "CK",
    dial_code: "+682"
  },
  {
    name: "Costa Rica",
    flag: "🇨🇷",
    code: "CR",
    dial_code: "+506"
  },
  {
    name: "Cote d'Ivoire",
    flag: "🇨🇮",
    code: "CI",
    dial_code: "+225"
  },
  {
    name: "Croatia",
    flag: "🇭🇷",
    code: "HR",
    dial_code: "+385"
  },
  {
    name: "Cuba",
    flag: "🇨🇺",
    code: "CU",
    dial_code: "+53"
  },
  {
    name: "Cyprus",
    flag: "🇨🇾",
    code: "CY",
    dial_code: "+357"
  },
  {
    name: "Czech Republic",
    flag: "🇨🇿",
    code: "CZ",
    dial_code: "+420"
  },
  {
    name: "Denmark",
    flag: "🇩🇰",
    code: "DK",
    dial_code: "+45"
  },
  {
    name: "Djibouti",
    flag: "🇩🇯",
    code: "DJ",
    dial_code: "+253"
  },
  {
    name: "Dominica",
    flag: "🇩🇲",
    code: "DM",
    dial_code: "+1767"
  },
  {
    name: "Dominican Republic",
    flag: "🇩🇴",
    code: "DO",
    dial_code: "+1849"
  },
  {
    name: "Ecuador",
    flag: "🇪🇨",
    code: "EC",
    dial_code: "+593"
  },
  {
    name: "Egypt",
    flag: "🇪🇬",
    code: "EG",
    dial_code: "+20"
  },
  {
    name: "El Salvador",
    flag: "🇸🇻",
    code: "SV",
    dial_code: "+503"
  },
  {
    name: "Equatorial Guinea",
    flag: "🇬🇶",
    code: "GQ",
    dial_code: "+240"
  },
  {
    name: "Eritrea",
    flag: "🇪🇷",
    code: "ER",
    dial_code: "+291"
  },
  {
    name: "Estonia",
    flag: "🇪🇪",
    code: "EE",
    dial_code: "+372"
  },
  {
    name: "Ethiopia",
    flag: "🇪🇹",
    code: "ET",
    dial_code: "+251"
  },
  {
    name: "Falkland Islands (Malvinas)",
    flag: "🇫🇰",
    code: "FK",
    dial_code: "+500"
  },
  {
    name: "Faroe Islands",
    flag: "🇫🇴",
    code: "FO",
    dial_code: "+298"
  },
  {
    name: "Fiji",
    flag: "🇫🇯",
    code: "FJ",
    dial_code: "+679"
  },
  {
    name: "Finland",
    flag: "🇫🇮",
    code: "FI",
    dial_code: "+358"
  },
  {
    name: "France",
    flag: "🇫🇷",
    code: "FR",
    dial_code: "+33"
  },
  {
    name: "French Guiana",
    flag: "🇬🇫",
    code: "GF",
    dial_code: "+594"
  },
  {
    name: "French Polynesia",
    flag: "🇵🇫",
    code: "PF",
    dial_code: "+689"
  },
  {
    name: "French Southern Territories",
    flag: "🇹🇫",
    code: "TF",
    dial_code: "+262"
  },
  {
    name: "Gabon",
    flag: "🇬🇦",
    code: "GA",
    dial_code: "+241"
  },
  {
    name: "Gambia",
    flag: "🇬🇲",
    code: "GM",
    dial_code: "+220"
  },
  {
    name: "Georgia",
    flag: "🇬🇪",
    code: "GE",
    dial_code: "+995"
  },
  {
    name: "Germany",
    flag: "🇩🇪",
    code: "DE",
    dial_code: "+49"
  },
  {
    name: "Ghana",
    flag: "🇬🇭",
    code: "GH",
    dial_code: "+233"
  },
  {
    name: "Gibraltar",
    flag: "🇬🇮",
    code: "GI",
    dial_code: "+350"
  },
  {
    name: "Greece",
    flag: "🇬🇷",
    code: "GR",
    dial_code: "+30"
  },
  {
    name: "Greenland",
    flag: "🇬🇱",
    code: "GL",
    dial_code: "+299"
  },
  {
    name: "Grenada",
    flag: "🇬🇩",
    code: "GD",
    dial_code: "+1473"
  },
  {
    name: "Guadeloupe",
    flag: "🇬🇵",
    code: "GP",
    dial_code: "+590"
  },
  {
    name: "Guam",
    flag: "🇬🇺",
    code: "GU",
    dial_code: "+1671"
  },
  {
    name: "Guatemala",
    flag: "🇬🇹",
    code: "GT",
    dial_code: "+502"
  },
  {
    name: "Guernsey",
    flag: "🇬🇬",
    code: "GG",
    dial_code: "+44"
  },
  {
    name: "Guinea",
    flag: "🇬🇳",
    code: "GN",
    dial_code: "+224"
  },
  {
    name: "Guinea-Bissau",
    flag: "🇬🇼",
    code: "GW",
    dial_code: "+245"
  },
  {
    name: "Guyana",
    flag: "🇬🇾",
    code: "GY",
    dial_code: "+592"
  },
  {
    name: "Haiti",
    flag: "🇭🇹",
    code: "HT",
    dial_code: "+509"
  },
  {
    name: "Heard Island and Mcdonald Islands",
    flag: "🇭🇲",
    code: "HM",
    dial_code: "+672"
  },
  {
    name: "Holy See (Vatican City State)",
    flag: "🇻🇦",
    code: "VA",
    dial_code: "+379"
  },
  {
    name: "Honduras",
    flag: "🇭🇳",
    code: "HN",
    dial_code: "+504"
  },
  {
    name: "Hong Kong",
    flag: "🇭🇰",
    code: "HK",
    dial_code: "+852"
  },
  {
    name: "Hungary",
    flag: "🇭🇺",
    code: "HU",
    dial_code: "+36"
  },
  {
    name: "Iceland",
    flag: "🇮🇸",
    code: "IS",
    dial_code: "+354"
  },
  {
    name: "India",
    flag: "🇮🇳",
    code: "IN",
    dial_code: "+91"
  },
  {
    name: "Indonesia",
    flag: "🇮🇩",
    code: "ID",
    dial_code: "+62"
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    flag: "🇮🇷",
    code: "IR",
    dial_code: "+98"
  },
  {
    name: "Iraq",
    flag: "🇮🇶",
    code: "IQ",
    dial_code: "+964"
  },
  {
    name: "Ireland",
    flag: "🇮🇪",
    code: "IE",
    dial_code: "+353"
  },
  {
    name: "Isle of Man",
    flag: "🇮🇲",
    code: "IM",
    dial_code: "+44"
  },
  {
    name: "Israel",
    flag: "🇮🇱",
    code: "IL",
    dial_code: "+972"
  },
  {
    name: "Italy",
    flag: "🇮🇹",
    code: "IT",
    dial_code: "+39"
  },
  {
    name: "Jamaica",
    flag: "🇯🇲",
    code: "JM",
    dial_code: "+1876"
  },
  {
    name: "Japan",
    flag: "🇯🇵",
    code: "JP",
    dial_code: "+81"
  },
  {
    name: "Jersey",
    flag: "🇯🇪",
    code: "JE",
    dial_code: "+44"
  },
  {
    name: "Jordan",
    flag: "🇯🇴",
    code: "JO",
    dial_code: "+962"
  },
  {
    name: "Kazakhstan",
    flag: "🇰🇿",
    code: "KZ",
    dial_code: "+7"
  },
  {
    name: "Kenya",
    flag: "🇰🇪",
    code: "KE",
    dial_code: "+254"
  },
  {
    name: "Kiribati",
    flag: "🇰🇮",
    code: "KI",
    dial_code: "+686"
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    flag: "🇰🇵",
    code: "KP",
    dial_code: "+850"
  },
  {
    name: "Korea, Republic of South Korea",
    flag: "🇰🇷",
    code: "KR",
    dial_code: "+82"
  },
  {
    name: "Kosovo",
    flag: "🇽🇰",
    code: "XK",
    dial_code: "+383"
  },
  {
    name: "Kuwait",
    flag: "🇰🇼",
    code: "KW",
    dial_code: "+965"
  },
  {
    name: "Kyrgyzstan",
    flag: "🇰🇬",
    code: "KG",
    dial_code: "+996"
  },
  {
    name: "Laos",
    flag: "🇱🇦",
    code: "LA",
    dial_code: "+856"
  },
  {
    name: "Latvia",
    flag: "🇱🇻",
    code: "LV",
    dial_code: "+371"
  },
  {
    name: "Lebanon",
    flag: "🇱🇧",
    code: "LB",
    dial_code: "+961"
  },
  {
    name: "Lesotho",
    flag: "🇱🇸",
    code: "LS",
    dial_code: "+266"
  },
  {
    name: "Liberia",
    flag: "🇱🇷",
    code: "LR",
    dial_code: "+231"
  },
  {
    name: "Libyan Arab Jamahiriya",
    flag: "🇱🇾",
    code: "LY",
    dial_code: "+218"
  },
  {
    name: "Liechtenstein",
    flag: "🇱🇮",
    code: "LI",
    dial_code: "+423"
  },
  {
    name: "Lithuania",
    flag: "🇱🇹",
    code: "LT",
    dial_code: "+370"
  },
  {
    name: "Luxembourg",
    flag: "🇱🇺",
    code: "LU",
    dial_code: "+352"
  },
  {
    name: "Macao",
    flag: "🇲🇴",
    code: "MO",
    dial_code: "+853"
  },
  {
    name: "Macedonia",
    flag: "🇲🇰",
    code: "MK",
    dial_code: "+389"
  },
  {
    name: "Madagascar",
    flag: "🇲🇬",
    code: "MG",
    dial_code: "+261"
  },
  {
    name: "Malawi",
    flag: "🇲🇼",
    code: "MW",
    dial_code: "+265"
  },
  {
    name: "Malaysia",
    flag: "🇲🇾",
    code: "MY",
    dial_code: "+60"
  },
  {
    name: "Maldives",
    flag: "🇲🇻",
    code: "MV",
    dial_code: "+960"
  },
  {
    name: "Mali",
    flag: "🇲🇱",
    code: "ML",
    dial_code: "+223"
  },
  {
    name: "Malta",
    flag: "🇲🇹",
    code: "MT",
    dial_code: "+356"
  },
  {
    name: "Marshall Islands",
    flag: "🇲🇭",
    code: "MH",
    dial_code: "+692"
  },
  {
    name: "Martinique",
    flag: "🇲🇶",
    code: "MQ",
    dial_code: "+596"
  },
  {
    name: "Mauritania",
    flag: "🇲🇷",
    code: "MR",
    dial_code: "+222"
  },
  {
    name: "Mauritius",
    flag: "🇲🇺",
    code: "MU",
    dial_code: "+230"
  },
  {
    name: "Mayotte",
    flag: "🇾🇹",
    code: "YT",
    dial_code: "+262"
  },
  {
    name: "Mexico",
    flag: "🇲🇽",
    code: "MX",
    dial_code: "+52"
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    flag: "🇫🇲",
    code: "FM",
    dial_code: "+691"
  },
  {
    name: "Moldova",
    flag: "🇲🇩",
    code: "MD",
    dial_code: "+373"
  },
  {
    name: "Monaco",
    flag: "🇲🇨",
    code: "MC",
    dial_code: "+377"
  },
  {
    name: "Mongolia",
    flag: "🇲🇳",
    code: "MN",
    dial_code: "+976"
  },
  {
    name: "Montenegro",
    flag: "🇲🇪",
    code: "ME",
    dial_code: "+382"
  },
  {
    name: "Montserrat",
    flag: "🇲🇸",
    code: "MS",
    dial_code: "+1664"
  },
  {
    name: "Morocco",
    flag: "🇲🇦",
    code: "MA",
    dial_code: "+212"
  },
  {
    name: "Mozambique",
    flag: "🇲🇿",
    code: "MZ",
    dial_code: "+258"
  },
  {
    name: "Myanmar",
    flag: "🇲🇲",
    code: "MM",
    dial_code: "+95"
  },
  {
    name: "Namibia",
    flag: "🇳🇦",
    code: "NA",
    dial_code: "+264"
  },
  {
    name: "Nauru",
    flag: "🇳🇷",
    code: "NR",
    dial_code: "+674"
  },
  {
    name: "Nepal",
    flag: "🇳🇵",
    code: "NP",
    dial_code: "+977"
  },
  {
    name: "Netherlands",
    flag: "🇳🇱",
    code: "NL",
    dial_code: "+31"
  },
  {
    name: "Netherlands Antilles",
    flag: "",
    code: "AN",
    dial_code: "+599"
  },
  {
    name: "New Caledonia",
    flag: "🇳🇨",
    code: "NC",
    dial_code: "+687"
  },
  {
    name: "New Zealand",
    flag: "🇳🇿",
    code: "NZ",
    dial_code: "+64"
  },
  {
    name: "Nicaragua",
    flag: "🇳🇮",
    code: "NI",
    dial_code: "+505"
  },
  {
    name: "Niger",
    flag: "🇳🇪",
    code: "NE",
    dial_code: "+227"
  },
  {
    name: "Nigeria",
    flag: "🇳🇬",
    code: "NG",
    dial_code: "+234"
  },
  {
    name: "Niue",
    flag: "🇳🇺",
    code: "NU",
    dial_code: "+683"
  },
  {
    name: "Norfolk Island",
    flag: "🇳🇫",
    code: "NF",
    dial_code: "+672"
  },
  {
    name: "Northern Mariana Islands",
    flag: "🇲🇵",
    code: "MP",
    dial_code: "+1670"
  },
  {
    name: "Norway",
    flag: "🇳🇴",
    code: "NO",
    dial_code: "+47"
  },
  {
    name: "Oman",
    flag: "🇴🇲",
    code: "OM",
    dial_code: "+968"
  },
  {
    name: "Pakistan",
    flag: "🇵🇰",
    code: "PK",
    dial_code: "+92"
  },
  {
    name: "Palau",
    flag: "🇵🇼",
    code: "PW",
    dial_code: "+680"
  },
  {
    name: "Palestinian Territory, Occupied",
    flag: "🇵🇸",
    code: "PS",
    dial_code: "+970"
  },
  {
    name: "Panama",
    flag: "🇵🇦",
    code: "PA",
    dial_code: "+507"
  },
  {
    name: "Papua New Guinea",
    flag: "🇵🇬",
    code: "PG",
    dial_code: "+675"
  },
  {
    name: "Paraguay",
    flag: "🇵🇾",
    code: "PY",
    dial_code: "+595"
  },
  {
    name: "Peru",
    flag: "🇵🇪",
    code: "PE",
    dial_code: "+51"
  },
  {
    name: "Philippines",
    flag: "🇵🇭",
    code: "PH",
    dial_code: "+63"
  },
  {
    name: "Pitcairn",
    flag: "🇵🇳",
    code: "PN",
    dial_code: "+64"
  },
  {
    name: "Poland",
    flag: "🇵🇱",
    code: "PL",
    dial_code: "+48"
  },
  {
    name: "Portugal",
    flag: "🇵🇹",
    code: "PT",
    dial_code: "+351"
  },
  {
    name: "Puerto Rico",
    flag: "🇵🇷",
    code: "PR",
    dial_code: "+1939"
  },
  {
    name: "Qatar",
    flag: "🇶🇦",
    code: "QA",
    dial_code: "+974"
  },
  {
    name: "Romania",
    flag: "🇷🇴",
    code: "RO",
    dial_code: "+40"
  },
  {
    name: "Russia",
    flag: "🇷🇺",
    code: "RU",
    dial_code: "+7"
  },
  {
    name: "Rwanda",
    flag: "🇷🇼",
    code: "RW",
    dial_code: "+250"
  },
  {
    name: "Reunion",
    flag: "🇷🇪",
    code: "RE",
    dial_code: "+262"
  },
  {
    name: "Saint Barthelemy",
    flag: "🇧🇱",
    code: "BL",
    dial_code: "+590"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    flag: "🇸🇭",
    code: "SH",
    dial_code: "+290"
  },
  {
    name: "Saint Kitts and Nevis",
    flag: "🇰🇳",
    code: "KN",
    dial_code: "+1869"
  },
  {
    name: "Saint Lucia",
    flag: "🇱🇨",
    code: "LC",
    dial_code: "+1758"
  },
  {
    name: "Saint Martin",
    flag: "🇲🇫",
    code: "MF",
    dial_code: "+590"
  },
  {
    name: "Saint Pierre and Miquelon",
    flag: "🇵🇲",
    code: "PM",
    dial_code: "+508"
  },
  {
    name: "Saint Vincent and the Grenadines",
    flag: "🇻🇨",
    code: "VC",
    dial_code: "+1784"
  },
  {
    name: "Samoa",
    flag: "🇼🇸",
    code: "WS",
    dial_code: "+685"
  },
  {
    name: "San Marino",
    flag: "🇸🇲",
    code: "SM",
    dial_code: "+378"
  },
  {
    name: "Sao Tome and Principe",
    flag: "🇸🇹",
    code: "ST",
    dial_code: "+239"
  },
  {
    name: "Saudi Arabia",
    flag: "🇸🇦",
    code: "SA",
    dial_code: "+966"
  },
  {
    name: "Senegal",
    flag: "🇸🇳",
    code: "SN",
    dial_code: "+221"
  },
  {
    name: "Serbia",
    flag: "🇷🇸",
    code: "RS",
    dial_code: "+381"
  },
  {
    name: "Seychelles",
    flag: "🇸🇨",
    code: "SC",
    dial_code: "+248"
  },
  {
    name: "Sierra Leone",
    flag: "🇸🇱",
    code: "SL",
    dial_code: "+232"
  },
  {
    name: "Singapore",
    flag: "🇸🇬",
    code: "SG",
    dial_code: "+65"
  },
  {
    name: "Slovakia",
    flag: "🇸🇰",
    code: "SK",
    dial_code: "+421"
  },
  {
    name: "Slovenia",
    flag: "🇸🇮",
    code: "SI",
    dial_code: "+386"
  },
  {
    name: "Solomon Islands",
    flag: "🇸🇧",
    code: "SB",
    dial_code: "+677"
  },
  {
    name: "Somalia",
    flag: "🇸🇴",
    code: "SO",
    dial_code: "+252"
  },
  {
    name: "South Africa",
    flag: "🇿🇦",
    code: "ZA",
    dial_code: "+27"
  },
  {
    name: "South Sudan",
    flag: "🇸🇸",
    code: "SS",
    dial_code: "+211"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    flag: "🇬🇸",
    code: "GS",
    dial_code: "+500"
  },
  {
    name: "Spain",
    flag: "🇪🇸",
    code: "ES",
    dial_code: "+34"
  },
  {
    name: "Sri Lanka",
    flag: "🇱🇰",
    code: "LK",
    dial_code: "+94"
  },
  {
    name: "Sudan",
    flag: "🇸🇩",
    code: "SD",
    dial_code: "+249"
  },
  {
    name: "Suriname",
    flag: "🇸🇷",
    code: "SR",
    dial_code: "+597"
  },
  {
    name: "Svalbard and Jan Mayen",
    flag: "🇸🇯",
    code: "SJ",
    dial_code: "+47"
  },
  {
    name: "Swaziland",
    flag: "🇸🇿",
    code: "SZ",
    dial_code: "+268"
  },
  {
    name: "Sweden",
    flag: "🇸🇪",
    code: "SE",
    dial_code: "+46"
  },
  {
    name: "Switzerland",
    flag: "🇨🇭",
    code: "CH",
    dial_code: "+41"
  },
  {
    name: "Syrian Arab Republic",
    flag: "🇸🇾",
    code: "SY",
    dial_code: "+963"
  },
  {
    name: "Taiwan",
    flag: "🇹🇼",
    code: "TW",
    dial_code: "+886"
  },
  {
    name: "Tajikistan",
    flag: "🇹🇯",
    code: "TJ",
    dial_code: "+992"
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    flag: "🇹🇿",
    code: "TZ",
    dial_code: "+255"
  },
  {
    name: "Thailand",
    flag: "🇹🇭",
    code: "TH",
    dial_code: "+66"
  },
  {
    name: "Timor-Leste",
    flag: "🇹🇱",
    code: "TL",
    dial_code: "+670"
  },
  {
    name: "Togo",
    flag: "🇹🇬",
    code: "TG",
    dial_code: "+228"
  },
  {
    name: "Tokelau",
    flag: "🇹🇰",
    code: "TK",
    dial_code: "+690"
  },
  {
    name: "Tonga",
    flag: "🇹🇴",
    code: "TO",
    dial_code: "+676"
  },
  {
    name: "Trinidad and Tobago",
    flag: "🇹🇹",
    code: "TT",
    dial_code: "+1868"
  },
  {
    name: "Tunisia",
    flag: "🇹🇳",
    code: "TN",
    dial_code: "+216"
  },
  {
    name: "Turkey",
    flag: "🇹🇷",
    code: "TR",
    dial_code: "+90"
  },
  {
    name: "Turkmenistan",
    flag: "🇹🇲",
    code: "TM",
    dial_code: "+993"
  },
  {
    name: "Turks and Caicos Islands",
    flag: "🇹🇨",
    code: "TC",
    dial_code: "+1649"
  },
  {
    name: "Tuvalu",
    flag: "🇹🇻",
    code: "TV",
    dial_code: "+688"
  },
  {
    name: "Uganda",
    flag: "🇺🇬",
    code: "UG",
    dial_code: "+256"
  },
  {
    name: "Ukraine",
    flag: "🇺🇦",
    code: "UA",
    dial_code: "+380"
  },
  {
    name: "United Arab Emirates",
    flag: "🇦🇪",
    code: "AE",
    dial_code: "+971"
  },
  {
    name: "United Kingdom",
    flag: "🇬🇧",
    code: "GB",
    dial_code: "+44"
  },
  {
    name: "United States",
    flag: "🇺🇸",
    code: "US",
    dial_code: "+1"
  },
  {
    name: "Uruguay",
    flag: "🇺🇾",
    code: "UY",
    dial_code: "+598"
  },
  {
    name: "Uzbekistan",
    flag: "🇺🇿",
    code: "UZ",
    dial_code: "+998"
  },
  {
    name: "Vanuatu",
    flag: "🇻🇺",
    code: "VU",
    dial_code: "+678"
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    flag: "🇻🇪",
    code: "VE",
    dial_code: "+58"
  },
  {
    name: "Vietnam",
    flag: "🇻🇳",
    code: "VN",
    dial_code: "+84"
  },
  {
    name: "Virgin Islands, British",
    flag: "🇻🇬",
    code: "VG",
    dial_code: "+1284"
  },
  {
    name: "Virgin Islands, U.S.",
    flag: "🇻🇮",
    code: "VI",
    dial_code: "+1340"
  },
  {
    name: "Wallis and Futuna",
    flag: "🇼🇫",
    code: "WF",
    dial_code: "+681"
  },
  {
    name: "Yemen",
    flag: "🇾🇪",
    code: "YE",
    dial_code: "+967"
  },
  {
    name: "Zambia",
    flag: "🇿🇲",
    code: "ZM",
    dial_code: "+260"
  },
  {
    name: "Zimbabwe",
    flag: "🇿🇼",
    code: "ZW",
    dial_code: "+263"
  }
], fi = {
  beforeMount: function(u, e) {
    const D = (f) => {
      !u.contains(f.target) && u !== f.target && e.value(f);
    };
    u.__vueClickEventHandler__ = D, document.addEventListener("click", D);
  },
  unmounted: function(u) {
    document.removeEventListener("click", u.__vueClickEventHandler__);
  }
}, ti = z({
  directives: {
    clickOutside: fi
  },
  components: {
    QuestionMarkCircleIcon: jf,
    ExclamationCircleIcon: Mf,
    CheckIcon: Tf,
    XCircleIcon: Of,
    EyeIcon: _3,
    LoadingIcon: Je,
    Select: Di,
    Badge: lD,
    Tooltip: Pf
  },
  emits: ["update:modelValue", "update-batch"],
  props: {
    color: { type: String, default: "light" },
    clearable: { type: Boolean, default: !1 },
    getPhoneCountryCode: { type: Function },
    size: { type: String, default: "base" },
    loading: { type: Boolean, default: !1 },
    _veeValidateConfig: { type: Object },
    disabled: { type: Boolean, default: !1 },
    maxlength: { type: Number },
    autocomplete: { type: String, default: "off" },
    items: { type: Array, default: () => [] },
    selectedItem: { type: Object },
    fetchItems: { type: Function },
    groupedItems: {
      type: Array,
      default: () => []
    },
    itemName: { type: String, default: "élément" },
    itemsLoading: { type: Boolean, default: !1 },
    errorLoadingItems: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    badgeColor: { type: String, default: "primary" },
    badgeSize: { type: String, default: "lg" },
    name: { type: String, required: !0 },
    label: { type: String },
    modelValue: { type: [String, Array, Number, Date], default: void 0 },
    type: {
      type: String,
      default: "text"
    },
    decimalScale: { type: Number, default: 2 },
    // How many decimal digits to keep (e.g. 2 => x100)
    decimalSeparator: { type: String, default: "," },
    // Display separator in the input
    tooltip: { type: Boolean },
    tooltipHeader: { type: String },
    tooltipText: { type: String },
    subLabel: { type: String },
    hint: { type: String },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        },
        meta: {}
      })
    },
    validations: { type: Object, default: () => ({ exclusiveTests: {} }) },
    icon: { type: Function },
    autoCompleteItemComponent: { type: Object },
    placeholder: { type: String, default: "" },
    uuid: {
      type: Number,
      default: 0
    },
    component: { type: Object },
    model: { type: String },
    min: { type: [Date, Number, String, Object] },
    max: { type: [Date, Number, String, Object] },
    minSearchLengthToShowAutocomplete: { type: Number, default: 0 },
    selectAllOption: { type: Boolean, default: !1 },
    prefix: { type: String },
    hideValidationError: { type: Boolean, default: !1 },
    class: { type: String }
  },
  setup(u, { emit: e }) {
    const D = I(!1), f = w(
      () => u.type === "date" && !!u.placeholder && !u.modelValue && !D.value
    ), { debounce: t, keyBy: n, arraysEquals: a, pluralize: o } = fe(), r = I("FR"), l = n(B1, "code"), i = B1.sort((x, V) => x.code < V.code ? -1 : x.code > V.code ? 1 : 0).map((x) => ({ id: x.code, name: x.code, emoji: x.flag })), s = async (x) => {
      e("update:modelValue", l[x].dial_code);
    }, d = (x) => {
      if (u.type === "tel") {
        const V = l[r.value];
        if (x.startsWith("0") && x.length === 10) {
          e("update:modelValue", `${V.dial_code}${x.substring(1)}`);
          return;
        }
        if ((x.startsWith("6") || x.startsWith("7")) && x.length === 9) {
          e("update:modelValue", `${V.dial_code}${x}`);
          return;
        }
      }
      e("update:modelValue", x);
    };
    u.type === "tel" && au(
      () => u.validation,
      async (x) => {
        const V = x.meta.valid, K = l[r.value];
        if (V && !Array.isArray(u.modelValue) && u.modelValue && !u.modelValue.toString().startsWith(K.dial_code) && u.getPhoneCountryCode) {
          const _u = await u.getPhoneCountryCode(u.modelValue);
          _u && (r.value = _u);
        }
      }
    );
    const g = I(!1), h = I(!1), _ = I(u.modelValue), C = I(""), p = I(!1), b = I(!1), m = w(() => u.itemsLoading || b.value), F = I(-1), c = I(""), B = w(() => {
      const x = u.groupedItems.flatMap((V) => V.items);
      return x.length ? x : u.items;
    }), k = () => {
      u.type === "autocomplete" && (h.value = !0);
    }, A = () => {
      u.type === "autocomplete" && (h.value = !1);
    }, j = () => {
      C.value = "", p.value = !1, F.value = -1, u.type === "autocomplete" && (_.value = ""), u.multiple ? _.value = "" : u.type === "decimal" ? (c.value = "", e("update:modelValue", null)) : e("update:modelValue", "");
    }, T = (x) => {
      m.value || (p.value = !1, u.multiple ? (Array.isArray(u.modelValue) ? u.modelValue.map((V) => V.id).includes(x.id) ? e(
        "update:modelValue",
        u.modelValue.filter((V) => V.id !== x.id)
      ) : e("update:modelValue", u.modelValue.concat([JSON.parse(JSON.stringify(x))])) : u.modelValue === void 0 ? e("update:modelValue", [x]) : e("update:modelValue", [u.modelValue, x]), _.value = "") : (C.value = x.name, u.modelValue === x.id ? j() : e("update:modelValue", x.id), A()));
    }, S = (x) => {
      Array.isArray(u.modelValue) && e(
        "update:modelValue",
        u.modelValue.filter((V) => V.id !== x.id)
      );
    }, W = () => {
      if (u.type !== "autocomplete" || m.value)
        return;
      if (!h.value) {
        k(), F.value = B.value.length ? 1 : -1;
        return;
      }
      if (F.value === 0 && u.selectAllOption && u.multiple) {
        Du();
        return;
      }
      const x = B.value[F.value - 1];
      x && T(x);
    }, L = (x) => {
      const V = document.getElementById(`listbox-option-${x}`);
      V && V.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    }, H = (x) => {
      if (u.type === "autocomplete" && (x == null || x.preventDefault(), !m.value && F.value < B.value.length && h.value)) {
        const V = u.selectAllOption && u.multiple && u.items.length ? 0 : 1;
        F.value = Math.max(V, F.value + 1), L(F.value);
      }
    }, X = (x) => {
      if (u.type !== "autocomplete")
        return;
      x == null || x.preventDefault();
      const V = u.selectAllOption && u.multiple && u.items.length ? 0 : 1;
      !m.value && F.value > V && h.value && (F.value--, L(F.value));
    }, lu = (x) => u.multiple && u.modelValue ? !!u.modelValue.find((V) => V.id === x.id) : u.modelValue === x.id, yu = w({
      get: () => u.modelValue && u.type === "date" && !Array.isArray(u.modelValue) ? Ue(new Date(u.modelValue), "yyyy-MM-dd") : u.modelValue && u.type === "time" && !Array.isArray(u.modelValue) ? Ue(new Date(u.modelValue), "HH':'mm") : u.type === "autocomplete" ? _.value : u.type === "decimal" ? c.value : u.modelValue,
      set: (x) => {
        if (u.type === "decimal")
          c.value = typeof x == "string" ? Ce(x) : String(x ?? "");
        else if (u.type === "autocomplete")
          p.value = !0, F.value = -1, _.value = x, h.value || k();
        else if (u.type === "time" && x && typeof x == "string") {
          const [V, K] = x.split(":"), _u = new Date(1970, 0, 1);
          _u.setHours(parseInt(V)), _u.setMinutes(parseInt(K)), e("update:modelValue", _u);
        } else if (u.type === "date" && x && typeof x == "string") {
          const V = `${x}T00:00:00.000Z`;
          e("update:modelValue", V);
        } else
          u.type === "tel" && typeof x == "string" ? d(x) : e("update:modelValue", x);
      }
    }), Tu = w(() => {
      const x = Hu(u.min);
      return u.type === "date" && (typeof x == "string" || typeof x == "number" || x instanceof Date) ? Ue(new Date(x), "yyyy-MM-dd") : x == null ? void 0 : x.toString();
    }), Ru = w(() => {
      const x = Hu(u.max);
      return u.type === "date" && (typeof x == "string" || typeof x == "number" || x instanceof Date) ? Ue(new Date(x), "yyyy-MM-dd") : x == null ? void 0 : x.toString();
    }), Wu = w(() => {
      if (!u.multiple || !u.modelValue)
        return !1;
      const x = [...u.modelValue].sort(
        (K, _u) => K.id.localeCompare(_u.id)
      ), V = [...u.items].sort((K, _u) => K.id.localeCompare(_u.id));
      return a(x, V);
    }), Du = () => {
      u.multiple && (Wu.value ? e("update:modelValue", []) : e("update:modelValue", [...u.items])), A();
    }, tu = () => {
      var V;
      const x = B.value.find((K) => K.id === u.modelValue) ?? (((V = u.selectedItem) == null ? void 0 : V.id) === u.modelValue ? u.selectedItem : void 0);
      x ? (_.value = x.name, C.value = x.name) : C.value ? _.value = C.value : _.value = "", p.value = !1;
    }, wu = () => {
      if (D.value = !1, u.type === "decimal") {
        const x = ge(c.value, u.decimalScale);
        e("update:modelValue", x), c.value = te(x, u.decimalScale);
      }
      u.modelValue && u.type === "autocomplete" && tu(), u.validation.setTouched(!0);
    };
    if (u.type === "autocomplete") {
      const x = t(() => {
        const V = C.value === _.value ? "" : _.value, K = u.fetchItems && u.fetchItems(V);
        return Eu(() => {
          b.value = !1;
        }), K;
      });
      au(
        _,
        () => {
          const V = C.value === _.value ? "" : _.value;
          return b.value = !!u.fetchItems && typeof V == "string" && !!V.length && V.length >= u.minSearchLengthToShowAutocomplete, x();
        }
      ), u.modelValue && (u.items.length || u.groupedItems) && tu(), au(
        () => u.modelValue,
        (V, K) => {
          !V && K && j(), u.multiple || (V !== K && (C.value = ""), tu());
        }
      ), au(
        [() => u.items, () => u.groupedItems, () => u.selectedItem],
        () => {
          F.value = -1, u.modelValue && !u.multiple && !p.value && tu();
        }
      ), au(
        () => u.disabled,
        (V) => {
          V ? (_.value = "", F.value = -1) : u.modelValue && !u.multiple && tu();
        }
      );
    }
    const hu = w(() => u.groupedItems.filter((x) => x.items.length > 0)), qu = w(() => hu.value.length <= 1), Gu = w(() => {
      let x = 1;
      return hu.value.map((V) => {
        const K = x;
        return x += V.items.length, K;
      });
    }), Pu = w(() => u.type === "decimal"), Xu = (x) => Math.pow(10, x), Ce = (x) => {
      let V = x;
      V = V.replace(/[^\d,.-]/g, ""), V = V.replace(/(?!^)-/g, "");
      const K = V.indexOf(","), _u = V.indexOf("."), ae = [K, _u].filter((CD) => CD !== -1), Zu = ae.length ? Math.min(...ae) : -1;
      if (Zu !== -1) {
        const CD = V.slice(0, Zu + 1), H0 = V.slice(Zu + 1).replace(/[.,]/g, "");
        V = CD + H0;
      }
      const [Ee, zf] = V.replace(",", ".").split(".");
      return zf != null && (V = `${Ee}${V.includes(",") ? "," : "."}${zf.slice(0, u.decimalScale)}`), V;
    }, ge = (x, V) => {
      const K = x.trim();
      if (K === "" || K === "-" || K === "," || K === "." || K === "-," || K === "-." || K.endsWith(",") || K.endsWith("."))
        return null;
      const _u = K.replace(",", ".");
      if (!/^-?\d+(\.\d+)?$/.test(_u))
        return null;
      const [, ae = ""] = _u.split(".");
      if (ae.length > V)
        return null;
      const Zu = Xu(V), Ee = Number(_u);
      return Number.isNaN(Ee) ? null : Math.round((Ee + Number.EPSILON) * Zu);
    }, te = (x, V) => {
      if (x == null)
        return "";
      const K = Xu(V), _u = x < 0 ? "-" : "", ae = Math.abs(x), Zu = Math.floor(ae / K).toString(), Ee = (ae % K).toString().padStart(V, "0");
      return V > 0 ? `${_u}${Zu}${u.decimalSeparator}${Ee}` : `${_u}${Zu}`;
    }, dD = w(() => g.value || u.type === "autocomplete" || Pu.value ? "text" : u.type), sD = w(() => {
      if (Pu.value)
        return "-?[0-9]+([.,][0-9]*)?";
    }), cD = w(() => {
      if (Pu.value)
        return "decimal";
      if (u.type === "tel")
        return "tel";
    }), FD = (x) => {
      if (!Pu.value)
        return;
      const V = x.target, K = Ce(V.value);
      K !== V.value && (V.value = K), c.value = K, K === "" && e("update:modelValue", null);
    };
    return au(
      () => u.modelValue,
      (x) => {
        if (!Pu.value)
          return;
        const V = typeof x == "number" ? x : x == null ? null : Number(x);
        c.value = Number.isNaN(V) ? "" : te(V, u.decimalScale);
      },
      { immediate: !0 }
    ), {
      isFocused: D,
      showDatePlaceholder: f,
      decimalText: c,
      computedInputType: dD,
      computedInputMode: cD,
      computedPattern: sD,
      onInput: FD,
      pluralize: o,
      phoneCode: r,
      phoneCodes: i,
      updatePhoneCode: s,
      onInputEnter: W,
      goDown: H,
      goUp: X,
      search: _,
      showPassword: g,
      isItemListOpen: h,
      isAutocompleteLoading: m,
      isSelected: lu,
      selectItem: T,
      openItemList: k,
      closeItemList: A,
      value: yu,
      activeItem: F,
      clear: j,
      updateInput: d,
      minValue: Tu,
      maxValue: Ru,
      removeBadge: S,
      areAllSelected: Wu,
      selectAll: Du,
      onBlur: wu,
      groupStartIndexes: Gu,
      nonEmptyGroups: hu,
      hideLabels: qu
    };
  }
}), ai = ["for"], ni = {
  key: 0,
  class: "text-xs text-gray-500 font-normal"
}, oi = { class: "text-sm" }, ri = { class: "font-medium text-gray-900" }, li = { class: "font-light text-gray-500" }, ii = {
  key: 0,
  class: "flex select-none items-center pl-3 text-gray-500 sm:text-sm"
}, di = {
  key: 1,
  class: "pl-3 flex items-center pointer-events-none"
}, si = /* @__PURE__ */ v("div", { class: "animate-pulse h-3 bg-gray-200 rounded w-5/6" }, null, -1), ci = [
  si
], Fi = {
  key: 3,
  class: "flex items-center"
}, Ci = /* @__PURE__ */ v("label", {
  class: "sr-only",
  for: "phoneCode"
}, "Indicatif", -1), Ei = ["id", "autocomplete", "aria-label", "disabled", "inputmode", "max", "maxlength", "min", "name", "pattern", "placeholder", "required", "type"], mi = { class: "truncate" }, pi = {
  key: 1,
  class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
}, bi = {
  key: 4,
  class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
}, gi = {
  key: 5,
  class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
}, vi = ["aria-activedescendant", "aria-busy"], hi = {
  key: 0,
  class: "text-gray-400 cursor-default select-none relative py-2 pl-3 pr-9"
}, Bi = { class: "lowercase" }, yi = { key: 2 }, _i = { key: 0 }, wi = {
  key: 0,
  class: "z-10 sticky top-0 border-t border-b border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-500 uppercase"
}, ki = { key: 1 }, Ai = ["id", "onClick", "onMouseenter"], xi = ["id", "onClick", "onMouseenter"], $i = {
  key: 1,
  class: "mt-2"
}, Si = { class: "flex gap-2 flex-wrap" }, Ti = {
  key: 2,
  class: "mt-1 text-xs text-gray-500"
}, Mi = {
  key: 3,
  class: "mt-1 min-h-5 text-red-600 text-xs"
}, Oi = { key: 0 }, Ii = { key: 1 };
function Pi(u, e, D, f, t, n) {
  const a = P("QuestionMarkCircleIcon"), o = P("Tooltip"), r = P("Select"), l = P("EyeIcon"), i = P("LoadingIcon"), s = P("XCircleIcon"), d = P("ExclamationCircleIcon"), g = P("CheckIcon"), h = P("Badge"), _ = J0("click-outside");
  return qe((E(), y("div", {
    class: M({ "opacity-50": u.disabled })
  }, [
    u.label || u.subLabel || u.tooltip ? (E(), y("label", {
      key: 0,
      for: u.name,
      class: M([u.color === "dark" ? "text-primary-100" : "text-gray-700", "block align-middle text-sm font-medium"])
    }, [
      G(O(u.label) + " ", 1),
      u.subLabel ? (E(), y("p", ni, O(u.subLabel), 1)) : R("", !0),
      u.tooltip && !u.disabled ? (E(), q(o, { key: 1 }, {
        trigger: N(() => [
          U(a, { class: "h-5 w-5 text-gray-400 hover:text-gray-500" })
        ]),
        content: N(() => [
          v("div", oi, [
            v("p", ri, O(u.tooltipHeader), 1),
            v("p", li, O(u.tooltipText), 1)
          ])
        ]),
        _: 1
      })) : R("", !0)
    ], 10, ai)) : R("", !0),
    v("div", {
      class: M([{ "mt-1": u.label || u.subLabel || u.tooltip }, "flex relative"])
    }, [
      v("div", {
        class: M([[
          u.color === "dark" ? "bg-primary-600" : "",
          u.validation.errorMessage ? "border-red-300 focus-within:ring-1 focus-within:outline-none focus-within:ring-red-500 focus-within:border-red-500 pr-10" : [
            u.color === "dark" ? "border-primary-700" : "border-gray-300",
            "focus-within:ring-1 focus-within:outline-none focus-within:ring-primary-400 focus-within:border-primary-400"
          ]
        ], "flex justify-between rounded-md border shadow-sm w-full"])
      }, [
        u.prefix ? (E(), y("span", ii, O(u.prefix), 1)) : u.icon ? (E(), y("div", di, [
          (E(), q(xu(u.icon), { class: "h-5 w-5 text-gray-400" }))
        ])) : R("", !0),
        u.loading && u.type !== "autocomplete" ? (E(), y("div", {
          key: 2,
          class: M([{ "pl-10": u.icon, "pr-12": u.type === "password" }, "absolute inset-0 py-3 px-4 w-full flex items-center"])
        }, ci, 2)) : R("", !0),
        u.type === "tel" ? (E(), y("div", Fi, [
          Ci,
          U(r, {
            modelValue: u.phoneCode,
            "onUpdate:modelValue": [
              e[0] || (e[0] = (C) => u.phoneCode = C),
              u.updatePhoneCode
            ],
            "hide-validation-error": !0,
            items: u.phoneCodes,
            required: !0,
            "show-selected-tick": !1,
            class: "w-24",
            color: "transparent",
            name: "phoneCode",
            size: "lg"
          }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
        ])) : R("", !0),
        qe(v("input", {
          id: u.name,
          ref: u.name,
          "onUpdate:modelValue": e[1] || (e[1] = (C) => u.value = C),
          autocomplete: u.autocomplete,
          "aria-label": u.label || u.placeholder || u.name,
          style: re({
            colorScheme: u.color === "dark" ? "dark" : void 0,
            color: u.showDatePlaceholder ? "transparent" : void 0
          }),
          class: M([[
            {
              "bg-primary-600": u.color === "dark",
              "pr-14": u.type === "autocomplete",
              "pr-10": u.clearable && u.type !== "autocomplete" && u.type !== "password" && (u.type !== "date" || !!u.modelValue),
              "cursor-not-allowed": u.disabled,
              "p-3": u.size === "lg",
              "rounded-l-none focus-within:z-0": u.type === "tel",
              "pl-1": u.prefix,
              "pr-12": u.type === "password",
              "text-opacity-0 placeholder-opacity-0": u.loading && u.type !== "autocomplete",
              "sentry-mask": u.type === "password" || u.name === "IBAN"
            },
            u.validation.errorMessage ? "text-red-900 placeholder-red-300" : u.color === "dark" ? "text-white placeholder-gray-300" : "text-gray-900 placeholder-gray-400"
          ], "border-0 block w-full sm:text-sm rounded-md focus:ring-0"]),
          disabled: u.disabled,
          inputmode: u.computedInputMode,
          max: u.maxValue,
          maxlength: u.maxlength,
          min: u.minValue,
          name: u.name,
          pattern: u.computedPattern,
          placeholder: u.placeholder,
          required: u.validations.exclusiveTests.required,
          type: u.computedInputType,
          onFocus: e[2] || (e[2] = (C) => u.isFocused = !0),
          onBlur: e[3] || (e[3] = (...C) => u.onBlur && u.onBlur(...C)),
          onClick: e[4] || (e[4] = (...C) => u.openItemList && u.openItemList(...C)),
          onInput: e[5] || (e[5] = (...C) => u.onInput && u.onInput(...C)),
          onKeydown: [
            e[6] || (e[6] = Nu(ju((...C) => u.onInputEnter && u.onInputEnter(...C), ["prevent"]), ["enter"])),
            e[7] || (e[7] = Nu((...C) => u.closeItemList && u.closeItemList(...C), ["tab"])),
            e[8] || (e[8] = Nu((...C) => u.goUp && u.goUp(...C), ["up"])),
            e[9] || (e[9] = Nu((...C) => u.goDown && u.goDown(...C), ["down"])),
            e[10] || (e[10] = Nu((...C) => u.closeItemList && u.closeItemList(...C), ["esc"]))
          ]
        }, null, 46, Ei), [
          [ut, u.value]
        ]),
        u.showDatePlaceholder ? (E(), y("span", {
          key: 4,
          "aria-hidden": "true",
          class: M([u.color === "dark" ? "text-gray-300" : "text-gray-400", "pointer-events-none absolute inset-y-0 left-3 right-10 flex items-center text-sm"])
        }, [
          v("span", mi, O(u.placeholder), 1)
        ], 2)) : R("", !0)
      ], 2),
      v("div", {
        class: M([{ "text-red-500": u.validation.errorMessage }, "text-gray-400 group"])
      }, [
        u.type === "password" ? (E(), y("button", {
          key: 0,
          class: "absolute inset-y-0 right-0 px-3 hover:text-gray-500 active:text-gray-900",
          type: "button",
          onMousedown: e[11] || (e[11] = (C) => u.showPassword = !0),
          onMouseleave: e[12] || (e[12] = (C) => u.showPassword = !1),
          onMouseup: e[13] || (e[13] = (C) => u.showPassword = !1),
          onTouchend: e[14] || (e[14] = (C) => u.showPassword = !1),
          onTouchstart: e[15] || (e[15] = (C) => u.showPassword = !0),
          onKeydown: e[16] || (e[16] = Nu((C) => u.showPassword = !0, ["enter"])),
          onKeyup: e[17] || (e[17] = Nu((C) => u.showPassword = !1, ["enter"]))
        }, [
          U(l, {
            class: M([{ "opacity-0": !!u.validation.errorMessage }, "h-5 w-5 group-hover:opacity-100"])
          }, null, 8, ["class"])
        ], 32)) : u.type === "autocomplete" && u.isAutocompleteLoading && u.isItemListOpen ? (E(), y("div", pi, [
          U(i, { class: "h-5 w-5 text-primary-900" })
        ])) : u.type === "autocomplete" && u.search && !u.validation.errorMessage && u.clearable ? (E(), y("button", {
          key: 2,
          class: M([u.color === "dark" ? "hover:text-white" : "hover:text-gray-500", "absolute inset-y-0 right-0 inline-flex items-center px-3 border border-transparent rounded-md text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-400"]),
          type: "button",
          onClick: e[18] || (e[18] = ju((...C) => u.clear && u.clear(...C), ["stop"])),
          onKeydown: e[19] || (e[19] = Nu(ju((...C) => u.clear && u.clear(...C), ["stop"]), ["enter"]))
        }, [
          U(s, {
            "aria-hidden": "true",
            class: M([{ "bg-white": u.color !== "dark" }, "h-5 w-5"])
          }, null, 8, ["class"])
        ], 34)) : u.type !== "autocomplete" && u.clearable && !u.validation.errorMessage && !u.loading && (u.type === "decimal" ? u.decimalText : u.modelValue != null && u.modelValue !== "") ? (E(), y("button", {
          key: 3,
          class: M([u.color === "dark" ? "hover:text-white" : "hover:text-gray-500", "absolute inset-y-0 right-0 inline-flex items-center px-3 border border-transparent rounded-md text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-400"]),
          type: "button",
          onClick: e[20] || (e[20] = ju((...C) => u.clear && u.clear(...C), ["stop"])),
          onKeydown: e[21] || (e[21] = Nu(ju((...C) => u.clear && u.clear(...C), ["stop"]), ["enter"]))
        }, [
          U(s, {
            "aria-hidden": "true",
            class: M([{ "bg-white": u.color !== "dark" }, "h-5 w-5"])
          }, null, 8, ["class"])
        ], 34)) : R("", !0),
        u.validation.errorMessage && !u.isAutocompleteLoading ? (E(), y("div", bi, [
          U(d, {
            class: M([{ "group-hover:opacity-0": u.type === "password" }, "h-5 w-5"])
          }, null, 8, ["class"])
        ])) : (E(), y("div", gi, [
          fu(u.$slots, "icon-after")
        ]))
      ], 2),
      U(_e, {
        "leave-active-class": "transition ease-in duration-100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: N(() => [
          u.type === "autocomplete" && (u.search != null && u.search.length >= u.minSearchLengthToShowAutocomplete || u.minSearchLengthToShowAutocomplete === 0) ? qe((E(), y("ul", {
            key: 0,
            class: M([{
              "divide divide-y divide-gray-200": u.autoCompleteItemComponent,
              "py-1": !u.nonEmptyGroups.length,
              "pointer-events-none": u.isAutocompleteLoading
            }, "absolute z-30 mt-12 w-full bg-white shadow-lg max-h-60 rounded-md py-0 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"]),
            "aria-activedescendant": u.activeItem >= 0 ? `listbox-option-${u.activeItem}` : void 0,
            "aria-busy": u.isAutocompleteLoading,
            "aria-labelledby": "listbox-label",
            role: "listbox",
            tabindex: "-1"
          }, [
            !u.isAutocompleteLoading && !u.items.length && !u.nonEmptyGroups.length ? (E(), y("li", hi, " Aucun résultat ")) : R("", !0),
            u.selectAllOption && u.multiple && u.items.length ? (E(), y("li", {
              key: 1,
              id: "listbox-option-0",
              class: M([
                u.activeItem === 0 ? "text-white bg-primary-400" : "text-primary-400",
                "cursor-default select-none relative py-2 pl-3 pr-9"
              ]),
              onClick: e[22] || (e[22] = (...C) => u.selectAll && u.selectAll(...C)),
              onMouseenter: e[23] || (e[23] = (C) => u.activeItem = 0),
              onMouseleave: e[24] || (e[24] = (C) => u.activeItem = -1)
            }, [
              v("span", {
                class: M([u.areAllSelected ? "font-semibold" : "font-normal", "block truncate"])
              }, [
                G(" Tout " + O(u.areAllSelected ? "désélectionner" : "sélectionner") + " (" + O(u.items.length) + " ", 1),
                v("span", Bi, O(u.pluralize(u.itemName, u.items.length)), 1),
                G(") ")
              ], 2),
              u.areAllSelected ? (E(), y("span", {
                key: 0,
                class: M([
                  u.activeItem ? "text-white" : "text-primary-400",
                  "absolute inset-y-0 right-0 flex items-center pr-4"
                ])
              }, [
                U(g, {
                  "aria-hidden": "true",
                  class: "h-5 w-5"
                })
              ], 2)) : R("", !0)
            ], 34)) : R("", !0),
            u.autoCompleteItemComponent ? (E(), y("div", yi, [
              u.nonEmptyGroups.length ? (E(), y("li", _i, [
                (E(!0), y(J, null, du(u.nonEmptyGroups, (C, p) => (E(), y("div", {
                  key: C.label
                }, [
                  u.hideLabels ? R("", !0) : (E(), y("div", wi, O(C.label), 1)),
                  u.autoCompleteItemComponent && C.items.length ? (E(), y("div", ki, [
                    (E(!0), y(J, null, du(C.items, (b, m) => (E(), q(xu(u.autoCompleteItemComponent), {
                      key: b.id,
                      "is-active": u.activeItem === u.groupStartIndexes[p] + m,
                      "is-selected": u.isSelected(b),
                      item: b,
                      onClick: (F) => u.selectItem(b),
                      onMouseenter: (F) => u.activeItem = u.groupStartIndexes[p] + m,
                      onMouseleave: e[25] || (e[25] = (F) => u.activeItem = -1)
                    }, null, 40, ["is-active", "is-selected", "item", "onClick", "onMouseenter"]))), 128))
                  ])) : (E(!0), y(J, { key: 2 }, du(C.items, (b, m) => (E(), y("li", {
                    id: `listbox-option-${u.groupStartIndexes[p] + m}`,
                    key: b.id,
                    class: M([
                      u.activeItem === u.groupStartIndexes[p] + m ? "text-white bg-primary-400" : "text-gray-900",
                      "cursor-default select-none relative py-2 pl-3 pr-9"
                    ]),
                    role: "option",
                    onClick: (F) => u.selectItem(b),
                    onMouseenter: (F) => u.activeItem = u.groupStartIndexes[p] + m,
                    onMouseleave: e[26] || (e[26] = (F) => u.activeItem = -1)
                  }, O(b.name), 43, Ai))), 128))
                ]))), 128))
              ])) : (E(!0), y(J, { key: 1 }, du(u.items, (C, p) => (E(), q(xu(u.autoCompleteItemComponent), {
                key: p,
                "is-active": u.activeItem === p + 1,
                "is-selected": u.isSelected(C),
                item: C,
                onClick: (b) => u.selectItem(C),
                onMouseenter: (b) => u.activeItem = p + 1,
                onMouseleave: e[27] || (e[27] = (b) => u.activeItem = -1)
              }, null, 40, ["is-active", "is-selected", "item", "onClick", "onMouseenter"]))), 128))
            ])) : (E(!0), y(J, { key: 3 }, du(u.items, (C, p) => (E(), y("li", {
              id: `listbox-option-${p + 1}`,
              key: C.id,
              class: M([
                u.activeItem === p + 1 ? "text-white bg-primary-400" : "text-gray-900",
                "cursor-default select-none relative py-2 pl-3 pr-9 "
              ]),
              role: "option",
              onClick: (b) => u.selectItem(C),
              onMouseenter: (b) => u.activeItem = p + 1,
              onMouseleave: e[28] || (e[28] = (b) => u.activeItem = -1)
            }, [
              v("span", {
                class: M([u.isSelected(C) || C.description ? "font-semibold" : "font-normal", "block"])
              }, O(C.name), 3),
              C.description ? (E(), y("span", {
                key: 0,
                class: M([u.activeItem === p + 1 ? "text-white" : "text-gray-500", "block text-xs mt-1"])
              }, O(C.description), 3)) : R("", !0),
              u.isSelected(C) ? (E(), y("span", {
                key: 1,
                class: M([
                  u.activeItem === p + 1 ? "text-white" : "text-primary-400",
                  "absolute inset-y-0 right-0 flex items-center pr-4"
                ])
              }, [
                U(g, { class: "h-5 w-5" })
              ], 2)) : R("", !0)
            ], 42, xi))), 128))
          ], 10, vi)), [
            [et, u.isItemListOpen && (!u.isAutocompleteLoading || u.items.length || u.nonEmptyGroups.length)]
          ]) : R("", !0)
        ]),
        _: 1
      })
    ], 2),
    u.type === "autocomplete" && u.multiple ? (E(), y("div", $i, [
      v("div", Si, [
        (E(!0), y(J, null, du(u.modelValue, (C) => (E(), q(h, {
          key: C.id,
          color: u.badgeColor,
          item: C,
          size: u.badgeSize,
          clearable: "",
          onRemove: (p) => u.removeBadge(C)
        }, {
          default: N(() => [
            G(O(C.name), 1)
          ]),
          _: 2
        }, 1032, ["color", "item", "size", "onRemove"]))), 128))
      ])
    ])) : R("", !0),
    u.hint ? (E(), y("p", Ti, O(u.hint), 1)) : R("", !0),
    u.hideValidationError ? R("", !0) : (E(), y("p", Mi, [
      u.errorLoadingItems ? (E(), y("span", Oi, "Erreur lors du chargement de la liste. Veuillez réessayer plus tard.")) : (E(), y("span", Ii, O(u.validation.errorMessage), 1))
    ]))
  ], 2)), [
    [_, u.closeItemList]
  ]);
}
const Y0 = /* @__PURE__ */ Q(ti, [["render", Pi]]), Li = z({
  components: {
    ExclamationCircleIcon: Mf
  },
  emits: ["update:modelValue", "update-batch"],
  props: {
    _veeValidateConfig: { type: Object },
    disabled: { type: Boolean, default: !1 },
    rows: { type: Number, default: 10 },
    maxlength: { type: Number },
    name: { type: String, required: !0 },
    label: { type: String },
    underlineText: { type: String },
    subtitle: { type: String },
    modelValue: { type: String, default: "" },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        },
        meta: {}
      })
    },
    validations: { type: Object, default: () => ({}) },
    placeholder: { type: String, default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(u, { emit: e }) {
    return { updateModelValue: (f) => {
      const t = f.target;
      e("update:modelValue", t.value);
    } };
  }
}), Ri = ["for"], Ni = {
  key: 0,
  class: "text-xs text-gray-500"
}, ji = { class: "mt-1 relative rounded-md" }, Vi = {
  key: 0,
  class: "absolute inset-0 py-3 px-4 w-full flex flex-col gap-2"
}, zi = ["id", "disabled", "maxlength", "name", "placeholder", "required", "rows", "value"], Ui = {
  key: 0,
  class: "rounded-b-md border-t border-gray-300 bg-gray-50 px-3 text-gray-500 sm:text-sm whitespace-pre-line py-2 text-left"
}, Wi = {
  key: 0,
  class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
}, qi = { class: "mt-1 min-h-5 text-red-600 text-xs" };
function Yi(u, e, D, f, t, n) {
  const a = P("ExclamationCircleIcon");
  return E(), y("div", {
    class: M({ "opacity-50": u.disabled })
  }, [
    v("label", {
      for: u.name,
      class: "block text-sm font-medium text-gray-700"
    }, O(u.label), 9, Ri),
    u.subtitle ? (E(), y("p", Ni, O(u.subtitle), 1)) : R("", !0),
    v("div", ji, [
      u.loading ? (E(), y("div", Vi, [
        (E(!0), y(J, null, du(u.rows, (o) => (E(), y("div", {
          key: o,
          class: "animate-pulse h-3 bg-gray-200 rounded w-full"
        }))), 128))
      ])) : R("", !0),
      v("div", {
        class: M([[
          u.validation.errorMessage ? "border-red-300 focus-within:ring-1 focus-within:outline-none focus-within:ring-red-500 focus-within:border-red-500 pr-10" : "border-gray-300 focus-within:ring-1 focus-within:outline-none focus-within:ring-primary-400 focus-within:border-primary-400"
        ], "overflow-hidden rounded-lg border shadow-sm"])
      }, [
        v("textarea", {
          id: u.name,
          class: M([[
            u.validation.errorMessage ? "text-red-900 placeholder-red-300" : "text-gray-900 placeholder-gray-400"
          ], "w-full border-0 py-3 focus:ring-0 sm:text-sm"]),
          disabled: u.disabled,
          maxlength: u.maxlength,
          name: u.name,
          placeholder: u.loading ? "" : u.placeholder,
          required: u.validations.exclusiveTests ? u.validations.exclusiveTests.required : !1,
          rows: u.rows,
          value: u.modelValue,
          onBlur: e[0] || (e[0] = (o) => u.validation.setTouched(!0)),
          onInput: e[1] || (e[1] = (...o) => u.updateModelValue && u.updateModelValue(...o))
        }, null, 42, zi),
        u.underlineText ? (E(), y("div", Ui, O(u.underlineText), 1)) : R("", !0)
      ], 2),
      v("div", {
        class: M([{ "text-red-500": u.validation.errorMessage }, "text-gray-400 group"])
      }, [
        u.validation.errorMessage ? (E(), y("div", Wi, [
          U(a, { class: "h-5 w-5" })
        ])) : R("", !0)
      ], 2)
    ]),
    v("p", qi, O(u.validation.errorMessage), 1)
  ], 2);
}
const o4 = /* @__PURE__ */ Q(Li, [["render", Yi]]), Hi = z({
  components: {
    XMarkIcon: If,
    PaperClipIcon: k3,
    Button: Pe
  },
  emits: ["update:modelValue", "update-batch"],
  props: {
    isViewable: { type: Boolean, default: !1 },
    _veeValidateConfig: { type: Object },
    disabled: { type: Boolean, default: !1 },
    name: { type: String, required: !0 },
    label: { type: String },
    subtitle: { type: String },
    fileExtensions: { type: Array, default: () => ["png", "jpeg", "jpg", "pdf"] },
    fileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpeg", "image/jpg", "application/pdf"]
    },
    fileSize: { type: Number, default: 5 },
    fileNumber: { type: Number, default: 1 },
    modelValue: {
      type: Object,
      default: ({ fileNumber: u }) => {
        if (u !== 1)
          return new Array();
      }
    },
    title: {
      type: String,
      default: ({ fileNumber: u }) => u === 1 ? "Importer un fichier" : "Importer des fichiers"
    },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        },
        meta: {}
      })
    },
    validations: { type: Object, default: () => ({}) },
    uploadFile: { type: Function, default: () => () => ({}) },
    deleteFile: { type: Function, default: () => () => ({}) }
  },
  setup(u) {
    const e = I(!1), D = I(""), { pluralize: f } = fe(), t = ({
      file: d,
      fileEntity: g
    }) => Qe({
      file: d,
      fileEntity: g,
      isUploading: !1,
      progress: 0,
      currentProgress: 0,
      step: 0.5,
      isDeleting: !1,
      interval: null
    }), n = (d) => {
      d.isUploading = !0, d.interval = setInterval(() => {
        d.currentProgress += d.step, d.progress = Math.round(Math.atan(d.currentProgress) / (Math.PI / 2) * 100 * 1e3) / 1e3, d.progress >= 100 && d.interval ? clearInterval(d.interval) : d.progress >= 70 && (d.step = 0.1);
      }, 100);
    }, a = (d) => {
      d.currentProgress = 100, setTimeout(() => {
        d.isUploading = !1, d.interval && clearInterval(d.interval);
      }, 250);
    }, o = I(new Array());
    au(
      () => u.modelValue,
      (d) => {
        d && (!Array.isArray(d) && u.fileNumber === 1 ? o.value = [t({ fileEntity: d })] : o.value = d.map(
          (g) => t({ fileEntity: g })
        ));
      },
      { immediate: !0 }
    );
    const r = (d) => {
      if (D.value = "", d.length + o.value.length > u.fileNumber)
        return D.value = `Le nombre de fichiers est limité à ${u.fileNumber}`, !1;
      for (const g of d) {
        const h = g.name.split(".").pop();
        if (!h || !u.fileExtensions.includes(h))
          return D.value = "Le type de fichier n'est pas pris en charge.", !1;
        if (!u.fileTypes.includes(g.type))
          return D.value = "Le format du fichier n'est pas pris en charge.", !1;
        if (g.size > u.fileSize * 1e6)
          return D.value = `Le fichier est trop volumineux. La taille maximum est de ${u.fileSize} MB.`, !1;
      }
      return !0;
    };
    return {
      pluralize: f,
      handleUpload: async (d) => {
        const g = d.target;
        if (g && g.files && g.files.length) {
          const h = Array.from(g.files);
          r(h) && await Promise.all(
            h.map(async (C) => {
              const p = t({ file: C });
              o.value.push(p), n(p), p.fileEntity = await u.uploadFile(p.file), a(p);
            })
          );
        }
      },
      files: o,
      isDraggedOver: e,
      customErrorMessage: D,
      handleDelete: async (d) => {
        if (d.fileEntity) {
          const g = d.fileEntity.id;
          d.isDeleting = !0, await u.deleteFile(g) && (o.value = o.value.filter((_) => !_.fileEntity || _.fileEntity.id !== g)), d.isDeleting = !1;
        }
      },
      openFile: (d) => {
        if (d) {
          const g = window.open(d, "_blank");
          g && g.focus();
        }
      }
    };
  }
}), Gi = { class: "max-w-2xl" }, Xi = ["for"], Zi = { class: "text-xs text-gray-500" }, Ki = {
  key: 0,
  class: "border border-gray-200 rounded-md divide-y divide-gray-200 mt-1",
  role: "list"
}, Qi = { class: "w-0 flex-1 flex items-center" }, Ji = { class: "ml-2 flex-1 w-0 truncate" }, ud = {
  key: 0,
  class: "italic text-primary-400 font-medium"
}, ed = {
  key: 1,
  class: "text-primary-400"
}, Dd = { class: "ml-4 flex-shrink-0" }, fd = {
  key: 0,
  class: "py-2.5"
}, td = { class: "w-24 bg-gray-200 rounded-full h-2.5" }, ad = {
  key: 1,
  class: "mt-3"
}, nd = ["for"], od = ["id", "multiple", "name"], rd = { class: "space-y-1 text-center" }, ld = /* @__PURE__ */ v("svg", {
  "aria-hidden": "true",
  class: "mx-auto h-12 w-12 text-gray-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ v("path", {
    d: "M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1"
  })
], -1), id = { class: "flex flex-col sm:flex-row text-sm text-gray-600" }, dd = { class: "relative cursor-pointer rounded-md font-medium text-primary-400 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500" }, sd = /* @__PURE__ */ v("span", { class: "pl-1" }, "ou glisser et déposer", -1), cd = { class: "text-xs text-gray-500" }, Fd = { key: 0 }, Cd = { key: 1 }, Ed = { class: "mt-1 min-h-5 text-red-600 text-xs" };
function md(u, e, D, f, t, n) {
  const a = P("PaperClipIcon"), o = P("Button"), r = P("XMarkIcon");
  return E(), y("div", Gi, [
    v("label", {
      for: u.name,
      class: "block text-sm font-medium text-gray-900"
    }, O(u.label), 9, Xi),
    v("p", Zi, O(u.subtitle), 1),
    u.files.length ? (E(), y("ul", Ki, [
      (E(!0), y(J, null, du(u.files, (l, i) => (E(), y("li", {
        key: i,
        class: "pl-3 pr-4 py-1 flex items-center justify-between text-sm"
      }, [
        v("div", Qi, [
          U(a, {
            "aria-hidden": "true",
            class: "flex-shrink-0 h-5 w-5 text-gray-400"
          }),
          v("span", Ji, [
            l.isUploading && l.file ? (E(), y("span", ud, O(l.file.name), 1)) : l.fileEntity && !u.isViewable ? (E(), y("span", ed, O(l.fileEntity.originalName), 1)) : l.fileEntity && u.isViewable ? (E(), q(o, {
              key: 2,
              type: "link",
              onClick: (s) => {
                var d;
                return u.openFile((d = l.fileEntity) == null ? void 0 : d.url);
              }
            }, {
              default: N(() => [
                G(O(l.fileEntity.originalName), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])) : R("", !0)
          ])
        ]),
        v("div", Dd, [
          l.isUploading ? (E(), y("div", fd, [
            v("div", td, [
              v("div", {
                style: re(`width: ${l.progress}%`),
                class: "bg-primary-600 h-2.5 rounded-full"
              }, null, 4)
            ])
          ])) : (E(), q(o, {
            key: 1,
            loading: l.isDeleting,
            color: "warning",
            size: "sm",
            type: "text",
            onClick: (s) => u.handleDelete(l)
          }, {
            "icon-before": N(() => [
              U(r)
            ]),
            default: N(() => [
              G(" Supprimer ")
            ]),
            _: 2
          }, 1032, ["loading", "onClick"]))
        ])
      ]))), 128))
    ])) : R("", !0),
    u.fileNumber > u.files.length ? (E(), y("div", ad, [
      v("label", {
        for: u.name,
        class: "relative block h-40 group"
      }, [
        v("input", {
          id: u.name,
          multiple: u.fileNumber > 1,
          name: u.name,
          class: "absolute top-0 left-0 right-0 bottom-0 w-full block p-2 focus:outline-none cursor-pointer focus:shadow-none focus:ring-0",
          type: "file",
          onChange: e[0] || (e[0] = (...l) => u.handleUpload && u.handleUpload(...l)),
          onDragenter: e[1] || (e[1] = (l) => u.isDraggedOver = !0),
          onDragleave: e[2] || (e[2] = (l) => u.isDraggedOver = !1),
          onDrop: e[3] || (e[3] = (l) => u.isDraggedOver = !1)
        }, null, 40, od),
        v("span", {
          class: M([{ "bg-gray-100": u.isDraggedOver }, "pointer-events-none absolute bg-white top-0 left-0 right-0 bottom-0 w-full block flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md group-hover:bg-gray-100 group-focus-within:outline-none group-focus-within:ring-2 group-focus-within:ring-offset-2 group-focus-within:ring-primary-500"])
        }, [
          v("span", rd, [
            ld,
            v("span", id, [
              v("span", dd, O(u.title), 1),
              sd
            ]),
            v("span", cd, [
              u.fileExtensions.length ? (E(), y("span", Fd, [
                (E(!0), y(J, null, du(u.fileExtensions, (l, i) => (E(), y("span", {
                  key: i,
                  class: "uppercase"
                }, O(l) + ", ", 1))), 128))
              ])) : R("", !0),
              u.fileSize ? (E(), y("span", Cd, "jusqu'à " + O(u.fileSize) + "MB", 1)) : R("", !0),
              G(", " + O(u.fileNumber) + " " + O(u.pluralize("fichier", u.fileNumber)) + " maximum ", 1)
            ])
          ])
        ], 2)
      ], 8, nd)
    ])) : R("", !0),
    v("p", Ed, O(u.validation.errorMessage || u.customErrorMessage), 1)
  ]);
}
const r4 = /* @__PURE__ */ Q(Hi, [["render", md]]), pd = z({
  emits: ["update:modelValue", "update-batch"],
  props: {
    orientation: {
      type: String,
      default: "vertical",
      validator: (u) => ["vertical", "horizontal"].includes(u)
    },
    hideRadio: { type: Boolean, default: !1 },
    color: { type: String, default: "light" },
    size: { type: String, default: "base" },
    name: { type: String, required: !0 },
    showLabel: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    modelValue: { type: [String, Array, Boolean], default: "" },
    label: { type: String },
    items: { type: Array, default: () => [] },
    tooltip: { type: Boolean },
    tooltipHeader: { type: String },
    tooltipText: { type: String },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        },
        meta: {}
      })
    },
    validations: { type: Object, default: () => ({}) },
    hideValidationError: { type: Boolean, default: !1 },
    helperText: { type: String, default: "" }
  },
  components: {
    QuestionMarkCircleIcon: jf,
    RadioGroup: v0,
    RadioGroupDescription: y0,
    RadioGroupLabel: B0,
    RadioGroupOption: h0,
    Tooltip: Pf
  },
  setup(u, { emit: e }) {
    return {
      select: (f) => {
        e("update:modelValue", f);
      }
    };
  }
}), bd = { class: "text-sm" }, gd = { class: "font-medium text-gray-900" }, vd = ["innerHTML"], hd = {
  key: 0,
  class: "mt-1 min-h-5 text-red-600 text-xs"
}, Bd = ["innerHTML"];
function yd(u, e, D, f, t, n) {
  const a = P("QuestionMarkCircleIcon"), o = P("Tooltip"), r = P("RadioGroupLabel"), l = P("RadioGroupDescription"), i = P("RadioGroupOption"), s = P("RadioGroup", !0);
  return E(), q(s, {
    class: M({ "opacity-50 cursor-not-allowed": u.disabled }),
    disabled: u.disabled,
    modelValue: u.modelValue,
    "onUpdate:modelValue": u.select
  }, {
    default: N(() => [
      U(r, {
        class: M([{ "sr-only": !u.showLabel }, "text-sm font-medium text-gray-700 align-middle mb-1"])
      }, {
        default: N(() => [
          G(O(u.label) + " ", 1),
          u.tooltip && !u.disabled ? (E(), q(o, { key: 0 }, {
            trigger: N(() => [
              U(a, { class: "h-5 w-5 text-gray-400 hover:text-gray-500" })
            ]),
            content: N(() => [
              v("div", bd, [
                v("p", gd, O(u.tooltipHeader), 1),
                v("p", {
                  class: "font-light text-gray-500",
                  innerHTML: u.tooltipText
                }, null, 8, vd)
              ])
            ]),
            _: 1
          })) : R("", !0)
        ]),
        _: 1
      }, 8, ["class"]),
      v("div", {
        class: M([{
          "flex-col -space-y-px flex": u.orientation === "vertical",
          "-space-x-px flex": u.orientation === "horizontal",
          "bg-primary-600 border-primary-700": u.color === "dark",
          "bg-white border-gray-300": u.color === "light",
          "bg-gray-50 border-gray-300 rounded-r-none": u.color === "transparent"
        }, "rounded-md"])
      }, [
        (E(!0), y(J, null, du(u.items, (d, g) => (E(), q(i, {
          key: d.name,
          class: M({ "opacity-50 cursor-not-allowed": d.disabled }),
          disabled: d.disabled,
          value: d.id,
          as: "template"
        }, {
          default: N(({ checked: h, active: _ }) => [
            v("div", {
              class: M([{
                "rounded-t-md": g === 0 && u.orientation === "vertical",
                "rounded-b-md": g === u.items.length - 1 && u.orientation === "vertical",
                "rounded-l-md": g === 0 && u.orientation === "horizontal",
                "rounded-r-md": g === u.items.length - 1 && u.orientation === "horizontal",
                "border-gray-200": u.color === "light",
                "border-primary-700": u.color === "dark",
                "bg-primary-50 border-primary-200 z-10": h && u.color === "light",
                "bg-primary-700 border-primary-800 z-10": h && u.color === "dark",
                "px-4 py-2": u.size === "sm",
                "items-center": !d.description
              }, "relative border p-4 flex cursor-pointer focus:outline-none"])
            }, [
              u.hideRadio ? R("", !0) : (E(), y("span", {
                key: 0,
                class: M([{
                  "bg-primary-600 border-transparent": h && u.color === "light",
                  "bg-white border-gray-300": !h && u.color === "light",
                  "bg-white border-primary-800": h && u.color === "dark",
                  "bg-white border-primary-700": !h && u.color === "dark",
                  "ring-2 ring-offset-2 ring-primary-500": _,
                  "w-3 h-3": u.size === "sm",
                  "w-4 h-4": u.size === "base"
                }, "mt-0.5 cursor-pointer rounded-full border flex items-center justify-center flex-shrink-0"]),
                "aria-hidden": "true"
              }, [
                v("span", {
                  class: M([[u.color === "dark" && h ? "bg-primary-700" : "bg-white"], "rounded-full w-1.5 h-1.5"])
                }, null, 2)
              ], 2)),
              v("div", {
                class: M([{ "ml-3": !u.hideRadio }, "flex flex-col"])
              }, [
                U(r, {
                  class: M([{
                    "text-primary-900": h && u.color === "light",
                    "text-gray-900": !h && u.color === "light",
                    "text-white": u.color === "dark",
                    "font-base": u.size === "sm",
                    "font-medium": u.size === "base"
                  }, "block text-sm"]),
                  as: "span"
                }, {
                  default: N(() => [
                    G(O(d.name), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]),
                U(l, {
                  class: M([{
                    "text-primary-700": h && u.color === "light",
                    "text-gray-500": !h && u.color === "light",
                    "text-white": u.color === "dark"
                  }, "block text-sm"]),
                  as: "span"
                }, {
                  default: N(() => [
                    G(O(d.description), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ], 2)
            ], 2)
          ]),
          _: 2
        }, 1032, ["class", "disabled", "value"]))), 128))
      ], 2),
      !u.hideValidationError && (!u.helperText || u.validation.errorMessage) ? (E(), y("p", hd, O(u.validation.errorMessage), 1)) : R("", !0),
      u.helperText && !u.validation.errorMessage && !u.hideValidationError ? (E(), y("p", {
        key: 1,
        class: "mt-1 h-5 text-xs text-gray-500",
        innerHTML: u.helperText
      }, null, 8, Bd)) : R("", !0)
    ]),
    _: 1
  }, 8, ["class", "disabled", "modelValue", "onUpdate:modelValue"]);
}
const l4 = /* @__PURE__ */ Q(pd, [["render", yd]]), _d = z({
  emits: ["update:modelValue", "update-batch"],
  props: {
    cols: { type: Number, default: 3 },
    color: { type: String, default: "light" },
    name: { type: String, required: !0 },
    showLabel: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    modelValue: { type: [String, Array, Boolean, Number], default: "" },
    label: { type: String },
    items: { type: Array, default: () => [] },
    multiple: { type: Boolean, default: !1 },
    hideCheckIcon: { type: Boolean, default: !1 },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        },
        meta: {}
      })
    },
    validations: { type: Object, default: () => ({}) },
    orientation: {
      type: String,
      default: "cols",
      validator: (u) => ["cols", "rows"].includes(u)
    }
  },
  components: {
    RadioGroup: v0,
    RadioGroupDescription: y0,
    RadioGroupLabel: B0,
    RadioGroupOption: h0,
    CheckCircleIcon: iD
  },
  setup(u, { emit: e }) {
    const D = (a) => {
      u.loading || (u.multiple ? Array.isArray(u.modelValue) ? u.modelValue.includes(a) ? e(
        "update:modelValue",
        u.modelValue.filter((o) => o !== a)
      ) : e("update:modelValue", u.modelValue.concat([a])) : u.modelValue === void 0 ? e("update:modelValue", [a]) : e("update:modelValue", [u.modelValue, a]) : e("update:modelValue", a));
    }, f = (a) => u.multiple ? (u.modelValue || []).includes(a.id) : u.modelValue === a.id, t = w(() => u.loading ? new Array(u.cols).fill({ description: " ", value: " " }) : u.items);
    return {
      colsClass: w(() => ({
        1: "sm:grid-cols-1",
        2: "sm:grid-cols-2",
        3: "sm:grid-cols-3"
      })[u.cols]),
      options: t,
      isSelected: f,
      select: D
    };
  }
}), wd = { class: "flex-1 flex" }, kd = { key: 1 }, Ad = {
  key: 0,
  class: "flex flex-1 mt-1 flex-col block"
}, xd = /* @__PURE__ */ v("span", { class: "block animate-pulse h-3 w-full bg-gray-200 rounded" }, null, -1), $d = /* @__PURE__ */ v("span", { class: "block animate-pulse mt-1 h-3 w-2/3 bg-gray-200 rounded" }, null, -1), Sd = [
  xd,
  $d
], Td = { key: 1 }, Md = {
  key: 0,
  class: "block animate-pulse h-4 w-1/3 bg-gray-300 rounded"
}, Od = { key: 1 }, Id = { class: "mt-1 min-h-5 text-red-600 text-xs" };
function Pd(u, e, D, f, t, n) {
  const a = P("RadioGroupLabel"), o = P("RadioGroupDescription"), r = P("CheckCircleIcon"), l = P("RadioGroupOption"), i = P("RadioGroup");
  return E(), q(i, {
    disabled: u.disabled,
    modelValue: u.modelValue,
    "onUpdate:modelValue": u.select
  }, {
    default: N(() => [
      U(a, { class: "text-sm font-medium text-gray-900" }, {
        default: N(() => [
          G(O(u.label), 1)
        ]),
        _: 1
      }),
      v("div", {
        class: M([
          u.orientation === "rows" ? "grid-rows-1 gap-x-6 gap-y-2" : `grid-cols-1 gap-y-6 ${u.colsClass} sm:gap-x-4`,
          "mt-4 grid"
        ])
      }, [
        (E(!0), y(J, null, du(u.options, (s) => (E(), q(l, {
          key: s.id,
          value: s.id,
          as: "template"
        }, {
          default: N(({ active: d }) => [
            v("div", {
              class: M([
                { "opacity-50 cursor-not-allowed": u.disabled },
                u.isSelected(s) && !u.loading ? "border-transparent" : "border-gray-300",
                d && !u.multiple ? "ring-2 ring-primary-500" : "",
                "relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none"
              ])
            }, [
              v("div", wd, [
                v("div", {
                  class: M([{ "flex-1": u.loading }, "flex flex-col"])
                }, [
                  U(a, {
                    as: "span",
                    class: "block text-sm font-medium text-gray-900"
                  }, {
                    default: N(() => [
                      u.loading ? (E(), y("span", {
                        key: 0,
                        class: M([{ "w-24": u.orientation === "rows", "w-full": u.orientation === "cols" }, "block animate-pulse h-3 bg-gray-300 rounded"])
                      }, null, 2)) : (E(), y("span", kd, O(s.title), 1))
                    ]),
                    _: 2
                  }, 1024),
                  s.description ? (E(), q(o, {
                    key: 0,
                    as: "span",
                    class: "mt-1 flex items-center text-sm text-gray-500"
                  }, {
                    default: N(() => [
                      u.loading ? (E(), y("span", Ad, Sd)) : (E(), y("span", Td, O(s.description), 1))
                    ]),
                    _: 2
                  }, 1024)) : R("", !0),
                  s.value ? (E(), q(o, {
                    key: 1,
                    as: "span",
                    class: "mt-6 text-sm font-medium text-gray-900"
                  }, {
                    default: N(() => [
                      u.loading ? (E(), y("span", Md)) : (E(), y("span", Od, O(s.value), 1))
                    ]),
                    _: 2
                  }, 1024)) : R("", !0)
                ], 2)
              ]),
              u.isSelected(s) && !u.hideCheckIcon && !u.loading ? (E(), q(r, {
                key: 0,
                class: M(["h-5 w-5 text-primary-600"]),
                "aria-hidden": "true"
              })) : R("", !0),
              u.loading ? R("", !0) : (E(), y("div", {
                key: 1,
                class: M([
                  d && !u.multiple ? "border" : "border-2",
                  u.isSelected(s) && !u.loading ? "border-primary-500" : "border-transparent",
                  "absolute -inset-px rounded-lg pointer-events-none"
                ]),
                "aria-hidden": "true"
              }, null, 2))
            ], 2)
          ]),
          _: 2
        }, 1032, ["value"]))), 128))
      ], 2),
      v("p", Id, O(u.validation.errorMessage), 1)
    ]),
    _: 1
  }, 8, ["disabled", "modelValue", "onUpdate:modelValue"]);
}
const i4 = /* @__PURE__ */ Q(_d, [["render", Pd]]), Ld = z({
  emits: ["update:modelValue", "update-batch"],
  props: {
    name: { type: String, required: !0 },
    label: { type: String },
    modelValue: { type: String },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        }
      })
    },
    validations: { type: Object, default: () => ({}) },
    options: { type: Array, default: () => [] },
    uuid: {
      type: Number,
      default: 0
    },
    component: {
      type: Object
    },
    model: {
      type: String
    },
    class: {
      type: String
    }
  },
  setup(u, { emit: e }) {
    return { updateModelValue: (f) => {
      const t = f.target;
      e("update:modelValue", t.value);
    } };
  }
}), Rd = { class: "flex space-x-6" }, Nd = ["id", "checked", "name", "required", "value"], jd = ["for"], Vd = { class: "mt-1 min-h-5 text-red-600 text-xs" };
function zd(u, e, D, f, t, n) {
  return E(), y("div", null, [
    v("div", Rd, [
      (E(!0), y(J, null, du(u.options, (a) => (E(), y("div", {
        key: a.value,
        class: "flex items-center"
      }, [
        v("input", {
          id: a.value,
          checked: u.modelValue === a.value,
          name: u.name,
          required: u.validations.required,
          value: a.value,
          class: "focus:ring-primary-500 h-4 w-4 text-primary-400 border-gray-300",
          type: "radio",
          onBlur: e[0] || (e[0] = (o) => u.validation.setTouched(!0)),
          onInput: e[1] || (e[1] = (...o) => u.updateModelValue && u.updateModelValue(...o))
        }, null, 40, Nd),
        v("label", {
          for: a.value,
          class: "ml-3 block text-sm font-medium text-gray-700"
        }, O(a.label), 9, jd)
      ]))), 128))
    ]),
    v("p", Vd, O(u.validation.errorMessage), 1)
  ]);
}
const d4 = /* @__PURE__ */ Q(Ld, [["render", zd]]), Ud = z({
  components: { Badge: lD },
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    badgeTitle: { type: String, default: "" }
  }
}), Wd = { class: "mb-6" }, qd = { class: "flex gap-2" }, Yd = { class: "text-lg leading-6 font-medium text-gray-900" }, Hd = ["innerHTML"];
function Gd(u, e, D, f, t, n) {
  const a = P("Badge");
  return E(), y("div", Wd, [
    v("div", qd, [
      v("h3", Yd, O(u.title), 1),
      u.badgeTitle ? (E(), q(a, {
        key: 0,
        color: "secondary",
        rounded: ""
      }, {
        default: N(() => [
          G(O(u.badgeTitle), 1)
        ]),
        _: 1
      })) : R("", !0)
    ]),
    v("p", {
      class: "mt-1 text-sm text-gray-500",
      innerHTML: u.subtitle
    }, null, 8, Hd)
  ]);
}
const s4 = /* @__PURE__ */ Q(Ud, [["render", Gd]]), Xd = z({
  props: {
    label: { type: String, default: "" }
  }
}), Zd = { class: "text-gray-700 flex items-center text-sm font-medium mb-1" };
function Kd(u, e, D, f, t, n) {
  return E(), y("p", Zd, O(u.label), 1);
}
const c4 = /* @__PURE__ */ Q(Xd, [["render", Kd]]), Qd = z({
  components: { Badge: lD },
  props: {
    label: { type: String, default: "" },
    items: { type: Array, default: [] },
    placeholder: { type: String, default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup() {
    const { capitalize: u } = fe();
    return { capitalize: u };
  }
}), Jd = { class: "mb-6" }, us = { class: "block text-sm font-medium text-gray-700" }, es = {
  key: 0,
  class: "flex mt-1 gap-2 flex-wrap"
}, Ds = {
  key: 1,
  class: "flex mt-2 gap-2 flex-wrap"
}, fs = {
  key: 2,
  class: "text-sm text-gray-500 italic"
};
function ts(u, e, D, f, t, n) {
  const a = P("Badge");
  return E(), y("div", Jd, [
    v("div", us, O(u.label), 1),
    u.loading ? (E(), y("div", es, [
      (E(), y(J, null, du([0, 1, 2], (o) => v("div", {
        key: o,
        class: "h-3 w-10 rounded bg-gray-200 animate-pulse"
      })), 64))
    ])) : u.items && u.items.length ? (E(), y("div", Ds, [
      (E(!0), y(J, null, du(u.items, (o, r) => (E(), q(a, { key: r }, {
        default: N(() => [
          G(O(u.capitalize(o)), 1)
        ]),
        _: 2
      }, 1024))), 128))
    ])) : (E(), y("p", fs, O(u.placeholder), 1))
  ]);
}
const F4 = /* @__PURE__ */ Q(Qd, [["render", ts]]), as = z({
  components: { Button: Pe, ArrowPathRoundedSquareIcon: Ft },
  emits: ["update:modelValue"],
  props: {
    label: { type: String, required: !0 },
    type: { type: String },
    size: { type: String },
    color: { type: String },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    action: { type: Function, required: !0 },
    iconBefore: { type: [Object, Function] }
  }
});
function ns(u, e, D, f, t, n) {
  const a = P("Button");
  return E(), q(a, {
    color: u.color,
    disabled: u.disabled,
    loading: u.loading,
    size: u.size,
    type: u.type,
    class: "mb-6",
    onClick: e[0] || (e[0] = (o) => u.action())
  }, Dt({
    default: N(() => [
      G(" " + O(u.label), 1)
    ]),
    _: 2
  }, [
    u.iconBefore ? {
      name: "icon-before",
      fn: N(() => [
        (E(), q(xu(u.iconBefore)))
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["color", "disabled", "loading", "size", "type"]);
}
const C4 = /* @__PURE__ */ Q(as, [["render", ns]]), os = z({
  components: {
    Badge: lD
  },
  emits: ["remove"],
  props: {
    remove: { type: Function, default: () => () => ({}) },
    modelValue: {
      type: String
    }
  }
});
function rs(u, e, D, f, t, n) {
  const a = P("Badge");
  return E(), q(a, {
    clearable: !0,
    class: "mt-1",
    color: "secondary",
    size: "lg",
    onRemove: e[0] || (e[0] = (o) => u.remove())
  }, {
    default: N(() => [
      G(O(u.modelValue), 1)
    ]),
    _: 1
  });
}
const E4 = /* @__PURE__ */ Q(os, [["render", rs]]), ls = z({
  props: {
    updatedBy: { type: String, default: "" },
    updatedAt: { type: String, default: "" }
  },
  setup() {
    const { formatDate: u } = fe();
    return {
      formatDate: u
    };
  }
}), is = { class: "mb-6" }, ds = {
  key: 0,
  class: "mt-1 text-xs text-gray-400"
}, ss = { class: "text-gray-500" }, cs = { key: 0 }, Fs = { class: "text-gray-500" };
function Cs(u, e, D, f, t, n) {
  return E(), y("div", is, [
    u.updatedAt ? (E(), y("p", ds, [
      G(" Dernière modification le "),
      v("span", ss, O(u.formatDate(u.updatedAt, "dd/MM/yyyy 'à' HH'h'mm")), 1),
      u.updatedBy ? (E(), y("span", cs, [
        G(" par "),
        v("span", Fs, O(u.updatedBy), 1)
      ])) : R("", !0)
    ])) : R("", !0)
  ]);
}
const m4 = /* @__PURE__ */ Q(ls, [["render", Cs]]);
function Es(u) {
  if (!/^\d{14}$/.test(u))
    return !1;
  let e = 0;
  for (let D = 0; D < 14; D++) {
    let f = Number(u[D]);
    D % 2 === 0 && (f *= 2), f > 9 && (f -= 9), e += f;
  }
  return e % 10 === 0;
}
const ms = z({
  components: {
    Input: Y0,
    CheckCircleIcon: iD,
    LoadingIcon: Je
  },
  emits: ["update:modelValue", "update-batch", "validated"],
  props: {
    size: { type: String, default: "base" },
    _veeValidateConfig: { type: Object },
    disabled: { type: Boolean, default: !1 },
    name: { type: String, required: !0 },
    label: { type: String },
    modelValue: { type: String, default: null },
    loading: { type: Boolean, default: !1 },
    validation: {
      type: Object,
      default: () => ({
        setTouched: () => {
        },
        meta: {},
        errorMessage: ""
      })
    },
    validate: {
      type: Function,
      required: !0
    },
    validations: { type: Object, default: () => ({ exclusiveTests: {} }) },
    placeholder: { type: String, default: "" },
    uuid: {
      type: Number,
      default: 0
    },
    component: {
      type: Object
    },
    model: {
      type: String
    }
  },
  setup(u, { emit: e }) {
    const D = I(!1), f = I("");
    let t = null;
    const n = async (r) => {
      if (!Es(r)) {
        f.value = "Merci d'indiquer un numéro de SIRET (14 chiffres valides)", D.value = !1;
        return;
      }
      try {
        const l = await u.validate(r);
        l || (f.value = "Numéro de SIRET introuvable"), e("validated", l);
      } catch {
        f.value = "Erreur de validation du SIRET", e("validated", !1);
      } finally {
        D.value = !1;
      }
    }, a = w({
      get: () => u.modelValue ?? "",
      set: (r) => {
        if (e("update:modelValue", r), t && clearTimeout(t), u.disabled) {
          f.value = "", D.value = !1;
          return;
        }
        if (!r) {
          f.value = "", D.value = !1;
          return;
        }
        f.value = "", D.value = !0, t = setTimeout(() => void n(r), 250);
      }
    });
    au(
      () => u.disabled,
      (r) => {
        r && (t && clearTimeout(t), f.value = "", D.value = !1);
      }
    ), ru(() => {
      setTimeout(() => {
        u.modelValue && n(u.modelValue);
      }, 500);
    });
    const o = w(() => ({
      ...u.validation,
      errorMessage: f.value || u.validation.errorMessage || ""
    }));
    return {
      value: a,
      computedValidation: o,
      internalLoading: D
    };
  }
}), ps = { class: "max-w-2xl" };
function bs(u, e, D, f, t, n) {
  const a = P("LoadingIcon"), o = P("CheckCircleIcon"), r = P("Input");
  return E(), y("div", ps, [
    U(r, {
      modelValue: u.value,
      "onUpdate:modelValue": e[0] || (e[0] = (l) => u.value = l),
      disabled: u.disabled,
      label: u.label,
      loading: u.loading,
      maxlength: 14,
      name: u.name,
      placeholder: u.placeholder,
      size: u.size,
      validation: u.computedValidation
    }, {
      "icon-after": N(() => [
        u.internalLoading ? (E(), q(a, {
          key: 0,
          class: "h-5 w-5 text-primary-900"
        })) : u.value && !u.computedValidation.errorMessage ? (E(), q(o, {
          key: 1,
          class: "h-5 w-5 text-green-500"
        })) : R("", !0)
      ]),
      _: 1
    }, 8, ["modelValue", "disabled", "label", "loading", "name", "placeholder", "size", "validation"])
  ]);
}
const p4 = /* @__PURE__ */ Q(ms, [["render", bs]]);
function bf(u) {
  return (u || "").replace(/\s+/g, "").toUpperCase();
}
function gs(u) {
  const e = bf(u || "");
  if (!e)
    return "";
  const D = e.slice(0, 4), f = e.slice(-4);
  return `${D} **** **** **** ${f}`;
}
function y1(u) {
  return /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/.test(u);
}
function _1(u) {
  const e = u.slice(4) + u.slice(0, 4);
  let D = 0;
  for (let f = 0; f < e.length; f++) {
    const t = e[f], n = t >= "A" && t <= "Z" ? (t.charCodeAt(0) - 55).toString() : t;
    for (let a = 0; a < n.length; a++)
      D = (D * 10 + Number(n[a])) % 97;
  }
  return D === 1;
}
const vs = z({
  components: { Button: Pe, Input: Y0, CheckCircleIcon: iD, LoadingIcon: Je },
  emits: ["update:modelValue"],
  props: {
    size: { type: String, default: "base" },
    _veeValidateConfig: { type: Object },
    disabled: { type: Boolean, default: !1 },
    name: { type: String, required: !0 },
    label: { type: String },
    modelValue: { type: String, default: "" },
    loading: { type: Boolean, default: !1 },
    validation: {
      type: Object,
      default: () => ({ setTouched: () => {
      }, meta: {}, errorMessage: "" })
    },
    validate: { type: Function, required: !1 },
    validations: { type: Object, default: () => ({ exclusiveTests: {} }) },
    placeholder: { type: String, default: "" },
    submitSuccessTick: { type: Number, default: 0 },
    startInEdit: { type: Boolean, default: !1 },
    hasInitialValue: { type: Boolean, default: !1 },
    uuid: { type: Number, default: 0 },
    component: { type: Object },
    model: { type: String },
    class: { type: String }
  },
  setup(u, { emit: e }) {
    const D = I(!1), f = I(!1), t = I(""), n = I(void 0), a = I("");
    au(
      () => u.startInEdit,
      (p) => {
        p != null && (D.value = p);
      },
      { immediate: !0 }
    );
    const o = w(() => {
      var p, b;
      return !!(u.modelValue || (p = u.modelValue) != null && p.includes("*") || (b = u.placeholder) != null && b.includes("*"));
    }), r = w(() => {
      var b, m;
      if ((b = u.modelValue) != null && b.includes("*"))
        return u.modelValue;
      const p = bf(u.modelValue);
      return p ? gs(p) : (m = u.placeholder) != null && m.includes("*") ? u.placeholder : "";
    });
    function l() {
      return bf(n.value);
    }
    function i() {
      D.value = !0, t.value = "", f.value = !1, n.value = "", a.value = "";
    }
    function s() {
      D.value = !1, t.value = "", f.value = !1;
    }
    function d() {
      e("update:modelValue", void 0), s();
    }
    au(
      () => u.submitSuccessTick,
      () => {
        if (D.value) {
          const p = a.value;
          !!p && y1(p) && _1(p) ? (e("update:modelValue", p), s()) : e("update:modelValue", null);
        }
      }
    );
    let g = null;
    async function h(p) {
      !y1(p) || !_1(p) ? (t.value = "Merci de fournir un IBAN valide.", f.value = !1) : (f.value = !1, t.value = "", e("update:modelValue", p));
    }
    au(
      n,
      () => {
        if (!D.value)
          return;
        const p = l();
        if (a.value = p, g && clearTimeout(g), !p) {
          t.value = "IBAN requis", f.value = !1;
          return;
        }
        t.value = "", f.value = !0, g = setTimeout(() => void h(p), 300);
      },
      { immediate: !1 }
    ), au(
      () => u.disabled,
      (p) => {
        p && g && (clearTimeout(g), f.value = !1);
      }
    );
    const _ = w(() => ({
      ...u.validation,
      errorMessage: ""
    })), C = w(() => ({
      ...u.validation,
      errorMessage: t.value || u.validation.errorMessage || ""
    }));
    return {
      isEditing: D,
      internalLoading: f,
      editableValue: n,
      displayMasked: r,
      hasValue: o,
      readonlyValidation: _,
      computedValidation: C,
      startEditing: i,
      cancelEditing: d
    };
  }
}), hs = {
  key: 0,
  class: "flex items-center gap-2"
}, Bs = { class: "flex-1 max-w-2xl" }, ys = {
  key: 1,
  class: "flex items-center gap-2"
}, _s = { class: "flex-1 max-w-2xl" }, ws = { class: "flex flex-col gap-2" };
function ks(u, e, D, f, t, n) {
  const a = P("CheckCircleIcon"), o = P("Input"), r = P("Button"), l = P("LoadingIcon");
  return u.isEditing ? (E(), y("div", ys, [
    v("div", _s, [
      U(o, {
        modelValue: u.editableValue,
        "onUpdate:modelValue": e[0] || (e[0] = (i) => u.editableValue = i),
        disabled: u.disabled,
        label: u.label,
        maxlength: 42,
        name: u.name,
        placeholder: "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
        size: u.size,
        validation: u.computedValidation
      }, {
        "icon-after": N(() => [
          u.internalLoading ? (E(), q(l, {
            key: 0,
            class: "h-5 w-5 text-primary-900"
          })) : u.editableValue && !u.computedValidation.errorMessage ? (E(), q(a, {
            key: 1,
            class: "h-5 w-5 text-green-500"
          })) : R("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "label", "name", "size", "validation"])
    ]),
    v("div", ws, [
      u.hasInitialValue ? (E(), q(r, {
        key: 0,
        size: "xs",
        type: "text",
        onClick: u.cancelEditing
      }, {
        default: N(() => [
          G(" Annuler ")
        ]),
        _: 1
      }, 8, ["onClick"])) : R("", !0)
    ])
  ])) : (E(), y("div", hs, [
    v("div", Bs, [
      U(o, {
        disabled: !0,
        label: u.label,
        loading: !1,
        maxlength: 42,
        "model-value": u.displayMasked,
        name: u.name,
        placeholder: u.placeholder,
        size: u.size,
        validation: u.readonlyValidation,
        value: u.displayMasked
      }, {
        "icon-after": N(() => [
          u.hasValue ? (E(), q(a, {
            key: 0,
            class: "h-5 w-5 text-green-600"
          })) : R("", !0)
        ]),
        _: 1
      }, 8, ["label", "model-value", "name", "placeholder", "size", "validation", "value"])
    ]),
    !u.disabled && u.hasInitialValue ? (E(), q(r, {
      key: 0,
      size: "xs",
      type: "text",
      onClick: u.startEditing
    }, {
      default: N(() => [
        G(" Mettre à jour ")
      ]),
      _: 1
    }, 8, ["onClick"])) : R("", !0)
  ]));
}
const b4 = /* @__PURE__ */ Q(vs, [["render", ks]]), As = z({
  setup() {
    const { getAppName: u } = fe();
    return { getAppName: u };
  }
}), xs = {
  key: 0,
  class: "h-10 w-auto text-white",
  fill: "currentColor",
  viewBox: "0 0 2015.85 515.53",
  xmlns: "http://www.w3.org/2000/svg"
}, $s = /* @__PURE__ */ v("defs", null, null, -1), Ss = /* @__PURE__ */ v("g", null, [
  /* @__PURE__ */ v("path", {
    class: "cls-1",
    d: "M.01 294.79c0-42.21-.01-84.42.03-126.63 0-3.5.31-7.01.54-10.51.07-1.02 1.85-2.22 2.88-1.93 4.6 1.29 9.28 2.4 13.76 4.04 10.3 3.75 19.67 9.18 28.02 16.33 4.65 3.97 8.63 8.53 12.28 13.41 1.34 1.78 2.76 3.51 4.16 5.24.41.5 2.21.57 2.66.09 1.31-1.39 2.67-2.74 3.85-4.23 13.15-16.49 29.92-27.71 49.95-34.07 9.47-3.01 19.21-4.76 29.17-5.15 13.49-.53 26.83.35 39.9 4.05 23.95 6.79 43.3 20.16 57.65 40.54 10.47 14.87 16.81 31.46 20.08 49.32 2.67 14.59 3.01 29.31 1.6 43.96-2.17 22.65-9.19 43.71-22.88 62.21-16.75 22.64-38.99 36.46-66.71 41.4-19.18 3.42-38.22 2.71-56.97-2.64-12.73-3.64-24.3-9.71-34.74-17.9-2.24-1.76-4.62-3.35-6.96-4.98-.57-.4-2.14.43-2.32 1.17-.21.93-.55 1.85-.58 2.78-.1 3.2-.11 6.39-.11 9.59 0 40.29 0 80.58-.02 120.87 0 3.51-.06 7.03-.33 10.53-.18 2.31-1.4 3.21-3.92 3.24-5.22.05-10.1-1.62-14.93-3.2-19.15-6.27-33.36-18.43-42.58-36.38-5.45-10.61-8.81-21.87-10.96-33.58C.35 430.35.08 418.21.05 406.07c-.08-30.7-.03-61.39-.03-92.09v-19.19Zm185.8-21.9c-.2-2.98-.35-5.54-.54-8.08-.56-7.74-2.7-15.06-6-22.05-14.64-30.96-52.19-38.71-78.22-21.87-11.19 7.24-18.4 17.58-22.31 30.19-3.35 10.82-4.21 21.82-2.44 33.13 1.46 9.32 4.32 17.99 9.32 25.93 6.73 10.67 16.18 17.87 28.2 21.79 6.82 2.22 13.8 2.59 20.84 2.17 17.45-1.03 31.09-8.96 40.74-23.44 7.67-11.52 10.72-24.44 10.4-37.78ZM782.21 190.8V11.3c-.09-13.18-.34-12.92 12.77-8.76 10.76 3.41 20.74 8.44 29.58 15.51 15.31 12.25 24.7 28.29 29.5 47.12 2.38 9.33 3.4 18.87 3.77 28.48.16 4.15.08 8.32.08 12.48 0 44.48 0 88.95.03 133.43 0 2.84-.54 5.78.7 8.5.19.43 1.01.81 1.53.79.57-.02 1.25-.42 1.66-.85 1.75-1.86 3.46-3.76 5.12-5.71 18.2-21.48 36.38-42.98 54.58-64.46 3.51-4.15 7.03-8.3 10.6-12.4 3.56-4.1 8.03-6.09 13.52-6.05 13.12.08 26.24.01 39.36.01 11.52 0 23.04.03 34.56.01 2.29 0 4.44.35 6.41 1.61 1.52.97 2.45 3.34 1.78 5.03-.47 1.18-.9 2.43-1.66 3.42-1.35 1.77-2.88 3.43-4.43 5.03-22.47 23.23-44.96 46.43-67.43 69.65-6.01 6.21-11.96 12.47-17.92 18.72-.88.92-1.7 1.91-2.51 2.9-.75.91-.87 2.73-.19 3.58 1.39 1.75 2.76 3.52 4.27 5.16 17.78 19.29 35.59 38.56 53.38 57.84 12.15 13.17 24.29 26.35 36.39 39.56 1.72 1.88 3.42 3.83 4.78 5.97 2.27 3.56-.12 8.1-4.36 8.56-1.59.17-3.19.22-4.79.22-24.64.01-49.28.01-73.91 0-1.28 0-2.56-.02-3.84-.07-3.35-.14-6.21-1.5-8.56-3.81-1.59-1.56-3.05-3.28-4.43-5.04-18.42-23.36-36.83-46.74-55.23-70.12-4.35-5.53-8.68-11.08-13.09-16.57-.98-1.23-2.22-2.25-3.38-3.33-.68-.64-2.24-.16-2.33.72-.23 2.21-.55 4.42-.55 6.63-.05 16-.03 32-.03 47.99 0 9.92.02 19.84-.02 29.76 0 2.23-.05 4.49-.37 6.69-.5 3.43-3.7 6.42-7.09 6.9-.95.13-1.91.21-2.87.21-18.24.02-36.48.02-54.71 0-1.27 0-2.56-.13-3.81-.35-3.05-.53-5.88-3.35-6.42-6.41-.22-1.25-.33-2.54-.35-3.81-.06-3.2-.05-6.4-.05-9.6V190.78ZM556.67 273.44V378c0 2.88 0 5.76-.09 8.63-.12 3.63-1.67 4.43-4.99 4.05-3.47-.4-6.95-1.06-10.33-1.98-18-4.89-32.43-14.78-42.42-30.75-1.02-1.63-1.98-3.28-3.03-4.89-1.61-2.48-3.45-2.66-5.33-.52-2.75 3.11-5.39 6.33-8.23 9.36-15.63 16.65-34.92 26.48-57.22 30.88-12.7 2.51-25.48 2.61-38.2 1.3-18.45-1.89-35.41-8.29-50.6-19.03-11.65-8.24-20.94-18.76-28.41-30.84-9.55-15.46-15.04-32.37-17.29-50.38-.95-7.62-1.64-15.24-1.59-22.94.11-15.8 2.56-31.2 7.8-46.1 5.81-16.51 14.59-31.21 27.21-43.51 15.1-14.71 33.14-23.66 53.69-27.86 12.33-2.52 24.82-2.93 37.24-1.64 28.15 2.91 52.08 14.54 70.95 35.94 1.69 1.92 3.3 3.91 4.99 5.82 1.53 1.73 3.26 1.51 4.67-.59 1.25-1.86 2.41-3.77 3.65-5.63 10.36-15.67 24.91-25.39 42.92-30.15 3.7-.98 7.37-2.15 11.3-1.85 1.63.13 3.02 1.3 3.08 3.01.12 3.19.21 6.39.22 9.58.01 35.17 0 70.35 0 105.52Zm-75.8.35c0-10.69-1.95-21-6.5-30.69-13.88-29.57-47.32-37.48-72.2-25.65-13.76 6.55-22.63 17.38-27.79 31.45-3.45 9.43-4.54 19.23-3.86 29.24.75 11.01 3.6 21.39 9.34 30.87 6.9 11.4 16.69 19.1 29.47 23.08 6.23 1.94 12.55 2.3 18.95 2.05 19.05-.73 33.5-9.42 43.36-25.63 6.47-10.63 9.26-22.33 9.23-34.73ZM1172.72 394.77c-12.79.4-28.23-1.87-43.37-6.33-8.3-2.45-16.3-5.69-23.87-9.89-28.42-15.77-46.23-39.71-54.27-71.03-3.85-14.99-4.96-30.32-3.79-45.7 1.86-24.47 9.67-46.88 24.96-66.33 9.21-11.72 20.58-21.01 33.7-28.03 13.64-7.3 28.2-11.86 43.51-14.3 14-2.22 28.06-2.4 42.1-1.39 19.67 1.42 38.42 6.53 55.74 16.18 26.14 14.56 43.21 36.52 52.05 64.94 5.39 17.3 6.98 35.13 5.48 53.12-1.09 13.08-3.84 25.91-9 38.11-10.35 24.48-27.02 43.14-50.69 55.45-12.89 6.7-26.55 10.87-40.86 13.22-9.52 1.56-19.07 1.95-31.68 1.98Zm-49.96-121.12c0 2.55-.08 5.11.01 7.65.36 9.73 3.04 18.89 7.46 27.49 6.45 12.53 16.39 20.94 30.01 24.97 6.85 2.03 13.81 2.58 20.84 2.02 18.62-1.49 32.53-10.38 41.25-26.99 4.35-8.28 6.77-17.15 7.45-26.53.52-7.04.31-14.06-.51-21.03-1.17-9.92-4.16-19.31-9.48-27.86-4.82-7.76-11.08-14.11-19.39-17.99-15.62-7.29-31.44-7.51-47.16-.22-10.89 5.05-18.41 13.57-23.65 24.15-5.34 10.79-7.47 22.32-6.86 34.33ZM1815.82 303.25h22.08c1.92 0 3.84-.02 5.76.1 4.25.25 7.15 2.43 8.73 6.36.6 1.48 1.22 2.97 1.68 4.49 3.53 11.62 11.68 18.95 22.5 23.37 13.65 5.57 27.81 7.15 42.32 3.67 4.06-.97 7.93-2.51 11.41-4.88 3.51-2.39 6.19-5.43 7.85-9.43 2.78-6.67 1.22-12.53-3.04-17.9-2.43-3.07-5.71-5.08-9.28-6.63-6.2-2.68-12.68-4.47-19.3-5.61-12.28-2.12-24.61-4.01-36.91-6.01-13.59-2.21-27.04-4.98-39.98-9.79-8.13-3.02-15.8-6.93-22.63-12.37-11.07-8.82-17.32-20.3-19.06-34.28-.79-6.36-1.05-12.73-.34-19.14 1.82-16.41 9.25-29.74 21.82-40.27 7.17-6.01 15.23-10.56 23.96-13.91 9.89-3.79 20.09-6.24 30.58-7.85 16.25-2.48 32.57-2.53 48.83-1.36 17.61 1.27 34.8 4.98 50.74 13.14 10.09 5.17 18.91 11.9 26.14 20.7 6.82 8.3 11.3 17.78 14.32 27.99.62 2.11.81 4.4.86 6.62.07 2.94-2.09 5.53-4.98 6.28-1.23.32-2.5.53-3.77.61-1.91.11-3.84.08-5.76.08h-42.23c-1.92 0-3.84-.02-5.76-.05-4.91-.06-8.54-2.3-10.98-6.52-.96-1.66-1.88-3.35-2.81-5.02-5.18-9.3-13.33-14.62-23.53-16.57-8.18-1.56-16.52-1.94-24.82-.49-4.49.78-8.62 2.37-12.11 5.39-4.96 4.29-5.93 11.85-2.28 17.4 1.8 2.74 4.17 4.83 7 6.41 3.64 2.04 7.55 3.43 11.55 4.63 7.98 2.4 16.17 3.82 24.34 5.32 10.69 1.96 21.42 3.72 32.08 5.82 6.26 1.23 12.46 2.86 18.64 4.49 9.03 2.38 17.42 6.3 25.56 10.8 4.5 2.49 8.7 5.43 12.47 8.91 8.73 8.05 14.21 17.91 16.64 29.59 2.93 14.13 2.3 28.04-2.46 41.62-6.31 18.03-18.36 31.23-35.11 40.24-12.53 6.74-25.98 10.72-39.91 13.13-19.05 3.3-38.27 3.1-57.42 1.67-13.39-1-26.56-3.81-39.27-8.45-6.33-2.31-12.42-5.07-18.26-8.42-21.35-12.29-34.88-30.53-41.27-54.2-1-3.7-2.02-7.39-2-11.29.02-4.5 2.64-7.18 6.75-8.04 1.85-.39 3.82-.32 5.73-.33 8.32-.03 16.64-.01 24.96-.01ZM1564.6 277.94c0 33.59 0 67.18-.01 100.76 0 3.19-.18 6.39-.32 9.58-.05 1.08-1.54 2.44-2.61 2.4-1.91-.07-3.87.02-5.73-.35-20.7-4.09-37.48-14.21-49.14-32.16-1.56-2.4-3.27-4.7-4.95-7.03-.41-.57-2.11-.46-2.59.15-.8.99-1.61 1.97-2.34 3.01-2.21 3.14-4.29 6.37-6.58 9.44-11.17 15.01-26.18 24.16-44.18 28.55-13.22 3.23-26.69 3.14-40.08 1.72-9.21-.98-18.19-3.5-26.64-7.58-12.42-5.99-22.31-14.74-29.65-26.45-6.02-9.6-10.08-19.98-12.56-30.96-2.47-10.93-3.94-22.02-3.94-33.27 0-40.95-.02-81.89-.02-122.84 0-1.92 0-3.85.18-5.75.36-3.77 3.69-7.12 7.53-7.59 1.58-.19 3.19-.2 4.79-.2 16.95-.01 33.91 0 50.86 0 1.28 0 2.56.01 3.83.13 4.88.45 8.03 3.77 8.37 8.86.13 1.91.1 3.84.1 5.76.01 5.12 0 10.24 0 15.35 0 33.27.02 66.54 0 99.8 0 6.42.35 12.77 2.03 19.02 1.26 4.68 3.06 9.08 5.85 13.05 5.5 7.84 13.16 11.96 22.59 12.75 15.66 1.31 28.07-4.76 37.51-17.07 7.22-9.41 10.67-20.31 11.68-31.99.39-4.45.27-8.95.28-13.43.02-31.67 0-63.34.02-95.01 0-2.88-.06-5.77.16-8.63.38-4.88 3.81-8.12 8.76-8.5 1.27-.1 2.56-.1 3.84-.1h49.9c1.6 0 3.2 0 4.79.15 4.52.42 7.77 3.61 8.05 8.05.2 3.19.18 6.39.18 9.59.01 33.59 0 67.18 0 100.76ZM598.29 267.26v-98.83c0-2.88-.02-5.76.08-8.63.11-3.37 1.89-4.87 4.89-4.08 10.56 2.79 20.66 6.67 29.95 12.54 9.87 6.24 18.21 14.03 24.71 23.76 1.23 1.85 2.58 3.62 3.91 5.4.52.7 2.15.78 2.57.14 1.21-1.87 2.48-3.7 3.61-5.61 3.78-6.36 8.23-12.17 13.52-17.35 11.88-11.62 26.04-18.16 42.64-19.63 7.07-.63 14.06-.27 21.04.64 2.18.28 4.36 1.01 6.38 1.9 2.47 1.09 3.93 3.27 4.55 5.85.37 1.54.48 3.17.48 4.76.03 16.31.03 32.62 0 48.93 0 1.59-.24 3.19-.51 4.76-.34 1.99-2.64 3.98-4.77 4.16-1.27.11-2.56.19-3.82.03-2.85-.36-5.7-.81-8.52-1.36-7.6-1.46-15.28-1.79-22.93-1.12-17.48 1.53-29.93 10.3-36.66 26.65-3.43 8.34-5.3 17.09-5.4 26.14-.08 7.04-.02 14.07-.03 21.11v72.92c0 2.88-.01 5.76-.21 8.63-.28 3.94-3.45 7.06-7.48 7.5-1.27.14-2.55.18-3.83.18h-52.77c-.96 0-1.92-.04-2.87-.12-4.26-.38-7.06-2.8-7.91-7.07-.37-1.86-.54-3.8-.57-5.7-.08-5.44-.03-10.87-.04-16.31v-90.19ZM1605.94 267.69v-98.83c0-1.92.03-3.84 0-5.76-.11-7.45.65-8.88 9.06-6.24 10.12 3.19 19.76 7.29 28.57 13.29 9.12 6.21 16.66 13.91 22.68 23.13 1.03 1.58 2.26 3.04 3.54 4.43.27.29 1.24.17 1.76-.06.54-.24 1.02-.77 1.34-1.29 1.51-2.45 2.85-5.01 4.43-7.41 9.39-14.32 21.61-25.11 38.09-30.69 8.92-3.02 18.09-3.92 27.41-3.59 4.14.15 8.31.6 12.37 1.39 5.81 1.13 8.71 4.8 9.06 10.74.09 1.59.08 3.2.08 4.8v42.22c0 1.92-.01 3.84-.16 5.75-.33 4.35-3.29 6.89-7.78 6.52-2.86-.23-5.74-.58-8.54-1.2-7.25-1.59-14.59-1.72-21.95-1.56-3.85.08-7.59.81-11.33 1.78-11.18 2.91-19.37 9.61-24.98 19.5-4.81 8.48-7.02 17.79-7.8 27.44-.26 3.18-.13 6.39-.13 9.59 0 29.42 0 58.85-.01 88.27 0 2.88.03 5.76-.19 8.63-.33 4.36-3.71 7.56-8.18 7.96-1.27.11-2.56.14-3.83.14h-51.81c-1.28 0-2.56-.04-3.83-.17-3.83-.41-7.14-3.64-7.62-7.5-.19-1.58-.2-3.19-.21-4.79-.03-4.8-.02-9.59-.02-14.39v-92.11Z"
  })
], -1), Ts = [
  $s,
  Ss
], Ms = {
  key: 1,
  class: "h-10 w-auto text-white",
  viewBox: "0 0 1024 268",
  xmlns: "http://www.w3.org/2000/svg"
}, Os = /* @__PURE__ */ v("path", {
  d: "M241.468 269c-2.31-3.676-4.583-7.204-5.91-11.058-3.32-9.64-4.512-19.525-2.662-29.732 1.76-9.712 2.422-19.666 4.765-29.22 3.726-15.185 9.284-29.824 16.348-43.814 6.188-12.254 12.818-24.291 18.74-36.669 1.44-3.01 1.5-7.057 1.097-10.499-.922-7.863-2.323-15.687-3.889-23.455-2.854-14.152-7.825-27.2-18.378-37.804-6.097-6.126-12.481-11.503-21.238-11.805-5.167-.178-11.146.57-15.488 3.091-16.57 9.62-27.384 24.915-37.869 40.491-12.079 17.944-17.777 38.552-25.492 58.357-8.134 20.882-12.533 42.698-17.651 64.388-3.888 16.477-9.057 32.662-13.95 48.888-1.406 4.66-5.415 6.735-10.207 6.81-4.943.077-8.152-2.16-10.866-6.614-3.584-5.88-.172-11.112.454-16.392 1.152-9.711 3.375-19.348 5.84-28.838 3.38-13.012 7.582-25.81 11.085-38.793 2.257-8.363 4.002-16.87 5.775-25.356 2.042-9.772 4.044-19.56 5.715-29.4 1.09-6.423 1.764-12.935 2.27-19.435 1.132-14.563 2.046-29.144 3.035-43.718.065-.96.008-1.927.008-3.75-4.213 4.517-7.775 8.62-11.638 12.417-8.748 8.594-17.463 17.235-26.53 25.483-9.287 8.448-18.696 16.81-28.559 24.565-14.484 11.386-29.45 22.16-44.149 33.275-6.499 4.914-14.304 5.408-20.737-.41C1 135.31 1 130.62 1.364 125.465c7.346-5.454 14.433-10.3 21.289-15.454C36.633 99.5 50.608 88.975 64.338 78.14c5.888-4.645 11.316-9.91 16.673-15.18a1976.489 1976.489 0 0 0 30.977-31.157C118.603 25 125.014 17.99 131.34 10.917c2.778-3.105 5.12-6.6 7.659-9.917h13.535c1.694 1.727 3.54 3.3 4.02 5.214.898 3.596 1.407 7.394 1.368 11.1-.107 9.918-.52 19.835-.95 29.746-.242 5.546-.762 11.08-1.243 17.826 1.686-1.375 2.617-1.882 3.203-2.651 6.891-9.06 12.885-18.986 20.785-27.049 11.423-11.66 24.324-22.046 41.449-24.058 12.08-1.419 23.685.935 34.074 7.64 22.116 14.274 33.1 35.525 37.766 60.685.06.323.05.668.162.97.432 1.163.901 2.313 1.513 3.866 5.543-5.167 10.72-10.43 16.349-15.154 13.637-11.448 29.08-17.425 47.004-13.027 9.994 2.452 17.684 8.692 23.12 17.507 8.665 14.055 12.077 29.466 11.868 45.843-.124 9.663.233 19.336-.09 28.99-.384 11.511-1.96 23.018-1.753 34.505.252 13.918 1.22 27.898 3.156 41.671.697 4.952 4.42 10.011 7.983 13.902 5.319 5.808 12.683 4.54 19.25 2.403 8.796-2.861 17.3-6.613 25.957-9.912 4.231-1.612 8.526-1.812 12.401.854 5.338 3.673 4.64 9.37 3.703 14.516-.389 2.135-2.963 4.461-5.124 5.588-15.717 8.197-32.038 14.83-50.19 13.9-9.458-.485-17.776-4.27-24.556-11.391-8.834-9.278-12.995-20.4-13.7-32.861-.924-16.315-1.938-32.656-1.914-48.984.027-18.001 1.726-36.002 1.668-54-.04-12.336-2.55-24.39-10.751-34.502-3.615-4.456-11.324-6.4-16.742-4.997-15.907 4.123-25.103 15.795-33.585 28.5-1.886 2.825-4.258 5.34-6.026 8.23-2.683 4.384-4.928 8.65-4.928 14.383 0 13.999-.527 28.059-1.982 41.975-1.067 10.21-3.504 20.346-6.127 30.305-2.719 10.32-5.667 20.703-9.86 30.482-4.324 10.086-10.085 19.585-15.627 29.101-1.484 2.549-4.466 4.226-6.473 6.593-5.068.291-10.423.291-16.245.291m22.49-74.62c-5.298 14.578-7.385 24.635-5.543 27.869 4.895-12.115 8.524-24.303 10.697-36.873l-1.723-.544c-1.13 2.91-2.26 5.818-3.43 9.548zM1025 138.556c-4.724.878-9.447 1.312-14.256 1.754-1.445 3.228-2.722 6.811-4.586 10.056-2.352 4.094-5.606 3.822-7.708-.501-1.52-3.127-2.75-6.396-4.04-9.441-3.844-.473-7.751-.764-11.58-1.477-3.882-.723-4.546-2.708-2.191-6.094 2.384-3.428 4.928-6.745 7.403-10.111l1.343 1.86c-.795-3.498-2.013-6.963-2.285-10.5-.402-5.218 2.848-7.517 6.913-4.198 6.419 5.242 11.249 5.086 17.272-.392 3.055-2.778 6.933-.213 6.628 4.061-.255 3.567-1.272 7.078-2.102 11.4 2.243 1.717 5.43 4.159 8.903 6.314.286 2.084.286 4.454.286 7.269zM628.655 195.75c4.49-6.385 8.665-12.562 12.849-18.733 1.897-2.799 4.882-4.17 7.652-2.704 1.577.834 2.68 3.958 2.722 6.076.248 12.49.172 24.989.098 37.483-.031 5.289-3.161 7.92-7.4 5.699-1.826-.956-3.246-4.196-3.417-6.505-.464-6.249-.159-12.555-.159-20.342-3.527 4.707-6.09 8.36-8.898 11.813-3.133 3.851-6.351 3.563-9.106-.596-2.636-3.981-5.264-7.969-8.996-11.936v12.953c0 3.332-.202 6.68.055 9.992.28 3.602-2.012 4.65-4.704 4.976-3.033.368-5.221-1.47-5.26-4.386-.184-13.659-.201-27.324.083-40.98.031-1.525 2.261-4.147 3.621-4.248 2.28-.17 5.624.56 6.862 2.18 4.486 5.865 8.273 12.265 12.36 18.44.293.442.878.69 1.638.818zM629.729 121.703c4.154-6.188 8.263-11.969 11.921-18.022 2.135-3.533 5.373-3.01 8.097-2.377 1.12.26 2.125 3.595 2.155 5.548.192 12.49.095 24.986.1 37.48.001 3.082-.01 5.692-4.481 5.796-4.439.103-6.474-1.546-6.508-5.815-.05-6.386-.013-12.773-1.045-19.422-2.635 3.579-5.043 7.356-7.964 10.684-3.251 3.704-6.238 3.233-9.07-.947-2.643-3.9-5.254-7.824-8.934-11.486 0 7.375-.113 14.753.052 22.125.072 3.236-.587 4.98-4.36 4.817-3.5-.15-5.736-.946-5.716-4.988.065-12.827-.101-25.656.162-38.478.039-1.884 1.646-5.023 3.013-5.316 2.58-.554 5.769-1.495 7.933 2.329 3.504 6.19 7.762 11.958 11.834 17.812.366.527 1.695.384 2.811.26zM911.364 175.357c3.042-.66 5.759-1.225 8.49-1.31 5.153-.162 10.315-.077 15.472-.04 7.039.051 11.302 3.694 13.79 10.16 2.188 5.69.269 10.37-2.765 14.924-.52.78-1.563 1.213-1.816 1.4 1.017 2.22 1.712 3.812 2.47 5.374 1.59 3.27-.191 7.633 3.813 10.342.988.67.889 4.542-.092 6.034-.83 1.263-3.931 2.078-5.543 1.566-3.53-1.12-7.053-3.073-7.15-7.583-.19-8.796-1.763-10.303-10.696-10.226-1.96.016-3.921.002-6.337.002 0 4.085-.064 7.864.018 11.64.082 3.819-1.315 6.355-5.468 6.329-4.363-.027-5.396-3.347-5.477-6.689-.215-8.813-.192-17.636-.027-26.451.095-5.058.651-10.107 1.318-15.472M930.277 184h-8.974v13h10.66c.496 0 1.11.189 1.466-.034 1.349-.845 3.185-1.54 3.812-2.802 2.79-5.616.186-9.799-6.964-10.164zM804.79 146.543c-8.96 4.695-18.03 6.186-27.299 2.398-8.13-3.323-12.69-9.57-14.63-18.252-1.282-5.74.097-10.514 1.963-15.82 4.52-12.852 19.211-15.932 28.321-14.746 2.182.284 4.254 1.325 6.415 1.864 3.744.934 4.134 4.003 3.206 6.586-.554 1.544-3.176 2.984-5.044 3.255-2.293.332-4.797-.487-7.161-1.02-4.786-1.08-10.703 1.402-13.625 5.503-3.761 5.278-5.278 10.8-1.522 16.521 3.437 5.234 8.253 8.485 14.936 8.193 4.766-.209 4.77-.106 4.523-8.026-1.891 0-4.223.685-5.639-.161-2.084-1.247-4.612-3.426-4.914-5.504-.298-2.047 1.517-4.662 5.029-4.408 4.307.311 8.667-.107 12.976.19 1.208.084 3.316 1.572 3.317 2.418.008 6.878-.386 13.756-.853 21.01zM777.045 207.463c-.521 3.716-.936 7.109-1.003 10.508-.072 3.65-1.44 5.94-5.328 6.012-4.076.075-5.745-2.15-5.73-6.083.045-12.648.031-25.297.007-37.945-.007-3.97 1.817-6.12 5.867-5.93 3.746.176 5.499 2.012 5.21 6.022-.304 4.228-.068 8.495-.068 14.245 4.348-4.266 7.703-7.54 11.038-10.835 2.84-2.805 5.536-5.77 8.522-8.408 2.5-2.208 5.22-3.375 8.024-.045 2.462 2.924 1.635 5.062-.662 7.695-4.053 4.645-7.704 9.641-11.961 15.047 3.075 3.957 8.344 10.07 12.709 16.771 1.251 1.922.954 6.67-.552 8.101-1.797 1.706-5.616 2.81-8.291-.93-4.317-6.034-9.088-11.743-13.714-17.65a121.812 121.812 0 0 0-4.068 3.425zM1001.322 173c5.465 1.005 10.627 1.568 15.445 3.17 3.167 1.053 6.007 3.695 4.668 7.809-1.554 4.777-5.32 3.101-8.556 2.366-1.224-.278-2.353-1.004-3.502-1.571-6.238-3.079-8.648-2.518-13.337 3.13 1.997 5.447 7.19 4.886 11.445 6.1 4.348 1.242 8.903 1.781 12.102 5.772 3.342 4.17 3.536 14.586-.104 18.265-7.122 7.196-21.982 8.64-30.053 2.641-1.858-1.381-3.512-3.603-4.206-5.774-.416-1.303.849-4.286 2-4.69 1.965-.692 5.04-.775 6.573.351 3.673 2.697 7.533 4.2 11.832 3.285 2.279-.486 5.37-2.04 6.074-3.884 1.042-2.73-1.716-4.409-4.37-5.153-3.226-.904-6.428-1.978-9.714-2.565-14.154-2.53-14.418-17.961-7.439-24.404 2.73-2.52 7.08-3.284 11.142-4.848zM870.45 183.81c-6.578.166-12.722.166-19.157.166V193c4.318 0 8.754.063 13.188-.019 3.944-.073 6.387 1.612 6.473 5.664.09 4.263-2.984 4.433-6.19 4.375-4.457-.08-8.915-.02-13.563-.02v11c5.964 0 11.754.086 17.54-.037 2.79-.059 4.505.54 4.297 3.826-.183 2.891.654 6.223-3.978 6.214-7.998-.017-15.996.036-23.993-.026-2.914-.023-4.181-1.365-4.14-4.578.173-13.66.18-27.326-.003-40.986-.045-3.379 1.558-4.366 4.331-4.39 7.83-.064 15.666-.141 23.49.086 1.433.042 3.988 1.455 4.016 2.302.082 2.438 1.802 5.684-2.311 7.4zM709.937 213h-10.53c-1.156 2.594-2.502 4.992-3.303 7.56-1.131 3.624-3.985 4.083-6.641 3.204-1.227-.406-2.677-3.48-2.288-4.853 1.69-5.972 3.868-11.822 6.15-17.605 3.097-7.843 6.26-15.674 9.825-23.31.952-2.039 3.624-4.79 5.239-4.624 2.023.209 4.558 2.739 5.509 4.874 5.645 12.673 10.81 25.56 16.339 38.287 1.48 3.406.638 6.144-2.313 7.276-3.118 1.196-6.116-.038-7.4-3.727-.791-2.278-1.751-4.498-2.77-7.082h-7.817m1.147-10.001c.617-.334 1.791-.922 1.772-.964-1.446-3.155-2.986-6.266-4.907-10.17L703.754 203l7.33-.001zM687.195 149.448c-1.274-6.973 2.56-12.15 4.818-17.754a1816.681 1816.681 0 0 1 11.286-27.37c1.523-3.613 4.082-5.468 7.989-3.276 1.093.614 2.157 1.745 2.65 2.89 4.419 10.264 8.696 20.588 13.04 30.884 1.17 2.774 2.653 5.44 3.573 8.29.844 2.615 1.246 5.48-2.175 6.885-3.446 1.414-6.181.707-7.773-2.882-.387-.87-.615-1.824-.825-2.76-.745-3.33-2.5-5.036-6.18-4.407-1.778.303-3.68.26-5.477.014-6.047-.824-10.536.034-12.05 7.326-1.01 4.867-5.355 3.103-8.876 2.16m24.858-21.957c-1.18-2.61-2.362-5.218-4.03-8.905l-4.234 11.403c2.86 0 5.317.085 7.757-.084.4-.028.722-1.172.507-2.414zM891.628 115.85c2.309-7.403 10.407-14.583 17.416-14.759 5.537-.139 11.133.244 16.632.952 4.11.53 4.751 3.971 4.276 7.44-.54 3.946-3.806 2.424-5.97 2.43-3.078.009-6.153-.778-9.24-.869-5.276-.154-11.534 4.386-12.742 8.97-2.343 8.885-.264 14.927 6.006 18.58 4.494 2.62 8.574 3.586 13.635.846 1.983-1.073 6.232-2.336 7.971 1.787 1.763 4.176.23 6.782-4.631 8.321-12.49 3.953-23.476.842-31.361-9.54-4.395-5.786-4.001-12.828-3.321-19.686.14-1.415.68-2.79 1.33-4.473zM843 125c0-6.499.094-12.5-.035-18.496-.078-3.66 1.239-5.368 5.127-5.6 4.191-.25 5.793 1.842 5.858 5.405.154 8.329.05 16.662.05 24.994 0 4.333-.14 8.67.041 12.996.166 3.956-1.318 5.76-5.443 5.77-3.998.012-5.742-1.505-5.64-5.574.159-6.328.042-12.663.042-19.495z",
  fill: "#FFF"
}, null, -1), Is = [
  Os
];
function Ps(u, e, D, f, t, n) {
  return u.getAppName() === "Parkours" ? (E(), y("svg", xs, Ts)) : u.getAppName() === "Magic Makers" ? (E(), y("svg", Ms, Is)) : R("", !0);
}
const Ls = /* @__PURE__ */ Q(As, [["render", Ps]]), Rs = z({
  props: {
    imageUrl: { type: String },
    name: { type: String },
    role: { type: String },
    department: { type: String }
  }
}), Ns = { "aria-labelledby": "profile-overview-title" }, js = { class: "rounded-lg bg-white overflow-hidden shadow" }, Vs = /* @__PURE__ */ v("h2", {
  id: "profile-overview-title",
  class: "sr-only"
}, "Profile Overview", -1), zs = { class: "bg-white p-8" }, Us = { class: "sm:flex sm:items-center sm:justify-between" }, Ws = { class: "sm:flex sm:space-x-5" }, qs = {
  key: 0,
  class: "flex-shrink-0"
}, Ys = ["src"], Hs = {
  key: 1,
  class: "text-center"
}, Gs = /* @__PURE__ */ v("span", { class: "inline-block h-24 w-24 rounded-full overflow-hidden bg-gray-100" }, [
  /* @__PURE__ */ v("svg", {
    class: "h-full w-full text-gray-300",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /* @__PURE__ */ v("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
  ])
], -1), Xs = [
  Gs
], Zs = { class: "mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left" }, Ks = /* @__PURE__ */ v("p", { class: "text-sm font-medium text-gray-600" }, "Bienvenue,", -1), Qs = { class: "text-xl font-bold text-gray-900 sm:text-3xl" }, Js = { class: "text-base font-medium text-gray-600" }, u8 = { class: "mt-5 flex justify-center sm:mt-0" };
function e8(u, e, D, f, t, n) {
  return E(), y("section", Ns, [
    v("div", js, [
      Vs,
      v("div", zs, [
        v("div", Us, [
          v("div", Ws, [
            u.imageUrl ? (E(), y("div", qs, [
              v("img", {
                src: u.imageUrl,
                alt: "",
                class: "mx-auto h-24 w-24 rounded-full"
              }, null, 8, Ys)
            ])) : (E(), y("div", Hs, Xs)),
            v("div", Zs, [
              Ks,
              v("p", Qs, O(u.name), 1),
              v("p", Js, O(u.role) + " - " + O(u.department), 1)
            ])
          ]),
          v("div", u8, [
            fu(u.$slots, "right-column")
          ])
        ])
      ])
    ])
  ]);
}
const g4 = /* @__PURE__ */ Q(Rs, [["render", e8]]), D8 = z({
  setup() {
    return {};
  }
}), f8 = { class: "relative z-0 inline-flex shadow-sm rounded-md" };
function t8(u, e, D, f, t, n) {
  return E(), y("div", f8, [
    fu(u.$slots, "default")
  ]);
}
const v4 = /* @__PURE__ */ Q(D8, [["render", t8]]), a8 = z({
  setup() {
    return {};
  }
}), n8 = {
  type: "button",
  class: "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 -ml-px first:rounded-l-md first:ml-0 last:rounded-r-md hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary-400 focus:border-primary-400"
}, o8 = {
  key: 0,
  class: "-mx-2 h-5 w-5"
}, r8 = {
  key: 1,
  class: "inline-flex items-center"
}, l8 = {
  key: 0,
  class: "-ml-1 mr-2 h-5 w-5"
};
function i8(u, e, D, f, t, n) {
  return E(), y("button", n8, [
    u.$slots.icon ? (E(), y("span", o8, [
      fu(u.$slots, "icon")
    ])) : (E(), y("span", r8, [
      u.$slots["icon-before"] ? (E(), y("span", l8, [
        fu(u.$slots, "icon-before")
      ])) : R("", !0),
      fu(u.$slots, "default")
    ]))
  ]);
}
const h4 = /* @__PURE__ */ Q(a8, [["render", i8]]), d8 = z({}), s8 = /* @__PURE__ */ v("h1", null, "404 Page Not Found", -1), c8 = [
  s8
];
function F8(u, e, D, f, t, n) {
  return E(), y("div", null, c8);
}
const B4 = /* @__PURE__ */ Q(d8, [["render", F8]]), C8 = z({}), E8 = { class: "min-h-screen bg-primary-500 flex" }, m8 = { class: "flex flex-1 pb-16 sm:pt-8 sm:pb-24 flex-col lg:flex-none bg-white" }, p8 = { class: "px-4 sm:px-12 h-16 flex justify-between items-center" }, b8 = { class: "text-sm" }, g8 = { class: "text-gray-400 uppercase" }, v8 = { class: "text-gray-900" }, h8 = { class: "flex-1 flex flex-col justify-center px-4 py-8 sm:px-6 lg:px-20 xl:px-24" }, B8 = { class: "mx-auto w-full max-w-sm lg:w-96" }, y8 = { class: "mt-6 text-3xl font-extrabold text-gray-900" }, _8 = { class: "pt-4 text-gray-400 tracking-wide font-light" }, w8 = { class: "mt-8" }, k8 = { class: "mt-6" }, A8 = { class: "hidden h-screen lg:flex relative w-0 flex-1 justify-center items-center" }, x8 = { class: "fixed text-white max-w-md p-16 xl:max-w-2xl" }, $8 = { class: "text-4xl xl:text-5xl font-semibold" }, S8 = { class: "text-xl xl:text-2xl mt-10 font-light" };
function T8(u, e, D, f, t, n) {
  return E(), y("div", E8, [
    v("div", m8, [
      v("div", p8, [
        fu(u.$slots, "step-back"),
        v("div", b8, [
          v("div", g8, [
            fu(u.$slots, "step")
          ]),
          v("div", v8, [
            fu(u.$slots, "step-title")
          ])
        ])
      ]),
      v("div", h8, [
        v("div", B8, [
          v("div", null, [
            v("h2", y8, [
              fu(u.$slots, "title")
            ]),
            v("p", _8, [
              fu(u.$slots, "description")
            ])
          ]),
          v("div", w8, [
            v("div", k8, [
              fu(u.$slots, "default")
            ])
          ])
        ])
      ])
    ]),
    v("div", A8, [
      v("div", x8, [
        v("h3", $8, [
          fu(u.$slots, "side-title")
        ]),
        v("p", S8, [
          fu(u.$slots, "side-description")
        ])
      ])
    ])
  ]);
}
const y4 = /* @__PURE__ */ Q(C8, [["render", T8]]), M8 = z({
  components: {
    Avatar: ot,
    Logo: Ls,
    Menu: n0,
    MenuButton: o0,
    MenuItem: l0,
    MenuItems: r0,
    Popover: Af,
    PopoverButton: F0,
    PopoverOverlay: Va,
    PopoverPanel: C0,
    TransitionChild: oD,
    TransitionRoot: rD,
    Bars3Icon: Ct,
    XMarkIcon: vf
  },
  props: {
    navigation: { type: Object, required: !0 },
    userNavigation: { type: Object, required: !0 },
    user: { type: Object, required: !0 }
  },
  setup(u) {
    return {
      showPulseIcon: w(() => u.navigation.some((D) => !!D.count))
    };
  }
}), O8 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8" }, I8 = { class: "relative flex flex-wrap items-center justify-center lg:justify-between" }, P8 = { class: "hidden lg:ml-4 lg:flex lg:items-center lg:py-5 lg:pr-0.5" }, L8 = /* @__PURE__ */ v("span", { class: "sr-only" }, "Open user menu", -1), R8 = ["alt", "src"], N8 = { class: "w-full py-5 lg:border-t lg:border-white lg:border-opacity-20" }, j8 = { class: "lg:grid lg:grid-cols-3 lg:gap-8 lg:items-center" }, V8 = { class: "hidden lg:block lg:col-span-2" }, z8 = { class: "flex space-x-4" }, U8 = {
  key: 0,
  class: "bg-secondary-300 text-primary-600 ml-2 hidden rounded-full h-5 w-5 text-center text-xs font-medium justify-center items-center md:flex"
}, W8 = { class: "absolute right-0 flex-shrink-0 lg:hidden" }, q8 = {
  key: 0,
  class: "absolute flex h-3 w-3 top-0 right-0"
}, Y8 = /* @__PURE__ */ v("span", { class: "animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary-400 opacity-75" }, null, -1), H8 = /* @__PURE__ */ v("span", { class: "relative inline-flex rounded-full h-3 w-3 bg-secondary-500" }, null, -1), G8 = [
  Y8,
  H8
], X8 = /* @__PURE__ */ v("span", { class: "sr-only" }, "Open main menu", -1), Z8 = { class: "lg:hidden" }, K8 = { class: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y divide-gray-200" }, Q8 = { class: "pt-3 pb-2" }, J8 = { class: "flex items-center justify-between px-4" }, uc = { class: "-mr-2" }, ec = /* @__PURE__ */ v("span", { class: "sr-only" }, "Close menu", -1), Dc = { class: "mt-3 px-2 space-y-1" }, fc = {
  key: 0,
  class: "bg-secondary-300 text-primary-600 rounded-full h-5 w-5 text-center text-xs font-medium flex items-center justify-center"
}, tc = { class: "pt-4 pb-2" }, ac = { class: "flex items-center px-5" }, nc = {
  key: 0,
  class: "flex-shrink-0"
}, oc = ["src"], rc = {
  key: 1,
  class: "inline-block h-8 w-8 rounded-full overflow-hidden bg-gray-100"
}, lc = /* @__PURE__ */ v("svg", {
  class: "h-full w-full text-gray-300",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ v("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
], -1), ic = [
  lc
], dc = { class: "ml-3 min-w-0 flex-1" }, sc = { class: "text-base font-medium text-gray-800 truncate" }, cc = { class: "text-sm font-medium text-gray-500 truncate" }, Fc = { class: "mt-3 px-2 space-y-1" }, Cc = {
  key: 0,
  class: "bg-secondary-300 text-primary-600 ml-2 hidden rounded-full h-5 w-5 text-xs font-medium items-center justify-center md:flex"
};
function Ec(u, e, D, f, t, n) {
  const a = P("Logo"), o = P("Avatar"), r = P("MenuButton"), l = P("router-link"), i = P("MenuItem"), s = P("MenuItems"), d = P("Menu"), g = P("Bars3Icon"), h = P("XMarkIcon"), _ = P("PopoverButton"), C = P("PopoverOverlay"), p = P("TransitionChild"), b = P("PopoverPanel"), m = P("TransitionRoot"), F = P("Popover");
  return E(), q(F, {
    as: "header",
    class: "pb-24 bg-primary-500"
  }, {
    default: N(({ open: c }) => [
      v("div", O8, [
        v("div", I8, [
          U(a, { class: "my-5" }),
          v("div", P8, [
            U(d, {
              as: "div",
              class: "ml-4 relative flex-shrink-0"
            }, {
              default: N(() => [
                v("div", null, [
                  U(r, { class: "bg-white rounded-full flex text-sm ring-2 ring-white ring-opacity-20 focus:outline-none focus:ring-opacity-100" }, {
                    default: N(() => [
                      L8,
                      u.user.imageUrl ? (E(), y("img", {
                        key: 0,
                        alt: `${u.user.firstName} ${u.user.lastName} profile image`,
                        src: u.user.imageUrl,
                        class: "h-8 w-8 rounded-full"
                      }, null, 8, R8)) : (E(), q(o, {
                        key: 1,
                        size: "sm"
                      }))
                    ]),
                    _: 1
                  })
                ]),
                U(_e, {
                  "leave-active-class": "transition ease-in duration-75",
                  "leave-from-class": "transform opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 scale-95"
                }, {
                  default: N(() => [
                    U(s, { class: "origin-top-right z-40 absolute -right-2 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                      default: N(() => [
                        (E(!0), y(J, null, du(u.userNavigation, (B) => (E(), q(i, {
                          key: B.name
                        }, {
                          default: N(({ active: k }) => [
                            U(l, {
                              class: M([k ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700"]),
                              to: B.to
                            }, {
                              default: N(() => [
                                G(O(B.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "to"])
                          ]),
                          _: 2
                        }, 1024))), 128)),
                        v("form", {
                          onSubmit: e[0] || (e[0] = ju((B) => u.$emit("logout"), ["prevent"]))
                        }, [
                          U(i, null, {
                            default: N(({ active: B }) => [
                              v("button", {
                                class: M([
                                  B ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                  "block w-full text-left px-4 py-2 text-sm"
                                ]),
                                type: "submit"
                              }, " Se déconnecter ", 2)
                            ]),
                            _: 1
                          })
                        ], 32)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          v("div", N8, [
            v("div", j8, [
              v("div", V8, [
                v("nav", z8, [
                  (E(!0), y(J, null, du(u.navigation, (B) => (E(), q(l, {
                    key: B.name,
                    "aria-current": B.current ? "page" : void 0,
                    class: M([
                      B.current ? "text-white" : "text-primary-100",
                      "text-base font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10 flex items-center"
                    ]),
                    to: B.to
                  }, {
                    default: N(() => [
                      G(O(B.name) + " ", 1),
                      B.count ? (E(), y("span", U8, O(B.count), 1)) : R("", !0)
                    ]),
                    _: 2
                  }, 1032, ["aria-current", "class", "to"]))), 128))
                ])
              ])
            ])
          ]),
          v("div", W8, [
            U(_, { class: "bg-transparent relative p-2 rounded-md inline-flex items-center justify-center text-primary-200 hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:ring-2 focus:ring-white" }, {
              default: N(() => [
                u.showPulseIcon ? (E(), y("span", q8, G8)) : R("", !0),
                X8,
                c ? (E(), q(h, {
                  key: 2,
                  "aria-hidden": "true",
                  class: "block h-6 w-6"
                })) : (E(), q(g, {
                  key: 1,
                  "aria-hidden": "true",
                  class: "block h-6 w-6"
                }))
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]),
      U(m, {
        show: c,
        as: "template"
      }, {
        default: N(() => [
          v("div", Z8, [
            U(p, {
              as: "template",
              enter: "duration-150 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-150 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: N(() => [
                U(C, { class: "z-20 fixed inset-0 bg-black bg-opacity-25" })
              ]),
              _: 1
            }),
            U(p, {
              as: "template",
              enter: "duration-150 ease-out",
              "enter-from": "opacity-0 scale-95",
              "enter-to": "opacity-100 scale-100",
              leave: "duration-150 ease-in",
              "leave-from": "opacity-100 scale-100",
              "leave-to": "opacity-0 scale-95"
            }, {
              default: N(() => [
                U(b, {
                  class: "z-30 absolute top-0 inset-x-0 max-w-3xl mx-auto w-full p-2 transition transform origin-top",
                  focus: ""
                }, {
                  default: N(() => [
                    v("div", K8, [
                      v("div", Q8, [
                        v("div", J8, [
                          U(a),
                          v("div", uc, [
                            U(_, { class: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-400" }, {
                              default: N(() => [
                                ec,
                                U(h, {
                                  "aria-hidden": "true",
                                  class: "h-6 w-6"
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        v("div", Dc, [
                          (E(!0), y(J, null, du(u.navigation, (B) => (E(), q(l, {
                            key: B.name,
                            to: B.to,
                            class: "rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800 flex items-center gap-2"
                          }, {
                            default: N(() => [
                              G(O(B.name) + " ", 1),
                              B.count ? (E(), y("span", fc, O(B.count), 1)) : R("", !0)
                            ]),
                            _: 2
                          }, 1032, ["to"]))), 128))
                        ])
                      ]),
                      v("div", tc, [
                        v("div", ac, [
                          u.user.imageUrl ? (E(), y("div", nc, [
                            v("img", {
                              src: u.user.imageUrl,
                              alt: "",
                              class: "h-10 w-10 rounded-full"
                            }, null, 8, oc)
                          ])) : (E(), y("span", rc, ic)),
                          v("div", dc, [
                            v("div", sc, O(u.user.fullName), 1),
                            v("div", cc, O(u.user.email), 1)
                          ])
                        ]),
                        v("div", Fc, [
                          (E(!0), y(J, null, du(u.userNavigation, (B) => (E(), q(l, {
                            key: B.name,
                            to: B.to,
                            class: "block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800"
                          }, {
                            default: N(() => [
                              G(O(B.name) + " ", 1),
                              B.count ? (E(), y("span", Cc, O(B.count), 1)) : R("", !0)
                            ]),
                            _: 2
                          }, 1032, ["to"]))), 128)),
                          v("button", {
                            class: "block w-full text-left rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800",
                            type: "submit",
                            onClick: e[1] || (e[1] = (B) => u.$emit("logout"))
                          }, " Se déconnecter ")
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 2
      }, 1032, ["show"])
    ]),
    _: 1
  });
}
const mc = /* @__PURE__ */ Q(M8, [["render", Ec]]), w1 = I(""), k1 = I(""), wD = I(!0), A1 = I(""), x1 = I("");
function pc(u) {
  const e = (f) => {
    w1.value = f.title, k1.value = f.shortTitle, A1.value = f.linkText ? f.linkText : "", x1.value = f.to ? f.to : "", wD.value = !1;
  };
  return u && e(u), { title: w1, shortTitle: k1, to: x1, linkText: A1, isHidden: wD, hide: () => {
    wD.value = !0;
  }, setBannerParams: e };
}
const bc = z({
  components: {
    XMarkIcon: If
  },
  setup() {
    const { isHidden: u, title: e, shortTitle: D, to: f, linkText: t, hide: n } = pc();
    return {
      hide: n,
      isHidden: u,
      title: e,
      shortTitle: D,
      to: f,
      linkText: t
    };
  }
}), gc = {
  key: 0,
  class: "relative bg-secondary-400"
}, vc = { class: "max-w-screen-xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }, hc = { class: "pr-16 sm:text-center sm:px-16" }, Bc = { class: "text-secondary-900 text-sm" }, yc = { class: "md:hidden" }, _c = { class: "hidden md:inline" }, wc = {
  key: 0,
  class: "block sm:ml-2 sm:inline-block"
}, kc = ["href", "onClick"], Ac = { class: "absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start" };
function xc(u, e, D, f, t, n) {
  const a = P("router-link"), o = P("XMarkIcon");
  return u.isHidden ? R("", !0) : (E(), y("div", gc, [
    v("div", vc, [
      v("div", hc, [
        v("p", Bc, [
          v("span", yc, O(u.shortTitle), 1),
          v("span", _c, O(u.title), 1),
          u.to && u.linkText ? (E(), y("span", wc, [
            U(a, {
              to: u.to,
              custom: ""
            }, {
              default: N(({ href: r, navigate: l }) => [
                v("a", {
                  href: r,
                  class: "text-secondary-900 font-bold underline",
                  onClick: l
                }, O(u.linkText), 9, kc)
              ]),
              _: 1
            }, 8, ["to"])
          ])) : R("", !0)
        ])
      ]),
      v("div", Ac, [
        v("button", {
          "aria-label": "Dismiss",
          class: "flex p-2 rounded-md hover:bg-secondary-500 focus:outline-none focus:bg-secondary-500 transition ease-in-out duration-150",
          type: "button",
          onClick: e[0] || (e[0] = (...r) => u.hide && u.hide(...r))
        }, [
          U(o, { class: "h-5 w-5 text-secondary-900" })
        ])
      ])
    ])
  ]));
}
const $c = /* @__PURE__ */ Q(bc, [["render", xc]]), Sc = z({
  emits: ["logout"],
  components: {
    Banner: $c,
    Header: mc
  },
  props: {
    navigation: { type: Object, required: !0 },
    userNavigation: { type: Object, required: !0 },
    user: { type: Object, required: !0 }
  },
  setup() {
    const { getAppName: u } = fe();
    return {
      getAppName: u
    };
  }
}), Tc = { class: "min-h-full" }, Mc = { class: "-mt-24 pb-8" }, Oc = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8" }, Ic = /* @__PURE__ */ v("h1", { class: "sr-only" }, "Profile", -1), Pc = { class: "grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-8" }, Lc = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl" }, Rc = { class: "border-t border-gray-200 py-8 text-sm text-gray-500 text-center sm:text-left" }, Nc = { class: "block sm:inline" }, jc = /* @__PURE__ */ v("span", { class: "block sm:inline" }, "Tous droits réservés. ", -1);
function Vc(u, e, D, f, t, n) {
  const a = P("Banner"), o = P("Header");
  return E(), y("div", Tc, [
    U(a),
    U(o, {
      navigation: u.navigation,
      user: u.user,
      "user-navigation": u.userNavigation,
      onLogout: e[0] || (e[0] = (r) => u.$emit("logout"))
    }, null, 8, ["navigation", "user", "user-navigation"]),
    v("main", Mc, [
      v("div", Oc, [
        Ic,
        v("div", Pc, [
          fu(u.$slots, "default")
        ])
      ])
    ]),
    v("footer", null, [
      v("div", Lc, [
        v("div", Rc, [
          v("span", Nc, "© " + O((/* @__PURE__ */ new Date()).getFullYear()) + " " + O(u.getAppName()) + ". ", 1),
          jc
        ])
      ])
    ])
  ]);
}
const _4 = /* @__PURE__ */ Q(Sc, [["render", Vc]]), We = I(new Array());
function w4(u, e) {
  e && (We.value = e);
  const D = w(() => u.value.query.tab ? u.value.query.tab.toString() : We.value.length ? We.value[0].key : ""), f = (n) => w(() => D.value === n.key);
  return { tabs: w(
    () => We.value.map((n) => {
      const a = {
        current: f(n).value,
        to: {
          path: u.value.fullPath,
          query: {
            tab: n.key
          }
        },
        ...n
      };
      return f(n).value && u.value.query.filters && (a.to.query = {
        ...a.to.query,
        filters: u.value.query.filters
      }), a;
    })
  ), currentTab: D };
}
const Vf = Symbol("DefaultRouter");
export {
  qc as Alert,
  ot as Avatar,
  lD as Badge,
  Pe as Button,
  v4 as ButtonGroup,
  h4 as ButtonItem,
  Xc as Card,
  i4 as CardRadioGroup,
  Qc as Checkbox,
  Gc as ConfirmModal,
  _4 as ConstrainedGridLayout,
  Vf as DefaultRouter,
  h3 as Emoji,
  C4 as FormButton,
  F4 as FormItems,
  c4 as FormLabel,
  s4 as FormTitle,
  m4 as FormUpdatedBy,
  b4 as IBANInput,
  Y0 as Input,
  Je as LoadingIcon,
  Ls as Logo,
  Hc as Modal,
  B4 as PageNotFound,
  d4 as Radio,
  l4 as RadioGroup,
  y4 as RegistrationLayout,
  E4 as SearchBadge,
  Di as Select,
  p4 as SiretInput,
  Yc as Steps,
  Kc as Table,
  Zc as Tabs,
  Jc as TermsConfirmation,
  o4 as Textarea,
  Wc as Toggle,
  Pf as Tooltip,
  r4 as Upload,
  g4 as WelcomePanel,
  x2 as addDaysUTC,
  n4 as addMonthsUTC,
  a4 as addWeeksUTC,
  fi as clickOutside,
  u4 as eachDayOfIntervalUTC,
  t4 as endOfMonthUTC,
  D4 as endOfWeekUTC,
  A2 as midnightUTC,
  f4 as startOfMonthUTC,
  e4 as startOfWeekUTC,
  pc as useBanner,
  A0 as usePagination,
  w4 as useTabs,
  fe as useUtils
};
